
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ilwiq", function(module, exports) {

$parcel$export(module.exports, "REVISION", () => $d5b33d7c30034067$export$3545e07a80636437);
$parcel$export(module.exports, "PCFSoftShadowMap", () => $d5b33d7c30034067$export$a47c4b43a1be34f0);
$parcel$export(module.exports, "FrontSide", () => $d5b33d7c30034067$export$2ede184fc2998901);
$parcel$export(module.exports, "BackSide", () => $d5b33d7c30034067$export$d9f0486e75b5ace);
$parcel$export(module.exports, "DoubleSide", () => $d5b33d7c30034067$export$3b296b6f144d5b03);
$parcel$export(module.exports, "NoBlending", () => $d5b33d7c30034067$export$63b8d6b580fc65ba);
$parcel$export(module.exports, "NeverDepth", () => $d5b33d7c30034067$export$69025ce147cee220);
$parcel$export(module.exports, "AlwaysDepth", () => $d5b33d7c30034067$export$7182eb52ea3b3f04);
$parcel$export(module.exports, "LessDepth", () => $d5b33d7c30034067$export$eedccec66ab7ebe);
$parcel$export(module.exports, "LessEqualDepth", () => $d5b33d7c30034067$export$296f78a0b892f81a);
$parcel$export(module.exports, "EqualDepth", () => $d5b33d7c30034067$export$a60d398fc7b7590e);
$parcel$export(module.exports, "GreaterEqualDepth", () => $d5b33d7c30034067$export$7d7234c1240a1fc4);
$parcel$export(module.exports, "GreaterDepth", () => $d5b33d7c30034067$export$c5e2c52991f30937);
$parcel$export(module.exports, "NotEqualDepth", () => $d5b33d7c30034067$export$2f843afa843d8916);
$parcel$export(module.exports, "ACESFilmicToneMapping", () => $d5b33d7c30034067$export$a0d98fe6d7e4af64);
$parcel$export(module.exports, "UVMapping", () => $d5b33d7c30034067$export$1beec6768cbb3d2d);
$parcel$export(module.exports, "EquirectangularReflectionMapping", () => $d5b33d7c30034067$export$d64030b316d3b087);
$parcel$export(module.exports, "RepeatWrapping", () => $d5b33d7c30034067$export$533346c8e8dac0f5);
$parcel$export(module.exports, "ClampToEdgeWrapping", () => $d5b33d7c30034067$export$9d9334239a5a5e06);
$parcel$export(module.exports, "MirroredRepeatWrapping", () => $d5b33d7c30034067$export$c7e7c00b14f51a4f);
$parcel$export(module.exports, "NearestFilter", () => $d5b33d7c30034067$export$727aa5ec3fe39bf0);
$parcel$export(module.exports, "NearestMipmapNearestFilter", () => $d5b33d7c30034067$export$d129e38cf6feaa8c);
$parcel$export(module.exports, "NearestMipmapLinearFilter", () => $d5b33d7c30034067$export$d2327c1afe5bfdf2);
$parcel$export(module.exports, "LinearFilter", () => $d5b33d7c30034067$export$8a72f490b25c56c8);
$parcel$export(module.exports, "LinearMipmapNearestFilter", () => $d5b33d7c30034067$export$19a719f377145a13);
$parcel$export(module.exports, "LinearMipmapLinearFilter", () => $d5b33d7c30034067$export$5d8599b6a933fb1b);
$parcel$export(module.exports, "LinearMipMapLinearFilter", () => $d5b33d7c30034067$export$90d80f1e3506775f);
$parcel$export(module.exports, "UnsignedByteType", () => $d5b33d7c30034067$export$2e8ce08d3f6f5e10);
$parcel$export(module.exports, "UnsignedIntType", () => $d5b33d7c30034067$export$c3c7fc4518ebba96);
$parcel$export(module.exports, "FloatType", () => $d5b33d7c30034067$export$f6d331659b644596);
$parcel$export(module.exports, "HalfFloatType", () => $d5b33d7c30034067$export$2697304443f382bc);
$parcel$export(module.exports, "UnsignedInt248Type", () => $d5b33d7c30034067$export$6c8ea339bfab1301);
$parcel$export(module.exports, "RGBAFormat", () => $d5b33d7c30034067$export$3f8bb04b555a363c);
$parcel$export(module.exports, "LuminanceFormat", () => $d5b33d7c30034067$export$cc09ccbf6d1ed449);
$parcel$export(module.exports, "DepthStencilFormat", () => $d5b33d7c30034067$export$1e113ac2d0905829);
$parcel$export(module.exports, "RedFormat", () => $d5b33d7c30034067$export$4e041a7967d15c4b);
$parcel$export(module.exports, "RGFormat", () => $d5b33d7c30034067$export$6cdf0b461c7ce8a0);
$parcel$export(module.exports, "RGBA_S3TC_DXT1_Format", () => $d5b33d7c30034067$export$afa304c3e981b668);
$parcel$export(module.exports, "RGBA_S3TC_DXT5_Format", () => $d5b33d7c30034067$export$9a79c424327dacf9);
$parcel$export(module.exports, "RGB_PVRTC_4BPPV1_Format", () => $d5b33d7c30034067$export$19ada9bbb1af3573);
$parcel$export(module.exports, "RGBA_PVRTC_4BPPV1_Format", () => $d5b33d7c30034067$export$b82296714358084c);
$parcel$export(module.exports, "RGB_ETC1_Format", () => $d5b33d7c30034067$export$6ab91af2d757aee7);
$parcel$export(module.exports, "RGB_ETC2_Format", () => $d5b33d7c30034067$export$7800993ef8106a6a);
$parcel$export(module.exports, "RGBA_ETC2_EAC_Format", () => $d5b33d7c30034067$export$23ed8300a860e7d8);
$parcel$export(module.exports, "RGBA_ASTC_4x4_Format", () => $d5b33d7c30034067$export$dc5570b4a2b92d48);
$parcel$export(module.exports, "RGBA_ASTC_6x6_Format", () => $d5b33d7c30034067$export$c009e2cb4a66485e);
$parcel$export(module.exports, "RGBA_BPTC_Format", () => $d5b33d7c30034067$export$ce40b115e188bc81);
$parcel$export(module.exports, "InterpolateDiscrete", () => $d5b33d7c30034067$export$995b32462a65e855);
$parcel$export(module.exports, "InterpolateLinear", () => $d5b33d7c30034067$export$30fac1aace31cf4d);
$parcel$export(module.exports, "TrianglesDrawMode", () => $d5b33d7c30034067$export$4c28c87c2dc84758);
$parcel$export(module.exports, "TriangleStripDrawMode", () => $d5b33d7c30034067$export$b23a071aa286eb29);
$parcel$export(module.exports, "TriangleFanDrawMode", () => $d5b33d7c30034067$export$f0d8293634f88842);
$parcel$export(module.exports, "BasicDepthPacking", () => $d5b33d7c30034067$export$deeb383078690b50);
$parcel$export(module.exports, "RGBADepthPacking", () => $d5b33d7c30034067$export$8f910f4c4f73df11);
$parcel$export(module.exports, "NoColorSpace", () => $d5b33d7c30034067$export$bfcb490c2dd3db51);
$parcel$export(module.exports, "SRGBColorSpace", () => $d5b33d7c30034067$export$561f394b24edfcaa);
$parcel$export(module.exports, "LinearSRGBColorSpace", () => $d5b33d7c30034067$export$42429b3acfb233a4);
$parcel$export(module.exports, "DisplayP3ColorSpace", () => $d5b33d7c30034067$export$626af19ae879bdf6);
$parcel$export(module.exports, "LinearDisplayP3ColorSpace", () => $d5b33d7c30034067$export$c0dc1bc7e964761);
$parcel$export(module.exports, "EventDispatcher", () => $d5b33d7c30034067$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "MathUtils", () => $d5b33d7c30034067$export$6a7ef315a0d1ef07);
$parcel$export(module.exports, "Vector2", () => $d5b33d7c30034067$export$c977b3e384af9ae1);
$parcel$export(module.exports, "ColorManagement", () => $d5b33d7c30034067$export$5e6fd513f44698c);
$parcel$export(module.exports, "Texture", () => $d5b33d7c30034067$export$5431306cf43de24a);
$parcel$export(module.exports, "Vector4", () => $d5b33d7c30034067$export$fa7daccca11cdbe3);
$parcel$export(module.exports, "WebGLRenderTarget", () => $d5b33d7c30034067$export$3c052beb2e51e23f);
$parcel$export(module.exports, "Data3DTexture", () => $d5b33d7c30034067$export$d7a3086320f856db);
$parcel$export(module.exports, "Quaternion", () => $d5b33d7c30034067$export$23d6a54f0bbc85a3);
$parcel$export(module.exports, "Vector3", () => $d5b33d7c30034067$export$64b5c384219d3699);
$parcel$export(module.exports, "Box3", () => $d5b33d7c30034067$export$6f7d5a9418ab2aa3);
$parcel$export(module.exports, "Sphere", () => $d5b33d7c30034067$export$805e8b72413ccaba);
$parcel$export(module.exports, "Matrix4", () => $d5b33d7c30034067$export$2ae72fc923e5eb5);
$parcel$export(module.exports, "Euler", () => $d5b33d7c30034067$export$d93cc409a0768c5f);
$parcel$export(module.exports, "Object3D", () => $d5b33d7c30034067$export$e4dd07dff30cc924);
$parcel$export(module.exports, "Triangle", () => $d5b33d7c30034067$export$5a465592bfe74b48);
$parcel$export(module.exports, "Color", () => $d5b33d7c30034067$export$892596cec99bc70e);
$parcel$export(module.exports, "Material", () => $d5b33d7c30034067$export$a2d8b23205c25948);
$parcel$export(module.exports, "MeshBasicMaterial", () => $d5b33d7c30034067$export$55cbcc9b622fe1f5);
$parcel$export(module.exports, "DataUtils", () => $d5b33d7c30034067$export$11ce8b759162cc80);
$parcel$export(module.exports, "BufferAttribute", () => $d5b33d7c30034067$export$8dea267bd6bde117);
$parcel$export(module.exports, "Float32BufferAttribute", () => $d5b33d7c30034067$export$cbe7a62641830ebd);
$parcel$export(module.exports, "BufferGeometry", () => $d5b33d7c30034067$export$b7be63a67df8959);
$parcel$export(module.exports, "Mesh", () => $d5b33d7c30034067$export$e176487c05830cc5);
$parcel$export(module.exports, "BoxGeometry", () => $d5b33d7c30034067$export$33e43285f7406bd5);
$parcel$export(module.exports, "ShaderMaterial", () => $d5b33d7c30034067$export$83c7d75d550a8b0d);
$parcel$export(module.exports, "Camera", () => $d5b33d7c30034067$export$79f141de891a5fed);
$parcel$export(module.exports, "PerspectiveCamera", () => $d5b33d7c30034067$export$74e4ae24825f68d7);
$parcel$export(module.exports, "Plane", () => $d5b33d7c30034067$export$7ff5ac152ef991b0);
$parcel$export(module.exports, "Frustum", () => $d5b33d7c30034067$export$35efe6f4c85463d2);
$parcel$export(module.exports, "PlaneGeometry", () => $d5b33d7c30034067$export$967d831af31f69ce);
$parcel$export(module.exports, "OrthographicCamera", () => $d5b33d7c30034067$export$9ebf355ee4ed261b);
$parcel$export(module.exports, "PMREMGenerator", () => $d5b33d7c30034067$export$6add42717753e221);
$parcel$export(module.exports, "DepthTexture", () => $d5b33d7c30034067$export$fc830aa069cc8c2f);
$parcel$export(module.exports, "MeshDepthMaterial", () => $d5b33d7c30034067$export$2698c22ec13825db);
$parcel$export(module.exports, "Group", () => $d5b33d7c30034067$export$eb2fcfdbd7ba97d4);
$parcel$export(module.exports, "WebGLRenderer", () => $d5b33d7c30034067$export$f6cc00ef28d7cf97);
$parcel$export(module.exports, "FogExp2", () => $d5b33d7c30034067$export$6f1519f023b8d0f6);
$parcel$export(module.exports, "Scene", () => $d5b33d7c30034067$export$38af1803e3442a7f);
$parcel$export(module.exports, "InterleavedBuffer", () => $d5b33d7c30034067$export$3d5cd879f108f53f);
$parcel$export(module.exports, "InterleavedBufferAttribute", () => $d5b33d7c30034067$export$920b6d07334599c7);
$parcel$export(module.exports, "LOD", () => $d5b33d7c30034067$export$112e7237be0c5f30);
$parcel$export(module.exports, "SkinnedMesh", () => $d5b33d7c30034067$export$b303577035157ecf);
$parcel$export(module.exports, "Bone", () => $d5b33d7c30034067$export$b127726e56765aa4);
$parcel$export(module.exports, "DataTexture", () => $d5b33d7c30034067$export$b691f601014eabe1);
$parcel$export(module.exports, "Skeleton", () => $d5b33d7c30034067$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InstancedBufferAttribute", () => $d5b33d7c30034067$export$32ea87a8b54d744a);
$parcel$export(module.exports, "InstancedMesh", () => $d5b33d7c30034067$export$f3c979c331175ad7);
$parcel$export(module.exports, "LineBasicMaterial", () => $d5b33d7c30034067$export$fbaaa33907730a0c);
$parcel$export(module.exports, "Line", () => $d5b33d7c30034067$export$17d680238e50603e);
$parcel$export(module.exports, "LineSegments", () => $d5b33d7c30034067$export$ff1ed10fedfdd604);
$parcel$export(module.exports, "LineLoop", () => $d5b33d7c30034067$export$f85a24d745e4f17d);
$parcel$export(module.exports, "PointsMaterial", () => $d5b33d7c30034067$export$a178c45366ce5d6b);
$parcel$export(module.exports, "Points", () => $d5b33d7c30034067$export$1c787534cb11aa3e);
$parcel$export(module.exports, "VideoTexture", () => $d5b33d7c30034067$export$6e09d1edf8d5a25c);
$parcel$export(module.exports, "CompressedTexture", () => $d5b33d7c30034067$export$3466bac9141a5cc4);
$parcel$export(module.exports, "CompressedArrayTexture", () => $d5b33d7c30034067$export$5fe6b8e34b274fcb);
$parcel$export(module.exports, "CompressedCubeTexture", () => $d5b33d7c30034067$export$d80173634de65bff);
$parcel$export(module.exports, "Shape", () => $d5b33d7c30034067$export$6428a7f2611ef1fa);
$parcel$export(module.exports, "ShapeGeometry", () => $d5b33d7c30034067$export$57a29a1c803e9065);
$parcel$export(module.exports, "MeshStandardMaterial", () => $d5b33d7c30034067$export$f2980790215acccd);
$parcel$export(module.exports, "MeshPhysicalMaterial", () => $d5b33d7c30034067$export$28d04986c4269c9f);
$parcel$export(module.exports, "MeshNormalMaterial", () => $d5b33d7c30034067$export$bfe8c0a091f41ae7);
$parcel$export(module.exports, "Interpolant", () => $d5b33d7c30034067$export$b558baee9c0f72d3);
$parcel$export(module.exports, "NumberKeyframeTrack", () => $d5b33d7c30034067$export$d45f0d1a4d9a9314);
$parcel$export(module.exports, "QuaternionKeyframeTrack", () => $d5b33d7c30034067$export$b8043f12b5aafbd7);
$parcel$export(module.exports, "VectorKeyframeTrack", () => $d5b33d7c30034067$export$5ce2dcb4cc9f2bff);
$parcel$export(module.exports, "AnimationClip", () => $d5b33d7c30034067$export$d942c706bf23829c);
$parcel$export(module.exports, "LoadingManager", () => $d5b33d7c30034067$export$99cc795e99919eed);
$parcel$export(module.exports, "Loader", () => $d5b33d7c30034067$export$3b0d6d7590275603);
$parcel$export(module.exports, "FileLoader", () => $d5b33d7c30034067$export$98435a25b5cf7b2b);
$parcel$export(module.exports, "TextureLoader", () => $d5b33d7c30034067$export$fd1bfc71f64c538c);
$parcel$export(module.exports, "SpotLight", () => $d5b33d7c30034067$export$81495cbb73897362);
$parcel$export(module.exports, "PointLight", () => $d5b33d7c30034067$export$4c9c1cb3f0b6f455);
$parcel$export(module.exports, "DirectionalLight", () => $d5b33d7c30034067$export$3fea33cc9972c868);
$parcel$export(module.exports, "RectAreaLight", () => $d5b33d7c30034067$export$61db2d908bbd2429);
$parcel$export(module.exports, "LoaderUtils", () => $d5b33d7c30034067$export$b5d2dc08d867e41a);
$parcel$export(module.exports, "InstancedBufferGeometry", () => $d5b33d7c30034067$export$231f009cbe414146);
$parcel$export(module.exports, "ImageBitmapLoader", () => $d5b33d7c30034067$export$52286b55c4a9b51f);
$parcel$export(module.exports, "AudioLoader", () => $d5b33d7c30034067$export$d8d5fccfbf47714e);
$parcel$export(module.exports, "Clock", () => $d5b33d7c30034067$export$9735c82c4bae3302);
$parcel$export(module.exports, "AudioListener", () => $d5b33d7c30034067$export$8a1b810c6fde8951);
$parcel$export(module.exports, "Audio", () => $d5b33d7c30034067$export$153755f98d9861de);
$parcel$export(module.exports, "PositionalAudio", () => $d5b33d7c30034067$export$4b3e397ef1832507);
$parcel$export(module.exports, "PropertyBinding", () => $d5b33d7c30034067$export$7bf70fcf9f891893);
$parcel$export(module.exports, "Uniform", () => $d5b33d7c30034067$export$2947cebfe91c02f8);
$parcel$export(module.exports, "Raycaster", () => $d5b33d7c30034067$export$8b7aaceff00bd2f);
$parcel$export(module.exports, "Line3", () => $d5b33d7c30034067$export$e0ba6359f1954fd3);
/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $d5b33d7c30034067$export$3545e07a80636437 = "167";
const $d5b33d7c30034067$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $d5b33d7c30034067$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $d5b33d7c30034067$export$3237e1f2c1ea1f44 = 0;
const $d5b33d7c30034067$export$b9a7b4fc5cb15f9b = 1;
const $d5b33d7c30034067$export$b8058bcc7037d3f3 = 2;
const $d5b33d7c30034067$export$f24be24dcddeac0d = 3;
const $d5b33d7c30034067$export$346307dbae2b7447 = 0;
const $d5b33d7c30034067$export$5813f879eee7cd88 = 1;
const $d5b33d7c30034067$export$a47c4b43a1be34f0 = 2;
const $d5b33d7c30034067$export$896ae1ade6c829c4 = 3;
const $d5b33d7c30034067$export$2ede184fc2998901 = 0;
const $d5b33d7c30034067$export$d9f0486e75b5ace = 1;
const $d5b33d7c30034067$export$3b296b6f144d5b03 = 2;
const $d5b33d7c30034067$export$63b8d6b580fc65ba = 0;
const $d5b33d7c30034067$export$5b29a26d96ee6af0 = 1;
const $d5b33d7c30034067$export$777d8f9551c2216b = 2;
const $d5b33d7c30034067$export$cdfa06f868e2e467 = 3;
const $d5b33d7c30034067$export$4138e1c684b46a20 = 4;
const $d5b33d7c30034067$export$eda4864c68df1fa2 = 5;
const $d5b33d7c30034067$export$20183a0484ce21a0 = 100;
const $d5b33d7c30034067$export$73e0df5177988548 = 101;
const $d5b33d7c30034067$export$28e582859cbec660 = 102;
const $d5b33d7c30034067$export$c8c1508da8d0600c = 103;
const $d5b33d7c30034067$export$99948c02fb51055f = 104;
const $d5b33d7c30034067$export$2110f05edf778d3d = 200;
const $d5b33d7c30034067$export$8805bad65e24940e = 201;
const $d5b33d7c30034067$export$7fbe15b28d28cf52 = 202;
const $d5b33d7c30034067$export$947829af9f2c17f6 = 203;
const $d5b33d7c30034067$export$d5773124e86cf28c = 204;
const $d5b33d7c30034067$export$11d468cc7f19e971 = 205;
const $d5b33d7c30034067$export$a78aed1ca2a87192 = 206;
const $d5b33d7c30034067$export$5d0fe17fd8773bac = 207;
const $d5b33d7c30034067$export$ef5f2dd8ffac5574 = 208;
const $d5b33d7c30034067$export$56b85b2686ab16 = 209;
const $d5b33d7c30034067$export$c05e2a1fc8609506 = 210;
const $d5b33d7c30034067$export$7dd8f434fd59075 = 211;
const $d5b33d7c30034067$export$99c8d898a9afbcee = 212;
const $d5b33d7c30034067$export$310cd2be38d13b56 = 213;
const $d5b33d7c30034067$export$db77b8fbcf45dbf4 = 214;
const $d5b33d7c30034067$export$69025ce147cee220 = 0;
const $d5b33d7c30034067$export$7182eb52ea3b3f04 = 1;
const $d5b33d7c30034067$export$eedccec66ab7ebe = 2;
const $d5b33d7c30034067$export$296f78a0b892f81a = 3;
const $d5b33d7c30034067$export$a60d398fc7b7590e = 4;
const $d5b33d7c30034067$export$7d7234c1240a1fc4 = 5;
const $d5b33d7c30034067$export$c5e2c52991f30937 = 6;
const $d5b33d7c30034067$export$2f843afa843d8916 = 7;
const $d5b33d7c30034067$export$e50ac29801f1774d = 0;
const $d5b33d7c30034067$export$9f9d94f963c85479 = 1;
const $d5b33d7c30034067$export$e641dc52bc3494aa = 2;
const $d5b33d7c30034067$export$9fcb6b4294603b2 = 0;
const $d5b33d7c30034067$export$98f52c2a46c598ca = 1;
const $d5b33d7c30034067$export$74b25e54b3bcd548 = 2;
const $d5b33d7c30034067$export$932b3dd283d4a366 = 3;
const $d5b33d7c30034067$export$a0d98fe6d7e4af64 = 4;
const $d5b33d7c30034067$export$2c7b09c1e9abfb5e = 5;
const $d5b33d7c30034067$export$212d53a513a325b2 = 6;
const $d5b33d7c30034067$export$f2863e1668a8e317 = 7;
const $d5b33d7c30034067$export$2595a3798997538 = "attached";
const $d5b33d7c30034067$export$d7e7dc2e114517a0 = "detached";
const $d5b33d7c30034067$export$1beec6768cbb3d2d = 300;
const $d5b33d7c30034067$export$8759762a6477f2c4 = 301;
const $d5b33d7c30034067$export$dc59f8aed047f61d = 302;
const $d5b33d7c30034067$export$d64030b316d3b087 = 303;
const $d5b33d7c30034067$export$ee99d97d46898098 = 304;
const $d5b33d7c30034067$export$dbf3e70ff37af79 = 306;
const $d5b33d7c30034067$export$533346c8e8dac0f5 = 1000;
const $d5b33d7c30034067$export$9d9334239a5a5e06 = 1001;
const $d5b33d7c30034067$export$c7e7c00b14f51a4f = 1002;
const $d5b33d7c30034067$export$727aa5ec3fe39bf0 = 1003;
const $d5b33d7c30034067$export$d129e38cf6feaa8c = 1004;
const $d5b33d7c30034067$export$14a4936464a36496 = 1004;
const $d5b33d7c30034067$export$d2327c1afe5bfdf2 = 1005;
const $d5b33d7c30034067$export$cbc5b7f5647595d8 = 1005;
const $d5b33d7c30034067$export$8a72f490b25c56c8 = 1006;
const $d5b33d7c30034067$export$19a719f377145a13 = 1007;
const $d5b33d7c30034067$export$dbe96bee3fe9dbf0 = 1007;
const $d5b33d7c30034067$export$5d8599b6a933fb1b = 1008;
const $d5b33d7c30034067$export$90d80f1e3506775f = 1008;
const $d5b33d7c30034067$export$2e8ce08d3f6f5e10 = 1009;
const $d5b33d7c30034067$export$545fce0311a9796a = 1010;
const $d5b33d7c30034067$export$88572337f312435f = 1011;
const $d5b33d7c30034067$export$c63dc51868b06a9d = 1012;
const $d5b33d7c30034067$export$5c612977753abe2 = 1013;
const $d5b33d7c30034067$export$c3c7fc4518ebba96 = 1014;
const $d5b33d7c30034067$export$f6d331659b644596 = 1015;
const $d5b33d7c30034067$export$2697304443f382bc = 1016;
const $d5b33d7c30034067$export$b3969b01faf587f2 = 1017;
const $d5b33d7c30034067$export$18886f8ae33e90de = 1018;
const $d5b33d7c30034067$export$6c8ea339bfab1301 = 1020;
const $d5b33d7c30034067$export$5a4c329b7e2092d3 = 35902;
const $d5b33d7c30034067$export$988473390501ed4b = 1021;
const $d5b33d7c30034067$export$7c67423a5ee6f5eb = 1022;
const $d5b33d7c30034067$export$3f8bb04b555a363c = 1023;
const $d5b33d7c30034067$export$cc09ccbf6d1ed449 = 1024;
const $d5b33d7c30034067$export$9053a81c4a69c289 = 1025;
const $d5b33d7c30034067$export$c1b6b5136be58045 = 1026;
const $d5b33d7c30034067$export$1e113ac2d0905829 = 1027;
const $d5b33d7c30034067$export$4e041a7967d15c4b = 1028;
const $d5b33d7c30034067$export$aa92e870a709d190 = 1029;
const $d5b33d7c30034067$export$6cdf0b461c7ce8a0 = 1030;
const $d5b33d7c30034067$export$1ba1c45f9f77d4d7 = 1031;
const $d5b33d7c30034067$export$d1fd40c11bfa798e = 1032;
const $d5b33d7c30034067$export$c200e7d26f592f21 = 1033;
const $d5b33d7c30034067$export$21d1799c6d552fc0 = 33776;
const $d5b33d7c30034067$export$afa304c3e981b668 = 33777;
const $d5b33d7c30034067$export$d2a1a68024a3e56c = 33778;
const $d5b33d7c30034067$export$9a79c424327dacf9 = 33779;
const $d5b33d7c30034067$export$19ada9bbb1af3573 = 35840;
const $d5b33d7c30034067$export$d0f0355bb3d948e4 = 35841;
const $d5b33d7c30034067$export$b82296714358084c = 35842;
const $d5b33d7c30034067$export$b71692456c47b6c3 = 35843;
const $d5b33d7c30034067$export$6ab91af2d757aee7 = 36196;
const $d5b33d7c30034067$export$7800993ef8106a6a = 37492;
const $d5b33d7c30034067$export$23ed8300a860e7d8 = 37496;
const $d5b33d7c30034067$export$dc5570b4a2b92d48 = 37808;
const $d5b33d7c30034067$export$68880cd325f8b2fb = 37809;
const $d5b33d7c30034067$export$7d2c0be323373d95 = 37810;
const $d5b33d7c30034067$export$22b52da301fc3a3e = 37811;
const $d5b33d7c30034067$export$c009e2cb4a66485e = 37812;
const $d5b33d7c30034067$export$118fff5afa255b63 = 37813;
const $d5b33d7c30034067$export$120713c829ae0667 = 37814;
const $d5b33d7c30034067$export$c79eeabbf53313e9 = 37815;
const $d5b33d7c30034067$export$443cf6567cdd6424 = 37816;
const $d5b33d7c30034067$export$6573984fc9840780 = 37817;
const $d5b33d7c30034067$export$e7aee563f30091de = 37818;
const $d5b33d7c30034067$export$2eb8634622ddeab7 = 37819;
const $d5b33d7c30034067$export$202b1ce7b5d25742 = 37820;
const $d5b33d7c30034067$export$18ab77abd087e467 = 37821;
const $d5b33d7c30034067$export$ce40b115e188bc81 = 36492;
const $d5b33d7c30034067$export$d279c5c4bac5121e = 36494;
const $d5b33d7c30034067$export$cde52d17225fdbd3 = 36495;
const $d5b33d7c30034067$export$b1688df4c4c21670 = 36283;
const $d5b33d7c30034067$export$fc15e5d8261eed58 = 36284;
const $d5b33d7c30034067$export$d220f6ade8463a0f = 36285;
const $d5b33d7c30034067$export$768646d09dc1b6ef = 36286;
const $d5b33d7c30034067$export$d62fdc9d1b1cccad = 2200;
const $d5b33d7c30034067$export$dfaf4422ce096e29 = 2201;
const $d5b33d7c30034067$export$f8f6f2041b78e210 = 2202;
const $d5b33d7c30034067$export$995b32462a65e855 = 2300;
const $d5b33d7c30034067$export$30fac1aace31cf4d = 2301;
const $d5b33d7c30034067$export$198b11ff4c72bb30 = 2302;
const $d5b33d7c30034067$export$7f795934b84ab523 = 2400;
const $d5b33d7c30034067$export$24a4ccb5099273b5 = 2401;
const $d5b33d7c30034067$export$8e8c3ecdcd8e1fee = 2402;
const $d5b33d7c30034067$export$bcfbbdcf8de7f8cd = 2500;
const $d5b33d7c30034067$export$d875e029ef558d3 = 2501;
const $d5b33d7c30034067$export$4c28c87c2dc84758 = 0;
const $d5b33d7c30034067$export$b23a071aa286eb29 = 1;
const $d5b33d7c30034067$export$f0d8293634f88842 = 2;
const $d5b33d7c30034067$export$deeb383078690b50 = 3200;
const $d5b33d7c30034067$export$8f910f4c4f73df11 = 3201;
const $d5b33d7c30034067$export$be2e2ddbc3983173 = 3202;
const $d5b33d7c30034067$export$1a54198784742f80 = 3203;
const $d5b33d7c30034067$export$2852a58ebdac27b8 = 0;
const $d5b33d7c30034067$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $d5b33d7c30034067$export$bfcb490c2dd3db51 = "";
const $d5b33d7c30034067$export$561f394b24edfcaa = "srgb";
const $d5b33d7c30034067$export$42429b3acfb233a4 = "srgb-linear";
const $d5b33d7c30034067$export$626af19ae879bdf6 = "display-p3";
const $d5b33d7c30034067$export$c0dc1bc7e964761 = "display-p3-linear";
const $d5b33d7c30034067$export$f197347d588c1b4a = "linear";
const $d5b33d7c30034067$export$8d0a61916cc26abb = "srgb";
const $d5b33d7c30034067$export$ce9118f9eaae3bb2 = "rec709";
const $d5b33d7c30034067$export$ef371755dbe7f98a = "p3";
const $d5b33d7c30034067$export$69433f11f42d5527 = 0;
const $d5b33d7c30034067$export$9f542ae4b5baca34 = 7680;
const $d5b33d7c30034067$export$8a4f28336ef203d3 = 7681;
const $d5b33d7c30034067$export$2928c0231297c036 = 7682;
const $d5b33d7c30034067$export$c0e9611c8a15f9a8 = 7683;
const $d5b33d7c30034067$export$9c2c08927385dcc4 = 34055;
const $d5b33d7c30034067$export$7c74ea00fa1315e6 = 34056;
const $d5b33d7c30034067$export$22e2e5726612443 = 5386;
const $d5b33d7c30034067$export$1343870698229224 = 512;
const $d5b33d7c30034067$export$8e1d8ed281997fa6 = 513;
const $d5b33d7c30034067$export$55648a1cde8329a7 = 514;
const $d5b33d7c30034067$export$2dff107857e6aca2 = 515;
const $d5b33d7c30034067$export$6f93765ab2f451a2 = 516;
const $d5b33d7c30034067$export$6f3fb2d2440f2b76 = 517;
const $d5b33d7c30034067$export$4119cf7b4c98fd5a = 518;
const $d5b33d7c30034067$export$14cf96713ddd97a8 = 519;
const $d5b33d7c30034067$export$d9e2d19a747baaab = 512;
const $d5b33d7c30034067$export$36bcf49c713b3eb7 = 513;
const $d5b33d7c30034067$export$66f28d946fc6a0d5 = 514;
const $d5b33d7c30034067$export$64eea11eb407ddf1 = 515;
const $d5b33d7c30034067$export$155af022118f3a38 = 516;
const $d5b33d7c30034067$export$67ab95dde6bed156 = 517;
const $d5b33d7c30034067$export$1cdcb70d53d65f61 = 518;
const $d5b33d7c30034067$export$187b73a3e352c145 = 519;
const $d5b33d7c30034067$export$763e8360f4d7f77d = 35044;
const $d5b33d7c30034067$export$8505d14ac8546ca = 35048;
const $d5b33d7c30034067$export$721e63549e51d81e = 35040;
const $d5b33d7c30034067$export$415731dc4f48e299 = 35045;
const $d5b33d7c30034067$export$9e809946455f13bc = 35049;
const $d5b33d7c30034067$export$2ed9499a35b5f832 = 35041;
const $d5b33d7c30034067$export$32ab2503ea19469a = 35046;
const $d5b33d7c30034067$export$ab4022c2c3f86315 = 35050;
const $d5b33d7c30034067$export$ba7f1db36a76a970 = 35042;
const $d5b33d7c30034067$export$43600cc67fabd9f = "100";
const $d5b33d7c30034067$export$f63012db5506e7dd = "300 es";
const $d5b33d7c30034067$export$5a0e9190d10875d3 = 2000;
const $d5b33d7c30034067$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $d5b33d7c30034067$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $d5b33d7c30034067$var$_seed = 1234567;
const $d5b33d7c30034067$var$DEG2RAD = Math.PI / 180;
const $d5b33d7c30034067$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $d5b33d7c30034067$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $d5b33d7c30034067$var$_lut[d0 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 24 & 0xff] + "-" + $d5b33d7c30034067$var$_lut[d1 & 0xff] + $d5b33d7c30034067$var$_lut[d1 >> 8 & 0xff] + "-" + $d5b33d7c30034067$var$_lut[d1 >> 16 & 0x0f | 0x40] + $d5b33d7c30034067$var$_lut[d1 >> 24 & 0xff] + "-" + $d5b33d7c30034067$var$_lut[d2 & 0x3f | 0x80] + $d5b33d7c30034067$var$_lut[d2 >> 8 & 0xff] + "-" + $d5b33d7c30034067$var$_lut[d2 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d2 >> 24 & 0xff] + $d5b33d7c30034067$var$_lut[d3 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $d5b33d7c30034067$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $d5b33d7c30034067$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $d5b33d7c30034067$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $d5b33d7c30034067$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $d5b33d7c30034067$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $d5b33d7c30034067$var$damp(x, y, lambda, dt) {
    return $d5b33d7c30034067$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $d5b33d7c30034067$var$pingpong(x, length = 1) {
    return length - Math.abs($d5b33d7c30034067$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $d5b33d7c30034067$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $d5b33d7c30034067$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $d5b33d7c30034067$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $d5b33d7c30034067$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $d5b33d7c30034067$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $d5b33d7c30034067$var$seededRandom(s) {
    if (s !== undefined) $d5b33d7c30034067$var$_seed = s;
    // Mulberry32 generator
    let t = $d5b33d7c30034067$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $d5b33d7c30034067$var$degToRad(degrees) {
    return degrees * $d5b33d7c30034067$var$DEG2RAD;
}
function $d5b33d7c30034067$var$radToDeg(radians) {
    return radians * $d5b33d7c30034067$var$RAD2DEG;
}
function $d5b33d7c30034067$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $d5b33d7c30034067$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $d5b33d7c30034067$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $d5b33d7c30034067$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
const $d5b33d7c30034067$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $d5b33d7c30034067$var$DEG2RAD,
    RAD2DEG: $d5b33d7c30034067$var$RAD2DEG,
    generateUUID: $d5b33d7c30034067$var$generateUUID,
    clamp: $d5b33d7c30034067$var$clamp,
    euclideanModulo: $d5b33d7c30034067$var$euclideanModulo,
    mapLinear: $d5b33d7c30034067$var$mapLinear,
    inverseLerp: $d5b33d7c30034067$var$inverseLerp,
    lerp: $d5b33d7c30034067$var$lerp,
    damp: $d5b33d7c30034067$var$damp,
    pingpong: $d5b33d7c30034067$var$pingpong,
    smoothstep: $d5b33d7c30034067$var$smoothstep,
    smootherstep: $d5b33d7c30034067$var$smootherstep,
    randInt: $d5b33d7c30034067$var$randInt,
    randFloat: $d5b33d7c30034067$var$randFloat,
    randFloatSpread: $d5b33d7c30034067$var$randFloatSpread,
    seededRandom: $d5b33d7c30034067$var$seededRandom,
    degToRad: $d5b33d7c30034067$var$degToRad,
    radToDeg: $d5b33d7c30034067$var$radToDeg,
    isPowerOfTwo: $d5b33d7c30034067$var$isPowerOfTwo,
    ceilPowerOfTwo: $d5b33d7c30034067$var$ceilPowerOfTwo,
    floorPowerOfTwo: $d5b33d7c30034067$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $d5b33d7c30034067$var$setQuaternionFromProperEuler,
    normalize: $d5b33d7c30034067$var$normalize,
    denormalize: $d5b33d7c30034067$var$denormalize
};
class $d5b33d7c30034067$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $d5b33d7c30034067$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $d5b33d7c30034067$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $d5b33d7c30034067$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $d5b33d7c30034067$var$_m3 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
function $d5b33d7c30034067$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $d5b33d7c30034067$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $d5b33d7c30034067$var$getTypedArray(type, buffer) {
    return new $d5b33d7c30034067$var$TYPED_ARRAYS[type](buffer);
}
function $d5b33d7c30034067$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
function $d5b33d7c30034067$export$1033a2df66368859() {
    const canvas = $d5b33d7c30034067$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
const $d5b33d7c30034067$var$_cache = {};
function $d5b33d7c30034067$var$warnOnce(message) {
    if (message in $d5b33d7c30034067$var$_cache) return;
    $d5b33d7c30034067$var$_cache[message] = true;
    console.warn(message);
}
function $d5b33d7c30034067$var$probeAsync(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $d5b33d7c30034067$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918().set(0.8224621, 0.177538, 0.0, 0.0331941, 0.9668058, 0.0, 0.0170827, 0.0723974, 0.9105199);
const $d5b33d7c30034067$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918().set(1.2249401, -0.2249404, 0.0, -0.0420569, 1.0420571, 0.0, -0.0196376, -0.0786361, 1.0982735);
/**
 * Defines supported color spaces by transfer function and primaries,
 * and provides conversions to/from the Linear-sRGB reference space.
 */ const $d5b33d7c30034067$var$COLOR_SPACES = {
    [$d5b33d7c30034067$export$42429b3acfb233a4]: {
        transfer: $d5b33d7c30034067$export$f197347d588c1b4a,
        primaries: $d5b33d7c30034067$export$ce9118f9eaae3bb2,
        luminanceCoefficients: [
            0.2126,
            0.7152,
            0.0722
        ],
        toReference: (color)=>color,
        fromReference: (color)=>color
    },
    [$d5b33d7c30034067$export$561f394b24edfcaa]: {
        transfer: $d5b33d7c30034067$export$8d0a61916cc26abb,
        primaries: $d5b33d7c30034067$export$ce9118f9eaae3bb2,
        luminanceCoefficients: [
            0.2126,
            0.7152,
            0.0722
        ],
        toReference: (color)=>color.convertSRGBToLinear(),
        fromReference: (color)=>color.convertLinearToSRGB()
    },
    [$d5b33d7c30034067$export$c0dc1bc7e964761]: {
        transfer: $d5b33d7c30034067$export$f197347d588c1b4a,
        primaries: $d5b33d7c30034067$export$ef371755dbe7f98a,
        luminanceCoefficients: [
            0.2289,
            0.6917,
            0.0793
        ],
        toReference: (color)=>color.applyMatrix3($d5b33d7c30034067$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
        fromReference: (color)=>color.applyMatrix3($d5b33d7c30034067$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3)
    },
    [$d5b33d7c30034067$export$626af19ae879bdf6]: {
        transfer: $d5b33d7c30034067$export$8d0a61916cc26abb,
        primaries: $d5b33d7c30034067$export$ef371755dbe7f98a,
        luminanceCoefficients: [
            0.2289,
            0.6917,
            0.0793
        ],
        toReference: (color)=>color.convertSRGBToLinear().applyMatrix3($d5b33d7c30034067$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
        fromReference: (color)=>color.applyMatrix3($d5b33d7c30034067$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB()
    }
};
const $d5b33d7c30034067$var$SUPPORTED_WORKING_COLOR_SPACES = new Set([
    $d5b33d7c30034067$export$42429b3acfb233a4,
    $d5b33d7c30034067$export$c0dc1bc7e964761
]);
const $d5b33d7c30034067$export$5e6fd513f44698c = {
    enabled: true,
    _workingColorSpace: $d5b33d7c30034067$export$42429b3acfb233a4,
    get workingColorSpace () {
        return this._workingColorSpace;
    },
    set workingColorSpace (colorSpace){
        if (!$d5b33d7c30034067$var$SUPPORTED_WORKING_COLOR_SPACES.has(colorSpace)) throw new Error(`Unsupported working color space, "${colorSpace}".`);
        this._workingColorSpace = colorSpace;
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToReference = $d5b33d7c30034067$var$COLOR_SPACES[sourceColorSpace].toReference;
        const targetFromReference = $d5b33d7c30034067$var$COLOR_SPACES[targetColorSpace].fromReference;
        return targetFromReference(sourceToReference(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this._workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this._workingColorSpace);
    },
    getPrimaries: function(colorSpace1) {
        return $d5b33d7c30034067$var$COLOR_SPACES[colorSpace1].primaries;
    },
    getTransfer: function(colorSpace1) {
        if (colorSpace1 === $d5b33d7c30034067$export$bfcb490c2dd3db51) return $d5b33d7c30034067$export$f197347d588c1b4a;
        return $d5b33d7c30034067$var$COLOR_SPACES[colorSpace1].transfer;
    },
    getLuminanceCoefficients: function(target, colorSpace1 = this._workingColorSpace) {
        return target.fromArray($d5b33d7c30034067$var$COLOR_SPACES[colorSpace1].luminanceCoefficients);
    }
};
function $d5b33d7c30034067$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $d5b33d7c30034067$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $d5b33d7c30034067$var$_canvas;
class $d5b33d7c30034067$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($d5b33d7c30034067$var$_canvas === undefined) $d5b33d7c30034067$var$_canvas = $d5b33d7c30034067$var$createElementNS("canvas");
            $d5b33d7c30034067$var$_canvas.width = image.width;
            $d5b33d7c30034067$var$_canvas.height = image.height;
            const context = $d5b33d7c30034067$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $d5b33d7c30034067$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $d5b33d7c30034067$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
let $d5b33d7c30034067$var$_sourceId = 0;
class $d5b33d7c30034067$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$_sourceId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.data = data;
        this.dataReady = true;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ""
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($d5b33d7c30034067$var$serializeImage(data[i].image));
                else url.push($d5b33d7c30034067$var$serializeImage(data[i]));
            } else // texture
            url = $d5b33d7c30034067$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $d5b33d7c30034067$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $d5b33d7c30034067$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
let $d5b33d7c30034067$var$_textureId = 0;
class $d5b33d7c30034067$export$5431306cf43de24a extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(image = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $d5b33d7c30034067$export$9d9334239a5a5e06, wrapT = $d5b33d7c30034067$export$9d9334239a5a5e06, magFilter = $d5b33d7c30034067$export$8a72f490b25c56c8, minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b, format = $d5b33d7c30034067$export$3f8bb04b555a363c, type = $d5b33d7c30034067$export$2e8ce08d3f6f5e10, anisotropy = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $d5b33d7c30034067$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$_textureId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = "";
        this.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $d5b33d7c30034067$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        this.colorSpace = colorSpace1;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $d5b33d7c30034067$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING = $d5b33d7c30034067$export$1beec6768cbb3d2d;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $d5b33d7c30034067$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $d5b33d7c30034067$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $d5b33d7c30034067$export$efcb1f8bf367cbfb extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1
        }, options);
        const texture = new $d5b33d7c30034067$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        texture.flipY = false;
        texture.generateMipmaps = options.generateMipmaps;
        texture.internalFormat = options.internalFormat;
        this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
        }
        this.depthBuffer = options.depthBuffer;
        this.stencilBuffer = options.stencilBuffer;
        this.resolveDepthBuffer = options.resolveDepthBuffer;
        this.resolveStencilBuffer = options.resolveStencilBuffer;
        this.depthTexture = options.depthTexture;
        this.samples = options.samples;
    }
    get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
        }
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $d5b33d7c30034067$export$3c052beb2e51e23f extends $d5b33d7c30034067$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $d5b33d7c30034067$export$dfac6c8e811406a3 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $d5b33d7c30034067$export$c77a02c11ed180c7 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$d7a3086320f856db extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $d5b33d7c30034067$export$7ee06591009639df extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($d5b33d7c30034067$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize(); // normalize calls _onChangeCallback()
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // sets this quaternion to a uniform random unit quaternnion
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $d5b33d7c30034067$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $d5b33d7c30034067$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $d5b33d7c30034067$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($d5b33d7c30034067$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($d5b33d7c30034067$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $d5b33d7c30034067$var$_vector$c = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$6f7d5a9418ab2aa3 {
    constructor(min = new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($d5b33d7c30034067$var$_vector$b.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($d5b33d7c30034067$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute("position");
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $d5b33d7c30034067$var$_vector$b);
                else $d5b33d7c30034067$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($d5b33d7c30034067$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $d5b33d7c30034067$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $d5b33d7c30034067$var$_box$4.copy(geometry.boundingBox);
                }
                $d5b33d7c30034067$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($d5b33d7c30034067$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $d5b33d7c30034067$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $d5b33d7c30034067$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_extents.subVectors(this.max, $d5b33d7c30034067$var$_center);
        // translate triangle to aabb origin
        $d5b33d7c30034067$var$_v0$3.subVectors(triangle.a, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v1$7.subVectors(triangle.b, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v2$4.subVectors(triangle.c, $d5b33d7c30034067$var$_center);
        // compute edge vectors for triangle
        $d5b33d7c30034067$var$_f0.subVectors($d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v0$3);
        $d5b33d7c30034067$var$_f1.subVectors($d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_v1$7);
        $d5b33d7c30034067$var$_f2.subVectors($d5b33d7c30034067$var$_v0$3, $d5b33d7c30034067$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$d5b33d7c30034067$var$_f0.z,
            $d5b33d7c30034067$var$_f0.y,
            0,
            -$d5b33d7c30034067$var$_f1.z,
            $d5b33d7c30034067$var$_f1.y,
            0,
            -$d5b33d7c30034067$var$_f2.z,
            $d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f0.z,
            0,
            -$d5b33d7c30034067$var$_f0.x,
            $d5b33d7c30034067$var$_f1.z,
            0,
            -$d5b33d7c30034067$var$_f1.x,
            $d5b33d7c30034067$var$_f2.z,
            0,
            -$d5b33d7c30034067$var$_f2.x,
            -$d5b33d7c30034067$var$_f0.y,
            $d5b33d7c30034067$var$_f0.x,
            0,
            -$d5b33d7c30034067$var$_f1.y,
            $d5b33d7c30034067$var$_f1.x,
            0,
            -$d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f2.x,
            0
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$3, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$3, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $d5b33d7c30034067$var$_triangleNormal.crossVectors($d5b33d7c30034067$var$_f0, $d5b33d7c30034067$var$_f1);
        axes = [
            $d5b33d7c30034067$var$_triangleNormal.x,
            $d5b33d7c30034067$var$_triangleNormal.y,
            $d5b33d7c30034067$var$_triangleNormal.z
        ];
        return $d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$3, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $d5b33d7c30034067$var$_vector$b).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($d5b33d7c30034067$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $d5b33d7c30034067$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $d5b33d7c30034067$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $d5b33d7c30034067$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $d5b33d7c30034067$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $d5b33d7c30034067$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $d5b33d7c30034067$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $d5b33d7c30034067$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $d5b33d7c30034067$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($d5b33d7c30034067$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_points = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
];
const $d5b33d7c30034067$var$_vector$b = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $d5b33d7c30034067$var$_v0$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
// triangle edge vectors
const $d5b33d7c30034067$var$_f0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_center = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_extents = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangleNormal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_testAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
function $d5b33d7c30034067$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $d5b33d7c30034067$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($d5b33d7c30034067$var$_testAxis.x) + extents.y * Math.abs($d5b33d7c30034067$var$_testAxis.y) + extents.z * Math.abs($d5b33d7c30034067$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($d5b33d7c30034067$var$_testAxis);
        const p1 = v1.dot($d5b33d7c30034067$var$_testAxis);
        const p2 = v2.dot($d5b33d7c30034067$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $d5b33d7c30034067$var$_box$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_v1$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$805e8b72413ccaba {
    constructor(center = new $d5b33d7c30034067$export$64b5c384219d3699(), radius = -1){
        this.isSphere = true;
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $d5b33d7c30034067$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $d5b33d7c30034067$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $d5b33d7c30034067$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($d5b33d7c30034067$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $d5b33d7c30034067$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).add($d5b33d7c30034067$var$_v2$3));
            this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).sub($d5b33d7c30034067$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$a = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segCenter = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segDir = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_diff = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$a186db52eed6d40e {
    constructor(origin = new $d5b33d7c30034067$export$64b5c384219d3699(), direction = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $d5b33d7c30034067$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $d5b33d7c30034067$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $d5b33d7c30034067$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $d5b33d7c30034067$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $d5b33d7c30034067$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $d5b33d7c30034067$var$_segDir.copy(v1).sub(v0).normalize();
        $d5b33d7c30034067$var$_diff.copy(this.origin).sub($d5b33d7c30034067$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($d5b33d7c30034067$var$_segDir);
        const b0 = $d5b33d7c30034067$var$_diff.dot(this.direction);
        const b1 = -$d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_segDir);
        const c = $d5b33d7c30034067$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($d5b33d7c30034067$var$_segCenter).addScaledVector($d5b33d7c30034067$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $d5b33d7c30034067$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $d5b33d7c30034067$var$_vector$a.dot(this.direction);
        const d2 = $d5b33d7c30034067$var$_vector$a.dot($d5b33d7c30034067$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $d5b33d7c30034067$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $d5b33d7c30034067$var$_edge1.subVectors(b, a);
        $d5b33d7c30034067$var$_edge2.subVectors(c, a);
        $d5b33d7c30034067$var$_normal$1.crossVectors($d5b33d7c30034067$var$_edge1, $d5b33d7c30034067$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($d5b33d7c30034067$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $d5b33d7c30034067$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($d5b33d7c30034067$var$_edge2.crossVectors($d5b33d7c30034067$var$_diff, $d5b33d7c30034067$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($d5b33d7c30034067$var$_edge1.cross($d5b33d7c30034067$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $d5b33d7c30034067$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($d5b33d7c30034067$var$_zero, q, $d5b33d7c30034067$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $d5b33d7c30034067$var$_z.subVectors(eye, target);
        if ($d5b33d7c30034067$var$_z.lengthSq() === 0) // eye and target are in the same position
        $d5b33d7c30034067$var$_z.z = 1;
        $d5b33d7c30034067$var$_z.normalize();
        $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        if ($d5b33d7c30034067$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $d5b33d7c30034067$var$_z.x += 0.0001;
            else $d5b33d7c30034067$var$_z.z += 0.0001;
            $d5b33d7c30034067$var$_z.normalize();
            $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        }
        $d5b33d7c30034067$var$_x.normalize();
        $d5b33d7c30034067$var$_y.crossVectors($d5b33d7c30034067$var$_z, $d5b33d7c30034067$var$_x);
        te[0] = $d5b33d7c30034067$var$_x.x;
        te[4] = $d5b33d7c30034067$var$_y.x;
        te[8] = $d5b33d7c30034067$var$_z.x;
        te[1] = $d5b33d7c30034067$var$_x.y;
        te[5] = $d5b33d7c30034067$var$_y.y;
        te[9] = $d5b33d7c30034067$var$_z.y;
        te[2] = $d5b33d7c30034067$var$_x.z;
        te[6] = $d5b33d7c30034067$var$_y.z;
        te[10] = $d5b33d7c30034067$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $d5b33d7c30034067$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $d5b33d7c30034067$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $d5b33d7c30034067$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $d5b33d7c30034067$var$_m1$4.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $d5b33d7c30034067$var$_m1$4.elements[0] *= invSX;
        $d5b33d7c30034067$var$_m1$4.elements[1] *= invSX;
        $d5b33d7c30034067$var$_m1$4.elements[2] *= invSX;
        $d5b33d7c30034067$var$_m1$4.elements[4] *= invSY;
        $d5b33d7c30034067$var$_m1$4.elements[5] *= invSY;
        $d5b33d7c30034067$var$_m1$4.elements[6] *= invSY;
        $d5b33d7c30034067$var$_m1$4.elements[8] *= invSZ;
        $d5b33d7c30034067$var$_m1$4.elements[9] *= invSZ;
        $d5b33d7c30034067$var$_m1$4.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$4);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $d5b33d7c30034067$var$_v1$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_m1$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_zero = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0);
const $d5b33d7c30034067$var$_one = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
const $d5b33d7c30034067$var$_x = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_y = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_z = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_quaternion$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $d5b33d7c30034067$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($d5b33d7c30034067$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$d5b33d7c30034067$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($d5b33d7c30034067$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$d5b33d7c30034067$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($d5b33d7c30034067$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$d5b33d7c30034067$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $d5b33d7c30034067$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($d5b33d7c30034067$var$_matrix$2, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $d5b33d7c30034067$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($d5b33d7c30034067$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$d5b33d7c30034067$export$d93cc409a0768c5f.DEFAULT_ORDER = "XYZ";
class $d5b33d7c30034067$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $d5b33d7c30034067$var$_object3DId = 0;
const $d5b33d7c30034067$var$_v1$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_q1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_m1$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_target = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_position$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_scale$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_xAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0);
const $d5b33d7c30034067$var$_yAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
const $d5b33d7c30034067$var$_zAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1);
const $d5b33d7c30034067$var$_addedEvent = {
    type: "added"
};
const $d5b33d7c30034067$var$_removedEvent = {
    type: "removed"
};
const $d5b33d7c30034067$var$_childaddedEvent = {
    type: "childadded",
    child: null
};
const $d5b33d7c30034067$var$_childremovedEvent = {
    type: "childremoved",
    child: null
};
class $d5b33d7c30034067$export$e4dd07dff30cc924 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$_object3DId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $d5b33d7c30034067$export$64b5c384219d3699();
        const rotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        const quaternion = new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
        const scale = new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $d5b33d7c30034067$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        });
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixWorld = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($d5b33d7c30034067$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($d5b33d7c30034067$var$_m1$3.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $d5b33d7c30034067$var$_target.copy(x);
        else $d5b33d7c30034067$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $d5b33d7c30034067$var$_m1$3.lookAt($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_target, this.up);
        else $d5b33d7c30034067$var$_m1$3.lookAt($d5b33d7c30034067$var$_target, $d5b33d7c30034067$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$3);
        if (parent) {
            $d5b33d7c30034067$var$_m1$3.extractRotation(parent.matrixWorld);
            $d5b33d7c30034067$var$_q1.setFromRotationMatrix($d5b33d7c30034067$var$_m1$3);
            this.quaternion.premultiply($d5b33d7c30034067$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($d5b33d7c30034067$var$_addedEvent);
            $d5b33d7c30034067$var$_childaddedEvent.child = object;
            this.dispatchEvent($d5b33d7c30034067$var$_childaddedEvent);
            $d5b33d7c30034067$var$_childaddedEvent.child = null;
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($d5b33d7c30034067$var$_removedEvent);
            $d5b33d7c30034067$var$_childremovedEvent.child = object;
            this.dispatchEvent($d5b33d7c30034067$var$_childremovedEvent);
            $d5b33d7c30034067$var$_childremovedEvent.child = null;
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_m1$3.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $d5b33d7c30034067$var$_m1$3.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($d5b33d7c30034067$var$_m1$3);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($d5b33d7c30034067$var$_addedEvent);
        $d5b33d7c30034067$var$_childaddedEvent.child = object;
        this.dispatchEvent($d5b33d7c30034067$var$_childaddedEvent);
        $d5b33d7c30034067$var$_childaddedEvent.child = null;
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, target, $d5b33d7c30034067$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = "BatchedMesh";
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.visibility = this._visibility;
            object.active = this._active;
            object.bounds = this._bounds.map((bound)=>({
                    boxInitialized: bound.boxInitialized,
                    boxMin: bound.box.min.toArray(),
                    boxMax: bound.box.max.toArray(),
                    sphereInitialized: bound.sphereInitialized,
                    sphereRadius: bound.sphere.radius,
                    sphereCenter: bound.sphere.center.toArray()
                }));
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.geometryCount = this._geometryCount;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = {
                center: object.boundingSphere.center.toArray(),
                radius: object.boundingSphere.radius
            };
            if (this.boundingBox !== null) object.boundingBox = {
                min: object.boundingBox.min.toArray(),
                max: object.boundingBox.max.toArray()
            };
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $d5b33d7c30034067$var$_v0$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vab = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vac = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbc = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vap = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vcp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$5a465592bfe74b48 {
    constructor(a = new $d5b33d7c30034067$export$64b5c384219d3699(), b = new $d5b33d7c30034067$export$64b5c384219d3699(), c = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $d5b33d7c30034067$var$_v0$2.subVectors(a, b);
        target.cross($d5b33d7c30034067$var$_v0$2);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $d5b33d7c30034067$var$_v0$2.subVectors(c, a);
        $d5b33d7c30034067$var$_v1$3.subVectors(b, a);
        $d5b33d7c30034067$var$_v2$2.subVectors(point, a);
        const dot00 = $d5b33d7c30034067$var$_v0$2.dot($d5b33d7c30034067$var$_v0$2);
        const dot01 = $d5b33d7c30034067$var$_v0$2.dot($d5b33d7c30034067$var$_v1$3);
        const dot02 = $d5b33d7c30034067$var$_v0$2.dot($d5b33d7c30034067$var$_v2$2);
        const dot11 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v1$3);
        const dot12 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $d5b33d7c30034067$var$_v3$2) === null) return false;
        return $d5b33d7c30034067$var$_v3$2.x >= 0 && $d5b33d7c30034067$var$_v3$2.y >= 0 && $d5b33d7c30034067$var$_v3$2.x + $d5b33d7c30034067$var$_v3$2.y <= 1;
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $d5b33d7c30034067$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ("z" in target) target.z = 0;
            if ("w" in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $d5b33d7c30034067$var$_v3$2.x);
        target.addScaledVector(v2, $d5b33d7c30034067$var$_v3$2.y);
        target.addScaledVector(v3, $d5b33d7c30034067$var$_v3$2.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $d5b33d7c30034067$var$_v0$2.subVectors(c, b);
        $d5b33d7c30034067$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $d5b33d7c30034067$var$_v0$2.cross($d5b33d7c30034067$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $d5b33d7c30034067$var$_v0$2.subVectors(this.c, this.b);
        $d5b33d7c30034067$var$_v1$3.subVectors(this.a, this.b);
        return $d5b33d7c30034067$var$_v0$2.cross($d5b33d7c30034067$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $d5b33d7c30034067$var$_vab.subVectors(b, a);
        $d5b33d7c30034067$var$_vac.subVectors(c, a);
        $d5b33d7c30034067$var$_vap.subVectors(p, a);
        const d1 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vap);
        const d2 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $d5b33d7c30034067$var$_vbp.subVectors(p, b);
        const d3 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vbp);
        const d4 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v);
        }
        $d5b33d7c30034067$var$_vcp.subVectors(p, c);
        const d5 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vcp);
        const d6 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $d5b33d7c30034067$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($d5b33d7c30034067$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v).addScaledVector($d5b33d7c30034067$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const $d5b33d7c30034067$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $d5b33d7c30034067$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $d5b33d7c30034067$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $d5b33d7c30034067$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $d5b33d7c30034067$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === "number") this.setHex(value);
            else if (typeof value === "string") this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $d5b33d7c30034067$var$euclideanModulo(h, 1);
        s = $d5b33d7c30034067$var$clamp(s, 0, 1);
        l = $d5b33d7c30034067$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $d5b33d7c30034067$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $d5b33d7c30034067$var$hue2rgb(q, p, h);
            this.b = $d5b33d7c30034067$var$hue2rgb(q, p, h - 1 / 3);
        }
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn("THREE.Color: Unknown color model " + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn("THREE.Color: Invalid hex color " + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        // color keywords
        const hex = $d5b33d7c30034067$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $d5b33d7c30034067$var$SRGBToLinear(color.r);
        this.g = $d5b33d7c30034067$var$SRGBToLinear(color.g);
        this.b = $d5b33d7c30034067$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $d5b33d7c30034067$var$LinearToSRGB(color.r);
        this.g = $d5b33d7c30034067$var$LinearToSRGB(color.g);
        this.b = $d5b33d7c30034067$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        return Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.r * 255, 0, 255)) * 65536 + Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.g * 255, 0, 255)) * 256 + Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        return ("000000" + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        const r = $d5b33d7c30034067$var$_color.r, g = $d5b33d7c30034067$var$_color.g, b = $d5b33d7c30034067$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        target.r = $d5b33d7c30034067$var$_color.r;
        target.g = $d5b33d7c30034067$var$_color.g;
        target.b = $d5b33d7c30034067$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        const r = $d5b33d7c30034067$var$_color.r, g = $d5b33d7c30034067$var$_color.g, b = $d5b33d7c30034067$var$_color.b;
        if (colorSpace1 !== $d5b33d7c30034067$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        return this.setHSL($d5b33d7c30034067$var$_hslA.h + h, $d5b33d7c30034067$var$_hslA.s + s, $d5b33d7c30034067$var$_hslA.l + l);
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        color.getHSL($d5b33d7c30034067$var$_hslB);
        const h = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.h, $d5b33d7c30034067$var$_hslB.h, alpha);
        const s = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.s, $d5b33d7c30034067$var$_hslB.s, alpha);
        const l = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.l, $d5b33d7c30034067$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $d5b33d7c30034067$var$_color = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
$d5b33d7c30034067$export$892596cec99bc70e.NAMES = $d5b33d7c30034067$var$_colorKeywords;
let $d5b33d7c30034067$var$_materialId = 0;
class $d5b33d7c30034067$export$a2d8b23205c25948 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$_materialId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.blending = $d5b33d7c30034067$export$5b29a26d96ee6af0;
        this.side = $d5b33d7c30034067$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = $d5b33d7c30034067$export$d5773124e86cf28c;
        this.blendDst = $d5b33d7c30034067$export$11d468cc7f19e971;
        this.blendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.blendColor = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 0);
        this.blendAlpha = 0;
        this.depthFunc = $d5b33d7c30034067$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $d5b33d7c30034067$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZPass = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $d5b33d7c30034067$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $d5b33d7c30034067$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $d5b33d7c30034067$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $d5b33d7c30034067$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $d5b33d7c30034067$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $d5b33d7c30034067$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $d5b33d7c30034067$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $d5b33d7c30034067$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $d5b33d7c30034067$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $d5b33d7c30034067$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    onBuild() {
        console.warn("Material: onBuild() has been removed."); // @deprecated, r166
    }
    onBeforeRender() {
        console.warn("Material: onBeforeRender() has been removed."); // @deprecated, r166
    }
}
class $d5b33d7c30034067$export$55cbcc9b622fe1f5 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = "MeshBasicMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $d5b33d7c30034067$var$_tables = /*@__PURE__*/ $d5b33d7c30034067$var$_generateTables();
function $d5b33d7c30034067$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $d5b33d7c30034067$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
    val = $d5b33d7c30034067$var$clamp(val, -65504, 65504);
    $d5b33d7c30034067$var$_tables.floatView[0] = val;
    const f = $d5b33d7c30034067$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $d5b33d7c30034067$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $d5b33d7c30034067$var$_tables.shiftTable[e]);
}
// float16 to float32
function $d5b33d7c30034067$var$fromHalfFloat(val) {
    const m = val >> 10;
    $d5b33d7c30034067$var$_tables.uint32View[0] = $d5b33d7c30034067$var$_tables.mantissaTable[$d5b33d7c30034067$var$_tables.offsetTable[m] + (val & 0x3ff)] + $d5b33d7c30034067$var$_tables.exponentTable[m];
    return $d5b33d7c30034067$var$_tables.floatView[0];
}
const $d5b33d7c30034067$export$11ce8b759162cc80 = {
    toHalfFloat: $d5b33d7c30034067$var$toHalfFloat,
    fromHalfFloat: $d5b33d7c30034067$var$fromHalfFloat
};
const $d5b33d7c30034067$var$_vector$9 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = true;
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this._updateRange = {
            offset: 0,
            count: -1
        };
        this.updateRanges = [];
        this.gpuType = $d5b33d7c30034067$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    get updateRange() {
        $d5b33d7c30034067$var$warnOnce("THREE.BufferAttribute: updateRange() is deprecated and will be removed in r169. Use addUpdateRange() instead."); // @deprecated, r159
        return this._updateRange;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector2$1.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $d5b33d7c30034067$var$_vector2$1.x, $d5b33d7c30034067$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $d5b33d7c30034067$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $d5b33d7c30034067$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $d5b33d7c30034067$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
}
//
class $d5b33d7c30034067$export$f9ff2d6a20248cbf extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$cacc90cf35d11cdd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$baaa85a1a812c157 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$2b755a102ccdcefe extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$640a853f68025f2e extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$46b369aed2968a0a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$dbd3698c64958d69 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $d5b33d7c30034067$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $d5b33d7c30034067$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        this.array[index + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        this.array[index + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        this.array[index + 3] = $d5b33d7c30034067$var$toHalfFloat(w);
        return this;
    }
}
class $d5b33d7c30034067$export$cbe7a62641830ebd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let $d5b33d7c30034067$var$_id$2 = 0;
const $d5b33d7c30034067$var$_m1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_obj = /*@__PURE__*/ new $d5b33d7c30034067$export$e4dd07dff30cc924();
const $d5b33d7c30034067$var$_offset = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_boxMorphTargets = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_vector$8 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$b7be63a67df8959 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$_id$2++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($d5b33d7c30034067$var$arrayNeedsUint32(index) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $d5b33d7c30034067$var$_m1$2.makeRotationFromQuaternion(q);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $d5b33d7c30034067$var$_m1$2.makeRotationX(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $d5b33d7c30034067$var$_m1$2.makeRotationY(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $d5b33d7c30034067$var$_m1$2.makeRotationZ(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $d5b33d7c30034067$var$_m1$2.makeTranslation(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $d5b33d7c30034067$var$_m1$2.makeScale(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    lookAt(vector) {
        $d5b33d7c30034067$var$_obj.lookAt(vector);
        $d5b33d7c30034067$var$_obj.updateMatrix();
        this.applyMatrix4($d5b33d7c30034067$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($d5b33d7c30034067$var$_offset).negate();
        this.translate($d5b33d7c30034067$var$_offset.x, $d5b33d7c30034067$var$_offset.y, $d5b33d7c30034067$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this);
            this.boundingBox.set(new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$8.addVectors(this.boundingBox.min, $d5b33d7c30034067$var$_box$2.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$8);
                    $d5b33d7c30034067$var$_vector$8.addVectors(this.boundingBox.max, $d5b33d7c30034067$var$_box$2.max);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$2.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this);
            this.boundingSphere.set(new $d5b33d7c30034067$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $d5b33d7c30034067$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$8.addVectors($d5b33d7c30034067$var$_box$2.min, $d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$2.expandByPoint($d5b33d7c30034067$var$_vector$8);
                    $d5b33d7c30034067$var$_vector$8.addVectors($d5b33d7c30034067$var$_box$2.max, $d5b33d7c30034067$var$_boxMorphTargets.max);
                    $d5b33d7c30034067$var$_box$2.expandByPoint($d5b33d7c30034067$var$_vector$8);
                } else {
                    $d5b33d7c30034067$var$_box$2.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$2.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.max);
                }
            }
            $d5b33d7c30034067$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $d5b33d7c30034067$var$_offset.fromBufferAttribute(position, j);
                        $d5b33d7c30034067$var$_vector$8.add($d5b33d7c30034067$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute("tangent") === false) this.setAttribute("tangent", new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute("tangent");
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
            tan2[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        const vA = new $d5b33d7c30034067$export$64b5c384219d3699(), vB = new $d5b33d7c30034067$export$64b5c384219d3699(), vC = new $d5b33d7c30034067$export$64b5c384219d3699(), uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1(), sdir = new $d5b33d7c30034067$export$64b5c384219d3699(), tdir = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $d5b33d7c30034067$export$64b5c384219d3699(), tmp2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const n = new $d5b33d7c30034067$export$64b5c384219d3699(), n2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $d5b33d7c30034067$export$64b5c384219d3699(), pB = new $d5b33d7c30034067$export$64b5c384219d3699(), pC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const nA = new $d5b33d7c30034067$export$64b5c384219d3699(), nB = new $d5b33d7c30034067$export$64b5c384219d3699(), nC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const cb = new $d5b33d7c30034067$export$64b5c384219d3699(), ab = new $d5b33d7c30034067$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(normals, i);
            $d5b33d7c30034067$var$_vector$8.normalize();
            normals.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $d5b33d7c30034067$var$_inverseMatrix$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_sphereHitAt = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_tempA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_morphA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_normalA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPointWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e176487c05830cc5 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $d5b33d7c30034067$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $d5b33d7c30034067$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA, influence);
                else $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA.sub(target), influence);
            }
            target.add($d5b33d7c30034067$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$6.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $d5b33d7c30034067$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($d5b33d7c30034067$var$_sphere$6.containsPoint($d5b33d7c30034067$var$_ray$3.origin) === false) {
            if ($d5b33d7c30034067$var$_ray$3.intersectSphere($d5b33d7c30034067$var$_sphere$6, $d5b33d7c30034067$var$_sphereHitAt) === null) return;
            if ($d5b33d7c30034067$var$_ray$3.origin.distanceToSquared($d5b33d7c30034067$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $d5b33d7c30034067$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$3.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $d5b33d7c30034067$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $d5b33d7c30034067$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $d5b33d7c30034067$var$_intersectionPointWorld.copy(point);
    $d5b33d7c30034067$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $d5b33d7c30034067$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $d5b33d7c30034067$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $d5b33d7c30034067$var$_vA$1);
    object.getVertexPosition(b, $d5b33d7c30034067$var$_vB$1);
    object.getVertexPosition(c, $d5b33d7c30034067$var$_vC$1);
    const intersection = $d5b33d7c30034067$var$checkIntersection$1(object, material, raycaster, ray, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $d5b33d7c30034067$var$_uvA$1.fromBufferAttribute(uv, a);
            $d5b33d7c30034067$var$_uvB$1.fromBufferAttribute(uv, b);
            $d5b33d7c30034067$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_uvA$1, $d5b33d7c30034067$var$_uvB$1, $d5b33d7c30034067$var$_uvC$1, new $d5b33d7c30034067$export$c977b3e384af9ae1());
        }
        if (uv1) {
            $d5b33d7c30034067$var$_uvA$1.fromBufferAttribute(uv1, a);
            $d5b33d7c30034067$var$_uvB$1.fromBufferAttribute(uv1, b);
            $d5b33d7c30034067$var$_uvC$1.fromBufferAttribute(uv1, c);
            intersection.uv1 = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_uvA$1, $d5b33d7c30034067$var$_uvB$1, $d5b33d7c30034067$var$_uvC$1, new $d5b33d7c30034067$export$c977b3e384af9ae1());
        }
        if (normal) {
            $d5b33d7c30034067$var$_normalA.fromBufferAttribute(normal, a);
            $d5b33d7c30034067$var$_normalB.fromBufferAttribute(normal, b);
            $d5b33d7c30034067$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_normalA, $d5b33d7c30034067$var$_normalB, $d5b33d7c30034067$var$_normalC, new $d5b33d7c30034067$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $d5b33d7c30034067$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $d5b33d7c30034067$export$5a465592bfe74b48.getNormal($d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $d5b33d7c30034067$export$33e43285f7406bd5 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $d5b33d7c30034067$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $d5b33d7c30034067$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $d5b33d7c30034067$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $d5b33d7c30034067$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $d5b33d7c30034067$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $d5b33d7c30034067$export$d8ecdf8615bfea69 = {
    clone: $d5b33d7c30034067$var$cloneUniforms,
    merge: $d5b33d7c30034067$var$mergeUniforms
};
var $d5b33d7c30034067$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $d5b33d7c30034067$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $d5b33d7c30034067$export$83c7d75d550a8b0d extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $d5b33d7c30034067$var$default_vertex;
        this.fragmentShader = $d5b33d7c30034067$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv1": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $d5b33d7c30034067$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $d5b33d7c30034067$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $d5b33d7c30034067$export$79f141de891a5fed extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = "Camera";
        this.matrixWorldInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_v3$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_minTarget = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_maxTarget = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$74e4ae24825f68d7 extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $d5b33d7c30034067$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($d5b33d7c30034067$var$_v3$1.x, $d5b33d7c30034067$var$_v3$1.y).multiplyScalar(-distance / $d5b33d7c30034067$var$_v3$1.z);
        $d5b33d7c30034067$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($d5b33d7c30034067$var$_v3$1.x, $d5b33d7c30034067$var$_v3$1.y).multiplyScalar(-distance / $d5b33d7c30034067$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Copies the result into the target Vector2, where x is width and y is height.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $d5b33d7c30034067$var$_minTarget, $d5b33d7c30034067$var$_maxTarget);
        return target.subVectors($d5b33d7c30034067$var$_maxTarget, $d5b33d7c30034067$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $d5b33d7c30034067$var$fov = -90; // negative fov is not an error
const $d5b33d7c30034067$var$aspect = 1;
class $d5b33d7c30034067$export$d0cdd0bd804995de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        this.activeMipmapLevel = 0;
        const cameraPX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $d5b33d7c30034067$export$ee2e5a18258a4049 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $d5b33d7c30034067$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $d5b33d7c30034067$export$ac386671d651941e extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new $d5b33d7c30034067$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $d5b33d7c30034067$export$33e43285f7406bd5(5, 5, 5);
        const material = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $d5b33d7c30034067$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            blending: $d5b33d7c30034067$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $d5b33d7c30034067$export$5d8599b6a933fb1b) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
        const camera = new $d5b33d7c30034067$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $d5b33d7c30034067$var$_vector1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
class $d5b33d7c30034067$export$7ff5ac152ef991b0 {
    constructor(normal = new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $d5b33d7c30034067$var$_vector1.subVectors(c, b).cross($d5b33d7c30034067$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($d5b33d7c30034067$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $d5b33d7c30034067$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($d5b33d7c30034067$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_sphere$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_vector$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$35efe6f4c85463d2 {
    constructor(p0 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p1 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p2 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p3 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p4 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p5 = new $d5b33d7c30034067$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $d5b33d7c30034067$var$_sphere$5.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $d5b33d7c30034067$var$_sphere$5.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$5);
    }
    intersectsSprite(sprite) {
        $d5b33d7c30034067$var$_sphere$5.center.set(0, 0, 0);
        $d5b33d7c30034067$var$_sphere$5.radius = 0.7071067811865476;
        $d5b33d7c30034067$var$_sphere$5.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$5);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $d5b33d7c30034067$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $d5b33d7c30034067$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $d5b33d7c30034067$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($d5b33d7c30034067$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $d5b33d7c30034067$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $d5b33d7c30034067$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute._updateRange; // @deprecated, r159
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1 && updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        if (updateRanges.length !== 0) {
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        // @deprecated, r159
        if (updateRange.count !== -1) {
            gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $d5b33d7c30034067$export$967d831af31f69ce extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $d5b33d7c30034067$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $d5b33d7c30034067$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif";
var $d5b33d7c30034067$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $d5b33d7c30034067$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	#ifdef ALPHA_TO_COVERAGE\n	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n	if ( diffuseColor.a == 0.0 ) discard;\n	#else\n	if ( diffuseColor.a < alphaTest ) discard;\n	#endif\n#endif";
var $d5b33d7c30034067$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $d5b33d7c30034067$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $d5b33d7c30034067$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $d5b33d7c30034067$var$batching_pars_vertex = "#ifdef USE_BATCHING\n	#if ! defined( GL_ANGLE_multi_draw )\n	#define gl_DrawID _gl_DrawID\n	uniform int _gl_DrawID;\n	#endif\n	uniform highp sampler2D batchingTexture;\n	uniform highp usampler2D batchingIdTexture;\n	mat4 getBatchingMatrix( const in float i ) {\n		int size = textureSize( batchingTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n	float getIndirectIndex( const in int i ) {\n		int size = textureSize( batchingIdTexture, 0 ).x;\n		int x = i % size;\n		int y = i / size;\n		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n	}\n#endif\n#ifdef USE_BATCHING_COLOR\n	uniform sampler2D batchingColorTexture;\n	vec3 getBatchingColor( const in float i ) {\n		int size = textureSize( batchingColorTexture, 0 ).x;\n		int j = int( i );\n		int x = j % size;\n		int y = j / size;\n		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n	}\n#endif";
var $d5b33d7c30034067$var$batching_vertex = "#ifdef USE_BATCHING\n	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $d5b33d7c30034067$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif";
var $d5b33d7c30034067$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $d5b33d7c30034067$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
var $d5b33d7c30034067$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
var $d5b33d7c30034067$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $d5b33d7c30034067$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#ifdef ALPHA_TO_COVERAGE\n		float distanceToPlane, distanceGradient;\n		float clipOpacity = 1.0;\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n			distanceGradient = fwidth( distanceToPlane ) / 2.0;\n			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			if ( clipOpacity == 0.0 ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			float unionClipOpacity = 1.0;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n				distanceGradient = fwidth( distanceToPlane ) / 2.0;\n				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			}\n			#pragma unroll_loop_end\n			clipOpacity *= 1.0 - unionClipOpacity;\n		#endif\n		diffuseColor.a *= clipOpacity;\n		if ( diffuseColor.a == 0.0 ) discard;\n	#else\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			bool clipped = true;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n			}\n			#pragma unroll_loop_end\n			if ( clipped ) discard;\n		#endif\n	#endif\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $d5b33d7c30034067$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $d5b33d7c30034067$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	varying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n	vColor.xyz *= batchingColor.xyz;\n#endif";
var $d5b33d7c30034067$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $d5b33d7c30034067$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $d5b33d7c30034067$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n	vec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n	mat3 bm = mat3( batchingMatrix );\n	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n	transformedNormal = bm * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = bm * transformedTangent;\n	#endif\n#endif\n#ifdef USE_INSTANCING\n	mat3 im = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n	transformedNormal = im * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = im * transformedTangent;\n	#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $d5b33d7c30034067$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $d5b33d7c30034067$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $d5b33d7c30034067$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $d5b33d7c30034067$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $d5b33d7c30034067$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $d5b33d7c30034067$var$colorspace_pars_fragment = "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n	vec3( 0.8224621, 0.177538, 0.0 ),\n	vec3( 0.0331941, 0.9668058, 0.0 ),\n	vec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n	vec3( 1.2249401, - 0.2249404, 0.0 ),\n	vec3( - 0.0420569, 1.0420571, 0.0 ),\n	vec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $d5b33d7c30034067$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $d5b33d7c30034067$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	uniform mat3 envMapRotation;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $d5b33d7c30034067$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $d5b33d7c30034067$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $d5b33d7c30034067$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $d5b33d7c30034067$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $d5b33d7c30034067$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $d5b33d7c30034067$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $d5b33d7c30034067$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $d5b33d7c30034067$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
var $d5b33d7c30034067$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $d5b33d7c30034067$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
var $d5b33d7c30034067$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if ( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $d5b33d7c30034067$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif";
var $d5b33d7c30034067$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $d5b33d7c30034067$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
var $d5b33d7c30034067$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
var $d5b33d7c30034067$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n	material.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	if( material.anisotropy == 0.0 ) {\n		anisotropyV = vec2( 1.0, 0.0 );\n	} else {\n		anisotropyV /= material.anisotropy;\n		material.anisotropy = saturate( material.anisotropy );\n	}\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $d5b33d7c30034067$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	float dispersion;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $d5b33d7c30034067$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $d5b33d7c30034067$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $d5b33d7c30034067$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	vFragDepth = 1.0 + gl_Position.w;\n	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $d5b33d7c30034067$var$map_fragment = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
var $d5b33d7c30034067$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $d5b33d7c30034067$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $d5b33d7c30034067$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $d5b33d7c30034067$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n	float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n	}\n#endif";
var $d5b33d7c30034067$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var $d5b33d7c30034067$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
var $d5b33d7c30034067$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	#ifndef USE_INSTANCING_MORPH\n		uniform float morphTargetBaseInfluence;\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	#endif\n	uniform sampler2DArray morphTargetsTexture;\n	uniform ivec2 morphTargetsTextureSize;\n	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n		int y = texelIndex / morphTargetsTextureSize.x;\n		int x = texelIndex - y * morphTargetsTextureSize.x;\n		ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n		return texelFetch( morphTargetsTexture, morphUV, 0 );\n	}\n#endif";
var $d5b33d7c30034067$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
var $d5b33d7c30034067$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $d5b33d7c30034067$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $d5b33d7c30034067$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $d5b33d7c30034067$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $d5b33d7c30034067$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $d5b33d7c30034067$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $d5b33d7c30034067$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
var $d5b33d7c30034067$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var $d5b33d7c30034067$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $d5b33d7c30034067$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n	if( v <= 0.0 )\n		return vec4( 0., 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec4( 1., 1., 1., 1. );\n	float vuf;\n	float af = modf( v * PackFactors.a, vuf );\n	float bf = modf( vuf * ShiftRight8, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n	if( v <= 0.0 )\n		return vec3( 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec3( 1., 1., 1. );\n	float vuf;\n	float bf = modf( v * PackFactors.b, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n	if( v <= 0.0 )\n		return vec2( 0., 0. );\n	if( v >= 1.0 )\n		return vec2( 1., 1. );\n	float vuf;\n	float gf = modf( v * 256., vuf );\n	return vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n	return dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $d5b33d7c30034067$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $d5b33d7c30034067$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n	mvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $d5b33d7c30034067$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $d5b33d7c30034067$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $d5b33d7c30034067$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		\n		float lightToPositionLength = length( lightToPosition );\n		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;\n			vec3 bd3D = normalize( lightToPosition );\n			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n				shadow = (\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n				) * ( 1.0 / 9.0 );\n			#else\n				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n			#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $d5b33d7c30034067$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
var $d5b33d7c30034067$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $d5b33d7c30034067$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $d5b33d7c30034067$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	mat4 getBoneMatrix( const in float i ) {\n		int size = textureSize( boneTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n#endif";
var $d5b33d7c30034067$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $d5b33d7c30034067$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $d5b33d7c30034067$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $d5b33d7c30034067$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $d5b33d7c30034067$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n	vec3( 1.6605, - 0.1246, - 0.0182 ),\n	vec3( - 0.5876, 1.1329, - 0.1006 ),\n	vec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n	vec3( 0.6274, 0.0691, 0.0164 ),\n	vec3( 0.3293, 0.9195, 0.0880 ),\n	vec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n	vec3 x2 = x * x;\n	vec3 x4 = x2 * x2;\n	return + 15.5 * x4 * x2\n		- 40.14 * x4 * x\n		+ 31.96 * x4\n		- 6.868 * x2 * x\n		+ 0.4298 * x2\n		+ 0.1191 * x\n		- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n	const mat3 AgXInsetMatrix = mat3(\n		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n	);\n	const mat3 AgXOutsetMatrix = mat3(\n		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n	);\n	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;\n	color *= toneMappingExposure;\n	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n	color = AgXInsetMatrix * color;\n	color = max( color, 1e-10 );	color = log2( color );\n	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n	color = clamp( color, 0.0, 1.0 );\n	color = agxDefaultContrastApprox( color );\n	color = AgXOutsetMatrix * color;\n	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n	color = clamp( color, 0.0, 1.0 );\n	return color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n	const float StartCompression = 0.8 - 0.04;\n	const float Desaturation = 0.15;\n	color *= toneMappingExposure;\n	float x = min( color.r, min( color.g, color.b ) );\n	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n	color -= offset;\n	float peak = max( color.r, max( color.g, color.b ) );\n	if ( peak < StartCompression ) return color;\n	float d = 1. - StartCompression;\n	float newPeak = 1. - d * d / ( peak + d - StartCompression );\n	color *= newPeak / peak;\n	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n	return mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $d5b33d7c30034067$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $d5b33d7c30034067$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec4 transmittedLight;\n		vec3 transmittance;\n		#ifdef USE_DISPERSION\n			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n			for ( int i = 0; i < 3; i ++ ) {\n				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n				vec3 refractedRayExit = position + transmissionRay;\n		\n				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n				vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n				refractionCoords += 1.0;\n				refractionCoords /= 2.0;\n		\n				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n				transmittedLight[ i ] = transmissionSample[ i ];\n				transmittedLight.a += transmissionSample.a;\n				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n			}\n			transmittedLight.a /= 3.0;\n		\n		#else\n		\n			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n			vec3 refractedRayExit = position + transmissionRay;\n			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n			vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n			refractionCoords += 1.0;\n			refractionCoords /= 2.0;\n			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		\n		#endif\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif";
var $d5b33d7c30034067$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $d5b33d7c30034067$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_BATCHING\n		worldPosition = batchingMatrix * worldPosition;\n	#endif\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $d5b33d7c30034067$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $d5b33d7c30034067$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#elif DEPTH_PACKING == 3202\n		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n	#elif DEPTH_PACKING == 3203\n		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n	#endif\n}";
const $d5b33d7c30034067$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $d5b33d7c30034067$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $d5b33d7c30034067$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const $d5b33d7c30034067$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n	uniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const $d5b33d7c30034067$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const $d5b33d7c30034067$export$955f9f2e84c43c8b = {
    alphahash_fragment: $d5b33d7c30034067$var$alphahash_fragment,
    alphahash_pars_fragment: $d5b33d7c30034067$var$alphahash_pars_fragment,
    alphamap_fragment: $d5b33d7c30034067$var$alphamap_fragment,
    alphamap_pars_fragment: $d5b33d7c30034067$var$alphamap_pars_fragment,
    alphatest_fragment: $d5b33d7c30034067$var$alphatest_fragment,
    alphatest_pars_fragment: $d5b33d7c30034067$var$alphatest_pars_fragment,
    aomap_fragment: $d5b33d7c30034067$var$aomap_fragment,
    aomap_pars_fragment: $d5b33d7c30034067$var$aomap_pars_fragment,
    batching_pars_vertex: $d5b33d7c30034067$var$batching_pars_vertex,
    batching_vertex: $d5b33d7c30034067$var$batching_vertex,
    begin_vertex: $d5b33d7c30034067$var$begin_vertex,
    beginnormal_vertex: $d5b33d7c30034067$var$beginnormal_vertex,
    bsdfs: $d5b33d7c30034067$var$bsdfs,
    iridescence_fragment: $d5b33d7c30034067$var$iridescence_fragment,
    bumpmap_pars_fragment: $d5b33d7c30034067$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $d5b33d7c30034067$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $d5b33d7c30034067$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $d5b33d7c30034067$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $d5b33d7c30034067$var$clipping_planes_vertex,
    color_fragment: $d5b33d7c30034067$var$color_fragment,
    color_pars_fragment: $d5b33d7c30034067$var$color_pars_fragment,
    color_pars_vertex: $d5b33d7c30034067$var$color_pars_vertex,
    color_vertex: $d5b33d7c30034067$var$color_vertex,
    common: $d5b33d7c30034067$var$common,
    cube_uv_reflection_fragment: $d5b33d7c30034067$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $d5b33d7c30034067$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $d5b33d7c30034067$var$displacementmap_pars_vertex,
    displacementmap_vertex: $d5b33d7c30034067$var$displacementmap_vertex,
    emissivemap_fragment: $d5b33d7c30034067$var$emissivemap_fragment,
    emissivemap_pars_fragment: $d5b33d7c30034067$var$emissivemap_pars_fragment,
    colorspace_fragment: $d5b33d7c30034067$var$colorspace_fragment,
    colorspace_pars_fragment: $d5b33d7c30034067$var$colorspace_pars_fragment,
    envmap_fragment: $d5b33d7c30034067$var$envmap_fragment,
    envmap_common_pars_fragment: $d5b33d7c30034067$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $d5b33d7c30034067$var$envmap_pars_fragment,
    envmap_pars_vertex: $d5b33d7c30034067$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $d5b33d7c30034067$var$envmap_physical_pars_fragment,
    envmap_vertex: $d5b33d7c30034067$var$envmap_vertex,
    fog_vertex: $d5b33d7c30034067$var$fog_vertex,
    fog_pars_vertex: $d5b33d7c30034067$var$fog_pars_vertex,
    fog_fragment: $d5b33d7c30034067$var$fog_fragment,
    fog_pars_fragment: $d5b33d7c30034067$var$fog_pars_fragment,
    gradientmap_pars_fragment: $d5b33d7c30034067$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $d5b33d7c30034067$var$lightmap_pars_fragment,
    lights_lambert_fragment: $d5b33d7c30034067$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $d5b33d7c30034067$var$lights_lambert_pars_fragment,
    lights_pars_begin: $d5b33d7c30034067$var$lights_pars_begin,
    lights_toon_fragment: $d5b33d7c30034067$var$lights_toon_fragment,
    lights_toon_pars_fragment: $d5b33d7c30034067$var$lights_toon_pars_fragment,
    lights_phong_fragment: $d5b33d7c30034067$var$lights_phong_fragment,
    lights_phong_pars_fragment: $d5b33d7c30034067$var$lights_phong_pars_fragment,
    lights_physical_fragment: $d5b33d7c30034067$var$lights_physical_fragment,
    lights_physical_pars_fragment: $d5b33d7c30034067$var$lights_physical_pars_fragment,
    lights_fragment_begin: $d5b33d7c30034067$var$lights_fragment_begin,
    lights_fragment_maps: $d5b33d7c30034067$var$lights_fragment_maps,
    lights_fragment_end: $d5b33d7c30034067$var$lights_fragment_end,
    logdepthbuf_fragment: $d5b33d7c30034067$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $d5b33d7c30034067$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $d5b33d7c30034067$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $d5b33d7c30034067$var$logdepthbuf_vertex,
    map_fragment: $d5b33d7c30034067$var$map_fragment,
    map_pars_fragment: $d5b33d7c30034067$var$map_pars_fragment,
    map_particle_fragment: $d5b33d7c30034067$var$map_particle_fragment,
    map_particle_pars_fragment: $d5b33d7c30034067$var$map_particle_pars_fragment,
    metalnessmap_fragment: $d5b33d7c30034067$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $d5b33d7c30034067$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $d5b33d7c30034067$var$morphinstance_vertex,
    morphcolor_vertex: $d5b33d7c30034067$var$morphcolor_vertex,
    morphnormal_vertex: $d5b33d7c30034067$var$morphnormal_vertex,
    morphtarget_pars_vertex: $d5b33d7c30034067$var$morphtarget_pars_vertex,
    morphtarget_vertex: $d5b33d7c30034067$var$morphtarget_vertex,
    normal_fragment_begin: $d5b33d7c30034067$var$normal_fragment_begin,
    normal_fragment_maps: $d5b33d7c30034067$var$normal_fragment_maps,
    normal_pars_fragment: $d5b33d7c30034067$var$normal_pars_fragment,
    normal_pars_vertex: $d5b33d7c30034067$var$normal_pars_vertex,
    normal_vertex: $d5b33d7c30034067$var$normal_vertex,
    normalmap_pars_fragment: $d5b33d7c30034067$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $d5b33d7c30034067$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $d5b33d7c30034067$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $d5b33d7c30034067$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $d5b33d7c30034067$var$iridescence_pars_fragment,
    opaque_fragment: $d5b33d7c30034067$var$opaque_fragment,
    packing: $d5b33d7c30034067$var$packing,
    premultiplied_alpha_fragment: $d5b33d7c30034067$var$premultiplied_alpha_fragment,
    project_vertex: $d5b33d7c30034067$var$project_vertex,
    dithering_fragment: $d5b33d7c30034067$var$dithering_fragment,
    dithering_pars_fragment: $d5b33d7c30034067$var$dithering_pars_fragment,
    roughnessmap_fragment: $d5b33d7c30034067$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $d5b33d7c30034067$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $d5b33d7c30034067$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $d5b33d7c30034067$var$shadowmap_pars_vertex,
    shadowmap_vertex: $d5b33d7c30034067$var$shadowmap_vertex,
    shadowmask_pars_fragment: $d5b33d7c30034067$var$shadowmask_pars_fragment,
    skinbase_vertex: $d5b33d7c30034067$var$skinbase_vertex,
    skinning_pars_vertex: $d5b33d7c30034067$var$skinning_pars_vertex,
    skinning_vertex: $d5b33d7c30034067$var$skinning_vertex,
    skinnormal_vertex: $d5b33d7c30034067$var$skinnormal_vertex,
    specularmap_fragment: $d5b33d7c30034067$var$specularmap_fragment,
    specularmap_pars_fragment: $d5b33d7c30034067$var$specularmap_pars_fragment,
    tonemapping_fragment: $d5b33d7c30034067$var$tonemapping_fragment,
    tonemapping_pars_fragment: $d5b33d7c30034067$var$tonemapping_pars_fragment,
    transmission_fragment: $d5b33d7c30034067$var$transmission_fragment,
    transmission_pars_fragment: $d5b33d7c30034067$var$transmission_pars_fragment,
    uv_pars_fragment: $d5b33d7c30034067$var$uv_pars_fragment,
    uv_pars_vertex: $d5b33d7c30034067$var$uv_pars_vertex,
    uv_vertex: $d5b33d7c30034067$var$uv_vertex,
    worldpos_vertex: $d5b33d7c30034067$var$worldpos_vertex,
    background_vert: $d5b33d7c30034067$var$vertex$h,
    background_frag: $d5b33d7c30034067$var$fragment$h,
    backgroundCube_vert: $d5b33d7c30034067$var$vertex$g,
    backgroundCube_frag: $d5b33d7c30034067$var$fragment$g,
    cube_vert: $d5b33d7c30034067$var$vertex$f,
    cube_frag: $d5b33d7c30034067$var$fragment$f,
    depth_vert: $d5b33d7c30034067$var$vertex$e,
    depth_frag: $d5b33d7c30034067$var$fragment$e,
    distanceRGBA_vert: $d5b33d7c30034067$var$vertex$d,
    distanceRGBA_frag: $d5b33d7c30034067$var$fragment$d,
    equirect_vert: $d5b33d7c30034067$var$vertex$c,
    equirect_frag: $d5b33d7c30034067$var$fragment$c,
    linedashed_vert: $d5b33d7c30034067$var$vertex$b,
    linedashed_frag: $d5b33d7c30034067$var$fragment$b,
    meshbasic_vert: $d5b33d7c30034067$var$vertex$a,
    meshbasic_frag: $d5b33d7c30034067$var$fragment$a,
    meshlambert_vert: $d5b33d7c30034067$var$vertex$9,
    meshlambert_frag: $d5b33d7c30034067$var$fragment$9,
    meshmatcap_vert: $d5b33d7c30034067$var$vertex$8,
    meshmatcap_frag: $d5b33d7c30034067$var$fragment$8,
    meshnormal_vert: $d5b33d7c30034067$var$vertex$7,
    meshnormal_frag: $d5b33d7c30034067$var$fragment$7,
    meshphong_vert: $d5b33d7c30034067$var$vertex$6,
    meshphong_frag: $d5b33d7c30034067$var$fragment$6,
    meshphysical_vert: $d5b33d7c30034067$var$vertex$5,
    meshphysical_frag: $d5b33d7c30034067$var$fragment$5,
    meshtoon_vert: $d5b33d7c30034067$var$vertex$4,
    meshtoon_frag: $d5b33d7c30034067$var$fragment$4,
    points_vert: $d5b33d7c30034067$var$vertex$3,
    points_frag: $d5b33d7c30034067$var$fragment$3,
    shadow_vert: $d5b33d7c30034067$var$vertex$2,
    shadow_frag: $d5b33d7c30034067$var$fragment$2,
    sprite_vert: $d5b33d7c30034067$var$vertex$1,
    sprite_frag: $d5b33d7c30034067$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $d5b33d7c30034067$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $d5b33d7c30034067$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.roughnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.metalnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.gradientmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.points,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.sprite,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_frag
    }
};
$d5b33d7c30034067$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
        $d5b33d7c30034067$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
};
const $d5b33d7c30034067$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $d5b33d7c30034067$var$_e1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$d93cc409a0768c5f();
const $d5b33d7c30034067$var$_m1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
function $d5b33d7c30034067$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === "additive") state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === "alpha-blend") state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$33e43285f7406bd5(1, 1, 1), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $d5b33d7c30034067$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $d5b33d7c30034067$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $d5b33d7c30034067$var$_e1$1.x *= -1;
            $d5b33d7c30034067$var$_e1$1.y *= -1;
            $d5b33d7c30034067$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $d5b33d7c30034067$var$_e1$1.y *= -1;
                $d5b33d7c30034067$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($d5b33d7c30034067$var$_m1$1.makeRotationFromEuler($d5b33d7c30034067$var$_e1$1));
            boxMesh.material.toneMapped = $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $d5b33d7c30034067$export$8d0a61916cc26abb;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$967d831af31f69ce(2, 2), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $d5b33d7c30034067$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $d5b33d7c30034067$export$8d0a61916cc26abb;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($d5b33d7c30034067$var$_rgb, $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($d5b33d7c30034067$var$_rgb.r, $d5b33d7c30034067$var$_rgb.g, $d5b33d7c30034067$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList
    };
}
function $d5b33d7c30034067$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $d5b33d7c30034067$export$5c612977753abe2;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $d5b33d7c30034067$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get("WEBGL_multi_draw");
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get("WEBGL_multi_draw");
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i];
            for(let i = 0; i < primcount.length; i++)info.update(elementCount, mode, primcount[i]);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $d5b33d7c30034067$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== $d5b33d7c30034067$export$3f8bb04b555a363c && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === $d5b33d7c30034067$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || extensions.has("EXT_color_buffer_float"));
        if (textureType !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== $d5b33d7c30034067$export$f6d331659b644596 && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return "mediump";
        }
        return "lowp";
    }
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $d5b33d7c30034067$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), viewNormalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $d5b33d7c30034067$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $d5b33d7c30034067$export$d64030b316d3b087) texture.mapping = $d5b33d7c30034067$export$8759762a6477f2c4;
        else if (mapping === $d5b33d7c30034067$export$ee99d97d46898098) texture.mapping = $d5b33d7c30034067$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $d5b33d7c30034067$export$ac386671d651941e(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$9ebf355ee4ed261b extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $d5b33d7c30034067$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $d5b33d7c30034067$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $d5b33d7c30034067$var$MAX_SAMPLES = 20;
const $d5b33d7c30034067$var$_flatCamera = /*@__PURE__*/ new $d5b33d7c30034067$export$9ebf355ee4ed261b();
const $d5b33d7c30034067$var$_clearColor = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
let $d5b33d7c30034067$var$_oldTarget = null;
let $d5b33d7c30034067$var$_oldActiveCubeFace = 0;
let $d5b33d7c30034067$var$_oldActiveMipmapLevel = 0;
let $d5b33d7c30034067$var$_oldXrEnabled = false;
// Golden Ratio
const $d5b33d7c30034067$var$PHI = (1 + Math.sqrt(5)) / 2;
const $d5b33d7c30034067$var$INV_PHI = 1 / $d5b33d7c30034067$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $d5b33d7c30034067$var$_axisDirections = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, -$d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $d5b33d7c30034067$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        $d5b33d7c30034067$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5b33d7c30034067$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $d5b33d7c30034067$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported equirectangular image size is 64 x 32.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported cube size is 16 x 16.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d5b33d7c30034067$var$_oldTarget, $d5b33d7c30034067$var$_oldActiveCubeFace, $d5b33d7c30034067$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $d5b33d7c30034067$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $d5b33d7c30034067$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        $d5b33d7c30034067$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5b33d7c30034067$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $d5b33d7c30034067$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            minFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $d5b33d7c30034067$export$2697304443f382bc,
            format: $d5b33d7c30034067$export$3f8bb04b555a363c,
            colorSpace: $d5b33d7c30034067$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $d5b33d7c30034067$var$_createPlanes(_lodMax));
            this._blurMaterial = $d5b33d7c30034067$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $d5b33d7c30034067$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($d5b33d7c30034067$var$_clearColor);
        renderer.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($d5b33d7c30034067$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        const size = this._cubeSize;
        $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodPlanes.length;
        for(let i = 1; i < n; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $d5b33d7c30034067$var$_axisDirections[(n - i - 1) % $d5b33d7c30034067$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d5b33d7c30034067$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d5b33d7c30034067$var$MAX_SAMPLES;
        if (samples > $d5b33d7c30034067$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d5b33d7c30034067$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d5b33d7c30034067$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d5b33d7c30034067$var$LOD_MIN ? lodOut - _lodMax + $d5b33d7c30034067$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d5b33d7c30034067$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d5b33d7c30034067$var$_flatCamera);
    }
}
function $d5b33d7c30034067$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $d5b33d7c30034067$var$LOD_MIN + 1 + $d5b33d7c30034067$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d5b33d7c30034067$var$LOD_MIN) sigma = $d5b33d7c30034067$var$EXTRA_LOD_SIGMA[i - lodMax + $d5b33d7c30034067$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $d5b33d7c30034067$export$b7be63a67df8959();
        planes.setAttribute("position", new $d5b33d7c30034067$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $d5b33d7c30034067$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $d5b33d7c30034067$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $d5b33d7c30034067$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $d5b33d7c30034067$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $d5b33d7c30034067$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d5b33d7c30034067$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d5b33d7c30034067$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($d5b33d7c30034067$var$MAX_SAMPLES);
    const poleAxis = new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: "SphericalGaussianBlur",
        defines: {
            "n": $d5b33d7c30034067$var$MAX_SAMPLES,
            "CUBEUV_TEXEL_WIDTH": 1.0 / width,
            "CUBEUV_TEXEL_HEIGHT": 1.0 / height,
            "CUBEUV_MAX_MIP": `${lodMax}.0`
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $d5b33d7c30034067$var$_getEquirectMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCubemapMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $d5b33d7c30034067$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098;
            const isCubeMap = mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension("EXT_color_buffer_float");
            getExtension("WEBGL_clip_cull_distance");
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
            getExtension("WEBGL_render_shared_exponent");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) $d5b33d7c30034067$var$warnOnce("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $d5b33d7c30034067$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ($d5b33d7c30034067$var$arrayNeedsUint32(indices) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get("WEBGL_multi_draw");
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get("WEBGL_multi_draw");
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i];
            for(let i = 0; i < primcount.length; i++)info.update(elementCount, mode, primcount[i]);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $d5b33d7c30034067$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
            texture.type = $d5b33d7c30034067$export$f6d331659b644596;
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new $d5b33d7c30034067$export$c977b3e384af9ae1(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener("dispose", disposeTexture);
            }
            geometry.addEventListener("dispose", disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, "morphTexture", object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
        }
        program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
        program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
    }
    return {
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$fc830aa069cc8c2f extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format = $d5b33d7c30034067$export$c1b6b5136be58045){
        if (format !== $d5b33d7c30034067$export$c1b6b5136be58045 && format !== $d5b33d7c30034067$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $d5b33d7c30034067$export$c1b6b5136be58045) type = $d5b33d7c30034067$export$c3c7fc4518ebba96;
        if (type === undefined && format === $d5b33d7c30034067$export$1e113ac2d0905829) type = $d5b33d7c30034067$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $d5b33d7c30034067$var$emptyTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$5431306cf43de24a();
const $d5b33d7c30034067$var$emptyShadowTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$fc830aa069cc8c2f(1, 1);
const $d5b33d7c30034067$var$emptyArrayTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$dfac6c8e811406a3();
const $d5b33d7c30034067$var$empty3dTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$d7a3086320f856db();
const $d5b33d7c30034067$var$emptyCubeTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $d5b33d7c30034067$var$arrayCacheF32 = [];
const $d5b33d7c30034067$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $d5b33d7c30034067$var$mat4array = new Float32Array(16);
const $d5b33d7c30034067$var$mat3array = new Float32Array(9);
const $d5b33d7c30034067$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $d5b33d7c30034067$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $d5b33d7c30034067$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $d5b33d7c30034067$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $d5b33d7c30034067$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $d5b33d7c30034067$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $d5b33d7c30034067$var$allocTexUnits(textures, n) {
    let r = $d5b33d7c30034067$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $d5b33d7c30034067$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $d5b33d7c30034067$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $d5b33d7c30034067$var$mat2array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $d5b33d7c30034067$var$mat3array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $d5b33d7c30034067$var$mat4array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $d5b33d7c30034067$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $d5b33d7c30034067$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $d5b33d7c30034067$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $d5b33d7c30034067$var$emptyShadowTexture.compareFunction = $d5b33d7c30034067$export$64eea11eb407ddf1; // #28670
        emptyTexture2D = $d5b33d7c30034067$var$emptyShadowTexture;
    } else emptyTexture2D = $d5b33d7c30034067$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $d5b33d7c30034067$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $d5b33d7c30034067$var$empty3dTexture, unit);
}
function $d5b33d7c30034067$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $d5b33d7c30034067$var$emptyCubeTexture, unit);
}
function $d5b33d7c30034067$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $d5b33d7c30034067$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $d5b33d7c30034067$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4i; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArray1;
    }
}
// Array of scalars
function $d5b33d7c30034067$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV3fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV4fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM3Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM4Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $d5b33d7c30034067$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $d5b33d7c30034067$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $d5b33d7c30034067$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $d5b33d7c30034067$var$emptyTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $d5b33d7c30034067$var$empty3dTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $d5b33d7c30034067$var$emptyCubeTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $d5b33d7c30034067$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $d5b33d7c30034067$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $d5b33d7c30034067$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $d5b33d7c30034067$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $d5b33d7c30034067$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $d5b33d7c30034067$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $d5b33d7c30034067$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $d5b33d7c30034067$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $d5b33d7c30034067$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $d5b33d7c30034067$var$RePathPart.exec(path), matchEnd = $d5b33d7c30034067$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $d5b33d7c30034067$var$addUniform(container, subscript === undefined ? new $d5b33d7c30034067$var$SingleUniform(id, activeInfo, addr) : new $d5b33d7c30034067$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $d5b33d7c30034067$var$StructuredUniform(id);
                $d5b33d7c30034067$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $d5b33d7c30034067$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $d5b33d7c30034067$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $d5b33d7c30034067$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $d5b33d7c30034067$var$COMPLETION_STATUS_KHR = 0x91B1;
let $d5b33d7c30034067$var$programIdCount = 0;
function $d5b33d7c30034067$var$handleSource(string, errorLine) {
    const lines = string.split("\n");
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i]}`);
    }
    return lines2.join("\n");
}
function $d5b33d7c30034067$var$getEncodingComponents(colorSpace1) {
    const workingPrimaries = $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries($d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace);
    const encodingPrimaries = $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries(colorSpace1);
    let gamutMapping;
    if (workingPrimaries === encodingPrimaries) gamutMapping = "";
    else if (workingPrimaries === $d5b33d7c30034067$export$ef371755dbe7f98a && encodingPrimaries === $d5b33d7c30034067$export$ce9118f9eaae3bb2) gamutMapping = "LinearDisplayP3ToLinearSRGB";
    else if (workingPrimaries === $d5b33d7c30034067$export$ce9118f9eaae3bb2 && encodingPrimaries === $d5b33d7c30034067$export$ef371755dbe7f98a) gamutMapping = "LinearSRGBToLinearDisplayP3";
    switch(colorSpace1){
        case $d5b33d7c30034067$export$42429b3acfb233a4:
        case $d5b33d7c30034067$export$c0dc1bc7e964761:
            return [
                gamutMapping,
                "LinearTransferOETF"
            ];
        case $d5b33d7c30034067$export$561f394b24edfcaa:
        case $d5b33d7c30034067$export$626af19ae879bdf6:
            return [
                gamutMapping,
                "sRGBTransferOETF"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported color space:", colorSpace1);
            return [
                gamutMapping,
                "LinearTransferOETF"
            ];
    }
}
function $d5b33d7c30034067$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + "\n\n" + errors + "\n\n" + $d5b33d7c30034067$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $d5b33d7c30034067$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $d5b33d7c30034067$var$getEncodingComponents(colorSpace1);
    return `vec4 ${functionName}( vec4 value ) { return ${components[0]}( ${components[1]}( value ) ); }`;
}
function $d5b33d7c30034067$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $d5b33d7c30034067$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $d5b33d7c30034067$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $d5b33d7c30034067$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $d5b33d7c30034067$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $d5b33d7c30034067$export$212d53a513a325b2:
            toneMappingName = "AgX";
            break;
        case $d5b33d7c30034067$export$f2863e1668a8e317:
            toneMappingName = "Neutral";
            break;
        case $d5b33d7c30034067$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
const $d5b33d7c30034067$var$_v0$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
function $d5b33d7c30034067$var$getLuminanceFunction() {
    $d5b33d7c30034067$export$5e6fd513f44698c.getLuminanceCoefficients($d5b33d7c30034067$var$_v0$1);
    const r = $d5b33d7c30034067$var$_v0$1.x.toFixed(4);
    const g = $d5b33d7c30034067$var$_v0$1.y.toFixed(4);
    const b = $d5b33d7c30034067$var$_v0$1.z.toFixed(4);
    return [
        "float luminance( const in vec3 rgb ) {",
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        "	return dot( weights, rgb );",
        "}"
    ].join("\n");
}
function $d5b33d7c30034067$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
        parameters.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
    ];
    return chunks.filter($d5b33d7c30034067$var$filterEmptyLine).join("\n");
}
function $d5b33d7c30034067$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $d5b33d7c30034067$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $d5b33d7c30034067$var$filterEmptyLine(string) {
    return string !== "";
}
function $d5b33d7c30034067$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $d5b33d7c30034067$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $d5b33d7c30034067$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $d5b33d7c30034067$var$resolveIncludes(string) {
    return string.replace($d5b33d7c30034067$var$includePattern, $d5b33d7c30034067$var$includeReplacer);
}
const $d5b33d7c30034067$var$shaderChunkMap = new Map();
function $d5b33d7c30034067$var$includeReplacer(match, include) {
    let string = $d5b33d7c30034067$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $d5b33d7c30034067$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $d5b33d7c30034067$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error("Can not resolve #include <" + include + ">");
    }
    return $d5b33d7c30034067$var$resolveIncludes(string);
}
// Unroll Loops
const $d5b33d7c30034067$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $d5b33d7c30034067$var$unrollLoops(string) {
    return string.replace($d5b33d7c30034067$var$unrollLoopPattern, $d5b33d7c30034067$var$loopReplacer);
}
function $d5b33d7c30034067$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $d5b33d7c30034067$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $d5b33d7c30034067$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$8759762a6477f2c4:
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $d5b33d7c30034067$export$dbf3e70ff37af79:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $d5b33d7c30034067$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $d5b33d7c30034067$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $d5b33d7c30034067$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $d5b33d7c30034067$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $d5b33d7c30034067$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $d5b33d7c30034067$var$generateVertexExtensions(parameters);
    const customDefines = $d5b33d7c30034067$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
            parameters.batching ? "#define USE_BATCHING" : "",
            parameters.batchingColor ? "#define USE_BATCHING_COLOR" : "",
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            //
            parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
            parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
            parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
            parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
            parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
            parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
            parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
            parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
            parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
            parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
            parameters.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + parameters.anisotropyMapUv : "",
            parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
            parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
            parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
            parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
            parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
            parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
            parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
            parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
            parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
            parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
            parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
            parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
            //
            parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphColors ? "#define USE_MORPHCOLORS" : "",
            parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
            parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "#ifdef USE_INSTANCING_MORPH",
            "	uniform sampler2D morphTexture;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_UV1",
            "	attribute vec2 uv1;",
            "#endif",
            "#ifdef USE_UV2",
            "	attribute vec2 uv2;",
            "#endif",
            "#ifdef USE_UV3",
            "	attribute vec2 uv3;",
            "#endif",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join("\n");
        prefixFragment = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
            envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.dispersion ? "#define USE_DISPERSION" : "",
            parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
            parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.opaque ? "#define OPAQUE" : "",
            $d5b33d7c30034067$export$955f9f2e84c43c8b["colorspace_pars_fragment"],
            $d5b33d7c30034067$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputColorSpace),
            $d5b33d7c30034067$var$getLuminanceFunction(),
            parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join("\n");
    }
    vertexShader = $d5b33d7c30034067$var$resolveIncludes(vertexShader);
    vertexShader = $d5b33d7c30034067$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$resolveIncludes(fragmentShader);
    fragmentShader = $d5b33d7c30034067$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $d5b33d7c30034067$var$unrollLoops(vertexShader);
    fragmentShader = $d5b33d7c30034067$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            customVertexExtensions,
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programLog = gl.getProgramInfoLog(program).trim();
            const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === "function") renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glVertexShader, "vertex");
                    const fragmentErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glFragmentShader, "fragment");
                    console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\n" + "Material Name: " + self1.name + "\n" + "Material Type: " + self1.type + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
                }
            } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
            else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $d5b33d7c30034067$var$WebGLUniforms(gl, program);
        cachedAttributes = $d5b33d7c30034067$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $d5b33d7c30034067$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $d5b33d7c30034067$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $d5b33d7c30034067$var$_id$1 = 0;
class $d5b33d7c30034067$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $d5b33d7c30034067$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $d5b33d7c30034067$var$WebGLShaderStage {
    constructor(code){
        this.id = $d5b33d7c30034067$var$_id$1++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $d5b33d7c30034067$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $d5b33d7c30034067$export$89312ce47c0ca777();
    const _customShaders = new $d5b33d7c30034067$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return "uv";
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $d5b33d7c30034067$export$42429b3acfb233a4,
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $d5b33d7c30034067$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $d5b33d7c30034067$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0 && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(material.map.colorSpace) === $d5b33d7c30034067$export$8d0a61916cc26abb,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $d5b33d7c30034067$export$3b296b6f144d5b03,
            flipSided: material.side === $d5b33d7c30034067$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has("WEBGL_clip_cull_distance"),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has("WEBGL_multi_draw"),
            rendererExtensionParallelShaderCompile: extensions.has("KHR_parallel_shader_compile"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.doubleSided) _programLayers.enable(10);
        if (parameters.flipSided) _programLayers.enable(11);
        if (parameters.useDepthPacking) _programLayers.enable(12);
        if (parameters.dithering) _programLayers.enable(13);
        if (parameters.transmission) _programLayers.enable(14);
        if (parameters.sheen) _programLayers.enable(15);
        if (parameters.opaque) _programLayers.enable(16);
        if (parameters.pointsUvs) _programLayers.enable(17);
        if (parameters.decodeVideoTexture) _programLayers.enable(18);
        if (parameters.alphaToCoverage) _programLayers.enable(19);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            uniforms = $d5b33d7c30034067$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $d5b33d7c30034067$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $d5b33d7c30034067$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        skyColor: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        groundColor: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfWidth: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfHeight: new $d5b33d7c30034067$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $d5b33d7c30034067$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $d5b33d7c30034067$var$nextVersion = 0;
function $d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $d5b33d7c30034067$var$WebGLLights(extensions) {
    const cache = new $d5b33d7c30034067$var$UniformsCache();
    const shadowCache = $d5b33d7c30034067$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    const vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
    const matrix4 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    const matrix42 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has("OES_texture_float_linear") === true) {
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $d5b33d7c30034067$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $d5b33d7c30034067$var$WebGLRenderState(extensions) {
    const lights = new $d5b33d7c30034067$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $d5b33d7c30034067$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$2698c22ec13825db extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = "MeshDepthMaterial";
        this.depthPacking = $d5b33d7c30034067$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $d5b33d7c30034067$export$33e187ed002f2a19 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = "MeshDistanceMaterial";
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $d5b33d7c30034067$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $d5b33d7c30034067$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
    const _shadowMapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewportSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(), _depthMaterial = new $d5b33d7c30034067$export$2698c22ec13825db({
        depthPacking: $d5b33d7c30034067$export$8f910f4c4f73df11
    }), _distanceMaterial = new $d5b33d7c30034067$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [$d5b33d7c30034067$export$2ede184fc2998901]: $d5b33d7c30034067$export$d9f0486e75b5ace,
        [$d5b33d7c30034067$export$d9f0486e75b5ace]: $d5b33d7c30034067$export$2ede184fc2998901,
        [$d5b33d7c30034067$export$3b296b6f144d5b03]: $d5b33d7c30034067$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $d5b33d7c30034067$var$vertex,
        fragmentShader: $d5b33d7c30034067$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $d5b33d7c30034067$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $d5b33d7c30034067$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $d5b33d7c30034067$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $d5b33d7c30034067$export$896ae1ade6c829c4 && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $d5b33d7c30034067$export$896ae1ade6c829c4 && this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4 ? {
                    minFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
                    magFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener("dispose", onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $d5b33d7c30034067$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $d5b33d7c30034067$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener("dispose", onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
function $d5b33d7c30034067$var$WebGLState(gl) {
    function ColorBuffer() {
        let locked = false;
        const color = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $d5b33d7c30034067$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $d5b33d7c30034067$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $d5b33d7c30034067$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $d5b33d7c30034067$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $d5b33d7c30034067$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $d5b33d7c30034067$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $d5b33d7c30034067$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $d5b33d7c30034067$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($d5b33d7c30034067$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($d5b33d7c30034067$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$d5b33d7c30034067$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$d5b33d7c30034067$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$d5b33d7c30034067$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[$d5b33d7c30034067$export$c8c1508da8d0600c] = gl.MIN;
    equationToGL[$d5b33d7c30034067$export$99948c02fb51055f] = gl.MAX;
    const factorToGL = {
        [$d5b33d7c30034067$export$2110f05edf778d3d]: gl.ZERO,
        [$d5b33d7c30034067$export$8805bad65e24940e]: gl.ONE,
        [$d5b33d7c30034067$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$d5b33d7c30034067$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$d5b33d7c30034067$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$d5b33d7c30034067$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$d5b33d7c30034067$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$d5b33d7c30034067$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$d5b33d7c30034067$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$d5b33d7c30034067$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$d5b33d7c30034067$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA,
        [$d5b33d7c30034067$export$7dd8f434fd59075]: gl.CONSTANT_COLOR,
        [$d5b33d7c30034067$export$99c8d898a9afbcee]: gl.ONE_MINUS_CONSTANT_COLOR,
        [$d5b33d7c30034067$export$310cd2be38d13b56]: gl.CONSTANT_ALPHA,
        [$d5b33d7c30034067$export$db77b8fbcf45dbf4]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === $d5b33d7c30034067$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $d5b33d7c30034067$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $d5b33d7c30034067$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $d5b33d7c30034067$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $d5b33d7c30034067$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $d5b33d7c30034067$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $d5b33d7c30034067$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $d5b33d7c30034067$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $d5b33d7c30034067$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $d5b33d7c30034067$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
function $d5b33d7c30034067$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
function $d5b33d7c30034067$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Given the width, height, format, and type of a texture. Determines how many
 * bytes must be used to represent the texture.
 */ function $d5b33d7c30034067$var$getByteLength(width, height, format, type) {
    const typeByteLength = $d5b33d7c30034067$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $d5b33d7c30034067$export$988473390501ed4b:
            return width * height;
        case $d5b33d7c30034067$export$cc09ccbf6d1ed449:
            return width * height;
        case $d5b33d7c30034067$export$9053a81c4a69c289:
            return width * height * 2;
        case $d5b33d7c30034067$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $d5b33d7c30034067$export$21d1799c6d552fc0:
        case $d5b33d7c30034067$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $d5b33d7c30034067$export$d2a1a68024a3e56c:
        case $d5b33d7c30034067$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $d5b33d7c30034067$export$d0f0355bb3d948e4:
        case $d5b33d7c30034067$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $d5b33d7c30034067$export$19ada9bbb1af3573:
        case $d5b33d7c30034067$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $d5b33d7c30034067$export$6ab91af2d757aee7:
        case $d5b33d7c30034067$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $d5b33d7c30034067$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $d5b33d7c30034067$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $d5b33d7c30034067$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $d5b33d7c30034067$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $d5b33d7c30034067$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $d5b33d7c30034067$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $d5b33d7c30034067$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $d5b33d7c30034067$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $d5b33d7c30034067$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $d5b33d7c30034067$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $d5b33d7c30034067$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $d5b33d7c30034067$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $d5b33d7c30034067$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $d5b33d7c30034067$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $d5b33d7c30034067$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $d5b33d7c30034067$export$ce40b115e188bc81:
        case $d5b33d7c30034067$export$d279c5c4bac5121e:
        case $d5b33d7c30034067$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $d5b33d7c30034067$export$b1688df4c4c21670:
        case $d5b33d7c30034067$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $d5b33d7c30034067$export$d220f6ade8463a0f:
        case $d5b33d7c30034067$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $d5b33d7c30034067$var$getTextureTypeByteLength(type) {
    switch(type){
        case $d5b33d7c30034067$export$2e8ce08d3f6f5e10:
        case $d5b33d7c30034067$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $d5b33d7c30034067$export$c63dc51868b06a9d:
        case $d5b33d7c30034067$export$88572337f312435f:
        case $d5b33d7c30034067$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $d5b33d7c30034067$export$b3969b01faf587f2:
        case $d5b33d7c30034067$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $d5b33d7c30034067$export$c3c7fc4518ebba96:
        case $d5b33d7c30034067$export$5c612977753abe2:
        case $d5b33d7c30034067$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $d5b33d7c30034067$export$5a4c329b7e2092d3:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
const $d5b33d7c30034067$export$ec276d39f33d4b7 = {
    contain: $d5b33d7c30034067$var$contain,
    cover: $d5b33d7c30034067$var$cover,
    fill: $d5b33d7c30034067$var$fill,
    getByteLength: $d5b33d7c30034067$var$getByteLength
};
function $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
    const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new $d5b33d7c30034067$export$c977b3e384af9ae1();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $d5b33d7c30034067$var$createElementNS("canvas");
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap || typeof VideoFrame !== "undefined" && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + dimensions.width + "x" + dimensions.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + dimensions.width + "x" + dimensions.height + ").");
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? $d5b33d7c30034067$export$f197347d588c1b4a : $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(colorSpace1);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === $d5b33d7c30034067$export$c3c7fc4518ebba96 || depthType === $d5b33d7c30034067$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === $d5b33d7c30034067$export$c63dc51868b06a9d) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.");
            }
        } else {
            if (depthType === null || depthType === $d5b33d7c30034067$export$c3c7fc4518ebba96 || depthType === $d5b33d7c30034067$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === $d5b33d7c30034067$export$c63dc51868b06a9d) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$d5b33d7c30034067$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$d5b33d7c30034067$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$d5b33d7c30034067$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$d5b33d7c30034067$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$d5b33d7c30034067$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$d5b33d7c30034067$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$d5b33d7c30034067$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$d5b33d7c30034067$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$d5b33d7c30034067$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$d5b33d7c30034067$export$d9e2d19a747baaab]: _gl.NEVER,
        [$d5b33d7c30034067$export$187b73a3e352c145]: _gl.ALWAYS,
        [$d5b33d7c30034067$export$36bcf49c713b3eb7]: _gl.LESS,
        [$d5b33d7c30034067$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$d5b33d7c30034067$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$d5b33d7c30034067$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$d5b33d7c30034067$export$155af022118f3a38]: _gl.GREATER,
        [$d5b33d7c30034067$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === $d5b33d7c30034067$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false && (texture.magFilter === $d5b33d7c30034067$export$8a72f490b25c56c8 || texture.magFilter === $d5b33d7c30034067$export$19a719f377145a13 || texture.magFilter === $d5b33d7c30034067$export$d2327c1afe5bfdf2 || texture.magFilter === $d5b33d7c30034067$export$5d8599b6a933fb1b || texture.minFilter === $d5b33d7c30034067$export$8a72f490b25c56c8 || texture.minFilter === $d5b33d7c30034067$export$19a719f377145a13 || texture.minFilter === $d5b33d7c30034067$export$d2327c1afe5bfdf2 || texture.minFilter === $d5b33d7c30034067$export$5d8599b6a933fb1b)) console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.");
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            if (texture.magFilter === $d5b33d7c30034067$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $d5b33d7c30034067$export$d2327c1afe5bfdf2 && texture.minFilter !== $d5b33d7c30034067$export$5d8599b6a933fb1b) return;
            if (texture.type === $d5b33d7c30034067$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get("EXT_texture_filter_anisotropic");
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries($d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 ? null : $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === $d5b33d7c30034067$export$1e113ac2d0905829, texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = $d5b33d7c30034067$var$getByteLength(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData, 0, 0);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = $d5b33d7c30034067$var$getByteLength(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries($d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 ? null : $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            const samples = getRenderTargetSamples(renderTarget);
            const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace1 !== $d5b33d7c30034067$export$42429b3acfb233a4 && colorSpace1 !== $d5b33d7c30034067$export$bfcb490c2dd3db51) {
            // sRGB
            if ($d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(colorSpace1) === $d5b33d7c30034067$export$8d0a61916cc26abb) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== $d5b33d7c30034067$export$3f8bb04b555a363c || type !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace1);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== "undefined" && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $d5b33d7c30034067$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace1 = $d5b33d7c30034067$export$bfcb490c2dd3db51) {
        let extension;
        const transfer = $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(colorSpace1);
        if (p === $d5b33d7c30034067$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $d5b33d7c30034067$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $d5b33d7c30034067$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $d5b33d7c30034067$export$5a4c329b7e2092d3) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === $d5b33d7c30034067$export$545fce0311a9796a) return gl.BYTE;
        if (p === $d5b33d7c30034067$export$88572337f312435f) return gl.SHORT;
        if (p === $d5b33d7c30034067$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $d5b33d7c30034067$export$5c612977753abe2) return gl.INT;
        if (p === $d5b33d7c30034067$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $d5b33d7c30034067$export$f6d331659b644596) return gl.FLOAT;
        if (p === $d5b33d7c30034067$export$2697304443f382bc) return gl.HALF_FLOAT;
        if (p === $d5b33d7c30034067$export$988473390501ed4b) return gl.ALPHA;
        if (p === $d5b33d7c30034067$export$7c67423a5ee6f5eb) return gl.RGB;
        if (p === $d5b33d7c30034067$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $d5b33d7c30034067$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $d5b33d7c30034067$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $d5b33d7c30034067$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $d5b33d7c30034067$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === $d5b33d7c30034067$export$4e041a7967d15c4b) return gl.RED;
        if (p === $d5b33d7c30034067$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $d5b33d7c30034067$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $d5b33d7c30034067$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $d5b33d7c30034067$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $d5b33d7c30034067$export$21d1799c6d552fc0 || p === $d5b33d7c30034067$export$afa304c3e981b668 || p === $d5b33d7c30034067$export$d2a1a68024a3e56c || p === $d5b33d7c30034067$export$9a79c424327dacf9) {
            if (transfer === $d5b33d7c30034067$export$8d0a61916cc26abb) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $d5b33d7c30034067$export$19ada9bbb1af3573 || p === $d5b33d7c30034067$export$d0f0355bb3d948e4 || p === $d5b33d7c30034067$export$b82296714358084c || p === $d5b33d7c30034067$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === $d5b33d7c30034067$export$6ab91af2d757aee7 || p === $d5b33d7c30034067$export$7800993ef8106a6a || p === $d5b33d7c30034067$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$6ab91af2d757aee7 || p === $d5b33d7c30034067$export$7800993ef8106a6a) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $d5b33d7c30034067$export$23ed8300a860e7d8) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48 || p === $d5b33d7c30034067$export$68880cd325f8b2fb || p === $d5b33d7c30034067$export$7d2c0be323373d95 || p === $d5b33d7c30034067$export$22b52da301fc3a3e || p === $d5b33d7c30034067$export$c009e2cb4a66485e || p === $d5b33d7c30034067$export$118fff5afa255b63 || p === $d5b33d7c30034067$export$120713c829ae0667 || p === $d5b33d7c30034067$export$c79eeabbf53313e9 || p === $d5b33d7c30034067$export$443cf6567cdd6424 || p === $d5b33d7c30034067$export$6573984fc9840780 || p === $d5b33d7c30034067$export$e7aee563f30091de || p === $d5b33d7c30034067$export$2eb8634622ddeab7 || p === $d5b33d7c30034067$export$202b1ce7b5d25742 || p === $d5b33d7c30034067$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $d5b33d7c30034067$export$68880cd325f8b2fb) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $d5b33d7c30034067$export$7d2c0be323373d95) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $d5b33d7c30034067$export$22b52da301fc3a3e) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $d5b33d7c30034067$export$c009e2cb4a66485e) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $d5b33d7c30034067$export$118fff5afa255b63) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $d5b33d7c30034067$export$120713c829ae0667) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $d5b33d7c30034067$export$c79eeabbf53313e9) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $d5b33d7c30034067$export$443cf6567cdd6424) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $d5b33d7c30034067$export$6573984fc9840780) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $d5b33d7c30034067$export$e7aee563f30091de) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $d5b33d7c30034067$export$2eb8634622ddeab7) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $d5b33d7c30034067$export$202b1ce7b5d25742) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $d5b33d7c30034067$export$18ab77abd087e467) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $d5b33d7c30034067$export$ce40b115e188bc81 || p === $d5b33d7c30034067$export$d279c5c4bac5121e || p === $d5b33d7c30034067$export$cde52d17225fdbd3) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === $d5b33d7c30034067$export$d279c5c4bac5121e) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === $d5b33d7c30034067$export$cde52d17225fdbd3) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === $d5b33d7c30034067$export$b1688df4c4c21670 || p === $d5b33d7c30034067$export$fc15e5d8261eed58 || p === $d5b33d7c30034067$export$d220f6ade8463a0f || p === $d5b33d7c30034067$export$768646d09dc1b6ef) {
            extension = extensions.get("EXT_texture_compression_rgtc");
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $d5b33d7c30034067$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $d5b33d7c30034067$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $d5b33d7c30034067$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $d5b33d7c30034067$export$6c8ea339bfab1301) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $d5b33d7c30034067$export$56b937d9e5581166 extends $d5b33d7c30034067$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $d5b33d7c30034067$export$eb2fcfdbd7ba97d4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = "Group";
    }
}
const $d5b33d7c30034067$var$_moveEvent = {
    type: "move"
};
class $d5b33d7c30034067$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: "connected",
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($d5b33d7c30034067$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
const $d5b33d7c30034067$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $d5b33d7c30034067$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class $d5b33d7c30034067$var$WebXRDepthSensing {
    constructor(){
        this.texture = null;
        this.mesh = null;
        this.depthNear = 0;
        this.depthFar = 0;
    }
    init(renderer, depthData, renderState) {
        if (this.texture === null) {
            const texture = new $d5b33d7c30034067$export$5431306cf43de24a();
            const texProps = renderer.properties.get(texture);
            texProps.__webglTexture = depthData.texture;
            if (depthData.depthNear != renderState.depthNear || depthData.depthFar != renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    vertexShader: $d5b33d7c30034067$var$_occlusion_vertex,
                    fragmentShader: $d5b33d7c30034067$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$967d831af31f69ce(20, 20), material);
            }
        }
        return this.mesh;
    }
    reset() {
        this.texture = null;
        this.mesh = null;
    }
    getDepthTexture() {
        return this.texture;
    }
}
class $d5b33d7c30034067$var$WebXRManager extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const depthSensing = new $d5b33d7c30034067$var$WebXRDepthSensing();
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        let currentPixelRatio = null;
        //
        const cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $d5b33d7c30034067$export$56b937d9e5581166();
        cameraXR.layers.enable(1);
        cameraXR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener("select", onSessionEvent);
            session.removeEventListener("selectstart", onSessionEvent);
            session.removeEventListener("selectend", onSessionEvent);
            session.removeEventListener("squeeze", onSessionEvent);
            session.removeEventListener("squeezestart", onSessionEvent);
            session.removeEventListener("squeezeend", onSessionEvent);
            session.removeEventListener("end", onSessionEnd);
            session.removeEventListener("inputsourceschange", onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                if (session.renderState.layers === undefined) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $d5b33d7c30034067$export$1e113ac2d0905829 : $d5b33d7c30034067$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $d5b33d7c30034067$export$6c8ea339bfab1301 : $d5b33d7c30034067$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        depthTexture: new $d5b33d7c30034067$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        const cameraRPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            if (depthSensing.texture !== null) {
                camera.near = depthSensing.depthNear;
                camera.far = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = camera.near;
            cameraXR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
                cameraL.near = _currentDepthNear;
                cameraL.far = _currentDepthFar;
                cameraR.near = _currentDepthNear;
                cameraR.far = _currentDepthFar;
                cameraL.updateProjectionMatrix();
                cameraR.updateProjectionMatrix();
                camera.updateProjectionMatrix();
            }
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $d5b33d7c30034067$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                if (enabledFeatures && enabledFeatures.includes("depth-sensing")) {
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(renderer, depthData, session.renderState);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: "planesdetected",
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $d5b33d7c30034067$var$_e1 = /*@__PURE__*/ new $d5b33d7c30034067$export$d93cc409a0768c5f();
const $d5b33d7c30034067$var$_m1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
function $d5b33d7c30034067$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $d5b33d7c30034067$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $d5b33d7c30034067$var$_e1.x *= -1;
            $d5b33d7c30034067$var$_e1.y *= -1;
            $d5b33d7c30034067$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $d5b33d7c30034067$var$_e1.y *= -1;
                $d5b33d7c30034067$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($d5b33d7c30034067$var$_m1.makeRotationFromEuler($d5b33d7c30034067$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $d5b33d7c30034067$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === "number" || typeof value === "boolean") {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + "_" + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === "number" || typeof value === "boolean") cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === "number" || typeof value === "boolean") {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === "number" || typeof value === "boolean") {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
        else console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $d5b33d7c30034067$export$1033a2df66368859(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = "default", failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== "undefined" && context instanceof WebGLRenderingContext) throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this._outputColorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
        // tone mapping
        this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const _currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _projScreenMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        const _vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const _vector4 = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${$d5b33d7c30034067$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener("webglcontextlost", onContextLost, false);
            canvas.addEventListener("webglcontextrestored", onContextRestore, false);
            canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
            if (_gl === null) {
                const contextName = "webgl2";
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error("Error creating WebGL context with your selected attributes.");
                    else throw new Error("Error creating WebGL context.");
                }
            }
        } catch (error) {
            console.error("THREE.WebGLRenderer: " + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $d5b33d7c30034067$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $d5b33d7c30034067$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $d5b33d7c30034067$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $d5b33d7c30034067$var$WebGLState(_gl);
            info = new $d5b33d7c30034067$var$WebGLInfo(_gl);
            properties = new $d5b33d7c30034067$var$WebGLProperties();
            textures = new $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $d5b33d7c30034067$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $d5b33d7c30034067$var$WebGLCubeUVMaps(_this);
            attributes = new $d5b33d7c30034067$var$WebGLAttributes(_gl);
            bindingStates = new $d5b33d7c30034067$var$WebGLBindingStates(_gl, attributes);
            geometries = new $d5b33d7c30034067$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $d5b33d7c30034067$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $d5b33d7c30034067$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $d5b33d7c30034067$var$WebGLClipping(properties);
            programCache = new $d5b33d7c30034067$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $d5b33d7c30034067$var$WebGLMaterials(_this, properties);
            renderLists = new $d5b33d7c30034067$var$WebGLRenderLists();
            renderStates = new $d5b33d7c30034067$var$WebGLRenderStates(extensions);
            background = new $d5b33d7c30034067$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $d5b33d7c30034067$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $d5b33d7c30034067$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $d5b33d7c30034067$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $d5b33d7c30034067$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + "px";
                canvas.style.height = height + "px";
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $d5b33d7c30034067$export$c200e7d26f592f21 || targetFormat === $d5b33d7c30034067$export$1ba1c45f9f77d4d7 || targetFormat === $d5b33d7c30034067$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $d5b33d7c30034067$export$2e8ce08d3f6f5e10 || targetType === $d5b33d7c30034067$export$c3c7fc4518ebba96 || targetType === $d5b33d7c30034067$export$c63dc51868b06a9d || targetType === $d5b33d7c30034067$export$6c8ea339bfab1301 || targetType === $d5b33d7c30034067$export$b3969b01faf587f2 || targetType === $d5b33d7c30034067$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener("webglcontextlost", onContextLost, false);
            canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
            canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener("sessionstart", onXRSessionStart);
            xr.removeEventListener("sessionend", onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log("THREE.WebGLRenderer: Context Lost.");
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log("THREE.WebGLRenderer: Context Restored.");
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener("dispose", onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                else if (!extensions.get("WEBGL_multi_draw")) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, "_gl_DrawID", i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $d5b33d7c30034067$export$2ede184fc2998901;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
            } else getProgram(material, scene, object);
        }
        this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
            return materials;
        };
        // compileAsync
        this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get("KHR_parallel_shader_compile") !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== "undefined") animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener("sessionstart", onXRSessionStart);
        xr.addEventListener("sessionend", onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new $d5b33d7c30034067$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has("EXT_color_buffer_half_float") || extensions.has("EXT_color_buffer_float") ? $d5b33d7c30034067$export$2697304443f382bc : $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                minFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b,
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace
            });
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z, activeViewport.w);
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has("WEBGL_multisampled_render_to_texture") === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const object = renderItem.object;
                    const geometry = renderItem.geometry;
                    const material = renderItem.material;
                    const group = renderItem.group;
                    if (material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $d5b33d7c30034067$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener("dispose", onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $d5b33d7c30034067$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $d5b33d7c30034067$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
                p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, "bindMatrix");
                p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, "batchingTexture");
                p_uniforms.setValue(_gl, "batchingTexture", object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, "batchingIdTexture");
                p_uniforms.setValue(_gl, "batchingIdTexture", object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, "batchingColorTexture");
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, "batchingColorTexture", object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
            // common matrices
            p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
            p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
            p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
                    console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
                    renderTargetProperties.__useRenderToTexture = false;
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
                    if (!capabilities.textureTypeReadable(textureType)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                        const glBuffer = _gl.createBuffer();
                        _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                        _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                        _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                        _gl.flush();
                        // check if the commands have finished every 8 ms
                        const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                        await $d5b33d7c30034067$var$probeAsync(_gl, sync, 4);
                        try {
                            _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                            _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                        } finally{
                            _gl.deleteBuffer(glBuffer);
                            _gl.deleteSync(sync);
                        }
                        return buffer;
                    }
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            // support previous signature with position first
            if (texture.isTexture !== true) {
                // @deprecated, r165
                $d5b33d7c30034067$var$warnOnce("WebGLRenderer: copyFramebufferToTexture function signature has changed.");
                position = arguments[0] || null;
                texture = arguments[1];
            }
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // support previous signature with dstPosition first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                $d5b33d7c30034067$var$warnOnce("WebGLRenderer: copyTextureToTexture function signature has changed.");
                dstPosition = arguments[0] || null;
                srcTexture = arguments[1];
                dstTexture = arguments[2];
                level = arguments[3] || 0;
                srcRegion = null;
            }
            let width, height, minX, minY;
            let dstX, dstY;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
            } else {
                width = srcTexture.image.width;
                height = srcTexture.image.height;
                minX = 0;
                minY = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
            } else {
                dstX = 0;
                dstY = 0;
            }
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[level] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, image.width, image.height, glFormat, image.data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // support previous signature with source box first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                $d5b33d7c30034067$var$warnOnce("WebGLRenderer: copyTextureToTexture3D function signature has changed.");
                srcRegion = arguments[0] || null;
                dstPosition = arguments[1] || null;
                srcTexture = arguments[2];
                dstTexture = arguments[3];
                level = arguments[4] || 0;
            }
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[level] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.max.z - srcRegion.min.z;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.min.z;
            } else {
                width = image.width;
                height = image.height;
                depth = image.depth;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
            else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
            else _gl.texSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $d5b33d7c30034067$export$5a0e9190d10875d3;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace1) {
        this._outputColorSpace = colorSpace1;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = colorSpace1 === $d5b33d7c30034067$export$626af19ae879bdf6 ? "display-p3" : "srgb";
        gl.unpackColorSpace = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace === $d5b33d7c30034067$export$c0dc1bc7e964761 ? "display-p3" : "srgb";
    }
}
class $d5b33d7c30034067$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = "";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $d5b33d7c30034067$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $d5b33d7c30034067$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = "";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $d5b33d7c30034067$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $d5b33d7c30034067$export$38af1803e3442a7f extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.backgroundRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.environmentIntensity = 1;
        this.environmentRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
class $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this._updateRange = {
            offset: 0,
            count: -1
        };
        this.updateRanges = [];
        this.version = 0;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    get updateRange() {
        $d5b33d7c30034067$var$warnOnce("THREE.InterleavedBuffer: updateRange() is deprecated and will be removed in r169. Use addUpdateRange() instead."); // @deprecated, r159
        return this._updateRange;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $d5b33d7c30034067$var$_vector$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$6.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$6.x, $d5b33d7c30034067$var$_vector$6.y, $d5b33d7c30034067$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$6.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$6.x, $d5b33d7c30034067$var$_vector$6.y, $d5b33d7c30034067$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$6.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$6.x, $d5b33d7c30034067$var$_vector$6.y, $d5b33d7c30034067$var$_vector$6.z);
        }
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $d5b33d7c30034067$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $d5b33d7c30034067$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $d5b33d7c30034067$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $d5b33d7c30034067$export$5ec7dd1c6994bf8e extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = "SpriteMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $d5b33d7c30034067$var$_geometry;
const $d5b33d7c30034067$var$_intersectPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_worldScale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_mvPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_alignedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_rotatedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_viewWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$3075603db8e6204c extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(material = new $d5b33d7c30034067$export$5ec7dd1c6994bf8e()){
        super();
        this.isSprite = true;
        this.type = "Sprite";
        if ($d5b33d7c30034067$var$_geometry === undefined) {
            $d5b33d7c30034067$var$_geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $d5b33d7c30034067$export$3d5cd879f108f53f(float32Array, 5);
            $d5b33d7c30034067$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $d5b33d7c30034067$var$_geometry.setAttribute("position", new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $d5b33d7c30034067$var$_geometry.setAttribute("uv", new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $d5b33d7c30034067$var$_geometry;
        this.material = material;
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $d5b33d7c30034067$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $d5b33d7c30034067$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $d5b33d7c30034067$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $d5b33d7c30034067$var$_worldScale.multiplyScalar(-$d5b33d7c30034067$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vA.set(-0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vC.set(0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$_uvA.set(0, 0);
        $d5b33d7c30034067$var$_uvB.set(1, 0);
        $d5b33d7c30034067$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, false, $d5b33d7c30034067$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(-0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
            $d5b33d7c30034067$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_vB, false, $d5b33d7c30034067$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $d5b33d7c30034067$var$_intersectPoint.clone(),
            uv: $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectPoint, $d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_uvA, $d5b33d7c30034067$var$_uvB, $d5b33d7c30034067$var$_uvC, new $d5b33d7c30034067$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $d5b33d7c30034067$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $d5b33d7c30034067$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $d5b33d7c30034067$var$_rotatedPosition.x = cos * $d5b33d7c30034067$var$_alignedPosition.x - sin * $d5b33d7c30034067$var$_alignedPosition.y;
        $d5b33d7c30034067$var$_rotatedPosition.y = sin * $d5b33d7c30034067$var$_alignedPosition.x + cos * $d5b33d7c30034067$var$_alignedPosition.y;
    } else $d5b33d7c30034067$var$_rotatedPosition.copy($d5b33d7c30034067$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $d5b33d7c30034067$var$_rotatedPosition.x;
    vertexPosition.y += $d5b33d7c30034067$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($d5b33d7c30034067$var$_viewWorldMatrix);
}
const $d5b33d7c30034067$var$_v1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$112e7237be0c5f30 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $d5b33d7c30034067$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $d5b33d7c30034067$var$_v1$2.distanceTo($d5b33d7c30034067$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $d5b33d7c30034067$var$_basePosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_skinIndex = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_skinWeight = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_vector3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix4 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vertex = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_sphere$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_inverseMatrix$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
class $d5b33d7c30034067$export$b303577035157ecf extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = "SkinnedMesh";
        this.bindMode = $d5b33d7c30034067$export$2595a3798997538;
        this.bindMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $d5b33d7c30034067$var$_vertex);
            this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $d5b33d7c30034067$var$_vertex);
            this.boundingSphere.expandByPoint($d5b33d7c30034067$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$4.copy(this.boundingSphere);
        $d5b33d7c30034067$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$4) === false) return;
        // convert ray to local space of skinned mesh
        $d5b33d7c30034067$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$2.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $d5b33d7c30034067$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $d5b33d7c30034067$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $d5b33d7c30034067$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $d5b33d7c30034067$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $d5b33d7c30034067$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $d5b33d7c30034067$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $d5b33d7c30034067$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $d5b33d7c30034067$var$_skinIndex.getComponent(i);
                $d5b33d7c30034067$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($d5b33d7c30034067$var$_vector3.copy($d5b33d7c30034067$var$_basePosition).applyMatrix4($d5b33d7c30034067$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
}
class $d5b33d7c30034067$export$b127726e56765aa4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = "Bone";
    }
}
class $d5b33d7c30034067$export$b691f601014eabe1 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $d5b33d7c30034067$var$_offsetMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_identityMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $d5b33d7c30034067$var$_identityMatrix$1;
            $d5b33d7c30034067$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $d5b33d7c30034067$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $d5b33d7c30034067$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $d5b33d7c30034067$export$b691f601014eabe1(boneMatrices, size, size, $d5b33d7c30034067$export$3f8bb04b555a363c, $d5b33d7c30034067$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $d5b33d7c30034067$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $d5b33d7c30034067$export$32ea87a8b54d744a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $d5b33d7c30034067$var$_instanceLocalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceIntersects = [];
const $d5b33d7c30034067$var$_box3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_identity = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_mesh$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$e176487c05830cc5();
const $d5b33d7c30034067$var$_sphere$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
class $d5b33d7c30034067$export$f3c979c331175ad7 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.morphTexture = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $d5b33d7c30034067$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_box3.copy(geometry.boundingBox).applyMatrix4($d5b33d7c30034067$var$_instanceLocalMatrix);
            this.boundingBox.union($d5b33d7c30034067$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4($d5b33d7c30034067$var$_instanceLocalMatrix);
            this.boundingSphere.union($d5b33d7c30034067$var$_sphere$3);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $d5b33d7c30034067$var$_mesh$1.geometry = this.geometry;
        $d5b33d7c30034067$var$_mesh$1.material = this.material;
        if ($d5b33d7c30034067$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$3.copy(this.boundingSphere);
        $d5b33d7c30034067$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$3) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $d5b33d7c30034067$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $d5b33d7c30034067$var$_mesh$1.matrixWorld = $d5b33d7c30034067$var$_instanceWorldMatrix;
            $d5b33d7c30034067$var$_mesh$1.raycast(raycaster, $d5b33d7c30034067$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $d5b33d7c30034067$var$_instanceIntersects.length; i < l; i++){
                const intersect = $d5b33d7c30034067$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $d5b33d7c30034067$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $d5b33d7c30034067$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $d5b33d7c30034067$export$4e041a7967d15c4b, $d5b33d7c30034067$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
        return this;
    }
}
function $d5b33d7c30034067$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $d5b33d7c30034067$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $d5b33d7c30034067$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(drawRange, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = drawRange.start;
        item.count = drawRange.count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $d5b33d7c30034067$var$_matrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_invMatrixWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_identityMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_whiteColor = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
const $d5b33d7c30034067$var$_projScreenMatrix$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_frustum = /*@__PURE__*/ new $d5b33d7c30034067$export$35efe6f4c85463d2();
const $d5b33d7c30034067$var$_box$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_sphere$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_vector$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_forward = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_temp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_renderList = /*@__PURE__*/ new $d5b33d7c30034067$var$MultiDrawRenderList();
const $d5b33d7c30034067$var$_mesh = /*@__PURE__*/ new $d5b33d7c30034067$export$e176487c05830cc5();
const $d5b33d7c30034067$var$_batchIntersects = [];
// @TODO: SkinnedMesh support?
// @TODO: geometry.groups support?
// @TODO: geometry.drawRange support?
// @TODO: geometry.morphAttributes support?
// @TODO: Support uniform parameter per geometry
// @TODO: Add an "optimize" function to pack geometry and remove data gaps
// copies data from attribute "src" into "target" starting at "targetOffset"
function $d5b33d7c30034067$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
class $d5b33d7c30034067$export$6e01c5ee52ed8f7b extends $d5b33d7c30034067$export$e176487c05830cc5 {
    get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $d5b33d7c30034067$export$b7be63a67df8959(), material);
        this.isBatchedMesh = true;
        this.perObjectFrustumCulled = true;
        this.sortObjects = true;
        this.boundingBox = null;
        this.boundingSphere = null;
        this.customSort = null;
        // stores visible, active, and geometry id per object
        this._drawInfo = [];
        // geometry information
        this._drawRanges = [];
        this._reservedRanges = [];
        this._bounds = [];
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        this._geometryInitialized = false;
        this._geometryCount = 0;
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        this._visibilityChanged = true;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $d5b33d7c30034067$export$b691f601014eabe1(matricesArray, size, size, $d5b33d7c30034067$export$3f8bb04b555a363c, $d5b33d7c30034067$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $d5b33d7c30034067$export$b691f601014eabe1(indirectArray, size, size, $d5b33d7c30034067$export$aa92e870a709d190, $d5b33d7c30034067$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxIndexCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $d5b33d7c30034067$export$b691f601014eabe1(colorsArray, size, size, $d5b33d7c30034067$export$3f8bb04b555a363c, $d5b33d7c30034067$export$f6d331659b644596);
        colorsTexture.colorSpace = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error("BatchedMesh: All attributes must have a consistent itemSize and normalized value.");
        }
    }
    setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        const geometryCount = this._geometryCount;
        const boundingBox = this.boundingBox;
        const drawInfo = this._drawInfo;
        boundingBox.makeEmpty();
        for(let i = 0; i < geometryCount; i++){
            if (drawInfo[i].active === false) continue;
            const geometryId = drawInfo[i].geometryIndex;
            this.getMatrixAt(i, $d5b33d7c30034067$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $d5b33d7c30034067$var$_box$1).applyMatrix4($d5b33d7c30034067$var$_matrix$1);
            boundingBox.union($d5b33d7c30034067$var$_box$1);
        }
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const drawInfo = this._drawInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = drawInfo.length; i < l; i++){
            if (drawInfo[i].active === false) continue;
            const geometryId = drawInfo[i].geometryIndex;
            this.getMatrixAt(i, $d5b33d7c30034067$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $d5b33d7c30034067$var$_sphere$2).applyMatrix4($d5b33d7c30034067$var$_matrix$1);
            boundingSphere.union($d5b33d7c30034067$var$_sphere$2);
        }
    }
    addInstance(geometryId) {
        // ensure we're not over geometry
        if (this._drawInfo.length >= this._maxInstanceCount) throw new Error("BatchedMesh: Maximum item count reached.");
        this._drawInfo.push({
            visible: true,
            active: true,
            geometryIndex: geometryId
        });
        // initialize the matrix
        const drawId = this._drawInfo.length - 1;
        const matricesTexture = this._matricesTexture;
        const matricesArray = matricesTexture.image.data;
        $d5b33d7c30034067$var$_identityMatrix.toArray(matricesArray, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $d5b33d7c30034067$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        return drawId;
    }
    addGeometry(geometry, vertexCount = -1, indexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        // ensure we're not over geometry
        if (this._drawInfo.length >= this._maxInstanceCount) throw new Error("BatchedMesh: Maximum item count reached.");
        // get the necessary range fo the geometry
        const reservedRange = {
            vertexStart: -1,
            vertexCount: -1,
            indexStart: -1,
            indexCount: -1
        };
        let lastRange = null;
        const reservedRanges = this._reservedRanges;
        const drawRanges = this._drawRanges;
        const bounds = this._bounds;
        if (this._geometryCount !== 0) lastRange = reservedRanges[reservedRanges.length - 1];
        if (vertexCount === -1) reservedRange.vertexCount = geometry.getAttribute("position").count;
        else reservedRange.vertexCount = vertexCount;
        if (lastRange === null) reservedRange.vertexStart = 0;
        else reservedRange.vertexStart = lastRange.vertexStart + lastRange.vertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            if (indexCount === -1) reservedRange.indexCount = index.count;
            else reservedRange.indexCount = indexCount;
            if (lastRange === null) reservedRange.indexStart = 0;
            else reservedRange.indexStart = lastRange.indexStart + lastRange.indexCount;
        }
        if (reservedRange.indexStart !== -1 && reservedRange.indexStart + reservedRange.indexCount > this._maxIndexCount || reservedRange.vertexStart + reservedRange.vertexCount > this._maxVertexCount) throw new Error("BatchedMesh: Reserved space request exceeds the maximum buffer size.");
        // update id
        const geometryId = this._geometryCount;
        this._geometryCount++;
        // add the reserved range and draw range objects
        reservedRanges.push(reservedRange);
        drawRanges.push({
            start: hasIndex ? reservedRange.indexStart : reservedRange.vertexStart,
            count: -1
        });
        bounds.push({
            boxInitialized: false,
            box: new $d5b33d7c30034067$export$6f7d5a9418ab2aa3(),
            sphereInitialized: false,
            sphere: new $d5b33d7c30034067$export$805e8b72413ccaba()
        });
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        return geometryId;
    }
    setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error("BatchedMesh: Maximum geometry count reached.");
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const reservedRange = this._reservedRanges[geometryId];
        if (hasIndex && srcIndex.count > reservedRange.indexCount || geometry.attributes.position.count > reservedRange.vertexCount) throw new Error("BatchedMesh: Reserved space not large enough for provided geometry.");
        // copy geometry over
        const vertexStart = reservedRange.vertexStart;
        const vertexCount = reservedRange.vertexCount;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $d5b33d7c30034067$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = vertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, vertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = reservedRange.indexStart;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedRange.indexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, reservedRange.indexCount);
        }
        // store the bounding boxes
        const bound = this._bounds[geometryId];
        if (geometry.boundingBox !== null) {
            bound.box.copy(geometry.boundingBox);
            bound.boxInitialized = true;
        } else bound.boxInitialized = false;
        if (geometry.boundingSphere !== null) {
            bound.sphere.copy(geometry.boundingSphere);
            bound.sphereInitialized = true;
        } else bound.sphereInitialized = false;
        // set drawRange count
        const drawRange = this._drawRanges[geometryId];
        const posAttr = geometry.getAttribute("position");
        drawRange.count = hasIndex ? srcIndex.count : posAttr.count;
        this._visibilityChanged = true;
        return geometryId;
    }
    /*
	deleteGeometry( geometryId ) {

		// TODO: delete geometry and associated instances

	}
	*/ /*
	deleteInstance( instanceId ) {

		// Note: User needs to call optimize() afterward to pack the data.

		const drawInfo = this._drawInfo;
		if ( instanceId >= drawInfo.length || drawInfo[ instanceId ].active === false ) {

			return this;

		}

		drawInfo[ instanceId ].active = false;
		this._visibilityChanged = true;

		return this;

	}
	*/ // get bounding box and compute it if it doesn't exist
    getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const bound = this._bounds[geometryId];
        const box = bound.box;
        const geometry = this.geometry;
        if (bound.boxInitialized === false) {
            box.makeEmpty();
            const index = geometry.index;
            const position = geometry.attributes.position;
            const drawRange = this._drawRanges[geometryId];
            for(let i = drawRange.start, l = drawRange.start + drawRange.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($d5b33d7c30034067$var$_vector$5.fromBufferAttribute(position, iv));
            }
            bound.boxInitialized = true;
        }
        target.copy(box);
        return target;
    }
    // get bounding sphere and compute it if it doesn't exist
    getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const bound = this._bounds[geometryId];
        const sphere = bound.sphere;
        const geometry = this.geometry;
        if (bound.sphereInitialized === false) {
            sphere.makeEmpty();
            this.getBoundingBoxAt(geometryId, $d5b33d7c30034067$var$_box$1);
            $d5b33d7c30034067$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            const drawRange = this._drawRanges[geometryId];
            let maxRadiusSq = 0;
            for(let i = drawRange.start, l = drawRange.start + drawRange.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($d5b33d7c30034067$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            bound.sphereInitialized = true;
        }
        target.copy(sphere);
        return target;
    }
    setMatrixAt(instanceId, matrix) {
        // @TODO: Map geometryId to index of the arrays because
        //        optimize() can make geometryId mismatch the index
        const drawInfo = this._drawInfo;
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return this;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    getMatrixAt(instanceId, matrix) {
        const drawInfo = this._drawInfo;
        const matricesArray = this._matricesTexture.image.data;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return null;
        return matrix.fromArray(matricesArray, instanceId * 16);
    }
    setColorAt(instanceId, color) {
        if (this._colorsTexture === null) this._initColorsTexture();
        // @TODO: Map id to index of the arrays because
        //        optimize() can make id mismatch the index
        const colorsTexture = this._colorsTexture;
        const colorsArray = this._colorsTexture.image.data;
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return this;
        color.toArray(colorsArray, instanceId * 4);
        colorsTexture.needsUpdate = true;
        return this;
    }
    getColorAt(instanceId, color) {
        const colorsArray = this._colorsTexture.image.data;
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return null;
        return color.fromArray(colorsArray, instanceId * 4);
    }
    setVisibleAt(instanceId, value) {
        // if the geometry is out of range, not active, or visibility state
        // does not change then return early
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false || drawInfo[instanceId].visible === value) return this;
        drawInfo[instanceId].visible = value;
        this._visibilityChanged = true;
        return this;
    }
    getVisibleAt(instanceId) {
        // return early if the geometry is out of range or not active
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return false;
        return drawInfo[instanceId].visible;
    }
    raycast(raycaster, intersects) {
        const drawInfo = this._drawInfo;
        const drawRanges = this._drawRanges;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $d5b33d7c30034067$var$_mesh.material = this.material;
        $d5b33d7c30034067$var$_mesh.geometry.index = batchGeometry.index;
        $d5b33d7c30034067$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($d5b33d7c30034067$var$_mesh.geometry.boundingBox === null) $d5b33d7c30034067$var$_mesh.geometry.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        if ($d5b33d7c30034067$var$_mesh.geometry.boundingSphere === null) $d5b33d7c30034067$var$_mesh.geometry.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        for(let i = 0, l = drawInfo.length; i < l; i++){
            if (!drawInfo[i].visible || !drawInfo[i].active) continue;
            const geometryId = drawInfo[i].geometryIndex;
            const drawRange = drawRanges[geometryId];
            $d5b33d7c30034067$var$_mesh.geometry.setDrawRange(drawRange.start, drawRange.count);
            // ge the intersects
            this.getMatrixAt(i, $d5b33d7c30034067$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $d5b33d7c30034067$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $d5b33d7c30034067$var$_mesh.geometry.boundingSphere);
            $d5b33d7c30034067$var$_mesh.raycast(raycaster, $d5b33d7c30034067$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $d5b33d7c30034067$var$_batchIntersects.length; j < l; j++){
                const intersect = $d5b33d7c30034067$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $d5b33d7c30034067$var$_batchIntersects.length = 0;
        }
        $d5b33d7c30034067$var$_mesh.material = null;
        $d5b33d7c30034067$var$_mesh.geometry.index = null;
        $d5b33d7c30034067$var$_mesh.geometry.attributes = {};
        $d5b33d7c30034067$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._drawRanges = source._drawRanges.map((range)=>({
                ...range
            }));
        this._reservedRanges = source._reservedRanges.map((range)=>({
                ...range
            }));
        this._drawInfo = source._drawInfo.map((inf)=>({
                ...inf
            }));
        this._bounds = source._bounds.map((bound)=>({
                boxInitialized: bound.boxInitialized,
                box: bound.box.clone(),
                sphereInitialized: bound.sphereInitialized,
                sphere: bound.sphere.clone()
            }));
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._geometryCount = source._geometryCount;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
        return this;
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const drawInfo = this._drawInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const drawRanges = this._drawRanges;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled) {
            $d5b33d7c30034067$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $d5b33d7c30034067$var$_frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix$2, renderer.coordinateSystem);
        }
        let count = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $d5b33d7c30034067$var$_invMatrixWorld.copy(this.matrixWorld).invert();
            $d5b33d7c30034067$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($d5b33d7c30034067$var$_invMatrixWorld);
            $d5b33d7c30034067$var$_forward.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($d5b33d7c30034067$var$_invMatrixWorld);
            for(let i = 0, l = drawInfo.length; i < l; i++)if (drawInfo[i].visible && drawInfo[i].active) {
                const geometryId = drawInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $d5b33d7c30034067$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $d5b33d7c30034067$var$_sphere$2).applyMatrix4($d5b33d7c30034067$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !$d5b33d7c30034067$var$_frustum.intersectsSphere($d5b33d7c30034067$var$_sphere$2);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const z = $d5b33d7c30034067$var$_temp.subVectors($d5b33d7c30034067$var$_sphere$2.center, $d5b33d7c30034067$var$_vector$5).dot($d5b33d7c30034067$var$_forward);
                    $d5b33d7c30034067$var$_renderList.push(drawRanges[geometryId], z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $d5b33d7c30034067$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $d5b33d7c30034067$var$sortTransparent : $d5b33d7c30034067$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[count] = item.start * bytesPerElement;
                multiDrawCounts[count] = item.count;
                indirectArray[count] = item.index;
                count++;
            }
            $d5b33d7c30034067$var$_renderList.reset();
        } else {
            for(let i = 0, l = drawInfo.length; i < l; i++)if (drawInfo[i].visible && drawInfo[i].active) {
                const geometryId = drawInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $d5b33d7c30034067$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $d5b33d7c30034067$var$_sphere$2).applyMatrix4($d5b33d7c30034067$var$_matrix$1);
                    culled = !$d5b33d7c30034067$var$_frustum.intersectsSphere($d5b33d7c30034067$var$_sphere$2);
                }
                if (!culled) {
                    const range = drawRanges[geometryId];
                    multiDrawStarts[count] = range.start * bytesPerElement;
                    multiDrawCounts[count] = range.count;
                    indirectArray[count] = i;
                    count++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = count;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
class $d5b33d7c30034067$export$fbaaa33907730a0c extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = "LineBasicMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_vStart = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vEnd = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_inverseMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_intersectPointOnRay = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectPointOnSegment = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$17d680238e50603e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $d5b33d7c30034067$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $d5b33d7c30034067$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $d5b33d7c30034067$var$_vStart.distanceTo($d5b33d7c30034067$var$_vEnd);
            }
            geometry.setAttribute("lineDistance", new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$1.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$1.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$1) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$1.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $d5b33d7c30034067$var$checkIntersection(this, raycaster, $d5b33d7c30034067$var$_ray$1, localThresholdSq, a, b);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $d5b33d7c30034067$var$checkIntersection(this, raycaster, $d5b33d7c30034067$var$_ray$1, localThresholdSq, a, b);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $d5b33d7c30034067$var$checkIntersection(this, raycaster, $d5b33d7c30034067$var$_ray$1, localThresholdSq, i, i + 1);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $d5b33d7c30034067$var$checkIntersection(this, raycaster, $d5b33d7c30034067$var$_ray$1, localThresholdSq, end - 1, start);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b) {
    const positionAttribute = object.geometry.attributes.position;
    $d5b33d7c30034067$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $d5b33d7c30034067$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($d5b33d7c30034067$var$_vStart, $d5b33d7c30034067$var$_vEnd, $d5b33d7c30034067$var$_intersectPointOnRay, $d5b33d7c30034067$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $d5b33d7c30034067$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $d5b33d7c30034067$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: a,
        face: null,
        faceIndex: null,
        object: object
    };
}
const $d5b33d7c30034067$var$_start = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_end = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$ff1ed10fedfdd604 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $d5b33d7c30034067$var$_start.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $d5b33d7c30034067$var$_start.distanceTo($d5b33d7c30034067$var$_end);
            }
            geometry.setAttribute("lineDistance", new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $d5b33d7c30034067$export$f85a24d745e4f17d extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = "LineLoop";
    }
}
class $d5b33d7c30034067$export$a178c45366ce5d6b extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = "PointsMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_inverseMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_position$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$1c787534cb11aa3e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $d5b33d7c30034067$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $d5b33d7c30034067$export$64b5c384219d3699();
        $d5b33d7c30034067$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $d5b33d7c30034067$export$6e09d1edf8d5a25c extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$9270d786f73ce6fe extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$3466bac9141a5cc4 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $d5b33d7c30034067$export$5fe6b8e34b274fcb extends $d5b33d7c30034067$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $d5b33d7c30034067$export$d80173634de65bff extends $d5b33d7c30034067$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $d5b33d7c30034067$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $d5b33d7c30034067$export$f7189e49152d1c13 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $d5b33d7c30034067$export$c977b3e384af9ae1() : new $d5b33d7c30034067$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $d5b33d7c30034067$export$64b5c384219d3699();
        const mat = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $d5b33d7c30034067$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        binormals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($d5b33d7c30034067$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($d5b33d7c30034067$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $d5b33d7c30034067$export$3f87a931616cde04 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $d5b33d7c30034067$export$b1eedc9aab6300e8 extends $d5b33d7c30034067$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = "ArcCurve";
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $d5b33d7c30034067$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $d5b33d7c30034067$var$tmp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$px = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$py = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$pz = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
class $d5b33d7c30034067$export$b9146b27c24b744c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $d5b33d7c30034067$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $d5b33d7c30034067$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $d5b33d7c30034067$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $d5b33d7c30034067$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $d5b33d7c30034067$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $d5b33d7c30034067$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $d5b33d7c30034067$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $d5b33d7c30034067$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $d5b33d7c30034067$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $d5b33d7c30034067$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($d5b33d7c30034067$var$px.calc(weight), $d5b33d7c30034067$var$py.calc(weight), $d5b33d7c30034067$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $d5b33d7c30034067$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $d5b33d7c30034067$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezier(t, p0, p1, p2) {
    return $d5b33d7c30034067$var$QuadraticBezierP0(t, p0) + $d5b33d7c30034067$var$QuadraticBezierP1(t, p1) + $d5b33d7c30034067$var$QuadraticBezierP2(t, p2);
}
//
function $d5b33d7c30034067$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $d5b33d7c30034067$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezier(t, p0, p1, p2, p3) {
    return $d5b33d7c30034067$var$CubicBezierP0(t, p0) + $d5b33d7c30034067$var$CubicBezierP1(t, p1) + $d5b33d7c30034067$var$CubicBezierP2(t, p2) + $d5b33d7c30034067$var$CubicBezierP3(t, p3);
}
class $d5b33d7c30034067$export$e36650d36468bb39 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v3 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$13d5f1c9525f246c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699(), v3 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $d5b33d7c30034067$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$ab2e07e76531a47e extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$1fdfd9d9cf487600 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = "LineCurve3";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$5938c4ee491a43ad extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$bf3f4c7e459f90fc extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $d5b33d7c30034067$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$d3bdd77da77afc1b extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($d5b33d7c30034067$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $d5b33d7c30034067$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $d5b33d7c30034067$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $d5b33d7c30034067$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $d5b33d7c30034067$export$b9146b27c24b744c,
    CubicBezierCurve: $d5b33d7c30034067$export$e36650d36468bb39,
    CubicBezierCurve3: $d5b33d7c30034067$export$13d5f1c9525f246c,
    EllipseCurve: $d5b33d7c30034067$export$3f87a931616cde04,
    LineCurve: $d5b33d7c30034067$export$ab2e07e76531a47e,
    LineCurve3: $d5b33d7c30034067$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $d5b33d7c30034067$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $d5b33d7c30034067$export$bf3f4c7e459f90fc,
    SplineCurve: $d5b33d7c30034067$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $d5b33d7c30034067$export$4aaf9b66af1bbf2c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? "LineCurve" : "LineCurve3";
            this.curves.push(new $d5b33d7c30034067$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $d5b33d7c30034067$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $d5b33d7c30034067$export$4b2950bdac9b6ee9 extends $d5b33d7c30034067$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $d5b33d7c30034067$export$ab2e07e76531a47e(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $d5b33d7c30034067$export$5938c4ee491a43ad(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCPx, aCPy), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $d5b33d7c30034067$export$e36650d36468bb39(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP1x, aCP1y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP2x, aCP2y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $d5b33d7c30034067$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $d5b33d7c30034067$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $d5b33d7c30034067$export$6d839803fcd1882c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(points = [
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $d5b33d7c30034067$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const curNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const prevNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $d5b33d7c30034067$export$41680e8551036033 extends $d5b33d7c30034067$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = "CapsuleGeometry";
        this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $d5b33d7c30034067$export$d5c0e8d607467193 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$68f745719dbe5198 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$a7a48974f285c9b3 extends $d5b33d7c30034067$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$60e57a7d3f20ff65 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            const centroid = new $d5b33d7c30034067$export$64b5c384219d3699();
            const uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $d5b33d7c30034067$export$c0babfeb8708fc9c extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $d5b33d7c30034067$var$_v0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangle = /*@__PURE__*/ new $d5b33d7c30034067$export$5a465592bfe74b48();
class $d5b33d7c30034067$export$4730b1542707547f extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($d5b33d7c30034067$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $d5b33d7c30034067$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $d5b33d7c30034067$var$_triangle.getNormal($d5b33d7c30034067$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $d5b33d7c30034067$var$_triangle[vertKeys[j]];
                    const v1 = $d5b33d7c30034067$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($d5b33d7c30034067$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $d5b33d7c30034067$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $d5b33d7c30034067$var$_v0.fromBufferAttribute(positionAttr, index0);
                $d5b33d7c30034067$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($d5b33d7c30034067$var$_v0.x, $d5b33d7c30034067$var$_v0.y, $d5b33d7c30034067$var$_v0.z);
                vertices.push($d5b33d7c30034067$var$_v1$1.x, $d5b33d7c30034067$var$_v1$1.y, $d5b33d7c30034067$var$_v1$1.z);
            }
            this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $d5b33d7c30034067$export$6428a7f2611ef1fa extends $d5b33d7c30034067$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $d5b33d7c30034067$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $d5b33d7c30034067$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $d5b33d7c30034067$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $d5b33d7c30034067$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $d5b33d7c30034067$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $d5b33d7c30034067$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $d5b33d7c30034067$var$equals(last, last.next)) {
        $d5b33d7c30034067$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $d5b33d7c30034067$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($d5b33d7c30034067$var$equals(p, p.next) || $d5b33d7c30034067$var$area(p.prev, p, p.next) === 0)) {
            $d5b33d7c30034067$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $d5b33d7c30034067$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) : $d5b33d7c30034067$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $d5b33d7c30034067$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $d5b33d7c30034067$var$earcutLinked($d5b33d7c30034067$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $d5b33d7c30034067$var$cureLocalIntersections($d5b33d7c30034067$var$filterPoints(ear), triangles, dim);
                $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $d5b33d7c30034067$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $d5b33d7c30034067$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $d5b33d7c30034067$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $d5b33d7c30034067$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $d5b33d7c30034067$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$intersects(a, p, p.next, b) && $d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $d5b33d7c30034067$var$removeNode(p);
            $d5b33d7c30034067$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $d5b33d7c30034067$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $d5b33d7c30034067$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $d5b33d7c30034067$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $d5b33d7c30034067$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $d5b33d7c30034067$var$filterPoints(a, a.next);
                c = $d5b33d7c30034067$var$filterPoints(c, c.next);
                // run earcut on each half
                $d5b33d7c30034067$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $d5b33d7c30034067$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $d5b33d7c30034067$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($d5b33d7c30034067$var$getLeftmost(list));
    }
    queue.sort($d5b33d7c30034067$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $d5b33d7c30034067$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $d5b33d7c30034067$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $d5b33d7c30034067$var$eliminateHole(hole, outerNode) {
    const bridge = $d5b33d7c30034067$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $d5b33d7c30034067$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $d5b33d7c30034067$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $d5b33d7c30034067$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $d5b33d7c30034067$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $d5b33d7c30034067$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($d5b33d7c30034067$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $d5b33d7c30034067$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $d5b33d7c30034067$var$sectorContainsSector(m, p) {
    return $d5b33d7c30034067$var$area(m.prev, m, p.prev) < 0 && $d5b33d7c30034067$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $d5b33d7c30034067$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $d5b33d7c30034067$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $d5b33d7c30034067$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $d5b33d7c30034067$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $d5b33d7c30034067$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $d5b33d7c30034067$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $d5b33d7c30034067$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$d5b33d7c30034067$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a) && $d5b33d7c30034067$var$middleInside(a, b) && // locally visible
    ($d5b33d7c30034067$var$area(a.prev, a, b.prev) || $d5b33d7c30034067$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$area(a.prev, a, a.next) > 0 && $d5b33d7c30034067$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $d5b33d7c30034067$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $d5b33d7c30034067$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $d5b33d7c30034067$var$intersects(p1, q1, p2, q2) {
    const o1 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, p2));
    const o2 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, q2));
    const o3 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, p1));
    const o4 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $d5b33d7c30034067$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $d5b33d7c30034067$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $d5b33d7c30034067$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $d5b33d7c30034067$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $d5b33d7c30034067$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $d5b33d7c30034067$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $d5b33d7c30034067$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $d5b33d7c30034067$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $d5b33d7c30034067$var$locallyInside(a, b) {
    return $d5b33d7c30034067$var$area(a.prev, a, a.next) < 0 ? $d5b33d7c30034067$var$area(a, b, a.next) >= 0 && $d5b33d7c30034067$var$area(a, a.prev, b) >= 0 : $d5b33d7c30034067$var$area(a, b, a.prev) < 0 || $d5b33d7c30034067$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $d5b33d7c30034067$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $d5b33d7c30034067$var$splitPolygon(a, b) {
    const a2 = new $d5b33d7c30034067$var$Node(a.i, a.x, a.y), b2 = new $d5b33d7c30034067$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $d5b33d7c30034067$var$insertNode(i, x, y, last) {
    const p = new $d5b33d7c30034067$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $d5b33d7c30034067$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $d5b33d7c30034067$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $d5b33d7c30034067$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $d5b33d7c30034067$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $d5b33d7c30034067$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $d5b33d7c30034067$var$removeDupEndPts(contour);
        $d5b33d7c30034067$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($d5b33d7c30034067$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $d5b33d7c30034067$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $d5b33d7c30034067$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $d5b33d7c30034067$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $d5b33d7c30034067$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $d5b33d7c30034067$export$598697a1efa63ca7 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $d5b33d7c30034067$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $d5b33d7c30034067$export$64b5c384219d3699();
                normal = new $d5b33d7c30034067$export$64b5c384219d3699();
                position2 = new $d5b33d7c30034067$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $d5b33d7c30034067$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $d5b33d7c30034067$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $d5b33d7c30034067$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $d5b33d7c30034067$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, a_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, b_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $d5b33d7c30034067$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $d5b33d7c30034067$export$9567cc828c9535da extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$1954e2b809fe361e extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$68cb731f50f614af extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$57a29a1c803e9065 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $d5b33d7c30034067$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $d5b33d7c30034067$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $d5b33d7c30034067$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $d5b33d7c30034067$export$1b417fc3b307a251 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$fb3f7adc68bd6e02 extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$a2312a2a1fa56495 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $d5b33d7c30034067$export$64b5c384219d3699();
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $d5b33d7c30034067$export$77e9bfadfb9ab8c8 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P1 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const B = new $d5b33d7c30034067$export$64b5c384219d3699();
        const T = new $d5b33d7c30034067$export$64b5c384219d3699();
        const N = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $d5b33d7c30034067$export$7897d9d48904490c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(path = new $d5b33d7c30034067$export$bf3f4c7e459f90fc(new $d5b33d7c30034067$export$64b5c384219d3699(-1, -1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        let P = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $d5b33d7c30034067$export$7897d9d48904490c(new $d5b33d7c30034067$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $d5b33d7c30034067$export$4b739da06d24892b extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $d5b33d7c30034067$export$64b5c384219d3699();
            const end = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $d5b33d7c30034067$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $d5b33d7c30034067$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $d5b33d7c30034067$export$33e43285f7406bd5,
    CapsuleGeometry: $d5b33d7c30034067$export$41680e8551036033,
    CircleGeometry: $d5b33d7c30034067$export$d5c0e8d607467193,
    ConeGeometry: $d5b33d7c30034067$export$a7a48974f285c9b3,
    CylinderGeometry: $d5b33d7c30034067$export$68f745719dbe5198,
    DodecahedronGeometry: $d5b33d7c30034067$export$c0babfeb8708fc9c,
    EdgesGeometry: $d5b33d7c30034067$export$4730b1542707547f,
    ExtrudeGeometry: $d5b33d7c30034067$export$598697a1efa63ca7,
    IcosahedronGeometry: $d5b33d7c30034067$export$9567cc828c9535da,
    LatheGeometry: $d5b33d7c30034067$export$6d839803fcd1882c,
    OctahedronGeometry: $d5b33d7c30034067$export$1954e2b809fe361e,
    PlaneGeometry: $d5b33d7c30034067$export$967d831af31f69ce,
    PolyhedronGeometry: $d5b33d7c30034067$export$60e57a7d3f20ff65,
    RingGeometry: $d5b33d7c30034067$export$68cb731f50f614af,
    ShapeGeometry: $d5b33d7c30034067$export$57a29a1c803e9065,
    SphereGeometry: $d5b33d7c30034067$export$1b417fc3b307a251,
    TetrahedronGeometry: $d5b33d7c30034067$export$fb3f7adc68bd6e02,
    TorusGeometry: $d5b33d7c30034067$export$a2312a2a1fa56495,
    TorusKnotGeometry: $d5b33d7c30034067$export$77e9bfadfb9ab8c8,
    TubeGeometry: $d5b33d7c30034067$export$7897d9d48904490c,
    WireframeGeometry: $d5b33d7c30034067$export$4b739da06d24892b
});
class $d5b33d7c30034067$export$e8564da406055a3 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = "ShadowMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$21c421a2e1df9d22 extends $d5b33d7c30034067$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = "RawShaderMaterial";
    }
}
class $d5b33d7c30034067$export$f2980790215acccd extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$28d04986c4269c9f extends $d5b33d7c30034067$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $d5b33d7c30034067$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $d5b33d7c30034067$export$24c72f71cbaf0678 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = "MeshPhongMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $d5b33d7c30034067$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$df893cf97e765622 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$bfe8c0a091f41ae7 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $d5b33d7c30034067$export$5023a9a8114806b8 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = "MeshLambertMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$6f5fef6235ec12ee extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$327886a3efaeaebe extends $d5b33d7c30034067$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// converts an array to a specific type
function $d5b33d7c30034067$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $d5b33d7c30034067$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $d5b33d7c30034067$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $d5b33d7c30034067$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $d5b33d7c30034067$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $d5b33d7c30034067$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $d5b33d7c30034067$var$convertArray(times, track.times.constructor);
        track.values = $d5b33d7c30034067$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $d5b33d7c30034067$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === "quaternion") {
            const referenceQuat = new $d5b33d7c30034067$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
            $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $d5b33d7c30034067$export$d875e029ef558d3;
    return targetClip;
}
const $d5b33d7c30034067$export$7ee8caa573e71ad1 = {
    convertArray: $d5b33d7c30034067$var$convertArray,
    isTypedArray: $d5b33d7c30034067$var$isTypedArray,
    getKeyframeOrder: $d5b33d7c30034067$var$getKeyframeOrder,
    sortedArray: $d5b33d7c30034067$var$sortedArray,
    flattenJSON: $d5b33d7c30034067$var$flattenJSON,
    subclip: $d5b33d7c30034067$var$subclip,
    makeClipAdditive: $d5b33d7c30034067$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $d5b33d7c30034067$export$3646682e7a3959 extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $d5b33d7c30034067$export$a8e6009059f51e1a extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $d5b33d7c30034067$export$fb9758ef7ef8d5cc extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $d5b33d7c30034067$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $d5b33d7c30034067$var$convertArray(times, this.TimeBufferType);
        this.values = $d5b33d7c30034067$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $d5b33d7c30034067$var$convertArray(track.times, Array),
                "values": $d5b33d7c30034067$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $d5b33d7c30034067$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $d5b33d7c30034067$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $d5b33d7c30034067$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $d5b33d7c30034067$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $d5b33d7c30034067$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $d5b33d7c30034067$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $d5b33d7c30034067$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $d5b33d7c30034067$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($d5b33d7c30034067$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $d5b33d7c30034067$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $d5b33d7c30034067$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $d5b33d7c30034067$export$d3a344b98cf0b775 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $d5b33d7c30034067$export$83444c5d885347d8 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $d5b33d7c30034067$export$d45f0d1a4d9a9314 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $d5b33d7c30034067$export$2db1cfb7923d931e extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $d5b33d7c30034067$export$b8043f12b5aafbd7 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $d5b33d7c30034067$export$6ce41d4f3a8df9cd extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $d5b33d7c30034067$export$5ce2dcb4cc9f2bff extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $d5b33d7c30034067$export$d942c706bf23829c {
    constructor(name = "", duration = -1, tracks = [], blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $d5b33d7c30034067$var$getKeyframeOrder(times);
            times = $d5b33d7c30034067$var$sortedArray(times, 1, order);
            values = $d5b33d7c30034067$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $d5b33d7c30034067$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($d5b33d7c30034067$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $d5b33d7c30034067$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $d5b33d7c30034067$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $d5b33d7c30034067$export$5ce2dcb4cc9f2bff;
        case "color":
            return $d5b33d7c30034067$export$83444c5d885347d8;
        case "quaternion":
            return $d5b33d7c30034067$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $d5b33d7c30034067$export$d3a344b98cf0b775;
        case "string":
            return $d5b33d7c30034067$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $d5b33d7c30034067$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $d5b33d7c30034067$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $d5b33d7c30034067$var$flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $d5b33d7c30034067$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $d5b33d7c30034067$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $d5b33d7c30034067$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $d5b33d7c30034067$export$99cc795e99919eed();
class $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $d5b33d7c30034067$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
$d5b33d7c30034067$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const $d5b33d7c30034067$var$loading = {};
class $d5b33d7c30034067$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $d5b33d7c30034067$export$98435a25b5cf7b2b extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($d5b33d7c30034067$var$loading[url] !== undefined) {
            $d5b33d7c30034067$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $d5b33d7c30034067$var$loading[url] = [];
        $d5b33d7c30034067$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === "undefined" || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $d5b33d7c30034067$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get("X-File-Size") || response.headers.get("Content-Length");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $d5b33d7c30034067$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, data);
            const callbacks = $d5b33d7c30034067$var$loading[url];
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $d5b33d7c30034067$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $d5b33d7c30034067$export$29711c7e14f61db extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$bd73ce947a280350 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $d5b33d7c30034067$export$3466bac9141a5cc4();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$8905ce1c7a2464a1 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $d5b33d7c30034067$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.slice(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $d5b33d7c30034067$export$2ec114afc2cf6308 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
        texture.colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$792d8a18f2c55855 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $d5b33d7c30034067$export$b691f601014eabe1();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$fd1bfc71f64c538c extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$5431306cf43de24a();
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$6ecadb6ed240d696 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = "Light";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        if (this.target !== undefined) data.object.target = this.target.uuid;
        return data;
    }
}
class $d5b33d7c30034067$export$8d474f55edbb9624 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = "HemisphereLight";
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $d5b33d7c30034067$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.intensity = 1;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $d5b33d7c30034067$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($d5b33d7c30034067$var$_lightPositionWorld$1);
        $d5b33d7c30034067$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($d5b33d7c30034067$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $d5b33d7c30034067$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($d5b33d7c30034067$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $d5b33d7c30034067$var$SpotLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $d5b33d7c30034067$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $d5b33d7c30034067$export$81495cbb73897362 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = "SpotLight";
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $d5b33d7c30034067$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$PointLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(-1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $d5b33d7c30034067$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($d5b33d7c30034067$var$_lightPositionWorld);
        $d5b33d7c30034067$var$_lookTarget.copy(camera.position);
        $d5b33d7c30034067$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($d5b33d7c30034067$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$d5b33d7c30034067$var$_lightPositionWorld.x, -$d5b33d7c30034067$var$_lightPositionWorld.y, -$d5b33d7c30034067$var$_lightPositionWorld.z);
        $d5b33d7c30034067$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix);
    }
}
class $d5b33d7c30034067$export$4c9c1cb3f0b6f455 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $d5b33d7c30034067$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$var$DirectionalLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $d5b33d7c30034067$export$3fea33cc9972c868 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = "DirectionalLight";
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.shadow = new $d5b33d7c30034067$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$export$af279bfef9ec2c96 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = "AmbientLight";
    }
}
class $d5b33d7c30034067$export$61db2d908bbd2429 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $d5b33d7c30034067$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $d5b33d7c30034067$export$e7ef036e309b38d2 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(sh = new $d5b33d7c30034067$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $d5b33d7c30034067$export$3bd6d323353dcf96 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = $d5b33d7c30034067$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $d5b33d7c30034067$export$e8564da406055a3,
            SpriteMaterial: $d5b33d7c30034067$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $d5b33d7c30034067$export$21c421a2e1df9d22,
            ShaderMaterial: $d5b33d7c30034067$export$83c7d75d550a8b0d,
            PointsMaterial: $d5b33d7c30034067$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $d5b33d7c30034067$export$28d04986c4269c9f,
            MeshStandardMaterial: $d5b33d7c30034067$export$f2980790215acccd,
            MeshPhongMaterial: $d5b33d7c30034067$export$24c72f71cbaf0678,
            MeshToonMaterial: $d5b33d7c30034067$export$df893cf97e765622,
            MeshNormalMaterial: $d5b33d7c30034067$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $d5b33d7c30034067$export$5023a9a8114806b8,
            MeshDepthMaterial: $d5b33d7c30034067$export$2698c22ec13825db,
            MeshDistanceMaterial: $d5b33d7c30034067$export$33e187ed002f2a19,
            MeshBasicMaterial: $d5b33d7c30034067$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $d5b33d7c30034067$export$6f5fef6235ec12ee,
            LineDashedMaterial: $d5b33d7c30034067$export$327886a3efaeaebe,
            LineBasicMaterial: $d5b33d7c30034067$export$fbaaa33907730a0c,
            Material: $d5b33d7c30034067$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $d5b33d7c30034067$export$b5d2dc08d867e41a {
    static decodeText(array) {
        console.warn("THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.");
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $d5b33d7c30034067$export$231f009cbe414146 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $d5b33d7c30034067$export$dc275bb96327833a extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $d5b33d7c30034067$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $d5b33d7c30034067$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $d5b33d7c30034067$export$231f009cbe414146() : new $d5b33d7c30034067$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $d5b33d7c30034067$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $d5b33d7c30034067$export$32ea87a8b54d744a : $d5b33d7c30034067$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $d5b33d7c30034067$export$40110c8505c5ad19 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                if (onError !== undefined) onError(new Error("THREE.ObjectLoader: Can't load " + url));
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $d5b33d7c30034067$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $d5b33d7c30034067$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $d5b33d7c30034067$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $d5b33d7c30034067$var$Geometries) geometry = $d5b33d7c30034067$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $d5b33d7c30034067$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $d5b33d7c30034067$export$99cc795e99919eed(onLoad);
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $d5b33d7c30034067$export$b691f601014eabe1();
                else texture = new $d5b33d7c30034067$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $d5b33d7c30034067$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $d5b33d7c30034067$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $d5b33d7c30034067$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $d5b33d7c30034067$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $d5b33d7c30034067$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== "") object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case "PerspectiveCamera":
                object = new $d5b33d7c30034067$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $d5b33d7c30034067$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $d5b33d7c30034067$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $d5b33d7c30034067$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || "";
                break;
            case "PointLight":
                object = new $d5b33d7c30034067$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $d5b33d7c30034067$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $d5b33d7c30034067$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || "";
                break;
            case "HemisphereLight":
                object = new $d5b33d7c30034067$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $d5b33d7c30034067$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $d5b33d7c30034067$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "BatchedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._visibility = data.visibility;
                object._active = data.active;
                object._bounds = data.bounds.map((bound)=>{
                    const box = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
                    box.min.fromArray(bound.boxMin);
                    box.max.fromArray(bound.boxMax);
                    const sphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
                    sphere.radius = bound.sphereRadius;
                    sphere.center.fromArray(bound.sphereCenter);
                    return {
                        boxInitialized: bound.boxInitialized,
                        box: box,
                        sphereInitialized: bound.sphereInitialized,
                        sphere: sphere
                    };
                });
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._geometryCount = data.geometryCount;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                break;
            case "LOD":
                object = new $d5b33d7c30034067$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $d5b33d7c30034067$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $d5b33d7c30034067$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $d5b33d7c30034067$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $d5b33d7c30034067$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $d5b33d7c30034067$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $d5b33d7c30034067$export$b127726e56765aa4();
                break;
            default:
                object = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty("uuid", uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
            }
        });
    }
}
const $d5b33d7c30034067$var$TEXTURE_MAPPING = {
    UVMapping: $d5b33d7c30034067$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $d5b33d7c30034067$export$8759762a6477f2c4,
    CubeRefractionMapping: $d5b33d7c30034067$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $d5b33d7c30034067$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $d5b33d7c30034067$export$ee99d97d46898098,
    CubeUVReflectionMapping: $d5b33d7c30034067$export$dbf3e70ff37af79
};
const $d5b33d7c30034067$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $d5b33d7c30034067$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $d5b33d7c30034067$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $d5b33d7c30034067$export$c7e7c00b14f51a4f
};
const $d5b33d7c30034067$var$TEXTURE_FILTER = {
    NearestFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $d5b33d7c30034067$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $d5b33d7c30034067$export$d2327c1afe5bfdf2,
    LinearFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $d5b33d7c30034067$export$19a719f377145a13,
    LinearMipmapLinearFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b
};
class $d5b33d7c30034067$export$52286b55c4a9b51f extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    if (onLoad) onLoad(imageBitmap);
                    scope.manager.itemEnd(url);
                }).catch((e)=>{
                    if (onError) onError(e);
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $d5b33d7c30034067$export$94affb487e701bf2.remove(url);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $d5b33d7c30034067$export$94affb487e701bf2.add(url, promise);
        scope.manager.itemStart(url);
    }
}
let $d5b33d7c30034067$var$_context;
class $d5b33d7c30034067$export$fcbc63750ec2a81f {
    static getContext() {
        if ($d5b33d7c30034067$var$_context === undefined) $d5b33d7c30034067$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $d5b33d7c30034067$var$_context;
    }
    static setContext(value) {
        $d5b33d7c30034067$var$_context = value;
    }
}
class $d5b33d7c30034067$export$d8d5fccfbf47714e extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
const $d5b33d7c30034067$var$_eyeRight = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_eyeLeft = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_projectionMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $d5b33d7c30034067$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($d5b33d7c30034067$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $d5b33d7c30034067$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $d5b33d7c30034067$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeRight);
    }
}
class $d5b33d7c30034067$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $d5b33d7c30034067$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $d5b33d7c30034067$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $d5b33d7c30034067$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $d5b33d7c30034067$var$_position$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$8a1b810c6fde8951 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $d5b33d7c30034067$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$1, $d5b33d7c30034067$var$_quaternion$1, $d5b33d7c30034067$var$_scale$1);
        $d5b33d7c30034067$var$_orientation$1.set(0, 0, -1).applyQuaternion($d5b33d7c30034067$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($d5b33d7c30034067$var$_position$1.x, $d5b33d7c30034067$var$_position$1.y, $d5b33d7c30034067$var$_position$1.z);
            listener.setOrientation($d5b33d7c30034067$var$_orientation$1.x, $d5b33d7c30034067$var$_orientation$1.y, $d5b33d7c30034067$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $d5b33d7c30034067$export$153755f98d9861de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $d5b33d7c30034067$var$_position = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b3e397ef1832507 extends $d5b33d7c30034067$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position, $d5b33d7c30034067$var$_quaternion, $d5b33d7c30034067$var$_scale);
        $d5b33d7c30034067$var$_orientation.set(0, 0, 1).applyQuaternion($d5b33d7c30034067$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.z, endTime);
        } else {
            panner.setPosition($d5b33d7c30034067$var$_position.x, $d5b33d7c30034067$var$_position.y, $d5b33d7c30034067$var$_position.z);
            panner.setOrientation($d5b33d7c30034067$var$_orientation.x, $d5b33d7c30034067$var$_orientation.y, $d5b33d7c30034067$var$_orientation.z);
        }
    }
}
class $d5b33d7c30034067$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $d5b33d7c30034067$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $d5b33d7c30034067$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $d5b33d7c30034067$var$_reservedRe = new RegExp("[" + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $d5b33d7c30034067$var$_wordChar = "[^" + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + "]";
const $d5b33d7c30034067$var$_wordCharOrDot = "[^" + $d5b33d7c30034067$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $d5b33d7c30034067$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace("WC", $d5b33d7c30034067$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $d5b33d7c30034067$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace("WCOD", $d5b33d7c30034067$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $d5b33d7c30034067$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $d5b33d7c30034067$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $d5b33d7c30034067$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $d5b33d7c30034067$var$_wordChar);
const $d5b33d7c30034067$var$_trackRe = new RegExp("^" + $d5b33d7c30034067$var$_directoryRe + $d5b33d7c30034067$var$_nodeRe + $d5b33d7c30034067$var$_objectRe + $d5b33d7c30034067$var$_propertyRe + "$");
const $d5b33d7c30034067$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones",
    "map"
];
class $d5b33d7c30034067$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $d5b33d7c30034067$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $d5b33d7c30034067$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $d5b33d7c30034067$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($d5b33d7c30034067$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $d5b33d7c30034067$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($d5b33d7c30034067$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$d5b33d7c30034067$export$7bf70fcf9f891893.Composite = $d5b33d7c30034067$var$Composite;
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_direct,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_array,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $d5b33d7c30034067$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $d5b33d7c30034067$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $d5b33d7c30034067$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $d5b33d7c30034067$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $d5b33d7c30034067$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $d5b33d7c30034067$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $d5b33d7c30034067$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $d5b33d7c30034067$export$24a4ccb5099273b5;
            settings.endingEnd = $d5b33d7c30034067$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingStart = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingEnd = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $d5b33d7c30034067$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $d5b33d7c30034067$export$fbd77e5aefaa0102 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $d5b33d7c30034067$export$dfe0af1ca1acb78a($d5b33d7c30034067$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $d5b33d7c30034067$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $d5b33d7c30034067$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $d5b33d7c30034067$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $d5b33d7c30034067$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $d5b33d7c30034067$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $d5b33d7c30034067$var$_id = 0;
class $d5b33d7c30034067$export$c412d5ffe1f79209 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$_id++
        });
        this.name = "";
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$25ec0e1af1389358 extends $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $d5b33d7c30034067$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = "";
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
const $d5b33d7c30034067$var$_matrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $d5b33d7c30034067$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    setFromXRController(controller) {
        $d5b33d7c30034067$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($d5b33d7c30034067$var$_matrix);
        return this;
    }
    intersectObject(object, recursive = true, intersects = []) {
        $d5b33d7c30034067$var$intersect(object, this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$d5b33d7c30034067$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
}
function $d5b33d7c30034067$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $d5b33d7c30034067$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$d5b33d7c30034067$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * phi (the polar angle) is measured from the positive y-axis. The positive y-axis is up.
 * theta (the azimuthal angle) is measured from the positive z-axis.
 */ class $d5b33d7c30034067$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($d5b33d7c30034067$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $d5b33d7c30034067$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$cbcc6560bf79fb38 {
    constructor(n11, n12, n21, n22){
        $d5b33d7c30034067$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $d5b33d7c30034067$var$_vector$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$60f553fa130f08b0 {
    constructor(min = new $d5b33d7c30034067$export$c977b3e384af9ae1(Infinity, Infinity), max = new $d5b33d7c30034067$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $d5b33d7c30034067$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_startP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_startEnd = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e0ba6359f1954fd3 {
    constructor(start = new $d5b33d7c30034067$export$64b5c384219d3699(), end = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $d5b33d7c30034067$var$_startP.subVectors(point, this.start);
        $d5b33d7c30034067$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startEnd);
        const startEnd_startP = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $d5b33d7c30034067$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b14638ffdd81e68 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "SpotLightHelper";
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $d5b33d7c30034067$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $d5b33d7c30034067$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($d5b33d7c30034067$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $d5b33d7c30034067$var$_vector$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_boneMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_matrixWorldInv = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$5277df3c9e732259 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $d5b33d7c30034067$var$getBoneList(object);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = "SkeletonHelper";
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $d5b33d7c30034067$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.parent.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j + 1, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $d5b33d7c30034067$var$getBoneList(object.children[i]));
    return boneList;
}
class $d5b33d7c30034067$export$9a9291685b9e4023 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $d5b33d7c30034067$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $d5b33d7c30034067$var$_vector$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_color1 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
const $d5b33d7c30034067$var$_color2 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
class $d5b33d7c30034067$export$8dca15f13f4f8172 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "HemisphereLightHelper";
        const geometry = new $d5b33d7c30034067$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $d5b33d7c30034067$export$8dea267bd6bde117(colors, 3));
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $d5b33d7c30034067$var$_color1.copy(this.light.color);
            $d5b33d7c30034067$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $d5b33d7c30034067$var$_color1 : $d5b33d7c30034067$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($d5b33d7c30034067$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $d5b33d7c30034067$export$3875d39926561055 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$361430a10f533cd3 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $d5b33d7c30034067$var$_v1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$f8e434dc14203e7d extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "DirectionalLightHelper";
        if (size === undefined) size = 1;
        let geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $d5b33d7c30034067$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $d5b33d7c30034067$var$_v3.subVectors($d5b33d7c30034067$var$_v2, $d5b33d7c30034067$var$_v1);
        this.lightPlane.lookAt($d5b33d7c30034067$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($d5b33d7c30034067$var$_v2);
        this.targetLine.scale.z = $d5b33d7c30034067$var$_v3.length();
    }
}
const $d5b33d7c30034067$var$_vector = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_camera = /*@__PURE__*/ new $d5b33d7c30034067$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $d5b33d7c30034067$export$ed8e93f853cd795 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine("n1", "n2");
        addLine("n2", "n4");
        addLine("n4", "n3");
        addLine("n3", "n1");
        // far
        addLine("f1", "f2");
        addLine("f2", "f4");
        addLine("f4", "f3");
        addLine("f3", "f1");
        // sides
        addLine("n1", "f1");
        addLine("n2", "f2");
        addLine("n3", "f3");
        addLine("n4", "f4");
        // cone
        addLine("p", "n1");
        addLine("p", "n2");
        addLine("p", "n3");
        addLine("p", "n4");
        // up
        addLine("u1", "u2");
        addLine("u2", "u3");
        addLine("u3", "u1");
        // target
        addLine("c", "t");
        addLine("p", "c");
        // cross
        addLine("cn1", "cn2");
        addLine("cn3", "cn4");
        addLine("cf1", "cf2");
        addLine("cf3", "cf4");
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $d5b33d7c30034067$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $d5b33d7c30034067$export$892596cec99bc70e(0xff0000);
        const colorUp = new $d5b33d7c30034067$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        const colorCross = new $d5b33d7c30034067$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute("color");
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $d5b33d7c30034067$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $d5b33d7c30034067$var$setPoint("c", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, -1);
        $d5b33d7c30034067$var$setPoint("t", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, 1);
        // near
        $d5b33d7c30034067$var$setPoint("n1", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, -1);
        $d5b33d7c30034067$var$setPoint("n2", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, -1);
        $d5b33d7c30034067$var$setPoint("n3", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, -1);
        $d5b33d7c30034067$var$setPoint("n4", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, -1);
        // far
        $d5b33d7c30034067$var$setPoint("f1", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, 1);
        $d5b33d7c30034067$var$setPoint("f2", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, 1);
        $d5b33d7c30034067$var$setPoint("f3", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, 1);
        $d5b33d7c30034067$var$setPoint("f4", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, 1);
        // up
        $d5b33d7c30034067$var$setPoint("u1", pointMap, geometry, $d5b33d7c30034067$var$_camera, w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint("u2", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint("u3", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h * 2, -1);
        // cross
        $d5b33d7c30034067$var$setPoint("cf1", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, 1);
        $d5b33d7c30034067$var$setPoint("cf2", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, 1);
        $d5b33d7c30034067$var$setPoint("cf3", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, 1);
        $d5b33d7c30034067$var$setPoint("cf4", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, 1);
        $d5b33d7c30034067$var$setPoint("cn1", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, -1);
        $d5b33d7c30034067$var$setPoint("cn2", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, -1);
        $d5b33d7c30034067$var$setPoint("cn3", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, -1);
        $d5b33d7c30034067$var$setPoint("cn4", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $d5b33d7c30034067$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $d5b33d7c30034067$var$_vector.x, $d5b33d7c30034067$var$_vector.y, $d5b33d7c30034067$var$_vector.z);
    }
}
const $d5b33d7c30034067$var$_box = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
class $d5b33d7c30034067$export$38a664cc862a6a9d extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $d5b33d7c30034067$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $d5b33d7c30034067$var$_box.setFromObject(this.object);
        if ($d5b33d7c30034067$var$_box.isEmpty()) return;
        const min = $d5b33d7c30034067$var$_box.min;
        const max = $d5b33d7c30034067$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$ce39f4bb96c9a290 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$a34fe8156c66e5d7 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry2, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $d5b33d7c30034067$var$_axis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
let $d5b33d7c30034067$var$_lineGeometry, $d5b33d7c30034067$var$_coneGeometry;
class $d5b33d7c30034067$export$a3008e7bd8d2cbe7 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1), origin = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($d5b33d7c30034067$var$_lineGeometry === undefined) {
            $d5b33d7c30034067$var$_lineGeometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            $d5b33d7c30034067$var$_lineGeometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $d5b33d7c30034067$var$_coneGeometry = new $d5b33d7c30034067$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $d5b33d7c30034067$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $d5b33d7c30034067$export$17d680238e50603e($d5b33d7c30034067$var$_lineGeometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $d5b33d7c30034067$export$e176487c05830cc5($d5b33d7c30034067$var$_coneGeometry, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $d5b33d7c30034067$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($d5b33d7c30034067$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $d5b33d7c30034067$export$6c8303f35b8578fd extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $d5b33d7c30034067$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $d5b33d7c30034067$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
class $d5b33d7c30034067$export$bd934554fb721730 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        console.warn('THREE.WebGLMultipleRenderTargets has been deprecated and will be removed in r172. Use THREE.WebGLRenderTarget and set the "count" parameter to enable MRT.');
        super(width, height, {
            ...options,
            count: count
        });
        this.isWebGLMultipleRenderTargets = true;
    }
    get texture() {
        return this.textures;
    }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $d5b33d7c30034067$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $d5b33d7c30034067$export$3545e07a80636437;
}

});

parcelRegister("1zN5O", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("kEdgE")).C);

var $kEdgE = parcelRequire("kEdgE");
parcelRequire("cavKm");

parcelRequire("5w59H");
parcelRequire("eBltz");
parcelRequire("iNOaC");

});
parcelRegister("kEdgE", function(module, exports) {

$parcel$export(module.exports, "C", () => $f081d5bdd247e907$export$e7094788287c5e9b);

var $cavKm = parcelRequire("cavKm");

var $ilwiq = parcelRequire("ilwiq");

var $5w59H = parcelRequire("5w59H");

var $eBltz = parcelRequire("eBltz");

var $iNOaC = parcelRequire("iNOaC");
function $f081d5bdd247e907$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f081d5bdd247e907$var$_toPropertyKey(arg) {
    var key = $f081d5bdd247e907$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f081d5bdd247e907$var$_defineProperty(obj, key, value) {
    key = $f081d5bdd247e907$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f081d5bdd247e907$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f081d5bdd247e907$export$407448d2b89b1813(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f081d5bdd247e907$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f081d5bdd247e907$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f081d5bdd247e907$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f081d5bdd247e907$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f081d5bdd247e907$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = $f081d5bdd247e907$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f081d5bdd247e907$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f081d5bdd247e907$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f081d5bdd247e907$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f081d5bdd247e907$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f081d5bdd247e907$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f081d5bdd247e907$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f081d5bdd247e907$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f081d5bdd247e907$var$_setPrototypeOf(o, p) {
    $f081d5bdd247e907$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f081d5bdd247e907$var$_setPrototypeOf(o, p);
}
function $f081d5bdd247e907$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f081d5bdd247e907$var$_setPrototypeOf(subClass, superClass);
}
function $f081d5bdd247e907$var$_getPrototypeOf(o) {
    $f081d5bdd247e907$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f081d5bdd247e907$var$_getPrototypeOf(o);
}
function $f081d5bdd247e907$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f081d5bdd247e907$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f081d5bdd247e907$var$_assertThisInitialized(self);
}
function $f081d5bdd247e907$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f081d5bdd247e907$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f081d5bdd247e907$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f081d5bdd247e907$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f081d5bdd247e907$var$_possibleConstructorReturn(this, result);
    };
}
var $f081d5bdd247e907$var$keywords = {
    position: "csm_Position",
    positionRaw: "csm_PositionRaw",
    pointSize: "csm_PointSize",
    fragColor: "csm_FragColor",
    // PBR
    diffuseColor: "csm_DiffuseColor",
    // Color + alpha
    normal: "csm_Normal",
    // Normal
    roughness: "csm_Roughness",
    // Roughness
    metalness: "csm_Metalness",
    // Metalness
    emissive: "csm_Emissive",
    // Emissive
    ao: "csm_AO",
    // AO
    bump: "csm_Bump",
    // Bump
    depthAlpha: "csm_DepthAlpha" // Depth
};
var $f081d5bdd247e907$var$_defaultPatchMap, $f081d5bdd247e907$var$_shaderMaterial_Patch;
var $f081d5bdd247e907$var$defaultPatchMap = ($f081d5bdd247e907$var$_defaultPatchMap = {}, $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.normal), {
    "#include <beginnormal_vertex>": "\n    vec3 objectNormal = ".concat($f081d5bdd247e907$var$keywords.normal, ";\n    #ifdef USE_TANGENT\n	    vec3 objectTangent = vec3( tangent.xyz );\n    #endif\n    ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.position), {
    "#include <begin_vertex>": "\n    vec3 transformed = ".concat($f081d5bdd247e907$var$keywords.position, ";\n  ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.positionRaw), {
    "#include <begin_vertex>": "\n    vec4 csm_internal_positionUnprojected = ".concat($f081d5bdd247e907$var$keywords.positionRaw, ";\n    mat4x4 csm_internal_unprojectMatrix = projectionMatrix * modelViewMatrix;\n    #ifdef USE_INSTANCING\n      csm_internal_unprojectMatrix = csm_internal_unprojectMatrix * instanceMatrix;\n    #endif\n    csm_internal_positionUnprojected = inverse(csm_internal_unprojectMatrix) * csm_internal_positionUnprojected;\n    vec3 transformed = csm_internal_positionUnprojected.xyz;\n  ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.pointSize), {
    "gl_PointSize = size;": "\n    gl_PointSize = ".concat($f081d5bdd247e907$var$keywords.pointSize, ";\n    ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.diffuseColor), {
    "#include <color_fragment>": "\n    #include <color_fragment>\n    diffuseColor = ".concat($f081d5bdd247e907$var$keywords.diffuseColor, ";\n  ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.fragColor), {
    "#include <dithering_fragment>": "\n    #include <dithering_fragment>\n    gl_FragColor  = ".concat($f081d5bdd247e907$var$keywords.fragColor, ";\n  ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.emissive), {
    "vec3 totalEmissiveRadiance = emissive;": "\n    vec3 totalEmissiveRadiance = ".concat($f081d5bdd247e907$var$keywords.emissive, ";\n    ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.roughness), {
    "#include <roughnessmap_fragment>": "\n    #include <roughnessmap_fragment>\n    roughnessFactor = ".concat($f081d5bdd247e907$var$keywords.roughness, ";\n    ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.metalness), {
    "#include <metalnessmap_fragment>": "\n    #include <metalnessmap_fragment>\n    metalnessFactor = ".concat($f081d5bdd247e907$var$keywords.metalness, ";\n    ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.ao), {
    "#include <aomap_fragment>": "\n    #include <aomap_fragment>\n    reflectedLight.indirectDiffuse *= 1. - ".concat($f081d5bdd247e907$var$keywords.ao, ";\n    ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.bump), {
    "#include <normal_fragment_maps>": "\n    #include <normal_fragment_maps>\n\n    vec3 csm_internal_orthogonal = ".concat($f081d5bdd247e907$var$keywords.bump, " - (dot(").concat($f081d5bdd247e907$var$keywords.bump, ", normal) * normal);\n    vec3 csm_internal_projectedbump = mat3(csm_internal_vModelViewMatrix) * csm_internal_orthogonal;\n    normal = normalize(normal - csm_internal_projectedbump);\n    ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultPatchMap, "".concat($f081d5bdd247e907$var$keywords.depthAlpha), {
    "gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );": "\n      gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity * ".concat($f081d5bdd247e907$var$keywords.depthAlpha, " );\n    "),
    "gl_FragColor = packDepthToRGBA( fragCoordZ );": "\n      gl_FragColor = packDepthToRGBA( fragCoordZ );\n      gl_FragColor.a *= ".concat($f081d5bdd247e907$var$keywords.depthAlpha, ";\n    ")
}), $f081d5bdd247e907$var$_defaultPatchMap);
var $f081d5bdd247e907$var$shaderMaterial_PatchMap = ($f081d5bdd247e907$var$_shaderMaterial_Patch = {}, $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_shaderMaterial_Patch, "".concat($f081d5bdd247e907$var$keywords.position), {
    "gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );": "\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( ".concat($f081d5bdd247e907$var$keywords.position, ", 1.0 );\n  ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_shaderMaterial_Patch, "".concat($f081d5bdd247e907$var$keywords.positionRaw), {
    "gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );": "\n    gl_Position = ".concat($f081d5bdd247e907$var$keywords.position, ";\n  ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_shaderMaterial_Patch, "".concat($f081d5bdd247e907$var$keywords.diffuseColor), {
    "gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );": "\n    gl_FragColor = ".concat($f081d5bdd247e907$var$keywords.diffuseColor, ";\n  ")
}), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_shaderMaterial_Patch, "".concat($f081d5bdd247e907$var$keywords.fragColor), {
    "gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );": "\n    gl_FragColor = ".concat($f081d5bdd247e907$var$keywords.fragColor, ";\n  ")
}), $f081d5bdd247e907$var$_shaderMaterial_Patch);
var $f081d5bdd247e907$var$defaultDefinitions = /* glsl */ "\n\n#ifdef IS_VERTEX\n    // csm_Position & csm_PositionRaw\n    #ifdef IS_UNKNOWN\n        vec3 csm_Position = vec3(0.0);\n        vec4 csm_PositionRaw = vec4(0.0);\n        vec3 csm_Normal = vec3(0.0);\n    #else\n        vec3 csm_Position = position;\n        vec4 csm_PositionRaw = projectionMatrix * modelViewMatrix * vec4(position, 1.);\n        vec3 csm_Normal = normal;\n    #endif\n\n    // csm_PointSize\n    #ifdef IS_POINTSMATERIAL\n        float csm_PointSize = size;\n    #endif\n#else\n    // csm_DiffuseColor & csm_FragColor\n    #if defined IS_UNKNOWN || defined IS_SHADERMATERIAL || defined IS_MESHDEPTHMATERIAL || defined IS_MESHNORMALMATERIAL || defined IS_SHADOWMATERIAL\n        vec4 csm_DiffuseColor = vec4(1.0, 0.0, 1.0, 1.0);\n        vec4 csm_FragColor = vec4(1.0, 0.0, 1.0, 1.0);\n    #else\n        #ifdef USE_MAP\n            vec4 _csm_sampledDiffuseColor = texture2D(map, vMapUv);\n\n            #ifdef DECODE_VIDEO_TEXTURE\n            // inline sRGB decode (TODO: Remove this code when https://crbug.com/1256340 is solved)\n            _csm_sampledDiffuseColor = vec4(mix(pow(_csm_sampledDiffuseColor.rgb * 0.9478672986 + vec3(0.0521327014), vec3(2.4)), _csm_sampledDiffuseColor.rgb * 0.0773993808, vec3(lessThanEqual(_csm_sampledDiffuseColor.rgb, vec3(0.04045)))), _csm_sampledDiffuseColor.w);\n            #endif\n\n            vec4 csm_DiffuseColor = vec4(diffuse, opacity) * _csm_sampledDiffuseColor;\n            vec4 csm_FragColor = vec4(diffuse, opacity) * _csm_sampledDiffuseColor;\n        #else\n            vec4 csm_DiffuseColor = vec4(diffuse, opacity);\n            vec4 csm_FragColor = vec4(diffuse, opacity);\n        #endif\n    #endif\n\n    // csm_Emissive, csm_Roughness, csm_Metalness\n    #if defined IS_MESHSTANDARDMATERIAL || defined IS_MESHPHYSICALMATERIAL\n        vec3 csm_Emissive = emissive;\n        float csm_Roughness = roughness;\n        float csm_Metalness = metalness;\n    #endif\n\n    // csm_AO\n    #if defined IS_MESHSTANDARDMATERIAL || defined IS_MESHPHYSICALMATERIAL || defined IS_MESHBASICMATERIAL || defined IS_MESHLAMBERTMATERIAL || defined IS_MESHPHONGMATERIAL || defined IS_MESHTOONMATERIAL\n        float csm_AO = 0.0;\n    #endif\n\n    // csm_Bump\n    #if defined IS_MESHLAMBERTMATERIAL || defined IS_MESHMATCAPMATERIAL || defined IS_MESHNORMALMATERIAL || defined IS_MESHPHONGMATERIAL || defined IS_MESHPHYSICALMATERIAL || defined IS_MESHSTANDARDMATERIAL || defined IS_MESHTOONMATERIAL || defined IS_SHADOWMATERIAL \n        vec3 csm_Bump = vec3(0.0);\n    #endif\n\n    float csm_DepthAlpha = 1.0;\n#endif\n";
var $f081d5bdd247e907$var$defaultVertDefinitions = /* glsl */ "\n    varying mat4 csm_internal_vModelViewMatrix;\n";
var $f081d5bdd247e907$var$defaultVertMain = /* glsl */ "\n    csm_internal_vModelViewMatrix = modelViewMatrix;\n";
var $f081d5bdd247e907$var$defaultFragDefinitions = /* glsl */ "\n    varying mat4 csm_internal_vModelViewMatrix;\n";
var $f081d5bdd247e907$var$defaultFragMain = /* glsl */ "\n    \n";
var $f081d5bdd247e907$var$_defaultAvailabilityM;
var $f081d5bdd247e907$var$defaultAvailabilityMap = ($f081d5bdd247e907$var$_defaultAvailabilityM = {}, $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.position), "*"), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.positionRaw), "*"), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.normal), "*"), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.pointSize), [
    "PointsMaterial"
]), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.diffuseColor), "*"), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.fragColor), "*"), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.emissive), [
    "MeshStandardMaterial",
    "MeshPhysicalMaterial"
]), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.roughness), [
    "MeshStandardMaterial",
    "MeshPhysicalMaterial"
]), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.metalness), [
    "MeshStandardMaterial",
    "MeshPhysicalMaterial"
]), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.ao), [
    "MeshStandardMaterial",
    "MeshPhysicalMaterial",
    "MeshBasicMaterial",
    "MeshLambertMaterial",
    "MeshPhongMaterial",
    "MeshToonMaterial"
]), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.bump), [
    "MeshLambertMaterial",
    "MeshMatcapMaterial",
    "MeshNormalMaterial",
    "MeshPhongMaterial",
    "MeshPhysicalMaterial",
    "MeshStandardMaterial",
    "MeshToonMaterial",
    "ShadowMaterial"
]), $f081d5bdd247e907$var$_defineProperty($f081d5bdd247e907$var$_defaultAvailabilityM, "".concat($f081d5bdd247e907$var$keywords.depthAlpha), "*"), $f081d5bdd247e907$var$_defaultAvailabilityM);
var $f081d5bdd247e907$var$_excluded = [
    "baseMaterial",
    "fragmentShader",
    "vertexShader",
    "uniforms",
    "patchMap",
    "cacheKey",
    "silent"
];
var $f081d5bdd247e907$var$replaceAll = function replaceAll(str, find, rep) {
    return str.split(find).join(rep);
};
var $f081d5bdd247e907$var$escapeRegExpMatch = function escapeRegExpMatch(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
};
var $f081d5bdd247e907$var$isExactMatch = function isExactMatch(str, match) {
    return new RegExp("\\b".concat($f081d5bdd247e907$var$escapeRegExpMatch(match), "\\b")).test(str);
};
// Hacky, yikes!
function $f081d5bdd247e907$var$isConstructor(f) {
    try {
        // @ts-ignore
        new f();
    } catch (err) {
        if (err.message.indexOf("is not a constructor") >= 0) return false;
    }
    return true;
}
function $f081d5bdd247e907$var$copyObject(target, source) {
    var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    Object.assign(target, source);
    var proto = Object.getPrototypeOf(source);
    Object.entries(Object.getOwnPropertyDescriptors(proto)).filter(function(e) {
        var isGetter = typeof e[1].get === "function";
        var isSetter = typeof e[1].set === "function";
        var isFunction = typeof e[1].value === "function";
        var isConstructor = e[0] === "constructor";
        return (isGetter || isSetter || isFunction) && !isConstructor;
    }).forEach(function(val) {
        // If function exists on target, rename it with "base_" prefix
        if (typeof target[val[0]] === "function") {
            if (!silent) console.warn("Function ".concat(val[0], " already exists on CSM, renaming to base_").concat(val[0]));
            var baseName = "base_".concat(val[0]);
            target[baseName] = val[1].value.bind(target);
            return;
        }
        Object.defineProperty(target, val[0], val[1]);
    });
}
function $f081d5bdd247e907$var$isFunctionEmpty(fn) {
    var fnString = fn.toString().trim();
    var fnBody = fnString.substring(fnString.indexOf("{") + 1, fnString.lastIndexOf("}"));
    return fnBody.trim().length === 0;
}
function $f081d5bdd247e907$var$stripSpaces(str) {
    return str.replace(/\s/g, "");
}
function $f081d5bdd247e907$var$replaceLastOccurrence(str, find, rep) {
    var index = str.lastIndexOf(find);
    if (index === -1) return str;
    return str.substring(0, index) + rep + str.substring(index + find.length);
}
var $f081d5bdd247e907$export$e7094788287c5e9b = /*#__PURE__*/ function(_THREE$Material) {
    $f081d5bdd247e907$var$_inherits(CustomShaderMaterial, _THREE$Material);
    var _super = $f081d5bdd247e907$var$_createSuper(CustomShaderMaterial);
    function CustomShaderMaterial(_ref) {
        var _this;
        var baseMaterial = _ref.baseMaterial, fragmentShader = _ref.fragmentShader, vertexShader = _ref.vertexShader, uniforms = _ref.uniforms, patchMap = _ref.patchMap, cacheKey = _ref.cacheKey, silent = _ref.silent, opts = $f081d5bdd247e907$export$71511d61b312f219(_ref, $f081d5bdd247e907$var$_excluded);
        $f081d5bdd247e907$var$_classCallCheck(this, CustomShaderMaterial);
        var base;
        if ($f081d5bdd247e907$var$isConstructor(baseMaterial)) // If base material is a constructor, instantiate it
        base = new baseMaterial(opts);
        else {
            // Else, copy options onto base material and use the already create
            // instance as the base material
            base = baseMaterial;
            Object.assign(base, opts);
        }
        // Supporting RawShaderMaterial is redundant as there is nothing
        // to patch, extend or override
        if (base.type === "RawShaderMaterial") throw new Error("CustomShaderMaterial does not support RawShaderMaterial");
        // Copy all properties from base material onto this material
        // Rename any functions that already exist on this material with "base_" prefix
        _this = _super.call(this);
        $f081d5bdd247e907$var$copyObject($f081d5bdd247e907$var$_assertThisInitialized(_this), base, silent);
        // Set up private internals
        _this.__csm = {
            patchMap: patchMap || {},
            fragmentShader: fragmentShader || "",
            vertexShader: vertexShader || "",
            cacheKey: cacheKey,
            baseMaterial: baseMaterial,
            instanceID: $ilwiq.MathUtils.generateUUID(),
            type: base.type,
            isAlreadyExtended: !$f081d5bdd247e907$var$isFunctionEmpty(base.onBeforeCompile),
            cacheHash: "",
            silent: silent
        };
        _this.uniforms = $f081d5bdd247e907$export$407448d2b89b1813($f081d5bdd247e907$export$407448d2b89b1813({}, _this.uniforms || {}), uniforms || {});
        // Generate material and assign cache key
        var _this$__csm = _this.__csm, _fragmentShader = _this$__csm.fragmentShader, _vertexShader = _this$__csm.vertexShader;
        var _uniforms = _this.uniforms;
        _this.__csm.cacheHash = _this.getCacheHash();
        _this.generateMaterial(_fragmentShader, _vertexShader, _uniforms);
        return _this;
    }
    /**
   *
   * Update the material with new arguments.
   * TODO: Fix memory leak.
   *
   * @param opts Options to update the material with.
   *
   * @deprecated This method leaks memory.
   */ $f081d5bdd247e907$var$_createClass(CustomShaderMaterial, [
        {
            key: "update",
            value: function update() {
                var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                // Basically just re-run the last bit of the constructor
                this.uniforms = opts.uniforms || this.uniforms;
                Object.assign(this.__csm, opts);
                var _this$__csm2 = this.__csm, fragmentShader = _this$__csm2.fragmentShader, vertexShader = _this$__csm2.vertexShader;
                var uniforms = this.uniforms;
                var newHash = this.getCacheHash();
                this.__csm.cacheHash = newHash;
                this.generateMaterial(fragmentShader, vertexShader, uniforms);
            }
        },
        {
            key: "clone",
            value: function clone() {
                var opts = {
                    baseMaterial: this.__csm.baseMaterial,
                    fragmentShader: this.__csm.fragmentShader,
                    vertexShader: this.__csm.vertexShader,
                    uniforms: this.uniforms,
                    silent: this.__csm.silent,
                    patchMap: this.__csm.patchMap,
                    cacheKey: this.__csm.cacheKey
                };
                var clone = new this.constructor(opts);
                Object.assign(this, clone);
                return clone;
            }
        },
        {
            key: "getCacheHash",
            value: function getCacheHash() {
                // The cache key is a hash of the fragment shader, vertex shader, and uniforms
                var _this$__csm3 = this.__csm, fragmentShader = _this$__csm3.fragmentShader, vertexShader = _this$__csm3.vertexShader;
                var uniforms = this.uniforms;
                var serializedUniforms = Object.values(uniforms).reduce(function(prev, _ref2) {
                    var value = _ref2.value;
                    return prev + JSON.stringify(value);
                }, "");
                // We strip spaces because whitespace is not significant in GLSL
                // and we want `blah` and `     blah ` to be the same.
                var hashInp = $f081d5bdd247e907$var$stripSpaces(fragmentShader) + $f081d5bdd247e907$var$stripSpaces(vertexShader) + serializedUniforms;
                // If CSM inputs are empty, use default cache key
                // This means that `<baseMaterial />` and <CSM baseMaterial={baseMaterial} />`
                // are the same shader program, i.e they share the same cache key
                return hashInp.trim().length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($cavKm)))(hashInp) : this.customProgramCacheKey();
            }
        },
        {
            key: "generateMaterial",
            value: function generateMaterial(fragmentShader, vertexShader, uniforms) {
                var _this2 = this;
                // Get parsed shaders. A Parsed shader is a shader with
                // it's `#define`s, function and var definitions and main separated.
                var parsedFragmentShader = this.parseShader(fragmentShader);
                var parsedVertexShader = this.parseShader(vertexShader);
                this.uniforms = uniforms || {};
                // Set material cache key
                this.customProgramCacheKey = function() {
                    return _this2.__csm.cacheHash;
                };
                // Set onBeforeCompile
                var customOnBeforeCompile = function customOnBeforeCompile(shader) {
                    try {
                        // If Fragment shader is not empty, patch it
                        if (parsedFragmentShader) {
                            var patchedFragmentShader = _this2.patchShader(parsedFragmentShader, shader.fragmentShader, true);
                            shader.fragmentShader = _this2.getMaterialDefine() + patchedFragmentShader;
                        }
                        // If Vertex shader is not empty, patch it
                        if (parsedVertexShader) {
                            var patchedVertexShader = _this2.patchShader(parsedVertexShader, shader.vertexShader);
                            shader.vertexShader = "#define IS_VERTEX;\n" + patchedVertexShader;
                            shader.vertexShader = _this2.getMaterialDefine() + shader.vertexShader;
                        }
                        // Patch uniforms
                        shader.uniforms = $f081d5bdd247e907$export$407448d2b89b1813($f081d5bdd247e907$export$407448d2b89b1813({}, shader.uniforms), _this2.uniforms);
                        _this2.uniforms = shader.uniforms;
                    } catch (error) {
                        console.error(error);
                    }
                };
                if (this.__csm.isAlreadyExtended) {
                    // If the material has already been extending via onBeforeCompile has a
                    // then chain the new onBeforeCompile after the old one.
                    var prevOnBeforeCompile = this.onBeforeCompile;
                    this.onBeforeCompile = function(shader, renderer) {
                        prevOnBeforeCompile(shader, renderer);
                        customOnBeforeCompile(shader);
                    };
                } else // Else just set the onBeforeCompile
                this.onBeforeCompile = customOnBeforeCompile;
                this.needsUpdate = true;
            }
        },
        {
            key: "patchShader",
            value: function patchShader(customShader, shader, isFrag) {
                var _this3 = this;
                var patchedShader = shader;
                // Get the patch map, its a combination of the default patch map and the
                // user defined patch map. The user defined map takes precedence.
                var patchMap = $f081d5bdd247e907$export$407448d2b89b1813($f081d5bdd247e907$export$407448d2b89b1813({}, this.getPatchMapForMaterial()), this.__csm.patchMap);
                // Replace all entries in the patch map
                Object.keys(patchMap).forEach(function(name) {
                    Object.keys(patchMap[name]).forEach(function(key) {
                        var availableIn = $f081d5bdd247e907$var$defaultAvailabilityMap[name];
                        var type = _this3.__csm.type;
                        // Only inject keywords that appear in the shader.
                        // If the keyword is '*', then inject the patch regardless.
                        if (name === "*" || $f081d5bdd247e907$var$isExactMatch(customShader.main, name)) {
                            if (!availableIn || Array.isArray(availableIn) && availableIn.includes(type) || availableIn === "*") patchedShader = $f081d5bdd247e907$var$replaceAll(patchedShader, key, patchMap[name][key]);
                            else throw new Error("CSM: ".concat(name, " is not available in ").concat(type, ". Shader cannot compile."));
                        }
                    });
                });
                // Inject defaults
                patchedShader = patchedShader.replace("void main() {", "\n        #ifndef CSM_IS_HEAD_DEFAULTS_DEFINED\n          ".concat(isFrag ? $f081d5bdd247e907$var$defaultFragDefinitions : $f081d5bdd247e907$var$defaultVertDefinitions, "\n          #define CSM_IS_HEAD_DEFAULTS_DEFINED 1\n        #endif\n\n        ").concat(customShader.header, "\n        \n        void main() {\n          #ifndef CSM_IS_DEFAULTS_DEFINED\n            ").concat($f081d5bdd247e907$var$defaultDefinitions, "\n            #define CSM_IS_DEFAULTS_DEFINED 1\n          #endif\n          \n          #ifndef CSM_IS_MAIN_DEFAULTS_DEFINED\n            ").concat(isFrag ? $f081d5bdd247e907$var$defaultFragMain : $f081d5bdd247e907$var$defaultVertMain, "\n            #define CSM_IS_MAIN_DEFAULTS_DEFINED 1\n          #endif\n\n          // CSM_START\n      "));
                var needsCustomInjectionOrder = this.__csm.isAlreadyExtended;
                var hasCSMEndMark = patchedShader.includes("// CSM_END");
                if (needsCustomInjectionOrder && hasCSMEndMark) // If the shader has already been extended, and contains the
                // CSM_END mark, then inject the custom shader after the CSM_END mark.
                // This ensures that the last shader in the chain receives all the vars and
                // values of the previous shaders.
                // This means that any custom materials would have to have the CSM_END mark
                // injected beforehand but thats the only way to know where the custom material's
                // main function ends.
                patchedShader = $f081d5bdd247e907$var$replaceLastOccurrence(patchedShader, "// CSM_END", "\n          // CSM_END\n          ".concat(customShader.main, "\n          // CSM_END\n        "));
                else // Else inject the custom shader at the start of main
                patchedShader = patchedShader.replace("// CSM_START", "\n        // CSM_START\n        ".concat(customShader.main, "\n        // CSM_END\n          "));
                patchedShader = customShader.defines + patchedShader;
                return patchedShader;
            }
        },
        {
            key: "parseShader",
            value: function parseShader(shader) {
                if (!shader) return;
                // Strip comments
                var s = shader.replace(/\/\*\*(.*?)\*\/|\/\/(.*?)\n/gm, "");
                // Tokenize and separate into defines, header and main
                var tokens = (0, (/*@__PURE__*/$parcel$interopDefault($5w59H)))(s);
                var funcs = (0, (/*@__PURE__*/$parcel$interopDefault($iNOaC)))(tokens);
                var mainIndex = funcs.map(function(e) {
                    return e.name;
                }).indexOf("main");
                var variables = (0, (/*@__PURE__*/$parcel$interopDefault($eBltz)))(tokens.slice(0, mainIndex >= 0 ? funcs[mainIndex].outer[0] : undefined));
                var mainBody = mainIndex >= 0 ? this.getShaderFromIndex(tokens, funcs[mainIndex].body) : "";
                return {
                    defines: "",
                    header: variables,
                    main: mainBody
                };
            }
        },
        {
            key: "getMaterialDefine",
            value: function getMaterialDefine() {
                var type = this.__csm.type;
                return type ? "#define IS_".concat(type.toUpperCase(), ";\n") : "#define IS_UNKNOWN;\n";
            }
        },
        {
            key: "getPatchMapForMaterial",
            value: function getPatchMapForMaterial() {
                switch(this.__csm.type){
                    case "ShaderMaterial":
                        return $f081d5bdd247e907$var$shaderMaterial_PatchMap;
                    default:
                        return $f081d5bdd247e907$var$defaultPatchMap;
                }
            }
        },
        {
            key: "getShaderFromIndex",
            value: function getShaderFromIndex(tokens, index) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($eBltz)))(tokens.slice(index[0], index[1]));
            }
        }
    ]);
    return CustomShaderMaterial;
}($ilwiq.Material);

});
parcelRegister("cavKm", function(module, exports) {
!function(e) {
    var t;
    module.exports = e();
}(function() {
    return (function r(o, i, u) {
        function s(n, e) {
            if (!i[n]) {
                if (!o[n]) {
                    var t = undefined;
                    if (!e && t) return t(n, !0);
                    if (a) return a(n, !0);
                    throw new Error("Cannot find module '" + n + "'");
                }
                e = i[n] = {
                    exports: {}
                };
                o[n][0].call(e.exports, function(e) {
                    var t = o[n][1][e];
                    return s(t || e);
                }, e, e.exports, r, o, i, u);
            }
            return i[n].exports;
        }
        for(var a = undefined, e = 0; e < u.length; e++)s(u[e]);
        return s;
    })({
        1: [
            function(w, b, m) {
                (function(e, n, s, c, d, h, p, g, y) {
                    "use strict";
                    var r = w("crypto");
                    function t(e, t) {
                        t = u(e, t);
                        var n;
                        return void 0 === (n = "passthrough" !== t.algorithm ? r.createHash(t.algorithm) : new l).write && (n.write = n.update, n.end = n.update), f(t, n).dispatch(e), n.update || n.end(""), n.digest ? n.digest("buffer" === t.encoding ? void 0 : t.encoding) : (e = n.read(), "buffer" !== t.encoding ? e.toString(t.encoding) : e);
                    }
                    (m = b.exports = t).sha1 = function(e) {
                        return t(e);
                    }, m.keys = function(e) {
                        return t(e, {
                            excludeValues: !0,
                            algorithm: "sha1",
                            encoding: "hex"
                        });
                    }, m.MD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex"
                        });
                    }, m.keysMD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex",
                            excludeValues: !0
                        });
                    };
                    var o = r.getHashes ? r.getHashes().slice() : [
                        "sha1",
                        "md5"
                    ], i = (o.push("passthrough"), [
                        "buffer",
                        "hex",
                        "binary",
                        "base64"
                    ]);
                    function u(e, t) {
                        var n = {};
                        if (n.algorithm = (t = t || {}).algorithm || "sha1", n.encoding = t.encoding || "hex", n.excludeValues = !!t.excludeValues, n.algorithm = n.algorithm.toLowerCase(), n.encoding = n.encoding.toLowerCase(), n.ignoreUnknown = !0 === t.ignoreUnknown, n.respectType = !1 !== t.respectType, n.respectFunctionNames = !1 !== t.respectFunctionNames, n.respectFunctionProperties = !1 !== t.respectFunctionProperties, n.unorderedArrays = !0 === t.unorderedArrays, n.unorderedSets = !1 !== t.unorderedSets, n.unorderedObjects = !1 !== t.unorderedObjects, n.replacer = t.replacer || void 0, n.excludeKeys = t.excludeKeys || void 0, void 0 === e) throw new Error("Object argument required.");
                        for(var r = 0; r < o.length; ++r)o[r].toLowerCase() === n.algorithm.toLowerCase() && (n.algorithm = o[r]);
                        if (-1 === o.indexOf(n.algorithm)) throw new Error('Algorithm "' + n.algorithm + '"  not supported. supported values: ' + o.join(", "));
                        if (-1 === i.indexOf(n.encoding) && "passthrough" !== n.algorithm) throw new Error('Encoding "' + n.encoding + '"  not supported. supported values: ' + i.join(", "));
                        return n;
                    }
                    function a(e) {
                        if ("function" == typeof e) return null != /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(e));
                    }
                    function f(o, t, i) {
                        i = i || [];
                        function u(e) {
                            return t.update ? t.update(e, "utf8") : t.write(e, "utf8");
                        }
                        return {
                            dispatch: function(e) {
                                return this["_" + (null === (e = o.replacer ? o.replacer(e) : e) ? "null" : typeof e)](e);
                            },
                            _object: function(t) {
                                var n, e = Object.prototype.toString.call(t), r = /\[object (.*)\]/i.exec(e);
                                r = (r = r ? r[1] : "unknown:[" + e + "]").toLowerCase();
                                if (0 <= (e = i.indexOf(t))) return this.dispatch("[CIRCULAR:" + e + "]");
                                if (i.push(t), void 0 !== s && s.isBuffer && s.isBuffer(t)) return u("buffer:"), u(t);
                                if ("object" === r || "function" === r || "asyncfunction" === r) return e = Object.keys(t), o.unorderedObjects && (e = e.sort()), !1 === o.respectType || a(t) || e.splice(0, 0, "prototype", "__proto__", "constructor"), o.excludeKeys && (e = e.filter(function(e) {
                                    return !o.excludeKeys(e);
                                })), u("object:" + e.length + ":"), n = this, e.forEach(function(e) {
                                    n.dispatch(e), u(":"), o.excludeValues || n.dispatch(t[e]), u(",");
                                });
                                if (!this["_" + r]) {
                                    if (o.ignoreUnknown) return u("[" + r + "]");
                                    throw new Error('Unknown object type "' + r + '"');
                                }
                                this["_" + r](t);
                            },
                            _array: function(e, t) {
                                t = void 0 !== t ? t : !1 !== o.unorderedArrays;
                                var n = this;
                                if (u("array:" + e.length + ":"), !t || e.length <= 1) return e.forEach(function(e) {
                                    return n.dispatch(e);
                                });
                                var r = [], t = e.map(function(e) {
                                    var t = new l, n = i.slice();
                                    return f(o, t, n).dispatch(e), r = r.concat(n.slice(i.length)), t.read().toString();
                                });
                                return i = i.concat(r), t.sort(), this._array(t, !1);
                            },
                            _date: function(e) {
                                return u("date:" + e.toJSON());
                            },
                            _symbol: function(e) {
                                return u("symbol:" + e.toString());
                            },
                            _error: function(e) {
                                return u("error:" + e.toString());
                            },
                            _boolean: function(e) {
                                return u("bool:" + e.toString());
                            },
                            _string: function(e) {
                                u("string:" + e.length + ":"), u(e.toString());
                            },
                            _function: function(e) {
                                u("fn:"), a(e) ? this.dispatch("[native]") : this.dispatch(e.toString()), !1 !== o.respectFunctionNames && this.dispatch("function-name:" + String(e.name)), o.respectFunctionProperties && this._object(e);
                            },
                            _number: function(e) {
                                return u("number:" + e.toString());
                            },
                            _xml: function(e) {
                                return u("xml:" + e.toString());
                            },
                            _null: function() {
                                return u("Null");
                            },
                            _undefined: function() {
                                return u("Undefined");
                            },
                            _regexp: function(e) {
                                return u("regex:" + e.toString());
                            },
                            _uint8array: function(e) {
                                return u("uint8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint8clampedarray: function(e) {
                                return u("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int8array: function(e) {
                                return u("int8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint16array: function(e) {
                                return u("uint16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int16array: function(e) {
                                return u("int16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint32array: function(e) {
                                return u("uint32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int32array: function(e) {
                                return u("int32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float32array: function(e) {
                                return u("float32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float64array: function(e) {
                                return u("float64array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _arraybuffer: function(e) {
                                return u("arraybuffer:"), this.dispatch(new Uint8Array(e));
                            },
                            _url: function(e) {
                                return u("url:" + e.toString());
                            },
                            _map: function(e) {
                                u("map:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _set: function(e) {
                                u("set:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _file: function(e) {
                                return u("file:"), this.dispatch([
                                    e.name,
                                    e.size,
                                    e.type,
                                    e.lastModfied
                                ]);
                            },
                            _blob: function() {
                                if (o.ignoreUnknown) return u("[blob]");
                                throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n');
                            },
                            _domwindow: function() {
                                return u("domwindow");
                            },
                            _bigint: function(e) {
                                return u("bigint:" + e.toString());
                            },
                            _process: function() {
                                return u("process");
                            },
                            _timer: function() {
                                return u("timer");
                            },
                            _pipe: function() {
                                return u("pipe");
                            },
                            _tcp: function() {
                                return u("tcp");
                            },
                            _udp: function() {
                                return u("udp");
                            },
                            _tty: function() {
                                return u("tty");
                            },
                            _statwatcher: function() {
                                return u("statwatcher");
                            },
                            _securecontext: function() {
                                return u("securecontext");
                            },
                            _connection: function() {
                                return u("connection");
                            },
                            _zlib: function() {
                                return u("zlib");
                            },
                            _context: function() {
                                return u("context");
                            },
                            _nodescript: function() {
                                return u("nodescript");
                            },
                            _httpparser: function() {
                                return u("httpparser");
                            },
                            _dataview: function() {
                                return u("dataview");
                            },
                            _signal: function() {
                                return u("signal");
                            },
                            _fsevent: function() {
                                return u("fsevent");
                            },
                            _tlswrap: function() {
                                return u("tlswrap");
                            }
                        };
                    }
                    function l() {
                        return {
                            buf: "",
                            write: function(e) {
                                this.buf += e;
                            },
                            end: function(e) {
                                this.buf += e;
                            },
                            read: function() {
                                return this.buf;
                            }
                        };
                    }
                    m.writeToStream = function(e, t, n) {
                        return void 0 === n && (n = t, t = {}), f(t = u(e, t), n).dispatch(e);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
            },
            {
                buffer: 3,
                crypto: 5,
                lYpoI2: 11
            }
        ],
        2: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    !function(e) {
                        "use strict";
                        var a = "undefined" != typeof Uint8Array ? Uint8Array : Array, t = "+".charCodeAt(0), n = "/".charCodeAt(0), r = "0".charCodeAt(0), o = "a".charCodeAt(0), i = "A".charCodeAt(0), u = "-".charCodeAt(0), s = "_".charCodeAt(0);
                        function f(e) {
                            e = e.charCodeAt(0);
                            return e === t || e === u ? 62 : e === n || e === s ? 63 : e < r ? -1 : e < r + 10 ? e - r + 26 + 26 : e < i + 26 ? e - i : e < o + 26 ? e - o + 26 : void 0;
                        }
                        e.toByteArray = function(e) {
                            var t, n;
                            if (0 < e.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                            var r = e.length, r = "=" === e.charAt(r - 2) ? 2 : "=" === e.charAt(r - 1) ? 1 : 0, o = new a(3 * e.length / 4 - r), i = 0 < r ? e.length - 4 : e.length, u = 0;
                            function s(e) {
                                o[u++] = e;
                            }
                            for(t = 0; t < i; t += 4)s((16711680 & (n = f(e.charAt(t)) << 18 | f(e.charAt(t + 1)) << 12 | f(e.charAt(t + 2)) << 6 | f(e.charAt(t + 3)))) >> 16), s((65280 & n) >> 8), s(255 & n);
                            return 2 == r ? s(255 & (n = f(e.charAt(t)) << 2 | f(e.charAt(t + 1)) >> 4)) : 1 == r && (s((n = f(e.charAt(t)) << 10 | f(e.charAt(t + 1)) << 4 | f(e.charAt(t + 2)) >> 2) >> 8 & 255), s(255 & n)), o;
                        }, e.fromByteArray = function(e) {
                            var t, n, r, o, i = e.length % 3, u = "";
                            function s(e) {
                                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e);
                            }
                            for(t = 0, r = e.length - i; t < r; t += 3)n = (e[t] << 16) + (e[t + 1] << 8) + e[t + 2], u += s((o = n) >> 18 & 63) + s(o >> 12 & 63) + s(o >> 6 & 63) + s(63 & o);
                            switch(i){
                                case 1:
                                    u = (u += s((n = e[e.length - 1]) >> 2)) + s(n << 4 & 63) + "==";
                                    break;
                                case 2:
                                    u = (u = (u += s((n = (e[e.length - 2] << 8) + e[e.length - 1]) >> 10)) + s(n >> 4 & 63)) + s(n << 2 & 63) + "=";
                            }
                            return u;
                        };
                    }(void 0 === f ? this.base64js = {} : f);
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        3: [
            function(O, e, H) {
                (function(e, n, f, r, h, p, g, y, w) {
                    var a = O("base64-js"), i = O("ieee754");
                    function f(e, t, n) {
                        if (!(this instanceof f)) return new f(e, t, n);
                        var r, o, i, u, s = typeof e;
                        if ("base64" === t && "string" == s) for(e = (u = e).trim ? u.trim() : u.replace(/^\s+|\s+$/g, ""); e.length % 4 != 0;)e += "=";
                        if ("number" == s) r = j(e);
                        else if ("string" == s) r = f.byteLength(e, t);
                        else {
                            if ("object" != s) throw new Error("First argument needs to be a number, array or string.");
                            r = j(e.length);
                        }
                        if (f._useTypedArrays ? o = f._augment(new Uint8Array(r)) : ((o = this).length = r, o._isBuffer = !0), f._useTypedArrays && "number" == typeof e.byteLength) o._set(e);
                        else if (C(u = e) || f.isBuffer(u) || u && "object" == typeof u && "number" == typeof u.length) for(i = 0; i < r; i++)f.isBuffer(e) ? o[i] = e.readUInt8(i) : o[i] = e[i];
                        else if ("string" == s) o.write(e, 0, t);
                        else if ("number" == s && !f._useTypedArrays && !n) for(i = 0; i < r; i++)o[i] = 0;
                        return o;
                    }
                    function b(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t = [], n = 0; n < e.length; n++)t.push(255 & e.charCodeAt(n));
                            return t;
                        }(t), e, n, r);
                    }
                    function m(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t, n, r = [], o = 0; o < e.length; o++)n = e.charCodeAt(o), t = n >> 8, n = n % 256, r.push(n), r.push(t);
                            return r;
                        }(t), e, n, r);
                    }
                    function v(e, t, n) {
                        var r = "";
                        n = Math.min(e.length, n);
                        for(var o = t; o < n; o++)r += String.fromCharCode(e[o]);
                        return r;
                    }
                    function o(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (o = e[t], t + 1 < r && (o |= e[t + 1] << 8)) : (o = e[t] << 8, t + 1 < r && (o |= e[t + 1])), o;
                    }
                    function u(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (t + 2 < r && (o = e[t + 2] << 16), t + 1 < r && (o |= e[t + 1] << 8), o |= e[t], t + 3 < r && (o += e[t + 3] << 24 >>> 0)) : (t + 1 < r && (o = e[t + 1] << 16), t + 2 < r && (o |= e[t + 2] << 8), t + 3 < r && (o |= e[t + 3]), o += e[t] << 24 >>> 0), o;
                    }
                    function _(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = o(e, t, n, !0), 32768 & r ? -1 * (65535 - r + 1) : r;
                    }
                    function E(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = u(e, t, n, !0), 2147483648 & r ? -1 * (4294967295 - r + 1) : r;
                    }
                    function I(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 3 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 23, 4);
                    }
                    function A(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 7 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 52, 8);
                    }
                    function s(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "trying to write beyond buffer length"), Y(t, 65535));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 2); i < u; i++)e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
                    }
                    function l(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "trying to write beyond buffer length"), Y(t, 4294967295));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 4); i < u; i++)e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
                    }
                    function B(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "Trying to write beyond buffer length"), F(t, 32767, -32768)), e.length <= n || s(e, 0 <= t ? t : 65535 + t + 1, n, r, o);
                    }
                    function L(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), F(t, 2147483647, -2147483648)), e.length <= n || l(e, 0 <= t ? t : 4294967295 + t + 1, n, r, o);
                    }
                    function U(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), D(t, 34028234663852886e22, -340282346638528860000000000000000000000)), e.length <= n || i.write(e, t, n, r, 23, 4);
                    }
                    function x(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 7 < e.length, "Trying to write beyond buffer length"), D(t, 17976931348623157e292, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000)), e.length <= n || i.write(e, t, n, r, 52, 8);
                    }
                    H.Buffer = f, H.SlowBuffer = f, H.INSPECT_MAX_BYTES = 50, f.poolSize = 8192, f._useTypedArrays = function() {
                        try {
                            var e = new ArrayBuffer(0), t = new Uint8Array(e);
                            return t.foo = function() {
                                return 42;
                            }, 42 === t.foo() && "function" == typeof t.subarray;
                        } catch (e) {
                            return !1;
                        }
                    }(), f.isEncoding = function(e) {
                        switch(String(e).toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "binary":
                            case "base64":
                            case "raw":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return !0;
                            default:
                                return !1;
                        }
                    }, f.isBuffer = function(e) {
                        return !(null == e || !e._isBuffer);
                    }, f.byteLength = function(e, t) {
                        var n;
                        switch(e += "", t || "utf8"){
                            case "hex":
                                n = e.length / 2;
                                break;
                            case "utf8":
                            case "utf-8":
                                n = T(e).length;
                                break;
                            case "ascii":
                            case "binary":
                            case "raw":
                                n = e.length;
                                break;
                            case "base64":
                                n = M(e).length;
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                n = 2 * e.length;
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return n;
                    }, f.concat = function(e, t) {
                        if (d(C(e), "Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."), 0 === e.length) return new f(0);
                        if (1 === e.length) return e[0];
                        if ("number" != typeof t) for(o = t = 0; o < e.length; o++)t += e[o].length;
                        for(var n = new f(t), r = 0, o = 0; o < e.length; o++){
                            var i = e[o];
                            i.copy(n, r), r += i.length;
                        }
                        return n;
                    }, f.prototype.write = function(e, t, n, r) {
                        isFinite(t) ? isFinite(n) || (r = n, n = void 0) : (a = r, r = t, t = n, n = a), t = Number(t) || 0;
                        var o, i, u, s, a = this.length - t;
                        switch((!n || a < (n = Number(n))) && (n = a), r = String(r || "utf8").toLowerCase()){
                            case "hex":
                                o = function(e, t, n, r) {
                                    n = Number(n) || 0;
                                    var o = e.length - n;
                                    (!r || o < (r = Number(r))) && (r = o), d((o = t.length) % 2 == 0, "Invalid hex string"), o / 2 < r && (r = o / 2);
                                    for(var i = 0; i < r; i++){
                                        var u = parseInt(t.substr(2 * i, 2), 16);
                                        d(!isNaN(u), "Invalid hex string"), e[n + i] = u;
                                    }
                                    return f._charsWritten = 2 * i, i;
                                }(this, e, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                i = this, u = t, s = n, o = f._charsWritten = c(T(e), i, u, s);
                                break;
                            case "ascii":
                            case "binary":
                                o = b(this, e, t, n);
                                break;
                            case "base64":
                                i = this, u = t, s = n, o = f._charsWritten = c(M(e), i, u, s);
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                o = m(this, e, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return o;
                    }, f.prototype.toString = function(e, t, n) {
                        var r, o, i, u, s = this;
                        if (e = String(e || "utf8").toLowerCase(), t = Number(t) || 0, (n = void 0 !== n ? Number(n) : s.length) === t) return "";
                        switch(e){
                            case "hex":
                                r = function(e, t, n) {
                                    var r = e.length;
                                    (!t || t < 0) && (t = 0);
                                    (!n || n < 0 || r < n) && (n = r);
                                    for(var o = "", i = t; i < n; i++)o += k(e[i]);
                                    return o;
                                }(s, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                r = function(e, t, n) {
                                    var r = "", o = "";
                                    n = Math.min(e.length, n);
                                    for(var i = t; i < n; i++)e[i] <= 127 ? (r += N(o) + String.fromCharCode(e[i]), o = "") : o += "%" + e[i].toString(16);
                                    return r + N(o);
                                }(s, t, n);
                                break;
                            case "ascii":
                            case "binary":
                                r = v(s, t, n);
                                break;
                            case "base64":
                                o = s, u = n, r = 0 === (i = t) && u === o.length ? a.fromByteArray(o) : a.fromByteArray(o.slice(i, u));
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                r = function(e, t, n) {
                                    for(var r = e.slice(t, n), o = "", i = 0; i < r.length; i += 2)o += String.fromCharCode(r[i] + 256 * r[i + 1]);
                                    return o;
                                }(s, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return r;
                    }, f.prototype.toJSON = function() {
                        return {
                            type: "Buffer",
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    }, f.prototype.copy = function(e, t, n, r) {
                        if (t = t || 0, (r = r || 0 === r ? r : this.length) !== (n = n || 0) && 0 !== e.length && 0 !== this.length) {
                            d(n <= r, "sourceEnd < sourceStart"), d(0 <= t && t < e.length, "targetStart out of bounds"), d(0 <= n && n < this.length, "sourceStart out of bounds"), d(0 <= r && r <= this.length, "sourceEnd out of bounds"), r > this.length && (r = this.length);
                            var o = (r = e.length - t < r - n ? e.length - t + n : r) - n;
                            if (o < 100 || !f._useTypedArrays) for(var i = 0; i < o; i++)e[i + t] = this[i + n];
                            else e._set(this.subarray(n, n + o), t);
                        }
                    }, f.prototype.slice = function(e, t) {
                        var n = this.length;
                        if (e = S(e, n, 0), t = S(t, n, n), f._useTypedArrays) return f._augment(this.subarray(e, t));
                        for(var r = t - e, o = new f(r, void 0, !0), i = 0; i < r; i++)o[i] = this[i + e];
                        return o;
                    }, f.prototype.get = function(e) {
                        return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e);
                    }, f.prototype.set = function(e, t) {
                        return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e, t);
                    }, f.prototype.readUInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return this[e];
                    }, f.prototype.readUInt16LE = function(e, t) {
                        return o(this, e, !0, t);
                    }, f.prototype.readUInt16BE = function(e, t) {
                        return o(this, e, !1, t);
                    }, f.prototype.readUInt32LE = function(e, t) {
                        return u(this, e, !0, t);
                    }, f.prototype.readUInt32BE = function(e, t) {
                        return u(this, e, !1, t);
                    }, f.prototype.readInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                    }, f.prototype.readInt16LE = function(e, t) {
                        return _(this, e, !0, t);
                    }, f.prototype.readInt16BE = function(e, t) {
                        return _(this, e, !1, t);
                    }, f.prototype.readInt32LE = function(e, t) {
                        return E(this, e, !0, t);
                    }, f.prototype.readInt32BE = function(e, t) {
                        return E(this, e, !1, t);
                    }, f.prototype.readFloatLE = function(e, t) {
                        return I(this, e, !0, t);
                    }, f.prototype.readFloatBE = function(e, t) {
                        return I(this, e, !1, t);
                    }, f.prototype.readDoubleLE = function(e, t) {
                        return A(this, e, !0, t);
                    }, f.prototype.readDoubleBE = function(e, t) {
                        return A(this, e, !1, t);
                    }, f.prototype.writeUInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "trying to write beyond buffer length"), Y(e, 255)), t >= this.length || (this[t] = e);
                    }, f.prototype.writeUInt16LE = function(e, t, n) {
                        s(this, e, t, !0, n);
                    }, f.prototype.writeUInt16BE = function(e, t, n) {
                        s(this, e, t, !1, n);
                    }, f.prototype.writeUInt32LE = function(e, t, n) {
                        l(this, e, t, !0, n);
                    }, f.prototype.writeUInt32BE = function(e, t, n) {
                        l(this, e, t, !1, n);
                    }, f.prototype.writeInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "Trying to write beyond buffer length"), F(e, 127, -128)), t >= this.length || (0 <= e ? this.writeUInt8(e, t, n) : this.writeUInt8(255 + e + 1, t, n));
                    }, f.prototype.writeInt16LE = function(e, t, n) {
                        B(this, e, t, !0, n);
                    }, f.prototype.writeInt16BE = function(e, t, n) {
                        B(this, e, t, !1, n);
                    }, f.prototype.writeInt32LE = function(e, t, n) {
                        L(this, e, t, !0, n);
                    }, f.prototype.writeInt32BE = function(e, t, n) {
                        L(this, e, t, !1, n);
                    }, f.prototype.writeFloatLE = function(e, t, n) {
                        U(this, e, t, !0, n);
                    }, f.prototype.writeFloatBE = function(e, t, n) {
                        U(this, e, t, !1, n);
                    }, f.prototype.writeDoubleLE = function(e, t, n) {
                        x(this, e, t, !0, n);
                    }, f.prototype.writeDoubleBE = function(e, t, n) {
                        x(this, e, t, !1, n);
                    }, f.prototype.fill = function(e, t, n) {
                        if (t = t || 0, n = n || this.length, d("number" == typeof (e = "string" == typeof (e = e || 0) ? e.charCodeAt(0) : e) && !isNaN(e), "value is not a number"), d(t <= n, "end < start"), n !== t && 0 !== this.length) {
                            d(0 <= t && t < this.length, "start out of bounds"), d(0 <= n && n <= this.length, "end out of bounds");
                            for(var r = t; r < n; r++)this[r] = e;
                        }
                    }, f.prototype.inspect = function() {
                        for(var e = [], t = this.length, n = 0; n < t; n++)if (e[n] = k(this[n]), n === H.INSPECT_MAX_BYTES) {
                            e[n + 1] = "...";
                            break;
                        }
                        return "<Buffer " + e.join(" ") + ">";
                    }, f.prototype.toArrayBuffer = function() {
                        if ("undefined" == typeof Uint8Array) throw new Error("Buffer.toArrayBuffer not supported in this browser");
                        if (f._useTypedArrays) return new f(this).buffer;
                        for(var e = new Uint8Array(this.length), t = 0, n = e.length; t < n; t += 1)e[t] = this[t];
                        return e.buffer;
                    };
                    var t = f.prototype;
                    function S(e, t, n) {
                        return "number" != typeof e ? n : t <= (e = ~~e) ? t : 0 <= e || 0 <= (e += t) ? e : 0;
                    }
                    function j(e) {
                        return (e = ~~Math.ceil(+e)) < 0 ? 0 : e;
                    }
                    function C(e) {
                        return (Array.isArray || function(e) {
                            return "[object Array]" === Object.prototype.toString.call(e);
                        })(e);
                    }
                    function k(e) {
                        return e < 16 ? "0" + e.toString(16) : e.toString(16);
                    }
                    function T(e) {
                        for(var t = [], n = 0; n < e.length; n++){
                            var r = e.charCodeAt(n);
                            if (r <= 127) t.push(e.charCodeAt(n));
                            else for(var o = n, i = (55296 <= r && r <= 57343 && n++, encodeURIComponent(e.slice(o, n + 1)).substr(1).split("%")), u = 0; u < i.length; u++)t.push(parseInt(i[u], 16));
                        }
                        return t;
                    }
                    function M(e) {
                        return a.toByteArray(e);
                    }
                    function c(e, t, n, r) {
                        for(var o = 0; o < r && !(o + n >= t.length || o >= e.length); o++)t[o + n] = e[o];
                        return o;
                    }
                    function N(e) {
                        try {
                            return decodeURIComponent(e);
                        } catch (e) {
                            return String.fromCharCode(65533);
                        }
                    }
                    function Y(e, t) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(0 <= e, "specified a negative value for writing an unsigned value"), d(e <= t, "value is larger than maximum value for type"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function F(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function D(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value");
                    }
                    function d(e, t) {
                        if (!e) throw new Error(t || "Failed assertion");
                    }
                    f._augment = function(e) {
                        return e._isBuffer = !0, e._get = e.get, e._set = e.set, e.get = t.get, e.set = t.set, e.write = t.write, e.toString = t.toString, e.toLocaleString = t.toString, e.toJSON = t.toJSON, e.copy = t.copy, e.slice = t.slice, e.readUInt8 = t.readUInt8, e.readUInt16LE = t.readUInt16LE, e.readUInt16BE = t.readUInt16BE, e.readUInt32LE = t.readUInt32LE, e.readUInt32BE = t.readUInt32BE, e.readInt8 = t.readInt8, e.readInt16LE = t.readInt16LE, e.readInt16BE = t.readInt16BE, e.readInt32LE = t.readInt32LE, e.readInt32BE = t.readInt32BE, e.readFloatLE = t.readFloatLE, e.readFloatBE = t.readFloatBE, e.readDoubleLE = t.readDoubleLE, e.readDoubleBE = t.readDoubleBE, e.writeUInt8 = t.writeUInt8, e.writeUInt16LE = t.writeUInt16LE, e.writeUInt16BE = t.writeUInt16BE, e.writeUInt32LE = t.writeUInt32LE, e.writeUInt32BE = t.writeUInt32BE, e.writeInt8 = t.writeInt8, e.writeInt16LE = t.writeInt16LE, e.writeInt16BE = t.writeInt16BE, e.writeInt32LE = t.writeInt32LE, e.writeInt32BE = t.writeInt32BE, e.writeFloatLE = t.writeFloatLE, e.writeFloatBE = t.writeFloatBE, e.writeDoubleLE = t.writeDoubleLE, e.writeDoubleBE = t.writeDoubleBE, e.fill = t.fill, e.inspect = t.inspect, e.toArrayBuffer = t.toArrayBuffer, e;
                    };
                }).call(this, O("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, O("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
            },
            {
                "base64-js": 2,
                buffer: 3,
                ieee754: 10,
                lYpoI2: 11
            }
        ],
        4: [
            function(c, d, e) {
                (function(e, t, a, n, r, o, i, u, s) {
                    var a = c("buffer").Buffer, f = 4, l = new a(f);
                    l.fill(0);
                    d.exports = {
                        hash: function(e, t, n, r) {
                            for(var o = t(function(e, t) {
                                e.length % f != 0 && (n = e.length + (f - e.length % f), e = a.concat([
                                    e,
                                    l
                                ], n));
                                for(var n, r = [], o = t ? e.readInt32BE : e.readInt32LE, i = 0; i < e.length; i += f)r.push(o.call(e, i));
                                return r;
                            }(e = a.isBuffer(e) ? e : new a(e), r), 8 * e.length), t = r, i = new a(n), u = t ? i.writeInt32BE : i.writeInt32LE, s = 0; s < o.length; s++)u.call(i, o[s], 4 * s, !0);
                            return i;
                        }
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        5: [
            function(v, e, _) {
                (function(l, c, u, d, h, p, g, y, w) {
                    var u = v("buffer").Buffer, e = v("./sha"), t = v("./sha256"), n = v("./rng"), b = {
                        sha1: e,
                        sha256: t,
                        md5: v("./md5")
                    }, s = 64, a = new u(s);
                    function r(e, n) {
                        var r = b[e = e || "sha1"], o = [];
                        return r || i("algorithm:", e, "is not yet supported"), {
                            update: function(e) {
                                return u.isBuffer(e) || (e = new u(e)), o.push(e), e.length, this;
                            },
                            digest: function(e) {
                                var t = u.concat(o), t = n ? function(e, t, n) {
                                    u.isBuffer(t) || (t = new u(t)), u.isBuffer(n) || (n = new u(n)), t.length > s ? t = e(t) : t.length < s && (t = u.concat([
                                        t,
                                        a
                                    ], s));
                                    for(var r = new u(s), o = new u(s), i = 0; i < s; i++)r[i] = 54 ^ t[i], o[i] = 92 ^ t[i];
                                    return n = e(u.concat([
                                        r,
                                        n
                                    ])), e(u.concat([
                                        o,
                                        n
                                    ]));
                                }(r, n, t) : r(t);
                                return o = null, e ? t.toString(e) : t;
                            }
                        };
                    }
                    function i() {
                        var e = [].slice.call(arguments).join(" ");
                        throw new Error([
                            e,
                            "we accept pull requests",
                            "http://github.com/dominictarr/crypto-browserify"
                        ].join("\n"));
                    }
                    a.fill(0), _.createHash = function(e) {
                        return r(e);
                    }, _.createHmac = r, _.randomBytes = function(e, t) {
                        if (!t || !t.call) return new u(n(e));
                        try {
                            t.call(this, void 0, new u(n(e)));
                        } catch (e) {
                            t(e);
                        }
                    };
                    var o, f = [
                        "createCredentials",
                        "createCipher",
                        "createCipheriv",
                        "createDecipher",
                        "createDecipheriv",
                        "createSign",
                        "createVerify",
                        "createDiffieHellman",
                        "pbkdf2"
                    ], m = function(e) {
                        _[e] = function() {
                            i("sorry,", e, "is not implemented yet");
                        };
                    };
                    for(o in f)m(f[o], o);
                }).call(this, v("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, v("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./md5": 6,
                "./rng": 7,
                "./sha": 8,
                "./sha256": 9,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        6: [
            function(w, b, e) {
                (function(e, r, o, i, u, a, f, l, y) {
                    var t = w("./helpers");
                    function n(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
                        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, u = 0; u < e.length; u += 16){
                            var s = n, a = r, f = o, l = i, n = c(n, r, o, i, e[u + 0], 7, -680876936), i = c(i, n, r, o, e[u + 1], 12, -389564586), o = c(o, i, n, r, e[u + 2], 17, 606105819), r = c(r, o, i, n, e[u + 3], 22, -1044525330);
                            n = c(n, r, o, i, e[u + 4], 7, -176418897), i = c(i, n, r, o, e[u + 5], 12, 1200080426), o = c(o, i, n, r, e[u + 6], 17, -1473231341), r = c(r, o, i, n, e[u + 7], 22, -45705983), n = c(n, r, o, i, e[u + 8], 7, 1770035416), i = c(i, n, r, o, e[u + 9], 12, -1958414417), o = c(o, i, n, r, e[u + 10], 17, -42063), r = c(r, o, i, n, e[u + 11], 22, -1990404162), n = c(n, r, o, i, e[u + 12], 7, 1804603682), i = c(i, n, r, o, e[u + 13], 12, -40341101), o = c(o, i, n, r, e[u + 14], 17, -1502002290), n = d(n, r = c(r, o, i, n, e[u + 15], 22, 1236535329), o, i, e[u + 1], 5, -165796510), i = d(i, n, r, o, e[u + 6], 9, -1069501632), o = d(o, i, n, r, e[u + 11], 14, 643717713), r = d(r, o, i, n, e[u + 0], 20, -373897302), n = d(n, r, o, i, e[u + 5], 5, -701558691), i = d(i, n, r, o, e[u + 10], 9, 38016083), o = d(o, i, n, r, e[u + 15], 14, -660478335), r = d(r, o, i, n, e[u + 4], 20, -405537848), n = d(n, r, o, i, e[u + 9], 5, 568446438), i = d(i, n, r, o, e[u + 14], 9, -1019803690), o = d(o, i, n, r, e[u + 3], 14, -187363961), r = d(r, o, i, n, e[u + 8], 20, 1163531501), n = d(n, r, o, i, e[u + 13], 5, -1444681467), i = d(i, n, r, o, e[u + 2], 9, -51403784), o = d(o, i, n, r, e[u + 7], 14, 1735328473), n = h(n, r = d(r, o, i, n, e[u + 12], 20, -1926607734), o, i, e[u + 5], 4, -378558), i = h(i, n, r, o, e[u + 8], 11, -2022574463), o = h(o, i, n, r, e[u + 11], 16, 1839030562), r = h(r, o, i, n, e[u + 14], 23, -35309556), n = h(n, r, o, i, e[u + 1], 4, -1530992060), i = h(i, n, r, o, e[u + 4], 11, 1272893353), o = h(o, i, n, r, e[u + 7], 16, -155497632), r = h(r, o, i, n, e[u + 10], 23, -1094730640), n = h(n, r, o, i, e[u + 13], 4, 681279174), i = h(i, n, r, o, e[u + 0], 11, -358537222), o = h(o, i, n, r, e[u + 3], 16, -722521979), r = h(r, o, i, n, e[u + 6], 23, 76029189), n = h(n, r, o, i, e[u + 9], 4, -640364487), i = h(i, n, r, o, e[u + 12], 11, -421815835), o = h(o, i, n, r, e[u + 15], 16, 530742520), n = p(n, r = h(r, o, i, n, e[u + 2], 23, -995338651), o, i, e[u + 0], 6, -198630844), i = p(i, n, r, o, e[u + 7], 10, 1126891415), o = p(o, i, n, r, e[u + 14], 15, -1416354905), r = p(r, o, i, n, e[u + 5], 21, -57434055), n = p(n, r, o, i, e[u + 12], 6, 1700485571), i = p(i, n, r, o, e[u + 3], 10, -1894986606), o = p(o, i, n, r, e[u + 10], 15, -1051523), r = p(r, o, i, n, e[u + 1], 21, -2054922799), n = p(n, r, o, i, e[u + 8], 6, 1873313359), i = p(i, n, r, o, e[u + 15], 10, -30611744), o = p(o, i, n, r, e[u + 6], 15, -1560198380), r = p(r, o, i, n, e[u + 13], 21, 1309151649), n = p(n, r, o, i, e[u + 4], 6, -145523070), i = p(i, n, r, o, e[u + 11], 10, -1120210379), o = p(o, i, n, r, e[u + 2], 15, 718787259), r = p(r, o, i, n, e[u + 9], 21, -343485551), n = g(n, s), r = g(r, a), o = g(o, f), i = g(i, l);
                        }
                        return Array(n, r, o, i);
                    }
                    function s(e, t, n, r, o, i) {
                        return g((t = g(g(t, e), g(r, i))) << o | t >>> 32 - o, n);
                    }
                    function c(e, t, n, r, o, i, u) {
                        return s(t & n | ~t & r, e, t, o, i, u);
                    }
                    function d(e, t, n, r, o, i, u) {
                        return s(t & r | n & ~r, e, t, o, i, u);
                    }
                    function h(e, t, n, r, o, i, u) {
                        return s(t ^ n ^ r, e, t, o, i, u);
                    }
                    function p(e, t, n, r, o, i, u) {
                        return s(n ^ (t | ~r), e, t, o, i, u);
                    }
                    function g(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    b.exports = function(e) {
                        return t.hash(e, n, 16);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        7: [
            function(e, l, t) {
                (function(e, t, n, r, o, i, u, s, f) {
                    var a;
                    l.exports = a || function(e) {
                        for(var t, n = new Array(e), r = 0; r < e; r++)0 == (3 & r) && (t = 4294967296 * Math.random()), n[r] = t >>> ((3 & r) << 3) & 255;
                        return n;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        8: [
            function(c, d, e) {
                (function(e, t, n, r, o, s, a, f, l) {
                    var i = c("./helpers");
                    function u(l, c) {
                        l[c >> 5] |= 128 << 24 - c % 32, l[15 + (c + 64 >> 9 << 4)] = c;
                        for(var e, t, n, r = Array(80), o = 1732584193, i = -271733879, u = -1732584194, s = 271733878, d = -1009589776, h = 0; h < l.length; h += 16){
                            for(var p = o, g = i, y = u, w = s, b = d, a = 0; a < 80; a++){
                                r[a] = a < 16 ? l[h + a] : v(r[a - 3] ^ r[a - 8] ^ r[a - 14] ^ r[a - 16], 1);
                                var f = m(m(v(o, 5), (f = i, t = u, n = s, (e = a) < 20 ? f & t | ~f & n : !(e < 40) && e < 60 ? f & t | f & n | t & n : f ^ t ^ n)), m(m(d, r[a]), (e = a) < 20 ? 1518500249 : e < 40 ? 1859775393 : e < 60 ? -1894007588 : -899497514)), d = s, s = u, u = v(i, 30), i = o, o = f;
                            }
                            o = m(o, p), i = m(i, g), u = m(u, y), s = m(s, w), d = m(d, b);
                        }
                        return Array(o, i, u, s, d);
                    }
                    function m(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function v(e, t) {
                        return e << t | e >>> 32 - t;
                    }
                    d.exports = function(e) {
                        return i.hash(e, u, 20, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        9: [
            function(c, d, e) {
                (function(e, t, n, r, u, s, a, f, l) {
                    function b(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function o(e, l) {
                        var c, d = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), t = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), n = new Array(64);
                        e[l >> 5] |= 128 << 24 - l % 32, e[15 + (l + 64 >> 9 << 4)] = l;
                        for(var r, o, h = 0; h < e.length; h += 16){
                            for(var i = t[0], u = t[1], s = t[2], p = t[3], a = t[4], g = t[5], y = t[6], w = t[7], f = 0; f < 64; f++)n[f] = f < 16 ? e[f + h] : b(b(b((o = n[f - 2], m(o, 17) ^ m(o, 19) ^ v(o, 10)), n[f - 7]), (o = n[f - 15], m(o, 7) ^ m(o, 18) ^ v(o, 3))), n[f - 16]), c = b(b(b(b(w, m(o = a, 6) ^ m(o, 11) ^ m(o, 25)), a & g ^ ~a & y), d[f]), n[f]), r = b(m(r = i, 2) ^ m(r, 13) ^ m(r, 22), i & u ^ i & s ^ u & s), w = y, y = g, g = a, a = b(p, c), p = s, s = u, u = i, i = b(c, r);
                            t[0] = b(i, t[0]), t[1] = b(u, t[1]), t[2] = b(s, t[2]), t[3] = b(p, t[3]), t[4] = b(a, t[4]), t[5] = b(g, t[5]), t[6] = b(y, t[6]), t[7] = b(w, t[7]);
                        }
                        return t;
                    }
                    var i = c("./helpers"), m = function(e, t) {
                        return e >>> t | e << 32 - t;
                    }, v = function(e, t) {
                        return e >>> t;
                    };
                    d.exports = function(e) {
                        return i.hash(e, o, 32, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        10: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    f.read = function(e, t, n, r, o) {
                        var i, u, l = 8 * o - r - 1, c = (1 << l) - 1, d = c >> 1, s = -7, a = n ? o - 1 : 0, f = n ? -1 : 1, o = e[t + a];
                        for(a += f, i = o & (1 << -s) - 1, o >>= -s, s += l; 0 < s; i = 256 * i + e[t + a], a += f, s -= 8);
                        for(u = i & (1 << -s) - 1, i >>= -s, s += r; 0 < s; u = 256 * u + e[t + a], a += f, s -= 8);
                        if (0 === i) i = 1 - d;
                        else {
                            if (i === c) return u ? NaN : 1 / 0 * (o ? -1 : 1);
                            u += Math.pow(2, r), i -= d;
                        }
                        return (o ? -1 : 1) * u * Math.pow(2, i - r);
                    }, f.write = function(e, t, l, n, r, c) {
                        var o, i, u = 8 * c - r - 1, s = (1 << u) - 1, a = s >> 1, d = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : c - 1, h = n ? 1 : -1, c = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                        for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (i = isNaN(t) ? 1 : 0, o = s) : (o = Math.floor(Math.log(t) / Math.LN2), t * (n = Math.pow(2, -o)) < 1 && (o--, n *= 2), 2 <= (t += 1 <= o + a ? d / n : d * Math.pow(2, 1 - a)) * n && (o++, n /= 2), s <= o + a ? (i = 0, o = s) : 1 <= o + a ? (i = (t * n - 1) * Math.pow(2, r), o += a) : (i = t * Math.pow(2, a - 1) * Math.pow(2, r), o = 0)); 8 <= r; e[l + f] = 255 & i, f += h, i /= 256, r -= 8);
                        for(o = o << r | i, u += r; 0 < u; e[l + f] = 255 & o, f += h, o /= 256, u -= 8);
                        e[l + f - h] |= 128 * c;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        11: [
            function(e, h, t) {
                (function(e, t, n, r, o, f, l, c, d) {
                    var i, u, s;
                    function a() {}
                    (e = h.exports = {}).nextTick = (u = "undefined" != typeof window && window.setImmediate, s = "undefined" != typeof window && window.postMessage && window.addEventListener, u ? function(e) {
                        return window.setImmediate(e);
                    } : s ? (i = [], window.addEventListener("message", function(e) {
                        var t = e.source;
                        t !== window && null !== t || "process-tick" !== e.data || (e.stopPropagation(), 0 < i.length && i.shift()());
                    }, !0), function(e) {
                        i.push(e), window.postMessage("process-tick", "*");
                    }) : function(e) {
                        setTimeout(e, 0);
                    }), e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.on = a, e.addListener = a, e.once = a, e.off = a, e.removeListener = a, e.removeAllListeners = a, e.emit = a, e.binding = function(e) {
                        throw new Error("process.binding is not supported");
                    }, e.cwd = function() {
                        return "/";
                    }, e.chdir = function(e) {
                        throw new Error("process.chdir is not supported");
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ]
    }, {}, [
        1
    ])(1);
});

});

parcelRegister("5w59H", function(module, exports) {

var $dzMbm = parcelRequire("dzMbm");
module.exports = $4043f0acfe9fa3ff$var$tokenizeString;
function $4043f0acfe9fa3ff$var$tokenizeString(str, opt) {
    var generator = $dzMbm(opt);
    var tokens = [];
    tokens = tokens.concat(generator(str));
    tokens = tokens.concat(generator(null));
    return tokens;
}

});
parcelRegister("dzMbm", function(module, exports) {
module.exports = $9e23eb38d12e497b$var$tokenize;

var $cXK4x = parcelRequire("cXK4x");

var $9YvHM = parcelRequire("9YvHM");

var $f8h8X = parcelRequire("f8h8X");

var $gNfDV = parcelRequire("gNfDV");

var $d6iZA = parcelRequire("d6iZA");
var $9e23eb38d12e497b$var$NORMAL = 999 // <-- never emitted
, $9e23eb38d12e497b$var$TOKEN = 9999 // <-- never emitted
, $9e23eb38d12e497b$var$BLOCK_COMMENT = 0, $9e23eb38d12e497b$var$LINE_COMMENT = 1, $9e23eb38d12e497b$var$PREPROCESSOR = 2, $9e23eb38d12e497b$var$OPERATOR = 3, $9e23eb38d12e497b$var$INTEGER = 4, $9e23eb38d12e497b$var$FLOAT = 5, $9e23eb38d12e497b$var$IDENT = 6, $9e23eb38d12e497b$var$BUILTIN = 7, $9e23eb38d12e497b$var$KEYWORD = 8, $9e23eb38d12e497b$var$WHITESPACE = 9, $9e23eb38d12e497b$var$EOF = 10, $9e23eb38d12e497b$var$HEX = 11;
var $9e23eb38d12e497b$var$map = [
    "block-comment",
    "line-comment",
    "preprocessor",
    "operator",
    "integer",
    "float",
    "ident",
    "builtin",
    "keyword",
    "whitespace",
    "eof",
    "integer"
];
function $9e23eb38d12e497b$var$tokenize(opt) {
    var i = 0, total = 0, mode = $9e23eb38d12e497b$var$NORMAL, c, last, content = [], tokens = [], token_idx = 0, token_offs = 0, line = 1, col = 0, start = 0, isnum = false, isoperator = false, input = "", len;
    opt = opt || {};
    var allBuiltins = $f8h8X;
    var allLiterals = $cXK4x;
    if (opt.version === "300 es") {
        allBuiltins = $d6iZA;
        allLiterals = $gNfDV;
    }
    // cache by name
    var builtinsDict = {}, literalsDict = {};
    for(var i = 0; i < allBuiltins.length; i++)builtinsDict[allBuiltins[i]] = true;
    for(var i = 0; i < allLiterals.length; i++)literalsDict[allLiterals[i]] = true;
    return function(data) {
        tokens = [];
        if (data !== null) return write(data);
        return end();
    };
    function token(data) {
        if (data.length) tokens.push({
            type: $9e23eb38d12e497b$var$map[mode],
            data: data,
            position: start,
            line: line,
            column: col
        });
    }
    function write(chunk) {
        i = 0;
        if (chunk.toString) chunk = chunk.toString();
        input += chunk.replace(/\r\n/g, "\n");
        len = input.length;
        var last;
        while(c = input[i], i < len){
            last = i;
            switch(mode){
                case $9e23eb38d12e497b$var$BLOCK_COMMENT:
                    i = block_comment();
                    break;
                case $9e23eb38d12e497b$var$LINE_COMMENT:
                    i = line_comment();
                    break;
                case $9e23eb38d12e497b$var$PREPROCESSOR:
                    i = preprocessor();
                    break;
                case $9e23eb38d12e497b$var$OPERATOR:
                    i = operator();
                    break;
                case $9e23eb38d12e497b$var$INTEGER:
                    i = integer();
                    break;
                case $9e23eb38d12e497b$var$HEX:
                    i = hex();
                    break;
                case $9e23eb38d12e497b$var$FLOAT:
                    i = decimal();
                    break;
                case $9e23eb38d12e497b$var$TOKEN:
                    i = readtoken();
                    break;
                case $9e23eb38d12e497b$var$WHITESPACE:
                    i = whitespace();
                    break;
                case $9e23eb38d12e497b$var$NORMAL:
                    i = normal();
                    break;
            }
            if (last !== i) switch(input[last]){
                case "\n":
                    col = 0;
                    ++line;
                    break;
                default:
                    ++col;
                    break;
            }
        }
        total += i;
        input = input.slice(i);
        return tokens;
    }
    function end(chunk) {
        if (content.length) token(content.join(""));
        mode = $9e23eb38d12e497b$var$EOF;
        token("(eof)");
        return tokens;
    }
    function normal() {
        content = content.length ? [] : content;
        if (last === "/" && c === "*") {
            start = total + i - 1;
            mode = $9e23eb38d12e497b$var$BLOCK_COMMENT;
            last = c;
            return i + 1;
        }
        if (last === "/" && c === "/") {
            start = total + i - 1;
            mode = $9e23eb38d12e497b$var$LINE_COMMENT;
            last = c;
            return i + 1;
        }
        if (c === "#") {
            mode = $9e23eb38d12e497b$var$PREPROCESSOR;
            start = total + i;
            return i;
        }
        if (/\s/.test(c)) {
            mode = $9e23eb38d12e497b$var$WHITESPACE;
            start = total + i;
            return i;
        }
        isnum = /\d/.test(c);
        isoperator = /[^\w_]/.test(c);
        start = total + i;
        mode = isnum ? $9e23eb38d12e497b$var$INTEGER : isoperator ? $9e23eb38d12e497b$var$OPERATOR : $9e23eb38d12e497b$var$TOKEN;
        return i;
    }
    function whitespace() {
        if (/[^\s]/g.test(c)) {
            token(content.join(""));
            mode = $9e23eb38d12e497b$var$NORMAL;
            return i;
        }
        content.push(c);
        last = c;
        return i + 1;
    }
    function preprocessor() {
        if ((c === "\r" || c === "\n") && last !== "\\") {
            token(content.join(""));
            mode = $9e23eb38d12e497b$var$NORMAL;
            return i;
        }
        content.push(c);
        last = c;
        return i + 1;
    }
    function line_comment() {
        return preprocessor();
    }
    function block_comment() {
        if (c === "/" && last === "*") {
            content.push(c);
            token(content.join(""));
            mode = $9e23eb38d12e497b$var$NORMAL;
            return i + 1;
        }
        content.push(c);
        last = c;
        return i + 1;
    }
    function operator() {
        if (last === "." && /\d/.test(c)) {
            mode = $9e23eb38d12e497b$var$FLOAT;
            return i;
        }
        if (last === "/" && c === "*") {
            mode = $9e23eb38d12e497b$var$BLOCK_COMMENT;
            return i;
        }
        if (last === "/" && c === "/") {
            mode = $9e23eb38d12e497b$var$LINE_COMMENT;
            return i;
        }
        if (c === "." && content.length) {
            while(determine_operator(content));
            mode = $9e23eb38d12e497b$var$FLOAT;
            return i;
        }
        if (c === ";" || c === ")" || c === "(") {
            if (content.length) while(determine_operator(content));
            token(c);
            mode = $9e23eb38d12e497b$var$NORMAL;
            return i + 1;
        }
        var is_composite_operator = content.length === 2 && c !== "=";
        if (/[\w_\d\s]/.test(c) || is_composite_operator) {
            while(determine_operator(content));
            mode = $9e23eb38d12e497b$var$NORMAL;
            return i;
        }
        content.push(c);
        last = c;
        return i + 1;
    }
    function determine_operator(buf) {
        var j = 0, idx, res;
        do {
            idx = $9YvHM.indexOf(buf.slice(0, buf.length + j).join(""));
            res = $9YvHM[idx];
            if (idx === -1) {
                if (j-- + buf.length > 0) continue;
                res = buf.slice(0, 1).join("");
            }
            token(res);
            start += res.length;
            content = content.slice(res.length);
            return content.length;
        }while (1);
    }
    function hex() {
        if (/[^a-fA-F0-9]/.test(c)) {
            token(content.join(""));
            mode = $9e23eb38d12e497b$var$NORMAL;
            return i;
        }
        content.push(c);
        last = c;
        return i + 1;
    }
    function integer() {
        if (c === ".") {
            content.push(c);
            mode = $9e23eb38d12e497b$var$FLOAT;
            last = c;
            return i + 1;
        }
        if (/[eE]/.test(c)) {
            content.push(c);
            mode = $9e23eb38d12e497b$var$FLOAT;
            last = c;
            return i + 1;
        }
        if (c === "x" && content.length === 1 && content[0] === "0") {
            mode = $9e23eb38d12e497b$var$HEX;
            content.push(c);
            last = c;
            return i + 1;
        }
        if (/[^\d]/.test(c)) {
            token(content.join(""));
            mode = $9e23eb38d12e497b$var$NORMAL;
            return i;
        }
        content.push(c);
        last = c;
        return i + 1;
    }
    function decimal() {
        if (c === "f") {
            content.push(c);
            last = c;
            i += 1;
        }
        if (/[eE]/.test(c)) {
            content.push(c);
            last = c;
            return i + 1;
        }
        if ((c === "-" || c === "+") && /[eE]/.test(last)) {
            content.push(c);
            last = c;
            return i + 1;
        }
        if (/[^\d]/.test(c)) {
            token(content.join(""));
            mode = $9e23eb38d12e497b$var$NORMAL;
            return i;
        }
        content.push(c);
        last = c;
        return i + 1;
    }
    function readtoken() {
        if (/[^\d\w_]/.test(c)) {
            var contentstr = content.join("");
            if (literalsDict[contentstr]) mode = $9e23eb38d12e497b$var$KEYWORD;
            else if (builtinsDict[contentstr]) mode = $9e23eb38d12e497b$var$BUILTIN;
            else mode = $9e23eb38d12e497b$var$IDENT;
            token(content.join(""));
            mode = $9e23eb38d12e497b$var$NORMAL;
            return i;
        }
        content.push(c);
        last = c;
        return i + 1;
    }
}

});
parcelRegister("cXK4x", function(module, exports) {
module.exports = [
    // current
    "precision",
    "highp",
    "mediump",
    "lowp",
    "attribute",
    "const",
    "uniform",
    "varying",
    "break",
    "continue",
    "do",
    "for",
    "while",
    "if",
    "else",
    "in",
    "out",
    "inout",
    "float",
    "int",
    "uint",
    "void",
    "bool",
    "true",
    "false",
    "discard",
    "return",
    "mat2",
    "mat3",
    "mat4",
    "vec2",
    "vec3",
    "vec4",
    "ivec2",
    "ivec3",
    "ivec4",
    "bvec2",
    "bvec3",
    "bvec4",
    "sampler1D",
    "sampler2D",
    "sampler3D",
    "samplerCube",
    "sampler1DShadow",
    "sampler2DShadow",
    "struct",
    "asm",
    "class",
    "union",
    "enum",
    "typedef",
    "template",
    "this",
    "packed",
    "goto",
    "switch",
    "default",
    "inline",
    "noinline",
    "volatile",
    "public",
    "static",
    "extern",
    "external",
    "interface",
    "long",
    "short",
    "double",
    "half",
    "fixed",
    "unsigned",
    "input",
    "output",
    "hvec2",
    "hvec3",
    "hvec4",
    "dvec2",
    "dvec3",
    "dvec4",
    "fvec2",
    "fvec3",
    "fvec4",
    "sampler2DRect",
    "sampler3DRect",
    "sampler2DRectShadow",
    "sizeof",
    "cast",
    "namespace",
    "using"
];

});

parcelRegister("9YvHM", function(module, exports) {
module.exports = [
    "<<=",
    ">>=",
    "++",
    "--",
    "<<",
    ">>",
    "<=",
    ">=",
    "==",
    "!=",
    "&&",
    "||",
    "+=",
    "-=",
    "*=",
    "/=",
    "%=",
    "&=",
    "^^",
    "^=",
    "|=",
    "(",
    ")",
    "[",
    "]",
    ".",
    "!",
    "~",
    "*",
    "/",
    "%",
    "+",
    "-",
    "<",
    ">",
    "&",
    "^",
    "|",
    "?",
    ":",
    "=",
    ",",
    ";",
    "{",
    "}"
];

});

parcelRegister("f8h8X", function(module, exports) {
module.exports = [
    // Keep this list sorted
    "abs",
    "acos",
    "all",
    "any",
    "asin",
    "atan",
    "ceil",
    "clamp",
    "cos",
    "cross",
    "dFdx",
    "dFdy",
    "degrees",
    "distance",
    "dot",
    "equal",
    "exp",
    "exp2",
    "faceforward",
    "floor",
    "fract",
    "gl_BackColor",
    "gl_BackLightModelProduct",
    "gl_BackLightProduct",
    "gl_BackMaterial",
    "gl_BackSecondaryColor",
    "gl_ClipPlane",
    "gl_ClipVertex",
    "gl_Color",
    "gl_DepthRange",
    "gl_DepthRangeParameters",
    "gl_EyePlaneQ",
    "gl_EyePlaneR",
    "gl_EyePlaneS",
    "gl_EyePlaneT",
    "gl_Fog",
    "gl_FogCoord",
    "gl_FogFragCoord",
    "gl_FogParameters",
    "gl_FragColor",
    "gl_FragCoord",
    "gl_FragData",
    "gl_FragDepth",
    "gl_FragDepthEXT",
    "gl_FrontColor",
    "gl_FrontFacing",
    "gl_FrontLightModelProduct",
    "gl_FrontLightProduct",
    "gl_FrontMaterial",
    "gl_FrontSecondaryColor",
    "gl_LightModel",
    "gl_LightModelParameters",
    "gl_LightModelProducts",
    "gl_LightProducts",
    "gl_LightSource",
    "gl_LightSourceParameters",
    "gl_MaterialParameters",
    "gl_MaxClipPlanes",
    "gl_MaxCombinedTextureImageUnits",
    "gl_MaxDrawBuffers",
    "gl_MaxFragmentUniformComponents",
    "gl_MaxLights",
    "gl_MaxTextureCoords",
    "gl_MaxTextureImageUnits",
    "gl_MaxTextureUnits",
    "gl_MaxVaryingFloats",
    "gl_MaxVertexAttribs",
    "gl_MaxVertexTextureImageUnits",
    "gl_MaxVertexUniformComponents",
    "gl_ModelViewMatrix",
    "gl_ModelViewMatrixInverse",
    "gl_ModelViewMatrixInverseTranspose",
    "gl_ModelViewMatrixTranspose",
    "gl_ModelViewProjectionMatrix",
    "gl_ModelViewProjectionMatrixInverse",
    "gl_ModelViewProjectionMatrixInverseTranspose",
    "gl_ModelViewProjectionMatrixTranspose",
    "gl_MultiTexCoord0",
    "gl_MultiTexCoord1",
    "gl_MultiTexCoord2",
    "gl_MultiTexCoord3",
    "gl_MultiTexCoord4",
    "gl_MultiTexCoord5",
    "gl_MultiTexCoord6",
    "gl_MultiTexCoord7",
    "gl_Normal",
    "gl_NormalMatrix",
    "gl_NormalScale",
    "gl_ObjectPlaneQ",
    "gl_ObjectPlaneR",
    "gl_ObjectPlaneS",
    "gl_ObjectPlaneT",
    "gl_Point",
    "gl_PointCoord",
    "gl_PointParameters",
    "gl_PointSize",
    "gl_Position",
    "gl_ProjectionMatrix",
    "gl_ProjectionMatrixInverse",
    "gl_ProjectionMatrixInverseTranspose",
    "gl_ProjectionMatrixTranspose",
    "gl_SecondaryColor",
    "gl_TexCoord",
    "gl_TextureEnvColor",
    "gl_TextureMatrix",
    "gl_TextureMatrixInverse",
    "gl_TextureMatrixInverseTranspose",
    "gl_TextureMatrixTranspose",
    "gl_Vertex",
    "greaterThan",
    "greaterThanEqual",
    "inversesqrt",
    "length",
    "lessThan",
    "lessThanEqual",
    "log",
    "log2",
    "matrixCompMult",
    "max",
    "min",
    "mix",
    "mod",
    "normalize",
    "not",
    "notEqual",
    "pow",
    "radians",
    "reflect",
    "refract",
    "sign",
    "sin",
    "smoothstep",
    "sqrt",
    "step",
    "tan",
    "texture2D",
    "texture2DLod",
    "texture2DProj",
    "texture2DProjLod",
    "textureCube",
    "textureCubeLod",
    "texture2DLodEXT",
    "texture2DProjLodEXT",
    "textureCubeLodEXT",
    "texture2DGradEXT",
    "texture2DProjGradEXT",
    "textureCubeGradEXT"
];

});

parcelRegister("gNfDV", function(module, exports) {

var $cXK4x = parcelRequire("cXK4x");
module.exports = $cXK4x.slice().concat([
    "layout",
    "centroid",
    "smooth",
    "case",
    "mat2x2",
    "mat2x3",
    "mat2x4",
    "mat3x2",
    "mat3x3",
    "mat3x4",
    "mat4x2",
    "mat4x3",
    "mat4x4",
    "uvec2",
    "uvec3",
    "uvec4",
    "samplerCubeShadow",
    "sampler2DArray",
    "sampler2DArrayShadow",
    "isampler2D",
    "isampler3D",
    "isamplerCube",
    "isampler2DArray",
    "usampler2D",
    "usampler3D",
    "usamplerCube",
    "usampler2DArray",
    "coherent",
    "restrict",
    "readonly",
    "writeonly",
    "resource",
    "atomic_uint",
    "noperspective",
    "patch",
    "sample",
    "subroutine",
    "common",
    "partition",
    "active",
    "filter",
    "image1D",
    "image2D",
    "image3D",
    "imageCube",
    "iimage1D",
    "iimage2D",
    "iimage3D",
    "iimageCube",
    "uimage1D",
    "uimage2D",
    "uimage3D",
    "uimageCube",
    "image1DArray",
    "image2DArray",
    "iimage1DArray",
    "iimage2DArray",
    "uimage1DArray",
    "uimage2DArray",
    "image1DShadow",
    "image2DShadow",
    "image1DArrayShadow",
    "image2DArrayShadow",
    "imageBuffer",
    "iimageBuffer",
    "uimageBuffer",
    "sampler1DArray",
    "sampler1DArrayShadow",
    "isampler1D",
    "isampler1DArray",
    "usampler1D",
    "usampler1DArray",
    "isampler2DRect",
    "usampler2DRect",
    "samplerBuffer",
    "isamplerBuffer",
    "usamplerBuffer",
    "sampler2DMS",
    "isampler2DMS",
    "usampler2DMS",
    "sampler2DMSArray",
    "isampler2DMSArray",
    "usampler2DMSArray"
]);

});

parcelRegister("d6iZA", function(module, exports) {
// 300es builtins/reserved words that were previously valid in v100

var $f8h8X = parcelRequire("f8h8X");
var $989a916069b8dbd6$require$v100 = $f8h8X;
// The texture2D|Cube functions have been removed
// And the gl_ features are updated
$989a916069b8dbd6$require$v100 = $989a916069b8dbd6$require$v100.slice().filter(function(b) {
    return !/^(gl\_|texture)/.test(b);
});
module.exports = $989a916069b8dbd6$require$v100.concat([
    // the updated gl_ constants
    "gl_VertexID",
    "gl_InstanceID",
    "gl_Position",
    "gl_PointSize",
    "gl_FragCoord",
    "gl_FrontFacing",
    "gl_FragDepth",
    "gl_PointCoord",
    "gl_MaxVertexAttribs",
    "gl_MaxVertexUniformVectors",
    "gl_MaxVertexOutputVectors",
    "gl_MaxFragmentInputVectors",
    "gl_MaxVertexTextureImageUnits",
    "gl_MaxCombinedTextureImageUnits",
    "gl_MaxTextureImageUnits",
    "gl_MaxFragmentUniformVectors",
    "gl_MaxDrawBuffers",
    "gl_MinProgramTexelOffset",
    "gl_MaxProgramTexelOffset",
    "gl_DepthRangeParameters",
    "gl_DepthRange",
    "trunc",
    "round",
    "roundEven",
    "isnan",
    "isinf",
    "floatBitsToInt",
    "floatBitsToUint",
    "intBitsToFloat",
    "uintBitsToFloat",
    "packSnorm2x16",
    "unpackSnorm2x16",
    "packUnorm2x16",
    "unpackUnorm2x16",
    "packHalf2x16",
    "unpackHalf2x16",
    "outerProduct",
    "transpose",
    "determinant",
    "inverse",
    "texture",
    "textureSize",
    "textureProj",
    "textureLod",
    "textureOffset",
    "texelFetch",
    "texelFetchOffset",
    "textureProjOffset",
    "textureLodOffset",
    "textureProjLod",
    "textureProjLodOffset",
    "textureGrad",
    "textureGradOffset",
    "textureProjGrad",
    "textureProjGradOffset"
]);

});



parcelRegister("eBltz", function(module, exports) {
module.exports = $aa152e14d36b290c$var$toString;
function $aa152e14d36b290c$var$toString(tokens) {
    var output = [];
    for(var i = 0; i < tokens.length; i++){
        if (tokens[i].type === "eof") continue;
        output.push(tokens[i].data);
    }
    return output.join("");
}

});

parcelRegister("iNOaC", function(module, exports) {
module.exports = $db03b85ec03e9e00$var$functions;
function $db03b85ec03e9e00$var$functions(tokens) {
    var returnType = null;
    var defnName = null;
    var braceDepth = 0;
    var braceStart = 0;
    var defnStart = 0;
    var argFinish = 0;
    var argStart = 0;
    var output = [];
    var i, j, token;
    // The following loop detects functions with bodies of any type,
    // including structs. e.g.
    // void main() {...}
    // vec4 fn(vec3 a) {...}
    // Ray3 fn(vec3 ro, vec3 rd) {...}
    for(i = 0, j; i < tokens.length; i++){
        token = tokens[i];
        if (token.data === "{") {
            // If already in a function, keep track of opening braces
            if (braceDepth && braceDepth++) continue;
            // Stepping backwards from the closing brace, find the end
            // of the arguments list. There should only be whitespace on
            // the way there.
            j = findPrevious(i, $db03b85ec03e9e00$var$findOp(")"), $db03b85ec03e9e00$var$findOp());
            if (j < 0) continue;
            argFinish = j;
            // Step backwards to find the beginning of the arguments list. If there's
            // a nested paranthesis in there, then it's definitely not a function.
            j = findPrevious(j, $db03b85ec03e9e00$var$findOp("("), $db03b85ec03e9e00$var$findOp(")"));
            if (j < 0) continue;
            argStart = j;
            // Continue stepping backwards past any whitespace to find the
            // function name. If the token isn't an identifier then it's not a
            // function so we bail
            j = findPrevious(j, $db03b85ec03e9e00$var$findGlyph);
            if (j < 0) continue;
            if (tokens[j].type !== "ident") continue;
            defnName = tokens[j].data;
            // The next non-whitespace token should be the return type of
            // the function
            j = findPrevious(j, $db03b85ec03e9e00$var$findGlyph);
            if (j < 0) continue;
            braceDepth = 1;
            braceStart = i;
            returnType = tokens[j].data;
            defnStart = j;
            // There are cases when a function definition includes a
            // precision qualifier, e.g. highp float random();
            // So we backtrack one extra step to check if that's the
            // case, and handle it :)
            var k = findPrevious(j, $db03b85ec03e9e00$var$findGlyph);
            switch(tokens[k] && tokens[k].data){
                case "lowp":
                case "highp":
                case "mediump":
                    defnStart = k;
            }
        } else if (braceDepth && token.data === "}") {
            if (--braceDepth) continue;
            output.push({
                name: defnName,
                type: returnType,
                body: [
                    braceStart + 1,
                    i
                ],
                args: [
                    argStart,
                    argFinish + 1
                ],
                outer: [
                    defnStart,
                    i + 1
                ]
            });
        }
    }
    // This loop is for handling the edge case of functions defined
    // without a body. Generally, this body is defined later in the file.
    // void main();
    // vec2 doModel(vec3 p);
    // Note the replacement of curly braces with a semicolon.
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        if (token.data === ";") {
            // Like before, we start from a semicolon and find the
            // bounds of the argument list to find the function name
            j = findPrevious(i, $db03b85ec03e9e00$var$findOp(")"), $db03b85ec03e9e00$var$findOp());
            if (j < 0) continue;
            argFinish = j;
            j = findPrevious(j, $db03b85ec03e9e00$var$findOp("("), $db03b85ec03e9e00$var$findOp(")"));
            if (j < 0) continue;
            argStart = j;
            j = findPrevious(j, $db03b85ec03e9e00$var$findGlyph);
            if (j < 0) continue;
            if (tokens[j].type !== "ident") continue;
            defnName = tokens[j].data;
            // Try and find an ident or builtin character, which should be
            // our return type. If so, it'll be the very first preceding glyph.
            j = findPrevious(j, $db03b85ec03e9e00$var$findGlyph);
            if (j < 0) continue;
            if (tokens[j].type === "operator") continue;
            if (tokens[j].data === "return") continue;
            returnType = tokens[j].data;
            output.push({
                name: defnName,
                type: returnType,
                body: false,
                args: [
                    argStart,
                    argFinish + 1
                ],
                outer: [
                    j,
                    i + 1
                ]
            });
        }
    }
    return output.sort(function(a, b) {
        return a.outer[0] - b.outer[0];
    });
    function findPrevious(start, match, bail) {
        for(var i = start - 1; i >= 0; i--){
            if (match(tokens[i])) return i;
            if (bail && bail(tokens[i])) return -1;
        }
        return -1;
    }
}
function $db03b85ec03e9e00$var$findOp(data) {
    return function(token) {
        return token.type === "operator" && (!data || token.data === data);
    };
}
function $db03b85ec03e9e00$var$findGlyph(token) {
    return token.type !== "whitespace";
}

});



parcelRegister("arjYd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4XgWo").then(()=>parcelRequire("4dDVm"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


//https://threejs.org/docs/index.html?q=interleaved#api/en/core/InterleavedBuffer
/*
observer objects -> unobserve
*/ 
var $ilwiq = parcelRequire("ilwiq");
// Ported from Stefan Gustavson's java implementation
// http://staffwww.itn.liu.se/~stegu/simplexnoise/simplexnoise.pdf
// Read Stefan's excellent paper for details on how this code works.
//
// Sean McCullough banksean@gmail.com
//
// Added 4D noise
/**
 * You can pass in a random number generator object if you like.
 * It is assumed to have a random() method.
 */ class $d6d8d9f9c79a2dae$export$7cef8d54b4fb09be {
    constructor(r = Math){
        this.grad3 = [
            [
                1,
                1,
                0
            ],
            [
                -1,
                1,
                0
            ],
            [
                1,
                -1,
                0
            ],
            [
                -1,
                -1,
                0
            ],
            [
                1,
                0,
                1
            ],
            [
                -1,
                0,
                1
            ],
            [
                1,
                0,
                -1
            ],
            [
                -1,
                0,
                -1
            ],
            [
                0,
                1,
                1
            ],
            [
                0,
                -1,
                1
            ],
            [
                0,
                1,
                -1
            ],
            [
                0,
                -1,
                -1
            ]
        ];
        this.grad4 = [
            [
                0,
                1,
                1,
                1
            ],
            [
                0,
                1,
                1,
                -1
            ],
            [
                0,
                1,
                -1,
                1
            ],
            [
                0,
                1,
                -1,
                -1
            ],
            [
                0,
                -1,
                1,
                1
            ],
            [
                0,
                -1,
                1,
                -1
            ],
            [
                0,
                -1,
                -1,
                1
            ],
            [
                0,
                -1,
                -1,
                -1
            ],
            [
                1,
                0,
                1,
                1
            ],
            [
                1,
                0,
                1,
                -1
            ],
            [
                1,
                0,
                -1,
                1
            ],
            [
                1,
                0,
                -1,
                -1
            ],
            [
                -1,
                0,
                1,
                1
            ],
            [
                -1,
                0,
                1,
                -1
            ],
            [
                -1,
                0,
                -1,
                1
            ],
            [
                -1,
                0,
                -1,
                -1
            ],
            [
                1,
                1,
                0,
                1
            ],
            [
                1,
                1,
                0,
                -1
            ],
            [
                1,
                -1,
                0,
                1
            ],
            [
                1,
                -1,
                0,
                -1
            ],
            [
                -1,
                1,
                0,
                1
            ],
            [
                -1,
                1,
                0,
                -1
            ],
            [
                -1,
                -1,
                0,
                1
            ],
            [
                -1,
                -1,
                0,
                -1
            ],
            [
                1,
                1,
                1,
                0
            ],
            [
                1,
                1,
                -1,
                0
            ],
            [
                1,
                -1,
                1,
                0
            ],
            [
                1,
                -1,
                -1,
                0
            ],
            [
                -1,
                1,
                1,
                0
            ],
            [
                -1,
                1,
                -1,
                0
            ],
            [
                -1,
                -1,
                1,
                0
            ],
            [
                -1,
                -1,
                -1,
                0
            ]
        ];
        this.p = [];
        for(let i = 0; i < 256; i++)this.p[i] = Math.floor(r.random() * 256);
        // To remove the need for index wrapping, double the permutation table length
        this.perm = [];
        for(let i = 0; i < 512; i++)this.perm[i] = this.p[i & 255];
        // A lookup table to traverse the simplex around a given point in 4D.
        // Details can be found where this table is used, in the 4D noise method.
        this.simplex = [
            [
                0,
                1,
                2,
                3
            ],
            [
                0,
                1,
                3,
                2
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                2,
                3,
                1
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                1,
                2,
                3,
                0
            ],
            [
                0,
                2,
                1,
                3
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                3,
                1,
                2
            ],
            [
                0,
                3,
                2,
                1
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                1,
                3,
                2,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                1,
                2,
                0,
                3
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                1,
                3,
                0,
                2
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                2,
                3,
                0,
                1
            ],
            [
                2,
                3,
                1,
                0
            ],
            [
                1,
                0,
                2,
                3
            ],
            [
                1,
                0,
                3,
                2
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                2,
                0,
                3,
                1
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                2,
                1,
                3,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                2,
                0,
                1,
                3
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                3,
                0,
                1,
                2
            ],
            [
                3,
                0,
                2,
                1
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                3,
                1,
                2,
                0
            ],
            [
                2,
                1,
                0,
                3
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                3,
                1,
                0,
                2
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                3,
                2,
                0,
                1
            ],
            [
                3,
                2,
                1,
                0
            ]
        ];
    }
    dot(g, x, y) {
        return g[0] * x + g[1] * y;
    }
    dot3(g, x, y, z) {
        return g[0] * x + g[1] * y + g[2] * z;
    }
    dot4(g, x, y, z, w) {
        return g[0] * x + g[1] * y + g[2] * z + g[3] * w;
    }
    noise(xin, yin) {
        let n0; // Noise contributions from the three corners
        let n1;
        let n2;
        // Skew the input space to determine which simplex cell we're in
        const F2 = 0.5 * (Math.sqrt(3.0) - 1.0);
        const s = (xin + yin) * F2; // Hairy factor for 2D
        const i = Math.floor(xin + s);
        const j = Math.floor(yin + s);
        const G2 = (3.0 - Math.sqrt(3.0)) / 6.0;
        const t = (i + j) * G2;
        const X0 = i - t; // Unskew the cell origin back to (x,y) space
        const Y0 = j - t;
        const x0 = xin - X0; // The x,y distances from the cell origin
        const y0 = yin - Y0;
        // For the 2D case, the simplex shape is an equilateral triangle.
        // Determine which simplex we are in.
        let i1; // Offsets for second (middle) corner of simplex in (i,j) coords
        let j1;
        if (x0 > y0) {
            i1 = 1;
            j1 = 0;
        // lower triangle, XY order: (0,0)->(1,0)->(1,1)
        } else {
            i1 = 0;
            j1 = 1;
        } // upper triangle, YX order: (0,0)->(0,1)->(1,1)
        // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
        // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
        // c = (3-sqrt(3))/6
        const x1 = x0 - i1 + G2; // Offsets for middle corner in (x,y) unskewed coords
        const y1 = y0 - j1 + G2;
        const x2 = x0 - 1.0 + 2.0 * G2; // Offsets for last corner in (x,y) unskewed coords
        const y2 = y0 - 1.0 + 2.0 * G2;
        // Work out the hashed gradient indices of the three simplex corners
        const ii = i & 255;
        const jj = j & 255;
        const gi0 = this.perm[ii + this.perm[jj]] % 12;
        const gi1 = this.perm[ii + i1 + this.perm[jj + j1]] % 12;
        const gi2 = this.perm[ii + 1 + this.perm[jj + 1]] % 12;
        // Calculate the contribution from the three corners
        let t0 = 0.5 - x0 * x0 - y0 * y0;
        if (t0 < 0) n0 = 0.0;
        else {
            t0 *= t0;
            n0 = t0 * t0 * this.dot(this.grad3[gi0], x0, y0); // (x,y) of grad3 used for 2D gradient
        }
        let t1 = 0.5 - x1 * x1 - y1 * y1;
        if (t1 < 0) n1 = 0.0;
        else {
            t1 *= t1;
            n1 = t1 * t1 * this.dot(this.grad3[gi1], x1, y1);
        }
        let t2 = 0.5 - x2 * x2 - y2 * y2;
        if (t2 < 0) n2 = 0.0;
        else {
            t2 *= t2;
            n2 = t2 * t2 * this.dot(this.grad3[gi2], x2, y2);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to return values in the interval [-1,1].
        return 70.0 * (n0 + n1 + n2);
    }
    // 3D simplex noise
    noise3d(xin, yin, zin) {
        let n0; // Noise contributions from the four corners
        let n1;
        let n2;
        let n3;
        // Skew the input space to determine which simplex cell we're in
        const F3 = 1.0 / 3.0;
        const s = (xin + yin + zin) * F3; // Very nice and simple skew factor for 3D
        const i = Math.floor(xin + s);
        const j = Math.floor(yin + s);
        const k = Math.floor(zin + s);
        const G3 = 1.0 / 6.0; // Very nice and simple unskew factor, too
        const t = (i + j + k) * G3;
        const X0 = i - t; // Unskew the cell origin back to (x,y,z) space
        const Y0 = j - t;
        const Z0 = k - t;
        const x0 = xin - X0; // The x,y,z distances from the cell origin
        const y0 = yin - Y0;
        const z0 = zin - Z0;
        // For the 3D case, the simplex shape is a slightly irregular tetrahedron.
        // Determine which simplex we are in.
        let i1; // Offsets for second corner of simplex in (i,j,k) coords
        let j1;
        let k1;
        let i2; // Offsets for third corner of simplex in (i,j,k) coords
        let j2;
        let k2;
        if (x0 >= y0) {
            if (y0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            // X Y Z order
            } else if (x0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            // X Z Y order
            } else {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            } // Z X Y order
        } else {
            if (y0 < z0) {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            // Z Y X order
            } else if (x0 < z0) {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            // Y Z X order
            } else {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            } // Y X Z order
        }
        // A step of (1,0,0) in (i,j,k) means a step of (1-c,-c,-c) in (x,y,z),
        // a step of (0,1,0) in (i,j,k) means a step of (-c,1-c,-c) in (x,y,z), and
        // a step of (0,0,1) in (i,j,k) means a step of (-c,-c,1-c) in (x,y,z), where
        // c = 1/6.
        const x1 = x0 - i1 + G3; // Offsets for second corner in (x,y,z) coords
        const y1 = y0 - j1 + G3;
        const z1 = z0 - k1 + G3;
        const x2 = x0 - i2 + 2.0 * G3; // Offsets for third corner in (x,y,z) coords
        const y2 = y0 - j2 + 2.0 * G3;
        const z2 = z0 - k2 + 2.0 * G3;
        const x3 = x0 - 1.0 + 3.0 * G3; // Offsets for last corner in (x,y,z) coords
        const y3 = y0 - 1.0 + 3.0 * G3;
        const z3 = z0 - 1.0 + 3.0 * G3;
        // Work out the hashed gradient indices of the four simplex corners
        const ii = i & 255;
        const jj = j & 255;
        const kk = k & 255;
        const gi0 = this.perm[ii + this.perm[jj + this.perm[kk]]] % 12;
        const gi1 = this.perm[ii + i1 + this.perm[jj + j1 + this.perm[kk + k1]]] % 12;
        const gi2 = this.perm[ii + i2 + this.perm[jj + j2 + this.perm[kk + k2]]] % 12;
        const gi3 = this.perm[ii + 1 + this.perm[jj + 1 + this.perm[kk + 1]]] % 12;
        // Calculate the contribution from the four corners
        let t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0;
        if (t0 < 0) n0 = 0.0;
        else {
            t0 *= t0;
            n0 = t0 * t0 * this.dot3(this.grad3[gi0], x0, y0, z0);
        }
        let t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1;
        if (t1 < 0) n1 = 0.0;
        else {
            t1 *= t1;
            n1 = t1 * t1 * this.dot3(this.grad3[gi1], x1, y1, z1);
        }
        let t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2;
        if (t2 < 0) n2 = 0.0;
        else {
            t2 *= t2;
            n2 = t2 * t2 * this.dot3(this.grad3[gi2], x2, y2, z2);
        }
        let t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3;
        if (t3 < 0) n3 = 0.0;
        else {
            t3 *= t3;
            n3 = t3 * t3 * this.dot3(this.grad3[gi3], x3, y3, z3);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to stay just inside [-1,1]
        return 32.0 * (n0 + n1 + n2 + n3);
    }
    // 4D simplex noise
    noise4d(x, y, z, w) {
        // For faster and easier lookups
        const grad4 = this.grad4;
        const simplex = this.simplex;
        const perm = this.perm;
        // The skewing and unskewing factors are hairy again for the 4D case
        const F4 = (Math.sqrt(5.0) - 1.0) / 4.0;
        const G4 = (5.0 - Math.sqrt(5.0)) / 20.0;
        let n0; // Noise contributions from the five corners
        let n1;
        let n2;
        let n3;
        let n4;
        // Skew the (x,y,z,w) space to determine which cell of 24 simplices we're in
        const s = (x + y + z + w) * F4; // Factor for 4D skewing
        const i = Math.floor(x + s);
        const j = Math.floor(y + s);
        const k = Math.floor(z + s);
        const l = Math.floor(w + s);
        const t = (i + j + k + l) * G4; // Factor for 4D unskewing
        const X0 = i - t; // Unskew the cell origin back to (x,y,z,w) space
        const Y0 = j - t;
        const Z0 = k - t;
        const W0 = l - t;
        const x0 = x - X0; // The x,y,z,w distances from the cell origin
        const y0 = y - Y0;
        const z0 = z - Z0;
        const w0 = w - W0;
        // For the 4D case, the simplex is a 4D shape I won't even try to describe.
        // To find out which of the 24 possible simplices we're in, we need to
        // determine the magnitude ordering of x0, y0, z0 and w0.
        // The method below is a good way of finding the ordering of x,y,z,w and
        // then find the correct traversal order for the simplex we’re in.
        // First, six pair-wise comparisons are performed between each possible pair
        // of the four coordinates, and the results are used to add up binary bits
        // for an integer index.
        const c1 = x0 > y0 ? 32 : 0;
        const c2 = x0 > z0 ? 16 : 0;
        const c3 = y0 > z0 ? 8 : 0;
        const c4 = x0 > w0 ? 4 : 0;
        const c5 = y0 > w0 ? 2 : 0;
        const c6 = z0 > w0 ? 1 : 0;
        const c = c1 + c2 + c3 + c4 + c5 + c6;
        // simplex[c] is a 4-vector with the numbers 0, 1, 2 and 3 in some order.
        // Many values of c will never occur, since e.g. x>y>z>w makes x<z, y<w and x<w
        // impossible. Only the 24 indices which have non-zero entries make any sense.
        // We use a thresholding to set the coordinates in turn from the largest magnitude.
        // The number 3 in the "simplex" array is at the position of the largest coordinate.
        const i1 = simplex[c][0] >= 3 ? 1 : 0;
        const j1 = simplex[c][1] >= 3 ? 1 : 0;
        const k1 = simplex[c][2] >= 3 ? 1 : 0;
        const l1 = simplex[c][3] >= 3 ? 1 : 0;
        // The number 2 in the "simplex" array is at the second largest coordinate.
        const i2 = simplex[c][0] >= 2 ? 1 : 0;
        const j2 = simplex[c][1] >= 2 ? 1 : 0;
        const k2 = simplex[c][2] >= 2 ? 1 : 0;
        const l2 = simplex[c][3] >= 2 ? 1 : 0;
        // The number 1 in the "simplex" array is at the second smallest coordinate.
        const i3 = simplex[c][0] >= 1 ? 1 : 0;
        const j3 = simplex[c][1] >= 1 ? 1 : 0;
        const k3 = simplex[c][2] >= 1 ? 1 : 0;
        const l3 = simplex[c][3] >= 1 ? 1 : 0;
        // The fifth corner has all coordinate offsets = 1, so no need to look that up.
        const x1 = x0 - i1 + G4; // Offsets for second corner in (x,y,z,w) coords
        const y1 = y0 - j1 + G4;
        const z1 = z0 - k1 + G4;
        const w1 = w0 - l1 + G4;
        const x2 = x0 - i2 + 2.0 * G4; // Offsets for third corner in (x,y,z,w) coords
        const y2 = y0 - j2 + 2.0 * G4;
        const z2 = z0 - k2 + 2.0 * G4;
        const w2 = w0 - l2 + 2.0 * G4;
        const x3 = x0 - i3 + 3.0 * G4; // Offsets for fourth corner in (x,y,z,w) coords
        const y3 = y0 - j3 + 3.0 * G4;
        const z3 = z0 - k3 + 3.0 * G4;
        const w3 = w0 - l3 + 3.0 * G4;
        const x4 = x0 - 1.0 + 4.0 * G4; // Offsets for last corner in (x,y,z,w) coords
        const y4 = y0 - 1.0 + 4.0 * G4;
        const z4 = z0 - 1.0 + 4.0 * G4;
        const w4 = w0 - 1.0 + 4.0 * G4;
        // Work out the hashed gradient indices of the five simplex corners
        const ii = i & 255;
        const jj = j & 255;
        const kk = k & 255;
        const ll = l & 255;
        const gi0 = perm[ii + perm[jj + perm[kk + perm[ll]]]] % 32;
        const gi1 = perm[ii + i1 + perm[jj + j1 + perm[kk + k1 + perm[ll + l1]]]] % 32;
        const gi2 = perm[ii + i2 + perm[jj + j2 + perm[kk + k2 + perm[ll + l2]]]] % 32;
        const gi3 = perm[ii + i3 + perm[jj + j3 + perm[kk + k3 + perm[ll + l3]]]] % 32;
        const gi4 = perm[ii + 1 + perm[jj + 1 + perm[kk + 1 + perm[ll + 1]]]] % 32;
        // Calculate the contribution from the five corners
        let t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0 - w0 * w0;
        if (t0 < 0) n0 = 0.0;
        else {
            t0 *= t0;
            n0 = t0 * t0 * this.dot4(grad4[gi0], x0, y0, z0, w0);
        }
        let t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1 - w1 * w1;
        if (t1 < 0) n1 = 0.0;
        else {
            t1 *= t1;
            n1 = t1 * t1 * this.dot4(grad4[gi1], x1, y1, z1, w1);
        }
        let t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2 - w2 * w2;
        if (t2 < 0) n2 = 0.0;
        else {
            t2 *= t2;
            n2 = t2 * t2 * this.dot4(grad4[gi2], x2, y2, z2, w2);
        }
        let t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3 - w3 * w3;
        if (t3 < 0) n3 = 0.0;
        else {
            t3 *= t3;
            n3 = t3 * t3 * this.dot4(grad4[gi3], x3, y3, z3, w3);
        }
        let t4 = 0.6 - x4 * x4 - y4 * y4 - z4 * z4 - w4 * w4;
        if (t4 < 0) n4 = 0.0;
        else {
            t4 *= t4;
            n4 = t4 * t4 * this.dot4(grad4[gi4], x4, y4, z4, w4);
        }
        // Sum up and scale the result to cover the range [-1,1]
        return 27.0 * (n0 + n1 + n2 + n3 + n4);
    }
}


function $320c956a09dd2394$export$d22a027dada4117a(seed) {
    return function() {
        let t = seed += 0x6D2B79F5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
const $320c956a09dd2394$export$aa58db76305f526b = 12345;
const $320c956a09dd2394$export$9f2c7e6bad203cfb = 400;
const $320c956a09dd2394$export$fee4d1b248547f9c = 12.5;
const $320c956a09dd2394$export$6c609f2df545563 = -0.2;
const $320c956a09dd2394$export$7344b5df02c9387c = [
    {
        x: 1200,
        z: 950,
        size: 250
    },
    {
        x: 385,
        z: -300,
        size: 120
    }
];
// ============ SHARED SIMPLEX INSTANCE ============
// SimplexNoise expects an object with .random() method (like Math)
const $320c956a09dd2394$var$seededRandom = {
    random: $320c956a09dd2394$export$d22a027dada4117a($320c956a09dd2394$export$aa58db76305f526b)
};
const $320c956a09dd2394$export$cdff0fdd5b0f2742 = new (0, $d6d8d9f9c79a2dae$export$7cef8d54b4fb09be)($320c956a09dd2394$var$seededRandom);
function $320c956a09dd2394$export$4053e36566dd3d9a(edge0, edge1, x) {
    let t = Math.max(0, Math.min(1, (x - edge0) / (edge1 - edge0)));
    return t * t * (3 - 2 * t);
}
function $320c956a09dd2394$export$c08559766941f856(x, z) {
    let roughTerrain = $320c956a09dd2394$export$fee4d1b248547f9c * $320c956a09dd2394$export$cdff0fdd5b0f2742.noise(x / $320c956a09dd2394$export$9f2c7e6bad203cfb, z / $320c956a09dd2394$export$9f2c7e6bad203cfb);
    let smoothTerrain = 0.0;
    let blendFactor = 1;
    for (let area of $320c956a09dd2394$export$7344b5df02c9387c){
        let distanceX = Math.abs(x - area.x);
        let distanceZ = Math.abs(z - area.z);
        let transitionSize = area.size * 0.25;
        let factorX = $320c956a09dd2394$export$4053e36566dd3d9a(area.size - transitionSize, area.size + transitionSize, distanceX);
        let factorZ = $320c956a09dd2394$export$4053e36566dd3d9a(area.size - transitionSize, area.size + transitionSize, distanceZ);
        let areaBlend = Math.min(factorX, factorZ);
        blendFactor = Math.min(blendFactor, areaBlend);
    }
    return roughTerrain * blendFactor + smoothTerrain * (1 - blendFactor);
}



var $ilwiq = parcelRequire("ilwiq");
// Split strategy constants
const $78926744db4a8a3e$export$91c2158bc24c63d4 = 0;
const $78926744db4a8a3e$export$d3bfe4097a2a8542 = 1;
const $78926744db4a8a3e$export$2b2cc3fb4f03d723 = 2;
const $78926744db4a8a3e$export$34b5498ca69d033 = 0;
const $78926744db4a8a3e$export$a26e00882057cd76 = 1;
const $78926744db4a8a3e$export$82ad94f0a038b67a = 2;
const $78926744db4a8a3e$export$22e1995328fd3cd9 = 1.25;
const $78926744db4a8a3e$export$f4b101accf1b23d1 = 1;
const $78926744db4a8a3e$export$a08e7d18fbc53be5 = 32;
const $78926744db4a8a3e$export$661fddb62bfe0e42 = 0xFFFF;
const $78926744db4a8a3e$export$859129fb5c8f4dc1 = Math.pow(2, -24);
const $78926744db4a8a3e$export$abef70518a11a6ba = Symbol("SKIP_GENERATION");



var $ilwiq = parcelRequire("ilwiq");
function $423096e95cd96e19$export$bb010cc24ecaa644(geo) {
    return geo.index ? geo.index.count : geo.attributes.position.count;
}
function $423096e95cd96e19$export$c56c51fae37b2d63(geo) {
    return $423096e95cd96e19$export$bb010cc24ecaa644(geo) / 3;
}
function $423096e95cd96e19$export$62808f0201824da2(vertexCount, BufferConstructor = ArrayBuffer) {
    if (vertexCount > 65535) return new Uint32Array(new BufferConstructor(4 * vertexCount));
    else return new Uint16Array(new BufferConstructor(2 * vertexCount));
}
function $423096e95cd96e19$export$90fd303420808ebb(geo, options) {
    if (!geo.index) {
        const vertexCount = geo.attributes.position.count;
        const BufferConstructor = options.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
        const index = $423096e95cd96e19$export$62808f0201824da2(vertexCount, BufferConstructor);
        geo.setIndex(new (0, $ilwiq.BufferAttribute)(index, 1));
        for(let i = 0; i < vertexCount; i++)index[i] = i;
    }
}
function $423096e95cd96e19$export$8c9d42783264c26e(geo, range) {
    const triCount = $423096e95cd96e19$export$c56c51fae37b2d63(geo);
    const drawRange = range ? range : geo.drawRange;
    const start = drawRange.start / 3;
    const end = (drawRange.start + drawRange.count) / 3;
    const offset = Math.max(0, start);
    const count = Math.min(triCount, end) - offset;
    return [
        {
            offset: Math.floor(offset),
            count: Math.floor(count)
        }
    ];
}
function $423096e95cd96e19$export$fd7a16c461f5043c(geo, range) {
    if (!geo.groups || !geo.groups.length) return $423096e95cd96e19$export$8c9d42783264c26e(geo, range);
    const ranges = [];
    const rangeBoundaries = new Set();
    const drawRange = range ? range : geo.drawRange;
    const drawRangeStart = drawRange.start / 3;
    const drawRangeEnd = (drawRange.start + drawRange.count) / 3;
    for (const group of geo.groups){
        const groupStart = group.start / 3;
        const groupEnd = (group.start + group.count) / 3;
        rangeBoundaries.add(Math.max(drawRangeStart, groupStart));
        rangeBoundaries.add(Math.min(drawRangeEnd, groupEnd));
    }
    // note that if you don't pass in a comparator, it sorts them lexicographically as strings :-(
    const sortedBoundaries = Array.from(rangeBoundaries.values()).sort((a, b)=>a - b);
    for(let i = 0; i < sortedBoundaries.length - 1; i++){
        const start = sortedBoundaries[i];
        const end = sortedBoundaries[i + 1];
        ranges.push({
            offset: Math.floor(start),
            count: Math.floor(end - start)
        });
    }
    return ranges;
}
function $423096e95cd96e19$export$d3cf4eabab21775d(geometry, range) {
    const vertexCount = $423096e95cd96e19$export$c56c51fae37b2d63(geometry);
    const groups = $423096e95cd96e19$export$fd7a16c461f5043c(geometry, range).sort((a, b)=>a.offset - b.offset);
    const finalGroup = groups[groups.length - 1];
    finalGroup.count = Math.min(vertexCount - finalGroup.offset, finalGroup.count);
    let total = 0;
    groups.forEach(({ count: count })=>total += count);
    return vertexCount !== total;
}




function $4ca55de292e93eb1$export$becd1e645219fa23(triangleBounds, offset, count, target, centroidTarget) {
    let minx = Infinity;
    let miny = Infinity;
    let minz = Infinity;
    let maxx = -Infinity;
    let maxy = -Infinity;
    let maxz = -Infinity;
    let cminx = Infinity;
    let cminy = Infinity;
    let cminz = Infinity;
    let cmaxx = -Infinity;
    let cmaxy = -Infinity;
    let cmaxz = -Infinity;
    for(let i = offset * 6, end = (offset + count) * 6; i < end; i += 6){
        const cx = triangleBounds[i + 0];
        const hx = triangleBounds[i + 1];
        const lx = cx - hx;
        const rx = cx + hx;
        if (lx < minx) minx = lx;
        if (rx > maxx) maxx = rx;
        if (cx < cminx) cminx = cx;
        if (cx > cmaxx) cmaxx = cx;
        const cy = triangleBounds[i + 2];
        const hy = triangleBounds[i + 3];
        const ly = cy - hy;
        const ry = cy + hy;
        if (ly < miny) miny = ly;
        if (ry > maxy) maxy = ry;
        if (cy < cminy) cminy = cy;
        if (cy > cmaxy) cmaxy = cy;
        const cz = triangleBounds[i + 4];
        const hz = triangleBounds[i + 5];
        const lz = cz - hz;
        const rz = cz + hz;
        if (lz < minz) minz = lz;
        if (rz > maxz) maxz = rz;
        if (cz < cminz) cminz = cz;
        if (cz > cmaxz) cmaxz = cz;
    }
    target[0] = minx;
    target[1] = miny;
    target[2] = minz;
    target[3] = maxx;
    target[4] = maxy;
    target[5] = maxz;
    centroidTarget[0] = cminx;
    centroidTarget[1] = cminy;
    centroidTarget[2] = cminz;
    centroidTarget[3] = cmaxx;
    centroidTarget[4] = cmaxy;
    centroidTarget[5] = cmaxz;
}
function $4ca55de292e93eb1$export$b3cc4d5d5179e78c(geo, target = null, offset = null, count = null) {
    const posAttr = geo.attributes.position;
    const index = geo.index ? geo.index.array : null;
    const triCount = (0, $423096e95cd96e19$export$c56c51fae37b2d63)(geo);
    const normalized = posAttr.normalized;
    let triangleBounds;
    if (target === null) {
        triangleBounds = new Float32Array(triCount * 6);
        offset = 0;
        count = triCount;
    } else {
        triangleBounds = target;
        offset = offset || 0;
        count = count || triCount;
    }
    // used for non-normalized positions
    const posArr = posAttr.array;
    // support for an interleaved position buffer
    const bufferOffset = posAttr.offset || 0;
    let stride = 3;
    if (posAttr.isInterleavedBufferAttribute) stride = posAttr.data.stride;
    // used for normalized positions
    const getters = [
        "getX",
        "getY",
        "getZ"
    ];
    for(let tri = offset; tri < offset + count; tri++){
        const tri3 = tri * 3;
        const tri6 = tri * 6;
        let ai = tri3 + 0;
        let bi = tri3 + 1;
        let ci = tri3 + 2;
        if (index) {
            ai = index[ai];
            bi = index[bi];
            ci = index[ci];
        }
        // we add the stride and offset here since we access the array directly
        // below for the sake of performance
        if (!normalized) {
            ai = ai * stride + bufferOffset;
            bi = bi * stride + bufferOffset;
            ci = ci * stride + bufferOffset;
        }
        for(let el = 0; el < 3; el++){
            let a, b, c;
            if (normalized) {
                a = posAttr[getters[el]](ai);
                b = posAttr[getters[el]](bi);
                c = posAttr[getters[el]](ci);
            } else {
                a = posArr[ai + el];
                b = posArr[bi + el];
                c = posArr[ci + el];
            }
            let min = a;
            if (b < min) min = b;
            if (c < min) min = c;
            let max = a;
            if (b > max) max = b;
            if (c > max) max = c;
            // Increase the bounds size by float32 epsilon to avoid precision errors when
            // converting to 32 bit float. Scale the epsilon by the size of the numbers being
            // worked with.
            const halfExtents = (max - min) / 2;
            const el2 = el * 2;
            triangleBounds[tri6 + el2 + 0] = min + halfExtents;
            triangleBounds[tri6 + el2 + 1] = halfExtents + (Math.abs(min) + halfExtents) * (0, $78926744db4a8a3e$export$859129fb5c8f4dc1);
        }
    }
    return triangleBounds;
}


function $a9f34d1ac25848aa$export$40b9a5e446bf11e0(nodeIndex32, array, target) {
    target.min.x = array[nodeIndex32];
    target.min.y = array[nodeIndex32 + 1];
    target.min.z = array[nodeIndex32 + 2];
    target.max.x = array[nodeIndex32 + 3];
    target.max.y = array[nodeIndex32 + 4];
    target.max.z = array[nodeIndex32 + 5];
    return target;
}
function $a9f34d1ac25848aa$export$8737d658f04762d3(target) {
    target[0] = target[1] = target[2] = Infinity;
    target[3] = target[4] = target[5] = -Infinity;
}
function $a9f34d1ac25848aa$export$dcdc414399b99746(bounds) {
    let splitDimIdx = -1;
    let splitDist = -Infinity;
    for(let i = 0; i < 3; i++){
        const dist = bounds[i + 3] - bounds[i];
        if (dist > splitDist) {
            splitDist = dist;
            splitDimIdx = i;
        }
    }
    return splitDimIdx;
}
function $a9f34d1ac25848aa$export$14b050a767b4a3a7(source, target) {
    target.set(source);
}
function $a9f34d1ac25848aa$export$a8a7063dce01a911(a, b, target) {
    let aVal, bVal;
    for(let d = 0; d < 3; d++){
        const d3 = d + 3;
        // set the minimum values
        aVal = a[d];
        bVal = b[d];
        target[d] = aVal < bVal ? aVal : bVal;
        // set the max values
        aVal = a[d3];
        bVal = b[d3];
        target[d3] = aVal > bVal ? aVal : bVal;
    }
}
function $a9f34d1ac25848aa$export$c989e53c4b24c2f5(startIndex, triangleBounds, bounds) {
    for(let d = 0; d < 3; d++){
        const tCenter = triangleBounds[startIndex + 2 * d];
        const tHalf = triangleBounds[startIndex + 2 * d + 1];
        const tMin = tCenter - tHalf;
        const tMax = tCenter + tHalf;
        if (tMin < bounds[d]) bounds[d] = tMin;
        if (tMax > bounds[d + 3]) bounds[d + 3] = tMax;
    }
}
function $a9f34d1ac25848aa$export$dbf4320364dc239e(bounds) {
    const d0 = bounds[3] - bounds[0];
    const d1 = bounds[4] - bounds[1];
    const d2 = bounds[5] - bounds[2];
    return 2 * (d0 * d1 + d1 * d2 + d2 * d0);
}



const $33d016ef2ae8a9ff$var$BIN_COUNT = 32;
const $33d016ef2ae8a9ff$var$binsSort = (a, b)=>a.candidate - b.candidate;
const $33d016ef2ae8a9ff$var$sahBins = new Array($33d016ef2ae8a9ff$var$BIN_COUNT).fill().map(()=>{
    return {
        count: 0,
        bounds: new Float32Array(6),
        rightCacheBounds: new Float32Array(6),
        leftCacheBounds: new Float32Array(6),
        candidate: 0
    };
});
const $33d016ef2ae8a9ff$var$leftBounds = new Float32Array(6);
function $33d016ef2ae8a9ff$export$9e40712018083c80(nodeBoundingData, centroidBoundingData, triangleBounds, offset, count, strategy) {
    let axis = -1;
    let pos = 0;
    // Center
    if (strategy === (0, $78926744db4a8a3e$export$91c2158bc24c63d4)) {
        axis = (0, $a9f34d1ac25848aa$export$dcdc414399b99746)(centroidBoundingData);
        if (axis !== -1) pos = (centroidBoundingData[axis] + centroidBoundingData[axis + 3]) / 2;
    } else if (strategy === (0, $78926744db4a8a3e$export$d3bfe4097a2a8542)) {
        axis = (0, $a9f34d1ac25848aa$export$dcdc414399b99746)(nodeBoundingData);
        if (axis !== -1) pos = $33d016ef2ae8a9ff$var$getAverage(triangleBounds, offset, count, axis);
    } else if (strategy === (0, $78926744db4a8a3e$export$2b2cc3fb4f03d723)) {
        const rootSurfaceArea = (0, $a9f34d1ac25848aa$export$dbf4320364dc239e)(nodeBoundingData);
        let bestCost = (0, $78926744db4a8a3e$export$22e1995328fd3cd9) * count;
        // iterate over all axes
        const cStart = offset * 6;
        const cEnd = (offset + count) * 6;
        for(let a = 0; a < 3; a++){
            const axisLeft = centroidBoundingData[a];
            const axisRight = centroidBoundingData[a + 3];
            const axisLength = axisRight - axisLeft;
            const binWidth = axisLength / $33d016ef2ae8a9ff$var$BIN_COUNT;
            // If we have fewer triangles than we're planning to split then just check all
            // the triangle positions because it will be faster.
            if (count < $33d016ef2ae8a9ff$var$BIN_COUNT / 4) {
                // initialize the bin candidates
                const truncatedBins = [
                    ...$33d016ef2ae8a9ff$var$sahBins
                ];
                truncatedBins.length = count;
                // set the candidates
                let b = 0;
                for(let c = cStart; c < cEnd; c += 6, b++){
                    const bin = truncatedBins[b];
                    bin.candidate = triangleBounds[c + 2 * a];
                    bin.count = 0;
                    const { bounds: bounds, leftCacheBounds: leftCacheBounds, rightCacheBounds: rightCacheBounds } = bin;
                    for(let d = 0; d < 3; d++){
                        rightCacheBounds[d] = Infinity;
                        rightCacheBounds[d + 3] = -Infinity;
                        leftCacheBounds[d] = Infinity;
                        leftCacheBounds[d + 3] = -Infinity;
                        bounds[d] = Infinity;
                        bounds[d + 3] = -Infinity;
                    }
                    (0, $a9f34d1ac25848aa$export$c989e53c4b24c2f5)(c, triangleBounds, bounds);
                }
                truncatedBins.sort($33d016ef2ae8a9ff$var$binsSort);
                // remove redundant splits
                let splitCount = count;
                for(let bi = 0; bi < splitCount; bi++){
                    const bin = truncatedBins[bi];
                    while(bi + 1 < splitCount && truncatedBins[bi + 1].candidate === bin.candidate){
                        truncatedBins.splice(bi + 1, 1);
                        splitCount--;
                    }
                }
                // find the appropriate bin for each triangle and expand the bounds.
                for(let c = cStart; c < cEnd; c += 6){
                    const center = triangleBounds[c + 2 * a];
                    for(let bi = 0; bi < splitCount; bi++){
                        const bin = truncatedBins[bi];
                        if (center >= bin.candidate) (0, $a9f34d1ac25848aa$export$c989e53c4b24c2f5)(c, triangleBounds, bin.rightCacheBounds);
                        else {
                            (0, $a9f34d1ac25848aa$export$c989e53c4b24c2f5)(c, triangleBounds, bin.leftCacheBounds);
                            bin.count++;
                        }
                    }
                }
                // expand all the bounds
                for(let bi = 0; bi < splitCount; bi++){
                    const bin = truncatedBins[bi];
                    const leftCount = bin.count;
                    const rightCount = count - bin.count;
                    // check the cost of this split
                    const leftBounds = bin.leftCacheBounds;
                    const rightBounds = bin.rightCacheBounds;
                    let leftProb = 0;
                    if (leftCount !== 0) leftProb = (0, $a9f34d1ac25848aa$export$dbf4320364dc239e)(leftBounds) / rootSurfaceArea;
                    let rightProb = 0;
                    if (rightCount !== 0) rightProb = (0, $a9f34d1ac25848aa$export$dbf4320364dc239e)(rightBounds) / rootSurfaceArea;
                    const cost = (0, $78926744db4a8a3e$export$f4b101accf1b23d1) + (0, $78926744db4a8a3e$export$22e1995328fd3cd9) * (leftProb * leftCount + rightProb * rightCount);
                    if (cost < bestCost) {
                        axis = a;
                        bestCost = cost;
                        pos = bin.candidate;
                    }
                }
            } else {
                // reset the bins
                for(let i = 0; i < $33d016ef2ae8a9ff$var$BIN_COUNT; i++){
                    const bin = $33d016ef2ae8a9ff$var$sahBins[i];
                    bin.count = 0;
                    bin.candidate = axisLeft + binWidth + i * binWidth;
                    const bounds = bin.bounds;
                    for(let d = 0; d < 3; d++){
                        bounds[d] = Infinity;
                        bounds[d + 3] = -Infinity;
                    }
                }
                // iterate over all center positions
                for(let c = cStart; c < cEnd; c += 6){
                    const triCenter = triangleBounds[c + 2 * a];
                    const relativeCenter = triCenter - axisLeft;
                    // in the partition function if the centroid lies on the split plane then it is
                    // considered to be on the right side of the split
                    let binIndex = ~~(relativeCenter / binWidth);
                    if (binIndex >= $33d016ef2ae8a9ff$var$BIN_COUNT) binIndex = $33d016ef2ae8a9ff$var$BIN_COUNT - 1;
                    const bin = $33d016ef2ae8a9ff$var$sahBins[binIndex];
                    bin.count++;
                    (0, $a9f34d1ac25848aa$export$c989e53c4b24c2f5)(c, triangleBounds, bin.bounds);
                }
                // cache the unioned bounds from right to left so we don't have to regenerate them each time
                const lastBin = $33d016ef2ae8a9ff$var$sahBins[$33d016ef2ae8a9ff$var$BIN_COUNT - 1];
                (0, $a9f34d1ac25848aa$export$14b050a767b4a3a7)(lastBin.bounds, lastBin.rightCacheBounds);
                for(let i = $33d016ef2ae8a9ff$var$BIN_COUNT - 2; i >= 0; i--){
                    const bin = $33d016ef2ae8a9ff$var$sahBins[i];
                    const nextBin = $33d016ef2ae8a9ff$var$sahBins[i + 1];
                    (0, $a9f34d1ac25848aa$export$a8a7063dce01a911)(bin.bounds, nextBin.rightCacheBounds, bin.rightCacheBounds);
                }
                let leftCount = 0;
                for(let i = 0; i < $33d016ef2ae8a9ff$var$BIN_COUNT - 1; i++){
                    const bin = $33d016ef2ae8a9ff$var$sahBins[i];
                    const binCount = bin.count;
                    const bounds = bin.bounds;
                    const nextBin = $33d016ef2ae8a9ff$var$sahBins[i + 1];
                    const rightBounds = nextBin.rightCacheBounds;
                    // don't do anything with the bounds if the new bounds have no triangles
                    if (binCount !== 0) {
                        if (leftCount === 0) (0, $a9f34d1ac25848aa$export$14b050a767b4a3a7)(bounds, $33d016ef2ae8a9ff$var$leftBounds);
                        else (0, $a9f34d1ac25848aa$export$a8a7063dce01a911)(bounds, $33d016ef2ae8a9ff$var$leftBounds, $33d016ef2ae8a9ff$var$leftBounds);
                    }
                    leftCount += binCount;
                    // check the cost of this split
                    let leftProb = 0;
                    let rightProb = 0;
                    if (leftCount !== 0) leftProb = (0, $a9f34d1ac25848aa$export$dbf4320364dc239e)($33d016ef2ae8a9ff$var$leftBounds) / rootSurfaceArea;
                    const rightCount = count - leftCount;
                    if (rightCount !== 0) rightProb = (0, $a9f34d1ac25848aa$export$dbf4320364dc239e)(rightBounds) / rootSurfaceArea;
                    const cost = (0, $78926744db4a8a3e$export$f4b101accf1b23d1) + (0, $78926744db4a8a3e$export$22e1995328fd3cd9) * (leftProb * leftCount + rightProb * rightCount);
                    if (cost < bestCost) {
                        axis = a;
                        bestCost = cost;
                        pos = bin.candidate;
                    }
                }
            }
        }
    } else console.warn(`MeshBVH: Invalid build strategy value ${strategy} used.`);
    return {
        axis: axis,
        pos: pos
    };
}
// returns the average coordinate on the specified axis of the all the provided triangles
function $33d016ef2ae8a9ff$var$getAverage(triangleBounds, offset, count, axis) {
    let avg = 0;
    for(let i = offset, end = offset + count; i < end; i++)avg += triangleBounds[i * 6 + axis * 2];
    return avg / count;
}


class $096668f03fbb5645$export$6f473cc5f89b0a1c {
    constructor(){
        // internal nodes have boundingData, left, right, and splitAxis
        // leaf nodes have offset and count (referring to primitives in the mesh geometry)
        this.boundingData = new Float32Array(6);
    }
}



/********************************************************/ /* This file is generated from "sortUtils.template.js". */ /********************************************************/ // reorders `tris` such that for `count` elements after `offset`, elements on the left side of the split
// will be on the left and elements on the right side of the split will be on the right. returns the index
// of the first element on the right side, or offset + count if there are no elements on the right side.
function $5f38cfeb5f7666c7$export$b29f828819edca8d(indirectBuffer, index, triangleBounds, offset, count, split) {
    let left = offset;
    let right = offset + count - 1;
    const pos = split.pos;
    const axisOffset = split.axis * 2;
    // hoare partitioning, see e.g. https://en.wikipedia.org/wiki/Quicksort#Hoare_partition_scheme
    while(true){
        while(left <= right && triangleBounds[left * 6 + axisOffset] < pos)left++;
        // if a triangle center lies on the partition plane it is considered to be on the right side
        while(left <= right && triangleBounds[right * 6 + axisOffset] >= pos)right--;
        if (left < right) {
            // we need to swap all of the information associated with the triangles at index
            // left and right; that's the verts in the geometry index, the bounds,
            // and perhaps the SAH planes
            for(let i = 0; i < 3; i++){
                let t0 = index[left * 3 + i];
                index[left * 3 + i] = index[right * 3 + i];
                index[right * 3 + i] = t0;
            }
            // swap bounds
            for(let i = 0; i < 6; i++){
                let tb = triangleBounds[left * 6 + i];
                triangleBounds[left * 6 + i] = triangleBounds[right * 6 + i];
                triangleBounds[right * 6 + i] = tb;
            }
            left++;
            right--;
        } else return left;
    }
}


/********************************************************/ /* This file is generated from "sortUtils.template.js". */ /********************************************************/ // reorders `tris` such that for `count` elements after `offset`, elements on the left side of the split
// will be on the left and elements on the right side of the split will be on the right. returns the index
// of the first element on the right side, or offset + count if there are no elements on the right side.
function $b1583556301b54a3$export$7cee363d477551d0(indirectBuffer, index, triangleBounds, offset, count, split) {
    let left = offset;
    let right = offset + count - 1;
    const pos = split.pos;
    const axisOffset = split.axis * 2;
    // hoare partitioning, see e.g. https://en.wikipedia.org/wiki/Quicksort#Hoare_partition_scheme
    while(true){
        while(left <= right && triangleBounds[left * 6 + axisOffset] < pos)left++;
        // if a triangle center lies on the partition plane it is considered to be on the right side
        while(left <= right && triangleBounds[right * 6 + axisOffset] >= pos)right--;
        if (left < right) {
            // we need to swap all of the information associated with the triangles at index
            // left and right; that's the verts in the geometry index, the bounds,
            // and perhaps the SAH planes
            let t = indirectBuffer[left];
            indirectBuffer[left] = indirectBuffer[right];
            indirectBuffer[right] = t;
            // swap bounds
            for(let i = 0; i < 6; i++){
                let tb = triangleBounds[left * 6 + i];
                triangleBounds[left * 6 + i] = triangleBounds[right * 6 + i];
                triangleBounds[right * 6 + i] = tb;
            }
            left++;
            right--;
        } else return left;
    }
}



function $6363300ccf15b961$export$bc7cbaf27fbe938e(n16, uint16Array) {
    return uint16Array[n16 + 15] === 0xFFFF;
}
function $6363300ccf15b961$export$3231e969238304f3(n32, uint32Array) {
    return uint32Array[n32 + 6];
}
function $6363300ccf15b961$export$d61684373eacdf61(n16, uint16Array) {
    return uint16Array[n16 + 14];
}
function $6363300ccf15b961$export$7a68bc00425859d(n32) {
    return n32 + 8;
}
function $6363300ccf15b961$export$4f44f52d9f75fa31(n32, uint32Array) {
    return uint32Array[n32 + 6];
}
function $6363300ccf15b961$export$b43717b3ca95505(n32, uint32Array) {
    return uint32Array[n32 + 7];
}
function $6363300ccf15b961$export$b5b7e27a1440579d(n32) {
    return n32;
}


let $63b9f27945e6e48e$var$float32Array, $63b9f27945e6e48e$var$uint32Array, $63b9f27945e6e48e$var$uint16Array, $63b9f27945e6e48e$var$uint8Array;
const $63b9f27945e6e48e$var$MAX_POINTER = Math.pow(2, 32);
function $63b9f27945e6e48e$export$1daf15cbaf649dad(node) {
    if ("count" in node) return 1;
    else return 1 + $63b9f27945e6e48e$export$1daf15cbaf649dad(node.left) + $63b9f27945e6e48e$export$1daf15cbaf649dad(node.right);
}
function $63b9f27945e6e48e$export$faac1b763a0eceb5(byteOffset, node, buffer) {
    $63b9f27945e6e48e$var$float32Array = new Float32Array(buffer);
    $63b9f27945e6e48e$var$uint32Array = new Uint32Array(buffer);
    $63b9f27945e6e48e$var$uint16Array = new Uint16Array(buffer);
    $63b9f27945e6e48e$var$uint8Array = new Uint8Array(buffer);
    return $63b9f27945e6e48e$var$_populateBuffer(byteOffset, node);
}
// pack structure
// boundingData  				: 6 float32
// right / offset 				: 1 uint32
// splitAxis / isLeaf + count 	: 1 uint32 / 2 uint16
function $63b9f27945e6e48e$var$_populateBuffer(byteOffset, node) {
    const stride4Offset = byteOffset / 4;
    const stride2Offset = byteOffset / 2;
    const isLeaf = "count" in node;
    const boundingData = node.boundingData;
    for(let i = 0; i < 6; i++)$63b9f27945e6e48e$var$float32Array[stride4Offset + i] = boundingData[i];
    if (isLeaf) {
        if (node.buffer) {
            const buffer = node.buffer;
            $63b9f27945e6e48e$var$uint8Array.set(new Uint8Array(buffer), byteOffset);
            for(let offset = byteOffset, l = byteOffset + buffer.byteLength; offset < l; offset += (0, $78926744db4a8a3e$export$a08e7d18fbc53be5)){
                const offset2 = offset / 2;
                if (!(0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(offset2, $63b9f27945e6e48e$var$uint16Array)) $63b9f27945e6e48e$var$uint32Array[offset / 4 + 6] += stride4Offset;
            }
            return byteOffset + buffer.byteLength;
        } else {
            const offset = node.offset;
            const count = node.count;
            $63b9f27945e6e48e$var$uint32Array[stride4Offset + 6] = offset;
            $63b9f27945e6e48e$var$uint16Array[stride2Offset + 14] = count;
            $63b9f27945e6e48e$var$uint16Array[stride2Offset + 15] = (0, $78926744db4a8a3e$export$661fddb62bfe0e42);
            return byteOffset + (0, $78926744db4a8a3e$export$a08e7d18fbc53be5);
        }
    } else {
        const left = node.left;
        const right = node.right;
        const splitAxis = node.splitAxis;
        let nextUnusedPointer;
        nextUnusedPointer = $63b9f27945e6e48e$var$_populateBuffer(byteOffset + (0, $78926744db4a8a3e$export$a08e7d18fbc53be5), left);
        if (nextUnusedPointer / 4 > $63b9f27945e6e48e$var$MAX_POINTER) throw new Error("MeshBVH: Cannot store child pointer greater than 32 bits.");
        $63b9f27945e6e48e$var$uint32Array[stride4Offset + 6] = nextUnusedPointer / 4;
        nextUnusedPointer = $63b9f27945e6e48e$var$_populateBuffer(nextUnusedPointer, right);
        $63b9f27945e6e48e$var$uint32Array[stride4Offset + 7] = splitAxis;
        return nextUnusedPointer;
    }
}


function $ed4ee2639a9fd94e$export$6008de7a0114426c(geometry, useSharedArrayBuffer) {
    const triCount = (geometry.index ? geometry.index.count : geometry.attributes.position.count) / 3;
    const useUint32 = triCount > 2 ** 16;
    const byteCount = useUint32 ? 4 : 2;
    const buffer = useSharedArrayBuffer ? new SharedArrayBuffer(triCount * byteCount) : new ArrayBuffer(triCount * byteCount);
    const indirectBuffer = useUint32 ? new Uint32Array(buffer) : new Uint16Array(buffer);
    for(let i = 0, l = indirectBuffer.length; i < l; i++)indirectBuffer[i] = i;
    return indirectBuffer;
}
function $ed4ee2639a9fd94e$export$9896244d8c99a4d0(bvh, triangleBounds, offset, count, options) {
    // epxand variables
    const { maxDepth: maxDepth, verbose: verbose, maxLeafTris: maxLeafTris, strategy: strategy, onProgress: onProgress, indirect: indirect } = options;
    const indirectBuffer = bvh._indirectBuffer;
    const geometry = bvh.geometry;
    const indexArray = geometry.index ? geometry.index.array : null;
    const partionFunc = indirect ? (0, $b1583556301b54a3$export$7cee363d477551d0) : (0, $5f38cfeb5f7666c7$export$b29f828819edca8d);
    // generate intermediate variables
    const totalTriangles = (0, $423096e95cd96e19$export$c56c51fae37b2d63)(geometry);
    const cacheCentroidBoundingData = new Float32Array(6);
    let reachedMaxDepth = false;
    const root = new (0, $096668f03fbb5645$export$6f473cc5f89b0a1c)();
    (0, $4ca55de292e93eb1$export$becd1e645219fa23)(triangleBounds, offset, count, root.boundingData, cacheCentroidBoundingData);
    splitNode(root, offset, count, cacheCentroidBoundingData);
    return root;
    function triggerProgress(trianglesProcessed) {
        if (onProgress) onProgress(trianglesProcessed / totalTriangles);
    }
    // either recursively splits the given node, creating left and right subtrees for it, or makes it a leaf node,
    // recording the offset and count of its triangles and writing them into the reordered geometry index.
    function splitNode(node, offset, count, centroidBoundingData = null, depth = 0) {
        if (!reachedMaxDepth && depth >= maxDepth) {
            reachedMaxDepth = true;
            if (verbose) {
                console.warn(`MeshBVH: Max depth of ${maxDepth} reached when generating BVH. Consider increasing maxDepth.`);
                console.warn(geometry);
            }
        }
        // early out if we've met our capacity
        if (count <= maxLeafTris || depth >= maxDepth) {
            triggerProgress(offset + count);
            node.offset = offset;
            node.count = count;
            return node;
        }
        // Find where to split the volume
        const split = (0, $33d016ef2ae8a9ff$export$9e40712018083c80)(node.boundingData, centroidBoundingData, triangleBounds, offset, count, strategy);
        if (split.axis === -1) {
            triggerProgress(offset + count);
            node.offset = offset;
            node.count = count;
            return node;
        }
        const splitOffset = partionFunc(indirectBuffer, indexArray, triangleBounds, offset, count, split);
        // create the two new child nodes
        if (splitOffset === offset || splitOffset === offset + count) {
            triggerProgress(offset + count);
            node.offset = offset;
            node.count = count;
        } else {
            node.splitAxis = split.axis;
            // create the left child and compute its bounding box
            const left = new (0, $096668f03fbb5645$export$6f473cc5f89b0a1c)();
            const lstart = offset;
            const lcount = splitOffset - offset;
            node.left = left;
            (0, $4ca55de292e93eb1$export$becd1e645219fa23)(triangleBounds, lstart, lcount, left.boundingData, cacheCentroidBoundingData);
            splitNode(left, lstart, lcount, cacheCentroidBoundingData, depth + 1);
            // repeat for right
            const right = new (0, $096668f03fbb5645$export$6f473cc5f89b0a1c)();
            const rstart = splitOffset;
            const rcount = count - lcount;
            node.right = right;
            (0, $4ca55de292e93eb1$export$becd1e645219fa23)(triangleBounds, rstart, rcount, right.boundingData, cacheCentroidBoundingData);
            splitNode(right, rstart, rcount, cacheCentroidBoundingData, depth + 1);
        }
        return node;
    }
}
function $ed4ee2639a9fd94e$export$e63bca57f220b8e3(bvh, options) {
    const geometry = bvh.geometry;
    if (options.indirect) {
        bvh._indirectBuffer = $ed4ee2639a9fd94e$export$6008de7a0114426c(geometry, options.useSharedArrayBuffer);
        if ((0, $423096e95cd96e19$export$d3cf4eabab21775d)(geometry, options.range) && !options.verbose) console.warn('MeshBVH: Provided geometry contains groups or a range that do not fully span the vertex contents while using the "indirect" option. BVH may incorrectly report intersections on unrendered portions of the geometry.');
    }
    if (!bvh._indirectBuffer) (0, $423096e95cd96e19$export$90fd303420808ebb)(geometry, options);
    const BufferConstructor = options.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
    const triangleBounds = (0, $4ca55de292e93eb1$export$b3cc4d5d5179e78c)(geometry);
    const geometryRanges = options.indirect ? (0, $423096e95cd96e19$export$8c9d42783264c26e)(geometry, options.range) : (0, $423096e95cd96e19$export$fd7a16c461f5043c)(geometry, options.range);
    bvh._roots = geometryRanges.map((range)=>{
        const root = $ed4ee2639a9fd94e$export$9896244d8c99a4d0(bvh, triangleBounds, range.offset, range.count, options);
        const nodeCount = (0, $63b9f27945e6e48e$export$1daf15cbaf649dad)(root);
        const buffer = new BufferConstructor((0, $78926744db4a8a3e$export$a08e7d18fbc53be5) * nodeCount);
        (0, $63b9f27945e6e48e$export$faac1b763a0eceb5)(0, root, buffer);
        return buffer;
    });
}



var $ilwiq = parcelRequire("ilwiq");

var $ilwiq = parcelRequire("ilwiq");
class $20d478469c10be0c$export$f758e41ecdcd8e69 {
    constructor(){
        this.min = Infinity;
        this.max = -Infinity;
    }
    setFromPointsField(points, field) {
        let min = Infinity;
        let max = -Infinity;
        for(let i = 0, l = points.length; i < l; i++){
            const p = points[i];
            const val = p[field];
            min = val < min ? val : min;
            max = val > max ? val : max;
        }
        this.min = min;
        this.max = max;
    }
    setFromPoints(axis, points) {
        let min = Infinity;
        let max = -Infinity;
        for(let i = 0, l = points.length; i < l; i++){
            const p = points[i];
            const val = axis.dot(p);
            min = val < min ? val : min;
            max = val > max ? val : max;
        }
        this.min = min;
        this.max = max;
    }
    isSeparated(other) {
        return this.min > other.max || other.min > this.max;
    }
}
$20d478469c10be0c$export$f758e41ecdcd8e69.prototype.setFromBox = function() {
    const p = new (0, $ilwiq.Vector3)();
    return function setFromBox(axis, box) {
        const boxMin = box.min;
        const boxMax = box.max;
        let min = Infinity;
        let max = -Infinity;
        for(let x = 0; x <= 1; x++){
            for(let y = 0; y <= 1; y++)for(let z = 0; z <= 1; z++){
                p.x = boxMin.x * x + boxMax.x * (1 - x);
                p.y = boxMin.y * y + boxMax.y * (1 - y);
                p.z = boxMin.z * z + boxMax.z * (1 - z);
                const val = axis.dot(p);
                min = Math.min(val, min);
                max = Math.max(val, max);
            }
        }
        this.min = min;
        this.max = max;
    };
}();
const $20d478469c10be0c$export$e086b7be1b4d1d36 = function() {
    const cacheSatBounds = new $20d478469c10be0c$export$f758e41ecdcd8e69();
    return function areIntersecting(shape1, shape2) {
        const points1 = shape1.points;
        const satAxes1 = shape1.satAxes;
        const satBounds1 = shape1.satBounds;
        const points2 = shape2.points;
        const satAxes2 = shape2.satAxes;
        const satBounds2 = shape2.satBounds;
        // check axes of the first shape
        for(let i = 0; i < 3; i++){
            const sb = satBounds1[i];
            const sa = satAxes1[i];
            cacheSatBounds.setFromPoints(sa, points2);
            if (sb.isSeparated(cacheSatBounds)) return false;
        }
        // check axes of the second shape
        for(let i = 0; i < 3; i++){
            const sb = satBounds2[i];
            const sa = satAxes2[i];
            cacheSatBounds.setFromPoints(sa, points1);
            if (sb.isSeparated(cacheSatBounds)) return false;
        }
    };
}();



var $ilwiq = parcelRequire("ilwiq");


var $ilwiq = parcelRequire("ilwiq");
const $afac8e64b68760a8$export$479eef7c8f1b846c = function() {
    // https://github.com/juj/MathGeoLib/blob/master/src/Geometry/Line.cpp#L56
    const dir1 = new (0, $ilwiq.Vector3)();
    const dir2 = new (0, $ilwiq.Vector3)();
    const v02 = new (0, $ilwiq.Vector3)();
    return function closestPointLineToLine(l1, l2, result) {
        const v0 = l1.start;
        const v10 = dir1;
        const v2 = l2.start;
        const v32 = dir2;
        v02.subVectors(v0, v2);
        dir1.subVectors(l1.end, l1.start);
        dir2.subVectors(l2.end, l2.start);
        // float d0232 = v02.Dot(v32);
        const d0232 = v02.dot(v32);
        // float d3210 = v32.Dot(v10);
        const d3210 = v32.dot(v10);
        // float d3232 = v32.Dot(v32);
        const d3232 = v32.dot(v32);
        // float d0210 = v02.Dot(v10);
        const d0210 = v02.dot(v10);
        // float d1010 = v10.Dot(v10);
        const d1010 = v10.dot(v10);
        // float denom = d1010*d3232 - d3210*d3210;
        const denom = d1010 * d3232 - d3210 * d3210;
        let d, d2;
        if (denom !== 0) d = (d0232 * d3210 - d0210 * d3232) / denom;
        else d = 0;
        d2 = (d0232 + d * d3210) / d3232;
        result.x = d;
        result.y = d2;
    };
}();
const $afac8e64b68760a8$export$b09f296caca7547a = function() {
    // https://github.com/juj/MathGeoLib/blob/master/src/Geometry/LineSegment.cpp#L187
    const paramResult = new (0, $ilwiq.Vector2)();
    const temp1 = new (0, $ilwiq.Vector3)();
    const temp2 = new (0, $ilwiq.Vector3)();
    return function closestPointsSegmentToSegment(l1, l2, target1, target2) {
        $afac8e64b68760a8$export$479eef7c8f1b846c(l1, l2, paramResult);
        let d = paramResult.x;
        let d2 = paramResult.y;
        if (d >= 0 && d <= 1 && d2 >= 0 && d2 <= 1) {
            l1.at(d, target1);
            l2.at(d2, target2);
            return;
        } else if (d >= 0 && d <= 1) {
            // Only d2 is out of bounds.
            if (d2 < 0) l2.at(0, target2);
            else l2.at(1, target2);
            l1.closestPointToPoint(target2, true, target1);
            return;
        } else if (d2 >= 0 && d2 <= 1) {
            // Only d is out of bounds.
            if (d < 0) l1.at(0, target1);
            else l1.at(1, target1);
            l2.closestPointToPoint(target1, true, target2);
            return;
        } else {
            // Both u and u2 are out of bounds.
            let p;
            if (d < 0) p = l1.start;
            else p = l1.end;
            let p2;
            if (d2 < 0) p2 = l2.start;
            else p2 = l2.end;
            const closestPoint = temp1;
            const closestPoint2 = temp2;
            l1.closestPointToPoint(p2, true, temp1);
            l2.closestPointToPoint(p, true, temp2);
            if (closestPoint.distanceToSquared(p2) <= closestPoint2.distanceToSquared(p)) {
                target1.copy(closestPoint);
                target2.copy(p2);
                return;
            } else {
                target1.copy(p);
                target2.copy(closestPoint2);
                return;
            }
        }
    };
}();
const $afac8e64b68760a8$export$eed3a6606b3adc41 = function() {
    // https://stackoverflow.com/questions/34043955/detect-collision-between-sphere-and-triangle-in-three-js
    const closestPointTemp = new (0, $ilwiq.Vector3)();
    const projectedPointTemp = new (0, $ilwiq.Vector3)();
    const planeTemp = new (0, $ilwiq.Plane)();
    const lineTemp = new (0, $ilwiq.Line3)();
    return function sphereIntersectTriangle(sphere, triangle) {
        const { radius: radius, center: center } = sphere;
        const { a: a, b: b, c: c } = triangle;
        // phase 1
        lineTemp.start = a;
        lineTemp.end = b;
        const closestPoint1 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
        if (closestPoint1.distanceTo(center) <= radius) return true;
        lineTemp.start = a;
        lineTemp.end = c;
        const closestPoint2 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
        if (closestPoint2.distanceTo(center) <= radius) return true;
        lineTemp.start = b;
        lineTemp.end = c;
        const closestPoint3 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
        if (closestPoint3.distanceTo(center) <= radius) return true;
        // phase 2
        const plane = triangle.getPlane(planeTemp);
        const dp = Math.abs(plane.distanceToPoint(center));
        if (dp <= radius) {
            const pp = plane.projectPoint(center, projectedPointTemp);
            const cp = triangle.containsPoint(pp);
            if (cp) return true;
        }
        return false;
    };
}();


const $681270c6f2e9ebff$var$ZERO_EPSILON = 1e-15;
function $681270c6f2e9ebff$var$isNearZero(value) {
    return Math.abs(value) < $681270c6f2e9ebff$var$ZERO_EPSILON;
}
class $681270c6f2e9ebff$export$a37f7ec1c23dfacf extends (0, $ilwiq.Triangle) {
    constructor(...args){
        super(...args);
        this.isExtendedTriangle = true;
        this.satAxes = new Array(4).fill().map(()=>new (0, $ilwiq.Vector3)());
        this.satBounds = new Array(4).fill().map(()=>new (0, $20d478469c10be0c$export$f758e41ecdcd8e69)());
        this.points = [
            this.a,
            this.b,
            this.c
        ];
        this.sphere = new (0, $ilwiq.Sphere)();
        this.plane = new (0, $ilwiq.Plane)();
        this.needsUpdate = true;
    }
    intersectsSphere(sphere) {
        return (0, $afac8e64b68760a8$export$eed3a6606b3adc41)(sphere, this);
    }
    update() {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const points = this.points;
        const satAxes = this.satAxes;
        const satBounds = this.satBounds;
        const axis0 = satAxes[0];
        const sab0 = satBounds[0];
        this.getNormal(axis0);
        sab0.setFromPoints(axis0, points);
        const axis1 = satAxes[1];
        const sab1 = satBounds[1];
        axis1.subVectors(a, b);
        sab1.setFromPoints(axis1, points);
        const axis2 = satAxes[2];
        const sab2 = satBounds[2];
        axis2.subVectors(b, c);
        sab2.setFromPoints(axis2, points);
        const axis3 = satAxes[3];
        const sab3 = satBounds[3];
        axis3.subVectors(c, a);
        sab3.setFromPoints(axis3, points);
        this.sphere.setFromPoints(this.points);
        this.plane.setFromNormalAndCoplanarPoint(axis0, a);
        this.needsUpdate = false;
    }
}
$681270c6f2e9ebff$export$a37f7ec1c23dfacf.prototype.closestPointToSegment = function() {
    const point1 = new (0, $ilwiq.Vector3)();
    const point2 = new (0, $ilwiq.Vector3)();
    const edge = new (0, $ilwiq.Line3)();
    return function distanceToSegment(segment, target1 = null, target2 = null) {
        const { start: start, end: end } = segment;
        const points = this.points;
        let distSq;
        let closestDistanceSq = Infinity;
        // check the triangle edges
        for(let i = 0; i < 3; i++){
            const nexti = (i + 1) % 3;
            edge.start.copy(points[i]);
            edge.end.copy(points[nexti]);
            (0, $afac8e64b68760a8$export$b09f296caca7547a)(edge, segment, point1, point2);
            distSq = point1.distanceToSquared(point2);
            if (distSq < closestDistanceSq) {
                closestDistanceSq = distSq;
                if (target1) target1.copy(point1);
                if (target2) target2.copy(point2);
            }
        }
        // check end points
        this.closestPointToPoint(start, point1);
        distSq = start.distanceToSquared(point1);
        if (distSq < closestDistanceSq) {
            closestDistanceSq = distSq;
            if (target1) target1.copy(point1);
            if (target2) target2.copy(start);
        }
        this.closestPointToPoint(end, point1);
        distSq = end.distanceToSquared(point1);
        if (distSq < closestDistanceSq) {
            closestDistanceSq = distSq;
            if (target1) target1.copy(point1);
            if (target2) target2.copy(end);
        }
        return Math.sqrt(closestDistanceSq);
    };
}();
$681270c6f2e9ebff$export$a37f7ec1c23dfacf.prototype.intersectsTriangle = function() {
    const saTri2 = new $681270c6f2e9ebff$export$a37f7ec1c23dfacf();
    const arr1 = new Array(3);
    const arr2 = new Array(3);
    const cachedSatBounds = new (0, $20d478469c10be0c$export$f758e41ecdcd8e69)();
    const cachedSatBounds2 = new (0, $20d478469c10be0c$export$f758e41ecdcd8e69)();
    const cachedAxis = new (0, $ilwiq.Vector3)();
    const dir = new (0, $ilwiq.Vector3)();
    const dir1 = new (0, $ilwiq.Vector3)();
    const dir2 = new (0, $ilwiq.Vector3)();
    const tempDir = new (0, $ilwiq.Vector3)();
    const edge = new (0, $ilwiq.Line3)();
    const edge1 = new (0, $ilwiq.Line3)();
    const edge2 = new (0, $ilwiq.Line3)();
    const tempPoint = new (0, $ilwiq.Vector3)();
    function triIntersectPlane(tri, plane, targetEdge) {
        // find the edge that intersects the other triangle plane
        const points = tri.points;
        let count = 0;
        let startPointIntersection = -1;
        for(let i = 0; i < 3; i++){
            const { start: start, end: end } = edge;
            start.copy(points[i]);
            end.copy(points[(i + 1) % 3]);
            edge.delta(dir);
            const startIntersects = $681270c6f2e9ebff$var$isNearZero(plane.distanceToPoint(start));
            if ($681270c6f2e9ebff$var$isNearZero(plane.normal.dot(dir)) && startIntersects) {
                // if the edge lies on the plane then take the line
                targetEdge.copy(edge);
                count = 2;
                break;
            }
            // check if the start point is near the plane because "intersectLine" is not robust to that case
            const doesIntersect = plane.intersectLine(edge, tempPoint);
            if (!doesIntersect && startIntersects) tempPoint.copy(start);
            // ignore the end point
            if ((doesIntersect || startIntersects) && !$681270c6f2e9ebff$var$isNearZero(tempPoint.distanceTo(end))) {
                if (count <= 1) {
                    // assign to the start or end point and save which index was snapped to
                    // the start point if necessary
                    const point = count === 1 ? targetEdge.start : targetEdge.end;
                    point.copy(tempPoint);
                    if (startIntersects) startPointIntersection = count;
                } else if (count >= 2) {
                    // if we're here that means that there must have been one point that had
                    // snapped to the start point so replace it here
                    const point = startPointIntersection === 1 ? targetEdge.start : targetEdge.end;
                    point.copy(tempPoint);
                    count = 2;
                    break;
                }
                count++;
                if (count === 2 && startPointIntersection === -1) break;
            }
        }
        return count;
    }
    // TODO: If the triangles are coplanar and intersecting the target is nonsensical. It should at least
    // be a line contained by both triangles if not a different special case somehow represented in the return result.
    return function intersectsTriangle(other, target = null, suppressLog = false) {
        if (this.needsUpdate) this.update();
        if (!other.isExtendedTriangle) {
            saTri2.copy(other);
            saTri2.update();
            other = saTri2;
        } else if (other.needsUpdate) other.update();
        const plane1 = this.plane;
        const plane2 = other.plane;
        if (Math.abs(plane1.normal.dot(plane2.normal)) > 1.0 - 1e-10) {
            // perform separating axis intersection test only for coplanar triangles
            const satBounds1 = this.satBounds;
            const satAxes1 = this.satAxes;
            arr2[0] = other.a;
            arr2[1] = other.b;
            arr2[2] = other.c;
            for(let i = 0; i < 4; i++){
                const sb = satBounds1[i];
                const sa = satAxes1[i];
                cachedSatBounds.setFromPoints(sa, arr2);
                if (sb.isSeparated(cachedSatBounds)) return false;
            }
            const satBounds2 = other.satBounds;
            const satAxes2 = other.satAxes;
            arr1[0] = this.a;
            arr1[1] = this.b;
            arr1[2] = this.c;
            for(let i = 0; i < 4; i++){
                const sb = satBounds2[i];
                const sa = satAxes2[i];
                cachedSatBounds.setFromPoints(sa, arr1);
                if (sb.isSeparated(cachedSatBounds)) return false;
            }
            // check crossed axes
            for(let i = 0; i < 4; i++){
                const sa1 = satAxes1[i];
                for(let i2 = 0; i2 < 4; i2++){
                    const sa2 = satAxes2[i2];
                    cachedAxis.crossVectors(sa1, sa2);
                    cachedSatBounds.setFromPoints(cachedAxis, arr1);
                    cachedSatBounds2.setFromPoints(cachedAxis, arr2);
                    if (cachedSatBounds.isSeparated(cachedSatBounds2)) return false;
                }
            }
            if (target) {
                // TODO find two points that intersect on the edges and make that the result
                if (!suppressLog) console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0.");
                target.start.set(0, 0, 0);
                target.end.set(0, 0, 0);
            }
            return true;
        } else {
            // find the edge that intersects the other triangle plane
            const count1 = triIntersectPlane(this, plane2, edge1);
            if (count1 === 1 && other.containsPoint(edge1.end)) {
                if (target) {
                    target.start.copy(edge1.end);
                    target.end.copy(edge1.end);
                }
                return true;
            } else if (count1 !== 2) return false;
            // find the other triangles edge that intersects this plane
            const count2 = triIntersectPlane(other, plane1, edge2);
            if (count2 === 1 && this.containsPoint(edge2.end)) {
                if (target) {
                    target.start.copy(edge2.end);
                    target.end.copy(edge2.end);
                }
                return true;
            } else if (count2 !== 2) return false;
            // find swap the second edge so both lines are running the same direction
            edge1.delta(dir1);
            edge2.delta(dir2);
            if (dir1.dot(dir2) < 0) {
                let tmp = edge2.start;
                edge2.start = edge2.end;
                edge2.end = tmp;
            }
            // check if the edges are overlapping
            const s1 = edge1.start.dot(dir1);
            const e1 = edge1.end.dot(dir1);
            const s2 = edge2.start.dot(dir1);
            const e2 = edge2.end.dot(dir1);
            const separated1 = e1 < s2;
            const separated2 = s1 < e2;
            if (s1 !== e2 && s2 !== e1 && separated1 === separated2) return false;
            // assign the target output
            if (target) {
                tempDir.subVectors(edge1.start, edge2.start);
                if (tempDir.dot(dir1) > 0) target.start.copy(edge1.start);
                else target.start.copy(edge2.start);
                tempDir.subVectors(edge1.end, edge2.end);
                if (tempDir.dot(dir1) < 0) target.end.copy(edge1.end);
                else target.end.copy(edge2.end);
            }
            return true;
        }
    };
}();
$681270c6f2e9ebff$export$a37f7ec1c23dfacf.prototype.distanceToPoint = function() {
    const target = new (0, $ilwiq.Vector3)();
    return function distanceToPoint(point) {
        this.closestPointToPoint(point, target);
        return point.distanceTo(target);
    };
}();
$681270c6f2e9ebff$export$a37f7ec1c23dfacf.prototype.distanceToTriangle = function() {
    const point = new (0, $ilwiq.Vector3)();
    const point2 = new (0, $ilwiq.Vector3)();
    const cornerFields = [
        "a",
        "b",
        "c"
    ];
    const line1 = new (0, $ilwiq.Line3)();
    const line2 = new (0, $ilwiq.Line3)();
    return function distanceToTriangle(other, target1 = null, target2 = null) {
        const lineTarget = target1 || target2 ? line1 : null;
        if (this.intersectsTriangle(other, lineTarget)) {
            if (target1 || target2) {
                if (target1) lineTarget.getCenter(target1);
                if (target2) lineTarget.getCenter(target2);
            }
            return 0;
        }
        let closestDistanceSq = Infinity;
        // check all point distances
        for(let i = 0; i < 3; i++){
            let dist;
            const field = cornerFields[i];
            const otherVec = other[field];
            this.closestPointToPoint(otherVec, point);
            dist = otherVec.distanceToSquared(point);
            if (dist < closestDistanceSq) {
                closestDistanceSq = dist;
                if (target1) target1.copy(point);
                if (target2) target2.copy(otherVec);
            }
            const thisVec = this[field];
            other.closestPointToPoint(thisVec, point);
            dist = thisVec.distanceToSquared(point);
            if (dist < closestDistanceSq) {
                closestDistanceSq = dist;
                if (target1) target1.copy(thisVec);
                if (target2) target2.copy(point);
            }
        }
        for(let i = 0; i < 3; i++){
            const f11 = cornerFields[i];
            const f12 = cornerFields[(i + 1) % 3];
            line1.set(this[f11], this[f12]);
            for(let i2 = 0; i2 < 3; i2++){
                const f21 = cornerFields[i2];
                const f22 = cornerFields[(i2 + 1) % 3];
                line2.set(other[f21], other[f22]);
                (0, $afac8e64b68760a8$export$b09f296caca7547a)(line1, line2, point, point2);
                const dist = point.distanceToSquared(point2);
                if (dist < closestDistanceSq) {
                    closestDistanceSq = dist;
                    if (target1) target1.copy(point);
                    if (target2) target2.copy(point2);
                }
            }
        }
        return Math.sqrt(closestDistanceSq);
    };
}();



class $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58 {
    constructor(min, max, matrix){
        this.isOrientedBox = true;
        this.min = new (0, $ilwiq.Vector3)();
        this.max = new (0, $ilwiq.Vector3)();
        this.matrix = new (0, $ilwiq.Matrix4)();
        this.invMatrix = new (0, $ilwiq.Matrix4)();
        this.points = new Array(8).fill().map(()=>new (0, $ilwiq.Vector3)());
        this.satAxes = new Array(3).fill().map(()=>new (0, $ilwiq.Vector3)());
        this.satBounds = new Array(3).fill().map(()=>new (0, $20d478469c10be0c$export$f758e41ecdcd8e69)());
        this.alignedSatBounds = new Array(3).fill().map(()=>new (0, $20d478469c10be0c$export$f758e41ecdcd8e69)());
        this.needsUpdate = false;
        if (min) this.min.copy(min);
        if (max) this.max.copy(max);
        if (matrix) this.matrix.copy(matrix);
    }
    set(min, max, matrix) {
        this.min.copy(min);
        this.max.copy(max);
        this.matrix.copy(matrix);
        this.needsUpdate = true;
    }
    copy(other) {
        this.min.copy(other.min);
        this.max.copy(other.max);
        this.matrix.copy(other.matrix);
        this.needsUpdate = true;
    }
}
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.update = function() {
    return function update() {
        const matrix = this.matrix;
        const min = this.min;
        const max = this.max;
        const points = this.points;
        for(let x = 0; x <= 1; x++){
            for(let y = 0; y <= 1; y++)for(let z = 0; z <= 1; z++){
                const i = 1 * x | 2 * y | 4 * z;
                const v = points[i];
                v.x = x ? max.x : min.x;
                v.y = y ? max.y : min.y;
                v.z = z ? max.z : min.z;
                v.applyMatrix4(matrix);
            }
        }
        const satBounds = this.satBounds;
        const satAxes = this.satAxes;
        const minVec = points[0];
        for(let i = 0; i < 3; i++){
            const axis = satAxes[i];
            const sb = satBounds[i];
            const index = 1 << i;
            const pi = points[index];
            axis.subVectors(minVec, pi);
            sb.setFromPoints(axis, points);
        }
        const alignedSatBounds = this.alignedSatBounds;
        alignedSatBounds[0].setFromPointsField(points, "x");
        alignedSatBounds[1].setFromPointsField(points, "y");
        alignedSatBounds[2].setFromPointsField(points, "z");
        this.invMatrix.copy(this.matrix).invert();
        this.needsUpdate = false;
    };
}();
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.intersectsBox = function() {
    const aabbBounds = new (0, $20d478469c10be0c$export$f758e41ecdcd8e69)();
    return function intersectsBox(box) {
        // TODO: should this be doing SAT against the AABB?
        if (this.needsUpdate) this.update();
        const min = box.min;
        const max = box.max;
        const satBounds = this.satBounds;
        const satAxes = this.satAxes;
        const alignedSatBounds = this.alignedSatBounds;
        aabbBounds.min = min.x;
        aabbBounds.max = max.x;
        if (alignedSatBounds[0].isSeparated(aabbBounds)) return false;
        aabbBounds.min = min.y;
        aabbBounds.max = max.y;
        if (alignedSatBounds[1].isSeparated(aabbBounds)) return false;
        aabbBounds.min = min.z;
        aabbBounds.max = max.z;
        if (alignedSatBounds[2].isSeparated(aabbBounds)) return false;
        for(let i = 0; i < 3; i++){
            const axis = satAxes[i];
            const sb = satBounds[i];
            aabbBounds.setFromBox(axis, box);
            if (sb.isSeparated(aabbBounds)) return false;
        }
        return true;
    };
}();
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.intersectsTriangle = function() {
    const saTri = new (0, $681270c6f2e9ebff$export$a37f7ec1c23dfacf)();
    const pointsArr = new Array(3);
    const cachedSatBounds = new (0, $20d478469c10be0c$export$f758e41ecdcd8e69)();
    const cachedSatBounds2 = new (0, $20d478469c10be0c$export$f758e41ecdcd8e69)();
    const cachedAxis = new (0, $ilwiq.Vector3)();
    return function intersectsTriangle(triangle) {
        if (this.needsUpdate) this.update();
        if (!triangle.isExtendedTriangle) {
            saTri.copy(triangle);
            saTri.update();
            triangle = saTri;
        } else if (triangle.needsUpdate) triangle.update();
        const satBounds = this.satBounds;
        const satAxes = this.satAxes;
        pointsArr[0] = triangle.a;
        pointsArr[1] = triangle.b;
        pointsArr[2] = triangle.c;
        for(let i = 0; i < 3; i++){
            const sb = satBounds[i];
            const sa = satAxes[i];
            cachedSatBounds.setFromPoints(sa, pointsArr);
            if (sb.isSeparated(cachedSatBounds)) return false;
        }
        const triSatBounds = triangle.satBounds;
        const triSatAxes = triangle.satAxes;
        const points = this.points;
        for(let i = 0; i < 3; i++){
            const sb = triSatBounds[i];
            const sa = triSatAxes[i];
            cachedSatBounds.setFromPoints(sa, points);
            if (sb.isSeparated(cachedSatBounds)) return false;
        }
        // check crossed axes
        for(let i = 0; i < 3; i++){
            const sa1 = satAxes[i];
            for(let i2 = 0; i2 < 4; i2++){
                const sa2 = triSatAxes[i2];
                cachedAxis.crossVectors(sa1, sa2);
                cachedSatBounds.setFromPoints(cachedAxis, pointsArr);
                cachedSatBounds2.setFromPoints(cachedAxis, points);
                if (cachedSatBounds.isSeparated(cachedSatBounds2)) return false;
            }
        }
        return true;
    };
}();
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.closestPointToPoint = function() {
    return function closestPointToPoint(point, target1) {
        if (this.needsUpdate) this.update();
        target1.copy(point).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix);
        return target1;
    };
}();
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.distanceToPoint = function() {
    const target = new (0, $ilwiq.Vector3)();
    return function distanceToPoint(point) {
        this.closestPointToPoint(point, target);
        return point.distanceTo(target);
    };
}();
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.distanceToBox = function() {
    const xyzFields = [
        "x",
        "y",
        "z"
    ];
    const segments1 = new Array(12).fill().map(()=>new (0, $ilwiq.Line3)());
    const segments2 = new Array(12).fill().map(()=>new (0, $ilwiq.Line3)());
    const point1 = new (0, $ilwiq.Vector3)();
    const point2 = new (0, $ilwiq.Vector3)();
    // early out if we find a value below threshold
    return function distanceToBox(box, threshold = 0, target1 = null, target2 = null) {
        if (this.needsUpdate) this.update();
        if (this.intersectsBox(box)) {
            if (target1 || target2) {
                box.getCenter(point2);
                this.closestPointToPoint(point2, point1);
                box.closestPointToPoint(point1, point2);
                if (target1) target1.copy(point1);
                if (target2) target2.copy(point2);
            }
            return 0;
        }
        const threshold2 = threshold * threshold;
        const min = box.min;
        const max = box.max;
        const points = this.points;
        // iterate over every edge and compare distances
        let closestDistanceSq = Infinity;
        // check over all these points
        for(let i = 0; i < 8; i++){
            const p = points[i];
            point2.copy(p).clamp(min, max);
            const dist = p.distanceToSquared(point2);
            if (dist < closestDistanceSq) {
                closestDistanceSq = dist;
                if (target1) target1.copy(p);
                if (target2) target2.copy(point2);
                if (dist < threshold2) return Math.sqrt(dist);
            }
        }
        // generate and check all line segment distances
        let count = 0;
        for(let i = 0; i < 3; i++){
            for(let i1 = 0; i1 <= 1; i1++)for(let i2 = 0; i2 <= 1; i2++){
                const nextIndex = (i + 1) % 3;
                const nextIndex2 = (i + 2) % 3;
                // get obb line segments
                const index = i1 << nextIndex | i2 << nextIndex2;
                const index2 = 1 << i | i1 << nextIndex | i2 << nextIndex2;
                const p1 = points[index];
                const p2 = points[index2];
                const line1 = segments1[count];
                line1.set(p1, p2);
                // get aabb line segments
                const f1 = xyzFields[i];
                const f2 = xyzFields[nextIndex];
                const f3 = xyzFields[nextIndex2];
                const line2 = segments2[count];
                const start = line2.start;
                const end = line2.end;
                start[f1] = min[f1];
                start[f2] = i1 ? min[f2] : max[f2];
                start[f3] = i2 ? min[f3] : max[f2];
                end[f1] = max[f1];
                end[f2] = i1 ? min[f2] : max[f2];
                end[f3] = i2 ? min[f3] : max[f2];
                count++;
            }
        }
        // check all the other boxes point
        for(let x = 0; x <= 1; x++){
            for(let y = 0; y <= 1; y++)for(let z = 0; z <= 1; z++){
                point2.x = x ? max.x : min.x;
                point2.y = y ? max.y : min.y;
                point2.z = z ? max.z : min.z;
                this.closestPointToPoint(point2, point1);
                const dist = point2.distanceToSquared(point1);
                if (dist < closestDistanceSq) {
                    closestDistanceSq = dist;
                    if (target1) target1.copy(point1);
                    if (target2) target2.copy(point2);
                    if (dist < threshold2) return Math.sqrt(dist);
                }
            }
        }
        for(let i = 0; i < 12; i++){
            const l1 = segments1[i];
            for(let i2 = 0; i2 < 12; i2++){
                const l2 = segments2[i2];
                (0, $afac8e64b68760a8$export$b09f296caca7547a)(l1, l2, point1, point2);
                const dist = point1.distanceToSquared(point2);
                if (dist < closestDistanceSq) {
                    closestDistanceSq = dist;
                    if (target1) target1.copy(point1);
                    if (target2) target2.copy(point2);
                    if (dist < threshold2) return Math.sqrt(dist);
                }
            }
        }
        return Math.sqrt(closestDistanceSq);
    };
}();




class $0f9e1864656e7fae$export$bf300c504651112a {
    constructor(getNewPrimitive){
        this._getNewPrimitive = getNewPrimitive;
        this._primitives = [];
    }
    getPrimitive() {
        const primitives = this._primitives;
        if (primitives.length === 0) return this._getNewPrimitive();
        else return primitives.pop();
    }
    releasePrimitive(primitive) {
        this._primitives.push(primitive);
    }
}


class $593bc8ef8d1a55fc$var$ExtendedTrianglePoolBase extends (0, $0f9e1864656e7fae$export$bf300c504651112a) {
    constructor(){
        super(()=>new (0, $681270c6f2e9ebff$export$a37f7ec1c23dfacf)());
    }
}
const $593bc8ef8d1a55fc$export$2622f4315304edad = /* @__PURE__ */ new $593bc8ef8d1a55fc$var$ExtendedTrianglePoolBase();



var $ilwiq = parcelRequire("ilwiq");




class $064797f1cfb48450$var$_BufferStack {
    constructor(){
        this.float32Array = null;
        this.uint16Array = null;
        this.uint32Array = null;
        const stack = [];
        let prevBuffer = null;
        this.setBuffer = (buffer)=>{
            if (prevBuffer) stack.push(prevBuffer);
            prevBuffer = buffer;
            this.float32Array = new Float32Array(buffer);
            this.uint16Array = new Uint16Array(buffer);
            this.uint32Array = new Uint32Array(buffer);
        };
        this.clearBuffer = ()=>{
            prevBuffer = null;
            this.float32Array = null;
            this.uint16Array = null;
            this.uint32Array = null;
            if (stack.length !== 0) this.setBuffer(stack.pop());
        };
    }
}
const $064797f1cfb48450$export$7451c73ce907854f = new $064797f1cfb48450$var$_BufferStack();


let $6075a1513b66f4c0$var$_box1, $6075a1513b66f4c0$var$_box2;
const $6075a1513b66f4c0$var$boxStack = [];
const $6075a1513b66f4c0$var$boxPool = /* @__PURE__ */ new (0, $0f9e1864656e7fae$export$bf300c504651112a)(()=>new (0, $ilwiq.Box3)());
function $6075a1513b66f4c0$export$963c78622ed2c172(bvh, root, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset) {
    // setup
    $6075a1513b66f4c0$var$_box1 = $6075a1513b66f4c0$var$boxPool.getPrimitive();
    $6075a1513b66f4c0$var$_box2 = $6075a1513b66f4c0$var$boxPool.getPrimitive();
    $6075a1513b66f4c0$var$boxStack.push($6075a1513b66f4c0$var$_box1, $6075a1513b66f4c0$var$_box2);
    (0, $064797f1cfb48450$export$7451c73ce907854f).setBuffer(bvh._roots[root]);
    const result = $6075a1513b66f4c0$var$shapecastTraverse(0, bvh.geometry, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset);
    // cleanup
    (0, $064797f1cfb48450$export$7451c73ce907854f).clearBuffer();
    $6075a1513b66f4c0$var$boxPool.releasePrimitive($6075a1513b66f4c0$var$_box1);
    $6075a1513b66f4c0$var$boxPool.releasePrimitive($6075a1513b66f4c0$var$_box2);
    $6075a1513b66f4c0$var$boxStack.pop();
    $6075a1513b66f4c0$var$boxStack.pop();
    const length = $6075a1513b66f4c0$var$boxStack.length;
    if (length > 0) {
        $6075a1513b66f4c0$var$_box2 = $6075a1513b66f4c0$var$boxStack[length - 1];
        $6075a1513b66f4c0$var$_box1 = $6075a1513b66f4c0$var$boxStack[length - 2];
    }
    return result;
}
function $6075a1513b66f4c0$var$shapecastTraverse(nodeIndex32, geometry, intersectsBoundsFunc, intersectsRangeFunc, nodeScoreFunc = null, nodeIndexByteOffset = 0, depth = 0) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $064797f1cfb48450$export$7451c73ce907854f);
    let nodeIndex16 = nodeIndex32 * 2;
    const isLeaf = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const offset = (0, $6363300ccf15b961$export$3231e969238304f3)(nodeIndex32, uint32Array);
        const count = (0, $6363300ccf15b961$export$d61684373eacdf61)(nodeIndex16, uint16Array);
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(nodeIndex32), float32Array, $6075a1513b66f4c0$var$_box1);
        return intersectsRangeFunc(offset, count, false, depth, nodeIndexByteOffset + nodeIndex32, $6075a1513b66f4c0$var$_box1);
    } else {
        const left = (0, $6363300ccf15b961$export$7a68bc00425859d)(nodeIndex32);
        const right = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(nodeIndex32, uint32Array);
        let c1 = left;
        let c2 = right;
        let score1, score2;
        let box1, box2;
        if (nodeScoreFunc) {
            box1 = $6075a1513b66f4c0$var$_box1;
            box2 = $6075a1513b66f4c0$var$_box2;
            // bounding data is not offset
            (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(c1), float32Array, box1);
            (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(c2), float32Array, box2);
            score1 = nodeScoreFunc(box1);
            score2 = nodeScoreFunc(box2);
            if (score2 < score1) {
                c1 = right;
                c2 = left;
                const temp = score1;
                score1 = score2;
                score2 = temp;
                box1 = box2;
            // box2 is always set before use below
            }
        }
        // Check box 1 intersection
        if (!box1) {
            box1 = $6075a1513b66f4c0$var$_box1;
            (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(c1), float32Array, box1);
        }
        const isC1Leaf = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(c1 * 2, uint16Array);
        const c1Intersection = intersectsBoundsFunc(box1, isC1Leaf, score1, depth + 1, nodeIndexByteOffset + c1);
        let c1StopTraversal;
        if (c1Intersection === (0, $78926744db4a8a3e$export$82ad94f0a038b67a)) {
            const offset = getLeftOffset(c1);
            const end = getRightEndOffset(c1);
            const count = end - offset;
            c1StopTraversal = intersectsRangeFunc(offset, count, true, depth + 1, nodeIndexByteOffset + c1, box1);
        } else c1StopTraversal = c1Intersection && $6075a1513b66f4c0$var$shapecastTraverse(c1, geometry, intersectsBoundsFunc, intersectsRangeFunc, nodeScoreFunc, nodeIndexByteOffset, depth + 1);
        if (c1StopTraversal) return true;
        // Check box 2 intersection
        // cached box2 will have been overwritten by previous traversal
        box2 = $6075a1513b66f4c0$var$_box2;
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(c2), float32Array, box2);
        const isC2Leaf = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(c2 * 2, uint16Array);
        const c2Intersection = intersectsBoundsFunc(box2, isC2Leaf, score2, depth + 1, nodeIndexByteOffset + c2);
        let c2StopTraversal;
        if (c2Intersection === (0, $78926744db4a8a3e$export$82ad94f0a038b67a)) {
            const offset = getLeftOffset(c2);
            const end = getRightEndOffset(c2);
            const count = end - offset;
            c2StopTraversal = intersectsRangeFunc(offset, count, true, depth + 1, nodeIndexByteOffset + c2, box2);
        } else c2StopTraversal = c2Intersection && $6075a1513b66f4c0$var$shapecastTraverse(c2, geometry, intersectsBoundsFunc, intersectsRangeFunc, nodeScoreFunc, nodeIndexByteOffset, depth + 1);
        if (c2StopTraversal) return true;
        return false;
        // Define these inside the function so it has access to the local variables needed
        // when converting to the buffer equivalents
        function getLeftOffset(nodeIndex32) {
            const { uint16Array: uint16Array, uint32Array: uint32Array } = (0, $064797f1cfb48450$export$7451c73ce907854f);
            let nodeIndex16 = nodeIndex32 * 2;
            // traverse until we find a leaf
            while(!(0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(nodeIndex16, uint16Array)){
                nodeIndex32 = (0, $6363300ccf15b961$export$7a68bc00425859d)(nodeIndex32);
                nodeIndex16 = nodeIndex32 * 2;
            }
            return (0, $6363300ccf15b961$export$3231e969238304f3)(nodeIndex32, uint32Array);
        }
        function getRightEndOffset(nodeIndex32) {
            const { uint16Array: uint16Array, uint32Array: uint32Array } = (0, $064797f1cfb48450$export$7451c73ce907854f);
            let nodeIndex16 = nodeIndex32 * 2;
            // traverse until we find a leaf
            while(!(0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(nodeIndex16, uint16Array)){
                // adjust offset to point to the right node
                nodeIndex32 = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(nodeIndex32, uint32Array);
                nodeIndex16 = nodeIndex32 * 2;
            }
            // return the end offset of the triangle range
            return (0, $6363300ccf15b961$export$3231e969238304f3)(nodeIndex32, uint32Array) + (0, $6363300ccf15b961$export$d61684373eacdf61)(nodeIndex16, uint16Array);
        }
    }
}



var $ilwiq = parcelRequire("ilwiq");
const $67f4708097c33efc$var$temp = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $67f4708097c33efc$var$temp1 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
function $67f4708097c33efc$export$96ec44700e587d99(bvh, point, target = {}, minThreshold = 0, maxThreshold = Infinity) {
    // early out if under minThreshold
    // skip checking if over maxThreshold
    // set minThreshold = maxThreshold to quickly check if a point is within a threshold
    // returns Infinity if no value found
    const minThresholdSq = minThreshold * minThreshold;
    const maxThresholdSq = maxThreshold * maxThreshold;
    let closestDistanceSq = Infinity;
    let closestDistanceTriIndex = null;
    bvh.shapecast({
        boundsTraverseOrder: (box)=>{
            $67f4708097c33efc$var$temp.copy(point).clamp(box.min, box.max);
            return $67f4708097c33efc$var$temp.distanceToSquared(point);
        },
        intersectsBounds: (box, isLeaf, score)=>{
            return score < closestDistanceSq && score < maxThresholdSq;
        },
        intersectsTriangle: (tri, triIndex)=>{
            tri.closestPointToPoint(point, $67f4708097c33efc$var$temp);
            const distSq = point.distanceToSquared($67f4708097c33efc$var$temp);
            if (distSq < closestDistanceSq) {
                $67f4708097c33efc$var$temp1.copy($67f4708097c33efc$var$temp);
                closestDistanceSq = distSq;
                closestDistanceTriIndex = triIndex;
            }
            if (distSq < minThresholdSq) return true;
            else return false;
        }
    });
    if (closestDistanceSq === Infinity) return null;
    const closestDistance = Math.sqrt(closestDistanceSq);
    if (!target.point) target.point = $67f4708097c33efc$var$temp1.clone();
    else target.point.copy($67f4708097c33efc$var$temp1);
    target.distance = closestDistance, target.faceIndex = closestDistanceTriIndex;
    return target;
}



var $ilwiq = parcelRequire("ilwiq");
const $5664c169f49816c4$var$IS_GT_REVISION_169 = parseInt((0, $ilwiq.REVISION)) >= 169;
// Ripped and modified From THREE.js Mesh raycast
// https://github.com/mrdoob/three.js/blob/0aa87c999fe61e216c1133fba7a95772b503eddf/src/objects/Mesh.js#L115
const $5664c169f49816c4$var$_vA = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_vB = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_vC = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_uvA = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
const $5664c169f49816c4$var$_uvB = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
const $5664c169f49816c4$var$_uvC = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
const $5664c169f49816c4$var$_normalA = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_normalB = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_normalC = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_intersectionPoint = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
function $5664c169f49816c4$var$checkIntersection(ray, pA, pB, pC, point, side, near, far) {
    let intersect;
    if (side === (0, $ilwiq.BackSide)) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, side !== (0, $ilwiq.DoubleSide), point);
    if (intersect === null) return null;
    const distance = ray.origin.distanceTo(point);
    if (distance < near || distance > far) return null;
    return {
        distance: distance,
        point: point.clone()
    };
}
function $5664c169f49816c4$var$checkBufferGeometryIntersection(ray, position, normal, uv, uv1, a, b, c, side, near, far) {
    $5664c169f49816c4$var$_vA.fromBufferAttribute(position, a);
    $5664c169f49816c4$var$_vB.fromBufferAttribute(position, b);
    $5664c169f49816c4$var$_vC.fromBufferAttribute(position, c);
    const intersection = $5664c169f49816c4$var$checkIntersection(ray, $5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, $5664c169f49816c4$var$_intersectionPoint, side, near, far);
    if (intersection) {
        const barycoord = new (0, $ilwiq.Vector3)();
        (0, $ilwiq.Triangle).getBarycoord($5664c169f49816c4$var$_intersectionPoint, $5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, barycoord);
        if (uv) {
            $5664c169f49816c4$var$_uvA.fromBufferAttribute(uv, a);
            $5664c169f49816c4$var$_uvB.fromBufferAttribute(uv, b);
            $5664c169f49816c4$var$_uvC.fromBufferAttribute(uv, c);
            intersection.uv = (0, $ilwiq.Triangle).getInterpolation($5664c169f49816c4$var$_intersectionPoint, $5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, $5664c169f49816c4$var$_uvA, $5664c169f49816c4$var$_uvB, $5664c169f49816c4$var$_uvC, new (0, $ilwiq.Vector2)());
        }
        if (uv1) {
            $5664c169f49816c4$var$_uvA.fromBufferAttribute(uv1, a);
            $5664c169f49816c4$var$_uvB.fromBufferAttribute(uv1, b);
            $5664c169f49816c4$var$_uvC.fromBufferAttribute(uv1, c);
            intersection.uv1 = (0, $ilwiq.Triangle).getInterpolation($5664c169f49816c4$var$_intersectionPoint, $5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, $5664c169f49816c4$var$_uvA, $5664c169f49816c4$var$_uvB, $5664c169f49816c4$var$_uvC, new (0, $ilwiq.Vector2)());
        }
        if (normal) {
            $5664c169f49816c4$var$_normalA.fromBufferAttribute(normal, a);
            $5664c169f49816c4$var$_normalB.fromBufferAttribute(normal, b);
            $5664c169f49816c4$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = (0, $ilwiq.Triangle).getInterpolation($5664c169f49816c4$var$_intersectionPoint, $5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, $5664c169f49816c4$var$_normalA, $5664c169f49816c4$var$_normalB, $5664c169f49816c4$var$_normalC, new (0, $ilwiq.Vector3)());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new (0, $ilwiq.Vector3)(),
            materialIndex: 0
        };
        (0, $ilwiq.Triangle).getNormal($5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, face.normal);
        intersection.face = face;
        intersection.faceIndex = a;
        if ($5664c169f49816c4$var$IS_GT_REVISION_169) intersection.barycoord = barycoord;
    }
    return intersection;
}
// https://github.com/mrdoob/three.js/blob/0aa87c999fe61e216c1133fba7a95772b503eddf/src/objects/Mesh.js#L258
function $5664c169f49816c4$export$1a557053019a130b(geo, side, ray, tri, intersections, near, far) {
    const triOffset = tri * 3;
    let a = triOffset + 0;
    let b = triOffset + 1;
    let c = triOffset + 2;
    const index = geo.index;
    if (geo.index) {
        a = index.getX(a);
        b = index.getX(b);
        c = index.getX(c);
    }
    const { position: position, normal: normal, uv: uv, uv1: uv1 } = geo.attributes;
    const intersection = $5664c169f49816c4$var$checkBufferGeometryIntersection(ray, position, normal, uv, uv1, a, b, c, side, near, far);
    if (intersection) {
        intersection.faceIndex = tri;
        if (intersections) intersections.push(intersection);
        return intersection;
    }
    return null;
}



var $ilwiq = parcelRequire("ilwiq");
function $a17a0e7ef0b826e6$export$32f7fa781964ae30(tri, i, index, pos) {
    const ta = tri.a;
    const tb = tri.b;
    const tc = tri.c;
    let i0 = i;
    let i1 = i + 1;
    let i2 = i + 2;
    if (index) {
        i0 = index.getX(i0);
        i1 = index.getX(i1);
        i2 = index.getX(i2);
    }
    ta.x = pos.getX(i0);
    ta.y = pos.getY(i0);
    ta.z = pos.getZ(i0);
    tb.x = pos.getX(i1);
    tb.y = pos.getY(i1);
    tb.z = pos.getZ(i1);
    tc.x = pos.getX(i2);
    tc.y = pos.getY(i2);
    tc.z = pos.getZ(i2);
}
const $a17a0e7ef0b826e6$var$tempV1 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $a17a0e7ef0b826e6$var$tempV2 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $a17a0e7ef0b826e6$var$tempV3 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $a17a0e7ef0b826e6$var$tempUV1 = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
const $a17a0e7ef0b826e6$var$tempUV2 = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
const $a17a0e7ef0b826e6$var$tempUV3 = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
function $a17a0e7ef0b826e6$export$d3cf03f2575167ef(point, geometry, triangleIndex, target) {
    const indices = geometry.getIndex().array;
    const positions = geometry.getAttribute("position");
    const uvs = geometry.getAttribute("uv");
    const a = indices[triangleIndex * 3];
    const b = indices[triangleIndex * 3 + 1];
    const c = indices[triangleIndex * 3 + 2];
    $a17a0e7ef0b826e6$var$tempV1.fromBufferAttribute(positions, a);
    $a17a0e7ef0b826e6$var$tempV2.fromBufferAttribute(positions, b);
    $a17a0e7ef0b826e6$var$tempV3.fromBufferAttribute(positions, c);
    // find the associated material index
    let materialIndex = 0;
    const groups = geometry.groups;
    const firstVertexIndex = triangleIndex * 3;
    for(let i = 0, l = groups.length; i < l; i++){
        const group = groups[i];
        const { start: start, count: count } = group;
        if (firstVertexIndex >= start && firstVertexIndex < start + count) {
            materialIndex = group.materialIndex;
            break;
        }
    }
    // extract barycoord
    const barycoord = target && target.barycoord ? target.barycoord : new (0, $ilwiq.Vector3)();
    (0, $ilwiq.Triangle).getBarycoord(point, $a17a0e7ef0b826e6$var$tempV1, $a17a0e7ef0b826e6$var$tempV2, $a17a0e7ef0b826e6$var$tempV3, barycoord);
    // extract uvs
    let uv = null;
    if (uvs) {
        $a17a0e7ef0b826e6$var$tempUV1.fromBufferAttribute(uvs, a);
        $a17a0e7ef0b826e6$var$tempUV2.fromBufferAttribute(uvs, b);
        $a17a0e7ef0b826e6$var$tempUV3.fromBufferAttribute(uvs, c);
        if (target && target.uv) uv = target.uv;
        else uv = new (0, $ilwiq.Vector2)();
        (0, $ilwiq.Triangle).getInterpolation(point, $a17a0e7ef0b826e6$var$tempV1, $a17a0e7ef0b826e6$var$tempV2, $a17a0e7ef0b826e6$var$tempV3, $a17a0e7ef0b826e6$var$tempUV1, $a17a0e7ef0b826e6$var$tempUV2, $a17a0e7ef0b826e6$var$tempUV3, uv);
    }
    // adjust the provided target or create a new one
    if (target) {
        if (!target.face) target.face = {};
        target.face.a = a;
        target.face.b = b;
        target.face.c = c;
        target.face.materialIndex = materialIndex;
        if (!target.face.normal) target.face.normal = new (0, $ilwiq.Vector3)();
        (0, $ilwiq.Triangle).getNormal($a17a0e7ef0b826e6$var$tempV1, $a17a0e7ef0b826e6$var$tempV2, $a17a0e7ef0b826e6$var$tempV3, target.face.normal);
        if (uv) target.uv = uv;
        target.barycoord = barycoord;
        return target;
    } else return {
        face: {
            a: a,
            b: b,
            c: c,
            materialIndex: materialIndex,
            normal: (0, $ilwiq.Triangle).getNormal($a17a0e7ef0b826e6$var$tempV1, $a17a0e7ef0b826e6$var$tempV2, $a17a0e7ef0b826e6$var$tempV3, new (0, $ilwiq.Vector3)())
        },
        uv: uv,
        barycoord: barycoord
    };
}


/*************************************************************/ /* This file is generated from "iterationUtils.template.js". */ /*************************************************************/ /* eslint-disable indent */ function $01d4f4206273ed95$export$6f0a8fc5d2775a51(bvh, side, ray, offset, count, intersections, near, far) {
    const { geometry: geometry, _indirectBuffer: _indirectBuffer } = bvh;
    for(let i = offset, end = offset + count; i < end; i++)(0, $5664c169f49816c4$export$1a557053019a130b)(geometry, side, ray, i, intersections, near, far);
}
function $01d4f4206273ed95$export$4331f2604b0bca4(bvh, side, ray, offset, count, near, far) {
    const { geometry: geometry, _indirectBuffer: _indirectBuffer } = bvh;
    let dist = Infinity;
    let res = null;
    for(let i = offset, end = offset + count; i < end; i++){
        let intersection;
        intersection = (0, $5664c169f49816c4$export$1a557053019a130b)(geometry, side, ray, i, null, near, far);
        if (intersection && intersection.distance < dist) {
            res = intersection;
            dist = intersection.distance;
        }
    }
    return res;
}
function $01d4f4206273ed95$export$be1391b7aa79c0f6(offset, count, bvh, intersectsTriangleFunc, contained, depth, triangle) {
    const { geometry: geometry } = bvh;
    const { index: index } = geometry;
    const pos = geometry.attributes.position;
    for(let i = offset, l = count + offset; i < l; i++){
        let tri;
        tri = i;
        (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle, tri * 3, index, pos);
        triangle.needsUpdate = true;
        if (intersectsTriangleFunc(triangle, tri, contained, depth)) return true;
    }
    return false;
}



/****************************************************/ /* This file is generated from "refit.template.js". */ /****************************************************/ function $7afeb992771d32d5$export$8eb1eda96b2e6d7a(bvh, nodeIndices = null) {
    if (nodeIndices && Array.isArray(nodeIndices)) nodeIndices = new Set(nodeIndices);
    const geometry = bvh.geometry;
    const indexArr = geometry.index ? geometry.index.array : null;
    const posAttr = geometry.attributes.position;
    let buffer, uint32Array, uint16Array, float32Array;
    let byteOffset = 0;
    const roots = bvh._roots;
    for(let i = 0, l = roots.length; i < l; i++){
        buffer = roots[i];
        uint32Array = new Uint32Array(buffer);
        uint16Array = new Uint16Array(buffer);
        float32Array = new Float32Array(buffer);
        _traverse(0, byteOffset);
        byteOffset += buffer.byteLength;
    }
    function _traverse(node32Index, byteOffset, force = false) {
        const node16Index = node32Index * 2;
        const isLeaf = uint16Array[node16Index + 15] === (0, $78926744db4a8a3e$export$661fddb62bfe0e42);
        if (isLeaf) {
            const offset = uint32Array[node32Index + 6];
            const count = uint16Array[node16Index + 14];
            let minx = Infinity;
            let miny = Infinity;
            let minz = Infinity;
            let maxx = -Infinity;
            let maxy = -Infinity;
            let maxz = -Infinity;
            for(let i = 3 * offset, l = 3 * (offset + count); i < l; i++){
                let index = indexArr[i];
                const x = posAttr.getX(index);
                const y = posAttr.getY(index);
                const z = posAttr.getZ(index);
                if (x < minx) minx = x;
                if (x > maxx) maxx = x;
                if (y < miny) miny = y;
                if (y > maxy) maxy = y;
                if (z < minz) minz = z;
                if (z > maxz) maxz = z;
            }
            if (float32Array[node32Index + 0] !== minx || float32Array[node32Index + 1] !== miny || float32Array[node32Index + 2] !== minz || float32Array[node32Index + 3] !== maxx || float32Array[node32Index + 4] !== maxy || float32Array[node32Index + 5] !== maxz) {
                float32Array[node32Index + 0] = minx;
                float32Array[node32Index + 1] = miny;
                float32Array[node32Index + 2] = minz;
                float32Array[node32Index + 3] = maxx;
                float32Array[node32Index + 4] = maxy;
                float32Array[node32Index + 5] = maxz;
                return true;
            } else return false;
        } else {
            const left = node32Index + 8;
            const right = uint32Array[node32Index + 6];
            // the identifying node indices provided by the shapecast function include offsets of all
            // root buffers to guarantee they're unique between roots so offset left and right indices here.
            const offsetLeft = left + byteOffset;
            const offsetRight = right + byteOffset;
            let forceChildren = force;
            let includesLeft = false;
            let includesRight = false;
            if (nodeIndices) // if we see that neither the left or right child are included in the set that need to be updated
            // then we assume that all children need to be updated.
            {
                if (!forceChildren) {
                    includesLeft = nodeIndices.has(offsetLeft);
                    includesRight = nodeIndices.has(offsetRight);
                    forceChildren = !includesLeft && !includesRight;
                }
            } else {
                includesLeft = true;
                includesRight = true;
            }
            const traverseLeft = forceChildren || includesLeft;
            const traverseRight = forceChildren || includesRight;
            let leftChange = false;
            if (traverseLeft) leftChange = _traverse(left, byteOffset, forceChildren);
            let rightChange = false;
            if (traverseRight) rightChange = _traverse(right, byteOffset, forceChildren);
            const didChange = leftChange || rightChange;
            if (didChange) for(let i = 0; i < 3; i++){
                const lefti = left + i;
                const righti = right + i;
                const minLeftValue = float32Array[lefti];
                const maxLeftValue = float32Array[lefti + 3];
                const minRightValue = float32Array[righti];
                const maxRightValue = float32Array[righti + 3];
                float32Array[node32Index + i] = minLeftValue < minRightValue ? minLeftValue : minRightValue;
                float32Array[node32Index + i + 3] = maxLeftValue > maxRightValue ? maxLeftValue : maxRightValue;
            }
            return didChange;
        }
    }
}


/**
 * This function performs intersection tests similar to Ray.intersectBox in three.js,
 * with the difference that the box values are read from an array to improve performance.
 */ function $98440f459aa220f3$export$d5a069a08bb68982(nodeIndex32, array, ray, near, far) {
    let tmin, tmax, tymin, tymax, tzmin, tzmax;
    const invdirx = 1 / ray.direction.x, invdiry = 1 / ray.direction.y, invdirz = 1 / ray.direction.z;
    const ox = ray.origin.x;
    const oy = ray.origin.y;
    const oz = ray.origin.z;
    let minx = array[nodeIndex32];
    let maxx = array[nodeIndex32 + 3];
    let miny = array[nodeIndex32 + 1];
    let maxy = array[nodeIndex32 + 3 + 1];
    let minz = array[nodeIndex32 + 2];
    let maxz = array[nodeIndex32 + 3 + 2];
    if (invdirx >= 0) {
        tmin = (minx - ox) * invdirx;
        tmax = (maxx - ox) * invdirx;
    } else {
        tmin = (maxx - ox) * invdirx;
        tmax = (minx - ox) * invdirx;
    }
    if (invdiry >= 0) {
        tymin = (miny - oy) * invdiry;
        tymax = (maxy - oy) * invdiry;
    } else {
        tymin = (maxy - oy) * invdiry;
        tymax = (miny - oy) * invdiry;
    }
    if (tmin > tymax || tymin > tmax) return false;
    if (tymin > tmin || isNaN(tmin)) tmin = tymin;
    if (tymax < tmax || isNaN(tmax)) tmax = tymax;
    if (invdirz >= 0) {
        tzmin = (minz - oz) * invdirz;
        tzmax = (maxz - oz) * invdirz;
    } else {
        tzmin = (maxz - oz) * invdirz;
        tzmax = (minz - oz) * invdirz;
    }
    if (tmin > tzmax || tzmin > tmax) return false;
    if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
    if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
    //return point closest to the ray (positive side)
    return tmin <= far && tmax >= near;
}






/******************************************************/ /* This file is generated from "raycast.template.js". */ /******************************************************/ function $f6a695dbb681b4c5$export$630e89aab3ddc1d6(bvh, root, side, ray, intersects, near, far) {
    (0, $064797f1cfb48450$export$7451c73ce907854f).setBuffer(bvh._roots[root]);
    $f6a695dbb681b4c5$var$_raycast(0, bvh, side, ray, intersects, near, far);
    (0, $064797f1cfb48450$export$7451c73ce907854f).clearBuffer();
}
function $f6a695dbb681b4c5$var$_raycast(nodeIndex32, bvh, side, ray, intersects, near, far) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $064797f1cfb48450$export$7451c73ce907854f);
    const nodeIndex16 = nodeIndex32 * 2;
    const isLeaf = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const offset = (0, $6363300ccf15b961$export$3231e969238304f3)(nodeIndex32, uint32Array);
        const count = (0, $6363300ccf15b961$export$d61684373eacdf61)(nodeIndex16, uint16Array);
        (0, $01d4f4206273ed95$export$6f0a8fc5d2775a51)(bvh, side, ray, offset, count, intersects, near, far);
    } else {
        const leftIndex = (0, $6363300ccf15b961$export$7a68bc00425859d)(nodeIndex32);
        if ((0, $98440f459aa220f3$export$d5a069a08bb68982)(leftIndex, float32Array, ray, near, far)) $f6a695dbb681b4c5$var$_raycast(leftIndex, bvh, side, ray, intersects, near, far);
        const rightIndex = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(nodeIndex32, uint32Array);
        if ((0, $98440f459aa220f3$export$d5a069a08bb68982)(rightIndex, float32Array, ray, near, far)) $f6a695dbb681b4c5$var$_raycast(rightIndex, bvh, side, ray, intersects, near, far);
    }
}







/***********************************************************/ /* This file is generated from "raycastFirst.template.js". */ /***********************************************************/ const $15dd3f9915d1b1ff$var$_xyzFields = [
    "x",
    "y",
    "z"
];
function $15dd3f9915d1b1ff$export$1fa457bc72ef1a2a(bvh, root, side, ray, near, far) {
    (0, $064797f1cfb48450$export$7451c73ce907854f).setBuffer(bvh._roots[root]);
    const result = $15dd3f9915d1b1ff$var$_raycastFirst(0, bvh, side, ray, near, far);
    (0, $064797f1cfb48450$export$7451c73ce907854f).clearBuffer();
    return result;
}
function $15dd3f9915d1b1ff$var$_raycastFirst(nodeIndex32, bvh, side, ray, near, far) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $064797f1cfb48450$export$7451c73ce907854f);
    let nodeIndex16 = nodeIndex32 * 2;
    const isLeaf = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const offset = (0, $6363300ccf15b961$export$3231e969238304f3)(nodeIndex32, uint32Array);
        const count = (0, $6363300ccf15b961$export$d61684373eacdf61)(nodeIndex16, uint16Array);
        // eslint-disable-next-line no-unreachable
        return (0, $01d4f4206273ed95$export$4331f2604b0bca4)(bvh, side, ray, offset, count, near, far);
    } else {
        // consider the position of the split plane with respect to the oncoming ray; whichever direction
        // the ray is coming from, look for an intersection among that side of the tree first
        const splitAxis = (0, $6363300ccf15b961$export$b43717b3ca95505)(nodeIndex32, uint32Array);
        const xyzAxis = $15dd3f9915d1b1ff$var$_xyzFields[splitAxis];
        const rayDir = ray.direction[xyzAxis];
        const leftToRight = rayDir >= 0;
        // c1 is the child to check first
        let c1, c2;
        if (leftToRight) {
            c1 = (0, $6363300ccf15b961$export$7a68bc00425859d)(nodeIndex32);
            c2 = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(nodeIndex32, uint32Array);
        } else {
            c1 = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(nodeIndex32, uint32Array);
            c2 = (0, $6363300ccf15b961$export$7a68bc00425859d)(nodeIndex32);
        }
        const c1Intersection = (0, $98440f459aa220f3$export$d5a069a08bb68982)(c1, float32Array, ray, near, far);
        const c1Result = c1Intersection ? $15dd3f9915d1b1ff$var$_raycastFirst(c1, bvh, side, ray, near, far) : null;
        // if we got an intersection in the first node and it's closer than the second node's bounding
        // box, we don't need to consider the second node because it couldn't possibly be a better result
        if (c1Result) {
            // check if the point is within the second bounds
            // "point" is in the local frame of the bvh
            const point = c1Result.point[xyzAxis];
            const isOutside = leftToRight ? point <= float32Array[c2 + splitAxis] : point >= float32Array[c2 + splitAxis + 3]; // max bounding data
            if (isOutside) return c1Result;
        }
        // either there was no intersection in the first node, or there could still be a closer
        // intersection in the second, so check the second node and then take the better of the two
        const c2Intersection = (0, $98440f459aa220f3$export$d5a069a08bb68982)(c2, float32Array, ray, near, far);
        const c2Result = c2Intersection ? $15dd3f9915d1b1ff$var$_raycastFirst(c2, bvh, side, ray, near, far) : null;
        if (c1Result && c2Result) return c1Result.distance <= c2Result.distance ? c1Result : c2Result;
        else return c1Result || c2Result || null;
    }
}



var $ilwiq = parcelRequire("ilwiq");






/*****************************************************************/ /* This file is generated from "intersectsGeometry.template.js". */ /*****************************************************************/ /* eslint-disable indent */ const $9acb57256233c065$var$boundingBox = /* @__PURE__ */ new (0, $ilwiq.Box3)();
const $9acb57256233c065$var$triangle = /* @__PURE__ */ new (0, $681270c6f2e9ebff$export$a37f7ec1c23dfacf)();
const $9acb57256233c065$var$triangle2 = /* @__PURE__ */ new (0, $681270c6f2e9ebff$export$a37f7ec1c23dfacf)();
const $9acb57256233c065$var$invertedMat = /* @__PURE__ */ new (0, $ilwiq.Matrix4)();
const $9acb57256233c065$var$obb = /* @__PURE__ */ new (0, $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58)();
const $9acb57256233c065$var$obb2 = /* @__PURE__ */ new (0, $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58)();
function $9acb57256233c065$export$b2f96b0abaf94e0a(bvh, root, otherGeometry, geometryToBvh) {
    (0, $064797f1cfb48450$export$7451c73ce907854f).setBuffer(bvh._roots[root]);
    const result = $9acb57256233c065$var$_intersectsGeometry(0, bvh, otherGeometry, geometryToBvh);
    (0, $064797f1cfb48450$export$7451c73ce907854f).clearBuffer();
    return result;
}
function $9acb57256233c065$var$_intersectsGeometry(nodeIndex32, bvh, otherGeometry, geometryToBvh, cachedObb = null) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $064797f1cfb48450$export$7451c73ce907854f);
    let nodeIndex16 = nodeIndex32 * 2;
    if (cachedObb === null) {
        if (!otherGeometry.boundingBox) otherGeometry.computeBoundingBox();
        $9acb57256233c065$var$obb.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
        cachedObb = $9acb57256233c065$var$obb;
    }
    const isLeaf = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const thisGeometry = bvh.geometry;
        const thisIndex = thisGeometry.index;
        const thisPos = thisGeometry.attributes.position;
        const index = otherGeometry.index;
        const pos = otherGeometry.attributes.position;
        const offset = (0, $6363300ccf15b961$export$3231e969238304f3)(nodeIndex32, uint32Array);
        const count = (0, $6363300ccf15b961$export$d61684373eacdf61)(nodeIndex16, uint16Array);
        // get the inverse of the geometry matrix so we can transform our triangles into the
        // geometry space we're trying to test. We assume there are fewer triangles being checked
        // here.
        $9acb57256233c065$var$invertedMat.copy(geometryToBvh).invert();
        if (otherGeometry.boundsTree) {
            // if there's a bounds tree
            (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(nodeIndex32), float32Array, $9acb57256233c065$var$obb2);
            $9acb57256233c065$var$obb2.matrix.copy($9acb57256233c065$var$invertedMat);
            $9acb57256233c065$var$obb2.needsUpdate = true;
            // TODO: use a triangle iteration function here
            const res = otherGeometry.boundsTree.shapecast({
                intersectsBounds: (box)=>$9acb57256233c065$var$obb2.intersectsBox(box),
                intersectsTriangle: (tri)=>{
                    tri.a.applyMatrix4(geometryToBvh);
                    tri.b.applyMatrix4(geometryToBvh);
                    tri.c.applyMatrix4(geometryToBvh);
                    tri.needsUpdate = true;
                    for(let i = offset * 3, l = (count + offset) * 3; i < l; i += 3){
                        // this triangle needs to be transformed into the current BVH coordinate frame
                        (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)($9acb57256233c065$var$triangle2, i, thisIndex, thisPos);
                        $9acb57256233c065$var$triangle2.needsUpdate = true;
                        if (tri.intersectsTriangle($9acb57256233c065$var$triangle2)) return true;
                    }
                    return false;
                }
            });
            return res;
        } else // if we're just dealing with raw geometry
        for(let i = offset * 3, l = (count + offset) * 3; i < l; i += 3){
            // this triangle needs to be transformed into the current BVH coordinate frame
            (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)($9acb57256233c065$var$triangle, i, thisIndex, thisPos);
            $9acb57256233c065$var$triangle.a.applyMatrix4($9acb57256233c065$var$invertedMat);
            $9acb57256233c065$var$triangle.b.applyMatrix4($9acb57256233c065$var$invertedMat);
            $9acb57256233c065$var$triangle.c.applyMatrix4($9acb57256233c065$var$invertedMat);
            $9acb57256233c065$var$triangle.needsUpdate = true;
            for(let i2 = 0, l2 = index.count; i2 < l2; i2 += 3){
                (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)($9acb57256233c065$var$triangle2, i2, index, pos);
                $9acb57256233c065$var$triangle2.needsUpdate = true;
                if ($9acb57256233c065$var$triangle.intersectsTriangle($9acb57256233c065$var$triangle2)) return true;
            }
        }
    } else {
        const left = nodeIndex32 + 8;
        const right = uint32Array[nodeIndex32 + 6];
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(left), float32Array, $9acb57256233c065$var$boundingBox);
        const leftIntersection = cachedObb.intersectsBox($9acb57256233c065$var$boundingBox) && $9acb57256233c065$var$_intersectsGeometry(left, bvh, otherGeometry, geometryToBvh, cachedObb);
        if (leftIntersection) return true;
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(right), float32Array, $9acb57256233c065$var$boundingBox);
        const rightIntersection = cachedObb.intersectsBox($9acb57256233c065$var$boundingBox) && $9acb57256233c065$var$_intersectsGeometry(right, bvh, otherGeometry, geometryToBvh, cachedObb);
        if (rightIntersection) return true;
        return false;
    }
}



var $ilwiq = parcelRequire("ilwiq");




/*********************************************************************/ /* This file is generated from "closestPointToGeometry.template.js". */ /*********************************************************************/ const $9be714d2e19cc068$var$tempMatrix = /* @__PURE__ */ new (0, $ilwiq.Matrix4)();
const $9be714d2e19cc068$var$obb = /* @__PURE__ */ new (0, $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58)();
const $9be714d2e19cc068$var$obb2 = /* @__PURE__ */ new (0, $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58)();
const $9be714d2e19cc068$var$temp1 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $9be714d2e19cc068$var$temp2 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $9be714d2e19cc068$var$temp3 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $9be714d2e19cc068$var$temp4 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
function $9be714d2e19cc068$export$5912902c175a555e(bvh, otherGeometry, geometryToBvh, target1 = {}, target2 = {}, minThreshold = 0, maxThreshold = Infinity) {
    if (!otherGeometry.boundingBox) otherGeometry.computeBoundingBox();
    $9be714d2e19cc068$var$obb.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
    $9be714d2e19cc068$var$obb.needsUpdate = true;
    const geometry = bvh.geometry;
    const pos = geometry.attributes.position;
    const index = geometry.index;
    const otherPos = otherGeometry.attributes.position;
    const otherIndex = otherGeometry.index;
    const triangle = (0, $593bc8ef8d1a55fc$export$2622f4315304edad).getPrimitive();
    const triangle2 = (0, $593bc8ef8d1a55fc$export$2622f4315304edad).getPrimitive();
    let tempTarget1 = $9be714d2e19cc068$var$temp1;
    let tempTargetDest1 = $9be714d2e19cc068$var$temp2;
    let tempTarget2 = null;
    let tempTargetDest2 = null;
    if (target2) {
        tempTarget2 = $9be714d2e19cc068$var$temp3;
        tempTargetDest2 = $9be714d2e19cc068$var$temp4;
    }
    let closestDistance = Infinity;
    let closestDistanceTriIndex = null;
    let closestDistanceOtherTriIndex = null;
    $9be714d2e19cc068$var$tempMatrix.copy(geometryToBvh).invert();
    $9be714d2e19cc068$var$obb2.matrix.copy($9be714d2e19cc068$var$tempMatrix);
    bvh.shapecast({
        boundsTraverseOrder: (box)=>{
            return $9be714d2e19cc068$var$obb.distanceToBox(box);
        },
        intersectsBounds: (box, isLeaf, score)=>{
            if (score < closestDistance && score < maxThreshold) {
                // if we know the triangles of this bounds will be intersected next then
                // save the bounds to use during triangle checks.
                if (isLeaf) {
                    $9be714d2e19cc068$var$obb2.min.copy(box.min);
                    $9be714d2e19cc068$var$obb2.max.copy(box.max);
                    $9be714d2e19cc068$var$obb2.needsUpdate = true;
                }
                return true;
            }
            return false;
        },
        intersectsRange: (offset, count)=>{
            if (otherGeometry.boundsTree) {
                // if the other geometry has a bvh then use the accelerated path where we use shapecast to find
                // the closest bounds in the other geometry to check.
                const otherBvh = otherGeometry.boundsTree;
                return otherBvh.shapecast({
                    boundsTraverseOrder: (box)=>{
                        return $9be714d2e19cc068$var$obb2.distanceToBox(box);
                    },
                    intersectsBounds: (box, isLeaf, score)=>{
                        return score < closestDistance && score < maxThreshold;
                    },
                    intersectsRange: (otherOffset, otherCount)=>{
                        for(let i2 = otherOffset, l2 = otherOffset + otherCount; i2 < l2; i2++){
                            (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle2, 3 * i2, otherIndex, otherPos);
                            triangle2.a.applyMatrix4(geometryToBvh);
                            triangle2.b.applyMatrix4(geometryToBvh);
                            triangle2.c.applyMatrix4(geometryToBvh);
                            triangle2.needsUpdate = true;
                            for(let i = offset, l = offset + count; i < l; i++){
                                (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle, 3 * i, index, pos);
                                triangle.needsUpdate = true;
                                const dist = triangle.distanceToTriangle(triangle2, tempTarget1, tempTarget2);
                                if (dist < closestDistance) {
                                    tempTargetDest1.copy(tempTarget1);
                                    if (tempTargetDest2) tempTargetDest2.copy(tempTarget2);
                                    closestDistance = dist;
                                    closestDistanceTriIndex = i;
                                    closestDistanceOtherTriIndex = i2;
                                }
                                // stop traversal if we find a point that's under the given threshold
                                if (dist < minThreshold) return true;
                            }
                        }
                    }
                });
            } else {
                // If no bounds tree then we'll just check every triangle.
                const triCount = (0, $423096e95cd96e19$export$c56c51fae37b2d63)(otherGeometry);
                for(let i2 = 0, l2 = triCount; i2 < l2; i2++){
                    (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle2, 3 * i2, otherIndex, otherPos);
                    triangle2.a.applyMatrix4(geometryToBvh);
                    triangle2.b.applyMatrix4(geometryToBvh);
                    triangle2.c.applyMatrix4(geometryToBvh);
                    triangle2.needsUpdate = true;
                    for(let i = offset, l = offset + count; i < l; i++){
                        (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle, 3 * i, index, pos);
                        triangle.needsUpdate = true;
                        const dist = triangle.distanceToTriangle(triangle2, tempTarget1, tempTarget2);
                        if (dist < closestDistance) {
                            tempTargetDest1.copy(tempTarget1);
                            if (tempTargetDest2) tempTargetDest2.copy(tempTarget2);
                            closestDistance = dist;
                            closestDistanceTriIndex = i;
                            closestDistanceOtherTriIndex = i2;
                        }
                        // stop traversal if we find a point that's under the given threshold
                        if (dist < minThreshold) return true;
                    }
                }
            }
        }
    });
    (0, $593bc8ef8d1a55fc$export$2622f4315304edad).releasePrimitive(triangle);
    (0, $593bc8ef8d1a55fc$export$2622f4315304edad).releasePrimitive(triangle2);
    if (closestDistance === Infinity) return null;
    if (!target1.point) target1.point = tempTargetDest1.clone();
    else target1.point.copy(tempTargetDest1);
    target1.distance = closestDistance, target1.faceIndex = closestDistanceTriIndex;
    if (target2) {
        if (!target2.point) target2.point = tempTargetDest2.clone();
        else target2.point.copy(tempTargetDest2);
        target2.point.applyMatrix4($9be714d2e19cc068$var$tempMatrix);
        tempTargetDest1.applyMatrix4($9be714d2e19cc068$var$tempMatrix);
        target2.distance = tempTargetDest1.sub(target2.point).length();
        target2.faceIndex = closestDistanceOtherTriIndex;
    }
    return target1;
}




/*************************************************************/ /* This file is generated from "iterationUtils.template.js". */ /*************************************************************/ /* eslint-disable indent */ function $c1c3e12524864241$export$7e7412b9f4f11a5c(bvh, side, ray, offset, count, intersections, near, far) {
    const { geometry: geometry, _indirectBuffer: _indirectBuffer } = bvh;
    for(let i = offset, end = offset + count; i < end; i++){
        let vi = _indirectBuffer ? _indirectBuffer[i] : i;
        (0, $5664c169f49816c4$export$1a557053019a130b)(geometry, side, ray, vi, intersections, near, far);
    }
}
function $c1c3e12524864241$export$dddff414156655a1(bvh, side, ray, offset, count, near, far) {
    const { geometry: geometry, _indirectBuffer: _indirectBuffer } = bvh;
    let dist = Infinity;
    let res = null;
    for(let i = offset, end = offset + count; i < end; i++){
        let intersection;
        intersection = (0, $5664c169f49816c4$export$1a557053019a130b)(geometry, side, ray, _indirectBuffer ? _indirectBuffer[i] : i, null, near, far);
        if (intersection && intersection.distance < dist) {
            res = intersection;
            dist = intersection.distance;
        }
    }
    return res;
}
function $c1c3e12524864241$export$dae1f8efdced590b(offset, count, bvh, intersectsTriangleFunc, contained, depth, triangle) {
    const { geometry: geometry } = bvh;
    const { index: index } = geometry;
    const pos = geometry.attributes.position;
    for(let i = offset, l = count + offset; i < l; i++){
        let tri;
        tri = bvh.resolveTriangleIndex(i);
        (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle, tri * 3, index, pos);
        triangle.needsUpdate = true;
        if (intersectsTriangleFunc(triangle, tri, contained, depth)) return true;
    }
    return false;
}



/****************************************************/ /* This file is generated from "refit.template.js". */ /****************************************************/ function $d955d16ddee6d2e4$export$40f4af49b81ca898(bvh, nodeIndices = null) {
    if (nodeIndices && Array.isArray(nodeIndices)) nodeIndices = new Set(nodeIndices);
    const geometry = bvh.geometry;
    const indexArr = geometry.index ? geometry.index.array : null;
    const posAttr = geometry.attributes.position;
    let buffer, uint32Array, uint16Array, float32Array;
    let byteOffset = 0;
    const roots = bvh._roots;
    for(let i = 0, l = roots.length; i < l; i++){
        buffer = roots[i];
        uint32Array = new Uint32Array(buffer);
        uint16Array = new Uint16Array(buffer);
        float32Array = new Float32Array(buffer);
        _traverse(0, byteOffset);
        byteOffset += buffer.byteLength;
    }
    function _traverse(node32Index, byteOffset, force = false) {
        const node16Index = node32Index * 2;
        const isLeaf = uint16Array[node16Index + 15] === (0, $78926744db4a8a3e$export$661fddb62bfe0e42);
        if (isLeaf) {
            const offset = uint32Array[node32Index + 6];
            const count = uint16Array[node16Index + 14];
            let minx = Infinity;
            let miny = Infinity;
            let minz = Infinity;
            let maxx = -Infinity;
            let maxy = -Infinity;
            let maxz = -Infinity;
            for(let i = offset, l = offset + count; i < l; i++){
                const t = 3 * bvh.resolveTriangleIndex(i);
                for(let j = 0; j < 3; j++){
                    let index = t + j;
                    index = indexArr ? indexArr[index] : index;
                    const x = posAttr.getX(index);
                    const y = posAttr.getY(index);
                    const z = posAttr.getZ(index);
                    if (x < minx) minx = x;
                    if (x > maxx) maxx = x;
                    if (y < miny) miny = y;
                    if (y > maxy) maxy = y;
                    if (z < minz) minz = z;
                    if (z > maxz) maxz = z;
                }
            }
            if (float32Array[node32Index + 0] !== minx || float32Array[node32Index + 1] !== miny || float32Array[node32Index + 2] !== minz || float32Array[node32Index + 3] !== maxx || float32Array[node32Index + 4] !== maxy || float32Array[node32Index + 5] !== maxz) {
                float32Array[node32Index + 0] = minx;
                float32Array[node32Index + 1] = miny;
                float32Array[node32Index + 2] = minz;
                float32Array[node32Index + 3] = maxx;
                float32Array[node32Index + 4] = maxy;
                float32Array[node32Index + 5] = maxz;
                return true;
            } else return false;
        } else {
            const left = node32Index + 8;
            const right = uint32Array[node32Index + 6];
            // the identifying node indices provided by the shapecast function include offsets of all
            // root buffers to guarantee they're unique between roots so offset left and right indices here.
            const offsetLeft = left + byteOffset;
            const offsetRight = right + byteOffset;
            let forceChildren = force;
            let includesLeft = false;
            let includesRight = false;
            if (nodeIndices) // if we see that neither the left or right child are included in the set that need to be updated
            // then we assume that all children need to be updated.
            {
                if (!forceChildren) {
                    includesLeft = nodeIndices.has(offsetLeft);
                    includesRight = nodeIndices.has(offsetRight);
                    forceChildren = !includesLeft && !includesRight;
                }
            } else {
                includesLeft = true;
                includesRight = true;
            }
            const traverseLeft = forceChildren || includesLeft;
            const traverseRight = forceChildren || includesRight;
            let leftChange = false;
            if (traverseLeft) leftChange = _traverse(left, byteOffset, forceChildren);
            let rightChange = false;
            if (traverseRight) rightChange = _traverse(right, byteOffset, forceChildren);
            const didChange = leftChange || rightChange;
            if (didChange) for(let i = 0; i < 3; i++){
                const lefti = left + i;
                const righti = right + i;
                const minLeftValue = float32Array[lefti];
                const maxLeftValue = float32Array[lefti + 3];
                const minRightValue = float32Array[righti];
                const maxRightValue = float32Array[righti + 3];
                float32Array[node32Index + i] = minLeftValue < minRightValue ? minLeftValue : minRightValue;
                float32Array[node32Index + i + 3] = maxLeftValue > maxRightValue ? maxLeftValue : maxRightValue;
            }
            return didChange;
        }
    }
}







/******************************************************/ /* This file is generated from "raycast.template.js". */ /******************************************************/ function $f2500bdd73784d92$export$1999205ebe856279(bvh, root, side, ray, intersects, near, far) {
    (0, $064797f1cfb48450$export$7451c73ce907854f).setBuffer(bvh._roots[root]);
    $f2500bdd73784d92$var$_raycast(0, bvh, side, ray, intersects, near, far);
    (0, $064797f1cfb48450$export$7451c73ce907854f).clearBuffer();
}
function $f2500bdd73784d92$var$_raycast(nodeIndex32, bvh, side, ray, intersects, near, far) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $064797f1cfb48450$export$7451c73ce907854f);
    const nodeIndex16 = nodeIndex32 * 2;
    const isLeaf = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const offset = (0, $6363300ccf15b961$export$3231e969238304f3)(nodeIndex32, uint32Array);
        const count = (0, $6363300ccf15b961$export$d61684373eacdf61)(nodeIndex16, uint16Array);
        (0, $c1c3e12524864241$export$7e7412b9f4f11a5c)(bvh, side, ray, offset, count, intersects, near, far);
    } else {
        const leftIndex = (0, $6363300ccf15b961$export$7a68bc00425859d)(nodeIndex32);
        if ((0, $98440f459aa220f3$export$d5a069a08bb68982)(leftIndex, float32Array, ray, near, far)) $f2500bdd73784d92$var$_raycast(leftIndex, bvh, side, ray, intersects, near, far);
        const rightIndex = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(nodeIndex32, uint32Array);
        if ((0, $98440f459aa220f3$export$d5a069a08bb68982)(rightIndex, float32Array, ray, near, far)) $f2500bdd73784d92$var$_raycast(rightIndex, bvh, side, ray, intersects, near, far);
    }
}







/***********************************************************/ /* This file is generated from "raycastFirst.template.js". */ /***********************************************************/ const $0b8fb114025d9d97$var$_xyzFields = [
    "x",
    "y",
    "z"
];
function $0b8fb114025d9d97$export$44e48d4cf2fe0609(bvh, root, side, ray, near, far) {
    (0, $064797f1cfb48450$export$7451c73ce907854f).setBuffer(bvh._roots[root]);
    const result = $0b8fb114025d9d97$var$_raycastFirst(0, bvh, side, ray, near, far);
    (0, $064797f1cfb48450$export$7451c73ce907854f).clearBuffer();
    return result;
}
function $0b8fb114025d9d97$var$_raycastFirst(nodeIndex32, bvh, side, ray, near, far) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $064797f1cfb48450$export$7451c73ce907854f);
    let nodeIndex16 = nodeIndex32 * 2;
    const isLeaf = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const offset = (0, $6363300ccf15b961$export$3231e969238304f3)(nodeIndex32, uint32Array);
        const count = (0, $6363300ccf15b961$export$d61684373eacdf61)(nodeIndex16, uint16Array);
        return (0, $c1c3e12524864241$export$dddff414156655a1)(bvh, side, ray, offset, count, near, far);
    } else {
        // consider the position of the split plane with respect to the oncoming ray; whichever direction
        // the ray is coming from, look for an intersection among that side of the tree first
        const splitAxis = (0, $6363300ccf15b961$export$b43717b3ca95505)(nodeIndex32, uint32Array);
        const xyzAxis = $0b8fb114025d9d97$var$_xyzFields[splitAxis];
        const rayDir = ray.direction[xyzAxis];
        const leftToRight = rayDir >= 0;
        // c1 is the child to check first
        let c1, c2;
        if (leftToRight) {
            c1 = (0, $6363300ccf15b961$export$7a68bc00425859d)(nodeIndex32);
            c2 = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(nodeIndex32, uint32Array);
        } else {
            c1 = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(nodeIndex32, uint32Array);
            c2 = (0, $6363300ccf15b961$export$7a68bc00425859d)(nodeIndex32);
        }
        const c1Intersection = (0, $98440f459aa220f3$export$d5a069a08bb68982)(c1, float32Array, ray, near, far);
        const c1Result = c1Intersection ? $0b8fb114025d9d97$var$_raycastFirst(c1, bvh, side, ray, near, far) : null;
        // if we got an intersection in the first node and it's closer than the second node's bounding
        // box, we don't need to consider the second node because it couldn't possibly be a better result
        if (c1Result) {
            // check if the point is within the second bounds
            // "point" is in the local frame of the bvh
            const point = c1Result.point[xyzAxis];
            const isOutside = leftToRight ? point <= float32Array[c2 + splitAxis] : point >= float32Array[c2 + splitAxis + 3]; // max bounding data
            if (isOutside) return c1Result;
        }
        // either there was no intersection in the first node, or there could still be a closer
        // intersection in the second, so check the second node and then take the better of the two
        const c2Intersection = (0, $98440f459aa220f3$export$d5a069a08bb68982)(c2, float32Array, ray, near, far);
        const c2Result = c2Intersection ? $0b8fb114025d9d97$var$_raycastFirst(c2, bvh, side, ray, near, far) : null;
        if (c1Result && c2Result) return c1Result.distance <= c2Result.distance ? c1Result : c2Result;
        else return c1Result || c2Result || null;
    }
}



var $ilwiq = parcelRequire("ilwiq");






/*****************************************************************/ /* This file is generated from "intersectsGeometry.template.js". */ /*****************************************************************/ /* eslint-disable indent */ const $8774d8cede10b4d0$var$boundingBox = /* @__PURE__ */ new (0, $ilwiq.Box3)();
const $8774d8cede10b4d0$var$triangle = /* @__PURE__ */ new (0, $681270c6f2e9ebff$export$a37f7ec1c23dfacf)();
const $8774d8cede10b4d0$var$triangle2 = /* @__PURE__ */ new (0, $681270c6f2e9ebff$export$a37f7ec1c23dfacf)();
const $8774d8cede10b4d0$var$invertedMat = /* @__PURE__ */ new (0, $ilwiq.Matrix4)();
const $8774d8cede10b4d0$var$obb = /* @__PURE__ */ new (0, $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58)();
const $8774d8cede10b4d0$var$obb2 = /* @__PURE__ */ new (0, $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58)();
function $8774d8cede10b4d0$export$80dca0df80ee0084(bvh, root, otherGeometry, geometryToBvh) {
    (0, $064797f1cfb48450$export$7451c73ce907854f).setBuffer(bvh._roots[root]);
    const result = $8774d8cede10b4d0$var$_intersectsGeometry(0, bvh, otherGeometry, geometryToBvh);
    (0, $064797f1cfb48450$export$7451c73ce907854f).clearBuffer();
    return result;
}
function $8774d8cede10b4d0$var$_intersectsGeometry(nodeIndex32, bvh, otherGeometry, geometryToBvh, cachedObb = null) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $064797f1cfb48450$export$7451c73ce907854f);
    let nodeIndex16 = nodeIndex32 * 2;
    if (cachedObb === null) {
        if (!otherGeometry.boundingBox) otherGeometry.computeBoundingBox();
        $8774d8cede10b4d0$var$obb.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
        cachedObb = $8774d8cede10b4d0$var$obb;
    }
    const isLeaf = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const thisGeometry = bvh.geometry;
        const thisIndex = thisGeometry.index;
        const thisPos = thisGeometry.attributes.position;
        const index = otherGeometry.index;
        const pos = otherGeometry.attributes.position;
        const offset = (0, $6363300ccf15b961$export$3231e969238304f3)(nodeIndex32, uint32Array);
        const count = (0, $6363300ccf15b961$export$d61684373eacdf61)(nodeIndex16, uint16Array);
        // get the inverse of the geometry matrix so we can transform our triangles into the
        // geometry space we're trying to test. We assume there are fewer triangles being checked
        // here.
        $8774d8cede10b4d0$var$invertedMat.copy(geometryToBvh).invert();
        if (otherGeometry.boundsTree) {
            // if there's a bounds tree
            (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(nodeIndex32), float32Array, $8774d8cede10b4d0$var$obb2);
            $8774d8cede10b4d0$var$obb2.matrix.copy($8774d8cede10b4d0$var$invertedMat);
            $8774d8cede10b4d0$var$obb2.needsUpdate = true;
            // TODO: use a triangle iteration function here
            const res = otherGeometry.boundsTree.shapecast({
                intersectsBounds: (box)=>$8774d8cede10b4d0$var$obb2.intersectsBox(box),
                intersectsTriangle: (tri)=>{
                    tri.a.applyMatrix4(geometryToBvh);
                    tri.b.applyMatrix4(geometryToBvh);
                    tri.c.applyMatrix4(geometryToBvh);
                    tri.needsUpdate = true;
                    for(let i = offset, l = count + offset; i < l; i++){
                        // this triangle needs to be transformed into the current BVH coordinate frame
                        (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)($8774d8cede10b4d0$var$triangle2, 3 * bvh.resolveTriangleIndex(i), thisIndex, thisPos);
                        $8774d8cede10b4d0$var$triangle2.needsUpdate = true;
                        if (tri.intersectsTriangle($8774d8cede10b4d0$var$triangle2)) return true;
                    }
                    return false;
                }
            });
            return res;
        } else // if we're just dealing with raw geometry
        for(let i = offset, l = count + offset; i < l; i++){
            // this triangle needs to be transformed into the current BVH coordinate frame
            const ti = bvh.resolveTriangleIndex(i);
            (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)($8774d8cede10b4d0$var$triangle, 3 * ti, thisIndex, thisPos);
            $8774d8cede10b4d0$var$triangle.a.applyMatrix4($8774d8cede10b4d0$var$invertedMat);
            $8774d8cede10b4d0$var$triangle.b.applyMatrix4($8774d8cede10b4d0$var$invertedMat);
            $8774d8cede10b4d0$var$triangle.c.applyMatrix4($8774d8cede10b4d0$var$invertedMat);
            $8774d8cede10b4d0$var$triangle.needsUpdate = true;
            for(let i2 = 0, l2 = index.count; i2 < l2; i2 += 3){
                (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)($8774d8cede10b4d0$var$triangle2, i2, index, pos);
                $8774d8cede10b4d0$var$triangle2.needsUpdate = true;
                if ($8774d8cede10b4d0$var$triangle.intersectsTriangle($8774d8cede10b4d0$var$triangle2)) return true;
            }
        }
    } else {
        const left = nodeIndex32 + 8;
        const right = uint32Array[nodeIndex32 + 6];
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(left), float32Array, $8774d8cede10b4d0$var$boundingBox);
        const leftIntersection = cachedObb.intersectsBox($8774d8cede10b4d0$var$boundingBox) && $8774d8cede10b4d0$var$_intersectsGeometry(left, bvh, otherGeometry, geometryToBvh, cachedObb);
        if (leftIntersection) return true;
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(right), float32Array, $8774d8cede10b4d0$var$boundingBox);
        const rightIntersection = cachedObb.intersectsBox($8774d8cede10b4d0$var$boundingBox) && $8774d8cede10b4d0$var$_intersectsGeometry(right, bvh, otherGeometry, geometryToBvh, cachedObb);
        if (rightIntersection) return true;
        return false;
    }
}



var $ilwiq = parcelRequire("ilwiq");




/*********************************************************************/ /* This file is generated from "closestPointToGeometry.template.js". */ /*********************************************************************/ const $c4f746093678aa23$var$tempMatrix = /* @__PURE__ */ new (0, $ilwiq.Matrix4)();
const $c4f746093678aa23$var$obb = /* @__PURE__ */ new (0, $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58)();
const $c4f746093678aa23$var$obb2 = /* @__PURE__ */ new (0, $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58)();
const $c4f746093678aa23$var$temp1 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $c4f746093678aa23$var$temp2 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $c4f746093678aa23$var$temp3 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $c4f746093678aa23$var$temp4 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
function $c4f746093678aa23$export$334b669407b5ec06(bvh, otherGeometry, geometryToBvh, target1 = {}, target2 = {}, minThreshold = 0, maxThreshold = Infinity) {
    if (!otherGeometry.boundingBox) otherGeometry.computeBoundingBox();
    $c4f746093678aa23$var$obb.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
    $c4f746093678aa23$var$obb.needsUpdate = true;
    const geometry = bvh.geometry;
    const pos = geometry.attributes.position;
    const index = geometry.index;
    const otherPos = otherGeometry.attributes.position;
    const otherIndex = otherGeometry.index;
    const triangle = (0, $593bc8ef8d1a55fc$export$2622f4315304edad).getPrimitive();
    const triangle2 = (0, $593bc8ef8d1a55fc$export$2622f4315304edad).getPrimitive();
    let tempTarget1 = $c4f746093678aa23$var$temp1;
    let tempTargetDest1 = $c4f746093678aa23$var$temp2;
    let tempTarget2 = null;
    let tempTargetDest2 = null;
    if (target2) {
        tempTarget2 = $c4f746093678aa23$var$temp3;
        tempTargetDest2 = $c4f746093678aa23$var$temp4;
    }
    let closestDistance = Infinity;
    let closestDistanceTriIndex = null;
    let closestDistanceOtherTriIndex = null;
    $c4f746093678aa23$var$tempMatrix.copy(geometryToBvh).invert();
    $c4f746093678aa23$var$obb2.matrix.copy($c4f746093678aa23$var$tempMatrix);
    bvh.shapecast({
        boundsTraverseOrder: (box)=>{
            return $c4f746093678aa23$var$obb.distanceToBox(box);
        },
        intersectsBounds: (box, isLeaf, score)=>{
            if (score < closestDistance && score < maxThreshold) {
                // if we know the triangles of this bounds will be intersected next then
                // save the bounds to use during triangle checks.
                if (isLeaf) {
                    $c4f746093678aa23$var$obb2.min.copy(box.min);
                    $c4f746093678aa23$var$obb2.max.copy(box.max);
                    $c4f746093678aa23$var$obb2.needsUpdate = true;
                }
                return true;
            }
            return false;
        },
        intersectsRange: (offset, count)=>{
            if (otherGeometry.boundsTree) {
                // if the other geometry has a bvh then use the accelerated path where we use shapecast to find
                // the closest bounds in the other geometry to check.
                const otherBvh = otherGeometry.boundsTree;
                return otherBvh.shapecast({
                    boundsTraverseOrder: (box)=>{
                        return $c4f746093678aa23$var$obb2.distanceToBox(box);
                    },
                    intersectsBounds: (box, isLeaf, score)=>{
                        return score < closestDistance && score < maxThreshold;
                    },
                    intersectsRange: (otherOffset, otherCount)=>{
                        for(let i2 = otherOffset, l2 = otherOffset + otherCount; i2 < l2; i2++){
                            const ti2 = otherBvh.resolveTriangleIndex(i2);
                            (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle2, 3 * ti2, otherIndex, otherPos);
                            triangle2.a.applyMatrix4(geometryToBvh);
                            triangle2.b.applyMatrix4(geometryToBvh);
                            triangle2.c.applyMatrix4(geometryToBvh);
                            triangle2.needsUpdate = true;
                            for(let i = offset, l = offset + count; i < l; i++){
                                const ti = bvh.resolveTriangleIndex(i);
                                (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle, 3 * ti, index, pos);
                                triangle.needsUpdate = true;
                                const dist = triangle.distanceToTriangle(triangle2, tempTarget1, tempTarget2);
                                if (dist < closestDistance) {
                                    tempTargetDest1.copy(tempTarget1);
                                    if (tempTargetDest2) tempTargetDest2.copy(tempTarget2);
                                    closestDistance = dist;
                                    closestDistanceTriIndex = i;
                                    closestDistanceOtherTriIndex = i2;
                                }
                                // stop traversal if we find a point that's under the given threshold
                                if (dist < minThreshold) return true;
                            }
                        }
                    }
                });
            } else {
                // If no bounds tree then we'll just check every triangle.
                const triCount = (0, $423096e95cd96e19$export$c56c51fae37b2d63)(otherGeometry);
                for(let i2 = 0, l2 = triCount; i2 < l2; i2++){
                    (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle2, 3 * i2, otherIndex, otherPos);
                    triangle2.a.applyMatrix4(geometryToBvh);
                    triangle2.b.applyMatrix4(geometryToBvh);
                    triangle2.c.applyMatrix4(geometryToBvh);
                    triangle2.needsUpdate = true;
                    for(let i = offset, l = offset + count; i < l; i++){
                        const ti = bvh.resolveTriangleIndex(i);
                        (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle, 3 * ti, index, pos);
                        triangle.needsUpdate = true;
                        const dist = triangle.distanceToTriangle(triangle2, tempTarget1, tempTarget2);
                        if (dist < closestDistance) {
                            tempTargetDest1.copy(tempTarget1);
                            if (tempTargetDest2) tempTargetDest2.copy(tempTarget2);
                            closestDistance = dist;
                            closestDistanceTriIndex = i;
                            closestDistanceOtherTriIndex = i2;
                        }
                        // stop traversal if we find a point that's under the given threshold
                        if (dist < minThreshold) return true;
                    }
                }
            }
        }
    });
    (0, $593bc8ef8d1a55fc$export$2622f4315304edad).releasePrimitive(triangle);
    (0, $593bc8ef8d1a55fc$export$2622f4315304edad).releasePrimitive(triangle2);
    if (closestDistance === Infinity) return null;
    if (!target1.point) target1.point = tempTargetDest1.clone();
    else target1.point.copy(tempTargetDest1);
    target1.distance = closestDistance, target1.faceIndex = closestDistanceTriIndex;
    if (target2) {
        if (!target2.point) target2.point = tempTargetDest2.clone();
        else target2.point.copy(tempTargetDest2);
        target2.point.applyMatrix4($c4f746093678aa23$var$tempMatrix);
        tempTargetDest1.applyMatrix4($c4f746093678aa23$var$tempMatrix);
        target2.distance = tempTargetDest1.sub(target2.point).length();
        target2.faceIndex = closestDistanceOtherTriIndex;
    }
    return target1;
}


function $9611e0cfae405faf$export$9c28fa8114adc339() {
    return typeof SharedArrayBuffer !== "undefined";
}
function $9611e0cfae405faf$export$fadff02e9aa23f60(array, BufferConstructor) {
    if (array === null) return array;
    else if (array.buffer) {
        const buffer = array.buffer;
        if (buffer.constructor === BufferConstructor) return array;
        const ArrayConstructor = array.constructor;
        const result = new ArrayConstructor(new BufferConstructor(buffer.byteLength));
        result.set(array);
        return result;
    } else {
        if (array.constructor === BufferConstructor) return array;
        const result = new BufferConstructor(array.byteLength);
        new Uint8Array(result).set(new Uint8Array(array));
        return result;
    }
}




var $ilwiq = parcelRequire("ilwiq");




const $af02cf38ee8e10da$var$_bufferStack1 = new (0, $064797f1cfb48450$export$7451c73ce907854f).constructor();
const $af02cf38ee8e10da$var$_bufferStack2 = new (0, $064797f1cfb48450$export$7451c73ce907854f).constructor();
const $af02cf38ee8e10da$var$_boxPool = new (0, $0f9e1864656e7fae$export$bf300c504651112a)(()=>new (0, $ilwiq.Box3)());
const $af02cf38ee8e10da$var$_leftBox1 = new (0, $ilwiq.Box3)();
const $af02cf38ee8e10da$var$_rightBox1 = new (0, $ilwiq.Box3)();
const $af02cf38ee8e10da$var$_leftBox2 = new (0, $ilwiq.Box3)();
const $af02cf38ee8e10da$var$_rightBox2 = new (0, $ilwiq.Box3)();
let $af02cf38ee8e10da$var$_active = false;
function $af02cf38ee8e10da$export$a2253c6980b92559(bvh, otherBvh, matrixToLocal, intersectsRanges) {
    if ($af02cf38ee8e10da$var$_active) throw new Error("MeshBVH: Recursive calls to bvhcast not supported.");
    $af02cf38ee8e10da$var$_active = true;
    const roots = bvh._roots;
    const otherRoots = otherBvh._roots;
    let result;
    let offset1 = 0;
    let offset2 = 0;
    const invMat = new (0, $ilwiq.Matrix4)().copy(matrixToLocal).invert();
    // iterate over the first set of roots
    for(let i = 0, il = roots.length; i < il; i++){
        $af02cf38ee8e10da$var$_bufferStack1.setBuffer(roots[i]);
        offset2 = 0;
        // prep the initial root box
        const localBox = $af02cf38ee8e10da$var$_boxPool.getPrimitive();
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(0), $af02cf38ee8e10da$var$_bufferStack1.float32Array, localBox);
        localBox.applyMatrix4(invMat);
        // iterate over the second set of roots
        for(let j = 0, jl = otherRoots.length; j < jl; j++){
            $af02cf38ee8e10da$var$_bufferStack2.setBuffer(otherRoots[j]);
            result = $af02cf38ee8e10da$var$_traverse(0, 0, matrixToLocal, invMat, intersectsRanges, offset1, offset2, 0, 0, localBox);
            $af02cf38ee8e10da$var$_bufferStack2.clearBuffer();
            offset2 += otherRoots[j].length;
            if (result) break;
        }
        // release stack info
        $af02cf38ee8e10da$var$_boxPool.releasePrimitive(localBox);
        $af02cf38ee8e10da$var$_bufferStack1.clearBuffer();
        offset1 += roots[i].length;
        if (result) break;
    }
    $af02cf38ee8e10da$var$_active = false;
    return result;
}
function $af02cf38ee8e10da$var$_traverse(node1Index32, node2Index32, matrix2to1, matrix1to2, intersectsRangesFunc, // offsets for ids
node1IndexByteOffset = 0, node2IndexByteOffset = 0, // tree depth
depth1 = 0, depth2 = 0, currBox = null, reversed = false) {
    // get the buffer stacks associated with the current indices
    let bufferStack1, bufferStack2;
    if (reversed) {
        bufferStack1 = $af02cf38ee8e10da$var$_bufferStack2;
        bufferStack2 = $af02cf38ee8e10da$var$_bufferStack1;
    } else {
        bufferStack1 = $af02cf38ee8e10da$var$_bufferStack1;
        bufferStack2 = $af02cf38ee8e10da$var$_bufferStack2;
    }
    // get the local instances of the typed buffers
    const float32Array1 = bufferStack1.float32Array, uint32Array1 = bufferStack1.uint32Array, uint16Array1 = bufferStack1.uint16Array, float32Array2 = bufferStack2.float32Array, uint32Array2 = bufferStack2.uint32Array, uint16Array2 = bufferStack2.uint16Array;
    const node1Index16 = node1Index32 * 2;
    const node2Index16 = node2Index32 * 2;
    const isLeaf1 = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(node1Index16, uint16Array1);
    const isLeaf2 = (0, $6363300ccf15b961$export$bc7cbaf27fbe938e)(node2Index16, uint16Array2);
    let result = false;
    if (isLeaf2 && isLeaf1) {
        // if both bounds are leaf nodes then fire the callback if the boxes intersect
        if (reversed) result = intersectsRangesFunc((0, $6363300ccf15b961$export$3231e969238304f3)(node2Index32, uint32Array2), (0, $6363300ccf15b961$export$d61684373eacdf61)(node2Index32 * 2, uint16Array2), (0, $6363300ccf15b961$export$3231e969238304f3)(node1Index32, uint32Array1), (0, $6363300ccf15b961$export$d61684373eacdf61)(node1Index32 * 2, uint16Array1), depth2, node2IndexByteOffset + node2Index32, depth1, node1IndexByteOffset + node1Index32);
        else result = intersectsRangesFunc((0, $6363300ccf15b961$export$3231e969238304f3)(node1Index32, uint32Array1), (0, $6363300ccf15b961$export$d61684373eacdf61)(node1Index32 * 2, uint16Array1), (0, $6363300ccf15b961$export$3231e969238304f3)(node2Index32, uint32Array2), (0, $6363300ccf15b961$export$d61684373eacdf61)(node2Index32 * 2, uint16Array2), depth1, node1IndexByteOffset + node1Index32, depth2, node2IndexByteOffset + node2Index32);
    } else if (isLeaf2) {
        // SWAP
        // If we've traversed to the leaf node on the other bvh then we need to swap over
        // to traverse down the first one
        // get the new box to use
        const newBox = $af02cf38ee8e10da$var$_boxPool.getPrimitive();
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(node2Index32), float32Array2, newBox);
        newBox.applyMatrix4(matrix2to1);
        // get the child bounds to check before traversal
        const cl1 = (0, $6363300ccf15b961$export$7a68bc00425859d)(node1Index32);
        const cr1 = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(node1Index32, uint32Array1);
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(cl1), float32Array1, $af02cf38ee8e10da$var$_leftBox1);
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(cr1), float32Array1, $af02cf38ee8e10da$var$_rightBox1);
        // precompute the intersections otherwise the global boxes will be modified during traversal
        const intersectCl1 = newBox.intersectsBox($af02cf38ee8e10da$var$_leftBox1);
        const intersectCr1 = newBox.intersectsBox($af02cf38ee8e10da$var$_rightBox1);
        result = intersectCl1 && $af02cf38ee8e10da$var$_traverse(node2Index32, cl1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed) || intersectCr1 && $af02cf38ee8e10da$var$_traverse(node2Index32, cr1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed);
        $af02cf38ee8e10da$var$_boxPool.releasePrimitive(newBox);
    } else {
        // if neither are leaves then we should swap if one of the children does not
        // intersect with the current bounds
        // get the child bounds to check
        const cl2 = (0, $6363300ccf15b961$export$7a68bc00425859d)(node2Index32);
        const cr2 = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(node2Index32, uint32Array2);
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(cl2), float32Array2, $af02cf38ee8e10da$var$_leftBox2);
        (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(cr2), float32Array2, $af02cf38ee8e10da$var$_rightBox2);
        const leftIntersects = currBox.intersectsBox($af02cf38ee8e10da$var$_leftBox2);
        const rightIntersects = currBox.intersectsBox($af02cf38ee8e10da$var$_rightBox2);
        if (leftIntersects && rightIntersects) // continue to traverse both children if they both intersect
        result = $af02cf38ee8e10da$var$_traverse(node1Index32, cl2, matrix2to1, matrix1to2, intersectsRangesFunc, node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1, currBox, reversed) || $af02cf38ee8e10da$var$_traverse(node1Index32, cr2, matrix2to1, matrix1to2, intersectsRangesFunc, node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1, currBox, reversed);
        else if (leftIntersects) {
            if (isLeaf1) // if the current box is a leaf then just continue
            result = $af02cf38ee8e10da$var$_traverse(node1Index32, cl2, matrix2to1, matrix1to2, intersectsRangesFunc, node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1, currBox, reversed);
            else {
                // SWAP
                // if only one box intersects then we have to swap to the other bvh to continue
                const newBox = $af02cf38ee8e10da$var$_boxPool.getPrimitive();
                newBox.copy($af02cf38ee8e10da$var$_leftBox2).applyMatrix4(matrix2to1);
                const cl1 = (0, $6363300ccf15b961$export$7a68bc00425859d)(node1Index32);
                const cr1 = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(node1Index32, uint32Array1);
                (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(cl1), float32Array1, $af02cf38ee8e10da$var$_leftBox1);
                (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(cr1), float32Array1, $af02cf38ee8e10da$var$_rightBox1);
                // precompute the intersections otherwise the global boxes will be modified during traversal
                const intersectCl1 = newBox.intersectsBox($af02cf38ee8e10da$var$_leftBox1);
                const intersectCr1 = newBox.intersectsBox($af02cf38ee8e10da$var$_rightBox1);
                result = intersectCl1 && $af02cf38ee8e10da$var$_traverse(cl2, cl1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed) || intersectCr1 && $af02cf38ee8e10da$var$_traverse(cl2, cr1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed);
                $af02cf38ee8e10da$var$_boxPool.releasePrimitive(newBox);
            }
        } else if (rightIntersects) {
            if (isLeaf1) // if the current box is a leaf then just continue
            result = $af02cf38ee8e10da$var$_traverse(node1Index32, cr2, matrix2to1, matrix1to2, intersectsRangesFunc, node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1, currBox, reversed);
            else {
                // SWAP
                // if only one box intersects then we have to swap to the other bvh to continue
                const newBox = $af02cf38ee8e10da$var$_boxPool.getPrimitive();
                newBox.copy($af02cf38ee8e10da$var$_rightBox2).applyMatrix4(matrix2to1);
                const cl1 = (0, $6363300ccf15b961$export$7a68bc00425859d)(node1Index32);
                const cr1 = (0, $6363300ccf15b961$export$4f44f52d9f75fa31)(node1Index32, uint32Array1);
                (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(cl1), float32Array1, $af02cf38ee8e10da$var$_leftBox1);
                (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)((0, $6363300ccf15b961$export$b5b7e27a1440579d)(cr1), float32Array1, $af02cf38ee8e10da$var$_rightBox1);
                // precompute the intersections otherwise the global boxes will be modified during traversal
                const intersectCl1 = newBox.intersectsBox($af02cf38ee8e10da$var$_leftBox1);
                const intersectCr1 = newBox.intersectsBox($af02cf38ee8e10da$var$_rightBox1);
                result = intersectCl1 && $af02cf38ee8e10da$var$_traverse(cr2, cl1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed) || intersectCr1 && $af02cf38ee8e10da$var$_traverse(cr2, cr1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed);
                $af02cf38ee8e10da$var$_boxPool.releasePrimitive(newBox);
            }
        }
    }
    return result;
}


const $4eb4044e12c26831$var$obb = /* @__PURE__ */ new (0, $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58)();
const $4eb4044e12c26831$var$tempBox = /* @__PURE__ */ new (0, $ilwiq.Box3)();
const $4eb4044e12c26831$export$93ca5d3f8675ae4c = {
    strategy: (0, $78926744db4a8a3e$export$91c2158bc24c63d4),
    maxDepth: 40,
    maxLeafTris: 10,
    useSharedArrayBuffer: false,
    setBoundingBox: true,
    onProgress: null,
    indirect: false,
    verbose: true,
    range: null
};
class $4eb4044e12c26831$export$9d614b3bc2c4eacf {
    static serialize(bvh, options = {}) {
        options = {
            cloneBuffers: true,
            ...options
        };
        const geometry = bvh.geometry;
        const rootData = bvh._roots;
        const indirectBuffer = bvh._indirectBuffer;
        const indexAttribute = geometry.getIndex();
        let result;
        if (options.cloneBuffers) result = {
            roots: rootData.map((root)=>root.slice()),
            index: indexAttribute ? indexAttribute.array.slice() : null,
            indirectBuffer: indirectBuffer ? indirectBuffer.slice() : null
        };
        else result = {
            roots: rootData,
            index: indexAttribute ? indexAttribute.array : null,
            indirectBuffer: indirectBuffer
        };
        return result;
    }
    static deserialize(data, geometry, options = {}) {
        options = {
            setIndex: true,
            indirect: Boolean(data.indirectBuffer),
            ...options
        };
        const { index: index, roots: roots, indirectBuffer: indirectBuffer } = data;
        const bvh = new $4eb4044e12c26831$export$9d614b3bc2c4eacf(geometry, {
            ...options,
            [(0, $78926744db4a8a3e$export$abef70518a11a6ba)]: true
        });
        bvh._roots = roots;
        bvh._indirectBuffer = indirectBuffer || null;
        if (options.setIndex) {
            const indexAttribute = geometry.getIndex();
            if (indexAttribute === null) {
                const newIndex = new (0, $ilwiq.BufferAttribute)(data.index, 1, false);
                geometry.setIndex(newIndex);
            } else if (indexAttribute.array !== index) {
                indexAttribute.array.set(index);
                indexAttribute.needsUpdate = true;
            }
        }
        return bvh;
    }
    get indirect() {
        return !!this._indirectBuffer;
    }
    constructor(geometry, options = {}){
        if (!geometry.isBufferGeometry) throw new Error("MeshBVH: Only BufferGeometries are supported.");
        else if (geometry.index && geometry.index.isInterleavedBufferAttribute) throw new Error("MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.");
        // default options
        options = Object.assign({
            ...$4eb4044e12c26831$export$93ca5d3f8675ae4c,
            // undocumented options
            // Whether to skip generating the tree. Used for deserialization.
            [(0, $78926744db4a8a3e$export$abef70518a11a6ba)]: false
        }, options);
        if (options.useSharedArrayBuffer && !(0, $9611e0cfae405faf$export$9c28fa8114adc339)()) throw new Error("MeshBVH: SharedArrayBuffer is not available.");
        // retain references to the geometry so we can use them it without having to
        // take a geometry reference in every function.
        this.geometry = geometry;
        this._roots = null;
        this._indirectBuffer = null;
        if (!options[0, $78926744db4a8a3e$export$abef70518a11a6ba]) {
            (0, $ed4ee2639a9fd94e$export$e63bca57f220b8e3)(this, options);
            if (!geometry.boundingBox && options.setBoundingBox) geometry.boundingBox = this.getBoundingBox(new (0, $ilwiq.Box3)());
        }
        this.resolveTriangleIndex = options.indirect ? (i)=>this._indirectBuffer[i] : (i)=>i;
    }
    refit(nodeIndices = null) {
        const refitFunc = this.indirect ? (0, $d955d16ddee6d2e4$export$40f4af49b81ca898) : (0, $7afeb992771d32d5$export$8eb1eda96b2e6d7a);
        return refitFunc(this, nodeIndices);
    }
    traverse(callback, rootIndex = 0) {
        const buffer = this._roots[rootIndex];
        const uint32Array = new Uint32Array(buffer);
        const uint16Array = new Uint16Array(buffer);
        _traverse(0);
        function _traverse(node32Index, depth = 0) {
            const node16Index = node32Index * 2;
            const isLeaf = uint16Array[node16Index + 15] === (0, $78926744db4a8a3e$export$661fddb62bfe0e42);
            if (isLeaf) {
                const offset = uint32Array[node32Index + 6];
                const count = uint16Array[node16Index + 14];
                callback(depth, isLeaf, new Float32Array(buffer, node32Index * 4, 6), offset, count);
            } else {
                // TODO: use node functions here
                const left = node32Index + (0, $78926744db4a8a3e$export$a08e7d18fbc53be5) / 4;
                const right = uint32Array[node32Index + 6];
                const splitAxis = uint32Array[node32Index + 7];
                const stopTraversal = callback(depth, isLeaf, new Float32Array(buffer, node32Index * 4, 6), splitAxis);
                if (!stopTraversal) {
                    _traverse(left, depth + 1);
                    _traverse(right, depth + 1);
                }
            }
        }
    }
    /* Core Cast Functions */ raycast(ray, materialOrSide = (0, $ilwiq.FrontSide), near = 0, far = Infinity) {
        const roots = this._roots;
        const geometry = this.geometry;
        const intersects = [];
        const isMaterial = materialOrSide.isMaterial;
        const isArrayMaterial = Array.isArray(materialOrSide);
        const groups = geometry.groups;
        const side = isMaterial ? materialOrSide.side : materialOrSide;
        const raycastFunc = this.indirect ? (0, $f2500bdd73784d92$export$1999205ebe856279) : (0, $f6a695dbb681b4c5$export$630e89aab3ddc1d6);
        for(let i = 0, l = roots.length; i < l; i++){
            const materialSide = isArrayMaterial ? materialOrSide[groups[i].materialIndex].side : side;
            const startCount = intersects.length;
            raycastFunc(this, i, materialSide, ray, intersects, near, far);
            if (isArrayMaterial) {
                const materialIndex = groups[i].materialIndex;
                for(let j = startCount, jl = intersects.length; j < jl; j++)intersects[j].face.materialIndex = materialIndex;
            }
        }
        return intersects;
    }
    raycastFirst(ray, materialOrSide = (0, $ilwiq.FrontSide), near = 0, far = Infinity) {
        const roots = this._roots;
        const geometry = this.geometry;
        const isMaterial = materialOrSide.isMaterial;
        const isArrayMaterial = Array.isArray(materialOrSide);
        let closestResult = null;
        const groups = geometry.groups;
        const side = isMaterial ? materialOrSide.side : materialOrSide;
        const raycastFirstFunc = this.indirect ? (0, $0b8fb114025d9d97$export$44e48d4cf2fe0609) : (0, $15dd3f9915d1b1ff$export$1fa457bc72ef1a2a);
        for(let i = 0, l = roots.length; i < l; i++){
            const materialSide = isArrayMaterial ? materialOrSide[groups[i].materialIndex].side : side;
            const result = raycastFirstFunc(this, i, materialSide, ray, near, far);
            if (result != null && (closestResult == null || result.distance < closestResult.distance)) {
                closestResult = result;
                if (isArrayMaterial) result.face.materialIndex = groups[i].materialIndex;
            }
        }
        return closestResult;
    }
    intersectsGeometry(otherGeometry, geomToMesh) {
        let result = false;
        const roots = this._roots;
        const intersectsGeometryFunc = this.indirect ? (0, $8774d8cede10b4d0$export$80dca0df80ee0084) : (0, $9acb57256233c065$export$b2f96b0abaf94e0a);
        for(let i = 0, l = roots.length; i < l; i++){
            result = intersectsGeometryFunc(this, i, otherGeometry, geomToMesh);
            if (result) break;
        }
        return result;
    }
    shapecast(callbacks) {
        const triangle = (0, $593bc8ef8d1a55fc$export$2622f4315304edad).getPrimitive();
        const iterateFunc = this.indirect ? (0, $c1c3e12524864241$export$dae1f8efdced590b) : (0, $01d4f4206273ed95$export$be1391b7aa79c0f6);
        let { boundsTraverseOrder: boundsTraverseOrder, intersectsBounds: intersectsBounds, intersectsRange: intersectsRange, intersectsTriangle: intersectsTriangle } = callbacks;
        // wrap the intersectsRange function
        if (intersectsRange && intersectsTriangle) {
            const originalIntersectsRange = intersectsRange;
            intersectsRange = (offset, count, contained, depth, nodeIndex)=>{
                if (!originalIntersectsRange(offset, count, contained, depth, nodeIndex)) return iterateFunc(offset, count, this, intersectsTriangle, contained, depth, triangle);
                return true;
            };
        } else if (!intersectsRange) {
            if (intersectsTriangle) intersectsRange = (offset, count, contained, depth)=>{
                return iterateFunc(offset, count, this, intersectsTriangle, contained, depth, triangle);
            };
            else intersectsRange = (offset, count, contained)=>{
                return contained;
            };
        }
        // run shapecast
        let result = false;
        let byteOffset = 0;
        const roots = this._roots;
        for(let i = 0, l = roots.length; i < l; i++){
            const root = roots[i];
            result = (0, $6075a1513b66f4c0$export$963c78622ed2c172)(this, i, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset);
            if (result) break;
            byteOffset += root.byteLength;
        }
        (0, $593bc8ef8d1a55fc$export$2622f4315304edad).releasePrimitive(triangle);
        return result;
    }
    bvhcast(otherBvh, matrixToLocal, callbacks) {
        let { intersectsRanges: intersectsRanges, intersectsTriangles: intersectsTriangles } = callbacks;
        const triangle1 = (0, $593bc8ef8d1a55fc$export$2622f4315304edad).getPrimitive();
        const indexAttr1 = this.geometry.index;
        const positionAttr1 = this.geometry.attributes.position;
        const assignTriangle1 = this.indirect ? (i1)=>{
            const ti = this.resolveTriangleIndex(i1);
            (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle1, ti * 3, indexAttr1, positionAttr1);
        } : (i1)=>{
            (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle1, i1 * 3, indexAttr1, positionAttr1);
        };
        const triangle2 = (0, $593bc8ef8d1a55fc$export$2622f4315304edad).getPrimitive();
        const indexAttr2 = otherBvh.geometry.index;
        const positionAttr2 = otherBvh.geometry.attributes.position;
        const assignTriangle2 = otherBvh.indirect ? (i2)=>{
            const ti2 = otherBvh.resolveTriangleIndex(i2);
            (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle2, ti2 * 3, indexAttr2, positionAttr2);
        } : (i2)=>{
            (0, $a17a0e7ef0b826e6$export$32f7fa781964ae30)(triangle2, i2 * 3, indexAttr2, positionAttr2);
        };
        // generate triangle callback if needed
        if (intersectsTriangles) {
            const iterateOverDoubleTriangles = (offset1, count1, offset2, count2, depth1, index1, depth2, index2)=>{
                for(let i2 = offset2, l2 = offset2 + count2; i2 < l2; i2++){
                    assignTriangle2(i2);
                    triangle2.a.applyMatrix4(matrixToLocal);
                    triangle2.b.applyMatrix4(matrixToLocal);
                    triangle2.c.applyMatrix4(matrixToLocal);
                    triangle2.needsUpdate = true;
                    for(let i1 = offset1, l1 = offset1 + count1; i1 < l1; i1++){
                        assignTriangle1(i1);
                        triangle1.needsUpdate = true;
                        if (intersectsTriangles(triangle1, triangle2, i1, i2, depth1, index1, depth2, index2)) return true;
                    }
                }
                return false;
            };
            if (intersectsRanges) {
                const originalIntersectsRanges = intersectsRanges;
                intersectsRanges = function(offset1, count1, offset2, count2, depth1, index1, depth2, index2) {
                    if (!originalIntersectsRanges(offset1, count1, offset2, count2, depth1, index1, depth2, index2)) return iterateOverDoubleTriangles(offset1, count1, offset2, count2, depth1, index1, depth2, index2);
                    return true;
                };
            } else intersectsRanges = iterateOverDoubleTriangles;
        }
        return (0, $af02cf38ee8e10da$export$a2253c6980b92559)(this, otherBvh, matrixToLocal, intersectsRanges);
    }
    /* Derived Cast Functions */ intersectsBox(box, boxToMesh) {
        $4eb4044e12c26831$var$obb.set(box.min, box.max, boxToMesh);
        $4eb4044e12c26831$var$obb.needsUpdate = true;
        return this.shapecast({
            intersectsBounds: (box)=>$4eb4044e12c26831$var$obb.intersectsBox(box),
            intersectsTriangle: (tri)=>$4eb4044e12c26831$var$obb.intersectsTriangle(tri)
        });
    }
    intersectsSphere(sphere) {
        return this.shapecast({
            intersectsBounds: (box)=>sphere.intersectsBox(box),
            intersectsTriangle: (tri)=>tri.intersectsSphere(sphere)
        });
    }
    closestPointToGeometry(otherGeometry, geometryToBvh, target1 = {}, target2 = {}, minThreshold = 0, maxThreshold = Infinity) {
        const closestPointToGeometryFunc = this.indirect ? (0, $c4f746093678aa23$export$334b669407b5ec06) : (0, $9be714d2e19cc068$export$5912902c175a555e);
        return closestPointToGeometryFunc(this, otherGeometry, geometryToBvh, target1, target2, minThreshold, maxThreshold);
    }
    closestPointToPoint(point, target = {}, minThreshold = 0, maxThreshold = Infinity) {
        return (0, $67f4708097c33efc$export$96ec44700e587d99)(this, point, target, minThreshold, maxThreshold);
    }
    getBoundingBox(target) {
        target.makeEmpty();
        const roots = this._roots;
        roots.forEach((buffer)=>{
            (0, $a9f34d1ac25848aa$export$40b9a5e446bf11e0)(0, new Float32Array(buffer), $4eb4044e12c26831$var$tempBox);
            target.union($4eb4044e12c26831$var$tempBox);
        });
        return target;
    }
}


parcelRequire("1zN5O");
var $kEdgE = parcelRequire("kEdgE");


var $ilwiq = parcelRequire("ilwiq");
class $9be4dfcf19ae1185$export$2e2bcd8739ae039 {
    /**
    * Generates a random float between min and max.
    */ static fnAddModelToRegistry(modelRegistry, name, mesh, position, lqTexture, isAddedToScene, needsTextureSwapToHQ, distanceTextureSwap, textureIsLoaded, bvh, collisionRadius) {
        const modelID = Symbol(name); // Ensures uniqueness
        modelRegistry.set(modelID, {
            name: name,
            mesh: mesh,
            needsTextureSwapToHQ: needsTextureSwapToHQ,
            distanceTextureSwap: distanceTextureSwap,
            textureIsLoaded: textureIsLoaded,
            isAddedToScene: isAddedToScene,
            position: position,
            bvh: bvh,
            collisionRadius: collisionRadius,
            lastDistance: Infinity,
            hqTexture: null,
            lqTexture: lqTexture //Store reference to lof-fi texture
        });
        return modelID;
    }
    /**
    * Generates a random position that is outside of the borderSize
    */ static fnGetRandomPosition(borderSize, rangeX, rangeZ) {
        let x, z;
        //const borderSize = 500; // The excluded zone
        // Randomly decide if we place the object in X or Z direction
        if (Math.random() < 0.5) {
            // Place on left (-x) or right (+x)
            x = (Math.random() < 0.5 ? -1 : 1) * (borderSize + Math.random() * borderSize);
            z = Math.random() * rangeZ - rangeZ / 2; // Fully random Z range
        } else {
            // Place on top (+z) or bottom (-z)
            z = (Math.random() < 0.5 ? -1 : 1) * (borderSize + Math.random() * borderSize);
            x = Math.random() * rangeX - rangeX / 2; // Fully random X range
        }
        return {
            x: x,
            z: z
        };
    }
    /**
     * Generates a random float between min and max.
     */ static randomFloat(min, max) {
        return Math.random() * (max - min) + min;
    }
    /**
     * Generates a random integer between min and max.
     */ static randomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    /**
     * Clamps a value between min and max.
     */ static clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
    }
    /**
     * Linearly interpolates between two values.
     */ static lerp(start, end, t) {
        return start * (1 - t) + end * t;
    }
    /**
     * Checks if an object is within a certain distance from a point.
     */ static fnIsWithinDistance(objPosition, targetPosition, distance) {
        return objPosition.distanceTo(targetPosition) <= distance;
    }
    /**
     * Checks if an object is within the camera frustum.
     */ static fnIsInFrustum(object, camera) {
        const frustum = new $ilwiq.Frustum();
        const cameraViewProjectionMatrix = new $ilwiq.Matrix4();
        camera.updateMatrixWorld();
        camera.updateProjectionMatrix();
        cameraViewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        frustum.setFromProjectionMatrix(cameraViewProjectionMatrix);
        return frustum.intersectsObject(object);
    }
    /**
     * Converts degrees to radians.
     */ static degToRad(degrees) {
        return degrees * (Math.PI / 180);
    }
    /**
     * Converts radians to degrees.
     */ static radToDeg(radians) {
        return radians * (180 / Math.PI);
    }
}



var $ilwiq = parcelRequire("ilwiq");
parcelRequire("1zN5O");
var $kEdgE = parcelRequire("kEdgE");
var $213deb4b79e41658$exports = {};
$213deb4b79e41658$exports = "#define GLSLIFY 1\nuniform float time;\nuniform vec3 cameraPos;\n\nattribute vec3 offset;\nattribute float scale;\nattribute mat3 instanceRotationMatrix;\n\nvarying float vHeight;\n\nconst float WIND_CUTOFF_DISTANCE_SQ = 350.0 * 350.0;\n\n// Simplified hash function using fewer operations\nfloat hash(vec2 p) {\n    return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453);\n}\n\n// Simplified noise - single sample instead of bilinear interpolation\nfloat fastNoise(vec2 p) {\n    vec2 i = floor(p);\n    vec2 f = fract(p);\n    // Use smoother step function\n    vec2 u = f * f * f * (f * (f * 6.0 - 15.0) + 10.0);\n    \n    return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), u.x),\n               mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x), u.y);\n}\n\nvoid main() {\n    // Transform grass geometry\n    vec3 transformedGrass = position * scale;\n    transformedGrass = instanceRotationMatrix * transformedGrass;\n    transformedGrass += offset;\n    \n    // Pre-calculate commonly used values\n    vHeight = clamp(position.y, 0.0, 1.0);\n    \n    // Skip wind calculations if beyond cutoff distance (squared to avoid sqrt)\n    float dx = transformedGrass.x - cameraPos.x;\n    float dz = transformedGrass.z - cameraPos.z;\n    float distSq = dx * dx + dz * dz;\n\n    if (distSq <= WIND_CUTOFF_DISTANCE_SQ) {\n        vec2 worldPos = transformedGrass.xz;\n        \n        // Single noise calculation for both axes (reuse result)\n        float baseNoise = fastNoise(worldPos * 0.1);\n        float timeNoise = fastNoise(vec2(time * 0.1, time * 0.05));\n        \n        // Combine noise effects\n        float windVariation = timeNoise * 0.35;\n        float totalWindEffect = 0.13 + windVariation;\n        \n        // Pre-calculate sine wave components\n        float timeOffset = time * 2.0;\n        float noiseOffset = baseNoise;\n        \n        // Calculate displacement power once\n        float displacementPower = 1.0 - cos(vHeight * 7.854); // 3.1416 / 0.4 = 7.854\n        \n        // Apply wind displacement to both axes\n        float sinZ = sin(offset.z * noiseOffset + timeOffset);\n        float sinX = sin(offset.x * noiseOffset + timeOffset);\n        \n        transformedGrass.z += sinZ * totalWindEffect * displacementPower;\n        transformedGrass.x += sinX * totalWindEffect * displacementPower * 1.2; \n    }\n    \n    csm_Position = transformedGrass;\n}\n\n";


var $82ac0ac0af74734d$exports = {};
$82ac0ac0af74734d$exports = "#define GLSLIFY 1\nvarying float vHeight;\n\nconst float brightness = 1.15;\nconst vec3 topBladeColor = vec3(0.365, 0.588, 0.369);\nconst float mixFactor = 0.80;\nconst vec3 baseColor = vec3(0.5);\n\nvoid main() {\n    float heightCubed = vHeight * vHeight * vHeight * vHeight;\n    vec3 color = mix(baseColor, topBladeColor, mixFactor) * heightCubed * brightness;\n\n    csm_DiffuseColor = vec4(color, 1.0);\n}\n\n";


var $312df7a8ed4359a1$export$2e2bcd8739ae039 = {
    frag: (/*@__PURE__*/$parcel$interopDefault($82ac0ac0af74734d$exports)),
    vert: (/*@__PURE__*/$parcel$interopDefault($213deb4b79e41658$exports))
};



var $ilwiq = parcelRequire("ilwiq");
var $2a219e33fabc058e$exports = {};
$2a219e33fabc058e$exports = "#define GLSLIFY 1\nvarying vec3 vWorldPosition;\nvarying float vDistanceFromCamera;\n\nuniform vec3 uCameraPosition;\n\nvoid main() {\n    vec4 worldPosition = modelMatrix * vec4(position, 1.0);\n    vWorldPosition = worldPosition.xyz;\n\n    // Calculate distance from camera (horizontal only, ignore Y)\n    vec2 horizontalDist = worldPosition.xz - uCameraPosition.xz;\n    vDistanceFromCamera = length(horizontalDist);\n\n    gl_Position = projectionMatrix * viewMatrix * worldPosition;\n}\n";


var $a961711a7411160e$exports = {};
$a961711a7411160e$exports = "#define GLSLIFY 1\n\n// uniform vec3 uBaseColor;\n// uniform sampler2D uEnvMap;\n// uniform vec3 uCameraPosition;\n// uniform float uHazeStart;\n// uniform float uHazeEnd;\n// uniform float uHazeIntensity;\n\n// void main() {\n//     // Direction from camera to fragment\n//     vec3 viewDir = normalize(vWorldPosition - uCameraPosition);\n\n//     // Horizon direction (force horizontal)\n//     vec3 horizonDir = normalize(vec3(viewDir.x, 0.0, viewDir.z));\n\n//     // Convert to equirectangular UV\n//     float u = atan(horizonDir.z, horizonDir.x) / (2.0 * 3.14159265) + 0.5;\n//     float v = asin(clamp(horizonDir.y, -1.0, 1.0)) / 3.14159265 + 0.5;\n\n//     // Sample HDRI\n//     vec3 horizonColor = texture2D(uEnvMap, vec2(u, v)).rgb;\n\n//     // Distance-based haze\n//     float hazeFactor = smoothstep(uHazeStart, uHazeEnd, vDistanceFromCamera) * uHazeIntensity;\n\n//     // Final color\n//     vec3 finalColor = mix(uBaseColor, horizonColor, hazeFactor);\n\n//     gl_FragColor = vec4(finalColor, 1.0);\n// }\n\n// uniform vec3 uBaseColor;\n// uniform sampler2D uEnvMap;\n// uniform vec3 uCameraPosition;\n// uniform float uHazeStart;\n// uniform float uHazeEnd;\n// uniform float uHazeIntensity;\n\n// void main() {\n//     // Direction from camera to fragment\n//     vec3 viewDir = normalize(vWorldPosition - uCameraPosition);\n\n//     // Force horizontal direction for horizon\n//     vec3 horizonDir = normalize(vec3(viewDir.x, 0.0, viewDir.z));\n\n//     // Convert to equirectangular UV\n//     float u = atan(horizonDir.z, horizonDir.x) / (2.0 * 3.14159265) + 0.5;\n//     float v = asin(clamp(horizonDir.y, -1.0, 1.0)) / 3.14159265 + 0.5;\n\n//     // Apply optional vertical offset to align HDRI horizon\n//     v += 0.05;\n//     v = clamp(v, 0.0, 1.0);\n\n//     // Sample HDRI for horizon color\n//     vec3 horizonColor = texture2D(uEnvMap, vec2(u, v)).rgb;\n//     horizonColor = pow(horizonColor, vec3(1.0/2.2));\n\n//     // Distance-based haze factor\n//     float hazeFactor = smoothstep(uHazeStart, uHazeEnd, vDistanceFromCamera) * uHazeIntensity;\n\n//     // Blend base color (black) with horizon color\n//     vec3 finalColor = mix(uBaseColor, horizonColor, hazeFactor);\n\n//     gl_FragColor = vec4(finalColor, 1.0);\n// }\n\nvarying vec3 vWorldPosition;\nvarying float vDistanceFromCamera;\n\nuniform vec3 uBaseColor;\nuniform sampler2D uEnvMap;          // Equirectangular HDR texture\nuniform vec3 uCameraPosition;\nuniform float uHazeStart;\nuniform float uHazeEnd;\nuniform float uHazeIntensity;\n\n#define PI 3.14159265359\n\nvoid main() {\n    // 1\uFE0F\u20E3 Direction from camera to fragment\n    vec3 viewDir = normalize(vWorldPosition - uCameraPosition);\n\n    // 2\uFE0F\u20E3 Horizon direction (force horizontal)\n    vec3 horizonDir = normalize(vec3(viewDir.x, 0.0, viewDir.z));\n\n    // 3\uFE0F\u20E3 Convert direction to equirectangular UV coordinates\n    float u = atan(horizonDir.z, horizonDir.x) / (2.0 * PI) + 0.5;\n    float v = 0.5; // Sample at horizon (middle of texture vertically)\n\n    // 4\uFE0F\u20E3 Sample HDR texture\n    vec3 horizonColor = texture2D(uEnvMap, vec2(u, v)).rgb;\n\n    // 5\uFE0F\u20E3 Distance-based haze factor\n    float hazeFactor = smoothstep(uHazeStart, uHazeEnd, vDistanceFromCamera) * uHazeIntensity;\n\n    // 6\uFE0F\u20E3 Blend base color with horizon color\n    vec3 finalColor = mix(uBaseColor, horizonColor, hazeFactor);\n\n    gl_FragColor = vec4(finalColor, 1.0);\n}";


var $d43eec820dad1e5b$export$2e2bcd8739ae039 = {
    frag: (/*@__PURE__*/$parcel$interopDefault($a961711a7411160e$exports)),
    vert: (/*@__PURE__*/$parcel$interopDefault($2a219e33fabc058e$exports))
};


function $9458edc618713703$export$acf715a863dac43c(options = {}) {
    const { baseColor: baseColor = new $ilwiq.Color(0x000000), envMap: envMap = envMap, hazeStart: hazeStart = 100, hazeEnd: hazeEnd = 500, horizonHeight: horizonHeight = 0.05, hazeIntensity: hazeIntensity = 1.0 // overall haze strength (0-1)
     } = options;
    const material = new $ilwiq.ShaderMaterial({
        uniforms: {
            uBaseColor: {
                value: baseColor
            },
            uEnvMap: {
                value: envMap
            },
            uCameraPosition: {
                value: new $ilwiq.Vector3()
            },
            uHazeStart: {
                value: hazeStart
            },
            uHazeEnd: {
                value: hazeEnd
            },
            uHorizonHeight: {
                value: horizonHeight
            },
            uHazeIntensity: {
                value: hazeIntensity
            }
        },
        vertexShader: (0, $d43eec820dad1e5b$export$2e2bcd8739ae039).vert,
        fragmentShader: (0, $d43eec820dad1e5b$export$2e2bcd8739ae039).frag,
        side: $ilwiq.FrontSide
    });
    return material;
}



var $f5862e2ae37e5af1$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $f5862e2ae37e5af1$var$url = new URL("grassWorker.c6d2df66.js", import.meta.url);
$f5862e2ae37e5af1$exports = $56b621a6dd25b2cb$exports($f5862e2ae37e5af1$var$url.toString(), $f5862e2ae37e5af1$var$url.origin, true);


class $2c13acf5111e79d3$export$7a788af8dc4eb88e {
    // Constants
    #chunkSize = 400;
    #viewRadius = 5;
    #unloadRadius = 6;
    #chunkVertexCount = 11;
    #instanceCount = 7000;
    #GRASS_MESH_ENVMAP_INTENSITY = 0.35;
    // Limits how many terrain chunks can be generated per animation frame.
    // Without this cap, the first frame would synchronously generate all ~120 missing
    // chunks at once (geometry creation + simplex noise per vertex), causing a hard freeze.
    // At 4 per frame the world fills in smoothly over ~30 frames instead.
    #maxChunksPerFrame = 4;
    #specialChunks = {
    };
    #GRASS_LOD_LEVELS = [
        {
            distanceSq: 10000,
            multiplier: 1.0
        },
        {
            distanceSq: 22500,
            multiplier: 1.0
        },
        {
            distanceSq: 40000,
            multiplier: 0.95
        },
        {
            distanceSq: 62500,
            multiplier: 0.92
        },
        {
            distanceSq: 90000,
            multiplier: 0.80
        },
        {
            distanceSq: 122500,
            multiplier: 0.70
        },
        {
            distanceSq: 160000,
            multiplier: 0.60
        },
        {
            distanceSq: 202500,
            multiplier: 0.50
        },
        {
            distanceSq: 250000,
            multiplier: 0.40
        },
        {
            distanceSq: 360000,
            multiplier: 0.30
        },
        {
            distanceSq: 490000,
            multiplier: 0.2
        },
        {
            distanceSq: 640000,
            multiplier: 0.1
        },
        {
            distanceSq: 810000,
            multiplier: 0.1
        },
        {
            distanceSq: 1000000,
            multiplier: 0.01
        },
        {
            distanceSq: 1440000,
            multiplier: 0.01
        },
        {
            distanceSq: Infinity,
            multiplier: 0.001
        }
    ];
    // State
    #loadedChunks = new Map();
    #grassWorkerPool = [];
    #grassWorkerQueue = [];
    #allGrassComputed = false;
    // Tracks how many grass worker tasks are currently in-flight (queued or being processed).
    // Used to set allGrassComputed only when every task has truly finished, not just when
    // the queue happens to be empty (which can happen while workers are still running).
    #pendingWorkerCount = 0;
    // References
    #worldScene;
    #camera;
    #bladeGeometry;
    #grassMaterial;
    #groundMaterial;
    #halfChunkSize;
    constructor({ worldScene: worldScene, camera: camera }){
        this.#worldScene = worldScene;
        this.#camera = camera;
        this.#halfChunkSize = this.#chunkSize * 0.5;
        // Create grass blade geometry
        this.#bladeGeometry = new $ilwiq.ShapeGeometry(this.#createGrassBladeShape());
        // Create grass material
        this.#grassMaterial = new (0, $kEdgE.C)({
            baseMaterial: $ilwiq.MeshStandardMaterial,
            uniforms: {
                time: {
                    value: 0.0
                },
                cameraPos: {
                    value: camera.position
                }
            },
            vertexShader: (0, $312df7a8ed4359a1$export$2e2bcd8739ae039).vert,
            fragmentShader: (0, $312df7a8ed4359a1$export$2e2bcd8739ae039).frag,
            vertexColors: false,
            side: $ilwiq.DoubleSide,
            fog: true
        });
        // envMapIntensity is set once on the shared material here rather than inside the worker
        // callback. Setting it there (once per chunk response) would trigger material.needsUpdate
        // on the same shared material object every time a worker finishes, causing repeated GPU
        // shader recompiles during initial load.
        this.#grassMaterial.envMapIntensity = this.#GRASS_MESH_ENVMAP_INTENSITY;
        // Create ground material
        this.#groundMaterial = (0, $9458edc618713703$export$acf715a863dac43c)({
            baseColor: new $ilwiq.Color(0x000000),
            envMap: worldScene.envMap,
            hazeStart: 1300,
            hazeEnd: 1700,
            horizonHeight: 0.5,
            hazeIntensity: 0.65
        });
        // Both material env maps are updated in a single skyboxPromise callback so each material
        // recompiles its shader exactly once. Previously the ground material was updated here and
        // the grass material was updated inside the worker reply handler — that meant one recompile
        // per loaded chunk (up to 120+) instead of one recompile total.
        worldScene.skyboxPromise.then((texture)=>{
            if (this.#grassMaterial) {
                this.#grassMaterial.envMap = worldScene.envMap;
                this.#grassMaterial.needsUpdate = true;
            }
            if (this.#groundMaterial && this.#groundMaterial.uniforms) {
                this.#groundMaterial.uniforms.uEnvMap.value = texture;
                this.#groundMaterial.needsUpdate = true;
            }
        });
        // Initialize worker pool
        this.#initWorkerPool();
    }
    // Whether all queued grass worker tasks have finished
    get allGrassComputed() {
        return this.#allGrassComputed;
    }
    // Generate the starting grid of terrain chunks (sizeInChunks x sizeInChunks)
    loadInitialTerrain(sizeInChunks) {
        for(let z = 0; z < sizeInChunks; z++)for(let x = 0; x < sizeInChunks; x++){
            const chunkKey = `${x},${z}`;
            if (!this.#loadedChunks.has(chunkKey)) {
                const chunkMesh = this.#generateChunk(x, z);
                this.#worldScene.scene.add(chunkMesh);
                // chunkX and chunkZ are stored in the chunk data so that the per-frame
                // unload and LOD methods can read them directly rather than splitting and
                // parsing the string key on every chunk every frame.
                this.#loadedChunks.set(chunkKey, {
                    terrainMesh: chunkMesh,
                    chunkX: x,
                    chunkZ: z
                });
            }
        }
    }
    // Per-frame update: haze camera uniform, chunk streaming, grass LOD and wind
    update(playerPosition, deltaTime) {
        // Update ground material camera position for horizon haze effect
        this.#groundMaterial.uniforms.uCameraPosition.value.copy(playerPosition);
        // Dynamically update chunks
        this.#loadChunksAroundPlayer(playerPosition);
        this.#adjustGrassInstanceCount(playerPosition);
        this.#unloadFarChunks(playerPosition);
        // Update time for wind animation
        this.#grassMaterial.uniforms.time.value += deltaTime * 1.0;
    }
    // Build the tapered triangle Shape used for each grass blade
    #createGrassBladeShape() {
        const shape = new $ilwiq.Shape();
        shape.moveTo(-0.074, 0);
        shape.lineTo(0.074, 0);
        shape.lineTo(0, 2.2);
        shape.lineTo(-0.074, 0);
        return shape;
    }
    // Spawn web workers (one per CPU core) for off-thread grass placement
    #initWorkerPool() {
        const workerPoolSize = navigator.hardwareConcurrency || 4;
        for(let i = 0; i < workerPoolSize; i++){
            const worker = new Worker($f5862e2ae37e5af1$exports);
            worker.onmessage = (event)=>this.#handleWorkerMessage(event, worker);
            this.#grassWorkerPool.push(worker);
        }
    }
    // Receive computed grass data from a worker and create the InstancedMesh
    #handleWorkerMessage(event, worker) {
        const { chunkKey: chunkKey, grassGeometryData: grassGeometryData } = event.data;
        const grassGeometry = new $ilwiq.InstancedBufferGeometry();
        grassGeometry.copy(this.#bladeGeometry);
        grassGeometry.setAttribute("instanceRotationMatrix", new $ilwiq.InstancedBufferAttribute(grassGeometryData.rotationMatrices, 9));
        grassGeometry.setAttribute("scale", new $ilwiq.InstancedBufferAttribute(grassGeometryData.scales, 1));
        grassGeometry.setAttribute("offset", new $ilwiq.InstancedBufferAttribute(grassGeometryData.offsets, 3));
        const grassMesh = new $ilwiq.InstancedMesh(grassGeometry, this.#grassMaterial, grassGeometryData.instanceCount);
        grassMesh.geometry.boundingSphere = grassGeometryData.boundingSphere;
        // envMap and envMapIntensity are intentionally NOT set here. All grass meshes share
        // the same #grassMaterial instance, so setting envMap here would call needsUpdate on
        // the shared material once per worker reply, causing a shader recompile per chunk.
        // Instead, both are set once in the constructor after the skybox loads.
        this.#worldScene.scene.add(grassMesh);
        if (this.#loadedChunks.has(chunkKey)) this.#loadedChunks.get(chunkKey).grassMesh = grassMesh;
        // Decrement to reflect this task completing. If more tasks are queued, hand the next
        // one directly to this worker so it stays busy without returning to the pool first.
        // The queued task's count was already incremented when it was enqueued in
        // #postToGrassWorker, so we must NOT increment again here — only decrement for the
        // task that just finished.
        this.#pendingWorkerCount--;
        if (this.#grassWorkerQueue.length > 0) {
            const nextTask = this.#grassWorkerQueue.shift();
            worker.postMessage(nextTask);
        } else this.#grassWorkerPool.push(worker);
        // Only mark completion when every in-flight task has finished. Previously the flag
        // was set as soon as the queue drained, which could happen while several workers were
        // still computing their current task — causing allGrassComputed to fire too early.
        if (this.#pendingWorkerCount === 0) this.#allGrassComputed = true;
    }
    // Send a task to an idle worker, or queue it if all workers are busy
    #postToGrassWorker(task) {
        // Increment before dispatching so the counter is always >= the number of active tasks.
        // allGrassComputed is reset to false because new work is now in flight — the flag will
        // be set back to true once this (and any other pending) tasks complete.
        this.#pendingWorkerCount++;
        this.#allGrassComputed = false;
        if (this.#grassWorkerPool.length > 0) {
            const worker = this.#grassWorkerPool.pop();
            worker.postMessage(task);
        } else this.#grassWorkerQueue.push(task);
    }
    // Create a terrain mesh and dispatch grass generation for one chunk
    #generateChunk(x, z) {
        const offsetX = x * this.#chunkSize;
        const offsetZ = z * this.#chunkSize;
        const chunkKey = `${x},${z}`;
        const isSpecialChunk = this.#specialChunks.hasOwnProperty(chunkKey);
        const chunkProps = isSpecialChunk ? this.#specialChunks[chunkKey] : {
            type: "default",
            materialColor: 0x000000,
            grassBladeCount: this.#instanceCount
        };
        // A deterministic seed derived from chunk coordinates. XOR-combining two large primes
        // gives a good spread with no collisions for reasonable chunk ranges. The >>> 0 coerces
        // the result to an unsigned 32-bit integer as expected by mulberry32.
        // This ensures the worker produces identical grass positions every time this chunk loads,
        // preventing visible popping when a chunk is unloaded and re-entered.
        const seed = (x * 73856093 ^ z * 19349663) >>> 0;
        this.#postToGrassWorker({
            chunkKey: chunkKey,
            offsetX: offsetX,
            offsetZ: offsetZ,
            chunkSize: this.#chunkSize,
            instanceCount: chunkProps.grassBladeCount,
            seed: seed
        });
        const baseGeometry = new $ilwiq.PlaneGeometry(this.#chunkSize, this.#chunkSize, this.#chunkVertexCount, this.#chunkVertexCount);
        baseGeometry.rotateX(-Math.PI / 2);
        baseGeometry.translate(this.#chunkSize / 2, 0, this.#chunkSize / 2);
        // The bounding sphere center must be the midpoint of the geometry in local space.
        // After translate(chunkSize/2, 0, chunkSize/2), vertex X and Z both span [0, chunkSize],
        // so the center is (chunkSize/2, 0, chunkSize/2). The previous value was (chunkSize, 0,
        // chunkSize) — the far corner — which placed the sphere off-center and broke Three.js
        // frustum culling, causing all terrain chunks to be submitted to the GPU every frame
        // even when they were clearly outside the camera's view.
        const chunkBoundingSphere = new $ilwiq.Sphere(new $ilwiq.Vector3(this.#chunkSize / 2, 0.0, this.#chunkSize / 2), this.#chunkSize * 1.0);
        baseGeometry.boundingSphere = chunkBoundingSphere;
        const vertices = baseGeometry.attributes.position.array;
        for(let i = 0; i < vertices.length; i += 3){
            const vertexX = vertices[i] + offsetX;
            const vertexZ = vertices[i + 2] + offsetZ;
            vertices[i + 1] = (0, $320c956a09dd2394$export$c08559766941f856)(vertexX, vertexZ);
        }
        const chunkMesh = new $ilwiq.Mesh(baseGeometry, this.#groundMaterial);
        chunkMesh.position.set(offsetX, 0, offsetZ);
        return chunkMesh;
    }
    // Generate missing chunks within viewRadius of the player, at most #maxChunksPerFrame per call.
    // This is called every frame, so without the cap it would try to generate all ~120 missing
    // chunks synchronously on the first frame — each requiring geometry allocation and simplex
    // noise evaluation per vertex — causing a hard freeze before the first render.
    #loadChunksAroundPlayer(playerPosition) {
        const playerChunkX = Math.floor(playerPosition.x / this.#chunkSize);
        const playerChunkZ = Math.floor(playerPosition.z / this.#chunkSize);
        let generated = 0;
        for(let dz = -this.#viewRadius; dz <= this.#viewRadius; dz++)for(let dx = -this.#viewRadius; dx <= this.#viewRadius; dx++){
            if (generated >= this.#maxChunksPerFrame) return;
            const chunkX = playerChunkX + dx;
            const chunkZ = playerChunkZ + dz;
            const chunkKey = `${chunkX},${chunkZ}`;
            if (!this.#loadedChunks.has(chunkKey)) {
                const chunkMesh = this.#generateChunk(chunkX, chunkZ);
                this.#worldScene.scene.add(chunkMesh);
                this.#loadedChunks.set(chunkKey, {
                    terrainMesh: chunkMesh,
                    chunkX: chunkX,
                    chunkZ: chunkZ
                });
                generated++;
            }
        }
    }
    // Remove and dispose chunks beyond unloadRadius from the player
    #unloadFarChunks(playerPosition) {
        const playerChunkX = Math.floor(playerPosition.x / this.#chunkSize);
        const playerChunkZ = Math.floor(playerPosition.z / this.#chunkSize);
        this.#loadedChunks.forEach((chunk, key)=>{
            // chunkX/chunkZ were stored when the chunk was inserted, avoiding key.split(",").map(Number)
            // on every chunk every frame (which created allocations and GC pressure at 100+ chunks).
            const { chunkX: chunkX, chunkZ: chunkZ } = chunk;
            const distance = Math.max(Math.abs(chunkX - playerChunkX), Math.abs(chunkZ - playerChunkZ));
            if (distance > this.#unloadRadius) {
                this.#worldScene.scene.remove(chunk.terrainMesh);
                chunk.terrainMesh.geometry.dispose();
                if (chunk.grassMesh) {
                    this.#worldScene.scene.remove(chunk.grassMesh);
                    chunk.grassMesh.geometry.dispose();
                }
                this.#loadedChunks.delete(key);
            }
        });
    }
    // Reduce visible grass instances on distant chunks for performance
    #adjustGrassInstanceCount(playerPosition) {
        const playerX = playerPosition.x;
        const playerZ = playerPosition.z;
        this.#loadedChunks.forEach((chunk, key)=>{
            if (this.#specialChunks.hasOwnProperty(key) || !chunk.grassMesh) return;
            // Same as above — use stored coords rather than splitting the key string.
            const { chunkX: chunkX, chunkZ: chunkZ } = chunk;
            const centerX = chunkX * this.#chunkSize + this.#halfChunkSize;
            const centerZ = chunkZ * this.#chunkSize + this.#halfChunkSize;
            const deltaX = playerX - centerX;
            const deltaZ = playerZ - centerZ;
            const distanceSq = deltaX * deltaX + deltaZ * deltaZ;
            for(let i = 0; i < this.#GRASS_LOD_LEVELS.length; i++)if (distanceSq <= this.#GRASS_LOD_LEVELS[i].distanceSq) {
                const newCount = Math.floor(this.#instanceCount * this.#GRASS_LOD_LEVELS[i].multiplier);
                if (chunk.grassMesh.count !== newCount) chunk.grassMesh.count = newCount;
                break;
            }
        });
    }
}


var $e40f0939130a5d82$exports = {};
$e40f0939130a5d82$exports = "#define GLSLIFY 1\n    varying float vPositionAlongLine;\n\n    void main() {\n        //vPositionAlongLine = position.z; // Assuming the line runs along the x-axis\n        vPositionAlongLine = (position.z) ; // Assuming the line runs along the x-axis from -5 to 5\n        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n    }";


var $77e9639cdeff831d$exports = {};
$77e9639cdeff831d$exports = "#define GLSLIFY 1\nuniform float uTime;\nuniform vec3 colorStart;\nuniform vec3 colorEnd;\nvarying float vPositionAlongLine;\n\n// Precompute constants\nconst float TIME_SCALE = 0.15;\nconst float POSITION_SCALE = 0.0125; // 1.0/80.0 precomputed\nconst float ALPHA = 0.70;\nconst float SMOOTHSTEP_MIN = 0.4;\nconst float SMOOTHSTEP_MAX = 1.0;\nconst float SMOOTHSTEP_RANGE = 0.6; // 1.0 - 0.4\n\nvoid main() {\n    // Single calculation combining time and position effects\n    float runEffect = abs(sin(uTime * TIME_SCALE - vPositionAlongLine * POSITION_SCALE));\n    \n    // Optimized smoothstep - avoid division by precomputing range\n    float t = clamp((runEffect - SMOOTHSTEP_MIN) / SMOOTHSTEP_RANGE, 0.0, 1.0);\n    // Apply smoothstep curve manually (more efficient than built-in smoothstep)\n    t = t * t * (3.0 - 2.0 * t);\n    \n    // Mix colors and output\n    vec3 color = mix(colorStart, colorEnd, t);\n    gl_FragColor = vec4(color, ALPHA);\n}\n";


var $70eca344ea66fcb2$export$2e2bcd8739ae039 = {
    frag: (/*@__PURE__*/$parcel$interopDefault($77e9639cdeff831d$exports)),
    vert: (/*@__PURE__*/$parcel$interopDefault($e40f0939130a5d82$exports))
};



var $ilwiq = parcelRequire("ilwiq");
var $4e1ed3af3349301e$exports = {};
$4e1ed3af3349301e$exports = "#define GLSLIFY 1\n\nvarying vec2 vUv;\nvarying float vCameraDistance;\nuniform float uTime;\n\n// Simple noise function (much lighter than Simplex)\nfloat hash(float n) {\n    return fract(sin(n) * 43758.5453);\n}\n\nfloat noise(float x) {\n    float i = floor(x);\n    float f = fract(x);\n    f = f * f * (3.0 - 2.0 * f);\n    return mix(hash(i), hash(i + 1.0), f);\n}\n\nvoid main() {\n    vUv = uv;\n    \n    vec3 pos = position;\n    \n    float n = noise(pos.x * 0.008 + uTime);\n    pos.z += n * 20.0;\n    \n    vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);\n    gl_Position = projectionMatrix * mvPosition;\n    vCameraDistance = -mvPosition.z;\n}\n";


var $ca8811fba9d4a1cf$exports = {};
$ca8811fba9d4a1cf$exports = "#define GLSLIFY 1\nuniform sampler2D videoTexture;\nuniform float edgeTransparency;\nuniform float globalOpacity;\n\nvarying vec2 vUv;\nvarying float vCameraDistance;\n\nconst float minDistance = 400.0;\nconst float maxDistance = 1400.0;\n\nvoid main() {\n    vec4 color = texture2D(videoTexture, vUv);\n    \n    // Edge transparency (simplified)\n    vec2 edgeDist = min(vUv, 1.0 - vUv);\n    float minEdgeDist = min(edgeDist.x, edgeDist.y);\n    float edgeAlpha = smoothstep(0.0, edgeTransparency, minEdgeDist);\n    \n    // Distance attenuation\n    float distanceAttenuation = 1.0 - smoothstep(minDistance, maxDistance, vCameraDistance);\n    \n    // Final alpha\n    float finalAlpha = edgeAlpha * globalOpacity * distanceAttenuation;\n    \n    // Apply distance fading to color (fade to darker/transparent instead of white)\n    vec3 finalColor = color.rgb * distanceAttenuation;\n    \n    gl_FragColor = vec4(finalColor, finalAlpha);\n}\n";


var $57fbb357077db4db$export$2e2bcd8739ae039 = {
    frag: (/*@__PURE__*/$parcel$interopDefault($ca8811fba9d4a1cf$exports)),
    vert: (/*@__PURE__*/$parcel$interopDefault($4e1ed3af3349301e$exports))
};


function $59e304539a3bf5aa$export$d4f3284e3e7553ea(videoTexture, options = {}) {
    const { edgeTransparency: edgeTransparency = 0.15, globalOpacity: globalOpacity = 0.85 } = options;
    return new $ilwiq.ShaderMaterial({
        uniforms: {
            videoTexture: {
                value: videoTexture
            },
            edgeTransparency: {
                value: edgeTransparency
            },
            uTime: {
                value: 0.0
            },
            globalOpacity: {
                value: globalOpacity
            }
        },
        vertexShader: (0, $57fbb357077db4db$export$2e2bcd8739ae039).vert,
        fragmentShader: (0, $57fbb357077db4db$export$2e2bcd8739ae039).frag,
        transparent: true
    });
}


var $0f36310eac0aa08d$exports = {};
$0f36310eac0aa08d$exports = "#define GLSLIFY 1\nvarying vec2 vUv;\nvarying vec3 vPosition;\nvarying vec3 vWorldPosition;\nvarying vec3 vNormalVector;\n\nvoid main() {\n  vUv = uv;\n  vPosition = position;\n  vWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;\n  vNormalVector = normalize(normalMatrix * normal);\n  //gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n  csm_PositionRaw = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}";


var $2e95bb3490454717$exports = {};
$2e95bb3490454717$exports = "#define GLSLIFY 1\nuniform sampler2D uDiffuseMap;\nuniform vec3 hologramColor;\nuniform float time;\nuniform float uOpacity;\nuniform float scanLineFrequency;\nuniform float scanLineSpeed;\nuniform float distortionAmount;\nuniform float glowAmount;\nuniform float flickerSpeed;\nuniform float flickerIntensity;\nuniform float textureInfluence;\nuniform float effectsIntensity;\nuniform float positionScale;\nuniform float uFadeHeight;\nuniform float uTerrainHeight;\nuniform float uBrightness;\n\nvarying vec2 vUv;\nvarying vec3 vPosition;\nvarying vec3 vWorldPosition;\nvarying vec3 vNormalVector;\n\n// Random noise function\nfloat random(vec2 co) {\n  return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main() {\n\n    vec3 finalColor;\n    float holoAlpha;\n    vec2 effectCoords;\n\n    // For effectsIntensity = 0, just show the original texture with full opacity\n\n    if (effectsIntensity < 0.001) {\n        vec4 originalTexture = texture2D(uDiffuseMap, vUv);\n        //gl_FragColor = originalTexture;\n        //csm_DiffuseColor = originalTexture;\n        //csm_DiffuseColor = vec4(originalTexture.rgb, 1.0);\n        finalColor = originalTexture.rgb;\n        holoAlpha = 1.0;\n\n    }else{\n\n        // Using position for effects - normalize and scale\n        // Choose any two axes that work best for your model\n        effectCoords = vec2(vPosition.x * positionScale, vPosition.y * positionScale);\n\n        // Apply time-based distortion to texture coordinates\n        float distortionEffect = sin(effectCoords.y * 10.0 + time) * distortionAmount * 0.1 * effectsIntensity;\n        vec2 distortedCoords = vUv + distortionEffect;\n\n        vec4 texColor = texture2D(uDiffuseMap, distortedCoords);\n\n        // Base color with rim lighting effect\n        float rimLight = pow(1.0 - abs(dot(normalize(vNormalVector), vec3(0.0, 0.0, 1.0))), 2.0);\n        vec3 baseColor = hologramColor * (rimLight * glowAmount + 0.5);\n\n        // Blend texture with hologram color based on textureInfluence\n        baseColor = mix(baseColor, texColor.rgb * hologramColor, textureInfluence);\n\n        // Scanlines - use position or UV\n        float scanY = effectCoords.y;\n        float scanLine = sin(scanY * scanLineFrequency + time * scanLineSpeed) * 0.5 + 0.5;\n        scanLine = pow(scanLine, 0.5);\n        scanLine = mix(1.0, scanLine, effectsIntensity);\n\n        // Flickering effect\n        float flicker = 1.0 - (random(vec2(time * flickerSpeed, time * flickerSpeed)) * flickerIntensity * effectsIntensity);\n\n        // Horizontal glitch lines\n        float glitchY = effectCoords.y;\n        float glitchLine = step(0.98, random(vec2(floor(glitchY * 20.0), time * 0.1))) * effectsIntensity;\n\n        // Combine effects\n        finalColor = baseColor * scanLine * flicker;\n        finalColor += glitchLine * hologramColor * effectsIntensity;\n\n        // Apply distortion to color\n        finalColor += sin(time * 2.0 + scanY * 10.0) * distortionAmount * hologramColor * effectsIntensity;\n\n        // Calculate alpha - blend between full opacity and hologram effect based on effectsIntensity\n        holoAlpha = uOpacity * scanLine * flicker;\n\n        // Optional: Use texture alpha if available\n        if (texColor.a < 1.0) {\n            holoAlpha *= texColor.a;\n        }\n    }\n\n    // Compute the fade effect\n    float fadeFactor = smoothstep(uTerrainHeight, uTerrainHeight + uFadeHeight, vWorldPosition.y);\n\n    // Ensure the fade effect remains strong even with envMap blending\n    finalColor.rgb *= fadeFactor;\n\n    //add brightness\n    finalColor.rgb *= uBrightness;\n\n    // Final output with transparency\n    csm_DiffuseColor = vec4(finalColor, holoAlpha);\n    //gl_FragColor = vec4(finalColor, holoAlpha);\n}";


var $ac4331ebc7819748$export$2e2bcd8739ae039 = {
    frag: (/*@__PURE__*/$parcel$interopDefault($2e95bb3490454717$exports)),
    vert: (/*@__PURE__*/$parcel$interopDefault($0f36310eac0aa08d$exports))
};


var $123ccf140c6eef5b$exports = {};
$123ccf140c6eef5b$exports = "#define GLSLIFY 1\n      varying vec3 vWorldPos;\n      varying vec2 vUv;\n      varying vec3 vNormalVector;\n      varying float vIsFrontFacing;\n      \n      void main() {\n        vUv = uv;\n        vec4 worldPos = modelMatrix * vec4(position, 1.0);\n        vWorldPos = worldPos.xyz;\n        \n        // Calculate world space normal\n        vNormalVector = normalize(mat3(modelMatrix) * normal);\n        \n        // Determine if front facing using the camera position\n        vec3 cameraPosition = cameraPosition; // Built-in three.js variable\n        vec3 viewDirection = normalize(cameraPosition - worldPos.xyz);\n        vIsFrontFacing = dot(vNormalVector, viewDirection) > 0.0 ? 1.0 : -1.0;\n        \n        //gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n        csm_PositionRaw = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n      }";


var $9150cd9ab5a1d2a1$exports = {};
$9150cd9ab5a1d2a1$exports = "#define GLSLIFY 1\n      uniform sampler2D uVideoTexture;\n      uniform sampler2D uDiffuseMap;\n      uniform vec3 uProjectorPosition;\n      uniform vec3 uProjectorDirection;\n      uniform mat4 uProjectorMatrix;\n      uniform float uProjectorFOV;\n      uniform float uProjectorAspect;\n      uniform vec3 uBaseColor;\n      uniform float uProjectionIntensity;\n      uniform float uVignette;\n      uniform float uBlendFactor;\n      uniform float uMinZDistance;\n      uniform float uFadeHeight;\n      uniform float uTerrainHeight;\n      \n      varying vec3 vWorldPos;\n      varying vec2 vUv;\n      varying vec3 vNormalVector;\n      varying float vIsFrontFacing;\n      \nvoid main() {\n  // Sample the diffuse texture\n  vec4 diffuseC = texture2D(uDiffuseMap, vUv);\n  vec3 finalColor = diffuseC.rgb; // Initialize with diffuse color by default\n\n  float fadeFactor = smoothstep(uTerrainHeight, uTerrainHeight + uFadeHeight, vWorldPos.y);\n\n  // We explicitly designate the positive normal direction as the side for projection\n  // For a standard plane, this is the side with normal (0,0,1)\n  bool isProjectionSide = vIsFrontFacing > 0.0; // Only project on front side\n  \n  if (isProjectionSide) {\n    // Direction from projector to this fragment\n    vec3 projToFrag = normalize(vWorldPos - uProjectorPosition);\n    \n    // Project the point onto the projector's viewing plane\n    vec4 projectorViewPosition = uProjectorMatrix * vec4(vWorldPos, 1.0);\n    \n    // If the fragment is in front of the projector, show the projection\n    if (projectorViewPosition.z > uMinZDistance) {\n      // Calculate UV coordinates for projection\n      //float distance = length(vWorldPos - uProjectorPosition);\n      //float attenuation = 1.0 / (1.0 + 0.1 * distance + 0.0 * distance);\n      \n      // Convert view position to NDC space, then to UV coordinates\n      vec2 projUV = projectorViewPosition.xy / projectorViewPosition.z;\n      projUV = projUV * 0.5 + 0.5;\n      \n      // Check if within projection bounds (0 to 1)\n      if (projUV.x >= 0.0 && projUV.x <= 1.0 && projUV.y >= 0.0 && projUV.y <= 1.0) {\n        // Sample video texture with projected coordinates\n        vec4 projectedColor = texture2D(uVideoTexture, projUV);\n        \n        // Add vignette effect for old-school projector look\n        //float vignetteAmount = 1.0 - uVignette * length(projUV - 0.5) * 2.0;\n        //vignetteAmount = clamp(vignetteAmount, 0.0, 1.0);\n        \n        // Add subtle noise for film grain effect\n        //float noise = fract(sin(dot(projUV, vec2(12.9898, 78.233))) * 43758.5453) * 0.09;\n        \n        // Calculate projection color with effects\n        vec3 projColor = projectedColor.rgb * uProjectionIntensity;\n        //projColor += noise;\n        \n        // Screen blend mode (brightens the image)\n        vec3 blendedColor = 1.0 - (1.0 - diffuseC.rgb) * (1.0 - projColor);\n        \n        // Final color is a blend between the diffuse and the blended projection\n        finalColor = mix(diffuseC.rgb , blendedColor, uBlendFactor);\n        finalColor *= 2.5;\n        //finalColor *= fadeFactor;\n      }\n    }\n  }\n  \n  // Always output the final color, whether it's been projected on or not\n  csm_DiffuseColor = vec4(finalColor, 1.0) * fadeFactor;\n}";


var $c758bc53cea77699$export$2e2bcd8739ae039 = {
    frag: (/*@__PURE__*/$parcel$interopDefault($9150cd9ab5a1d2a1$exports)),
    vert: (/*@__PURE__*/$parcel$interopDefault($123ccf140c6eef5b$exports))
};



var $ilwiq = parcelRequire("ilwiq");
parcelRequire("1zN5O");
var $kEdgE = parcelRequire("kEdgE");
var $1c637aeeae793075$exports = {};
$1c637aeeae793075$exports = "#define GLSLIFY 1\n        varying vec3 vWorldPosition;\n        varying vec2 vUv;\n        void main() {\n            vUv = uv;\n            vWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;\n            csm_PositionRaw = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n        }";


var $bf5df50354c55f6d$exports = {};
$bf5df50354c55f6d$exports = "#define GLSLIFY 1\n        uniform bool uHasDiffuseMap;\n        uniform sampler2D uDiffuseMap;\n        uniform vec3 uColor;\n        uniform float uFadeHeight;\n        uniform float uTerrainHeight;\n        uniform float uBrightness;\n        varying vec3 vWorldPosition;\n        varying vec2 vUv;\n\n        void main() {\n            vec4 colorDiffuse = uHasDiffuseMap ? texture2D(uDiffuseMap, vUv) : vec4(uColor, 1.0);\n\n            float fadeFactor = smoothstep(uTerrainHeight, uTerrainHeight + uFadeHeight, vWorldPosition.y);\n\n            colorDiffuse.rgb *= fadeFactor * uBrightness;\n\n            csm_DiffuseColor = colorDiffuse;\n        }";


var $447585841da3dd7f$export$2e2bcd8739ae039 = {
    frag: (/*@__PURE__*/$parcel$interopDefault($bf5df50354c55f6d$exports)),
    vert: (/*@__PURE__*/$parcel$interopDefault($1c637aeeae793075$exports))
};


function $b1c999dd6ba4b081$export$f67d8322b0a09fb0(options = {}) {
    const { fadeHeight: fadeHeight = 5.5, brightness: brightness = 1.0, side: side = $ilwiq.FrontSide } = options;
    return new (0, $kEdgE.C)({
        baseMaterial: $ilwiq.MeshStandardMaterial,
        uniforms: {
            uDiffuseMap: {
                value: null
            },
            uHasDiffuseMap: {
                value: true
            },
            uColor: {
                value: null
            },
            uTerrainHeight: {
                value: null
            },
            uFadeHeight: {
                value: fadeHeight
            },
            uMeshPosition: {
                value: null
            },
            uBrightness: {
                value: brightness
            }
        },
        vertexShader: (0, $447585841da3dd7f$export$2e2bcd8739ae039).vert,
        fragmentShader: (0, $447585841da3dd7f$export$2e2bcd8739ae039).frag,
        side: side
    });
}



var $ilwiq = parcelRequire("ilwiq");
function $7af7b962df193495$export$4af111123e89df35(shader, { defines: defines = "", header: header = "", main: main = "", ...replaces }) {
    let patchedShader = shader;
    const replaceAll = (str, find, rep)=>str.split(find).join(rep);
    Object.keys(replaces).forEach((key)=>{
        patchedShader = replaceAll(patchedShader, key, replaces[key]);
    });
    patchedShader = patchedShader.replace("void main() {", `
      ${header}
      void main() {
        ${main}
      `);
    const stringDefines = Object.keys(defines).map((d)=>`#define ${d} ${defines[d]}`).join("\n");
    return `
      ${stringDefines}
      ${patchedShader}
    `;
}
function $7af7b962df193495$export$322ad2f3e35a0c6f(texture, callback) {
    // return if it's already loaded
    if (texture.image && texture.image.videoWidth !== 0 && texture.image.videoHeight !== 0) return;
    const interval = setInterval(()=>{
        if (texture.image && texture.image.videoWidth !== 0 && texture.image.videoHeight !== 0) {
            clearInterval(interval);
            return callback(texture);
        }
    }, 16);
}


class $0c0e813ce4ad425f$export$2e2bcd8739ae039 extends $ilwiq.MeshStandardMaterial {
    // internal values... they are exposed via getters
    #camera;
    #cover;
    #textureScale;
    get camera() {
        return this.#camera;
    }
    set camera(camera) {
        if (!camera || !camera.isCamera) throw new Error("Invalid camera set to the ProjectedMaterial");
        if (camera.type !== this.#camera.type) throw new Error("Cannot change camera type after the material has been created. Use another material.");
        this.#camera = camera;
        this.#saveDimensions();
    }
    get texture() {
        return this.uniforms.projectedTexture.value;
    }
    set texture(texture) {
        if (!texture?.isTexture) throw new Error("Invalid texture set to the ProjectedMaterial");
        this.uniforms.projectedTexture.value = texture;
        this.uniforms.isTextureLoaded.value = Boolean(texture.image);
        if (!this.uniforms.isTextureLoaded.value) (0, $7af7b962df193495$export$322ad2f3e35a0c6f)(texture, ()=>{
            this.uniforms.isTextureLoaded.value = true;
            this.dispatchEvent({
                type: "textureload"
            });
            this.#saveDimensions();
        });
        else this.#saveDimensions();
    }
    get textureScale() {
        return this.#textureScale;
    }
    set textureScale(textureScale) {
        this.#textureScale = textureScale;
        this.#saveDimensions();
    }
    get textureOffset() {
        return this.uniforms.textureOffset.value;
    }
    set textureOffset(textureOffset) {
        this.uniforms.textureOffset.value = textureOffset;
    }
    get isFaded() {
        return this.uniforms.isFaded.value;
    }
    set isFaded(isFaded) {
        this.uniforms.isFaded.value = isFaded;
    }
    get backgroundOpacity() {
        return this.uniforms.backgroundOpacity.value;
    }
    set backgroundOpacity(backgroundOpacity) {
        this.uniforms.backgroundOpacity.value = backgroundOpacity;
        if (backgroundOpacity < 1 && !this.transparent) console.warn('You have to pass "transparent: true" to the ProjectedMaterial for the backgroundOpacity option to work');
    }
    get cover() {
        return this.#cover;
    }
    set cover(cover) {
        this.#cover = cover;
        this.#saveDimensions();
    }
    constructor({ camera: camera = new $ilwiq.PerspectiveCamera(), texture: texture = new $ilwiq.Texture(), textureScale: textureScale = 1, textureOffset: textureOffset = new $ilwiq.Vector2(), backgroundOpacity: backgroundOpacity = 1, cover: cover = false, fadeHeight: fadeHeight = null, terrainHeight: terrainHeight = null, isFaded: isFaded = false, ...options } = {}){
        if (!texture.isTexture) throw new Error("Invalid texture passed to the ProjectedMaterial");
        if (!camera.isCamera) throw new Error("Invalid camera passed to the ProjectedMaterial");
        if (backgroundOpacity < 1 && !options.transparent) console.warn('You have to pass "transparent: true" to the ProjectedMaterial for the backgroundOpacity option to work');
        super(options);
        Object.defineProperty(this, "isProjectedMaterial", {
            value: true
        });
        // save the private variables
        this.#camera = camera;
        this.#cover = cover;
        this.#textureScale = textureScale;
        // scale to keep the image proportions and apply textureScale
        const [widthScaled, heightScaled] = $0c0e813ce4ad425f$var$computeScaledDimensions(texture, camera, textureScale, cover);
        this.uniforms = {
            projectedTexture: {
                value: texture
            },
            // this avoids rendering black if the texture
            // hasn't loaded yet
            isTextureLoaded: {
                value: Boolean(texture.image)
            },
            // don't show the texture if we haven't called project()
            isTextureProjected: {
                value: false
            },
            // if we have multiple materials we want to show the
            // background only of the first material
            backgroundOpacity: {
                value: backgroundOpacity
            },
            // these will be set on project()
            viewMatrixCamera: {
                value: new $ilwiq.Matrix4()
            },
            projectionMatrixCamera: {
                value: new $ilwiq.Matrix4()
            },
            projPosition: {
                value: new $ilwiq.Vector3()
            },
            projDirection: {
                value: new $ilwiq.Vector3(0, 0, -1)
            },
            // we will set this later when we will have positioned the object
            savedModelMatrix: {
                value: new $ilwiq.Matrix4()
            },
            widthScaled: {
                value: widthScaled
            },
            heightScaled: {
                value: heightScaled
            },
            textureOffset: {
                value: textureOffset
            },
            fadeHeight: {
                value: fadeHeight
            },
            terrainHeight: {
                value: terrainHeight
            },
            isFaded: {
                value: isFaded
            }
        };
        this.onBeforeCompile = (shader)=>{
            // expose also the material's uniforms
            Object.assign(this.uniforms, shader.uniforms);
            shader.uniforms = this.uniforms;
            if (this.camera.isOrthographicCamera) shader.defines.ORTHOGRAPHIC = "";
            shader.vertexShader = (0, $7af7b962df193495$export$4af111123e89df35)(shader.vertexShader, {
                header: /* glsl */ `
          uniform mat4 viewMatrixCamera;
          uniform mat4 projectionMatrixCamera;

          #ifdef USE_INSTANCING
          attribute vec4 savedModelMatrix0;
          attribute vec4 savedModelMatrix1;
          attribute vec4 savedModelMatrix2;
          attribute vec4 savedModelMatrix3;
          #else
          uniform mat4 savedModelMatrix;
          #endif

          varying vec3 vSavedNormal;
          varying vec4 vTexCoords;
          #ifndef ORTHOGRAPHIC
          varying vec4 vWorldPosition;
          #endif
        `,
                main: /* glsl */ `
          #ifdef USE_INSTANCING
          mat4 savedModelMatrix = mat4(
            savedModelMatrix0,
            savedModelMatrix1,
            savedModelMatrix2,
            savedModelMatrix3
          );
          #endif

          vSavedNormal = mat3(savedModelMatrix) * normal;
          vTexCoords = projectionMatrixCamera * viewMatrixCamera * savedModelMatrix * vec4(position, 1.0);
          #ifndef ORTHOGRAPHIC
          vWorldPosition = savedModelMatrix * vec4(position, 1.0);
          #endif
        `
            });
            shader.fragmentShader = (0, $7af7b962df193495$export$4af111123e89df35)(shader.fragmentShader, {
                header: /* glsl */ `
          uniform sampler2D projectedTexture;
          uniform bool isTextureLoaded;
          uniform bool isTextureProjected;
          uniform bool isFaded;
          uniform float backgroundOpacity;
          uniform vec3 projPosition;
          uniform vec3 projDirection;
          uniform float widthScaled;
          uniform float heightScaled;
          uniform vec2 textureOffset;
          uniform float fadeHeight;
          uniform float terrainHeight;
          uniform vec3 meshPosition;


          varying vec3 vSavedNormal;
          varying vec4 vTexCoords;
          #ifndef ORTHOGRAPHIC
          varying vec4 vWorldPosition;
          #endif

          float mapRange(float value, float min1, float max1, float min2, float max2) {
            return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
          }
        `,
                "vec4 diffuseColor = vec4( diffuse, opacity );": /* glsl */ `
          // clamp the w to make sure we don't project behind
          float w = max(vTexCoords.w, 0.0);

          vec2 uv = (vTexCoords.xy / w) * 0.5 + 0.5;

          uv += textureOffset;

          // apply the corrected width and height
          uv.x = mapRange(uv.x, 0.0, 1.0, 0.5 - widthScaled / 2.0, 0.5 + widthScaled / 2.0);
          uv.y = mapRange(uv.y, 0.0, 1.0, 0.5 - heightScaled / 2.0, 0.5 + heightScaled / 2.0);

          // this makes sure we don't sample out of the texture
          bool isInTexture = (max(uv.x, uv.y) <= 1.0 && min(uv.x, uv.y) >= 0.0);

          // this makes sure we don't render also the back of the object
          #ifdef ORTHOGRAPHIC
          vec3 projectorDirection = projDirection;
          #else
          vec3 projectorDirection = normalize(projPosition - vWorldPosition.xyz);
          #endif
          float dotProduct = dot(vSavedNormal, projectorDirection);
          bool isFacingProjector = dotProduct > 0.0000001;

          //edge fade
          // 1) Compute fade factor from UV edge
          vec2 center = vec2(0.5, 0.5);
          float dist = distance(uv, center);

          // Where fade starts & ends (adjust as needed)
          float edgeFade = smoothstep(0.3, 0.6, dist);
          float projectorFade = 1.0 - edgeFade;

          // Clamp to inside frustum too
          projectorFade *= float(isInTexture);



          vec4 diffuseColor = vec4(diffuse, opacity);
          float fadeFactor = 1.0;

          if (isFaded) {
            fadeFactor = smoothstep(terrainHeight, terrainHeight + fadeHeight, vWorldPosition.y);
            //diffuseColor = vec4(1.0, 0.0, 0.0, 1.0);
          }

          vec4 textureColor = vec4(0.0);
          //float projectionStrength =

          if (isFacingProjector && isInTexture && isTextureLoaded && isTextureProjected) {
            textureColor = texture2D(projectedTexture, uv);
            textureColor.rgb *= 1.5;


            textureColor.a *= projectorFade;
            //textureColor.a *= opacity * 1.5;
          }
   

          diffuseColor = mix(diffuseColor, textureColor, textureColor.a);
      
          diffuseColor = vec4(diffuseColor.rgb, diffuseColor.a) * fadeFactor;
        `
            });
        };
        // Listen on resize if the camera used for the projection
        // is the same used to render.
        // We do this on window resize because there is no way to
        // listen for the resize of the renderer
        window.addEventListener("resize", this.#saveCameraProjectionMatrix);
        // If the image texture passed hasn't loaded yet,
        // wait for it to load and compute the correct proportions.
        // This avoids rendering black while the texture is loading
        (0, $7af7b962df193495$export$322ad2f3e35a0c6f)(texture, ()=>{
            this.uniforms.isTextureLoaded.value = true;
            this.dispatchEvent({
                type: "textureload"
            });
            this.#saveDimensions();
        });
    }
    #saveCameraProjectionMatrix = ()=>{
        this.uniforms.projectionMatrixCamera.value.copy(this.camera.projectionMatrix);
        this.#saveDimensions();
    };
    #saveDimensions() {
        const [widthScaled, heightScaled] = $0c0e813ce4ad425f$var$computeScaledDimensions(this.texture, this.camera, this.textureScale, this.cover);
        this.uniforms.widthScaled.value = widthScaled;
        this.uniforms.heightScaled.value = heightScaled;
    }
    #saveCameraMatrices() {
        // make sure the camera matrices are updated
        this.camera.updateProjectionMatrix();
        this.camera.updateMatrixWorld();
        this.camera.updateWorldMatrix();
        // update the uniforms from the camera so they're
        // fixed in the camera's position at the projection time
        const viewMatrixCamera = this.camera.matrixWorldInverse;
        const projectionMatrixCamera = this.camera.projectionMatrix;
        const modelMatrixCamera = this.camera.matrixWorld;
        this.uniforms.viewMatrixCamera.value.copy(viewMatrixCamera);
        this.uniforms.projectionMatrixCamera.value.copy(projectionMatrixCamera);
        this.uniforms.projPosition.value.setFromMatrixPosition(modelMatrixCamera);
        this.uniforms.projDirection.value.set(0, 0, 1).applyMatrix4(modelMatrixCamera);
        // tell the shader we've projected
        this.uniforms.isTextureProjected.value = true;
    }
    project(mesh) {
        if (!(Array.isArray(mesh.material) ? mesh.material.some((m)=>m.isProjectedMaterial) : mesh.material.isProjectedMaterial)) throw new Error(`The mesh material must be a ProjectedMaterial`);
        if (!(Array.isArray(mesh.material) ? mesh.material.some((m)=>m === this) : mesh.material === this)) throw new Error(`The provided mesh doesn't have the same material as where project() has been called from`);
        // make sure the matrix is updated
        mesh.updateWorldMatrix(true, false);
        // we save the object model matrix so it's projected relative
        // to that position, like a snapshot
        this.uniforms.savedModelMatrix.value.copy(mesh.matrixWorld);
        // if the material is not the first, output just the texture
        if (Array.isArray(mesh.material)) {
            const materialIndex = mesh.material.indexOf(this);
            if (!mesh.material[materialIndex].transparent) console.warn(`You have to pass "transparent: true" to the ProjectedMaterial if you're working with multiple materials.`);
            if (materialIndex > 0) this.uniforms.backgroundOpacity.value = 0;
        }
        // persist also the current camera position and matrices
        this.#saveCameraMatrices();
    }
    projectInstanceAt(index, instancedMesh, matrixWorld, { forceCameraSave: forceCameraSave = false } = {}) {
        if (!instancedMesh.isInstancedMesh) throw new Error(`The provided mesh is not an InstancedMesh`);
        if (!(Array.isArray(instancedMesh.material) ? instancedMesh.material.every((m)=>m.isProjectedMaterial) : instancedMesh.material.isProjectedMaterial)) throw new Error(`The InstancedMesh material must be a ProjectedMaterial`);
        if (!(Array.isArray(instancedMesh.material) ? instancedMesh.material.some((m)=>m === this) : instancedMesh.material === this)) throw new Error(`The provided InstancedMeshhave't i samenclude thas e material where project() has been called from`);
        if (!instancedMesh.geometry.attributes[`savedModelMatrix0`] || !instancedMesh.geometry.attributes[`savedModelMatrix1`] || !instancedMesh.geometry.attributes[`savedModelMatrix2`] || !instancedMesh.geometry.attributes[`savedModelMatrix3`]) throw new Error(`No allocated data found on the geometry, please call 'allocateProjectionData(geometry, instancesCount)'`);
        instancedMesh.geometry.attributes[`savedModelMatrix0`].setXYZW(index, matrixWorld.elements[0], matrixWorld.elements[1], matrixWorld.elements[2], matrixWorld.elements[3]);
        instancedMesh.geometry.attributes[`savedModelMatrix1`].setXYZW(index, matrixWorld.elements[4], matrixWorld.elements[5], matrixWorld.elements[6], matrixWorld.elements[7]);
        instancedMesh.geometry.attributes[`savedModelMatrix2`].setXYZW(index, matrixWorld.elements[8], matrixWorld.elements[9], matrixWorld.elements[10], matrixWorld.elements[11]);
        instancedMesh.geometry.attributes[`savedModelMatrix3`].setXYZW(index, matrixWorld.elements[12], matrixWorld.elements[13], matrixWorld.elements[14], matrixWorld.elements[15]);
        // if the material is not the first, output just the texture
        if (Array.isArray(instancedMesh.material)) {
            const materialIndex = instancedMesh.material.indexOf(this);
            if (!instancedMesh.material[materialIndex].transparent) console.warn(`You have to pass "transparent: true" to the ProjectedMaterial if you're working with multiple materials.`);
            if (materialIndex > 0) this.uniforms.backgroundOpacity.value = 0;
        }
        // persist the current camera position and matrices
        // only if it's the first instance since most surely
        // in all other instances the camera won't change
        if (index === 0 || forceCameraSave) this.#saveCameraMatrices();
    }
    copy(source) {
        super.copy(source);
        this.camera = source.camera;
        this.texture = source.texture;
        this.textureScale = source.textureScale;
        this.textureOffset = source.textureOffset;
        this.cover = source.cover;
        return this;
    }
    dispose() {
        super.dispose();
        window.removeEventListener("resize", this.#saveCameraProjectionMatrix);
    }
}
// get camera ratio from different types of cameras
function $0c0e813ce4ad425f$var$getCameraRatio(camera) {
    switch(camera.type){
        case "PerspectiveCamera":
            return camera.aspect;
        case "OrthographicCamera":
            {
                const width = Math.abs(camera.right - camera.left);
                const height = Math.abs(camera.top - camera.bottom);
                return width / height;
            }
        default:
            throw new Error(`${camera.type} is currently not supported in ProjectedMaterial`);
    }
}
// scale to keep the image proportions and apply textureScale
function $0c0e813ce4ad425f$var$computeScaledDimensions(texture, camera, textureScale, cover) {
    // return some default values if the image hasn't loaded yet
    if (!texture.image) return [
        1,
        1
    ];
    // return if it's a video and if the video hasn't loaded yet
    if (texture.image.videoWidth === 0 && texture.image.videoHeight === 0) return [
        1,
        1
    ];
    const sourceWidth = texture.image.naturalWidth || texture.image.videoWidth || texture.image.clientWidth;
    const sourceHeight = texture.image.naturalHeight || texture.image.videoHeight || texture.image.clientHeight;
    const ratio = sourceWidth / sourceHeight;
    const ratioCamera = $0c0e813ce4ad425f$var$getCameraRatio(camera);
    const widthCamera = 1;
    const heightCamera = widthCamera * (1 / ratioCamera);
    let widthScaled;
    let heightScaled;
    if (cover ? ratio > ratioCamera : ratio < ratioCamera) {
        const width = heightCamera * ratio;
        widthScaled = 1 / (width / widthCamera * textureScale);
        heightScaled = 1 / textureScale;
    } else {
        const height = widthCamera * (1 / ratio);
        heightScaled = 1 / (height / heightCamera * textureScale);
        widthScaled = 1 / textureScale;
    }
    return [
        widthScaled,
        heightScaled
    ];
}
function $0c0e813ce4ad425f$export$52e56b8874e03b20(geometry, instancesCount) {
    geometry.setAttribute(`savedModelMatrix0`, new $ilwiq.InstancedBufferAttribute(new Float32Array(instancesCount * 4), 4));
    geometry.setAttribute(`savedModelMatrix1`, new $ilwiq.InstancedBufferAttribute(new Float32Array(instancesCount * 4), 4));
    geometry.setAttribute(`savedModelMatrix2`, new $ilwiq.InstancedBufferAttribute(new Float32Array(instancesCount * 4), 4));
    geometry.setAttribute(`savedModelMatrix3`, new $ilwiq.InstancedBufferAttribute(new Float32Array(instancesCount * 4), 4));
}



var $ilwiq = parcelRequire("ilwiq");


var $ilwiq = parcelRequire("ilwiq");
// UltraHDR Image Format - https://developer.android.com/media/platform/hdr-image-format
// HDR/EXR to UltraHDR Converter - https://gainmap-creator.monogrid.com/
/**
 *
 * Short format brief:
 *
 *  [JPEG headers]
 *  [XMP metadata describing the MPF container and *both* SDR and gainmap images]
 *  [Optional metadata] [EXIF] [ICC Profile]
 *  [SDR image]
 *  [XMP metadata describing only the gainmap image]
 *  [Gainmap image]
 *
 * Each section is separated by a 0xFFXX byte followed by a descriptor byte (0xFFE0, 0xFFE1, 0xFFE2.)
 * Binary image storages are prefixed with a unique 0xFFD8 16-bit descriptor.
 */ /**
 * Current feature set:
 * - JPEG headers (required)
 * - XMP metadata (required)
 *  - XMP validation (not implemented)
 * - EXIF profile (not implemented)
 * - ICC profile (not implemented)
 * - Binary storage for SDR & HDR images (required)
 * - Gainmap metadata (required)
 * - Non-JPEG image formats (not implemented)
 * - Primary image as an HDR image (not implemented)
 */ /* Calculating this SRGB powers is extremely slow for 4K images and can be sufficiently precalculated for a 3-4x speed boost */ const $4b74f05b0ba4394f$var$SRGB_TO_LINEAR = Array(1024).fill(0).map((_, value)=>Math.pow(value / 255 * 0.9478672986 + 0.0521327014, 2.4));
class $4b74f05b0ba4394f$export$89704621c14a7582 extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
        this.type = (0, $ilwiq.HalfFloatType);
    }
    setDataType(value) {
        this.type = value;
        return this;
    }
    parse(buffer, onLoad) {
        const xmpMetadata = {
            version: null,
            baseRenditionIsHDR: null,
            gainMapMin: null,
            gainMapMax: null,
            gamma: null,
            offsetSDR: null,
            offsetHDR: null,
            hdrCapacityMin: null,
            hdrCapacityMax: null
        };
        const textDecoder = new TextDecoder();
        const data = new DataView(buffer);
        let byteOffset = 0;
        const sections = [];
        while(byteOffset < data.byteLength){
            const byte = data.getUint8(byteOffset);
            if (byte === 0xff) {
                const leadingByte = data.getUint8(byteOffset + 1);
                if ([
                    /* Valid section headers */ 0xd8,
                    0xe0,
                    0xe1,
                    0xe2
                ].includes(leadingByte)) {
                    sections.push({
                        sectionType: leadingByte,
                        section: [
                            byte,
                            leadingByte
                        ],
                        sectionOffset: byteOffset + 2
                    });
                    byteOffset += 2;
                } else {
                    sections[sections.length - 1].section.push(byte, leadingByte);
                    byteOffset += 2;
                }
            } else {
                sections[sections.length - 1].section.push(byte);
                byteOffset++;
            }
        }
        let primaryImage, gainmapImage;
        for(let i = 0; i < sections.length; i++){
            const { sectionType: sectionType, section: section, sectionOffset: sectionOffset } = sections[i];
            if (sectionType === 0xe0) ;
            else if (sectionType === 0xe1) /* XMP Metadata */ this._parseXMPMetadata(textDecoder.decode(new Uint8Array(section)), xmpMetadata);
            else if (sectionType === 0xe2) {
                /* Data Sections - MPF / EXIF / ICC Profile */ const sectionData = new DataView(new Uint8Array(section.slice(2)).buffer);
                const sectionHeader = sectionData.getUint32(2, false);
                if (sectionHeader === 0x4d504600) {
                    /* MPF Section */ /* Section contains a list of static bytes and ends with offsets indicating location of SDR and gainmap images */ /* First bytes after header indicate little / big endian ordering (0x49492A00 - LE / 0x4D4D002A - BE) */ /*
					... 60 bytes indicating tags, versions, etc. ...

					bytes | bits | description

					4       32     primary image size
					4       32     primary image offset
					2       16     0x0000
					2       16     0x0000

					4       32     0x00000000
					4       32     gainmap image size
					4       32     gainmap image offset
					2       16     0x0000
					2       16     0x0000
					*/ const mpfLittleEndian = sectionData.getUint32(6) === 0x49492a00;
                    const mpfBytesOffset = 60;
                    /* SDR size includes the metadata length, SDR offset is always 0 */ const primaryImageSize = sectionData.getUint32(mpfBytesOffset, mpfLittleEndian);
                    const primaryImageOffset = sectionData.getUint32(mpfBytesOffset + 4, mpfLittleEndian);
                    /* Gainmap size is an absolute value starting from its offset, gainmap offset needs 6 bytes padding to take into account 0x00 bytes at the end of XMP */ const gainmapImageSize = sectionData.getUint32(mpfBytesOffset + 16, mpfLittleEndian);
                    const gainmapImageOffset = sectionData.getUint32(mpfBytesOffset + 20, mpfLittleEndian) + sectionOffset + 6;
                    primaryImage = new Uint8Array(data.buffer, primaryImageOffset, primaryImageSize);
                    gainmapImage = new Uint8Array(data.buffer, gainmapImageOffset, gainmapImageSize);
                }
            }
        }
        /* Minimal sufficient validation - https://developer.android.com/media/platform/hdr-image-format#signal_of_the_format */ if (!xmpMetadata.version) throw new Error("THREE.UltraHDRLoader: Not a valid UltraHDR image");
        if (primaryImage && gainmapImage) this._applyGainmapToSDR(xmpMetadata, primaryImage, gainmapImage, (hdrBuffer, width, height)=>{
            onLoad({
                width: width,
                height: height,
                data: hdrBuffer,
                format: (0, $ilwiq.RGBAFormat),
                type: this.type
            });
        }, (error)=>{
            throw new Error(error);
        });
        else throw new Error("THREE.UltraHDRLoader: Could not parse UltraHDR images");
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new (0, $ilwiq.DataTexture)(this.type === (0, $ilwiq.HalfFloatType) ? new Uint16Array() : new Float32Array(), 0, 0, (0, $ilwiq.RGBAFormat), this.type, (0, $ilwiq.UVMapping), (0, $ilwiq.ClampToEdgeWrapping), (0, $ilwiq.ClampToEdgeWrapping), (0, $ilwiq.LinearFilter), (0, $ilwiq.LinearMipMapLinearFilter), 1, (0, $ilwiq.LinearSRGBColorSpace));
        texture.generateMipmaps = true;
        texture.flipY = true;
        const loader = new (0, $ilwiq.FileLoader)(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (buffer)=>{
            try {
                this.parse(buffer, (texData)=>{
                    texture.image = {
                        data: texData.data,
                        width: texData.width,
                        height: texData.height
                    };
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture, texData);
                });
            } catch (error) {
                if (onError) onError(error);
                console.error(error);
            }
        }, onProgress, onError);
        return texture;
    }
    _parseXMPMetadata(xmpDataString, xmpMetadata) {
        const domParser = new DOMParser();
        const xmpXml = domParser.parseFromString(xmpDataString.substring(xmpDataString.indexOf("<"), xmpDataString.lastIndexOf(">") + 1), "text/xml");
        /* Determine if given XMP metadata is the primary GContainer descriptor or a gainmap descriptor */ const [hasHDRContainerDescriptor] = xmpXml.getElementsByTagName("Container:Directory");
        if (hasHDRContainerDescriptor) ;
        else {
            /* Gainmap descriptor - defaults from https://developer.android.com/media/platform/hdr-image-format#HDR_gain_map_metadata */ const [gainmapNode] = xmpXml.getElementsByTagName("rdf:Description");
            xmpMetadata.version = gainmapNode.getAttribute("hdrgm:Version");
            xmpMetadata.baseRenditionIsHDR = gainmapNode.getAttribute("hdrgm:BaseRenditionIsHDR") === "True";
            xmpMetadata.gainMapMin = parseFloat(gainmapNode.getAttribute("hdrgm:GainMapMin") || 0.0);
            xmpMetadata.gainMapMax = parseFloat(gainmapNode.getAttribute("hdrgm:GainMapMax") || 1.0);
            xmpMetadata.gamma = parseFloat(gainmapNode.getAttribute("hdrgm:Gamma") || 1.0);
            xmpMetadata.offsetSDR = parseFloat(gainmapNode.getAttribute("hdrgm:OffsetSDR") / (1 / 64));
            xmpMetadata.offsetHDR = parseFloat(gainmapNode.getAttribute("hdrgm:OffsetHDR") / (1 / 64));
            xmpMetadata.hdrCapacityMin = parseFloat(gainmapNode.getAttribute("hdrgm:HDRCapacityMin") || 0.0);
            xmpMetadata.hdrCapacityMax = parseFloat(gainmapNode.getAttribute("hdrgm:HDRCapacityMax") || 1.0);
        }
    }
    _srgbToLinear(value) {
        if (value / 255 < 0.04045) return value / 255 * 0.0773993808;
        if (value < 1024) return $4b74f05b0ba4394f$var$SRGB_TO_LINEAR[~~value];
        return Math.pow(value / 255 * 0.9478672986 + 0.0521327014, 2.4);
    }
    _applyGainmapToSDR(xmpMetadata, sdrBuffer, gainmapBuffer, onSuccess, onError) {
        const getImageDataFromBuffer = (buffer)=>new Promise((resolve, reject)=>{
                const imageLoader = document.createElement("img");
                imageLoader.onload = ()=>{
                    const image = {
                        width: imageLoader.naturalWidth,
                        height: imageLoader.naturalHeight,
                        source: imageLoader
                    };
                    URL.revokeObjectURL(imageLoader.src);
                    resolve(image);
                };
                imageLoader.onerror = ()=>{
                    URL.revokeObjectURL(imageLoader.src);
                    reject();
                };
                imageLoader.src = URL.createObjectURL(new Blob([
                    buffer
                ], {
                    type: "image/jpeg"
                }));
            });
        Promise.all([
            getImageDataFromBuffer(sdrBuffer),
            getImageDataFromBuffer(gainmapBuffer)
        ]).then(([sdrImage, gainmapImage])=>{
            const sdrImageAspect = sdrImage.width / sdrImage.height;
            const gainmapImageAspect = gainmapImage.width / gainmapImage.height;
            if (sdrImageAspect !== gainmapImageAspect) {
                onError("THREE.UltraHDRLoader Error: Aspect ratio mismatch between SDR and Gainmap images");
                return;
            }
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d", {
                willReadFrequently: true,
                colorSpace: "srgb"
            });
            canvas.width = sdrImage.width;
            canvas.height = sdrImage.height;
            /* Use out-of-the-box interpolation of Canvas API to scale gainmap to fit the SDR resolution */ ctx.drawImage(gainmapImage.source, 0, 0, gainmapImage.width, gainmapImage.height, 0, 0, sdrImage.width, sdrImage.height);
            const gainmapImageData = ctx.getImageData(0, 0, sdrImage.width, sdrImage.height, {
                colorSpace: "srgb"
            });
            ctx.drawImage(sdrImage.source, 0, 0);
            const sdrImageData = ctx.getImageData(0, 0, sdrImage.width, sdrImage.height, {
                colorSpace: "srgb"
            });
            /* HDR Recovery formula - https://developer.android.com/media/platform/hdr-image-format#use_the_gain_map_to_create_adapted_HDR_rendition */ let hdrBuffer;
            if (this.type === (0, $ilwiq.HalfFloatType)) hdrBuffer = new Uint16Array(sdrImageData.data.length).fill(23544);
            else hdrBuffer = new Float32Array(sdrImageData.data.length).fill(255);
            const maxDisplayBoost = Math.sqrt(Math.pow(/* 1.8 instead of 2 near-perfectly rectifies approximations introduced by precalculated SRGB_TO_LINEAR values */ 1.8, xmpMetadata.hdrCapacityMax));
            const unclampedWeightFactor = (Math.log2(maxDisplayBoost) - xmpMetadata.hdrCapacityMin) / (xmpMetadata.hdrCapacityMax - xmpMetadata.hdrCapacityMin);
            const weightFactor = Math.min(Math.max(unclampedWeightFactor, 0.0), 1.0);
            const useGammaOne = xmpMetadata.gamma === 1.0;
            for(let pixelIndex = 0; pixelIndex < sdrImageData.data.length; pixelIndex += 4){
                const x = pixelIndex / 4 % sdrImage.width;
                const y = Math.floor(pixelIndex / 4 / sdrImage.width);
                for(let channelIndex = 0; channelIndex < 3; channelIndex++){
                    const sdrValue = sdrImageData.data[pixelIndex + channelIndex];
                    const gainmapIndex = (y * sdrImage.width + x) * 4 + channelIndex;
                    const gainmapValue = gainmapImageData.data[gainmapIndex] / 255.0;
                    /* Gamma is 1.0 by default */ const logRecovery = useGammaOne ? gainmapValue : Math.pow(gainmapValue, 1.0 / xmpMetadata.gamma);
                    const logBoost = xmpMetadata.gainMapMin * (1.0 - logRecovery) + xmpMetadata.gainMapMax * logRecovery;
                    const hdrValue = (sdrValue + xmpMetadata.offsetSDR) * (logBoost * weightFactor === 0.0 ? 1.0 : Math.pow(2, logBoost * weightFactor)) - xmpMetadata.offsetHDR;
                    const linearHDRValue = Math.min(Math.max(this._srgbToLinear(hdrValue), 0), 65504);
                    hdrBuffer[pixelIndex + channelIndex] = this.type === (0, $ilwiq.HalfFloatType) ? (0, $ilwiq.DataUtils).toHalfFloat(linearHDRValue) : linearHDRValue;
                }
            }
            onSuccess(hdrBuffer, sdrImage.width, sdrImage.height);
        }).catch(()=>{
            throw new Error("THREE.UltraHDRLoader Error: Could not parse UltraHDR images");
        });
    }
}


/**
 * postprocessing v6.36.3 build Thu Sep 26 2024
 * https://github.com/pmndrs/postprocessing
 * Copyright 2015-2024 Raoul van Rüschen
 * @license Zlib
 */ // package.json

var $ilwiq = parcelRequire("ilwiq");
var $fe721963ebf18f1b$export$83d89fbfd8236492 = "6.36.3";
// src/core/Disposable.js
var $fe721963ebf18f1b$export$252720412a173de = class {
    /**
   * Frees internal resources.
   */ dispose() {}
};
// src/core/Timer.js
var $fe721963ebf18f1b$var$MILLISECONDS_TO_SECONDS = 0.001;
var $fe721963ebf18f1b$var$SECONDS_TO_MILLISECONDS = 1e3;
var $fe721963ebf18f1b$export$c57e9b2d8b9e4de = class {
    /**
   * Constructs a new timer.
   */ constructor(){
        this.startTime = performance.now();
        this.previousTime = 0;
        this.currentTime = 0;
        this._delta = 0;
        this._elapsed = 0;
        this._fixedDelta = 1e3 / 60;
        this.timescale = 1;
        this.useFixedDelta = false;
        this._autoReset = false;
    }
    /**
   * Enables or disables auto reset based on page visibility.
   *
   * If enabled, the timer will be reset when the page becomes visible. This effectively pauses the timer when the page
   * is hidden. Has no effect if the API is not supported.
   *
   * @type {Boolean}
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
   */ get autoReset() {
        return this._autoReset;
    }
    set autoReset(value) {
        if (typeof document !== "undefined" && document.hidden !== void 0) {
            if (value) document.addEventListener("visibilitychange", this);
            else document.removeEventListener("visibilitychange", this);
            this._autoReset = value;
        }
    }
    get delta() {
        return this._delta * $fe721963ebf18f1b$var$MILLISECONDS_TO_SECONDS;
    }
    get fixedDelta() {
        return this._fixedDelta * $fe721963ebf18f1b$var$MILLISECONDS_TO_SECONDS;
    }
    set fixedDelta(value) {
        this._fixedDelta = value * $fe721963ebf18f1b$var$SECONDS_TO_MILLISECONDS;
    }
    get elapsed() {
        return this._elapsed * $fe721963ebf18f1b$var$MILLISECONDS_TO_SECONDS;
    }
    /**
   * Updates this timer.
   *
   * @param {Boolean} [timestamp] - The current time in milliseconds.
   */ update(timestamp) {
        if (this.useFixedDelta) this._delta = this.fixedDelta;
        else {
            this.previousTime = this.currentTime;
            this.currentTime = (timestamp !== void 0 ? timestamp : performance.now()) - this.startTime;
            this._delta = this.currentTime - this.previousTime;
        }
        this._delta *= this.timescale;
        this._elapsed += this._delta;
    }
    /**
   * Resets this timer.
   */ reset() {
        this._delta = 0;
        this._elapsed = 0;
        this.currentTime = performance.now() - this.startTime;
    }
    getDelta() {
        return this.delta;
    }
    getElapsed() {
        return this.elapsed;
    }
    handleEvent(e) {
        if (!document.hidden) this.currentTime = performance.now() - this.startTime;
    }
    dispose() {
        this.autoReset = false;
    }
};
var $fe721963ebf18f1b$var$fullscreenGeometry = /* @__PURE__ */ (()=>{
    const vertices = new Float32Array([
        -1,
        -1,
        0,
        3,
        -1,
        0,
        -1,
        3,
        0
    ]);
    const uvs = new Float32Array([
        0,
        0,
        2,
        0,
        0,
        2
    ]);
    const geometry = new (0, $ilwiq.BufferGeometry)();
    geometry.setAttribute("position", new (0, $ilwiq.BufferAttribute)(vertices, 3));
    geometry.setAttribute("uv", new (0, $ilwiq.BufferAttribute)(uvs, 2));
    return geometry;
})();
var $fe721963ebf18f1b$export$802bc10488da99c7 = class _Pass {
    /**
   * A shared fullscreen triangle.
   *
   * The screen size is 2x2 units (NDC). A triangle needs to be 4x4 units to fill the screen.
   * @see https://michaldrobot.com/2014/04/01/gcn-execution-patterns-in-full-screen-passes/
   * @type {BufferGeometry}
   * @internal
   */ static get fullscreenGeometry() {
        return $fe721963ebf18f1b$var$fullscreenGeometry;
    }
    /**
   * Constructs a new pass.
   *
   * @param {String} [name] - The name of this pass. Does not have to be unique.
   * @param {Scene} [scene] - The scene to render. The default scene contains a single mesh that fills the screen.
   * @param {Camera} [camera] - A camera. Fullscreen effect passes don't require a camera.
   */ constructor(name = "Pass", scene = new (0, $ilwiq.Scene)(), camera = new (0, $ilwiq.Camera)()){
        this.name = name;
        this.renderer = null;
        this.scene = scene;
        this.camera = camera;
        this.screen = null;
        this.rtt = true;
        this.needsSwap = true;
        this.needsDepthTexture = false;
        this.enabled = true;
    }
    /**
   * Sets the render to screen flag.
   *
   * If this flag is changed, the fullscreen material will be updated as well.
   *
   * @type {Boolean}
   */ get renderToScreen() {
        return !this.rtt;
    }
    set renderToScreen(value) {
        if (this.rtt === value) {
            const material = this.fullscreenMaterial;
            if (material !== null) material.needsUpdate = true;
            this.rtt = !value;
        }
    }
    /**
   * Sets the main scene.
   *
   * @type {Scene}
   */ set mainScene(value) {}
    /**
   * Sets the main camera.
   *
   * @type {Camera}
   */ set mainCamera(value) {}
    /**
   * Sets the renderer
   *
   * @deprecated
   * @param {WebGLRenderer} renderer - The renderer.
   */ setRenderer(renderer) {
        this.renderer = renderer;
    }
    /**
   * Indicates whether this pass is enabled.
   *
   * @deprecated Use enabled instead.
   * @return {Boolean} Whether this pass is enabled.
   */ isEnabled() {
        return this.enabled;
    }
    /**
   * Enables or disables this pass.
   *
   * @deprecated Use enabled instead.
   * @param {Boolean} value - Whether the pass should be enabled.
   */ setEnabled(value) {
        this.enabled = value;
    }
    /**
   * The fullscreen material.
   *
   * @type {Material}
   */ get fullscreenMaterial() {
        return this.screen !== null ? this.screen.material : null;
    }
    set fullscreenMaterial(value) {
        let screen = this.screen;
        if (screen !== null) screen.material = value;
        else {
            screen = new (0, $ilwiq.Mesh)(_Pass.fullscreenGeometry, value);
            screen.frustumCulled = false;
            if (this.scene === null) this.scene = new (0, $ilwiq.Scene)();
            this.scene.add(screen);
            this.screen = screen;
        }
    }
    /**
   * Returns the current fullscreen material.
   *
   * @deprecated Use fullscreenMaterial instead.
   * @return {Material} The current fullscreen material, or null if there is none.
   */ getFullscreenMaterial() {
        return this.fullscreenMaterial;
    }
    /**
   * Sets the fullscreen material.
   *
   * @deprecated Use fullscreenMaterial instead.
   * @protected
   * @param {Material} value - A fullscreen material.
   */ setFullscreenMaterial(value) {
        this.fullscreenMaterial = value;
    }
    /**
   * Returns the current depth texture.
   *
   * @return {Texture} The current depth texture, or null if there is none.
   */ getDepthTexture() {
        return null;
    }
    /**
   * Sets the depth texture.
   *
   * This method will be called automatically by the {@link EffectComposer}.
   * You may override this method if your pass relies on the depth information of a preceding {@link RenderPass}.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategy} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {}
    /**
   * Renders this pass.
   *
   * This is an abstract method that must be overridden.
   *
   * @abstract
   * @throws {Error} An error is thrown if the method is not overridden.
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        throw new Error("Render method not implemented!");
    }
    /**
   * Sets the size.
   *
   * You may override this method if you want to be informed about the size of the backbuffer/canvas.
   * This method is called before {@link initialize} and every time the size of the {@link EffectComposer} changes.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {}
    /**
   * Performs initialization tasks.
   *
   * This method is called when this pass is added to an {@link EffectComposer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {}
    /**
   * Performs a shallow search for disposable properties and deletes them.
   *
   * The {@link EffectComposer} calls this method when it is being destroyed. You can use it independently to free
   * memory when you're certain that you don't need this pass anymore.
   */ dispose() {
        for (const key of Object.keys(this)){
            const property = this[key];
            const isDisposable = property instanceof (0, $ilwiq.WebGLRenderTarget) || property instanceof (0, $ilwiq.Material) || property instanceof (0, $ilwiq.Texture) || property instanceof _Pass;
            if (isDisposable) this[key].dispose();
        }
        if (this.fullscreenMaterial !== null) this.fullscreenMaterial.dispose();
    }
};
// src/passes/ClearMaskPass.js
var $fe721963ebf18f1b$export$8d8650aed29c6251 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new clear mask pass.
   */ constructor(){
        super("ClearMaskPass", null, null);
        this.needsSwap = false;
    }
    /**
   * Disables the global stencil test.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const stencil = renderer.state.buffers.stencil;
        stencil.setLocked(false);
        stencil.setTest(false);
    }
};
// src/materials/glsl/copy.frag
var $fe721963ebf18f1b$var$copy_default = "#include <common>\n#include <dithering_pars_fragment>\n#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\nuniform float opacity;varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);gl_FragColor=opacity*texel;\n#include <colorspace_fragment>\n#include <dithering_fragment>\n}";
// src/materials/glsl/common.vert
var $fe721963ebf18f1b$var$common_default = "varying vec2 vUv;void main(){vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/CopyMaterial.js
var $fe721963ebf18f1b$export$d4b5f24bda67f7e4 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new copy material.
   */ constructor(){
        super({
            name: "CopyMaterial",
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                opacity: new (0, $ilwiq.Uniform)(1)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$copy_default,
            vertexShader: $fe721963ebf18f1b$var$common_default
        });
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Number} value - The buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Returns the opacity.
   *
   * @deprecated Use opacity instead.
   * @return {Number} The opacity.
   */ getOpacity(value) {
        return this.uniforms.opacity.value;
    }
    /**
   * Sets the opacity.
   *
   * @deprecated Use opacity instead.
   * @param {Number} value - The opacity.
   */ setOpacity(value) {
        this.uniforms.opacity.value = value;
    }
};
// src/passes/CopyPass.js
var $fe721963ebf18f1b$export$ec9e16bd0f76e979 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new save pass.
   *
   * @param {WebGLRenderTarget} [renderTarget] - A render target.
   * @param {Boolean} [autoResize=true] - Whether the render target size should be updated automatically.
   */ constructor(renderTarget, autoResize = true){
        super("CopyPass");
        this.fullscreenMaterial = new $fe721963ebf18f1b$export$d4b5f24bda67f7e4();
        this.needsSwap = false;
        this.renderTarget = renderTarget;
        if (renderTarget === void 0) {
            this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
                minFilter: (0, $ilwiq.LinearFilter),
                magFilter: (0, $ilwiq.LinearFilter),
                stencilBuffer: false,
                depthBuffer: false
            });
            this.renderTarget.texture.name = "CopyPass.Target";
        }
        this.autoResize = autoResize;
    }
    /**
   * Enables or disables auto resizing of the render target.
   *
   * @deprecated Use autoResize instead.
   * @type {Boolean}
   */ get resize() {
        return this.autoResize;
    }
    set resize(value) {
        this.autoResize = value;
    }
    /**
   * The output texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the output texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * Enables or disables auto resizing of the render target.
   *
   * @deprecated Use autoResize instead.
   * @param {Boolean} value - Whether the render target size should be updated automatically.
   */ setAutoResizeEnabled(value) {
        this.autoResize = value;
    }
    /**
   * Saves the input buffer.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        this.fullscreenMaterial.inputBuffer = inputBuffer.texture;
        renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
        renderer.render(this.scene, this.camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        if (this.autoResize) this.renderTarget.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - A renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0) {
            this.renderTarget.texture.type = frameBufferType;
            if (frameBufferType !== (0, $ilwiq.UnsignedByteType)) this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
            else if (renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) this.renderTarget.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
        }
    }
};
var $fe721963ebf18f1b$var$color = /* @__PURE__ */ new (0, $ilwiq.Color)();
var $fe721963ebf18f1b$export$fc4180e277a6a0c2 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new clear pass.
   *
   * @param {Boolean} [color=true] - Determines whether the color buffer should be cleared.
   * @param {Boolean} [depth=true] - Determines whether the depth buffer should be cleared.
   * @param {Boolean} [stencil=false] - Determines whether the stencil buffer should be cleared.
   */ constructor(color2 = true, depth = true, stencil = false){
        super("ClearPass", null, null);
        this.needsSwap = false;
        this.color = color2;
        this.depth = depth;
        this.stencil = stencil;
        this.overrideClearColor = null;
        this.overrideClearAlpha = -1;
    }
    /**
   * Sets the clear flags.
   *
   * @param {Boolean} color - Whether the color buffer should be cleared.
   * @param {Boolean} depth - Whether the depth buffer should be cleared.
   * @param {Boolean} stencil - Whether the stencil buffer should be cleared.
   */ setClearFlags(color2, depth, stencil) {
        this.color = color2;
        this.depth = depth;
        this.stencil = stencil;
    }
    /**
   * Returns the override clear color. Default is null.
   *
   * @deprecated Use overrideClearColor instead.
   * @return {Color} The clear color.
   */ getOverrideClearColor() {
        return this.overrideClearColor;
    }
    /**
   * Sets the override clear color.
   *
   * @deprecated Use overrideClearColor instead.
   * @param {Color} value - The clear color.
   */ setOverrideClearColor(value) {
        this.overrideClearColor = value;
    }
    /**
   * Returns the override clear alpha. Default is -1.
   *
   * @deprecated Use overrideClearAlpha instead.
   * @return {Number} The clear alpha.
   */ getOverrideClearAlpha() {
        return this.overrideClearAlpha;
    }
    /**
   * Sets the override clear alpha.
   *
   * @deprecated Use overrideClearAlpha instead.
   * @param {Number} value - The clear alpha.
   */ setOverrideClearAlpha(value) {
        this.overrideClearAlpha = value;
    }
    /**
   * Clears the input buffer or the screen.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const overrideClearColor = this.overrideClearColor;
        const overrideClearAlpha = this.overrideClearAlpha;
        const clearAlpha = renderer.getClearAlpha();
        const hasOverrideClearColor = overrideClearColor !== null;
        const hasOverrideClearAlpha = overrideClearAlpha >= 0;
        if (hasOverrideClearColor) {
            renderer.getClearColor($fe721963ebf18f1b$var$color);
            renderer.setClearColor(overrideClearColor, hasOverrideClearAlpha ? overrideClearAlpha : clearAlpha);
        } else if (hasOverrideClearAlpha) renderer.setClearAlpha(overrideClearAlpha);
        renderer.setRenderTarget(this.renderToScreen ? null : inputBuffer);
        renderer.clear(this.color, this.depth, this.stencil);
        if (hasOverrideClearColor) renderer.setClearColor($fe721963ebf18f1b$var$color, clearAlpha);
        else if (hasOverrideClearAlpha) renderer.setClearAlpha(clearAlpha);
    }
};
// src/passes/MaskPass.js
var $fe721963ebf18f1b$export$bb424a4005d6dde0 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new mask pass.
   *
   * @param {Scene} scene - The scene to render.
   * @param {Camera} camera - The camera to use.
   */ constructor(scene, camera){
        super("MaskPass", scene, camera);
        this.needsSwap = false;
        this.clearPass = new $fe721963ebf18f1b$export$fc4180e277a6a0c2(false, false, true);
        this.inverse = false;
    }
    set mainScene(value) {
        this.scene = value;
    }
    set mainCamera(value) {
        this.camera = value;
    }
    /**
   * Indicates whether the mask should be inverted.
   *
   * @type {Boolean}
   */ get inverted() {
        return this.inverse;
    }
    set inverted(value) {
        this.inverse = value;
    }
    /**
   * Indicates whether this pass should clear the stencil buffer.
   *
   * @type {Boolean}
   * @deprecated Use clearPass.enabled instead.
   */ get clear() {
        return this.clearPass.enabled;
    }
    set clear(value) {
        this.clearPass.enabled = value;
    }
    /**
   * Returns the internal clear pass.
   *
   * @deprecated Use clearPass.enabled instead.
   * @return {ClearPass} The clear pass.
   */ getClearPass() {
        return this.clearPass;
    }
    /**
   * Indicates whether the mask is inverted.
   *
   * @deprecated Use inverted instead.
   * @return {Boolean} Whether the mask is inverted.
   */ isInverted() {
        return this.inverted;
    }
    /**
   * Enables or disable mask inversion.
   *
   * @deprecated Use inverted instead.
   * @param {Boolean} value - Whether the mask should be inverted.
   */ setInverted(value) {
        this.inverted = value;
    }
    /**
   * Renders the effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const context = renderer.getContext();
        const buffers = renderer.state.buffers;
        const scene = this.scene;
        const camera = this.camera;
        const clearPass = this.clearPass;
        const writeValue = this.inverted ? 0 : 1;
        const clearValue = 1 - writeValue;
        buffers.color.setMask(false);
        buffers.depth.setMask(false);
        buffers.color.setLocked(true);
        buffers.depth.setLocked(true);
        buffers.stencil.setTest(true);
        buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
        buffers.stencil.setFunc(context.ALWAYS, writeValue, 4294967295);
        buffers.stencil.setClear(clearValue);
        buffers.stencil.setLocked(true);
        if (this.clearPass.enabled) {
            if (this.renderToScreen) clearPass.render(renderer, null);
            else {
                clearPass.render(renderer, inputBuffer);
                clearPass.render(renderer, outputBuffer);
            }
        }
        if (this.renderToScreen) {
            renderer.setRenderTarget(null);
            renderer.render(scene, camera);
        } else {
            renderer.setRenderTarget(inputBuffer);
            renderer.render(scene, camera);
            renderer.setRenderTarget(outputBuffer);
            renderer.render(scene, camera);
        }
        buffers.color.setLocked(false);
        buffers.depth.setLocked(false);
        buffers.stencil.setLocked(false);
        buffers.stencil.setFunc(context.EQUAL, 1, 4294967295);
        buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
        buffers.stencil.setLocked(true);
    }
};
// src/core/EffectComposer.js
var $fe721963ebf18f1b$export$7fe01e6ab8aa748c = class {
    /**
   * Constructs a new effect composer.
   *
   * @param {WebGLRenderer} renderer - The renderer that should be used.
   * @param {Object} [options] - The options.
   * @param {Boolean} [options.depthBuffer=true] - Whether the main render targets should have a depth buffer.
   * @param {Boolean} [options.stencilBuffer=false] - Whether the main render targets should have a stencil buffer.
   * @param {Boolean} [options.alpha] - Deprecated. Buffers are always RGBA since three r137.
   * @param {Number} [options.multisampling=0] - The number of samples used for multisample antialiasing. Requires WebGL 2.
   * @param {Number} [options.frameBufferType] - The type of the internal frame buffers. It's recommended to use HalfFloatType if possible.
   */ constructor(renderer = null, { depthBuffer: depthBuffer = true, stencilBuffer: stencilBuffer = false, multisampling: multisampling = 0, frameBufferType: frameBufferType } = {}){
        this.renderer = null;
        this.inputBuffer = this.createBuffer(depthBuffer, stencilBuffer, frameBufferType, multisampling);
        this.outputBuffer = this.inputBuffer.clone();
        this.copyPass = new $fe721963ebf18f1b$export$ec9e16bd0f76e979();
        this.depthTexture = null;
        this.passes = [];
        this.timer = new $fe721963ebf18f1b$export$c57e9b2d8b9e4de();
        this.autoRenderToScreen = true;
        this.setRenderer(renderer);
    }
    /**
   * The current amount of samples used for multisample anti-aliasing.
   *
   * @type {Number}
   */ get multisampling() {
        return this.inputBuffer.samples || 0;
    }
    /**
   * Sets the amount of MSAA samples.
   *
   * Requires WebGL 2. Set to zero to disable multisampling.
   *
   * @type {Number}
   */ set multisampling(value) {
        const buffer = this.inputBuffer;
        const multisampling = this.multisampling;
        if (multisampling > 0 && value > 0) {
            this.inputBuffer.samples = value;
            this.outputBuffer.samples = value;
            this.inputBuffer.dispose();
            this.outputBuffer.dispose();
        } else if (multisampling !== value) {
            this.inputBuffer.dispose();
            this.outputBuffer.dispose();
            this.inputBuffer = this.createBuffer(buffer.depthBuffer, buffer.stencilBuffer, buffer.texture.type, value);
            this.inputBuffer.depthTexture = this.depthTexture;
            this.outputBuffer = this.inputBuffer.clone();
        }
    }
    /**
   * Returns the internal timer.
   *
   * @return {Timer} The timer.
   */ getTimer() {
        return this.timer;
    }
    /**
   * Returns the renderer.
   *
   * @return {WebGLRenderer} The renderer.
   */ getRenderer() {
        return this.renderer;
    }
    /**
   * Sets the renderer.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   */ setRenderer(renderer) {
        this.renderer = renderer;
        if (renderer !== null) {
            const size = renderer.getSize(new (0, $ilwiq.Vector2)());
            const alpha = renderer.getContext().getContextAttributes().alpha;
            const frameBufferType = this.inputBuffer.texture.type;
            if (frameBufferType === (0, $ilwiq.UnsignedByteType) && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) {
                this.inputBuffer.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
                this.outputBuffer.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
                this.inputBuffer.dispose();
                this.outputBuffer.dispose();
            }
            renderer.autoClear = false;
            this.setSize(size.width, size.height);
            for (const pass of this.passes)pass.initialize(renderer, alpha, frameBufferType);
        }
    }
    /**
   * Replaces the current renderer with the given one.
   *
   * The auto clear mechanism of the provided renderer will be disabled. If the new render size differs from the
   * previous one, all passes will be updated.
   *
   * By default, the DOM element of the current renderer will automatically be removed from its parent node and the DOM
   * element of the new renderer will take its place.
   *
   * @deprecated Use setRenderer instead.
   * @param {WebGLRenderer} renderer - The new renderer.
   * @param {Boolean} updateDOM - Indicates whether the old canvas should be replaced by the new one in the DOM.
   * @return {WebGLRenderer} The old renderer.
   */ replaceRenderer(renderer, updateDOM = true) {
        const oldRenderer = this.renderer;
        const parent = oldRenderer.domElement.parentNode;
        this.setRenderer(renderer);
        if (updateDOM && parent !== null) {
            parent.removeChild(oldRenderer.domElement);
            parent.appendChild(renderer.domElement);
        }
        return oldRenderer;
    }
    /**
   * Creates a depth texture attachment that will be provided to all passes.
   *
   * Note: When a shader reads from a depth texture and writes to a render target that uses the same depth texture
   * attachment, the depth information will be lost. This happens even if `depthWrite` is disabled.
   *
   * @private
   * @return {DepthTexture} The depth texture.
   */ createDepthTexture() {
        const depthTexture = this.depthTexture = new (0, $ilwiq.DepthTexture)();
        this.inputBuffer.depthTexture = depthTexture;
        this.inputBuffer.dispose();
        if (this.inputBuffer.stencilBuffer) {
            depthTexture.format = (0, $ilwiq.DepthStencilFormat);
            depthTexture.type = (0, $ilwiq.UnsignedInt248Type);
        } else depthTexture.type = (0, $ilwiq.UnsignedIntType);
        return depthTexture;
    }
    /**
   * Deletes the current depth texture.
   *
   * @private
   */ deleteDepthTexture() {
        if (this.depthTexture !== null) {
            this.depthTexture.dispose();
            this.depthTexture = null;
            this.inputBuffer.depthTexture = null;
            this.inputBuffer.dispose();
            for (const pass of this.passes)pass.setDepthTexture(null);
        }
    }
    /**
   * Creates a new render target.
   *
   * @deprecated Create buffers manually via WebGLRenderTarget instead.
   * @param {Boolean} depthBuffer - Whether the render target should have a depth buffer.
   * @param {Boolean} stencilBuffer - Whether the render target should have a stencil buffer.
   * @param {Number} type - The frame buffer type.
   * @param {Number} multisampling - The number of samples to use for antialiasing.
   * @return {WebGLRenderTarget} A new render target that equals the renderer's canvas.
   */ createBuffer(depthBuffer, stencilBuffer, type, multisampling) {
        const renderer = this.renderer;
        const size = renderer === null ? new (0, $ilwiq.Vector2)() : renderer.getDrawingBufferSize(new (0, $ilwiq.Vector2)());
        const options = {
            minFilter: (0, $ilwiq.LinearFilter),
            magFilter: (0, $ilwiq.LinearFilter),
            stencilBuffer: stencilBuffer,
            depthBuffer: depthBuffer,
            type: type
        };
        const renderTarget = new (0, $ilwiq.WebGLRenderTarget)(size.width, size.height, options);
        if (multisampling > 0) {
            renderTarget.ignoreDepthForMultisampleCopy = false;
            renderTarget.samples = multisampling;
        }
        if (type === (0, $ilwiq.UnsignedByteType) && renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) renderTarget.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
        renderTarget.texture.name = "EffectComposer.Buffer";
        renderTarget.texture.generateMipmaps = false;
        return renderTarget;
    }
    /**
   * Can be used to change the main scene for all registered passes and effects.
   *
   * @param {Scene} scene - The scene.
   */ setMainScene(scene) {
        for (const pass of this.passes)pass.mainScene = scene;
    }
    /**
   * Can be used to change the main camera for all registered passes and effects.
   *
   * @param {Camera} camera - The camera.
   */ setMainCamera(camera) {
        for (const pass of this.passes)pass.mainCamera = camera;
    }
    /**
   * Adds a pass, optionally at a specific index.
   *
   * @param {Pass} pass - A new pass.
   * @param {Number} [index] - An index at which the pass should be inserted.
   */ addPass(pass, index) {
        const passes = this.passes;
        const renderer = this.renderer;
        const drawingBufferSize = renderer.getDrawingBufferSize(new (0, $ilwiq.Vector2)());
        const alpha = renderer.getContext().getContextAttributes().alpha;
        const frameBufferType = this.inputBuffer.texture.type;
        pass.setRenderer(renderer);
        pass.setSize(drawingBufferSize.width, drawingBufferSize.height);
        pass.initialize(renderer, alpha, frameBufferType);
        if (this.autoRenderToScreen) {
            if (passes.length > 0) passes[passes.length - 1].renderToScreen = false;
            if (pass.renderToScreen) this.autoRenderToScreen = false;
        }
        if (index !== void 0) passes.splice(index, 0, pass);
        else passes.push(pass);
        if (this.autoRenderToScreen) passes[passes.length - 1].renderToScreen = true;
        if (pass.needsDepthTexture || this.depthTexture !== null) {
            if (this.depthTexture === null) {
                const depthTexture = this.createDepthTexture();
                for (pass of passes)pass.setDepthTexture(depthTexture);
            } else pass.setDepthTexture(this.depthTexture);
        }
    }
    /**
   * Removes a pass.
   *
   * @param {Pass} pass - The pass.
   */ removePass(pass) {
        const passes = this.passes;
        const index = passes.indexOf(pass);
        const exists = index !== -1;
        const removed = exists && passes.splice(index, 1).length > 0;
        if (removed) {
            if (this.depthTexture !== null) {
                const reducer = (a, b)=>a || b.needsDepthTexture;
                const depthTextureRequired = passes.reduce(reducer, false);
                if (!depthTextureRequired) {
                    if (pass.getDepthTexture() === this.depthTexture) pass.setDepthTexture(null);
                    this.deleteDepthTexture();
                }
            }
            if (this.autoRenderToScreen) {
                if (index === passes.length) {
                    pass.renderToScreen = false;
                    if (passes.length > 0) passes[passes.length - 1].renderToScreen = true;
                }
            }
        }
    }
    /**
   * Removes all passes.
   */ removeAllPasses() {
        const passes = this.passes;
        this.deleteDepthTexture();
        if (passes.length > 0) {
            if (this.autoRenderToScreen) passes[passes.length - 1].renderToScreen = false;
            this.passes = [];
        }
    }
    /**
   * Renders all enabled passes in the order in which they were added.
   *
   * @param {Number} [deltaTime] - The time since the last frame in seconds.
   */ render(deltaTime) {
        const renderer = this.renderer;
        const copyPass = this.copyPass;
        let inputBuffer = this.inputBuffer;
        let outputBuffer = this.outputBuffer;
        let stencilTest = false;
        let context, stencil, buffer;
        if (deltaTime === void 0) {
            this.timer.update();
            deltaTime = this.timer.getDelta();
        }
        for (const pass of this.passes)if (pass.enabled) {
            pass.render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest);
            if (pass.needsSwap) {
                if (stencilTest) {
                    copyPass.renderToScreen = pass.renderToScreen;
                    context = renderer.getContext();
                    stencil = renderer.state.buffers.stencil;
                    stencil.setFunc(context.NOTEQUAL, 1, 4294967295);
                    copyPass.render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest);
                    stencil.setFunc(context.EQUAL, 1, 4294967295);
                }
                buffer = inputBuffer;
                inputBuffer = outputBuffer;
                outputBuffer = buffer;
            }
            if (pass instanceof $fe721963ebf18f1b$export$bb424a4005d6dde0) stencilTest = true;
            else if (pass instanceof $fe721963ebf18f1b$export$8d8650aed29c6251) stencilTest = false;
        }
    }
    /**
   * Sets the size of the buffers, passes and the renderer.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   * @param {Boolean} [updateStyle] - Determines whether the style of the canvas should be updated.
   */ setSize(width, height, updateStyle) {
        const renderer = this.renderer;
        const currentSize = renderer.getSize(new (0, $ilwiq.Vector2)());
        if (width === void 0 || height === void 0) {
            width = currentSize.width;
            height = currentSize.height;
        }
        if (currentSize.width !== width || currentSize.height !== height) renderer.setSize(width, height, updateStyle);
        const drawingBufferSize = renderer.getDrawingBufferSize(new (0, $ilwiq.Vector2)());
        this.inputBuffer.setSize(drawingBufferSize.width, drawingBufferSize.height);
        this.outputBuffer.setSize(drawingBufferSize.width, drawingBufferSize.height);
        for (const pass of this.passes)pass.setSize(drawingBufferSize.width, drawingBufferSize.height);
    }
    /**
   * Resets this composer by deleting all passes and creating new buffers.
   */ reset() {
        this.dispose();
        this.autoRenderToScreen = true;
    }
    /**
   * Disposes this composer and all passes.
   */ dispose() {
        for (const pass of this.passes)pass.dispose();
        this.passes = [];
        if (this.inputBuffer !== null) this.inputBuffer.dispose();
        if (this.outputBuffer !== null) this.outputBuffer.dispose();
        this.deleteDepthTexture();
        this.copyPass.dispose();
        this.timer.dispose();
        $fe721963ebf18f1b$export$802bc10488da99c7.fullscreenGeometry.dispose();
    }
};
// src/enums/EffectAttribute.js
var $fe721963ebf18f1b$export$a72ebb312f9e05c6 = {
    NONE: 0,
    DEPTH: 1,
    CONVOLUTION: 2
};
// src/enums/EffectShaderSection.js
var $fe721963ebf18f1b$export$a147810b69c6903e = {
    FRAGMENT_HEAD: "FRAGMENT_HEAD",
    FRAGMENT_MAIN_UV: "FRAGMENT_MAIN_UV",
    FRAGMENT_MAIN_IMAGE: "FRAGMENT_MAIN_IMAGE",
    VERTEX_HEAD: "VERTEX_HEAD",
    VERTEX_MAIN_SUPPORT: "VERTEX_MAIN_SUPPORT"
};
// src/core/EffectShaderData.js
var $fe721963ebf18f1b$export$810aed40073d4f73 = class {
    /**
   * Constructs new shader data.
   */ constructor(){
        this.shaderParts = /* @__PURE__ */ new Map([
            [
                $fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_HEAD,
                null
            ],
            [
                $fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_UV,
                null
            ],
            [
                $fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE,
                null
            ],
            [
                $fe721963ebf18f1b$export$a147810b69c6903e.VERTEX_HEAD,
                null
            ],
            [
                $fe721963ebf18f1b$export$a147810b69c6903e.VERTEX_MAIN_SUPPORT,
                null
            ]
        ]);
        this.defines = /* @__PURE__ */ new Map();
        this.uniforms = /* @__PURE__ */ new Map();
        this.blendModes = /* @__PURE__ */ new Map();
        this.extensions = /* @__PURE__ */ new Set();
        this.attributes = $fe721963ebf18f1b$export$a72ebb312f9e05c6.NONE;
        this.varyings = /* @__PURE__ */ new Set();
        this.uvTransformation = false;
        this.readDepth = false;
        this.colorSpace = (0, $ilwiq.LinearSRGBColorSpace);
    }
};
// src/core/GaussKernel.js
function $fe721963ebf18f1b$var$getCoefficients(n) {
    let result;
    if (n === 0) result = new Float64Array(0);
    else if (n === 1) result = new Float64Array([
        1
    ]);
    else if (n > 1) {
        let row0 = new Float64Array(n);
        let row1 = new Float64Array(n);
        for(let y = 1; y <= n; ++y){
            for(let x = 0; x < y; ++x)row1[x] = x === 0 || x === y - 1 ? 1 : row0[x - 1] + row0[x];
            result = row1;
            row1 = row0;
            row0 = result;
        }
    }
    return result;
}
var $fe721963ebf18f1b$export$66c54bc65bf8869c = class {
    /**
   * Constructs a new Gauss kernel.
   *
   * @param {Number} kernelSize - The kernel size. Should be an odd number in the range [3, 1020].
   * @param {Number} [edgeBias=2] - Determines how many edge coefficients should be cut off for increased accuracy.
   */ constructor(kernelSize, edgeBias = 2){
        this.weights = null;
        this.offsets = null;
        this.linearWeights = null;
        this.linearOffsets = null;
        this.generate(kernelSize, edgeBias);
    }
    /**
   * The number of steps for discrete sampling.
   *
   * @type {Number}
   */ get steps() {
        return this.offsets === null ? 0 : this.offsets.length;
    }
    /**
   * The number of steps for linear sampling.
   *
   * @type {Number}
   */ get linearSteps() {
        return this.linearOffsets === null ? 0 : this.linearOffsets.length;
    }
    /**
   * Generates the kernel.
   *
   * @private
   * @param {Number} kernelSize - The kernel size.
   * @param {Number} edgeBias - The amount of edge coefficients to ignore.
   */ generate(kernelSize, edgeBias) {
        if (kernelSize < 3 || kernelSize > 1020) throw new Error("The kernel size must be in the range [3, 1020]");
        const n = kernelSize + edgeBias * 2;
        const coefficients = edgeBias > 0 ? $fe721963ebf18f1b$var$getCoefficients(n).slice(edgeBias, -edgeBias) : $fe721963ebf18f1b$var$getCoefficients(n);
        const mid = Math.floor((coefficients.length - 1) / 2);
        const sum = coefficients.reduce((a, b)=>a + b, 0);
        const weights = coefficients.slice(mid);
        const offsets = [
            ...Array(mid + 1).keys()
        ];
        const linearWeights = new Float64Array(Math.floor(offsets.length / 2));
        const linearOffsets = new Float64Array(linearWeights.length);
        linearWeights[0] = weights[0] / sum;
        for(let i = 1, j = 1, l = offsets.length - 1; i < l; i += 2, ++j){
            const offset0 = offsets[i], offset1 = offsets[i + 1];
            const weight0 = weights[i], weight1 = weights[i + 1];
            const w = weight0 + weight1;
            const o = (offset0 * weight0 + offset1 * weight1) / w;
            linearWeights[j] = w / sum;
            linearOffsets[j] = o;
        }
        for(let i = 0, l = weights.length, s = 1 / sum; i < l; ++i)weights[i] *= s;
        const linearWeightSum = (linearWeights.reduce((a, b)=>a + b, 0) - linearWeights[0] * 0.5) * 2;
        if (linearWeightSum !== 0) for(let i = 0, l = linearWeights.length, s = 1 / linearWeightSum; i < l; ++i)linearWeights[i] *= s;
        this.offsets = offsets;
        this.weights = weights;
        this.linearOffsets = linearOffsets;
        this.linearWeights = linearWeights;
    }
};
// src/core/ImmutableTimer.js
var $fe721963ebf18f1b$export$330f1e2d95fbcda4 = class {
    /**
   * The current delta time in seconds.
   *
   * @type {Number}
   */ getDelta() {
        return NaN;
    }
    /**
   * The elapsed time in seconds.
   *
   * @type {Number}
   */ getElapsed() {
        return NaN;
    }
};
// src/core/Initializable.js
var $fe721963ebf18f1b$export$45a3d12ae694afd = class {
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - A renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {}
};
var $fe721963ebf18f1b$var$workaroundEnabled = false;
var $fe721963ebf18f1b$export$6ef25c308da0147b = class {
    /**
   * Constructs a new override material manager.
   *
   * @param {Material} [material=null] - An override material.
   */ constructor(material = null){
        this.originalMaterials = /* @__PURE__ */ new Map();
        this.material = null;
        this.materials = null;
        this.materialsBackSide = null;
        this.materialsDoubleSide = null;
        this.materialsFlatShaded = null;
        this.materialsFlatShadedBackSide = null;
        this.materialsFlatShadedDoubleSide = null;
        this.setMaterial(material);
        this.meshCount = 0;
        this.replaceMaterial = (node)=>{
            if (node.isMesh) {
                let materials;
                if (node.material.flatShading) switch(node.material.side){
                    case 0, $ilwiq.DoubleSide:
                        materials = this.materialsFlatShadedDoubleSide;
                        break;
                    case 0, $ilwiq.BackSide:
                        materials = this.materialsFlatShadedBackSide;
                        break;
                    default:
                        materials = this.materialsFlatShaded;
                        break;
                }
                else switch(node.material.side){
                    case 0, $ilwiq.DoubleSide:
                        materials = this.materialsDoubleSide;
                        break;
                    case 0, $ilwiq.BackSide:
                        materials = this.materialsBackSide;
                        break;
                    default:
                        materials = this.materials;
                        break;
                }
                this.originalMaterials.set(node, node.material);
                if (node.isSkinnedMesh) node.material = materials[2];
                else if (node.isInstancedMesh) node.material = materials[1];
                else node.material = materials[0];
                ++this.meshCount;
            }
        };
    }
    /**
   * Clones the given material.
   *
   * @private
   * @param {Material} material - The material.
   * @return {Material} The cloned material.
   */ cloneMaterial(material) {
        if (!(material instanceof (0, $ilwiq.ShaderMaterial))) return material.clone();
        const uniforms = material.uniforms;
        const textureUniforms = /* @__PURE__ */ new Map();
        for(const key in uniforms){
            const value = uniforms[key].value;
            if (value.isRenderTargetTexture) {
                uniforms[key].value = null;
                textureUniforms.set(key, value);
            }
        }
        const clone = material.clone();
        for (const entry of textureUniforms){
            uniforms[entry[0]].value = entry[1];
            clone.uniforms[entry[0]].value = entry[1];
        }
        return clone;
    }
    /**
   * Sets the override material.
   *
   * @param {Material} material - The material.
   */ setMaterial(material) {
        this.disposeMaterials();
        this.material = material;
        if (material !== null) {
            const materials = this.materials = [
                this.cloneMaterial(material),
                this.cloneMaterial(material),
                this.cloneMaterial(material)
            ];
            for (const m2 of materials){
                m2.uniforms = Object.assign({}, material.uniforms);
                m2.side = (0, $ilwiq.FrontSide);
            }
            materials[2].skinning = true;
            this.materialsBackSide = materials.map((m2)=>{
                const c2 = this.cloneMaterial(m2);
                c2.uniforms = Object.assign({}, material.uniforms);
                c2.side = (0, $ilwiq.BackSide);
                return c2;
            });
            this.materialsDoubleSide = materials.map((m2)=>{
                const c2 = this.cloneMaterial(m2);
                c2.uniforms = Object.assign({}, material.uniforms);
                c2.side = (0, $ilwiq.DoubleSide);
                return c2;
            });
            this.materialsFlatShaded = materials.map((m2)=>{
                const c2 = this.cloneMaterial(m2);
                c2.uniforms = Object.assign({}, material.uniforms);
                c2.flatShading = true;
                return c2;
            });
            this.materialsFlatShadedBackSide = materials.map((m2)=>{
                const c2 = this.cloneMaterial(m2);
                c2.uniforms = Object.assign({}, material.uniforms);
                c2.flatShading = true;
                c2.side = (0, $ilwiq.BackSide);
                return c2;
            });
            this.materialsFlatShadedDoubleSide = materials.map((m2)=>{
                const c2 = this.cloneMaterial(m2);
                c2.uniforms = Object.assign({}, material.uniforms);
                c2.flatShading = true;
                c2.side = (0, $ilwiq.DoubleSide);
                return c2;
            });
        }
    }
    /**
   * Renders the scene with the override material.
   *
   * @private
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Scene} scene - A scene.
   * @param {Camera} camera - A camera.
   */ render(renderer, scene, camera) {
        const shadowMapEnabled = renderer.shadowMap.enabled;
        renderer.shadowMap.enabled = false;
        if ($fe721963ebf18f1b$var$workaroundEnabled) {
            const originalMaterials = this.originalMaterials;
            this.meshCount = 0;
            scene.traverse(this.replaceMaterial);
            renderer.render(scene, camera);
            for (const entry of originalMaterials)entry[0].material = entry[1];
            if (this.meshCount !== originalMaterials.size) originalMaterials.clear();
        } else {
            const overrideMaterial = scene.overrideMaterial;
            scene.overrideMaterial = this.material;
            renderer.render(scene, camera);
            scene.overrideMaterial = overrideMaterial;
        }
        renderer.shadowMap.enabled = shadowMapEnabled;
    }
    /**
   * Deletes cloned override materials.
   *
   * @private
   */ disposeMaterials() {
        if (this.material !== null) {
            const materials = this.materials.concat(this.materialsBackSide).concat(this.materialsDoubleSide).concat(this.materialsFlatShaded).concat(this.materialsFlatShadedBackSide).concat(this.materialsFlatShadedDoubleSide);
            for (const m2 of materials)m2.dispose();
        }
    }
    /**
   * Performs cleanup tasks.
   */ dispose() {
        this.originalMaterials.clear();
        this.disposeMaterials();
    }
    /**
   * Indicates whether the override material workaround is enabled.
   *
   * @type {Boolean}
   */ static get workaroundEnabled() {
        return $fe721963ebf18f1b$var$workaroundEnabled;
    }
    /**
   * Enables or disables the override material workaround globally.
   *
   * This only affects post processing passes and effects.
   *
   * @type {Boolean}
   */ static set workaroundEnabled(value) {
        $fe721963ebf18f1b$var$workaroundEnabled = value;
    }
};
// src/core/Resizable.js
var $fe721963ebf18f1b$export$e82068809229c83c = class {
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {}
};
var $fe721963ebf18f1b$var$AUTO_SIZE = -1;
var $fe721963ebf18f1b$export$48a76196cafe3b93 = class extends (0, $ilwiq.EventDispatcher) {
    /**
   * Constructs a new resolution.
   *
   * TODO Remove resizable param.
   * @param {Resizable} resizable - A resizable object.
   * @param {Number} [width=Resolution.AUTO_SIZE] - The preferred width.
   * @param {Number} [height=Resolution.AUTO_SIZE] - The preferred height.
   * @param {Number} [scale=1.0] - A resolution scale.
   */ constructor(resizable, width = $fe721963ebf18f1b$var$AUTO_SIZE, height = $fe721963ebf18f1b$var$AUTO_SIZE, scale = 1){
        super();
        this.resizable = resizable;
        this.baseSize = new (0, $ilwiq.Vector2)(1, 1);
        this.preferredSize = new (0, $ilwiq.Vector2)(width, height);
        this.target = this.preferredSize;
        this.s = scale;
        this.effectiveSize = new (0, $ilwiq.Vector2)();
        this.addEventListener("change", ()=>this.updateEffectiveSize());
        this.updateEffectiveSize();
    }
    /**
   * Calculates the effective size.
   *
   * @private
   */ updateEffectiveSize() {
        const base = this.baseSize;
        const preferred = this.preferredSize;
        const effective = this.effectiveSize;
        const scale = this.scale;
        if (preferred.width !== $fe721963ebf18f1b$var$AUTO_SIZE) effective.width = preferred.width;
        else if (preferred.height !== $fe721963ebf18f1b$var$AUTO_SIZE) effective.width = Math.round(preferred.height * (base.width / Math.max(base.height, 1)));
        else effective.width = Math.round(base.width * scale);
        if (preferred.height !== $fe721963ebf18f1b$var$AUTO_SIZE) effective.height = preferred.height;
        else if (preferred.width !== $fe721963ebf18f1b$var$AUTO_SIZE) effective.height = Math.round(preferred.width / Math.max(base.width / Math.max(base.height, 1), 1));
        else effective.height = Math.round(base.height * scale);
    }
    /**
   * The effective width.
   *
   * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base width will be returned.
   *
   * @type {Number}
   */ get width() {
        return this.effectiveSize.width;
    }
    set width(value) {
        this.preferredWidth = value;
    }
    /**
   * The effective height.
   *
   * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base height will be returned.
   *
   * @type {Number}
   */ get height() {
        return this.effectiveSize.height;
    }
    set height(value) {
        this.preferredHeight = value;
    }
    /**
   * Returns the effective width.
   *
   * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base width will be returned.
   *
   * @deprecated Use width instead.
   * @return {Number} The effective width.
   */ getWidth() {
        return this.width;
    }
    /**
   * Returns the effective height.
   *
   * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base height will be returned.
   *
   * @deprecated Use height instead.
   * @return {Number} The effective height.
   */ getHeight() {
        return this.height;
    }
    /**
   * The resolution scale.
   *
   * @type {Number}
   */ get scale() {
        return this.s;
    }
    set scale(value) {
        if (this.s !== value) {
            this.s = value;
            this.preferredSize.setScalar($fe721963ebf18f1b$var$AUTO_SIZE);
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Returns the current resolution scale.
   *
   * @deprecated Use scale instead.
   * @return {Number} The scale.
   */ getScale() {
        return this.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * Also sets the preferred resolution to {@link Resizer.AUTO_SIZE}.
   *
   * @deprecated Use scale instead.
   * @param {Number} value - The scale.
   */ setScale(value) {
        this.scale = value;
    }
    /**
   * The base width.
   *
   * @type {Number}
   */ get baseWidth() {
        return this.baseSize.width;
    }
    set baseWidth(value) {
        if (this.baseSize.width !== value) {
            this.baseSize.width = value;
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Returns the base width.
   *
   * @deprecated Use baseWidth instead.
   * @return {Number} The base width.
   */ getBaseWidth() {
        return this.baseWidth;
    }
    /**
   * Sets the base width.
   *
   * @deprecated Use baseWidth instead.
   * @param {Number} value - The width.
   */ setBaseWidth(value) {
        this.baseWidth = value;
    }
    /**
   * The base height.
   *
   * @type {Number}
   */ get baseHeight() {
        return this.baseSize.height;
    }
    set baseHeight(value) {
        if (this.baseSize.height !== value) {
            this.baseSize.height = value;
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Returns the base height.
   *
   * @deprecated Use baseHeight instead.
   * @return {Number} The base height.
   */ getBaseHeight() {
        return this.baseHeight;
    }
    /**
   * Sets the base height.
   *
   * @deprecated Use baseHeight instead.
   * @param {Number} value - The height.
   */ setBaseHeight(value) {
        this.baseHeight = value;
    }
    /**
   * Sets the base size.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setBaseSize(width, height) {
        if (this.baseSize.width !== width || this.baseSize.height !== height) {
            this.baseSize.set(width, height);
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * The preferred width.
   *
   * @type {Number}
   */ get preferredWidth() {
        return this.preferredSize.width;
    }
    set preferredWidth(value) {
        if (this.preferredSize.width !== value) {
            this.preferredSize.width = value;
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Returns the preferred width.
   *
   * @deprecated Use preferredWidth instead.
   * @return {Number} The preferred width.
   */ getPreferredWidth() {
        return this.preferredWidth;
    }
    /**
   * Sets the preferred width.
   *
   * Use {@link Resizer.AUTO_SIZE} to automatically calculate the width based on the height and aspect ratio.
   *
   * @deprecated Use preferredWidth instead.
   * @param {Number} value - The width.
   */ setPreferredWidth(value) {
        this.preferredWidth = value;
    }
    /**
   * The preferred height.
   *
   * @type {Number}
   */ get preferredHeight() {
        return this.preferredSize.height;
    }
    set preferredHeight(value) {
        if (this.preferredSize.height !== value) {
            this.preferredSize.height = value;
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Returns the preferred height.
   *
   * @deprecated Use preferredHeight instead.
   * @return {Number} The preferred height.
   */ getPreferredHeight() {
        return this.preferredHeight;
    }
    /**
   * Sets the preferred height.
   *
   * Use {@link Resizer.AUTO_SIZE} to automatically calculate the height based on the width and aspect ratio.
   *
   * @deprecated Use preferredHeight instead.
   * @param {Number} value - The height.
   */ setPreferredHeight(value) {
        this.preferredHeight = value;
    }
    /**
   * Sets the preferred size.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setPreferredSize(width, height) {
        if (this.preferredSize.width !== width || this.preferredSize.height !== height) {
            this.preferredSize.set(width, height);
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Copies the given resolution.
   *
   * @param {Resolution} resolution - The resolution.
   */ copy(resolution) {
        this.s = resolution.scale;
        this.baseSize.set(resolution.baseWidth, resolution.baseHeight);
        this.preferredSize.set(resolution.preferredWidth, resolution.preferredHeight);
        this.dispatchEvent({
            type: "change"
        });
        this.resizable.setSize(this.baseSize.width, this.baseSize.height);
    }
    /**
   * An auto sizing constant.
   *
   * Can be used to automatically calculate the width or height based on the original aspect ratio.
   *
   * @type {Number}
   */ static get AUTO_SIZE() {
        return $fe721963ebf18f1b$var$AUTO_SIZE;
    }
};
// src/utils/IdManager.js
var $fe721963ebf18f1b$var$IdManager = class {
    /**
   * Constructs a new ID manager.
   *
   * @param initialId - The first ID.
   */ constructor(initialId = 0){
        this.nextId = initialId;
    }
    /**
   * Returns the next unique ID.
   *
   * @return The ID.
   */ getNextId() {
        return this.nextId++;
    }
    /**
   * Resets the ID counter.
   *
   * @param initialId - The first ID.
   * @return This manager.
   */ reset(initialId = 0) {
        this.nextId = initialId;
        return this;
    }
};
// src/core/Selection.js
var $fe721963ebf18f1b$var$idManager = /* @__PURE__ */ new $fe721963ebf18f1b$var$IdManager(2);
var $fe721963ebf18f1b$export$52baac22726c72bf = class extends Set {
    /**
   * Constructs a new selection.
   *
   * @param {Iterable<Object3D>} [iterable] - A collection of objects that should be added to this selection.
   * @param {Number} [layer] - A dedicated render layer for selected objects. Range is `[2, 31]`. Starts at 2 if omitted.
   */ constructor(iterable, layer = $fe721963ebf18f1b$var$idManager.getNextId()){
        super();
        this.exclusive = false;
        this._layer = layer;
        if (this._layer < 1 || this._layer > 31) {
            console.warn("Layer out of range, resetting to 2");
            $fe721963ebf18f1b$var$idManager.reset(2);
            this._layer = $fe721963ebf18f1b$var$idManager.getNextId();
        }
        if (iterable !== void 0) this.set(iterable);
    }
    /**
   * The render layer for selected objects.
   *
   * @type {Number}
   */ get layer() {
        return this._layer;
    }
    set layer(value) {
        const currentLayer = this._layer;
        for (const object of this){
            object.layers.disable(currentLayer);
            object.layers.enable(value);
        }
        this._layer = value;
    }
    /**
   * Returns the current render layer for selected objects.
   *
   * The default layer is 2. If this collides with your own custom layers, please change it before rendering!
   *
   * @deprecated Use layer instead.
   * @return {Number} The layer.
   */ getLayer() {
        return this.layer;
    }
    /**
   * Sets the render layer for selected objects.
   *
   * The current selection will be updated accordingly.
   *
   * @deprecated Use layer instead.
   * @param {Number} value - The layer. Range is [0, 31].
   */ setLayer(value) {
        this.layer = value;
    }
    /**
   * Indicates whether objects that are added to this selection will be removed from all other layers.
   *
   * @deprecated Use exclusive instead.
   * @return {Number} Whether this selection is exclusive. Default is false.
   */ isExclusive() {
        return this.exclusive;
    }
    /**
   * Controls whether objects that are added to this selection should be removed from all other layers.
   *
   * @deprecated Use exclusive instead.
   * @param {Number} value - Whether this selection should be exclusive.
   */ setExclusive(value) {
        this.exclusive = value;
    }
    /**
   * Clears this selection.
   *
   * @return {Selection} This selection.
   */ clear() {
        const layer = this.layer;
        for (const object of this)object.layers.disable(layer);
        return super.clear();
    }
    /**
   * Clears this selection and adds the given objects.
   *
   * @param {Iterable<Object3D>} objects - The objects that should be selected.
   * @return {Selection} This selection.
   */ set(objects) {
        this.clear();
        for (const object of objects)this.add(object);
        return this;
    }
    /**
   * An alias for {@link has}.
   *
   * @param {Object3D} object - An object.
   * @return {Number} Returns 0 if the given object is currently selected, or -1 otherwise.
   * @deprecated Added for backward-compatibility.
   */ indexOf(object) {
        return this.has(object) ? 0 : -1;
    }
    /**
   * Adds an object to this selection.
   *
   * If {@link exclusive} is set to `true`, the object will also be removed from all other layers.
   *
   * @param {Object3D} object - The object that should be selected.
   * @return {Selection} This selection.
   */ add(object) {
        if (this.exclusive) object.layers.set(this.layer);
        else object.layers.enable(this.layer);
        return super.add(object);
    }
    /**
   * Removes an object from this selection.
   *
   * @param {Object3D} object - The object that should be deselected.
   * @return {Boolean} Returns true if an object has successfully been removed from this selection; otherwise false.
   */ delete(object) {
        if (this.has(object)) object.layers.disable(this.layer);
        return super.delete(object);
    }
    /**
   * Removes an existing object from the selection. If the object doesn't exist it's added instead.
   *
   * @param {Object3D} object - The object.
   * @return {Boolean} Returns true if the object is added, false otherwise.
   */ toggle(object) {
        let result;
        if (this.has(object)) {
            this.delete(object);
            result = false;
        } else {
            this.add(object);
            result = true;
        }
        return result;
    }
    /**
   * Sets the visibility of all selected objects.
   *
   * This method enables or disables render layer 0 of all selected objects.
   *
   * @param {Boolean} visible - Whether the selected objects should be visible.
   * @return {Selection} This selection.
   */ setVisible(visible) {
        for (const object of this)if (visible) object.layers.enable(0);
        else object.layers.disable(0);
        return this;
    }
};
// src/enums/BlendFunction.js
var $fe721963ebf18f1b$export$ea7520add44ba1b6 = {
    SKIP: 9,
    SET: 30,
    ADD: 0,
    ALPHA: 1,
    AVERAGE: 2,
    COLOR: 3,
    COLOR_BURN: 4,
    COLOR_DODGE: 5,
    DARKEN: 6,
    DIFFERENCE: 7,
    DIVIDE: 8,
    DST: 9,
    EXCLUSION: 10,
    HARD_LIGHT: 11,
    HARD_MIX: 12,
    HUE: 13,
    INVERT: 14,
    INVERT_RGB: 15,
    LIGHTEN: 16,
    LINEAR_BURN: 17,
    LINEAR_DODGE: 18,
    LINEAR_LIGHT: 19,
    LUMINOSITY: 20,
    MULTIPLY: 21,
    NEGATION: 22,
    NORMAL: 23,
    OVERLAY: 24,
    PIN_LIGHT: 25,
    REFLECT: 26,
    SATURATION: 27,
    SCREEN: 28,
    SOFT_LIGHT: 29,
    SRC: 30,
    SUBTRACT: 31,
    VIVID_LIGHT: 32
};
// src/effects/blending/glsl/add.frag
var $fe721963ebf18f1b$var$add_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x+y,opacity);}";
// src/effects/blending/glsl/alpha.frag
var $fe721963ebf18f1b$var$alpha_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y,min(y.a,opacity));}";
// src/effects/blending/glsl/average.frag
var $fe721963ebf18f1b$var$average_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,(x+y)*0.5,opacity);}";
// src/effects/blending/glsl/color.frag
var $fe721963ebf18f1b$var$color_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(yHSL.rg,xHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}";
// src/effects/blending/glsl/color-burn.frag
var $fe721963ebf18f1b$var$color_burn_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(step(0.0,y)*(1.0-min(vec4(1.0),(1.0-x)/y)),vec4(1.0),step(1.0,x));return mix(x,z,opacity);}";
// src/effects/blending/glsl/color-dodge.frag
var $fe721963ebf18f1b$var$color_dodge_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=step(0.0,x)*mix(min(vec4(1.0),x/max(1.0-y,1e-9)),vec4(1.0),step(1.0,y));return mix(x,z,opacity);}";
// src/effects/blending/glsl/darken.frag
var $fe721963ebf18f1b$var$darken_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,min(x,y),opacity);}";
// src/effects/blending/glsl/difference.frag
var $fe721963ebf18f1b$var$difference_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,abs(x-y),opacity);}";
// src/effects/blending/glsl/divide.frag
var $fe721963ebf18f1b$var$divide_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x/max(y,1e-12),opacity);}";
// src/effects/blending/glsl/exclusion.frag
var $fe721963ebf18f1b$var$exclusion_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,(x+y-2.0*x*y),opacity);}";
// src/effects/blending/glsl/hard-light.frag
var $fe721963ebf18f1b$var$hard_light_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 a=min(x,1.0),b=min(y,1.0);vec4 z=mix(2.0*a*b,1.0-2.0*(1.0-a)*(1.0-b),step(0.5,y));return mix(x,z,opacity);}";
// src/effects/blending/glsl/hard-mix.frag
var $fe721963ebf18f1b$var$hard_mix_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,step(1.0,x+y),opacity);}";
// src/effects/blending/glsl/hue.frag
var $fe721963ebf18f1b$var$hue_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(yHSL.r,xHSL.gb));return vec4(mix(x.rgb,z,opacity),y.a);}";
// src/effects/blending/glsl/invert.frag
var $fe721963ebf18f1b$var$invert_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,1.0-y,opacity);}";
// src/effects/blending/glsl/invert-rgb.frag
var $fe721963ebf18f1b$var$invert_rgb_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y*(1.0-x),opacity);}";
// src/effects/blending/glsl/lighten.frag
var $fe721963ebf18f1b$var$lighten_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,max(x,y),opacity);}";
// src/effects/blending/glsl/linear-burn.frag
var $fe721963ebf18f1b$var$linear_burn_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,clamp(y+x-1.0,0.0,1.0),opacity);}";
// src/effects/blending/glsl/linear-dodge.frag
var $fe721963ebf18f1b$var$linear_dodge_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,min(x+y,1.0),opacity);}";
// src/effects/blending/glsl/linear-light.frag
var $fe721963ebf18f1b$var$linear_light_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,clamp(2.0*y+x-1.0,0.0,1.0),opacity);}";
// src/effects/blending/glsl/luminosity.frag
var $fe721963ebf18f1b$var$luminosity_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(xHSL.rg,yHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}";
// src/effects/blending/glsl/multiply.frag
var $fe721963ebf18f1b$var$multiply_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x*y,opacity);}";
// src/effects/blending/glsl/negation.frag
var $fe721963ebf18f1b$var$negation_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,1.0-abs(1.0-x-y),opacity);}";
// src/effects/blending/glsl/normal.frag
var $fe721963ebf18f1b$var$normal_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y,opacity);}";
// src/effects/blending/glsl/overlay.frag
var $fe721963ebf18f1b$var$overlay_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(2.0*y*x,1.0-2.0*(1.0-y)*(1.0-x),step(0.5,x));return mix(x,z,opacity);}";
// src/effects/blending/glsl/pin-light.frag
var $fe721963ebf18f1b$var$pin_light_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 y2=2.0*y;vec4 z=mix(mix(y2,x,step(0.5*x,y)),max(vec4(0.0),y2-1.0),step(x,(y2-1.0)));return mix(x,z,opacity);}";
// src/effects/blending/glsl/reflect.frag
var $fe721963ebf18f1b$var$reflect_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(min(x*x/max(1.0-y,1e-12),1.0),y,step(1.0,y));return mix(x,z,opacity);}";
// src/effects/blending/glsl/saturation.frag
var $fe721963ebf18f1b$var$saturation_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(xHSL.r,yHSL.g,xHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}";
// src/effects/blending/glsl/screen.frag
var $fe721963ebf18f1b$var$screen_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x+y-min(x*y,1.0),opacity);}";
// src/effects/blending/glsl/soft-light.frag
var $fe721963ebf18f1b$var$soft_light_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 y2=2.0*y;vec4 w=step(0.5,y);vec4 z=mix(x-(1.0-y2)*x*(1.0-x),mix(x+(y2-1.0)*(sqrt(x)-x),x+(y2-1.0)*x*((16.0*x-12.0)*x+3.0),w*(1.0-step(0.25,x))),w);return mix(x,z,opacity);}";
// src/effects/blending/glsl/src.frag
var $fe721963ebf18f1b$var$src_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return y;}";
// src/effects/blending/glsl/subtract.frag
var $fe721963ebf18f1b$var$subtract_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,max(x+y-1.0,0.0),opacity);}";
// src/effects/blending/glsl/vivid-light.frag
var $fe721963ebf18f1b$var$vivid_light_default = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(max(1.0-min((1.0-x)/(2.0*y),1.0),0.0),min(x/(2.0*(1.0-y)),1.0),step(0.5,y));return mix(x,z,opacity);}";
// src/effects/blending/BlendMode.js
var $fe721963ebf18f1b$var$blendFunctions = /* @__PURE__ */ new Map([
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.ADD,
        $fe721963ebf18f1b$var$add_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.ALPHA,
        $fe721963ebf18f1b$var$alpha_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.AVERAGE,
        $fe721963ebf18f1b$var$average_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.COLOR,
        $fe721963ebf18f1b$var$color_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.COLOR_BURN,
        $fe721963ebf18f1b$var$color_burn_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.COLOR_DODGE,
        $fe721963ebf18f1b$var$color_dodge_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.DARKEN,
        $fe721963ebf18f1b$var$darken_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.DIFFERENCE,
        $fe721963ebf18f1b$var$difference_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.DIVIDE,
        $fe721963ebf18f1b$var$divide_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.DST,
        null
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.EXCLUSION,
        $fe721963ebf18f1b$var$exclusion_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.HARD_LIGHT,
        $fe721963ebf18f1b$var$hard_light_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.HARD_MIX,
        $fe721963ebf18f1b$var$hard_mix_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.HUE,
        $fe721963ebf18f1b$var$hue_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.INVERT,
        $fe721963ebf18f1b$var$invert_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.INVERT_RGB,
        $fe721963ebf18f1b$var$invert_rgb_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.LIGHTEN,
        $fe721963ebf18f1b$var$lighten_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.LINEAR_BURN,
        $fe721963ebf18f1b$var$linear_burn_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.LINEAR_DODGE,
        $fe721963ebf18f1b$var$linear_dodge_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.LINEAR_LIGHT,
        $fe721963ebf18f1b$var$linear_light_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.LUMINOSITY,
        $fe721963ebf18f1b$var$luminosity_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.MULTIPLY,
        $fe721963ebf18f1b$var$multiply_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.NEGATION,
        $fe721963ebf18f1b$var$negation_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.NORMAL,
        $fe721963ebf18f1b$var$normal_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.OVERLAY,
        $fe721963ebf18f1b$var$overlay_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.PIN_LIGHT,
        $fe721963ebf18f1b$var$pin_light_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.REFLECT,
        $fe721963ebf18f1b$var$reflect_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.SATURATION,
        $fe721963ebf18f1b$var$saturation_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.SCREEN,
        $fe721963ebf18f1b$var$screen_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.SOFT_LIGHT,
        $fe721963ebf18f1b$var$soft_light_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.SRC,
        $fe721963ebf18f1b$var$src_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.SUBTRACT,
        $fe721963ebf18f1b$var$subtract_default
    ],
    [
        $fe721963ebf18f1b$export$ea7520add44ba1b6.VIVID_LIGHT,
        $fe721963ebf18f1b$var$vivid_light_default
    ]
]);
var $fe721963ebf18f1b$export$c9b8fe72ac71821 = class extends (0, $ilwiq.EventDispatcher) {
    /**
   * Constructs a new blend mode.
   *
   * @param {BlendFunction} blendFunction - The blend function.
   * @param {Number} opacity - The opacity of the color that will be blended with the base color.
   */ constructor(blendFunction, opacity = 1){
        super();
        this._blendFunction = blendFunction;
        this.opacity = new (0, $ilwiq.Uniform)(opacity);
    }
    /**
   * Returns the opacity.
   *
   * @return {Number} The opacity.
   */ getOpacity() {
        return this.opacity.value;
    }
    /**
   * Sets the opacity.
   *
   * @param {Number} value - The opacity.
   */ setOpacity(value) {
        this.opacity.value = value;
    }
    /**
   * The blend function.
   *
   * @type {BlendFunction}
   */ get blendFunction() {
        return this._blendFunction;
    }
    set blendFunction(value) {
        this._blendFunction = value;
        this.dispatchEvent({
            type: "change"
        });
    }
    /**
   * Returns the blend function.
   *
   * @deprecated Use blendFunction instead.
   * @return {BlendFunction} The blend function.
   */ getBlendFunction() {
        return this.blendFunction;
    }
    /**
   * Sets the blend function.
   *
   * @deprecated Use blendFunction instead.
   * @param {BlendFunction} value - The blend function.
   */ setBlendFunction(value) {
        this.blendFunction = value;
    }
    /**
   * Returns the blend function shader code.
   *
   * @return {String} The blend function shader code.
   */ getShaderCode() {
        return $fe721963ebf18f1b$var$blendFunctions.get(this.blendFunction);
    }
};
// src/enums/KernelSize.js
var $fe721963ebf18f1b$export$543b1e4815577d06 = {
    VERY_SMALL: 0,
    SMALL: 1,
    MEDIUM: 2,
    LARGE: 3,
    VERY_LARGE: 4,
    HUGE: 5
};
// src/materials/glsl/convolution.kawase.frag
var $fe721963ebf18f1b$var$convolution_kawase_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\nvarying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec4 sum=texture2D(inputBuffer,vUv0);sum+=texture2D(inputBuffer,vUv1);sum+=texture2D(inputBuffer,vUv2);sum+=texture2D(inputBuffer,vUv3);gl_FragColor=sum*0.25;\n#include <colorspace_fragment>\n}";
// src/materials/glsl/convolution.kawase.vert
var $fe721963ebf18f1b$var$convolution_kawase_default2 = "uniform vec4 texelSize;uniform float kernel;uniform float scale;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vec2 dUv=(texelSize.xy*vec2(kernel)+texelSize.zw)*scale;vUv0=vec2(uv.x-dUv.x,uv.y+dUv.y);vUv1=vec2(uv.x+dUv.x,uv.y+dUv.y);vUv2=vec2(uv.x+dUv.x,uv.y-dUv.y);vUv3=vec2(uv.x-dUv.x,uv.y-dUv.y);gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/KawaseBlurMaterial.js
var $fe721963ebf18f1b$var$kernelPresets = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        0,
        1,
        1
    ]),
    new Float32Array([
        0,
        1,
        1,
        2
    ]),
    new Float32Array([
        0,
        1,
        2,
        2,
        3
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        4,
        5
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        5,
        7,
        8,
        9,
        10
    ])
];
var $fe721963ebf18f1b$export$c69ac3f2757c20a = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new convolution material.
   *
   * TODO Remove texelSize param.
   * @param {Vector4} [texelSize] - Deprecated.
   */ constructor(texelSize = new (0, $ilwiq.Vector4)()){
        super({
            name: "KawaseBlurMaterial",
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                texelSize: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector4)()),
                scale: new (0, $ilwiq.Uniform)(1),
                kernel: new (0, $ilwiq.Uniform)(0)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$convolution_kawase_default,
            vertexShader: $fe721963ebf18f1b$var$convolution_kawase_default2
        });
        this.setTexelSize(texelSize.x, texelSize.y);
        this.kernelSize = $fe721963ebf18f1b$export$543b1e4815577d06.MEDIUM;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.inputBuffer = value;
    }
    /**
   * The kernel sequence for the current kernel size.
   *
   * @type {Float32Array}
   */ get kernelSequence() {
        return $fe721963ebf18f1b$var$kernelPresets[this.kernelSize];
    }
    /**
   * The blur scale.
   *
   * @type {Number}
   */ get scale() {
        return this.uniforms.scale.value;
    }
    set scale(value) {
        this.uniforms.scale.value = value;
    }
    /**
   * Returns the blur scale.
   *
   * @deprecated Use scale instead.
   * @return {Number} The scale.
   */ getScale() {
        return this.uniforms.scale.value;
    }
    /**
   * Sets the blur scale.
   *
   * @deprecated Use scale instead.
   * @return {Number} value - The scale.
   */ setScale(value) {
        this.uniforms.scale.value = value;
    }
    /**
   * Returns the kernel.
   *
   * @return {Float32Array} The kernel.
   * @deprecated Implementation detail, removed with no replacement.
   */ getKernel() {
        return null;
    }
    /**
   * The current kernel.
   *
   * @type {Number}
   */ get kernel() {
        return this.uniforms.kernel.value;
    }
    set kernel(value) {
        this.uniforms.kernel.value = value;
    }
    /**
   * Sets the current kernel.
   *
   * @deprecated Use kernel instead.
   * @param {Number} value - The kernel.
   */ setKernel(value) {
        this.kernel = value;
    }
    /**
   * Sets the texel size.
   *
   * @deprecated Use setSize() instead.
   * @param {Number} x - The texel width.
   * @param {Number} y - The texel height.
   */ setTexelSize(x, y) {
        this.uniforms.texelSize.value.set(x, y, x * 0.5, y * 0.5);
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const x = 1 / width, y = 1 / height;
        this.uniforms.texelSize.value.set(x, y, x * 0.5, y * 0.5);
    }
};
// src/passes/KawaseBlurPass.js
var $fe721963ebf18f1b$export$657273fee9302035 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new Kawase blur pass.
   *
   * @param {Object} [options] - The options.
   * @param {KernelSize} [options.kernelSize=KernelSize.MEDIUM] - The blur kernel size.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor({ kernelSize: kernelSize = $fe721963ebf18f1b$export$543b1e4815577d06.MEDIUM, resolutionScale: resolutionScale = 0.5, width: width = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, height: height = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("KawaseBlurPass");
        this.renderTargetA = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetA.texture.name = "Blur.Target.A";
        this.renderTargetB = this.renderTargetA.clone();
        this.renderTargetB.texture.name = "Blur.Target.B";
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this._blurMaterial = new $fe721963ebf18f1b$export$c69ac3f2757c20a();
        this._blurMaterial.kernelSize = kernelSize;
        this.copyMaterial = new $fe721963ebf18f1b$export$d4b5f24bda67f7e4();
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * The blur material.
   *
   * @type {KawaseBlurMaterial}
   */ get blurMaterial() {
        return this._blurMaterial;
    }
    /**
   * The blur material.
   *
   * @type {KawaseBlurMaterial}
   * @protected
   */ set blurMaterial(value) {
        this._blurMaterial = value;
    }
    /**
   * Indicates whether dithering is enabled.
   *
   * @type {Boolean}
   * @deprecated Use copyMaterial.dithering instead.
   */ get dithering() {
        return this.copyMaterial.dithering;
    }
    set dithering(value) {
        this.copyMaterial.dithering = value;
    }
    /**
   * The kernel size.
   *
   * @type {KernelSize}
   * @deprecated Use blurMaterial.kernelSize instead.
   */ get kernelSize() {
        return this.blurMaterial.kernelSize;
    }
    set kernelSize(value) {
        this.blurMaterial.kernelSize = value;
    }
    /**
   * The current width of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.width instead.
   */ get width() {
        return this.resolution.width;
    }
    /**
   * Sets the render width.
   *
   * @type {Number}
   * @deprecated Use resolution.preferredWidth instead.
   */ set width(value) {
        this.resolution.preferredWidth = value;
    }
    /**
   * The current height of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.height instead.
   */ get height() {
        return this.resolution.height;
    }
    /**
   * Sets the render height.
   *
   * @type {Number}
   * @deprecated Use resolution.preferredHeight instead.
   */ set height(value) {
        this.resolution.preferredHeight = value;
    }
    /**
   * The current blur scale.
   *
   * @type {Number}
   * @deprecated Use blurMaterial.scale instead.
   */ get scale() {
        return this.blurMaterial.scale;
    }
    set scale(value) {
        this.blurMaterial.scale = value;
    }
    /**
   * Returns the current blur scale.
   *
   * @deprecated Use blurMaterial.scale instead.
   * @return {Number} The scale.
   */ getScale() {
        return this.blurMaterial.scale;
    }
    /**
   * Sets the blur scale.
   *
   * @deprecated Use blurMaterial.scale instead.
   * @param {Number} value - The scale.
   */ setScale(value) {
        this.blurMaterial.scale = value;
    }
    /**
   * Returns the kernel size.
   *
   * @deprecated Use blurMaterial.kernelSize instead.
   * @return {KernelSize} The kernel size.
   */ getKernelSize() {
        return this.kernelSize;
    }
    /**
   * Sets the kernel size.
   *
   * Larger kernels require more processing power but scale well with larger render resolutions.
   *
   * @deprecated Use blurMaterial.kernelSize instead.
   * @param {KernelSize} value - The kernel size.
   */ setKernelSize(value) {
        this.kernelSize = value;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated Use resolution instead.
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated Use resolution instead.
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * Renders the blur.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const scene = this.scene;
        const camera = this.camera;
        const renderTargetA = this.renderTargetA;
        const renderTargetB = this.renderTargetB;
        const material = this.blurMaterial;
        const kernelSequence = material.kernelSequence;
        let previousBuffer = inputBuffer;
        this.fullscreenMaterial = material;
        for(let i = 0, l = kernelSequence.length; i < l; ++i){
            const buffer = (i & 1) === 0 ? renderTargetA : renderTargetB;
            material.kernel = kernelSequence[i];
            material.inputBuffer = previousBuffer.texture;
            renderer.setRenderTarget(buffer);
            renderer.render(scene, camera);
            previousBuffer = buffer;
        }
        this.fullscreenMaterial = this.copyMaterial;
        this.copyMaterial.inputBuffer = previousBuffer.texture;
        renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
        renderer.render(scene, camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.renderTargetA.setSize(w, h);
        this.renderTargetB.setSize(w, h);
        this.blurMaterial.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0) {
            this.renderTargetA.texture.type = frameBufferType;
            this.renderTargetB.texture.type = frameBufferType;
            if (frameBufferType !== (0, $ilwiq.UnsignedByteType)) {
                this.blurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
                this.copyMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
            } else if (renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) {
                this.renderTargetA.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
                this.renderTargetB.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
            }
        }
    }
    /**
   * An auto sizing flag.
   *
   * @type {Number}
   * @deprecated Use {@link Resolution.AUTO_SIZE} instead.
   */ static get AUTO_SIZE() {
        return $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE;
    }
};
// src/materials/glsl/luminance.frag
var $fe721963ebf18f1b$var$luminance_default = "#include <common>\n#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\n#ifdef RANGE\nuniform vec2 range;\n#elif defined(THRESHOLD)\nuniform float threshold;uniform float smoothing;\n#endif\nvarying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);float l=luminance(texel.rgb);\n#ifdef RANGE\nfloat low=step(range.x,l);float high=step(l,range.y);l*=low*high;\n#elif defined(THRESHOLD)\nl=smoothstep(threshold,threshold+smoothing,l)*l;\n#endif\n#ifdef COLOR\ngl_FragColor=vec4(texel.rgb*clamp(l,0.0,1.0),l);\n#else\ngl_FragColor=vec4(l);\n#endif\n}";
// src/materials/LuminanceMaterial.js
var $fe721963ebf18f1b$export$5965aa8be393908 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new luminance material.
   *
   * @param {Boolean} [colorOutput=false] - Defines whether the shader should output colors scaled with their luminance value.
   * @param {Vector2} [luminanceRange] - If provided, the shader will mask out texels that aren't in the specified luminance range.
   */ constructor(colorOutput = false, luminanceRange = null){
        super({
            name: "LuminanceMaterial",
            defines: {
                THREE_REVISION: (0, $ilwiq.REVISION).replace(/\D+/g, "")
            },
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                threshold: new (0, $ilwiq.Uniform)(0),
                smoothing: new (0, $ilwiq.Uniform)(1),
                range: new (0, $ilwiq.Uniform)(null)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$luminance_default,
            vertexShader: $fe721963ebf18f1b$var$common_default
        });
        this.colorOutput = colorOutput;
        this.luminanceRange = luminanceRange;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The luminance threshold.
   *
   * @type {Number}
   */ get threshold() {
        return this.uniforms.threshold.value;
    }
    set threshold(value) {
        if (this.smoothing > 0 || value > 0) this.defines.THRESHOLD = "1";
        else delete this.defines.THRESHOLD;
        this.uniforms.threshold.value = value;
    }
    /**
   * Returns the luminance threshold.
   *
   * @deprecated Use threshold instead.
   * @return {Number} The threshold.
   */ getThreshold() {
        return this.threshold;
    }
    /**
   * Sets the luminance threshold.
   *
   * @deprecated Use threshold instead.
   * @param {Number} value - The threshold.
   */ setThreshold(value) {
        this.threshold = value;
    }
    /**
   * The luminance threshold smoothing.
   *
   * @type {Number}
   */ get smoothing() {
        return this.uniforms.smoothing.value;
    }
    set smoothing(value) {
        if (this.threshold > 0 || value > 0) this.defines.THRESHOLD = "1";
        else delete this.defines.THRESHOLD;
        this.uniforms.smoothing.value = value;
    }
    /**
   * Returns the luminance threshold smoothing factor.
   *
   * @deprecated Use smoothing instead.
   * @return {Number} The smoothing factor.
   */ getSmoothingFactor() {
        return this.smoothing;
    }
    /**
   * Sets the luminance threshold smoothing factor.
   *
   * @deprecated Use smoothing instead.
   * @param {Number} value - The smoothing factor.
   */ setSmoothingFactor(value) {
        this.smoothing = value;
    }
    /**
   * Indicates whether the luminance threshold is enabled.
   *
   * @type {Boolean}
   * @deprecated Adjust the threshold or smoothing factor instead.
   */ get useThreshold() {
        return this.threshold > 0 || this.smoothing > 0;
    }
    set useThreshold(value) {}
    /**
   * Indicates whether color output is enabled.
   *
   * @type {Boolean}
   */ get colorOutput() {
        return this.defines.COLOR !== void 0;
    }
    set colorOutput(value) {
        if (value) this.defines.COLOR = "1";
        else delete this.defines.COLOR;
        this.needsUpdate = true;
    }
    /**
   * Indicates whether color output is enabled.
   *
   * @deprecated Use colorOutput instead.
   * @return {Boolean} Whether color output is enabled.
   */ isColorOutputEnabled(value) {
        return this.colorOutput;
    }
    /**
   * Enables or disables color output.
   *
   * @deprecated Use colorOutput instead.
   * @param {Boolean} value - Whether color output should be enabled.
   */ setColorOutputEnabled(value) {
        this.colorOutput = value;
    }
    /**
   * Indicates whether luminance masking is enabled.
   *
   * @type {Boolean}
   * @deprecated
   */ get useRange() {
        return this.luminanceRange !== null;
    }
    set useRange(value) {
        this.luminanceRange = null;
    }
    /**
   * The luminance range. Set to null to disable.
   *
   * @type {Boolean}
   */ get luminanceRange() {
        return this.uniforms.range.value;
    }
    set luminanceRange(value) {
        if (value !== null) this.defines.RANGE = "1";
        else delete this.defines.RANGE;
        this.uniforms.range.value = value;
        this.needsUpdate = true;
    }
    /**
   * Returns the current luminance range.
   *
   * @deprecated Use luminanceRange instead.
   * @return {Vector2} The luminance range.
   */ getLuminanceRange() {
        return this.luminanceRange;
    }
    /**
   * Sets a luminance range. Set to null to disable.
   *
   * @deprecated Use luminanceRange instead.
   * @param {Vector2} value - The luminance range.
   */ setLuminanceRange(value) {
        this.luminanceRange = value;
    }
};
// src/passes/LuminancePass.js
var $fe721963ebf18f1b$export$855ea63a754bfd18 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new luminance pass.
   *
   * @param {Object} [options] - The options. See {@link LuminanceMaterial} for additional options.
   * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor({ renderTarget: renderTarget, luminanceRange: luminanceRange, colorOutput: colorOutput, resolutionScale: resolutionScale = 1, width: width = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, height: height = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("LuminancePass");
        this.fullscreenMaterial = new $fe721963ebf18f1b$export$5965aa8be393908(colorOutput, luminanceRange);
        this.needsSwap = false;
        this.renderTarget = renderTarget;
        if (this.renderTarget === void 0) {
            this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
                depthBuffer: false
            });
            this.renderTarget.texture.name = "LuminancePass.Target";
        }
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    /**
   * The luminance texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the luminance texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Renders the luminance.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const material = this.fullscreenMaterial;
        material.inputBuffer = inputBuffer.texture;
        renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
        renderer.render(this.scene, this.camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - A renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0 && frameBufferType !== (0, $ilwiq.UnsignedByteType)) {
            this.renderTarget.texture.type = frameBufferType;
            this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
        }
    }
};
// src/materials/glsl/convolution.downsampling.frag
var $fe721963ebf18f1b$var$convolution_downsampling_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\n#define WEIGHT_INNER 0.125\n#define WEIGHT_OUTER 0.0555555\nvarying vec2 vUv;varying vec2 vUv00;varying vec2 vUv01;varying vec2 vUv02;varying vec2 vUv03;varying vec2 vUv04;varying vec2 vUv05;varying vec2 vUv06;varying vec2 vUv07;varying vec2 vUv08;varying vec2 vUv09;varying vec2 vUv10;varying vec2 vUv11;float clampToBorder(const in vec2 uv){return float(uv.s>=0.0&&uv.s<=1.0&&uv.t>=0.0&&uv.t<=1.0);}void main(){vec4 c=vec4(0.0);vec4 w=WEIGHT_INNER*vec4(clampToBorder(vUv00),clampToBorder(vUv01),clampToBorder(vUv02),clampToBorder(vUv03));c+=w.x*texture2D(inputBuffer,vUv00);c+=w.y*texture2D(inputBuffer,vUv01);c+=w.z*texture2D(inputBuffer,vUv02);c+=w.w*texture2D(inputBuffer,vUv03);w=WEIGHT_OUTER*vec4(clampToBorder(vUv04),clampToBorder(vUv05),clampToBorder(vUv06),clampToBorder(vUv07));c+=w.x*texture2D(inputBuffer,vUv04);c+=w.y*texture2D(inputBuffer,vUv05);c+=w.z*texture2D(inputBuffer,vUv06);c+=w.w*texture2D(inputBuffer,vUv07);w=WEIGHT_OUTER*vec4(clampToBorder(vUv08),clampToBorder(vUv09),clampToBorder(vUv10),clampToBorder(vUv11));c+=w.x*texture2D(inputBuffer,vUv08);c+=w.y*texture2D(inputBuffer,vUv09);c+=w.z*texture2D(inputBuffer,vUv10);c+=w.w*texture2D(inputBuffer,vUv11);c+=WEIGHT_OUTER*texture2D(inputBuffer,vUv);gl_FragColor=c;\n#include <colorspace_fragment>\n}";
// src/materials/glsl/convolution.downsampling.vert
var $fe721963ebf18f1b$var$convolution_downsampling_default2 = "uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv00;varying vec2 vUv01;varying vec2 vUv02;varying vec2 vUv03;varying vec2 vUv04;varying vec2 vUv05;varying vec2 vUv06;varying vec2 vUv07;varying vec2 vUv08;varying vec2 vUv09;varying vec2 vUv10;varying vec2 vUv11;void main(){vUv=position.xy*0.5+0.5;vUv00=vUv+texelSize*vec2(-1.0,1.0);vUv01=vUv+texelSize*vec2(1.0,1.0);vUv02=vUv+texelSize*vec2(-1.0,-1.0);vUv03=vUv+texelSize*vec2(1.0,-1.0);vUv04=vUv+texelSize*vec2(-2.0,2.0);vUv05=vUv+texelSize*vec2(0.0,2.0);vUv06=vUv+texelSize*vec2(2.0,2.0);vUv07=vUv+texelSize*vec2(-2.0,0.0);vUv08=vUv+texelSize*vec2(2.0,0.0);vUv09=vUv+texelSize*vec2(-2.0,-2.0);vUv10=vUv+texelSize*vec2(0.0,-2.0);vUv11=vUv+texelSize*vec2(2.0,-2.0);gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/DownsamplingMaterial.js
var $fe721963ebf18f1b$export$28b4600b285eba04 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new downsampling material.
   */ constructor(){
        super({
            name: "DownsamplingMaterial",
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                texelSize: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)())
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$convolution_downsampling_default,
            vertexShader: $fe721963ebf18f1b$var$convolution_downsampling_default2
        });
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/materials/glsl/convolution.upsampling.frag
var $fe721963ebf18f1b$var$convolution_upsampling_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;uniform mediump sampler2D supportBuffer;\n#else\nuniform lowp sampler2D inputBuffer;uniform lowp sampler2D supportBuffer;\n#endif\nuniform float radius;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;varying vec2 vUv6;varying vec2 vUv7;void main(){vec4 c=vec4(0.0);c+=texture2D(inputBuffer,vUv0)*0.0625;c+=texture2D(inputBuffer,vUv1)*0.125;c+=texture2D(inputBuffer,vUv2)*0.0625;c+=texture2D(inputBuffer,vUv3)*0.125;c+=texture2D(inputBuffer,vUv)*0.25;c+=texture2D(inputBuffer,vUv4)*0.125;c+=texture2D(inputBuffer,vUv5)*0.0625;c+=texture2D(inputBuffer,vUv6)*0.125;c+=texture2D(inputBuffer,vUv7)*0.0625;vec4 baseColor=texture2D(supportBuffer,vUv);gl_FragColor=mix(baseColor,c,radius);\n#include <colorspace_fragment>\n}";
// src/materials/glsl/convolution.upsampling.vert
var $fe721963ebf18f1b$var$convolution_upsampling_default2 = "uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;varying vec2 vUv6;varying vec2 vUv7;void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,1.0);vUv1=vUv+texelSize*vec2(0.0,1.0);vUv2=vUv+texelSize*vec2(1.0,1.0);vUv3=vUv+texelSize*vec2(-1.0,0.0);vUv4=vUv+texelSize*vec2(1.0,0.0);vUv5=vUv+texelSize*vec2(-1.0,-1.0);vUv6=vUv+texelSize*vec2(0.0,-1.0);vUv7=vUv+texelSize*vec2(1.0,-1.0);gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/UpsamplingMaterial.js
var $fe721963ebf18f1b$export$bfa5970d414d05b5 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new upsampling material.
   */ constructor(){
        super({
            name: "UpsamplingMaterial",
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                supportBuffer: new (0, $ilwiq.Uniform)(null),
                texelSize: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                radius: new (0, $ilwiq.Uniform)(0.85)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$convolution_upsampling_default,
            vertexShader: $fe721963ebf18f1b$var$convolution_upsampling_default2
        });
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * A support buffer.
   *
   * @type {Texture}
   */ set supportBuffer(value) {
        this.uniforms.supportBuffer.value = value;
    }
    /**
   * The blur radius.
   *
   * @type {Number}
   */ get radius() {
        return this.uniforms.radius.value;
    }
    set radius(value) {
        this.uniforms.radius.value = value;
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/passes/MipmapBlurPass.js
var $fe721963ebf18f1b$export$dd9496fb07a8ca00 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new mipmap blur pass.
   *
   * @param {Object} [options] - The options.
   */ constructor(){
        super("MipmapBlurPass");
        this.needsSwap = false;
        this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTarget.texture.name = "Upsampling.Mipmap0";
        this.downsamplingMipmaps = [];
        this.upsamplingMipmaps = [];
        this.downsamplingMaterial = new $fe721963ebf18f1b$export$28b4600b285eba04();
        this.upsamplingMaterial = new $fe721963ebf18f1b$export$bfa5970d414d05b5();
        this.resolution = new (0, $ilwiq.Vector2)();
    }
    /**
   * A texture that contains the blurred result.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * The MIP levels. Default is 8.
   *
   * @type {Number}
   */ get levels() {
        return this.downsamplingMipmaps.length;
    }
    set levels(value) {
        if (this.levels !== value) {
            const renderTarget = this.renderTarget;
            this.dispose();
            this.downsamplingMipmaps = [];
            this.upsamplingMipmaps = [];
            for(let i = 0; i < value; ++i){
                const mipmap = renderTarget.clone();
                mipmap.texture.name = "Downsampling.Mipmap" + i;
                this.downsamplingMipmaps.push(mipmap);
            }
            this.upsamplingMipmaps.push(renderTarget);
            for(let i = 1, l = value - 1; i < l; ++i){
                const mipmap = renderTarget.clone();
                mipmap.texture.name = "Upsampling.Mipmap" + i;
                this.upsamplingMipmaps.push(mipmap);
            }
            this.setSize(this.resolution.x, this.resolution.y);
        }
    }
    /**
   * The blur radius.
   *
   * @type {Number}
   */ get radius() {
        return this.upsamplingMaterial.radius;
    }
    set radius(value) {
        this.upsamplingMaterial.radius = value;
    }
    /**
   * Renders the blur.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const { scene: scene, camera: camera } = this;
        const { downsamplingMaterial: downsamplingMaterial, upsamplingMaterial: upsamplingMaterial } = this;
        const { downsamplingMipmaps: downsamplingMipmaps, upsamplingMipmaps: upsamplingMipmaps } = this;
        let previousBuffer = inputBuffer;
        this.fullscreenMaterial = downsamplingMaterial;
        for(let i = 0, l = downsamplingMipmaps.length; i < l; ++i){
            const mipmap = downsamplingMipmaps[i];
            downsamplingMaterial.setSize(previousBuffer.width, previousBuffer.height);
            downsamplingMaterial.inputBuffer = previousBuffer.texture;
            renderer.setRenderTarget(mipmap);
            renderer.render(scene, camera);
            previousBuffer = mipmap;
        }
        this.fullscreenMaterial = upsamplingMaterial;
        for(let i = upsamplingMipmaps.length - 1; i >= 0; --i){
            const mipmap = upsamplingMipmaps[i];
            upsamplingMaterial.setSize(previousBuffer.width, previousBuffer.height);
            upsamplingMaterial.inputBuffer = previousBuffer.texture;
            upsamplingMaterial.supportBuffer = downsamplingMipmaps[i].texture;
            renderer.setRenderTarget(mipmap);
            renderer.render(scene, camera);
            previousBuffer = mipmap;
        }
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.set(width, height);
        let w = resolution.width, h = resolution.height;
        for(let i = 0, l = this.downsamplingMipmaps.length; i < l; ++i){
            w = Math.round(w * 0.5);
            h = Math.round(h * 0.5);
            this.downsamplingMipmaps[i].setSize(w, h);
            if (i < this.upsamplingMipmaps.length) this.upsamplingMipmaps[i].setSize(w, h);
        }
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0) {
            const mipmaps = this.downsamplingMipmaps.concat(this.upsamplingMipmaps);
            for (const mipmap of mipmaps)mipmap.texture.type = frameBufferType;
            if (frameBufferType !== (0, $ilwiq.UnsignedByteType)) {
                this.downsamplingMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
                this.upsamplingMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
            } else if (renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) for (const mipmap of mipmaps)mipmap.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
        }
    }
    /**
   * Deletes internal render targets and textures.
   */ dispose() {
        super.dispose();
        for (const mipmap of this.downsamplingMipmaps.concat(this.upsamplingMipmaps))mipmap.dispose();
    }
};
var $fe721963ebf18f1b$export$a32b0b1c1ac59d04 = class extends (0, $ilwiq.EventDispatcher) {
    /**
   * Constructs a new effect.
   *
   * @param {String} name - The name of this effect. Doesn't have to be unique.
   * @param {String} fragmentShader - The fragment shader. This shader is required.
   * @param {Object} [options] - Additional options.
   * @param {EffectAttribute} [options.attributes=EffectAttribute.NONE] - The effect attributes that determine the execution priority and resource requirements.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.NORMAL] - The blend function of this effect.
   * @param {Map<String, String>} [options.defines] - Custom preprocessor macro definitions. Keys are names and values are code.
   * @param {Map<String, Uniform>} [options.uniforms] - Custom shader uniforms. Keys are names and values are uniforms.
   * @param {Set<WebGLExtension>} [options.extensions] - WebGL extensions.
   * @param {String} [options.vertexShader=null] - The vertex shader. Most effects don't need one.
   */ constructor(name, fragmentShader, { attributes: attributes = $fe721963ebf18f1b$export$a72ebb312f9e05c6.NONE, blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.NORMAL, defines: defines = /* @__PURE__ */ new Map(), uniforms: uniforms = /* @__PURE__ */ new Map(), extensions: extensions = null, vertexShader: vertexShader = null } = {}){
        super();
        this.name = name;
        this.renderer = null;
        this.attributes = attributes;
        this.fragmentShader = fragmentShader;
        this.vertexShader = vertexShader;
        this.defines = defines;
        this.uniforms = uniforms;
        this.extensions = extensions;
        this.blendMode = new $fe721963ebf18f1b$export$c9b8fe72ac71821(blendFunction);
        this.blendMode.addEventListener("change", (event)=>this.setChanged());
        this._inputColorSpace = (0, $ilwiq.LinearSRGBColorSpace);
        this._outputColorSpace = (0, $ilwiq.NoColorSpace);
    }
    /**
   * The input color space.
   *
   * @type {ColorSpace}
   * @experimental
   */ get inputColorSpace() {
        return this._inputColorSpace;
    }
    /**
   * @type {ColorSpace}
   * @protected
   * @experimental
   */ set inputColorSpace(value) {
        this._inputColorSpace = value;
        this.setChanged();
    }
    /**
   * The output color space.
   *
   * Should only be changed if this effect converts the input colors to a different color space.
   *
   * @type {ColorSpace}
   * @experimental
   */ get outputColorSpace() {
        return this._outputColorSpace;
    }
    /**
   * @type {ColorSpace}
   * @protected
   * @experimental
   */ set outputColorSpace(value) {
        this._outputColorSpace = value;
        this.setChanged();
    }
    /**
   * Sets the main scene.
   *
   * @type {Scene}
   */ set mainScene(value) {}
    /**
   * Sets the main camera.
   *
   * @type {Camera}
   */ set mainCamera(value) {}
    /**
   * Returns the name of this effect.
   *
   * @deprecated Use name instead.
   * @return {String} The name.
   */ getName() {
        return this.name;
    }
    /**
   * Sets the renderer.
   *
   * @deprecated
   * @param {WebGLRenderer} renderer - The renderer.
   */ setRenderer(renderer) {
        this.renderer = renderer;
    }
    /**
   * Returns the preprocessor macro definitions.
   *
   * @deprecated Use defines instead.
   * @return {Map<String, String>} The extensions.
   */ getDefines() {
        return this.defines;
    }
    /**
   * Returns the uniforms of this effect.
   *
   * @deprecated Use uniforms instead.
   * @return {Map<String, Uniform>} The extensions.
   */ getUniforms() {
        return this.uniforms;
    }
    /**
   * Returns the WebGL extensions that are required by this effect.
   *
   * @deprecated Use extensions instead.
   * @return {Set<WebGLExtension>} The extensions.
   */ getExtensions() {
        return this.extensions;
    }
    /**
   * Returns the blend mode.
   *
   * The result of this effect will be blended with the result of the previous effect using this blend mode.
   *
   * @deprecated Use blendMode instead.
   * @return {BlendMode} The blend mode.
   */ getBlendMode() {
        return this.blendMode;
    }
    /**
   * Returns the effect attributes.
   *
   * @return {EffectAttribute} The attributes.
   */ getAttributes() {
        return this.attributes;
    }
    /**
   * Sets the effect attributes.
   *
   * Effects that have the same attributes will be executed in the order in which they were registered. Some attributes
   * imply a higher priority.
   *
   * @protected
   * @param {EffectAttribute} attributes - The attributes.
   */ setAttributes(attributes) {
        this.attributes = attributes;
        this.setChanged();
    }
    /**
   * Returns the fragment shader.
   *
   * @return {String} The fragment shader.
   */ getFragmentShader() {
        return this.fragmentShader;
    }
    /**
   * Sets the fragment shader.
   *
   * @protected
   * @param {String} fragmentShader - The fragment shader.
   */ setFragmentShader(fragmentShader) {
        this.fragmentShader = fragmentShader;
        this.setChanged();
    }
    /**
   * Returns the vertex shader.
   *
   * @return {String} The vertex shader.
   */ getVertexShader() {
        return this.vertexShader;
    }
    /**
   * Sets the vertex shader.
   *
   * @protected
   * @param {String} vertexShader - The vertex shader.
   */ setVertexShader(vertexShader) {
        this.vertexShader = vertexShader;
        this.setChanged();
    }
    /**
   * Informs the associated {@link EffectPass} that this effect requires a shader recompilation.
   *
   * Should be called after changing macros or extensions and after adding/removing uniforms.
   *
   * @protected
   */ setChanged() {
        this.dispatchEvent({
            type: "change"
        });
    }
    /**
   * Sets the depth texture.
   *
   * You may override this method if your effect requires direct access to the depth texture that is bound to the
   * associated {@link EffectPass}.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {}
    /**
   * Updates this effect by performing supporting operations.
   *
   * This method is called by the {@link EffectPass} right before the main fullscreen render operation, even if the
   * blend function is set to `SKIP`.
   *
   * You may override this method if you need to update custom uniforms or render additional off-screen textures.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {}
    /**
   * Updates the size of this effect.
   *
   * You may override this method if you want to be informed about the size of the backbuffer/canvas.
   * This method is called before {@link initialize} and every time the size of the {@link EffectComposer} changes.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {}
    /**
   * Performs initialization tasks.
   *
   * This method is called when the associated {@link EffectPass} is added to an {@link EffectComposer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   * @example if(!alpha && frameBufferType === UnsignedByteType) { this.myRenderTarget.texture.format = RGBFormat; }
   */ initialize(renderer, alpha, frameBufferType) {}
    /**
   * Performs a shallow search for properties that define a dispose method and deletes them.
   *
   * The {@link EffectComposer} calls this method when it is being destroyed.
   */ dispose() {
        for (const key of Object.keys(this)){
            const property = this[key];
            const isDisposable = property instanceof (0, $ilwiq.WebGLRenderTarget) || property instanceof (0, $ilwiq.Material) || property instanceof (0, $ilwiq.Texture) || property instanceof $fe721963ebf18f1b$export$802bc10488da99c7;
            if (isDisposable) this[key].dispose();
        }
    }
};
// src/effects/glsl/bloom.frag
var $fe721963ebf18f1b$var$bloom_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D map;\n#else\nuniform lowp sampler2D map;\n#endif\nuniform float intensity;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 texel=texture2D(map,uv);outputColor=vec4(texel.rgb*intensity,texel.a);}";
// src/effects/BloomEffect.js
var $fe721963ebf18f1b$export$1e2a1743038c77d5 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new bloom effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function of this effect.
   * @param {Number} [options.luminanceThreshold=0.9] - The luminance threshold. Raise this value to mask out darker elements in the scene.
   * @param {Number} [options.luminanceSmoothing=0.025] - Controls the smoothness of the luminance threshold.
   * @param {Boolean} [options.mipmapBlur=false] - Enables or disables mipmap blur.
   * @param {Number} [options.intensity=1.0] - The bloom intensity.
   * @param {Number} [options.radius=0.85] - The blur radius. Only applies to mipmap blur.
   * @param {Number} [options.levels=8] - The amount of MIP levels. Only applies to mipmap blur.
   * @param {KernelSize} [options.kernelSize=KernelSize.LARGE] - Deprecated. Use mipmapBlur instead.
   * @param {Number} [options.resolutionScale=0.5] - Deprecated. Use mipmapBlur instead.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SCREEN, luminanceThreshold: luminanceThreshold = 0.9, luminanceSmoothing: luminanceSmoothing = 0.025, mipmapBlur: mipmapBlur = false, intensity: intensity = 1, radius: radius = 0.85, levels: levels = 8, kernelSize: kernelSize = $fe721963ebf18f1b$export$543b1e4815577d06.LARGE, resolutionScale: resolutionScale = 0.5, width: width = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, height: height = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("BloomEffect", $fe721963ebf18f1b$var$bloom_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "map",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "intensity",
                    new (0, $ilwiq.Uniform)(intensity)
                ]
            ])
        });
        this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTarget.texture.name = "Bloom.Target";
        this.blurPass = new $fe721963ebf18f1b$export$657273fee9302035({
            kernelSize: kernelSize
        });
        this.luminancePass = new $fe721963ebf18f1b$export$855ea63a754bfd18({
            colorOutput: true
        });
        this.luminanceMaterial.threshold = luminanceThreshold;
        this.luminanceMaterial.smoothing = luminanceSmoothing;
        this.mipmapBlurPass = new $fe721963ebf18f1b$export$dd9496fb07a8ca00();
        this.mipmapBlurPass.enabled = mipmapBlur;
        this.mipmapBlurPass.radius = radius;
        this.mipmapBlurPass.levels = levels;
        this.uniforms.get("map").value = mipmapBlur ? this.mipmapBlurPass.texture : this.renderTarget.texture;
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    /**
   * A texture that contains the intermediate result of this effect.
   *
   * @type {Texture}
   */ get texture() {
        return this.mipmapBlurPass.enabled ? this.mipmapBlurPass.texture : this.renderTarget.texture;
    }
    /**
   * Returns the generated bloom texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.texture;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Returns the blur pass.
   *
   * @deprecated
   * @return {KawaseBlurPass} The blur pass.
   */ getBlurPass() {
        return this.blurPass;
    }
    /**
   * Returns the luminance pass.
   *
   * @deprecated Use luminancePass instead.
   * @return {LuminancePass} The luminance pass.
   */ getLuminancePass() {
        return this.luminancePass;
    }
    /**
   * The luminance material.
   *
   * @type {LuminanceMaterial}
   */ get luminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    /**
   * Returns the luminance material.
   *
   * @deprecated Use luminanceMaterial instead.
   * @return {LuminanceMaterial} The material.
   */ getLuminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    /**
   * The current width of the internal render targets.
   *
   * @type {Number}
   * @deprecated
   */ get width() {
        return this.resolution.width;
    }
    set width(value) {
        this.resolution.preferredWidth = value;
    }
    /**
   * The current height of the internal render targets.
   *
   * @type {Number}
   * @deprecated
   */ get height() {
        return this.resolution.height;
    }
    set height(value) {
        this.resolution.preferredHeight = value;
    }
    /**
   * Indicates whether dithering is enabled.
   *
   * @type {Boolean}
   * @deprecated Use EffectPass.dithering instead.
   */ get dithering() {
        return this.blurPass.dithering;
    }
    set dithering(value) {
        this.blurPass.dithering = value;
    }
    /**
   * The blur kernel size.
   *
   * @type {KernelSize}
   * @deprecated
   */ get kernelSize() {
        return this.blurPass.kernelSize;
    }
    set kernelSize(value) {
        this.blurPass.kernelSize = value;
    }
    /**
   * @type {Number}
   * @deprecated
   */ get distinction() {
        console.warn(this.name, "distinction was removed");
        return 1;
    }
    set distinction(value) {
        console.warn(this.name, "distinction was removed");
    }
    /**
   * The bloom intensity.
   *
   * @type {Number}
   */ get intensity() {
        return this.uniforms.get("intensity").value;
    }
    set intensity(value) {
        this.uniforms.get("intensity").value = value;
    }
    /**
   * The bloom intensity.
   *
   * @deprecated Use intensity instead.
   * @return {Number} The intensity.
   */ getIntensity() {
        return this.intensity;
    }
    /**
   * Sets the bloom intensity.
   *
   * @deprecated Use intensity instead.
   * @param {Number} value - The intensity.
   */ setIntensity(value) {
        this.intensity = value;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const renderTarget = this.renderTarget;
        const luminancePass = this.luminancePass;
        if (luminancePass.enabled) {
            luminancePass.render(renderer, inputBuffer);
            if (this.mipmapBlurPass.enabled) this.mipmapBlurPass.render(renderer, luminancePass.renderTarget);
            else this.blurPass.render(renderer, luminancePass.renderTarget, renderTarget);
        } else if (this.mipmapBlurPass.enabled) this.mipmapBlurPass.render(renderer, inputBuffer);
        else this.blurPass.render(renderer, inputBuffer, renderTarget);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
        this.blurPass.resolution.copy(resolution);
        this.luminancePass.setSize(width, height);
        this.mipmapBlurPass.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.blurPass.initialize(renderer, alpha, frameBufferType);
        this.luminancePass.initialize(renderer, alpha, frameBufferType);
        this.mipmapBlurPass.initialize(renderer, alpha, frameBufferType);
        if (frameBufferType !== void 0) {
            this.renderTarget.texture.type = frameBufferType;
            if (renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) this.renderTarget.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
        }
    }
};
// src/effects/glsl/bokeh.frag
var $fe721963ebf18f1b$var$bokeh_default = "uniform float focus;uniform float dof;uniform float aperture;uniform float maxBlur;void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){vec2 aspectCorrection=vec2(1.0,aspect);\n#ifdef PERSPECTIVE_CAMERA\nfloat viewZ=perspectiveDepthToViewZ(depth,cameraNear,cameraFar);float linearDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);\n#else\nfloat linearDepth=depth;\n#endif\nfloat focusNear=clamp(focus-dof,0.0,1.0);float focusFar=clamp(focus+dof,0.0,1.0);float low=step(linearDepth,focusNear);float high=step(focusFar,linearDepth);float factor=(linearDepth-focusNear)*low+(linearDepth-focusFar)*high;vec2 dofBlur=vec2(clamp(factor*aperture,-maxBlur,maxBlur));vec2 dofblur9=dofBlur*0.9;vec2 dofblur7=dofBlur*0.7;vec2 dofblur4=dofBlur*0.4;vec4 color=inputColor;color+=texture2D(inputBuffer,uv+(vec2(0.0,0.4)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.15,0.37)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.29,0.29)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.37,0.15)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.40,0.0)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.37,-0.15)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.29,-0.29)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.15,-0.37)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.0,-0.4)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.15,0.37)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.29,0.29)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.37,0.15)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.4,0.0)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.37,-0.15)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.29,-0.29)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.15,-0.37)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.15,0.37)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(-0.37,0.15)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(0.37,-0.15)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(-0.15,-0.37)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(-0.15,0.37)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(0.37,0.15)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(-0.37,-0.15)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(0.15,-0.37)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(0.29,0.29)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(0.40,0.0)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(0.29,-0.29)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(0.0,-0.4)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(-0.29,0.29)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(-0.4,0.0)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(-0.29,-0.29)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(0.0,0.4)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(0.29,0.29)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(0.4,0.0)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(0.29,-0.29)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(0.0,-0.4)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(-0.29,0.29)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(-0.4,0.0)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(-0.29,-0.29)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(0.0,0.4)*aspectCorrection)*dofblur4);outputColor=color/41.0;}";
// src/effects/BokehEffect.js
var $fe721963ebf18f1b$export$39a5b8c6d088825c = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new bokeh effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.focus=0.5] - The focus distance ratio, ranging from 0.0 to 1.0.
   * @param {Number} [options.dof=0.02] - Depth of field. An area in front of and behind the focal point that still appears sharp.
   * @param {Number} [options.aperture=0.015] - Camera aperture scale. Bigger values for stronger blur and shallower depth of field.
   * @param {Number} [options.maxBlur=1.0] - The maximum blur strength.
   */ constructor({ blendFunction: blendFunction, focus: focus = 0.5, dof: dof = 0.02, aperture: aperture = 0.015, maxBlur: maxBlur = 1 } = {}){
        super("BokehEffect", $fe721963ebf18f1b$var$bokeh_default, {
            blendFunction: blendFunction,
            attributes: $fe721963ebf18f1b$export$a72ebb312f9e05c6.CONVOLUTION | $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "focus",
                    new (0, $ilwiq.Uniform)(focus)
                ],
                [
                    "dof",
                    new (0, $ilwiq.Uniform)(dof)
                ],
                [
                    "aperture",
                    new (0, $ilwiq.Uniform)(aperture)
                ],
                [
                    "maxBlur",
                    new (0, $ilwiq.Uniform)(maxBlur)
                ]
            ])
        });
    }
};
// src/effects/glsl/brightness-contrast.frag
var $fe721963ebf18f1b$var$brightness_contrast_default = "uniform float brightness;uniform float contrast;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=inputColor.rgb+vec3(brightness-0.5);if(contrast>0.0){color/=vec3(1.0-contrast);}else{color*=vec3(1.0+contrast);}outputColor=vec4(color+vec3(0.5),inputColor.a);}";
// src/effects/BrightnessContrastEffect.js
var $fe721963ebf18f1b$export$35667687ce6e9ce = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new brightness/contrast effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Number} [options.brightness=0.0] - The brightness factor, ranging from -1 to 1, where 0 means no change.
   * @param {Number} [options.contrast=0.0] - The contrast factor, ranging from -1 to 1, where 0 means no change.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SRC, brightness: brightness = 0, contrast: contrast = 0 } = {}){
        super("BrightnessContrastEffect", $fe721963ebf18f1b$var$brightness_contrast_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "brightness",
                    new (0, $ilwiq.Uniform)(brightness)
                ],
                [
                    "contrast",
                    new (0, $ilwiq.Uniform)(contrast)
                ]
            ])
        });
        this.inputColorSpace = (0, $ilwiq.SRGBColorSpace);
    }
    /**
   * The brightness.
   *
   * @type {Number}
   */ get brightness() {
        return this.uniforms.get("brightness").value;
    }
    set brightness(value) {
        this.uniforms.get("brightness").value = value;
    }
    /**
   * Returns the brightness.
   *
   * @deprecated Use brightness instead.
   * @return {Number} The brightness.
   */ getBrightness() {
        return this.brightness;
    }
    /**
   * Sets the brightness.
   *
   * @deprecated Use brightness instead.
   * @param {Number} value - The brightness.
   */ setBrightness(value) {
        this.brightness = value;
    }
    /**
   * The contrast.
   *
   * @type {Number}
   */ get contrast() {
        return this.uniforms.get("contrast").value;
    }
    set contrast(value) {
        this.uniforms.get("contrast").value = value;
    }
    /**
   * Returns the contrast.
   *
   * @deprecated Use contrast instead.
   * @return {Number} The contrast.
   */ getContrast() {
        return this.contrast;
    }
    /**
   * Sets the contrast.
   *
   * @deprecated Use contrast instead.
   * @param {Number} value - The contrast.
   */ setContrast(value) {
        this.contrast = value;
    }
};
// src/effects/glsl/color-average.frag
var $fe721963ebf18f1b$var$color_average_default = "void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=vec4(vec3(average(inputColor.rgb)),inputColor.a);}";
// src/effects/ColorAverageEffect.js
var $fe721963ebf18f1b$export$562d7192c2de1170 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new color average effect.
   *
   * @param {BlendFunction} [blendFunction] - The blend function of this effect.
   */ constructor(blendFunction){
        super("ColorAverageEffect", $fe721963ebf18f1b$var$color_average_default, {
            blendFunction: blendFunction
        });
    }
};
// src/effects/glsl/color-depth.frag
var $fe721963ebf18f1b$var$color_depth_default = "uniform float factor;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=vec4(floor(inputColor.rgb*factor+0.5)/factor,inputColor.a);}";
// src/effects/ColorDepthEffect.js
var $fe721963ebf18f1b$export$3520bcefece76c80 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new color depth effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.bits=16] - The color bit depth.
   */ constructor({ blendFunction: blendFunction, bits: bits = 16 } = {}){
        super("ColorDepthEffect", $fe721963ebf18f1b$var$color_depth_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "factor",
                    new (0, $ilwiq.Uniform)(1)
                ]
            ])
        });
        this.bits = 0;
        this.bitDepth = bits;
    }
    /**
   * The virtual amount of color bits.
   *
   * Each color channel effectively uses a fourth of the total amount of bits. Alpha remains unaffected.
   *
   * @type {Number}
   */ get bitDepth() {
        return this.bits;
    }
    set bitDepth(value) {
        this.bits = value;
        this.uniforms.get("factor").value = Math.pow(2, value / 3);
    }
    /**
   * Returns the current color bit depth.
   *
   * @return {Number} The bit depth.
   */ getBitDepth() {
        return this.bitDepth;
    }
    /**
   * Sets the virtual amount of color bits.
   *
   * @param {Number} value - The bit depth.
   */ setBitDepth(value) {
        this.bitDepth = value;
    }
};
// src/effects/glsl/chromatic-aberration.frag
var $fe721963ebf18f1b$var$chromatic_aberration_default = "#ifdef RADIAL_MODULATION\nuniform float modulationOffset;\n#endif\nvarying float vActive;varying vec2 vUvR;varying vec2 vUvB;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 ra=inputColor.ra;vec2 ba=inputColor.ba;\n#ifdef RADIAL_MODULATION\nconst vec2 center=vec2(0.5);float d=distance(uv,center)*2.0;d=max(d-modulationOffset,0.0);if(vActive>0.0&&d>0.0){ra=texture2D(inputBuffer,mix(uv,vUvR,d)).ra;ba=texture2D(inputBuffer,mix(uv,vUvB,d)).ba;}\n#else\nif(vActive>0.0){ra=texture2D(inputBuffer,vUvR).ra;ba=texture2D(inputBuffer,vUvB).ba;}\n#endif\noutputColor=vec4(ra.x,inputColor.g,ba.x,max(max(ra.y,ba.y),inputColor.a));}";
// src/effects/glsl/chromatic-aberration.vert
var $fe721963ebf18f1b$var$chromatic_aberration_default2 = "uniform vec2 offset;varying float vActive;varying vec2 vUvR;varying vec2 vUvB;void mainSupport(const in vec2 uv){vec2 shift=offset*vec2(1.0,aspect);vActive=(shift.x!=0.0||shift.y!=0.0)?1.0:0.0;vUvR=uv+shift;vUvB=uv-shift;}";
// src/effects/ChromaticAberrationEffect.js
var $fe721963ebf18f1b$export$5d827f77057feeb7 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new chromatic aberration effect.
   *
   * @param {Object} [options] - The options.
   * @param {Vector2} [options.offset] - The color offset.
   * @param {Boolean} [options.radialModulation=false] - Whether the effect should be modulated with a radial gradient.
   * @param {Number} [options.modulationOffset=0.15] - The modulation offset. Only applies if `radialModulation` is enabled.
   */ constructor({ offset: offset = new (0, $ilwiq.Vector2)(1e-3, 5e-4), radialModulation: radialModulation = false, modulationOffset: modulationOffset = 0.15 } = {}){
        super("ChromaticAberrationEffect", $fe721963ebf18f1b$var$chromatic_aberration_default, {
            vertexShader: $fe721963ebf18f1b$var$chromatic_aberration_default2,
            attributes: $fe721963ebf18f1b$export$a72ebb312f9e05c6.CONVOLUTION,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "offset",
                    new (0, $ilwiq.Uniform)(offset)
                ],
                [
                    "modulationOffset",
                    new (0, $ilwiq.Uniform)(modulationOffset)
                ]
            ])
        });
        this.radialModulation = radialModulation;
    }
    /**
   * The color offset.
   *
   * @type {Vector2}
   */ get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(value) {
        this.uniforms.get("offset").value = value;
    }
    /**
   * Indicates whether radial modulation is enabled.
   *
   * When enabled, the effect will be weaker in the middle and stronger towards the screen edges.
   *
   * @type {Boolean}
   */ get radialModulation() {
        return this.defines.has("RADIAL_MODULATION");
    }
    set radialModulation(value) {
        if (value) this.defines.set("RADIAL_MODULATION", "1");
        else this.defines.delete("RADIAL_MODULATION");
        this.setChanged();
    }
    /**
   * The modulation offset.
   *
   * @type {Number}
   */ get modulationOffset() {
        return this.uniforms.get("modulationOffset").value;
    }
    set modulationOffset(value) {
        this.uniforms.get("modulationOffset").value = value;
    }
    /**
   * Returns the color offset vector.
   *
   * @deprecated Use offset instead.
   * @return {Vector2} The offset.
   */ getOffset() {
        return this.offset;
    }
    /**
   * Sets the color offset vector.
   *
   * @deprecated Use offset instead.
   * @param {Vector2} value - The offset.
   */ setOffset(value) {
        this.offset = value;
    }
};
// src/effects/glsl/depth.frag
var $fe721963ebf18f1b$var$depth_default = "void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){\n#ifdef INVERTED\nvec3 color=vec3(1.0-depth);\n#else\nvec3 color=vec3(depth);\n#endif\noutputColor=vec4(color,inputColor.a);}";
// src/effects/DepthEffect.js
var $fe721963ebf18f1b$export$616b524125abf15a = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new depth effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Boolean} [options.inverted=false] - Whether the depth should be inverted.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SRC, inverted: inverted = false } = {}){
        super("DepthEffect", $fe721963ebf18f1b$var$depth_default, {
            blendFunction: blendFunction,
            attributes: $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH
        });
        this.inverted = inverted;
    }
    /**
   * Indicates whether depth should be inverted.
   *
   * @type {Boolean}
   */ get inverted() {
        return this.defines.has("INVERTED");
    }
    set inverted(value) {
        if (this.inverted !== value) {
            if (value) this.defines.set("INVERTED", "1");
            else this.defines.delete("INVERTED");
            this.setChanged();
        }
    }
    /**
   * Indicates whether the rendered depth is inverted.
   *
   * @deprecated Use inverted instead.
   * @return {Boolean} Whether the rendered depth is inverted.
   */ isInverted() {
        return this.inverted;
    }
    /**
   * Enables or disables depth inversion.
   *
   * @deprecated Use inverted instead.
   * @param {Boolean} value - Whether depth should be inverted.
   */ setInverted(value) {
        this.inverted = value;
    }
};
// src/enums/ColorChannel.js
var $fe721963ebf18f1b$export$e8b1230a2d7ba080 = {
    RED: 0,
    GREEN: 1,
    BLUE: 2,
    ALPHA: 3
};
// src/enums/MaskFunction.js
var $fe721963ebf18f1b$export$5dd4eee9fb245df8 = {
    DISCARD: 0,
    MULTIPLY: 1,
    MULTIPLY_RGB_SET_ALPHA: 2,
    MULTIPLY_RGB: 3
};
// src/materials/glsl/convolution.bokeh.frag
var $fe721963ebf18f1b$var$convolution_bokeh_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\n#if PASS == 1\nuniform vec4 kernel64[32];\n#else\nuniform vec4 kernel16[8];\n#endif\nuniform lowp sampler2D cocBuffer;uniform vec2 texelSize;uniform float scale;varying vec2 vUv;void main(){\n#ifdef FOREGROUND\nvec2 cocNearFar=texture2D(cocBuffer,vUv).rg*scale;float coc=cocNearFar.x;\n#else\nfloat coc=texture2D(cocBuffer,vUv).g*scale;\n#endif\nif(coc==0.0){gl_FragColor=texture2D(inputBuffer,vUv);}else{\n#ifdef FOREGROUND\nvec2 step=texelSize*max(cocNearFar.x,cocNearFar.y);\n#else\nvec2 step=texelSize*coc;\n#endif\n#if PASS == 1\nvec4 acc=vec4(0.0);for(int i=0;i<32;++i){vec4 kernel=kernel64[i];vec2 uv=step*kernel.xy+vUv;acc+=texture2D(inputBuffer,uv);uv=step*kernel.zw+vUv;acc+=texture2D(inputBuffer,uv);}gl_FragColor=acc/64.0;\n#else\nvec4 maxValue=texture2D(inputBuffer,vUv);for(int i=0;i<8;++i){vec4 kernel=kernel16[i];vec2 uv=step*kernel.xy+vUv;maxValue=max(texture2D(inputBuffer,uv),maxValue);uv=step*kernel.zw+vUv;maxValue=max(texture2D(inputBuffer,uv),maxValue);}gl_FragColor=maxValue;\n#endif\n}}";
// src/materials/BokehMaterial.js
var $fe721963ebf18f1b$export$89e69b0a1c55abba = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new bokeh material.
   *
   * @param {Boolean} [fill=false] - Enables or disables the bokeh highlight fill mode.
   * @param {Boolean} [foreground=false] - Determines whether this material will be applied to foreground colors.
   */ constructor(fill = false, foreground = false){
        super({
            name: "BokehMaterial",
            defines: {
                PASS: fill ? "2" : "1"
            },
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                cocBuffer: new (0, $ilwiq.Uniform)(null),
                texelSize: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                kernel64: new (0, $ilwiq.Uniform)(null),
                kernel16: new (0, $ilwiq.Uniform)(null),
                scale: new (0, $ilwiq.Uniform)(1)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$convolution_bokeh_default,
            vertexShader: $fe721963ebf18f1b$var$common_default
        });
        if (foreground) this.defines.FOREGROUND = "1";
        this.generateKernel();
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The circle of confusion buffer.
   *
   * @type {Texture}
   */ set cocBuffer(value) {
        this.uniforms.cocBuffer.value = value;
    }
    /**
   * Sets the circle of confusion buffer.
   *
   * @deprecated Use cocBuffer instead.
   * @param {Texture} value - The buffer.
   */ setCoCBuffer(value) {
        this.uniforms.cocBuffer.value = value;
    }
    /**
   * The blur scale.
   *
   * @type {Number}
   */ get scale() {
        return this.uniforms.scale.value;
    }
    set scale(value) {
        this.uniforms.scale.value = value;
    }
    /**
   * Returns the blur scale.
   *
   * @deprecated Use scale instead.
   * @return {Number} The scale.
   */ getScale(value) {
        return this.scale;
    }
    /**
   * Sets the blur scale.
   *
   * @deprecated Use scale instead.
   * @param {Number} value - The scale.
   */ setScale(value) {
        this.scale = value;
    }
    /**
   * Generates the blur kernel.
   *
   * @private
   */ generateKernel() {
        const GOLDEN_ANGLE = 2.39996323;
        const points64 = new Float64Array(128);
        const points16 = new Float64Array(32);
        let i64 = 0, i16 = 0;
        for(let i = 0, sqrt80 = Math.sqrt(80); i < 80; ++i){
            const theta = i * GOLDEN_ANGLE;
            const r = Math.sqrt(i) / sqrt80;
            const u = r * Math.cos(theta), v3 = r * Math.sin(theta);
            if (i % 5 === 0) {
                points16[i16++] = u;
                points16[i16++] = v3;
            } else {
                points64[i64++] = u;
                points64[i64++] = v3;
            }
        }
        this.uniforms.kernel64.value = points64;
        this.uniforms.kernel16.value = points16;
    }
    /**
   * Sets the texel size.
   *
   * @deprecated Use setSize() instead.
   * @param {Number} x - The texel width.
   * @param {Number} y - The texel height.
   */ setTexelSize(x, y) {
        this.uniforms.texelSize.value.set(x, y);
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/utils/orthographicDepthToViewZ.js
function $fe721963ebf18f1b$var$orthographicDepthToViewZ(depth, near, far) {
    return depth * (near - far) - near;
}
// src/utils/viewZToOrthographicDepth.js
function $fe721963ebf18f1b$var$viewZToOrthographicDepth(viewZ, near, far) {
    return Math.min(Math.max((viewZ + near) / (near - far), 0), 1);
}
// src/materials/glsl/circle-of-confusion.frag
var $fe721963ebf18f1b$var$circle_of_confusion_default = "#include <common>\n#include <packing>\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D depthBuffer;\n#else\nuniform mediump sampler2D depthBuffer;\n#endif\nuniform float focusDistance;uniform float focusRange;uniform float cameraNear;uniform float cameraFar;varying vec2 vUv;float readDepth(const in vec2 uv){\n#if DEPTH_PACKING == 3201\nfloat depth=unpackRGBAToDepth(texture2D(depthBuffer,uv));\n#else\nfloat depth=texture2D(depthBuffer,uv).r;\n#endif\n#ifdef LOG_DEPTH\nfloat d=pow(2.0,depth*log2(cameraFar+1.0))-1.0;float a=cameraFar/(cameraFar-cameraNear);float b=cameraFar*cameraNear/(cameraNear-cameraFar);depth=a+b/d;\n#endif\nreturn depth;}void main(){float depth=readDepth(vUv);\n#ifdef PERSPECTIVE_CAMERA\nfloat viewZ=perspectiveDepthToViewZ(depth,cameraNear,cameraFar);float linearDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);\n#else\nfloat linearDepth=depth;\n#endif\nfloat signedDistance=linearDepth-focusDistance;float magnitude=smoothstep(0.0,focusRange,abs(signedDistance));gl_FragColor.rg=magnitude*vec2(step(signedDistance,0.0),step(0.0,signedDistance));}";
// src/materials/CircleOfConfusionMaterial.js
var $fe721963ebf18f1b$export$bea4e5c7bd31291c = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new CoC material.
   *
   * @param {Camera} camera - A camera.
   */ constructor(camera){
        super({
            name: "CircleOfConfusionMaterial",
            defines: {
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new (0, $ilwiq.Uniform)(null),
                focusDistance: new (0, $ilwiq.Uniform)(0),
                focusRange: new (0, $ilwiq.Uniform)(0),
                cameraNear: new (0, $ilwiq.Uniform)(0.3),
                cameraFar: new (0, $ilwiq.Uniform)(1e3)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$circle_of_confusion_default,
            vertexShader: $fe721963ebf18f1b$var$common_default
        });
        this.uniforms.focalLength = this.uniforms.focusRange;
        this.copyCameraSettings(camera);
    }
    /**
   * The current near plane setting.
   *
   * @type {Number}
   * @private
   */ get near() {
        return this.uniforms.cameraNear.value;
    }
    /**
   * The current far plane setting.
   *
   * @type {Number}
   * @private
   */ get far() {
        return this.uniforms.cameraFar.value;
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * The focus distance. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get focusDistance() {
        return this.uniforms.focusDistance.value;
    }
    set focusDistance(value) {
        this.uniforms.focusDistance.value = value;
    }
    /**
   * The focus distance in world units.
   *
   * @type {Number}
   */ get worldFocusDistance() {
        return -$fe721963ebf18f1b$var$orthographicDepthToViewZ(this.focusDistance, this.near, this.far);
    }
    set worldFocusDistance(value) {
        this.focusDistance = $fe721963ebf18f1b$var$viewZToOrthographicDepth(-value, this.near, this.far);
    }
    /**
   * Returns the focus distance.
   *
   * @deprecated Use focusDistance instead.
   * @return {Number} The focus distance.
   */ getFocusDistance(value) {
        this.uniforms.focusDistance.value = value;
    }
    /**
   * Sets the focus distance.
   *
   * @deprecated Use focusDistance instead.
   * @param {Number} value - The focus distance.
   */ setFocusDistance(value) {
        this.uniforms.focusDistance.value = value;
    }
    /**
   * The focal length.
   *
   * @deprecated Renamed to focusRange.
   * @type {Number}
   */ get focalLength() {
        return this.focusRange;
    }
    set focalLength(value) {
        this.focusRange = value;
    }
    /**
   * The focus range. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get focusRange() {
        return this.uniforms.focusRange.value;
    }
    set focusRange(value) {
        this.uniforms.focusRange.value = value;
    }
    /**
   * The focus range in world units.
   *
   * @type {Number}
   */ get worldFocusRange() {
        return -$fe721963ebf18f1b$var$orthographicDepthToViewZ(this.focusRange, this.near, this.far);
    }
    set worldFocusRange(value) {
        this.focusRange = $fe721963ebf18f1b$var$viewZToOrthographicDepth(-value, this.near, this.far);
    }
    /**
   * Returns the focal length.
   *
   * @deprecated Use focusRange instead.
   * @return {Number} The focal length.
   */ getFocalLength(value) {
        return this.focusRange;
    }
    /**
   * Sets the focal length.
   *
   * @deprecated Use focusRange instead.
   * @param {Number} value - The focal length.
   */ setFocalLength(value) {
        this.focusRange = value;
    }
    /**
   * Copies the settings of the given camera.
   *
   * @deprecated Use copyCameraSettings instead.
   * @param {Camera} camera - A camera.
   */ adoptCameraSettings(camera) {
        this.copyCameraSettings(camera);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNear.value = camera.near;
            this.uniforms.cameraFar.value = camera.far;
            if (camera instanceof (0, $ilwiq.PerspectiveCamera)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
};
// src/materials/glsl/mask.frag
var $fe721963ebf18f1b$var$mask_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\n#ifdef MASK_PRECISION_HIGH\nuniform mediump sampler2D maskTexture;\n#else\nuniform lowp sampler2D maskTexture;\n#endif\n#if MASK_FUNCTION != 0\nuniform float strength;\n#endif\nvarying vec2 vUv;void main(){\n#if COLOR_CHANNEL == 0\nfloat mask=texture2D(maskTexture,vUv).r;\n#elif COLOR_CHANNEL == 1\nfloat mask=texture2D(maskTexture,vUv).g;\n#elif COLOR_CHANNEL == 2\nfloat mask=texture2D(maskTexture,vUv).b;\n#else\nfloat mask=texture2D(maskTexture,vUv).a;\n#endif\n#if MASK_FUNCTION == 0\n#ifdef INVERTED\nmask=step(mask,0.0);\n#else\nmask=1.0-step(mask,0.0);\n#endif\n#else\nmask=clamp(mask*strength,0.0,1.0);\n#ifdef INVERTED\nmask=1.0-mask;\n#endif\n#endif\n#if MASK_FUNCTION == 3\nvec4 texel=texture2D(inputBuffer,vUv);gl_FragColor=vec4(mask*texel.rgb,texel.a);\n#elif MASK_FUNCTION == 2\ngl_FragColor=vec4(mask*texture2D(inputBuffer,vUv).rgb,mask);\n#else\ngl_FragColor=mask*texture2D(inputBuffer,vUv);\n#endif\n}";
// src/materials/MaskMaterial.js
var $fe721963ebf18f1b$export$ba47b73346a33bfc = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new mask material.
   *
   * @param {Texture} [maskTexture] - The mask texture.
   */ constructor(maskTexture = null){
        super({
            name: "MaskMaterial",
            uniforms: {
                maskTexture: new (0, $ilwiq.Uniform)(maskTexture),
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                strength: new (0, $ilwiq.Uniform)(1)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$mask_default,
            vertexShader: $fe721963ebf18f1b$var$common_default
        });
        this.colorChannel = $fe721963ebf18f1b$export$e8b1230a2d7ba080.RED;
        this.maskFunction = $fe721963ebf18f1b$export$5dd4eee9fb245df8.DISCARD;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The mask texture.
   *
   * @type {Texture}
   */ set maskTexture(value) {
        this.uniforms.maskTexture.value = value;
        delete this.defines.MASK_PRECISION_HIGH;
        if (value.type !== (0, $ilwiq.UnsignedByteType)) this.defines.MASK_PRECISION_HIGH = "1";
        this.needsUpdate = true;
    }
    /**
   * Sets the mask texture.
   *
   * @deprecated Use maskTexture instead.
   * @param {Texture} value - The texture.
   */ setMaskTexture(value) {
        this.maskTexture = value;
    }
    /**
   * Sets the color channel to use for masking. Default is `ColorChannel.RED`.
   *
   * @type {ColorChannel}
   */ set colorChannel(value) {
        this.defines.COLOR_CHANNEL = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the color channel to use for masking. Default is `ColorChannel.RED`.
   *
   * @deprecated Use colorChannel instead.
   * @param {ColorChannel} value - The channel.
   */ setColorChannel(value) {
        this.colorChannel = value;
    }
    /**
   * The masking technique. Default is `MaskFunction.DISCARD`.
   *
   * @type {MaskFunction}
   */ set maskFunction(value) {
        this.defines.MASK_FUNCTION = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the masking technique. Default is `MaskFunction.DISCARD`.
   *
   * @deprecated Use maskFunction instead.
   * @param {MaskFunction} value - The function.
   */ setMaskFunction(value) {
        this.maskFunction = value;
    }
    /**
   * Indicates whether the masking is inverted.
   *
   * @type {Boolean}
   */ get inverted() {
        return this.defines.INVERTED !== void 0;
    }
    set inverted(value) {
        if (this.inverted && !value) delete this.defines.INVERTED;
        else if (value) this.defines.INVERTED = "1";
        this.needsUpdate = true;
    }
    /**
   * Indicates whether the masking is inverted.
   *
   * @deprecated Use inverted instead.
   * @return {Boolean} Whether the masking is inverted.
   */ isInverted() {
        return this.inverted;
    }
    /**
   * Determines whether the masking should be inverted.
   *
   * @deprecated Use inverted instead.
   * @param {Boolean} value - Whether the masking should be inverted.
   */ setInverted(value) {
        this.inverted = value;
    }
    /**
   * The current mask strength.
   *
   * Individual mask values will be clamped to [0.0, 1.0]. Has no effect when the mask function is set to `DISCARD`.
   *
   * @type {Number}
   */ get strength() {
        return this.uniforms.strength.value;
    }
    set strength(value) {
        this.uniforms.strength.value = value;
    }
    /**
   * Returns the current mask strength.
   *
   * @deprecated Use strength instead.
   * @return {Number} The mask strength.
   */ getStrength() {
        return this.strength;
    }
    /**
   * Sets the mask strength.
   *
   * Has no effect when the mask function is set to `DISCARD`.
   *
   * @deprecated Use strength instead.
   * @param {Number} value - The mask strength.
   */ setStrength(value) {
        this.strength = value;
    }
};
var $fe721963ebf18f1b$export$c55093fd4f9e42f0 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new shader pass.
   *
   * @param {ShaderMaterial} material - A shader material.
   * @param {String} [input="inputBuffer"] - The name of the input buffer uniform.
   */ constructor(material, input = "inputBuffer"){
        super("ShaderPass");
        this.fullscreenMaterial = material;
        this.input = input;
    }
    /**
   * Sets the name of the input buffer uniform.
   *
   * @param {String} input - The name of the input buffer uniform.
   * @deprecated Use input instead.
   */ setInput(input) {
        this.input = input;
    }
    /**
   * Renders the effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const uniforms = this.fullscreenMaterial.uniforms;
        if (inputBuffer !== null && uniforms !== void 0 && uniforms[this.input] !== void 0) uniforms[this.input].value = inputBuffer.texture;
        renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
        renderer.render(this.scene, this.camera);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - A renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0 && frameBufferType !== (0, $ilwiq.UnsignedByteType)) this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
    }
};
// src/effects/glsl/depth-of-field.frag
var $fe721963ebf18f1b$var$depth_of_field_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D nearColorBuffer;uniform mediump sampler2D farColorBuffer;\n#else\nuniform lowp sampler2D nearColorBuffer;uniform lowp sampler2D farColorBuffer;\n#endif\nuniform lowp sampler2D nearCoCBuffer;uniform lowp sampler2D farCoCBuffer;uniform float scale;void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){vec4 colorNear=texture2D(nearColorBuffer,uv);vec4 colorFar=texture2D(farColorBuffer,uv);\n#if MASK_FUNCTION == 1\nvec2 cocNearFar=vec2(texture2D(nearCoCBuffer,uv).r,colorFar.a);cocNearFar.x=min(cocNearFar.x*scale,1.0);\n#else\nvec2 cocNearFar=vec2(texture2D(nearCoCBuffer,uv).r,texture2D(farCoCBuffer,uv).g);cocNearFar=min(cocNearFar*scale,1.0);\n#endif\nvec4 result=inputColor*(1.0-cocNearFar.y)+colorFar;result=mix(result,colorNear,cocNearFar.x);outputColor=result;}";
// src/effects/DepthOfFieldEffect.js
var $fe721963ebf18f1b$export$a473b3aa72725315 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new depth of field effect.
   *
   * @param {Camera} camera - The main camera.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.worldFocusDistance] - The focus distance in world units.
   * @param {Number} [options.worldFocusRange] - The focus distance in world units.
   * @param {Number} [options.focusDistance=0.0] - The normalized focus distance. Range is [0.0, 1.0].
   * @param {Number} [options.focusRange=0.1] - The focus range. Range is [0.0, 1.0].
   * @param {Number} [options.focalLength=0.1] - Deprecated.
   * @param {Number} [options.bokehScale=1.0] - The scale of the bokeh blur.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor(camera, { blendFunction: blendFunction, worldFocusDistance: worldFocusDistance, worldFocusRange: worldFocusRange, focusDistance: focusDistance = 0, focalLength: focalLength = 0.1, focusRange: focusRange = focalLength, bokehScale: bokehScale = 1, resolutionScale: resolutionScale = 1, width: width = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, height: height = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("DepthOfFieldEffect", $fe721963ebf18f1b$var$depth_of_field_default, {
            blendFunction: blendFunction,
            attributes: $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "nearColorBuffer",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "farColorBuffer",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "nearCoCBuffer",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "farCoCBuffer",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "scale",
                    new (0, $ilwiq.Uniform)(1)
                ]
            ])
        });
        this.camera = camera;
        this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTarget.texture.name = "DoF.Intermediate";
        this.renderTargetMasked = this.renderTarget.clone();
        this.renderTargetMasked.texture.name = "DoF.Masked.Far";
        this.renderTargetNear = this.renderTarget.clone();
        this.renderTargetNear.texture.name = "DoF.Bokeh.Near";
        this.uniforms.get("nearColorBuffer").value = this.renderTargetNear.texture;
        this.renderTargetFar = this.renderTarget.clone();
        this.renderTargetFar.texture.name = "DoF.Bokeh.Far";
        this.uniforms.get("farColorBuffer").value = this.renderTargetFar.texture;
        this.renderTargetCoC = this.renderTarget.clone();
        this.renderTargetCoC.texture.name = "DoF.CoC";
        this.uniforms.get("farCoCBuffer").value = this.renderTargetCoC.texture;
        this.renderTargetCoCBlurred = this.renderTargetCoC.clone();
        this.renderTargetCoCBlurred.texture.name = "DoF.CoC.Blurred";
        this.uniforms.get("nearCoCBuffer").value = this.renderTargetCoCBlurred.texture;
        this.cocPass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$bea4e5c7bd31291c(camera));
        const cocMaterial = this.cocMaterial;
        cocMaterial.focusDistance = focusDistance;
        cocMaterial.focusRange = focusRange;
        if (worldFocusDistance !== void 0) cocMaterial.worldFocusDistance = worldFocusDistance;
        if (worldFocusRange !== void 0) cocMaterial.worldFocusRange = worldFocusRange;
        this.blurPass = new $fe721963ebf18f1b$export$657273fee9302035({
            resolutionScale: resolutionScale,
            resolutionX: resolutionX,
            resolutionY: resolutionY,
            kernelSize: $fe721963ebf18f1b$export$543b1e4815577d06.MEDIUM
        });
        this.maskPass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$ba47b73346a33bfc(this.renderTargetCoC.texture));
        const maskMaterial = this.maskPass.fullscreenMaterial;
        maskMaterial.colorChannel = $fe721963ebf18f1b$export$e8b1230a2d7ba080.GREEN;
        this.maskFunction = $fe721963ebf18f1b$export$5dd4eee9fb245df8.MULTIPLY_RGB;
        this.bokehNearBasePass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$89e69b0a1c55abba(false, true));
        this.bokehNearBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture;
        this.bokehNearFillPass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$89e69b0a1c55abba(true, true));
        this.bokehNearFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture;
        this.bokehFarBasePass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$89e69b0a1c55abba(false, false));
        this.bokehFarBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture;
        this.bokehFarFillPass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$89e69b0a1c55abba(true, false));
        this.bokehFarFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture;
        this.target = null;
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.bokehScale = bokehScale;
    }
    set mainCamera(value) {
        this.camera = value;
        this.cocMaterial.copyCameraSettings(value);
    }
    /**
   * The circle of confusion texture.
   *
   * @type {Texture}
   */ get cocTexture() {
        return this.renderTargetCoC.texture;
    }
    /**
   * The mask function. Default is `MULTIPLY_RGB`.
   *
   * @type {MaskFunction}
   */ get maskFunction() {
        return this.maskPass.fullscreenMaterial.maskFunction;
    }
    set maskFunction(value) {
        if (this.maskFunction !== value) {
            this.defines.set("MASK_FUNCTION", value.toFixed(0));
            this.maskPass.fullscreenMaterial.maskFunction = value;
            this.setChanged();
        }
    }
    /**
   * The circle of confusion material.
   *
   * @type {CircleOfConfusionMaterial}
   */ get cocMaterial() {
        return this.cocPass.fullscreenMaterial;
    }
    /**
   * The circle of confusion material.
   *
   * @deprecated Use cocMaterial instead.
   * @type {CircleOfConfusionMaterial}
   */ get circleOfConfusionMaterial() {
        return this.cocMaterial;
    }
    /**
   * Returns the circle of confusion material.
   *
   * @deprecated Use cocMaterial instead.
   * @return {CircleOfConfusionMaterial} The material.
   */ getCircleOfConfusionMaterial() {
        return this.cocMaterial;
    }
    /**
   * Returns the pass that blurs the foreground CoC buffer to soften edges.
   *
   * @deprecated Use blurPass instead.
   * @return {KawaseBlurPass} The blur pass.
   */ getBlurPass() {
        return this.blurPass;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * The current bokeh scale.
   *
   * @type {Number}
   */ get bokehScale() {
        return this.uniforms.get("scale").value;
    }
    set bokehScale(value) {
        this.bokehNearBasePass.fullscreenMaterial.scale = value;
        this.bokehNearFillPass.fullscreenMaterial.scale = value;
        this.bokehFarBasePass.fullscreenMaterial.scale = value;
        this.bokehFarFillPass.fullscreenMaterial.scale = value;
        this.maskPass.fullscreenMaterial.strength = value;
        this.uniforms.get("scale").value = value;
    }
    /**
   * Returns the current bokeh scale.
   *
   * @deprecated Use bokehScale instead.
   * @return {Number} The scale.
   */ getBokehScale() {
        return this.bokehScale;
    }
    /**
   * Sets the bokeh scale.
   *
   * @deprecated Use bokehScale instead.
   * @param {Number} value - The scale.
   */ setBokehScale(value) {
        this.bokehScale = value;
    }
    /**
   * Returns the current auto focus target.
   *
   * @deprecated Use target instead.
   * @return {Vector3} The target.
   */ getTarget() {
        return this.target;
    }
    /**
   * Sets the auto focus target.
   *
   * @deprecated Use target instead.
   * @param {Vector3} value - The target.
   */ setTarget(value) {
        this.target = value;
    }
    /**
   * Calculates the focus distance from the camera to the given position.
   *
   * @param {Vector3} target - The target.
   * @return {Number} The normalized focus distance.
   */ calculateFocusDistance(target) {
        const camera = this.camera;
        const distance = camera.position.distanceTo(target);
        return $fe721963ebf18f1b$var$viewZToOrthographicDepth(-distance, camera.near, camera.far);
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.cocMaterial.depthBuffer = depthTexture;
        this.cocMaterial.depthPacking = depthPacking;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const renderTarget = this.renderTarget;
        const renderTargetCoC = this.renderTargetCoC;
        const renderTargetCoCBlurred = this.renderTargetCoCBlurred;
        const renderTargetMasked = this.renderTargetMasked;
        if (this.target !== null) {
            const distance = this.calculateFocusDistance(this.target);
            this.cocMaterial.focusDistance = distance;
        }
        this.cocPass.render(renderer, null, renderTargetCoC);
        this.blurPass.render(renderer, renderTargetCoC, renderTargetCoCBlurred);
        this.maskPass.render(renderer, inputBuffer, renderTargetMasked);
        this.bokehFarBasePass.render(renderer, renderTargetMasked, renderTarget);
        this.bokehFarFillPass.render(renderer, renderTarget, this.renderTargetFar);
        this.bokehNearBasePass.render(renderer, inputBuffer, renderTarget);
        this.bokehNearFillPass.render(renderer, renderTarget, this.renderTargetNear);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.cocPass.setSize(width, height);
        this.blurPass.setSize(width, height);
        this.maskPass.setSize(width, height);
        this.renderTargetFar.setSize(width, height);
        this.renderTargetCoC.setSize(width, height);
        this.renderTargetMasked.setSize(width, height);
        this.renderTarget.setSize(w, h);
        this.renderTargetNear.setSize(w, h);
        this.renderTargetCoCBlurred.setSize(w, h);
        this.bokehNearBasePass.fullscreenMaterial.setSize(width, height);
        this.bokehNearFillPass.fullscreenMaterial.setSize(width, height);
        this.bokehFarBasePass.fullscreenMaterial.setSize(width, height);
        this.bokehFarFillPass.fullscreenMaterial.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.cocPass.initialize(renderer, alpha, frameBufferType);
        this.maskPass.initialize(renderer, alpha, frameBufferType);
        this.bokehNearBasePass.initialize(renderer, alpha, frameBufferType);
        this.bokehNearFillPass.initialize(renderer, alpha, frameBufferType);
        this.bokehFarBasePass.initialize(renderer, alpha, frameBufferType);
        this.bokehFarFillPass.initialize(renderer, alpha, frameBufferType);
        this.blurPass.initialize(renderer, alpha, (0, $ilwiq.UnsignedByteType));
        if (renderer.capabilities.logarithmicDepthBuffer) this.cocPass.fullscreenMaterial.defines.LOG_DEPTH = "1";
        if (frameBufferType !== void 0) {
            this.renderTarget.texture.type = frameBufferType;
            this.renderTargetNear.texture.type = frameBufferType;
            this.renderTargetFar.texture.type = frameBufferType;
            this.renderTargetMasked.texture.type = frameBufferType;
            if (renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) {
                this.renderTarget.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
                this.renderTargetNear.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
                this.renderTargetFar.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
                this.renderTargetMasked.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
            }
        }
    }
};
// src/effects/glsl/dot-screen.frag
var $fe721963ebf18f1b$var$dot_screen_default = "uniform vec2 angle;uniform float scale;float pattern(const in vec2 uv){vec2 point=scale*vec2(dot(angle.yx,vec2(uv.x,-uv.y)),dot(angle,uv));return(sin(point.x)*sin(point.y))*4.0;}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(inputColor.rgb*10.0-5.0+pattern(uv*resolution));outputColor=vec4(color,inputColor.a);}";
// src/effects/DotScreenEffect.js
var $fe721963ebf18f1b$export$f9e0c2aa66f80f09 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new dot screen effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.angle=1.57] - The angle of the dot pattern.
   * @param {Number} [options.scale=1.0] - The scale of the dot pattern.
   */ constructor({ blendFunction: blendFunction, angle: angle = Math.PI * 0.5, scale: scale = 1 } = {}){
        super("DotScreenEffect", $fe721963ebf18f1b$var$dot_screen_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "angle",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)())
                ],
                [
                    "scale",
                    new (0, $ilwiq.Uniform)(scale)
                ]
            ])
        });
        this.angle = angle;
    }
    /**
   * The angle.
   *
   * @type {Number}
   */ get angle() {
        return Math.acos(this.uniforms.get("angle").value.y);
    }
    set angle(value) {
        this.uniforms.get("angle").value.set(Math.sin(value), Math.cos(value));
    }
    /**
   * Returns the pattern angle.
   *
   * @deprecated Use angle instead.
   * @return {Number} The angle in radians.
   */ getAngle() {
        return this.angle;
    }
    /**
   * Sets the pattern angle.
   *
   * @deprecated Use angle instead.
   * @param {Number} value - The angle in radians.
   */ setAngle(value) {
        this.angle = value;
    }
    /**
   * The scale.
   *
   * @type {Number}
   */ get scale() {
        return this.uniforms.get("scale").value;
    }
    set scale(value) {
        this.uniforms.get("scale").value = value;
    }
};
// src/effects/glsl/fxaa.frag
var $fe721963ebf18f1b$var$fxaa_default = "#define QUALITY(q) ((q) < 5 ? 1.0 : ((q) > 5 ? ((q) < 10 ? 2.0 : ((q) < 11 ? 4.0 : 8.0)) : 1.5))\n#define ONE_OVER_TWELVE 0.08333333333333333\nvarying vec2 vUvDown;varying vec2 vUvUp;varying vec2 vUvLeft;varying vec2 vUvRight;varying vec2 vUvDownLeft;varying vec2 vUvUpRight;varying vec2 vUvUpLeft;varying vec2 vUvDownRight;vec4 fxaa(const in vec4 inputColor,const in vec2 uv){float lumaCenter=luminance(inputColor.rgb);float lumaDown=luminance(texture2D(inputBuffer,vUvDown).rgb);float lumaUp=luminance(texture2D(inputBuffer,vUvUp).rgb);float lumaLeft=luminance(texture2D(inputBuffer,vUvLeft).rgb);float lumaRight=luminance(texture2D(inputBuffer,vUvRight).rgb);float lumaMin=min(lumaCenter,min(min(lumaDown,lumaUp),min(lumaLeft,lumaRight)));float lumaMax=max(lumaCenter,max(max(lumaDown,lumaUp),max(lumaLeft,lumaRight)));float lumaRange=lumaMax-lumaMin;if(lumaRange<max(EDGE_THRESHOLD_MIN,lumaMax*EDGE_THRESHOLD_MAX)){return inputColor;}float lumaDownLeft=luminance(texture2D(inputBuffer,vUvDownLeft).rgb);float lumaUpRight=luminance(texture2D(inputBuffer,vUvUpRight).rgb);float lumaUpLeft=luminance(texture2D(inputBuffer,vUvUpLeft).rgb);float lumaDownRight=luminance(texture2D(inputBuffer,vUvDownRight).rgb);float lumaDownUp=lumaDown+lumaUp;float lumaLeftRight=lumaLeft+lumaRight;float lumaLeftCorners=lumaDownLeft+lumaUpLeft;float lumaDownCorners=lumaDownLeft+lumaDownRight;float lumaRightCorners=lumaDownRight+lumaUpRight;float lumaUpCorners=lumaUpRight+lumaUpLeft;float edgeHorizontal=(abs(-2.0*lumaLeft+lumaLeftCorners)+abs(-2.0*lumaCenter+lumaDownUp)*2.0+abs(-2.0*lumaRight+lumaRightCorners));float edgeVertical=(abs(-2.0*lumaUp+lumaUpCorners)+abs(-2.0*lumaCenter+lumaLeftRight)*2.0+abs(-2.0*lumaDown+lumaDownCorners));bool isHorizontal=(edgeHorizontal>=edgeVertical);float stepLength=isHorizontal?texelSize.y:texelSize.x;float luma1=isHorizontal?lumaDown:lumaLeft;float luma2=isHorizontal?lumaUp:lumaRight;float gradient1=abs(luma1-lumaCenter);float gradient2=abs(luma2-lumaCenter);bool is1Steepest=gradient1>=gradient2;float gradientScaled=0.25*max(gradient1,gradient2);float lumaLocalAverage=0.0;if(is1Steepest){stepLength=-stepLength;lumaLocalAverage=0.5*(luma1+lumaCenter);}else{lumaLocalAverage=0.5*(luma2+lumaCenter);}vec2 currentUv=uv;if(isHorizontal){currentUv.y+=stepLength*0.5;}else{currentUv.x+=stepLength*0.5;}vec2 offset=isHorizontal?vec2(texelSize.x,0.0):vec2(0.0,texelSize.y);vec2 uv1=currentUv-offset*QUALITY(0);vec2 uv2=currentUv+offset*QUALITY(0);float lumaEnd1=luminance(texture2D(inputBuffer,uv1).rgb);float lumaEnd2=luminance(texture2D(inputBuffer,uv2).rgb);lumaEnd1-=lumaLocalAverage;lumaEnd2-=lumaLocalAverage;bool reached1=abs(lumaEnd1)>=gradientScaled;bool reached2=abs(lumaEnd2)>=gradientScaled;bool reachedBoth=reached1&&reached2;if(!reached1){uv1-=offset*QUALITY(1);}if(!reached2){uv2+=offset*QUALITY(1);}if(!reachedBoth){for(int i=2;i<SAMPLES;++i){if(!reached1){lumaEnd1=luminance(texture2D(inputBuffer,uv1).rgb);lumaEnd1=lumaEnd1-lumaLocalAverage;}if(!reached2){lumaEnd2=luminance(texture2D(inputBuffer,uv2).rgb);lumaEnd2=lumaEnd2-lumaLocalAverage;}reached1=abs(lumaEnd1)>=gradientScaled;reached2=abs(lumaEnd2)>=gradientScaled;reachedBoth=reached1&&reached2;if(!reached1){uv1-=offset*QUALITY(i);}if(!reached2){uv2+=offset*QUALITY(i);}if(reachedBoth){break;}}}float distance1=isHorizontal?(uv.x-uv1.x):(uv.y-uv1.y);float distance2=isHorizontal?(uv2.x-uv.x):(uv2.y-uv.y);bool isDirection1=distance1<distance2;float distanceFinal=min(distance1,distance2);float edgeThickness=(distance1+distance2);bool isLumaCenterSmaller=lumaCenter<lumaLocalAverage;bool correctVariation1=(lumaEnd1<0.0)!=isLumaCenterSmaller;bool correctVariation2=(lumaEnd2<0.0)!=isLumaCenterSmaller;bool correctVariation=isDirection1?correctVariation1:correctVariation2;float pixelOffset=-distanceFinal/edgeThickness+0.5;float finalOffset=correctVariation?pixelOffset:0.0;float lumaAverage=ONE_OVER_TWELVE*(2.0*(lumaDownUp+lumaLeftRight)+lumaLeftCorners+lumaRightCorners);float subPixelOffset1=clamp(abs(lumaAverage-lumaCenter)/lumaRange,0.0,1.0);float subPixelOffset2=(-2.0*subPixelOffset1+3.0)*subPixelOffset1*subPixelOffset1;float subPixelOffsetFinal=subPixelOffset2*subPixelOffset2*SUBPIXEL_QUALITY;finalOffset=max(finalOffset,subPixelOffsetFinal);vec2 finalUv=uv;if(isHorizontal){finalUv.y+=finalOffset*stepLength;}else{finalUv.x+=finalOffset*stepLength;}return texture2D(inputBuffer,finalUv);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=fxaa(inputColor,uv);}";
// src/effects/glsl/fxaa.vert
var $fe721963ebf18f1b$var$fxaa_default2 = "varying vec2 vUvDown;varying vec2 vUvUp;varying vec2 vUvLeft;varying vec2 vUvRight;varying vec2 vUvDownLeft;varying vec2 vUvUpRight;varying vec2 vUvUpLeft;varying vec2 vUvDownRight;void mainSupport(const in vec2 uv){vUvDown=uv+vec2(0.0,-1.0)*texelSize;vUvUp=uv+vec2(0.0,1.0)*texelSize;vUvRight=uv+vec2(1.0,0.0)*texelSize;vUvLeft=uv+vec2(-1.0,0.0)*texelSize;vUvDownLeft=uv+vec2(-1.0,-1.0)*texelSize;vUvUpRight=uv+vec2(1.0,1.0)*texelSize;vUvUpLeft=uv+vec2(-1.0,1.0)*texelSize;vUvDownRight=uv+vec2(1.0,-1.0)*texelSize;}";
// src/effects/FXAAEffect.js
var $fe721963ebf18f1b$export$b10a15fb2785e23f = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new FXAA effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SRC } = {}){
        super("FXAAEffect", $fe721963ebf18f1b$var$fxaa_default, {
            vertexShader: $fe721963ebf18f1b$var$fxaa_default2,
            blendFunction: blendFunction,
            defines: /* @__PURE__ */ new Map([
                [
                    "EDGE_THRESHOLD_MIN",
                    "0.0312"
                ],
                [
                    "EDGE_THRESHOLD_MAX",
                    "0.125"
                ],
                [
                    "SUBPIXEL_QUALITY",
                    "0.75"
                ],
                [
                    "SAMPLES",
                    "12"
                ]
            ])
        });
    }
    /**
   * The minimum edge detection threshold. Range is [0.0, 1.0].
   *
   * @type {Number}
   */ get minEdgeThreshold() {
        return Number(this.defines.get("EDGE_THRESHOLD_MIN"));
    }
    set minEdgeThreshold(value) {
        this.defines.set("EDGE_THRESHOLD_MIN", value.toFixed(12));
        this.setChanged();
    }
    /**
   * The maximum edge detection threshold. Range is [0.0, 1.0].
   *
   * @type {Number}
   */ get maxEdgeThreshold() {
        return Number(this.defines.get("EDGE_THRESHOLD_MAX"));
    }
    set maxEdgeThreshold(value) {
        this.defines.set("EDGE_THRESHOLD_MAX", value.toFixed(12));
        this.setChanged();
    }
    /**
   * The subpixel blend quality. Range is [0.0, 1.0].
   *
   * @type {Number}
   */ get subpixelQuality() {
        return Number(this.defines.get("SUBPIXEL_QUALITY"));
    }
    set subpixelQuality(value) {
        this.defines.set("SUBPIXEL_QUALITY", value.toFixed(12));
        this.setChanged();
    }
    /**
   * The maximum amount of edge detection samples.
   *
   * @type {Number}
   */ get samples() {
        return Number(this.defines.get("SAMPLES"));
    }
    set samples(value) {
        this.defines.set("SAMPLES", value.toFixed(0));
        this.setChanged();
    }
};
// src/effects/glsl/gamma-correction.frag
var $fe721963ebf18f1b$var$gamma_correction_default = "uniform float gamma;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=LinearToGamma(max(inputColor,0.0),gamma);}";
// src/effects/GammaCorrectionEffect.js
var $fe721963ebf18f1b$export$ffcf45862523c89e = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new gamma correction effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Number} [options.gamma=2.0] - The gamma factor.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SRC, gamma: gamma = 2 } = {}){
        super("GammaCorrectionEffect", $fe721963ebf18f1b$var$gamma_correction_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "gamma",
                    new (0, $ilwiq.Uniform)(gamma)
                ]
            ])
        });
    }
};
// src/enums/GlitchMode.js
var $fe721963ebf18f1b$export$678a9d3661117e39 = {
    DISABLED: 0,
    SPORADIC: 1,
    CONSTANT_MILD: 2,
    CONSTANT_WILD: 3
};
function $fe721963ebf18f1b$var$getNoise(size, format, type) {
    const channels = /* @__PURE__ */ new Map([
        [
            (0, $ilwiq.LuminanceFormat),
            1
        ],
        [
            (0, $ilwiq.RedFormat),
            1
        ],
        [
            (0, $ilwiq.RGFormat),
            2
        ],
        [
            (0, $ilwiq.RGBAFormat),
            4
        ]
    ]);
    let data;
    if (!channels.has(format)) console.error("Invalid noise texture format");
    if (type === (0, $ilwiq.UnsignedByteType)) {
        data = new Uint8Array(size * channels.get(format));
        for(let i = 0, l = data.length; i < l; ++i)data[i] = Math.random() * 255 + 0.5;
    } else {
        data = new Float32Array(size * channels.get(format));
        for(let i = 0, l = data.length; i < l; ++i)data[i] = Math.random();
    }
    return data;
}
var $fe721963ebf18f1b$export$2d9c702b3963e69c = class extends (0, $ilwiq.DataTexture) {
    /**
   * Constructs a new noise texture.
   *
   * The texture format can be either `LuminanceFormat` or `RGBAFormat`. Additionally, the formats `RedFormat` and
   * `RGFormat` can be used in a WebGL 2 context.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   * @param {Number} [format=LuminanceFormat] - The texture format.
   * @param {Number} [type=UnsignedByteType] - The texture type.
   */ constructor(width, height, format = (0, $ilwiq.LuminanceFormat), type = (0, $ilwiq.UnsignedByteType)){
        super($fe721963ebf18f1b$var$getNoise(width * height, format, type), width, height, format, type);
        this.needsUpdate = true;
    }
};
// src/effects/glsl/glitch.frag
var $fe721963ebf18f1b$var$glitch_default = "uniform lowp sampler2D perturbationMap;uniform bool active;uniform float columns;uniform float random;uniform vec2 seeds;uniform vec2 distortion;void mainUv(inout vec2 uv){if(active){if(uv.y<distortion.x+columns&&uv.y>distortion.x-columns*random){float sx=clamp(ceil(seeds.x),0.0,1.0);uv.y=sx*(1.0-(uv.y+distortion.y))+(1.0-sx)*distortion.y;}if(uv.x<distortion.y+columns&&uv.x>distortion.y-columns*random){float sy=clamp(ceil(seeds.y),0.0,1.0);uv.x=sy*distortion.x+(1.0-sy)*(1.0-(uv.x+distortion.x));}vec2 normal=texture2D(perturbationMap,uv*random*random).rg;uv+=normal*seeds*(random*0.2);}}";
// src/effects/GlitchEffect.js
var $fe721963ebf18f1b$var$textureTag = "Glitch.Generated";
function $fe721963ebf18f1b$var$randomFloat(low, high) {
    return low + Math.random() * (high - low);
}
var $fe721963ebf18f1b$export$87a0c8b425be8598 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new glitch effect.
   *
   * TODO Change ratio to 0.15.
   * @param {Object} [options] - The options.
   * @param {Vector2} [options.chromaticAberrationOffset] - A chromatic aberration offset. If provided, the glitch effect will influence this offset.
   * @param {Vector2} [options.delay] - The minimum and maximum delay between glitch activations in seconds.
   * @param {Vector2} [options.duration] - The minimum and maximum duration of a glitch in seconds.
   * @param {Vector2} [options.strength] - The strength of weak and strong glitches.
   * @param {Texture} [options.perturbationMap] - A perturbation map. If none is provided, a noise texture will be created.
   * @param {Number} [options.dtSize=64] - The size of the generated noise map. Will be ignored if a perturbation map is provided.
   * @param {Number} [options.columns=0.05] - The scale of the blocky glitch columns.
   * @param {Number} [options.ratio=0.85] - The threshold for strong glitches.
   */ constructor({ chromaticAberrationOffset: chromaticAberrationOffset = null, delay: delay = new (0, $ilwiq.Vector2)(1.5, 3.5), duration: duration = new (0, $ilwiq.Vector2)(0.6, 1), strength: strength = new (0, $ilwiq.Vector2)(0.3, 1), columns: columns = 0.05, ratio: ratio = 0.85, perturbationMap: perturbationMap = null, dtSize: dtSize = 64 } = {}){
        super("GlitchEffect", $fe721963ebf18f1b$var$glitch_default, {
            uniforms: /* @__PURE__ */ new Map([
                [
                    "perturbationMap",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "columns",
                    new (0, $ilwiq.Uniform)(columns)
                ],
                [
                    "active",
                    new (0, $ilwiq.Uniform)(false)
                ],
                [
                    "random",
                    new (0, $ilwiq.Uniform)(1)
                ],
                [
                    "seeds",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)())
                ],
                [
                    "distortion",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)())
                ]
            ])
        });
        if (perturbationMap === null) {
            const map = new $fe721963ebf18f1b$export$2d9c702b3963e69c(dtSize, dtSize, (0, $ilwiq.RGBAFormat));
            map.name = $fe721963ebf18f1b$var$textureTag;
            this.perturbationMap = map;
        } else this.perturbationMap = perturbationMap;
        this.time = 0;
        this.distortion = this.uniforms.get("distortion").value;
        this.delay = delay;
        this.duration = duration;
        this.breakPoint = new (0, $ilwiq.Vector2)($fe721963ebf18f1b$var$randomFloat(this.delay.x, this.delay.y), $fe721963ebf18f1b$var$randomFloat(this.duration.x, this.duration.y));
        this.strength = strength;
        this.mode = $fe721963ebf18f1b$export$678a9d3661117e39.SPORADIC;
        this.ratio = ratio;
        this.chromaticAberrationOffset = chromaticAberrationOffset;
    }
    /**
   * Random number seeds.
   *
   * @type {Vector2}
   * @private
   */ get seeds() {
        return this.uniforms.get("seeds").value;
    }
    /**
   * Indicates whether the glitch effect is currently active.
   *
   * @type {Boolean}
   */ get active() {
        return this.uniforms.get("active").value;
    }
    /**
   * Indicates whether the glitch effect is currently active.
   *
   * @deprecated Use active instead.
   * @return {Boolean} Whether the glitch effect is active.
   */ isActive() {
        return this.active;
    }
    /**
   * The minimum delay between glitch activations.
   *
   * @type {Number}
   */ get minDelay() {
        return this.delay.x;
    }
    set minDelay(value) {
        this.delay.x = value;
    }
    /**
   * Returns the minimum delay between glitch activations.
   *
   * @deprecated Use minDelay instead.
   * @return {Number} The minimum delay in seconds.
   */ getMinDelay() {
        return this.delay.x;
    }
    /**
   * Sets the minimum delay between glitch activations.
   *
   * @deprecated Use minDelay instead.
   * @param {Number} value - The minimum delay in seconds.
   */ setMinDelay(value) {
        this.delay.x = value;
    }
    /**
   * The maximum delay between glitch activations.
   *
   * @type {Number}
   */ get maxDelay() {
        return this.delay.y;
    }
    set maxDelay(value) {
        this.delay.y = value;
    }
    /**
   * Returns the maximum delay between glitch activations.
   *
   * @deprecated Use maxDelay instead.
   * @return {Number} The maximum delay in seconds.
   */ getMaxDelay() {
        return this.delay.y;
    }
    /**
   * Sets the maximum delay between glitch activations.
   *
   * @deprecated Use maxDelay instead.
   * @param {Number} value - The maximum delay in seconds.
   */ setMaxDelay(value) {
        this.delay.y = value;
    }
    /**
   * The minimum duration of sporadic glitches.
   *
   * @type {Number}
   */ get minDuration() {
        return this.duration.x;
    }
    set minDuration(value) {
        this.duration.x = value;
    }
    /**
   * Returns the minimum duration of sporadic glitches.
   *
   * @deprecated Use minDuration instead.
   * @return {Number} The minimum duration in seconds.
   */ getMinDuration() {
        return this.duration.x;
    }
    /**
   * Sets the minimum duration of sporadic glitches.
   *
   * @deprecated Use minDuration instead.
   * @param {Number} value - The minimum duration in seconds.
   */ setMinDuration(value) {
        this.duration.x = value;
    }
    /**
   * The maximum duration of sporadic glitches.
   *
   * @type {Number}
   */ get maxDuration() {
        return this.duration.y;
    }
    set maxDuration(value) {
        this.duration.y = value;
    }
    /**
   * Returns the maximum duration of sporadic glitches.
   *
   * @deprecated Use maxDuration instead.
   * @return {Number} The maximum duration in seconds.
   */ getMaxDuration() {
        return this.duration.y;
    }
    /**
   * Sets the maximum duration of sporadic glitches.
   *
   * @deprecated Use maxDuration instead.
   * @param {Number} value - The maximum duration in seconds.
   */ setMaxDuration(value) {
        this.duration.y = value;
    }
    /**
   * The strength of weak glitches.
   *
   * @type {Number}
   */ get minStrength() {
        return this.strength.x;
    }
    set minStrength(value) {
        this.strength.x = value;
    }
    /**
   * Returns the strength of weak glitches.
   *
   * @deprecated Use minStrength instead.
   * @return {Number} The strength.
   */ getMinStrength() {
        return this.strength.x;
    }
    /**
   * Sets the strength of weak glitches.
   *
   * @deprecated Use minStrength instead.
   * @param {Number} value - The strength.
   */ setMinStrength(value) {
        this.strength.x = value;
    }
    /**
   * The strength of strong glitches.
   *
   * @type {Number}
   */ get maxStrength() {
        return this.strength.y;
    }
    set maxStrength(value) {
        this.strength.y = value;
    }
    /**
   * Returns the strength of strong glitches.
   *
   * @deprecated Use maxStrength instead.
   * @return {Number} The strength.
   */ getMaxStrength() {
        return this.strength.y;
    }
    /**
   * Sets the strength of strong glitches.
   *
   * @deprecated Use maxStrength instead.
   * @param {Number} value - The strength.
   */ setMaxStrength(value) {
        this.strength.y = value;
    }
    /**
   * Returns the current glitch mode.
   *
   * @deprecated Use mode instead.
   * @return {GlitchMode} The mode.
   */ getMode() {
        return this.mode;
    }
    /**
   * Sets the current glitch mode.
   *
   * @deprecated Use mode instead.
   * @param {GlitchMode} value - The mode.
   */ setMode(value) {
        this.mode = value;
    }
    /**
   * Returns the glitch ratio.
   *
   * @deprecated Use ratio instead.
   * @return {Number} The ratio.
   */ getGlitchRatio() {
        return 1 - this.ratio;
    }
    /**
   * Sets the ratio of weak (0.0) and strong (1.0) glitches.
   *
   * @deprecated Use ratio instead.
   * @param {Number} value - The ratio. Range is [0.0, 1.0].
   */ setGlitchRatio(value) {
        this.ratio = Math.min(Math.max(1 - value, 0), 1);
    }
    /**
   * The glitch column size.
   *
   * @type {Number}
   */ get columns() {
        return this.uniforms.get("columns").value;
    }
    set columns(value) {
        this.uniforms.get("columns").value = value;
    }
    /**
   * Returns the glitch column size.
   *
   * @deprecated Use columns instead.
   * @return {Number} The glitch column size.
   */ getGlitchColumns() {
        return this.columns;
    }
    /**
   * Sets the glitch column size.
   *
   * @deprecated Use columns instead.
   * @param {Number} value - The glitch column size.
   */ setGlitchColumns(value) {
        this.columns = value;
    }
    /**
   * Returns the chromatic aberration offset.
   *
   * @deprecated Use chromaticAberrationOffset instead.
   * @return {Vector2} The offset.
   */ getChromaticAberrationOffset() {
        return this.chromaticAberrationOffset;
    }
    /**
   * Sets the chromatic aberration offset.
   *
   * @deprecated Use chromaticAberrationOffset instead.
   * @param {Vector2} value - The offset.
   */ setChromaticAberrationOffset(value) {
        this.chromaticAberrationOffset = value;
    }
    /**
   * The perturbation map.
   *
   * @type {Texture}
   */ get perturbationMap() {
        return this.uniforms.get("perturbationMap").value;
    }
    set perturbationMap(value) {
        const currentMap = this.perturbationMap;
        if (currentMap !== null && currentMap.name === $fe721963ebf18f1b$var$textureTag) currentMap.dispose();
        value.minFilter = value.magFilter = (0, $ilwiq.NearestFilter);
        value.wrapS = value.wrapT = (0, $ilwiq.RepeatWrapping);
        value.generateMipmaps = false;
        this.uniforms.get("perturbationMap").value = value;
    }
    /**
   * Returns the current perturbation map.
   *
   * @deprecated Use perturbationMap instead.
   * @return {Texture} The current perturbation map.
   */ getPerturbationMap() {
        return this.perturbationMap;
    }
    /**
   * Replaces the current perturbation map with the given one.
   *
   * The current map will be disposed if it was generated by this effect.
   *
   * @deprecated Use perturbationMap instead.
   * @param {Texture} value - The new perturbation map.
   */ setPerturbationMap(value) {
        this.perturbationMap = value;
    }
    /**
   * Generates a perturbation map.
   *
   * @deprecated Use NoiseTexture instead.
   * @param {Number} [value=64] - The texture size.
   * @return {DataTexture} The perturbation map.
   */ generatePerturbationMap(value = 64) {
        const map = new $fe721963ebf18f1b$export$2d9c702b3963e69c(value, value, (0, $ilwiq.RGBAFormat));
        map.name = $fe721963ebf18f1b$var$textureTag;
        return map;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const mode = this.mode;
        const breakPoint = this.breakPoint;
        const offset = this.chromaticAberrationOffset;
        const s = this.strength;
        let time = this.time;
        let active = false;
        let r = 0, a = 0;
        let trigger;
        if (mode !== $fe721963ebf18f1b$export$678a9d3661117e39.DISABLED) {
            if (mode === $fe721963ebf18f1b$export$678a9d3661117e39.SPORADIC) {
                time += deltaTime;
                trigger = time > breakPoint.x;
                if (time >= breakPoint.x + breakPoint.y) {
                    breakPoint.set($fe721963ebf18f1b$var$randomFloat(this.delay.x, this.delay.y), $fe721963ebf18f1b$var$randomFloat(this.duration.x, this.duration.y));
                    time = 0;
                }
            }
            r = Math.random();
            this.uniforms.get("random").value = r;
            if (trigger && r > this.ratio || mode === $fe721963ebf18f1b$export$678a9d3661117e39.CONSTANT_WILD) {
                active = true;
                r *= s.y * 0.03;
                a = $fe721963ebf18f1b$var$randomFloat(-Math.PI, Math.PI);
                this.seeds.set($fe721963ebf18f1b$var$randomFloat(-s.y, s.y), $fe721963ebf18f1b$var$randomFloat(-s.y, s.y));
                this.distortion.set($fe721963ebf18f1b$var$randomFloat(0, 1), $fe721963ebf18f1b$var$randomFloat(0, 1));
            } else if (trigger || mode === $fe721963ebf18f1b$export$678a9d3661117e39.CONSTANT_MILD) {
                active = true;
                r *= s.x * 0.03;
                a = $fe721963ebf18f1b$var$randomFloat(-Math.PI, Math.PI);
                this.seeds.set($fe721963ebf18f1b$var$randomFloat(-s.x, s.x), $fe721963ebf18f1b$var$randomFloat(-s.x, s.x));
                this.distortion.set($fe721963ebf18f1b$var$randomFloat(0, 1), $fe721963ebf18f1b$var$randomFloat(0, 1));
            }
            this.time = time;
        }
        if (offset !== null) {
            if (active) offset.set(Math.cos(a), Math.sin(a)).multiplyScalar(r);
            else offset.set(0, 0);
        }
        this.uniforms.get("active").value = active;
    }
    /**
   * Deletes generated resources.
   */ dispose() {
        const map = this.perturbationMap;
        if (map !== null && map.name === $fe721963ebf18f1b$var$textureTag) map.dispose();
    }
};
// src/enums/DepthTestStrategy.js
var $fe721963ebf18f1b$export$a11e355d280abe13 = {
    DEFAULT: 0,
    KEEP_MAX_DEPTH: 1,
    DISCARD_MAX_DEPTH: 2
};
// src/materials/glsl/depth-mask.frag
var $fe721963ebf18f1b$var$depth_mask_default = "#include <common>\n#include <packing>\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D depthBuffer0;uniform highp sampler2D depthBuffer1;\n#else\nuniform mediump sampler2D depthBuffer0;uniform mediump sampler2D depthBuffer1;\n#endif\nuniform sampler2D inputBuffer;uniform vec2 cameraNearFar;float getViewZ(const in float depth){\n#ifdef PERSPECTIVE_CAMERA\nreturn perspectiveDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);\n#else\nreturn orthographicDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);\n#endif\n}varying vec2 vUv;void main(){vec2 depth;\n#if DEPTH_PACKING_0 == 3201\ndepth.x=unpackRGBAToDepth(texture2D(depthBuffer0,vUv));\n#else\ndepth.x=texture2D(depthBuffer0,vUv).r;\n#ifdef LOG_DEPTH\nfloat d=pow(2.0,depth.x*log2(cameraNearFar.y+1.0))-1.0;float a=cameraNearFar.y/(cameraNearFar.y-cameraNearFar.x);float b=cameraNearFar.y*cameraNearFar.x/(cameraNearFar.x-cameraNearFar.y);depth.x=a+b/d;\n#endif\n#endif\n#if DEPTH_PACKING_1 == 3201\ndepth.y=unpackRGBAToDepth(texture2D(depthBuffer1,vUv));\n#else\ndepth.y=texture2D(depthBuffer1,vUv).r;\n#ifdef LOG_DEPTH\nfloat d=pow(2.0,depth.y*log2(cameraNearFar.y+1.0))-1.0;float a=cameraNearFar.y/(cameraNearFar.y-cameraNearFar.x);float b=cameraNearFar.y*cameraNearFar.x/(cameraNearFar.x-cameraNearFar.y);depth.y=a+b/d;\n#endif\n#endif\nbool isMaxDepth=(depth.x==1.0);\n#ifdef PERSPECTIVE_CAMERA\ndepth.x=viewZToOrthographicDepth(getViewZ(depth.x),cameraNearFar.x,cameraNearFar.y);depth.y=viewZToOrthographicDepth(getViewZ(depth.y),cameraNearFar.x,cameraNearFar.y);\n#endif\n#if DEPTH_TEST_STRATEGY == 0\nbool keep=depthTest(depth.x,depth.y);\n#elif DEPTH_TEST_STRATEGY == 1\nbool keep=isMaxDepth||depthTest(depth.x,depth.y);\n#else\nbool keep=!isMaxDepth&&depthTest(depth.x,depth.y);\n#endif\nif(keep){gl_FragColor=texture2D(inputBuffer,vUv);}else{discard;}}";
// src/materials/DepthMaskMaterial.js
var $fe721963ebf18f1b$export$fe1d84eaa823805a = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new depth mask material.
   */ constructor(){
        super({
            name: "DepthMaskMaterial",
            defines: {
                DEPTH_EPSILON: "0.0001",
                DEPTH_PACKING_0: "0",
                DEPTH_PACKING_1: "0",
                DEPTH_TEST_STRATEGY: $fe721963ebf18f1b$export$a11e355d280abe13.KEEP_MAX_DEPTH
            },
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                depthBuffer0: new (0, $ilwiq.Uniform)(null),
                depthBuffer1: new (0, $ilwiq.Uniform)(null),
                cameraNearFar: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)(1, 1))
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$depth_mask_default,
            vertexShader: $fe721963ebf18f1b$var$common_default
        });
        this.depthMode = (0, $ilwiq.LessDepth);
    }
    /**
   * The primary depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer0(value) {
        this.uniforms.depthBuffer0.value = value;
    }
    /**
   * The primary depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking0(value) {
        this.defines.DEPTH_PACKING_0 = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the base depth buffer.
   *
   * @deprecated Use depthBuffer0 and depthPacking0 instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer0(buffer, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthBuffer0 = buffer;
        this.depthPacking0 = depthPacking;
    }
    /**
   * The secondary depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer1(value) {
        this.uniforms.depthBuffer1.value = value;
    }
    /**
   * The secondary depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking1(value) {
        this.defines.DEPTH_PACKING_1 = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer that will be compared with the base depth buffer.
   *
   * @deprecated Use depthBuffer1 and depthPacking1 instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer1(buffer, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthBuffer1 = buffer;
        this.depthPacking1 = depthPacking;
    }
    /**
   * The strategy for handling maximum depth.
   *
   * @type {DepthTestStrategy}
   */ get maxDepthStrategy() {
        return Number(this.defines.DEPTH_TEST_STRATEGY);
    }
    set maxDepthStrategy(value) {
        this.defines.DEPTH_TEST_STRATEGY = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Indicates whether maximum depth values should be preserved.
   *
   * @type {Boolean}
   * @deprecated Use maxDepthStrategy instead.
   */ get keepFar() {
        return this.maxDepthStrategy;
    }
    set keepFar(value) {
        this.maxDepthStrategy = value ? $fe721963ebf18f1b$export$a11e355d280abe13.KEEP_MAX_DEPTH : $fe721963ebf18f1b$export$a11e355d280abe13.DISCARD_MAX_DEPTH;
    }
    /**
   * Returns the strategy for dealing with maximum depth values.
   *
   * @deprecated Use maxDepthStrategy instead.
   * @return {DepthTestStrategy} The strategy.
   */ getMaxDepthStrategy() {
        return this.maxDepthStrategy;
    }
    /**
   * Sets the strategy for dealing with maximum depth values.
   *
   * @deprecated Use maxDepthStrategy instead.
   * @param {DepthTestStrategy} value - The strategy.
   */ setMaxDepthStrategy(value) {
        this.maxDepthStrategy = value;
    }
    /**
   * A small error threshold that is used for `EqualDepth` and `NotEqualDepth` tests. Default is `1e-4`.
   *
   * @type {Number}
   */ get epsilon() {
        return Number(this.defines.DEPTH_EPSILON);
    }
    set epsilon(value) {
        this.defines.DEPTH_EPSILON = value.toFixed(16);
        this.needsUpdate = true;
    }
    /**
   * Returns the current error threshold for depth comparisons.
   *
   * @deprecated Use epsilon instead.
   * @return {Number} The error threshold.
   */ getEpsilon() {
        return this.epsilon;
    }
    /**
   * Sets the depth comparison error threshold.
   *
   * @deprecated Use epsilon instead.
   * @param {Number} value - The new error threshold.
   */ setEpsilon(value) {
        this.epsilon = value;
    }
    /**
   * The depth mode.
   *
   * @see https://threejs.org/docs/#api/en/constants/Materials
   * @type {DepthModes}
   */ get depthMode() {
        return Number(this.defines.DEPTH_MODE);
    }
    set depthMode(value) {
        let depthTest;
        switch(value){
            case 0, $ilwiq.NeverDepth:
                depthTest = "false";
                break;
            case 0, $ilwiq.AlwaysDepth:
                depthTest = "true";
                break;
            case 0, $ilwiq.EqualDepth:
                depthTest = "abs(d1 - d0) <= DEPTH_EPSILON";
                break;
            case 0, $ilwiq.NotEqualDepth:
                depthTest = "abs(d1 - d0) > DEPTH_EPSILON";
                break;
            case 0, $ilwiq.LessDepth:
                depthTest = "d0 > d1";
                break;
            case 0, $ilwiq.LessEqualDepth:
                depthTest = "d0 >= d1";
                break;
            case 0, $ilwiq.GreaterEqualDepth:
                depthTest = "d0 <= d1";
                break;
            case 0, $ilwiq.GreaterDepth:
            default:
                depthTest = "d0 < d1";
                break;
        }
        this.defines.DEPTH_MODE = value.toFixed(0);
        this.defines["depthTest(d0, d1)"] = depthTest;
        this.needsUpdate = true;
    }
    /**
   * Returns the current depth mode.
   *
   * @deprecated Use depthMode instead.
   * @return {DepthModes} The depth mode. Default is `LessDepth`.
   */ getDepthMode() {
        return this.depthMode;
    }
    /**
   * Sets the depth mode.
   *
   * @deprecated Use depthMode instead.
   * @param {DepthModes} mode - The depth mode.
   */ setDepthMode(mode) {
        this.depthMode = mode;
    }
    /**
   * Copies the settings of the given camera.
   *
   * @deprecated Use copyCameraSettings instead.
   * @param {Camera} camera - A camera.
   */ adoptCameraSettings(camera) {
        this.copyCameraSettings(camera);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNearFar.value.set(camera.near, camera.far);
            if (camera instanceof (0, $ilwiq.PerspectiveCamera)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
};
// src/materials/glsl/convolution.god-rays.frag
var $fe721963ebf18f1b$var$convolution_god_rays_default = "#include <common>\n#include <dithering_pars_fragment>\n#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\nuniform vec2 lightPosition;uniform float exposure;uniform float decay;uniform float density;uniform float weight;uniform float clampMax;varying vec2 vUv;void main(){vec2 coord=vUv;vec2 delta=lightPosition-coord;delta*=1.0/SAMPLES_FLOAT*density;float illuminationDecay=1.0;vec4 color=vec4(0.0);for(int i=0;i<SAMPLES_INT;++i){coord+=delta;vec4 texel=texture2D(inputBuffer,coord);texel*=illuminationDecay*weight;color+=texel;illuminationDecay*=decay;}gl_FragColor=clamp(color*exposure,0.0,clampMax);\n#include <dithering_fragment>\n}";
// src/materials/GodRaysMaterial.js
var $fe721963ebf18f1b$export$4ed51786a9a8bef8 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new god rays material.
   *
   * TODO Remove lightPosition param.
   * @param {Vector2} lightPosition - Deprecated.
   */ constructor(lightPosition){
        super({
            name: "GodRaysMaterial",
            defines: {
                SAMPLES_INT: "60",
                SAMPLES_FLOAT: "60.0"
            },
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                lightPosition: new (0, $ilwiq.Uniform)(lightPosition),
                density: new (0, $ilwiq.Uniform)(1),
                decay: new (0, $ilwiq.Uniform)(1),
                weight: new (0, $ilwiq.Uniform)(1),
                exposure: new (0, $ilwiq.Uniform)(1),
                clampMax: new (0, $ilwiq.Uniform)(1)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$convolution_god_rays_default,
            vertexShader: $fe721963ebf18f1b$var$common_default
        });
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The screen space position of the light source.
   *
   * @type {Vector2}
   */ get lightPosition() {
        return this.uniforms.lightPosition.value;
    }
    /**
   * Returns the screen space position of the light source.
   *
   * @deprecated Use lightPosition instead.
   * @return {Vector2} The position.
   */ getLightPosition() {
        return this.uniforms.lightPosition.value;
    }
    /**
   * Sets the screen space position of the light source.
   *
   * @deprecated Use lightPosition instead.
   * @param {Vector2} value - The position.
   */ setLightPosition(value) {
        this.uniforms.lightPosition.value = value;
    }
    /**
   * The density.
   *
   * @type {Number}
   */ get density() {
        return this.uniforms.density.value;
    }
    set density(value) {
        this.uniforms.density.value = value;
    }
    /**
   * Returns the density.
   *
   * @deprecated Use density instead.
   * @return {Number} The density.
   */ getDensity() {
        return this.uniforms.density.value;
    }
    /**
   * Sets the density.
   *
   * @deprecated Use density instead.
   * @param {Number} value - The density.
   */ setDensity(value) {
        this.uniforms.density.value = value;
    }
    /**
   * The decay.
   *
   * @type {Number}
   */ get decay() {
        return this.uniforms.decay.value;
    }
    set decay(value) {
        this.uniforms.decay.value = value;
    }
    /**
   * Returns the decay.
   *
   * @deprecated Use decay instead.
   * @return {Number} The decay.
   */ getDecay() {
        return this.uniforms.decay.value;
    }
    /**
   * Sets the decay.
   *
   * @deprecated Use decay instead.
   * @param {Number} value - The decay.
   */ setDecay(value) {
        this.uniforms.decay.value = value;
    }
    /**
   * The weight.
   *
   * @type {Number}
   */ get weight() {
        return this.uniforms.weight.value;
    }
    set weight(value) {
        this.uniforms.weight.value = value;
    }
    /**
   * Returns the weight.
   *
   * @deprecated Use weight instead.
   * @return {Number} The weight.
   */ getWeight() {
        return this.uniforms.weight.value;
    }
    /**
   * Sets the weight.
   *
   * @deprecated Use weight instead.
   * @param {Number} value - The weight.
   */ setWeight(value) {
        this.uniforms.weight.value = value;
    }
    /**
   * The exposure.
   *
   * @type {Number}
   */ get exposure() {
        return this.uniforms.exposure.value;
    }
    set exposure(value) {
        this.uniforms.exposure.value = value;
    }
    /**
   * Returns the exposure.
   *
   * @deprecated Use exposure instead.
   * @return {Number} The exposure.
   */ getExposure() {
        return this.uniforms.exposure.value;
    }
    /**
   * Sets the exposure.
   *
   * @deprecated Use exposure instead.
   * @param {Number} value - The exposure.
   */ setExposure(value) {
        this.uniforms.exposure.value = value;
    }
    /**
   * The maximum light intensity.
   *
   * @type {Number}
   */ get maxIntensity() {
        return this.uniforms.clampMax.value;
    }
    set maxIntensity(value) {
        this.uniforms.clampMax.value = value;
    }
    /**
   * Returns the maximum light intensity.
   *
   * @deprecated Use maxIntensity instead.
   * @return {Number} The maximum light intensity.
   */ getMaxIntensity() {
        return this.uniforms.clampMax.value;
    }
    /**
   * Sets the maximum light intensity.
   *
   * @deprecated Use maxIntensity instead.
   * @param {Number} value - The maximum light intensity.
   */ setMaxIntensity(value) {
        this.uniforms.clampMax.value = value;
    }
    /**
   * The amount of samples per pixel.
   *
   * @type {Number}
   */ get samples() {
        return Number(this.defines.SAMPLES_INT);
    }
    set samples(value) {
        const s = Math.floor(value);
        this.defines.SAMPLES_INT = s.toFixed(0);
        this.defines.SAMPLES_FLOAT = s.toFixed(1);
        this.needsUpdate = true;
    }
    /**
   * Returns the amount of samples per pixel.
   *
   * @deprecated Use samples instead.
   * @return {Number} The sample count.
   */ getSamples() {
        return this.samples;
    }
    /**
   * Sets the amount of samples per pixel.
   *
   * @deprecated Use samples instead.
   * @param {Number} value - The sample count.
   */ setSamples(value) {
        this.samples = value;
    }
};
// src/passes/RenderPass.js
var $fe721963ebf18f1b$export$f63ea822f020b5b0 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new render pass.
   *
   * @param {Scene} scene - The scene to render.
   * @param {Camera} camera - The camera to use to render the scene.
   * @param {Material} [overrideMaterial=null] - An override material.
   */ constructor(scene, camera, overrideMaterial = null){
        super("RenderPass", scene, camera);
        this.needsSwap = false;
        this.clearPass = new $fe721963ebf18f1b$export$fc4180e277a6a0c2();
        this.overrideMaterialManager = overrideMaterial === null ? null : new $fe721963ebf18f1b$export$6ef25c308da0147b(overrideMaterial);
        this.ignoreBackground = false;
        this.skipShadowMapUpdate = false;
        this.selection = null;
    }
    set mainScene(value) {
        this.scene = value;
    }
    set mainCamera(value) {
        this.camera = value;
    }
    get renderToScreen() {
        return super.renderToScreen;
    }
    set renderToScreen(value) {
        super.renderToScreen = value;
        this.clearPass.renderToScreen = value;
    }
    /**
   * The current override material.
   *
   * @type {Material}
   */ get overrideMaterial() {
        const manager = this.overrideMaterialManager;
        return manager !== null ? manager.material : null;
    }
    set overrideMaterial(value) {
        const manager = this.overrideMaterialManager;
        if (value !== null) {
            if (manager !== null) manager.setMaterial(value);
            else this.overrideMaterialManager = new $fe721963ebf18f1b$export$6ef25c308da0147b(value);
        } else if (manager !== null) {
            manager.dispose();
            this.overrideMaterialManager = null;
        }
    }
    /**
   * Returns the current override material.
   *
   * @deprecated Use overrideMaterial instead.
   * @return {Material} The material.
   */ getOverrideMaterial() {
        return this.overrideMaterial;
    }
    /**
   * Sets the override material.
   *
   * @deprecated Use overrideMaterial instead.
   * @return {Material} value - The material.
   */ setOverrideMaterial(value) {
        this.overrideMaterial = value;
    }
    /**
   * Indicates whether the target buffer should be cleared before rendering.
   *
   * @type {Boolean}
   * @deprecated Use clearPass.enabled instead.
   */ get clear() {
        return this.clearPass.enabled;
    }
    set clear(value) {
        this.clearPass.enabled = value;
    }
    /**
   * Returns the selection. Default is `null` (no restriction).
   *
   * @deprecated Use selection instead.
   * @return {Selection} The selection.
   */ getSelection() {
        return this.selection;
    }
    /**
   * Sets the selection. Set to `null` to disable.
   *
   * @deprecated Use selection instead.
   * @param {Selection} value - The selection.
   */ setSelection(value) {
        this.selection = value;
    }
    /**
   * Indicates whether the scene background is disabled.
   *
   * @deprecated Use ignoreBackground instead.
   * @return {Boolean} Whether the scene background is disabled.
   */ isBackgroundDisabled() {
        return this.ignoreBackground;
    }
    /**
   * Enables or disables the scene background.
   *
   * @deprecated Use ignoreBackground instead.
   * @param {Boolean} value - Whether the scene background should be disabled.
   */ setBackgroundDisabled(value) {
        this.ignoreBackground = value;
    }
    /**
   * Indicates whether the shadow map auto update is disabled.
   *
   * @deprecated Use skipShadowMapUpdate instead.
   * @return {Boolean} Whether the shadow map update is disabled.
   */ isShadowMapDisabled() {
        return this.skipShadowMapUpdate;
    }
    /**
   * Enables or disables the shadow map auto update.
   *
   * @deprecated Use skipShadowMapUpdate instead.
   * @param {Boolean} value - Whether the shadow map auto update should be disabled.
   */ setShadowMapDisabled(value) {
        this.skipShadowMapUpdate = value;
    }
    /**
   * Returns the clear pass.
   *
   * @deprecated Use clearPass.enabled instead.
   * @return {ClearPass} The clear pass.
   */ getClearPass() {
        return this.clearPass;
    }
    /**
   * Renders the scene.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const scene = this.scene;
        const camera = this.camera;
        const selection = this.selection;
        const mask = camera.layers.mask;
        const background = scene.background;
        const shadowMapAutoUpdate = renderer.shadowMap.autoUpdate;
        const renderTarget = this.renderToScreen ? null : inputBuffer;
        if (selection !== null) camera.layers.set(selection.getLayer());
        if (this.skipShadowMapUpdate) renderer.shadowMap.autoUpdate = false;
        if (this.ignoreBackground || this.clearPass.overrideClearColor !== null) scene.background = null;
        if (this.clearPass.enabled) this.clearPass.render(renderer, inputBuffer);
        renderer.setRenderTarget(renderTarget);
        if (this.overrideMaterialManager !== null) this.overrideMaterialManager.render(renderer, scene, camera);
        else renderer.render(scene, camera);
        camera.layers.mask = mask;
        scene.background = background;
        renderer.shadowMap.autoUpdate = shadowMapAutoUpdate;
    }
};
// src/effects/glsl/god-rays.frag
var $fe721963ebf18f1b$var$god_rays_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D map;\n#else\nuniform lowp sampler2D map;\n#endif\nvoid mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=texture2D(map,uv);}";
// src/effects/GodRaysEffect.js
var $fe721963ebf18f1b$var$v = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
var $fe721963ebf18f1b$var$m = /* @__PURE__ */ new (0, $ilwiq.Matrix4)();
var $fe721963ebf18f1b$export$6c90045c82ddd8e9 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new god rays effect.
   *
   * @param {Camera} [camera] - The main camera.
   * @param {Mesh|Points} [lightSource] - The light source. Must not write depth and has to be flagged as transparent.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function of this effect.
   * @param {Number} [options.samples=60.0] - The number of samples per pixel.
   * @param {Number} [options.density=0.96] - The density of the light rays.
   * @param {Number} [options.decay=0.9] - An illumination decay factor.
   * @param {Number} [options.weight=0.4] - A light ray weight factor.
   * @param {Number} [options.exposure=0.6] - A constant attenuation coefficient.
   * @param {Number} [options.clampMax=1.0] - An upper bound for the saturation of the overall effect.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   * @param {KernelSize} [options.kernelSize=KernelSize.SMALL] - The blur kernel size. Has no effect if blur is disabled.
   * @param {Boolean} [options.blur=true] - Whether the god rays should be blurred to reduce artifacts.
   */ constructor(camera, lightSource, { blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SCREEN, samples: samples = 60, density: density = 0.96, decay: decay = 0.9, weight: weight = 0.4, exposure: exposure = 0.6, clampMax: clampMax = 1, blur: blur = true, kernelSize: kernelSize = $fe721963ebf18f1b$export$543b1e4815577d06.SMALL, resolutionScale: resolutionScale = 0.5, width: width = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, height: height = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("GodRaysEffect", $fe721963ebf18f1b$var$god_rays_default, {
            blendFunction: blendFunction,
            attributes: $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "map",
                    new (0, $ilwiq.Uniform)(null)
                ]
            ])
        });
        this.camera = camera;
        this._lightSource = lightSource;
        this.lightSource = lightSource;
        this.lightScene = new (0, $ilwiq.Scene)();
        this.screenPosition = new (0, $ilwiq.Vector2)();
        this.renderTargetA = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetA.texture.name = "GodRays.Target.A";
        this.renderTargetB = this.renderTargetA.clone();
        this.renderTargetB.texture.name = "GodRays.Target.B";
        this.uniforms.get("map").value = this.renderTargetB.texture;
        this.renderTargetLight = new (0, $ilwiq.WebGLRenderTarget)(1, 1);
        this.renderTargetLight.texture.name = "GodRays.Light";
        this.renderTargetLight.depthTexture = new (0, $ilwiq.DepthTexture)();
        this.renderPassLight = new $fe721963ebf18f1b$export$f63ea822f020b5b0(this.lightScene, camera);
        this.renderPassLight.clearPass.overrideClearColor = new (0, $ilwiq.Color)(0);
        this.clearPass = new $fe721963ebf18f1b$export$fc4180e277a6a0c2(true, false, false);
        this.clearPass.overrideClearColor = new (0, $ilwiq.Color)(0);
        this.blurPass = new $fe721963ebf18f1b$export$657273fee9302035({
            kernelSize: kernelSize
        });
        this.blurPass.enabled = blur;
        this.depthMaskPass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$fe1d84eaa823805a());
        const depthMaskMaterial = this.depthMaskMaterial;
        depthMaskMaterial.depthBuffer1 = this.renderTargetLight.depthTexture;
        depthMaskMaterial.copyCameraSettings(camera);
        this.godRaysPass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$4ed51786a9a8bef8(this.screenPosition));
        const godRaysMaterial = this.godRaysMaterial;
        godRaysMaterial.density = density;
        godRaysMaterial.decay = decay;
        godRaysMaterial.weight = weight;
        godRaysMaterial.exposure = exposure;
        godRaysMaterial.maxIntensity = clampMax;
        godRaysMaterial.samples = samples;
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    set mainCamera(value) {
        this.camera = value;
        this.renderPassLight.mainCamera = value;
        this.depthMaskMaterial.copyCameraSettings(value);
    }
    /**
   * Sets the light source.
   *
   * @type {Mesh|Points}
   */ get lightSource() {
        return this._lightSource;
    }
    set lightSource(value) {
        this._lightSource = value;
        if (value !== null) {
            value.material.depthWrite = false;
            value.material.transparent = true;
        }
    }
    /**
   * Returns the blur pass that reduces aliasing artifacts and makes the light softer.
   *
   * @deprecated Use blurPass instead.
   * @return {KawaseBlurPass} The blur pass.
   */ getBlurPass() {
        return this.blurPass;
    }
    /**
   * A texture that contains the intermediate result of this effect.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTargetB.texture;
    }
    /**
   * Returns the god rays texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.texture;
    }
    /**
   * The depth mask material.
   *
   * @type {DepthMaskMaterial}
   * @private
   */ get depthMaskMaterial() {
        return this.depthMaskPass.fullscreenMaterial;
    }
    /**
   * The internal god rays material.
   *
   * @type {GodRaysMaterial}
   */ get godRaysMaterial() {
        return this.godRaysPass.fullscreenMaterial;
    }
    /**
   * Returns the god rays material.
   *
   * @deprecated Use godRaysMaterial instead.
   * @return {GodRaysMaterial} The material.
   */ getGodRaysMaterial() {
        return this.godRaysMaterial;
    }
    /**
   * Returns the resolution of this effect.
   *
   * @deprecated Use resolution instead.
   * @return {GodRaysMaterial} The material.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * The current width of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.width instead.
   */ get width() {
        return this.resolution.width;
    }
    set width(value) {
        this.resolution.preferredWidth = value;
    }
    /**
   * The current height of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.height instead.
   */ get height() {
        return this.resolution.height;
    }
    set height(value) {
        this.resolution.preferredHeight = value;
    }
    /**
   * Indicates whether dithering is enabled.
   *
   * @type {Boolean}
   * @deprecated
   */ get dithering() {
        return this.godRaysMaterial.dithering;
    }
    set dithering(value) {
        const material = this.godRaysMaterial;
        material.dithering = value;
        material.needsUpdate = true;
    }
    /**
   * Indicates whether the god rays should be blurred to reduce artifacts.
   *
   * @type {Boolean}
   * @deprecated Use blurPass.enabled instead.
   */ get blur() {
        return this.blurPass.enabled;
    }
    set blur(value) {
        this.blurPass.enabled = value;
    }
    /**
   * The blur kernel size.
   *
   * @type {KernelSize}
   * @deprecated Use blurPass.kernelSize instead.
   */ get kernelSize() {
        return this.blurPass.kernelSize;
    }
    set kernelSize(value) {
        this.blurPass.kernelSize = value;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated Use resolution instead.
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated Use resolution instead.
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * The number of samples per pixel.
   *
   * @type {Number}
   * @deprecated Use godRaysMaterial.samples instead.
   */ get samples() {
        return this.godRaysMaterial.samples;
    }
    /**
   * A higher sample count improves quality at the cost of performance.
   *
   * @type {Number}
   * @deprecated Use godRaysMaterial.samples instead.
   */ set samples(value) {
        this.godRaysMaterial.samples = value;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {Number} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthMaskPass.fullscreenMaterial.depthBuffer0 = depthTexture;
        this.depthMaskPass.fullscreenMaterial.depthPacking0 = depthPacking;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const lightSource = this.lightSource;
        const parent = lightSource.parent;
        const matrixAutoUpdate = lightSource.matrixAutoUpdate;
        const renderTargetA = this.renderTargetA;
        const renderTargetLight = this.renderTargetLight;
        lightSource.material.depthWrite = true;
        lightSource.matrixAutoUpdate = false;
        lightSource.updateWorldMatrix(true, false);
        if (parent !== null) {
            if (!matrixAutoUpdate) $fe721963ebf18f1b$var$m.copy(lightSource.matrix);
            lightSource.matrix.copy(lightSource.matrixWorld);
        }
        this.lightScene.add(lightSource);
        this.renderPassLight.render(renderer, renderTargetLight);
        this.clearPass.render(renderer, renderTargetA);
        this.depthMaskPass.render(renderer, renderTargetLight, renderTargetA);
        lightSource.material.depthWrite = false;
        lightSource.matrixAutoUpdate = matrixAutoUpdate;
        if (parent !== null) {
            if (!matrixAutoUpdate) lightSource.matrix.copy($fe721963ebf18f1b$var$m);
            parent.add(lightSource);
        }
        $fe721963ebf18f1b$var$v.setFromMatrixPosition(lightSource.matrixWorld).project(this.camera);
        this.screenPosition.set(Math.min(Math.max(($fe721963ebf18f1b$var$v.x + 1) * 0.5, -1), 2), Math.min(Math.max(($fe721963ebf18f1b$var$v.y + 1) * 0.5, -1), 2));
        if (this.blurPass.enabled) this.blurPass.render(renderer, renderTargetA, renderTargetA);
        this.godRaysPass.render(renderer, renderTargetA, this.renderTargetB);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.renderTargetA.setSize(w, h);
        this.renderTargetB.setSize(w, h);
        this.renderTargetLight.setSize(w, h);
        this.blurPass.resolution.copy(resolution);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.blurPass.initialize(renderer, alpha, frameBufferType);
        this.renderPassLight.initialize(renderer, alpha, frameBufferType);
        this.depthMaskPass.initialize(renderer, alpha, frameBufferType);
        this.godRaysPass.initialize(renderer, alpha, frameBufferType);
        if (frameBufferType !== void 0) {
            this.renderTargetA.texture.type = frameBufferType;
            this.renderTargetB.texture.type = frameBufferType;
            this.renderTargetLight.texture.type = frameBufferType;
            if (renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) {
                this.renderTargetA.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
                this.renderTargetB.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
                this.renderTargetLight.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
            }
        }
    }
};
// src/effects/glsl/grid.frag
var $fe721963ebf18f1b$var$grid_default = "uniform vec2 scale;uniform float lineWidth;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){float grid=0.5-max(abs(mod(uv.x*scale.x,1.0)-0.5),abs(mod(uv.y*scale.y,1.0)-0.5));outputColor=vec4(vec3(smoothstep(0.0,lineWidth,grid)),inputColor.a);}";
// src/effects/GridEffect.js
var $fe721963ebf18f1b$export$196041dbe92a1b1 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new grid effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.OVERLAY] - The blend function of this effect.
   * @param {Number} [options.scale=1.0] - The scale of the grid pattern.
   * @param {Number} [options.lineWidth=0.0] - The line width of the grid pattern.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.OVERLAY, scale: scale = 1, lineWidth: lineWidth = 0 } = {}){
        super("GridEffect", $fe721963ebf18f1b$var$grid_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "scale",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)())
                ],
                [
                    "lineWidth",
                    new (0, $ilwiq.Uniform)(lineWidth)
                ]
            ])
        });
        this.resolution = new (0, $ilwiq.Vector2)();
        this.s = 0;
        this.scale = scale;
        this.l = 0;
        this.lineWidth = lineWidth;
    }
    /**
   * The scale.
   *
   * @type {Number}
   */ get scale() {
        return this.s;
    }
    set scale(value) {
        this.s = Math.max(value, 1e-6);
        this.setSize(this.resolution.width, this.resolution.height);
    }
    /**
   * Returns the current grid scale.
   *
   * @deprecated Use scale instead.
   * @return {Number} The grid scale.
   */ getScale() {
        return this.scale;
    }
    /**
   * Sets the grid scale.
   *
   * @deprecated Use scale instead.
   * @param {Number} value - The new grid scale.
   */ setScale(value) {
        this.scale = value;
    }
    /**
   * The line width.
   *
   * @type {Number}
   */ get lineWidth() {
        return this.l;
    }
    set lineWidth(value) {
        this.l = value;
        this.setSize(this.resolution.width, this.resolution.height);
    }
    /**
   * Returns the current grid line width.
   *
   * @deprecated Use lineWidth instead.
   * @return {Number} The grid line width.
   */ getLineWidth() {
        return this.lineWidth;
    }
    /**
   * Sets the grid line width.
   *
   * @deprecated Use lineWidth instead.
   * @param {Number} value - The new grid line width.
   */ setLineWidth(value) {
        this.lineWidth = value;
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.resolution.set(width, height);
        const aspect = width / height;
        const scale = this.scale * (height * 0.125);
        this.uniforms.get("scale").value.set(aspect * scale, scale);
        this.uniforms.get("lineWidth").value = scale / height + this.lineWidth;
    }
};
// src/effects/glsl/hue-saturation.frag
var $fe721963ebf18f1b$var$hue_saturation_default = "uniform vec3 hue;uniform float saturation;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(dot(inputColor.rgb,hue.xyz),dot(inputColor.rgb,hue.zxy),dot(inputColor.rgb,hue.yzx));float average=(color.r+color.g+color.b)/3.0;vec3 diff=average-color;if(saturation>0.0){color+=diff*(1.0-1.0/(1.001-saturation));}else{color+=diff*-saturation;}outputColor=vec4(min(color,1.0),inputColor.a);}";
// src/effects/HueSaturationEffect.js
var $fe721963ebf18f1b$export$cb84d7708921e909 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new hue/saturation effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Number} [options.hue=0.0] - The hue in radians.
   * @param {Number} [options.saturation=0.0] - The saturation factor, ranging from -1 to 1, where 0 means no change.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SRC, hue: hue = 0, saturation: saturation = 0 } = {}){
        super("HueSaturationEffect", $fe721963ebf18f1b$var$hue_saturation_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "hue",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector3)())
                ],
                [
                    "saturation",
                    new (0, $ilwiq.Uniform)(saturation)
                ]
            ])
        });
        this.hue = hue;
    }
    /**
   * The saturation.
   *
   * @type {Number}
   */ get saturation() {
        return this.uniforms.get("saturation").value;
    }
    set saturation(value) {
        this.uniforms.get("saturation").value = value;
    }
    /**
   * Returns the saturation.
   *
   * @deprecated Use saturation instead.
   * @return {Number} The saturation.
   */ getSaturation() {
        return this.saturation;
    }
    /**
   * Sets the saturation.
   *
   * @deprecated Use saturation instead.
   * @param {Number} value - The saturation.
   */ setSaturation(value) {
        this.saturation = value;
    }
    /**
   * The hue.
   *
   * @type {Number}
   */ get hue() {
        const hue = this.uniforms.get("hue").value;
        return Math.acos((hue.x * 3 - 1) / 2);
    }
    set hue(value) {
        const s = Math.sin(value), c2 = Math.cos(value);
        this.uniforms.get("hue").value.set((2 * c2 + 1) / 3, (-Math.sqrt(3) * s - c2 + 1) / 3, (Math.sqrt(3) * s - c2 + 1) / 3);
    }
    /**
   * Returns the hue.
   *
   * @deprecated Use hue instead.
   * @return {Number} The hue in radians.
   */ getHue() {
        return this.hue;
    }
    /**
   * Sets the hue.
   *
   * @deprecated Use hue instead.
   * @param {Number} value - The hue in radians.
   */ setHue(value) {
        this.hue = value;
    }
};
// src/effects/glsl/lens-distortion.frag
var $fe721963ebf18f1b$var$lens_distortion_default = "uniform vec2 distortion;uniform vec2 principalPoint;uniform vec2 focalLength;uniform float skew;float mask(const in vec2 uv){return float(uv.s>=0.0&&uv.s<=1.0&&uv.t>=0.0&&uv.t<=1.0);}void mainUv(inout vec2 uv){vec2 xn=2.0*(uv.st-0.5);vec3 xDistorted=vec3((1.0+distortion*dot(xn,xn))*xn,1.0);mat3 kk=mat3(vec3(focalLength.x,0.0,0.0),vec3(skew*focalLength.x,focalLength.y,0.0),vec3(principalPoint.x,principalPoint.y,1.0));uv=(kk*xDistorted).xy*0.5+0.5;}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=mask(uv)*inputColor;}";
// src/effects/LensDistortionEffect.js
var $fe721963ebf18f1b$export$1d92d776a41aead9 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new lens distortion effect.
   *
   * @param {Object} [options] - The options.
   * @param {Vector2} [options.distortion] - The distortion value.
   * @param {Vector2} [options.principalPoint] - The center point.
   * @param {Vector2} [options.focalLength] - The focal length.
   * @param {Number} [options.skew=0] - The skew value.
   */ constructor({ distortion: distortion = new (0, $ilwiq.Vector2)(0, 0), principalPoint: principalPoint = new (0, $ilwiq.Vector2)(0, 0), focalLength: focalLength = new (0, $ilwiq.Vector2)(1, 1), skew: skew = 0 } = {}){
        super("LensDistortionEffect", $fe721963ebf18f1b$var$lens_distortion_default, {
            uniforms: /* @__PURE__ */ new Map([
                [
                    "distortion",
                    new (0, $ilwiq.Uniform)(distortion)
                ],
                [
                    "principalPoint",
                    new (0, $ilwiq.Uniform)(principalPoint)
                ],
                [
                    "focalLength",
                    new (0, $ilwiq.Uniform)(focalLength)
                ],
                [
                    "skew",
                    new (0, $ilwiq.Uniform)(skew)
                ]
            ])
        });
    }
    /**
   * The radial distortion coefficients. Default is (0, 0).
   *
   * @type {Vector2}
   */ get distortion() {
        return this.uniforms.get("distortion").value;
    }
    set distortion(value) {
        this.uniforms.get("distortion").value = value;
    }
    /**
   * The principal point. Default is (0, 0).
   *
   * @type {Vector2}
   */ get principalPoint() {
        return this.uniforms.get("principalPoint").value;
    }
    set principalPoint(value) {
        this.uniforms.get("principalPoint").value = value;
    }
    /**
   * The focal length. Default is (1, 1).
   *
   * @type {Vector2}
   */ get focalLength() {
        return this.uniforms.get("focalLength").value;
    }
    set focalLength(value) {
        this.uniforms.get("focalLength").value = value;
    }
    /**
   * The skew factor in radians.
   *
   * @type {Number}
   */ get skew() {
        return this.uniforms.get("skew").value;
    }
    set skew(value) {
        this.uniforms.get("skew").value = value;
    }
};
// src/effects/glsl/lut-1d.frag
var $fe721963ebf18f1b$var$lut_1d_default = "#ifdef LUT_PRECISION_HIGH\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D lut;\n#else\nuniform mediump sampler2D lut;\n#endif\n#else\nuniform lowp sampler2D lut;\n#endif\nvoid mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=vec4(texture2D(lut,vec2(inputColor.r,0.5)).r,texture2D(lut,vec2(inputColor.g,0.5)).r,texture2D(lut,vec2(inputColor.b,0.5)).r,inputColor.a);}";
// src/effects/LUT1DEffect.js
var $fe721963ebf18f1b$export$66593ee27ed5b22a = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new color grading effect.
   *
   * @param {Texture} lut - The lookup texture.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   */ constructor(lut, { blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SRC } = {}){
        super("LUT1DEffect", $fe721963ebf18f1b$var$lut_1d_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "lut",
                    new (0, $ilwiq.Uniform)(null)
                ]
            ])
        });
        this.lut = lut;
    }
    /**
   * The LUT.
   *
   * @type {Texture}
   */ get lut() {
        return this.uniforms.get("lut").value;
    }
    set lut(value) {
        this.uniforms.get("lut").value = value;
        if (value !== null && (value.type === (0, $ilwiq.FloatType) || value.type === (0, $ilwiq.HalfFloatType))) this.defines.set("LUT_PRECISION_HIGH", "1");
    }
};
// src/enums/LUTOperation.js
var $fe721963ebf18f1b$export$1e225700a60fe544 = {
    SCALE_UP: "lut.scaleup"
};
// src/textures/RawImageData.js
function $fe721963ebf18f1b$var$createCanvas(width, height, data) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = width;
    canvas.height = height;
    if (data instanceof Image) context.drawImage(data, 0, 0);
    else {
        const imageData = context.createImageData(width, height);
        imageData.data.set(data);
        context.putImageData(imageData, 0, 0);
    }
    return canvas;
}
var $fe721963ebf18f1b$export$82a80f8de384fe62 = class _RawImageData {
    /**
   * Constructs a new image data container.
   *
   * @param {Number} [width=0] - The width of the image.
   * @param {Number} [height=0] - The height of the image.
   * @param {Uint8ClampedArray} [data=null] - The image data.
   */ constructor(width = 0, height = 0, data = null){
        this.width = width;
        this.height = height;
        this.data = data;
    }
    /**
   * Creates a canvas from this image data.
   *
   * @return {Canvas} The canvas, or null if it couldn't be created.
   */ toCanvas() {
        return typeof document === "undefined" ? null : $fe721963ebf18f1b$var$createCanvas(this.width, this.height, this.data);
    }
    /**
   * Creates a new image data container.
   *
   * @param {ImageData|Image} image - An image or plain image data.
   * @return {RawImageData} The image data.
   */ static from(image) {
        const { width: width, height: height } = image;
        let data;
        if (image instanceof Image) {
            const canvas = $fe721963ebf18f1b$var$createCanvas(width, height, image);
            if (canvas !== null) {
                const context = canvas.getContext("2d");
                data = context.getImageData(0, 0, width, height).data;
            }
        } else data = image.data;
        return new _RawImageData(width, height, data);
    }
};
// tmp/lut/worker.txt
var $fe721963ebf18f1b$var$worker_default = '"use strict";(()=>{var O={SCALE_UP:"lut.scaleup"};var _=[new Float32Array(3),new Float32Array(3)],n=[new Float32Array(3),new Float32Array(3),new Float32Array(3),new Float32Array(3)],Z=[[new Float32Array([0,0,0]),new Float32Array([1,0,0]),new Float32Array([1,1,0]),new Float32Array([1,1,1])],[new Float32Array([0,0,0]),new Float32Array([1,0,0]),new Float32Array([1,0,1]),new Float32Array([1,1,1])],[new Float32Array([0,0,0]),new Float32Array([0,0,1]),new Float32Array([1,0,1]),new Float32Array([1,1,1])],[new Float32Array([0,0,0]),new Float32Array([0,1,0]),new Float32Array([1,1,0]),new Float32Array([1,1,1])],[new Float32Array([0,0,0]),new Float32Array([0,1,0]),new Float32Array([0,1,1]),new Float32Array([1,1,1])],[new Float32Array([0,0,0]),new Float32Array([0,0,1]),new Float32Array([0,1,1]),new Float32Array([1,1,1])]];function d(a,t,r,m){let i=r[0]-t[0],e=r[1]-t[1],y=r[2]-t[2],h=a[0]-t[0],A=a[1]-t[1],w=a[2]-t[2],c=e*w-y*A,l=y*h-i*w,x=i*A-e*h,u=Math.sqrt(c*c+l*l+x*x),b=u*.5,s=c/u,F=l/u,f=x/u,p=-(a[0]*s+a[1]*F+a[2]*f),M=m[0]*s+m[1]*F+m[2]*f;return Math.abs(M+p)*b/3}function V(a,t,r,m,i,e){let y=(r+m*t+i*t*t)*4;e[0]=a[y+0],e[1]=a[y+1],e[2]=a[y+2]}function k(a,t,r,m,i,e){let y=r*(t-1),h=m*(t-1),A=i*(t-1),w=Math.floor(y),c=Math.floor(h),l=Math.floor(A),x=Math.ceil(y),u=Math.ceil(h),b=Math.ceil(A),s=y-w,F=h-c,f=A-l;if(w===y&&c===h&&l===A)V(a,t,y,h,A,e);else{let p;s>=F&&F>=f?p=Z[0]:s>=f&&f>=F?p=Z[1]:f>=s&&s>=F?p=Z[2]:F>=s&&s>=f?p=Z[3]:F>=f&&f>=s?p=Z[4]:f>=F&&F>=s&&(p=Z[5]);let[M,g,X,Y]=p,P=_[0];P[0]=s,P[1]=F,P[2]=f;let o=_[1],L=x-w,S=u-c,U=b-l;o[0]=L*M[0]+w,o[1]=S*M[1]+c,o[2]=U*M[2]+l,V(a,t,o[0],o[1],o[2],n[0]),o[0]=L*g[0]+w,o[1]=S*g[1]+c,o[2]=U*g[2]+l,V(a,t,o[0],o[1],o[2],n[1]),o[0]=L*X[0]+w,o[1]=S*X[1]+c,o[2]=U*X[2]+l,V(a,t,o[0],o[1],o[2],n[2]),o[0]=L*Y[0]+w,o[1]=S*Y[1]+c,o[2]=U*Y[2]+l,V(a,t,o[0],o[1],o[2],n[3]);let T=d(g,X,Y,P)*6,q=d(M,X,Y,P)*6,C=d(M,g,Y,P)*6,E=d(M,g,X,P)*6;n[0][0]*=T,n[0][1]*=T,n[0][2]*=T,n[1][0]*=q,n[1][1]*=q,n[1][2]*=q,n[2][0]*=C,n[2][1]*=C,n[2][2]*=C,n[3][0]*=E,n[3][1]*=E,n[3][2]*=E,e[0]=n[0][0]+n[1][0]+n[2][0]+n[3][0],e[1]=n[0][1]+n[1][1]+n[2][1]+n[3][1],e[2]=n[0][2]+n[1][2]+n[2][2]+n[3][2]}}var v=class{static expand(t,r){let m=Math.cbrt(t.length/4),i=new Float32Array(3),e=new t.constructor(r**3*4),y=t instanceof Uint8Array?255:1,h=r**2,A=1/(r-1);for(let w=0;w<r;++w)for(let c=0;c<r;++c)for(let l=0;l<r;++l){let x=l*A,u=c*A,b=w*A,s=Math.round(l+c*r+w*h)*4;k(t,m,x,u,b,i),e[s+0]=i[0],e[s+1]=i[1],e[s+2]=i[2],e[s+3]=y}return e}};self.addEventListener("message",a=>{let t=a.data,r=t.data;switch(t.operation){case O.SCALE_UP:r=v.expand(r,t.size);break}postMessage(r,[r.buffer]),close()});})();\n';
// src/textures/lut/LookupTexture.js
var $fe721963ebf18f1b$var$c = /* @__PURE__ */ new (0, $ilwiq.Color)();
var $fe721963ebf18f1b$export$a3627e735a49df45 = class _LookupTexture extends (0, $ilwiq.Data3DTexture) {
    /**
   * Constructs a cubic 3D lookup texture.
   *
   * @param {TypedArray} data - The pixel data. The default format is RGBA.
   * @param {Number} size - The sidelength.
   */ constructor(data, size){
        super(data, size, size, size);
        this.type = (0, $ilwiq.FloatType);
        this.format = (0, $ilwiq.RGBAFormat);
        this.minFilter = (0, $ilwiq.LinearFilter);
        this.magFilter = (0, $ilwiq.LinearFilter);
        this.wrapS = (0, $ilwiq.ClampToEdgeWrapping);
        this.wrapT = (0, $ilwiq.ClampToEdgeWrapping);
        this.wrapR = (0, $ilwiq.ClampToEdgeWrapping);
        this.unpackAlignment = 1;
        this.needsUpdate = true;
        this.colorSpace = (0, $ilwiq.LinearSRGBColorSpace);
        this.domainMin = new (0, $ilwiq.Vector3)(0, 0, 0);
        this.domainMax = new (0, $ilwiq.Vector3)(1, 1, 1);
    }
    /**
   * Indicates that this is an instance of LookupTexture3D.
   *
   * @type {Boolean}
   * @deprecated
   */ get isLookupTexture3D() {
        return true;
    }
    /**
   * Scales this LUT up to a given target size using tetrahedral interpolation.
   *
   * @param {Number} size - The target sidelength.
   * @param {Boolean} [transferData=true] - Extra fast mode. Set to false to keep the original data intact.
   * @return {Promise<LookupTexture>} A promise that resolves with a new LUT upon completion.
   */ scaleUp(size, transferData = true) {
        const image = this.image;
        let promise;
        if (size <= image.width) promise = Promise.reject(new Error("The target size must be greater than the current size"));
        else promise = new Promise((resolve, reject)=>{
            const workerURL = URL.createObjectURL(new Blob([
                $fe721963ebf18f1b$var$worker_default
            ], {
                type: "text/javascript"
            }));
            const worker = new Worker(workerURL);
            worker.addEventListener("error", (event)=>reject(event.error));
            worker.addEventListener("message", (event)=>{
                const lut = new _LookupTexture(event.data, size);
                this.colorSpace = lut.colorSpace;
                lut.type = this.type;
                lut.name = this.name;
                URL.revokeObjectURL(workerURL);
                resolve(lut);
            });
            const transferList = transferData ? [
                image.data.buffer
            ] : [];
            worker.postMessage({
                operation: $fe721963ebf18f1b$export$1e225700a60fe544.SCALE_UP,
                data: image.data,
                size: size
            }, transferList);
        });
        return promise;
    }
    /**
   * Applies the given LUT to this one.
   *
   * @param {LookupTexture} lut - A LUT. Must have the same dimensions, type and format as this LUT.
   * @return {LookupTexture} This texture.
   */ applyLUT(lut) {
        const img0 = this.image;
        const img1 = lut.image;
        const size0 = Math.min(img0.width, img0.height, img0.depth);
        const size1 = Math.min(img1.width, img1.height, img1.depth);
        if (size0 !== size1) console.error("Size mismatch");
        else if (lut.type !== (0, $ilwiq.FloatType) || this.type !== (0, $ilwiq.FloatType)) console.error("Both LUTs must be FloatType textures");
        else if (lut.format !== (0, $ilwiq.RGBAFormat) || this.format !== (0, $ilwiq.RGBAFormat)) console.error("Both LUTs must be RGBA textures");
        else {
            const data0 = img0.data;
            const data1 = img1.data;
            const size = size0;
            const sizeSq = size ** 2;
            const s = size - 1;
            for(let i = 0, l = size ** 3; i < l; ++i){
                const i4 = i * 4;
                const r = data0[i4 + 0] * s;
                const g = data0[i4 + 1] * s;
                const b = data0[i4 + 2] * s;
                const iRGB = Math.round(r + g * size + b * sizeSq) * 4;
                data0[i4 + 0] = data1[iRGB + 0];
                data0[i4 + 1] = data1[iRGB + 1];
                data0[i4 + 2] = data1[iRGB + 2];
            }
            this.needsUpdate = true;
        }
        return this;
    }
    /**
   * Converts the LUT data into unsigned byte data.
   *
   * This is a lossy operation which should only be performed after all other transformations have been applied.
   *
   * @return {LookupTexture} This texture.
   */ convertToUint8() {
        if (this.type === (0, $ilwiq.FloatType)) {
            const floatData = this.image.data;
            const uint8Data = new Uint8Array(floatData.length);
            for(let i = 0, l = floatData.length; i < l; ++i)uint8Data[i] = floatData[i] * 255 + 0.5;
            this.image.data = uint8Data;
            this.type = (0, $ilwiq.UnsignedByteType);
            this.needsUpdate = true;
        }
        return this;
    }
    /**
   * Converts the LUT data into float data.
   *
   * @return {LookupTexture} This texture.
   */ convertToFloat() {
        if (this.type === (0, $ilwiq.UnsignedByteType)) {
            const uint8Data = this.image.data;
            const floatData = new Float32Array(uint8Data.length);
            for(let i = 0, l = uint8Data.length; i < l; ++i)floatData[i] = uint8Data[i] / 255;
            this.image.data = floatData;
            this.type = (0, $ilwiq.FloatType);
            this.needsUpdate = true;
        }
        return this;
    }
    /**
   * Converts this LUT into RGBA data.
   *
   * @deprecated LUTs are RGBA by default since three r137.
   * @return {LookupTexture} This texture.
   */ convertToRGBA() {
        console.warn("LookupTexture", "convertToRGBA() is deprecated, LUTs are now RGBA by default");
        return this;
    }
    /**
   * Converts the output of this LUT into sRGB color space.
   *
   * @return {LookupTexture} This texture.
   */ convertLinearToSRGB() {
        const data = this.image.data;
        if (this.type === (0, $ilwiq.FloatType)) {
            for(let i = 0, l = data.length; i < l; i += 4)$fe721963ebf18f1b$var$c.fromArray(data, i).convertLinearToSRGB().toArray(data, i);
            this.colorSpace = (0, $ilwiq.SRGBColorSpace);
            this.needsUpdate = true;
        } else console.error("Color space conversion requires FloatType data");
        return this;
    }
    /**
   * Converts the output of this LUT into linear color space.
   *
   * @return {LookupTexture} This texture.
   */ convertSRGBToLinear() {
        const data = this.image.data;
        if (this.type === (0, $ilwiq.FloatType)) {
            for(let i = 0, l = data.length; i < l; i += 4)$fe721963ebf18f1b$var$c.fromArray(data, i).convertSRGBToLinear().toArray(data, i);
            this.colorSpace = (0, $ilwiq.LinearSRGBColorSpace);
            this.needsUpdate = true;
        } else console.error("Color space conversion requires FloatType data");
        return this;
    }
    /**
   * Converts this LUT into a 2D data texture.
   *
   * Please note that custom input domains are not carried over to 2D textures.
   *
   * @return {DataTexture} The texture.
   */ toDataTexture() {
        const width = this.image.width;
        const height = this.image.height * this.image.depth;
        const texture = new (0, $ilwiq.DataTexture)(this.image.data, width, height);
        texture.name = this.name;
        texture.type = this.type;
        texture.format = this.format;
        texture.minFilter = (0, $ilwiq.LinearFilter);
        texture.magFilter = (0, $ilwiq.LinearFilter);
        texture.wrapS = this.wrapS;
        texture.wrapT = this.wrapT;
        texture.generateMipmaps = false;
        texture.needsUpdate = true;
        this.colorSpace = texture.colorSpace;
        return texture;
    }
    /**
   * Creates a new 3D LUT by copying a given LUT.
   *
   * Common image-based textures will be converted into 3D data textures.
   *
   * @param {Texture} texture - The LUT. Assumed to be cubic.
   * @return {LookupTexture} A new 3D LUT.
   */ static from(texture) {
        const image = texture.image;
        const { width: width, height: height } = image;
        const size = Math.min(width, height);
        let data;
        if (image instanceof Image) {
            const rawImageData = $fe721963ebf18f1b$export$82a80f8de384fe62.from(image);
            const src = rawImageData.data;
            if (width > height) {
                data = new Uint8Array(src.length);
                for(let z = 0; z < size; ++z){
                    for(let y = 0; y < size; ++y)for(let x = 0; x < size; ++x){
                        const i4 = (x + z * size + y * size * size) * 4;
                        const j4 = (x + y * size + z * size * size) * 4;
                        data[j4 + 0] = src[i4 + 0];
                        data[j4 + 1] = src[i4 + 1];
                        data[j4 + 2] = src[i4 + 2];
                        data[j4 + 3] = src[i4 + 3];
                    }
                }
            } else data = new Uint8Array(src.buffer);
        } else data = image.data.slice();
        const lut = new _LookupTexture(data, size);
        lut.type = texture.type;
        lut.name = texture.name;
        texture.colorSpace = lut.colorSpace;
        return lut;
    }
    /**
   * Creates a neutral 3D LUT.
   *
   * @param {Number} size - The sidelength.
   * @return {LookupTexture} A neutral 3D LUT.
   */ static createNeutral(size) {
        const data = new Float32Array(size ** 3 * 4);
        const sizeSq = size ** 2;
        const s = 1 / (size - 1);
        for(let r = 0; r < size; ++r){
            for(let g = 0; g < size; ++g)for(let b = 0; b < size; ++b){
                const i4 = (r + g * size + b * sizeSq) * 4;
                data[i4 + 0] = r * s;
                data[i4 + 1] = g * s;
                data[i4 + 2] = b * s;
                data[i4 + 3] = 1;
            }
        }
        const lut = new _LookupTexture(data, size);
        lut.name = "neutral";
        return lut;
    }
};
// src/effects/glsl/lut-3d.frag
var $fe721963ebf18f1b$var$lut_3d_default = "uniform vec3 scale;uniform vec3 offset;\n#ifdef CUSTOM_INPUT_DOMAIN\nuniform vec3 domainMin;uniform vec3 domainMax;\n#endif\n#ifdef LUT_3D\n#ifdef LUT_PRECISION_HIGH\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler3D lut;\n#else\nuniform mediump sampler3D lut;\n#endif\n#else\nuniform lowp sampler3D lut;\n#endif\nvec4 applyLUT(const in vec3 rgb){\n#ifdef TETRAHEDRAL_INTERPOLATION\nvec3 p=floor(rgb);vec3 f=rgb-p;vec3 v1=(p+0.5)*LUT_TEXEL_WIDTH;vec3 v4=(p+1.5)*LUT_TEXEL_WIDTH;vec3 v2,v3;vec3 frac;if(f.r>=f.g){if(f.g>f.b){frac=f.rgb;v2=vec3(v4.x,v1.y,v1.z);v3=vec3(v4.x,v4.y,v1.z);}else if(f.r>=f.b){frac=f.rbg;v2=vec3(v4.x,v1.y,v1.z);v3=vec3(v4.x,v1.y,v4.z);}else{frac=f.brg;v2=vec3(v1.x,v1.y,v4.z);v3=vec3(v4.x,v1.y,v4.z);}}else{if(f.b>f.g){frac=f.bgr;v2=vec3(v1.x,v1.y,v4.z);v3=vec3(v1.x,v4.y,v4.z);}else if(f.r>=f.b){frac=f.grb;v2=vec3(v1.x,v4.y,v1.z);v3=vec3(v4.x,v4.y,v1.z);}else{frac=f.gbr;v2=vec3(v1.x,v4.y,v1.z);v3=vec3(v1.x,v4.y,v4.z);}}vec4 n1=texture(lut,v1);vec4 n2=texture(lut,v2);vec4 n3=texture(lut,v3);vec4 n4=texture(lut,v4);vec4 weights=vec4(1.0-frac.x,frac.x-frac.y,frac.y-frac.z,frac.z);vec4 result=weights*mat4(vec4(n1.r,n2.r,n3.r,n4.r),vec4(n1.g,n2.g,n3.g,n4.g),vec4(n1.b,n2.b,n3.b,n4.b),vec4(1.0));return vec4(result.rgb,1.0);\n#else\nreturn texture(lut,rgb);\n#endif\n}\n#else\n#ifdef LUT_PRECISION_HIGH\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D lut;\n#else\nuniform mediump sampler2D lut;\n#endif\n#else\nuniform lowp sampler2D lut;\n#endif\nvec4 applyLUT(const in vec3 rgb){float slice=rgb.b*LUT_SIZE;float slice0=floor(slice);float interp=slice-slice0;float centeredInterp=interp-0.5;float slice1=slice0+sign(centeredInterp);\n#ifdef LUT_STRIP_HORIZONTAL\nfloat xOffset=clamp(rgb.r*LUT_TEXEL_HEIGHT,LUT_TEXEL_WIDTH*0.5,LUT_TEXEL_HEIGHT-LUT_TEXEL_WIDTH*0.5);vec2 uv0=vec2(slice0*LUT_TEXEL_HEIGHT+xOffset,rgb.g);vec2 uv1=vec2(slice1*LUT_TEXEL_HEIGHT+xOffset,rgb.g);\n#else\nfloat yOffset=clamp(rgb.g*LUT_TEXEL_WIDTH,LUT_TEXEL_HEIGHT*0.5,LUT_TEXEL_WIDTH-LUT_TEXEL_HEIGHT*0.5);vec2 uv0=vec2(rgb.r,slice0*LUT_TEXEL_WIDTH+yOffset);vec2 uv1=vec2(rgb.r,slice1*LUT_TEXEL_WIDTH+yOffset);\n#endif\nvec4 sample0=texture2D(lut,uv0);vec4 sample1=texture2D(lut,uv1);return mix(sample0,sample1,abs(centeredInterp));}\n#endif\nvoid mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 c=inputColor.rgb;\n#ifdef CUSTOM_INPUT_DOMAIN\nif(c.r>=domainMin.r&&c.g>=domainMin.g&&c.b>=domainMin.b&&c.r<=domainMax.r&&c.g<=domainMax.g&&c.b<=domainMax.b){c=applyLUT(scale*c+offset).rgb;}else{c=inputColor.rgb;}\n#else\n#if !defined(LUT_3D) || defined(TETRAHEDRAL_INTERPOLATION)\nc=clamp(c,0.0,1.0);\n#endif\nc=applyLUT(scale*c+offset).rgb;\n#endif\noutputColor=vec4(c,inputColor.a);}";
// src/effects/LUT3DEffect.js
var $fe721963ebf18f1b$export$16c73198fba02ce9 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new color grading effect.
   *
   * @param {Texture} lut - The lookup texture.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Boolean} [options.tetrahedralInterpolation=false] - Enables or disables tetrahedral interpolation.
   * @param {ColorSpace} [options.inputColorSpace=SRGBColorSpace] - The input color space.
   */ constructor(lut, { blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SRC, tetrahedralInterpolation: tetrahedralInterpolation = false, inputColorSpace: inputColorSpace = (0, $ilwiq.SRGBColorSpace) } = {}){
        super("LUT3DEffect", $fe721963ebf18f1b$var$lut_3d_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "lut",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "scale",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector3)())
                ],
                [
                    "offset",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector3)())
                ],
                [
                    "domainMin",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "domainMax",
                    new (0, $ilwiq.Uniform)(null)
                ]
            ])
        });
        this.tetrahedralInterpolation = tetrahedralInterpolation;
        this.inputColorSpace = inputColorSpace;
        this.lut = lut;
    }
    /**
   * The LUT.
   *
   * @type {Texture}
   */ get lut() {
        return this.uniforms.get("lut").value;
    }
    set lut(value) {
        const defines = this.defines;
        const uniforms = this.uniforms;
        if (this.lut !== value) {
            uniforms.get("lut").value = value;
            if (value !== null) {
                const image = value.image;
                const tetrahedralInterpolation = this.tetrahedralInterpolation;
                defines.clear();
                defines.set("LUT_SIZE", Math.min(image.width, image.height).toFixed(16));
                defines.set("LUT_TEXEL_WIDTH", (1 / image.width).toFixed(16));
                defines.set("LUT_TEXEL_HEIGHT", (1 / image.height).toFixed(16));
                uniforms.get("domainMin").value = null;
                uniforms.get("domainMax").value = null;
                if (value.type === (0, $ilwiq.FloatType) || value.type === (0, $ilwiq.HalfFloatType)) defines.set("LUT_PRECISION_HIGH", "1");
                if (image.width > image.height) defines.set("LUT_STRIP_HORIZONTAL", "1");
                else if (value instanceof (0, $ilwiq.Data3DTexture)) defines.set("LUT_3D", "1");
                if (value instanceof $fe721963ebf18f1b$export$a3627e735a49df45) {
                    const min = value.domainMin;
                    const max = value.domainMax;
                    if (min.x !== 0 || min.y !== 0 || min.z !== 0 || max.x !== 1 || max.y !== 1 || max.z !== 1) {
                        defines.set("CUSTOM_INPUT_DOMAIN", "1");
                        uniforms.get("domainMin").value = min.clone();
                        uniforms.get("domainMax").value = max.clone();
                    }
                }
                this.tetrahedralInterpolation = tetrahedralInterpolation;
            }
        }
    }
    /**
   * Returns the current LUT.
   *
   * @deprecated Use lut instead.
   * @return {Texture} The LUT.
   */ getLUT() {
        return this.lut;
    }
    /**
   * Sets the LUT.
   *
   * @deprecated Use lut instead.
   * @param {Texture} value - The LUT.
   */ setLUT(value) {
        this.lut = value;
    }
    /**
   * Updates the scale and offset for the LUT sampling coordinates.
   *
   * @private
   */ updateScaleOffset() {
        const lut = this.lut;
        if (lut !== null) {
            const size = Math.min(lut.image.width, lut.image.height);
            const scale = this.uniforms.get("scale").value;
            const offset = this.uniforms.get("offset").value;
            if (this.tetrahedralInterpolation && lut instanceof (0, $ilwiq.Data3DTexture)) {
                if (this.defines.has("CUSTOM_INPUT_DOMAIN")) {
                    const domainScale = lut.domainMax.clone().sub(lut.domainMin);
                    scale.setScalar(size - 1).divide(domainScale);
                    offset.copy(lut.domainMin).negate().multiply(scale);
                } else {
                    scale.setScalar(size - 1);
                    offset.setScalar(0);
                }
            } else if (this.defines.has("CUSTOM_INPUT_DOMAIN")) {
                const domainScale = lut.domainMax.clone().sub(lut.domainMin).multiplyScalar(size);
                scale.setScalar(size - 1).divide(domainScale);
                offset.copy(lut.domainMin).negate().multiply(scale).addScalar(1 / (2 * size));
            } else {
                scale.setScalar((size - 1) / size);
                offset.setScalar(1 / (2 * size));
            }
        }
    }
    /**
   * Configures parameters for tetrahedral interpolation.
   *
   * @private
   */ configureTetrahedralInterpolation() {
        const lut = this.lut;
        if (lut !== null) {
            lut.minFilter = (0, $ilwiq.LinearFilter);
            lut.magFilter = (0, $ilwiq.LinearFilter);
            if (this.tetrahedralInterpolation) {
                if (lut instanceof (0, $ilwiq.Data3DTexture)) {
                    lut.minFilter = (0, $ilwiq.NearestFilter);
                    lut.magFilter = (0, $ilwiq.NearestFilter);
                } else console.warn("Tetrahedral interpolation requires a 3D texture");
            }
            lut.needsUpdate = true;
        }
    }
    /**
   * Indicates whether tetrahedral interpolation is enabled. Requires a 3D LUT, disabled by default.
   *
   * Tetrahedral interpolation produces highly accurate results but is slower than hardware interpolation.
   *
   * @type {Boolean}
   */ get tetrahedralInterpolation() {
        return this.defines.has("TETRAHEDRAL_INTERPOLATION");
    }
    set tetrahedralInterpolation(value) {
        if (value) this.defines.set("TETRAHEDRAL_INTERPOLATION", "1");
        else this.defines.delete("TETRAHEDRAL_INTERPOLATION");
        this.configureTetrahedralInterpolation();
        this.updateScaleOffset();
        this.setChanged();
    }
    /**
   * Enables or disables tetrahedral interpolation.
   *
   * @deprecated Use tetrahedralInterpolation instead.
   * @param {Boolean} value - Whether tetrahedral interpolation should be enabled.
   */ setTetrahedralInterpolationEnabled(value) {
        this.tetrahedralInterpolation = value;
    }
};
// src/enums/DepthCopyMode.js
var $fe721963ebf18f1b$export$f14251d45898bc40 = {
    FULL: 0,
    SINGLE: 1
};
// src/enums/EdgeDetectionMode.js
var $fe721963ebf18f1b$export$20d1071ff7b64a56 = {
    DEPTH: 0,
    LUMA: 1,
    COLOR: 2
};
// src/enums/PredicationMode.js
var $fe721963ebf18f1b$export$6b657d16effdfea4 = {
    DISABLED: 0,
    DEPTH: 1,
    CUSTOM: 2
};
// src/enums/SMAAPreset.js
var $fe721963ebf18f1b$export$829eaccd811a63f = {
    LOW: 0,
    MEDIUM: 1,
    HIGH: 2,
    ULTRA: 3
};
// src/enums/ToneMappingMode.js
var $fe721963ebf18f1b$export$f72cb1a914b4b608 = {
    LINEAR: 0,
    REINHARD: 1,
    REINHARD2: 2,
    REINHARD2_ADAPTIVE: 3,
    UNCHARTED2: 4,
    OPTIMIZED_CINEON: 5,
    CINEON: 5,
    ACES_FILMIC: 6,
    AGX: 7,
    NEUTRAL: 8
};
// src/enums/VignetteTechnique.js
var $fe721963ebf18f1b$export$57fe020f9fbd56c7 = {
    DEFAULT: 0,
    ESKIL: 1
};
// src/enums/WebGLExtension.js
var $fe721963ebf18f1b$export$f67e9dcf2e8ac241 = {
    DERIVATIVES: "derivatives",
    FRAG_DEPTH: "fragDepth",
    DRAW_BUFFERS: "drawBuffers",
    SHADER_TEXTURE_LOD: "shaderTextureLOD"
};
// src/effects/glsl/noise.frag
var $fe721963ebf18f1b$var$noise_default = "void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 noise=vec3(rand(uv*(1.0+time)));\n#ifdef PREMULTIPLY\noutputColor=vec4(min(inputColor.rgb*noise,vec3(1.0)),inputColor.a);\n#else\noutputColor=vec4(noise,inputColor.a);\n#endif\n}";
// src/effects/NoiseEffect.js
var $fe721963ebf18f1b$export$1d02386659918a72 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new noise effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function of this effect.
   * @param {Boolean} [options.premultiply=false] - Whether the noise should be multiplied with the input colors prior to blending.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SCREEN, premultiply: premultiply = false } = {}){
        super("NoiseEffect", $fe721963ebf18f1b$var$noise_default, {
            blendFunction: blendFunction
        });
        this.premultiply = premultiply;
    }
    /**
   * Indicates whether noise will be multiplied with the input colors prior to blending.
   *
   * @type {Boolean}
   */ get premultiply() {
        return this.defines.has("PREMULTIPLY");
    }
    set premultiply(value) {
        if (this.premultiply !== value) {
            if (value) this.defines.set("PREMULTIPLY", "1");
            else this.defines.delete("PREMULTIPLY");
            this.setChanged();
        }
    }
    /**
   * Indicates whether noise will be multiplied with the input colors prior to blending.
   *
   * @deprecated Use premultiply instead.
   * @return {Boolean} Whether noise is premultiplied.
   */ isPremultiplied() {
        return this.premultiply;
    }
    /**
   * Controls whether noise should be multiplied with the input colors prior to blending.
   *
   * @deprecated Use premultiply instead.
   * @param {Boolean} value - Whether noise should be premultiplied.
   */ setPremultiplied(value) {
        this.premultiply = value;
    }
};
// src/materials/glsl/depth-comparison.frag
var $fe721963ebf18f1b$var$depth_comparison_default = "#include <packing>\n#include <clipping_planes_pars_fragment>\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D depthBuffer;\n#else\nuniform mediump sampler2D depthBuffer;\n#endif\nuniform float cameraNear;uniform float cameraFar;centroid varying float vViewZ;centroid varying vec4 vProjTexCoord;void main(){\n#include <clipping_planes_fragment>\nvec2 projTexCoord=(vProjTexCoord.xy/vProjTexCoord.w)*0.5+0.5;projTexCoord=clamp(projTexCoord,0.002,0.998);\n#if DEPTH_PACKING == 3201\nfloat fragCoordZ=unpackRGBAToDepth(texture2D(depthBuffer,projTexCoord));\n#else\nfloat fragCoordZ=texture2D(depthBuffer,projTexCoord).r;\n#endif\n#ifdef PERSPECTIVE_CAMERA\nfloat viewZ=perspectiveDepthToViewZ(fragCoordZ,cameraNear,cameraFar);\n#else\nfloat viewZ=orthographicDepthToViewZ(fragCoordZ,cameraNear,cameraFar);\n#endif\nfloat depthTest=(-vViewZ>-viewZ)?1.0:0.0;gl_FragColor.rg=vec2(0.0,depthTest);}";
// src/materials/glsl/depth-comparison.vert
var $fe721963ebf18f1b$var$depth_comparison_default2 = "#include <common>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying float vViewZ;varying vec4 vProjTexCoord;void main(){\n#include <skinbase_vertex>\n#include <begin_vertex>\n#include <morphtarget_vertex>\n#include <skinning_vertex>\n#include <project_vertex>\nvViewZ=mvPosition.z;vProjTexCoord=gl_Position;\n#include <clipping_planes_vertex>\n}";
// src/materials/DepthComparisonMaterial.js
var $fe721963ebf18f1b$export$36b10598ef35408b = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new depth comparison material.
   *
   * @param {Texture} [depthTexture=null] - A depth texture.
   * @param {PerspectiveCamera} [camera] - A camera.
   */ constructor(depthTexture = null, camera){
        super({
            name: "DepthComparisonMaterial",
            defines: {
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new (0, $ilwiq.Uniform)(null),
                cameraNear: new (0, $ilwiq.Uniform)(0.3),
                cameraFar: new (0, $ilwiq.Uniform)(1e3)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$depth_comparison_default,
            vertexShader: $fe721963ebf18f1b$var$depth_comparison_default2
        });
        this.depthBuffer = depthTexture;
        this.depthPacking = (0, $ilwiq.RGBADepthPacking);
        this.copyCameraSettings(camera);
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=RGBADepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ilwiq.RGBADepthPacking)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * Copies the settings of the given camera.
   *
   * @deprecated Use copyCameraSettings instead.
   * @param {Camera} camera - A camera.
   */ adoptCameraSettings(camera) {
        this.copyCameraSettings(camera);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNear.value = camera.near;
            this.uniforms.cameraFar.value = camera.far;
            if (camera instanceof (0, $ilwiq.PerspectiveCamera)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
};
// src/materials/glsl/outline.frag
var $fe721963ebf18f1b$var$outline_default = "uniform lowp sampler2D inputBuffer;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 c0=texture2D(inputBuffer,vUv0).rg;vec2 c1=texture2D(inputBuffer,vUv1).rg;vec2 c2=texture2D(inputBuffer,vUv2).rg;vec2 c3=texture2D(inputBuffer,vUv3).rg;float d0=(c0.x-c1.x)*0.5;float d1=(c2.x-c3.x)*0.5;float d=length(vec2(d0,d1));float a0=min(c0.y,c1.y);float a1=min(c2.y,c3.y);float visibilityFactor=min(a0,a1);gl_FragColor.rg=(1.0-visibilityFactor>0.001)?vec2(d,0.0):vec2(0.0,d);}";
// src/materials/glsl/outline.vert
var $fe721963ebf18f1b$var$outline_default2 = "uniform vec2 texelSize;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vUv0=vec2(uv.x+texelSize.x,uv.y);vUv1=vec2(uv.x-texelSize.x,uv.y);vUv2=vec2(uv.x,uv.y+texelSize.y);vUv3=vec2(uv.x,uv.y-texelSize.y);gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/OutlineMaterial.js
var $fe721963ebf18f1b$export$f17d9235adad998c = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new outline material.
   *
   * TODO Remove texelSize param.
   * @param {Vector2} [texelSize] - The screen texel size.
   */ constructor(texelSize = new (0, $ilwiq.Vector2)()){
        super({
            name: "OutlineMaterial",
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                texelSize: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)())
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$outline_default,
            vertexShader: $fe721963ebf18f1b$var$outline_default2
        });
        this.uniforms.texelSize.value.set(texelSize.x, texelSize.y);
        this.uniforms.maskTexture = this.uniforms.inputBuffer;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the texel size.
   *
   * @deprecated Use setSize() instead.
   * @param {Number} x - The texel width.
   * @param {Number} y - The texel height.
   */ setTexelSize(x, y) {
        this.uniforms.texelSize.value.set(x, y);
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
var $fe721963ebf18f1b$export$4059e0d5f564fa1 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new depth pass.
   *
   * @param {Scene} scene - The scene to render.
   * @param {Camera} camera - The camera to use to render the scene.
   * @param {Object} [options] - The options.
   * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor(scene, camera, { renderTarget: renderTarget, resolutionScale: resolutionScale = 1, width: width = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, height: height = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("DepthPass");
        this.needsSwap = false;
        this.renderPass = new $fe721963ebf18f1b$export$f63ea822f020b5b0(scene, camera, new (0, $ilwiq.MeshDepthMaterial)({
            depthPacking: (0, $ilwiq.RGBADepthPacking)
        }));
        const renderPass = this.renderPass;
        renderPass.skipShadowMapUpdate = true;
        renderPass.ignoreBackground = true;
        const clearPass = renderPass.clearPass;
        clearPass.overrideClearColor = new (0, $ilwiq.Color)(16777215);
        clearPass.overrideClearAlpha = 1;
        this.renderTarget = renderTarget;
        if (this.renderTarget === void 0) {
            this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
                minFilter: (0, $ilwiq.NearestFilter),
                magFilter: (0, $ilwiq.NearestFilter)
            });
            this.renderTarget.texture.name = "DepthPass.Target";
        }
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    set mainScene(value) {
        this.renderPass.mainScene = value;
    }
    set mainCamera(value) {
        this.renderPass.mainCamera = value;
    }
    /**
   * The depth texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the depth texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated Use resolution instead.
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated Use resolution instead.
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * Renders the scene depth.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const renderTarget = this.renderToScreen ? null : this.renderTarget;
        this.renderPass.render(renderer, renderTarget);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
    }
};
// src/effects/glsl/outline.frag
var $fe721963ebf18f1b$var$outline_default3 = "uniform lowp sampler2D edgeTexture;uniform lowp sampler2D maskTexture;uniform vec3 visibleEdgeColor;uniform vec3 hiddenEdgeColor;uniform float pulse;uniform float edgeStrength;\n#ifdef USE_PATTERN\nuniform lowp sampler2D patternTexture;varying vec2 vUvPattern;\n#endif\nvoid mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 edge=texture2D(edgeTexture,uv).rg;vec2 mask=texture2D(maskTexture,uv).rg;\n#ifndef X_RAY\nedge.y=0.0;\n#endif\nedge*=(edgeStrength*mask.x*pulse);vec3 color=edge.x*visibleEdgeColor+edge.y*hiddenEdgeColor;float visibilityFactor=0.0;\n#ifdef USE_PATTERN\nvec4 patternColor=texture2D(patternTexture,vUvPattern);\n#ifdef X_RAY\nfloat hiddenFactor=0.5;\n#else\nfloat hiddenFactor=0.0;\n#endif\nvisibilityFactor=(1.0-mask.y>0.0)?1.0:hiddenFactor;visibilityFactor*=(1.0-mask.x)*patternColor.a;color+=visibilityFactor*patternColor.rgb;\n#endif\nfloat alpha=max(max(edge.x,edge.y),visibilityFactor);\n#ifdef ALPHA\noutputColor=vec4(color,alpha);\n#else\noutputColor=vec4(color,max(alpha,inputColor.a));\n#endif\n}";
// src/effects/glsl/outline.vert
var $fe721963ebf18f1b$var$outline_default4 = "uniform float patternScale;varying vec2 vUvPattern;void mainSupport(const in vec2 uv){vUvPattern=uv*vec2(aspect,1.0)*patternScale;}";
// src/effects/OutlineEffect.js
var $fe721963ebf18f1b$export$7c28220b97a65a06 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new outline effect.
   *
   * @param {Scene} scene - The main scene.
   * @param {Camera} camera - The main camera.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function. Use `BlendFunction.ALPHA` for dark outlines.
   * @param {Texture} [options.patternTexture=null] - A pattern texture.
   * @param {Number} [options.patternScale=1.0] - The pattern scale.
   * @param {Number} [options.edgeStrength=1.0] - The edge strength.
   * @param {Number} [options.pulseSpeed=0.0] - The pulse speed. A value of zero disables the pulse effect.
   * @param {Number} [options.visibleEdgeColor=0xffffff] - The color of visible edges.
   * @param {Number} [options.hiddenEdgeColor=0x22090a] - The color of hidden edges.
   * @param {KernelSize} [options.kernelSize=KernelSize.VERY_SMALL] - The blur kernel size.
   * @param {Boolean} [options.blur=false] - Whether the outline should be blurred.
   * @param {Boolean} [options.xRay=true] - Whether occluded parts of selected objects should be visible.
   * @param {Number} [options.multisampling=0] - The number of samples used for multisample antialiasing. Requires WebGL 2.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor(scene, camera, { blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SCREEN, patternTexture: patternTexture = null, patternScale: patternScale = 1, edgeStrength: edgeStrength = 1, pulseSpeed: pulseSpeed = 0, visibleEdgeColor: visibleEdgeColor = 16777215, hiddenEdgeColor: hiddenEdgeColor = 2230538, kernelSize: kernelSize = $fe721963ebf18f1b$export$543b1e4815577d06.VERY_SMALL, blur: blur = false, xRay: xRay = true, multisampling: multisampling = 0, resolutionScale: resolutionScale = 0.5, width: width = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, height: height = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("OutlineEffect", $fe721963ebf18f1b$var$outline_default3, {
            uniforms: /* @__PURE__ */ new Map([
                [
                    "maskTexture",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "edgeTexture",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "edgeStrength",
                    new (0, $ilwiq.Uniform)(edgeStrength)
                ],
                [
                    "visibleEdgeColor",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Color)(visibleEdgeColor))
                ],
                [
                    "hiddenEdgeColor",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Color)(hiddenEdgeColor))
                ],
                [
                    "pulse",
                    new (0, $ilwiq.Uniform)(1)
                ],
                [
                    "patternScale",
                    new (0, $ilwiq.Uniform)(patternScale)
                ],
                [
                    "patternTexture",
                    new (0, $ilwiq.Uniform)(null)
                ]
            ])
        });
        this.blendMode.addEventListener("change", (event)=>{
            if (this.blendMode.blendFunction === $fe721963ebf18f1b$export$ea7520add44ba1b6.ALPHA) this.defines.set("ALPHA", "1");
            else this.defines.delete("ALPHA");
            this.setChanged();
        });
        this.blendMode.blendFunction = blendFunction;
        this.patternTexture = patternTexture;
        this.xRay = xRay;
        this.scene = scene;
        this.camera = camera;
        this.renderTargetMask = new (0, $ilwiq.WebGLRenderTarget)(1, 1);
        this.renderTargetMask.samples = multisampling;
        this.renderTargetMask.texture.name = "Outline.Mask";
        this.uniforms.get("maskTexture").value = this.renderTargetMask.texture;
        this.renderTargetOutline = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetOutline.texture.name = "Outline.Edges";
        this.uniforms.get("edgeTexture").value = this.renderTargetOutline.texture;
        this.clearPass = new $fe721963ebf18f1b$export$fc4180e277a6a0c2();
        this.clearPass.overrideClearColor = new (0, $ilwiq.Color)(0);
        this.clearPass.overrideClearAlpha = 1;
        this.depthPass = new $fe721963ebf18f1b$export$4059e0d5f564fa1(scene, camera);
        this.maskPass = new $fe721963ebf18f1b$export$f63ea822f020b5b0(scene, camera, new $fe721963ebf18f1b$export$36b10598ef35408b(this.depthPass.texture, camera));
        const clearPass = this.maskPass.clearPass;
        clearPass.overrideClearColor = new (0, $ilwiq.Color)(16777215);
        clearPass.overrideClearAlpha = 1;
        this.blurPass = new $fe721963ebf18f1b$export$657273fee9302035({
            resolutionScale: resolutionScale,
            resolutionX: resolutionX,
            resolutionY: resolutionY,
            kernelSize: kernelSize
        });
        this.blurPass.enabled = blur;
        const resolution = this.blurPass.resolution;
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.outlinePass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$f17d9235adad998c());
        const outlineMaterial = this.outlinePass.fullscreenMaterial;
        outlineMaterial.inputBuffer = this.renderTargetMask.texture;
        this.time = 0;
        this.forceUpdate = true;
        this.selection = new $fe721963ebf18f1b$export$52baac22726c72bf();
        this.pulseSpeed = pulseSpeed;
    }
    set mainScene(value) {
        this.scene = value;
        this.depthPass.mainScene = value;
        this.maskPass.mainScene = value;
    }
    set mainCamera(value) {
        this.camera = value;
        this.depthPass.mainCamera = value;
        this.maskPass.mainCamera = value;
        this.maskPass.overrideMaterial.copyCameraSettings(value);
    }
    /**
   * The resolution of this effect.
   *
   * @type {Resolution}
   */ get resolution() {
        return this.blurPass.resolution;
    }
    /**
   * Returns the resolution.
   *
   * @return {Resizer} The resolution.
   */ getResolution() {
        return this.blurPass.getResolution();
    }
    /**
   * The amount of MSAA samples.
   *
   * Requires WebGL 2. Set to zero to disable multisampling.
   *
   * @experimental Requires three >= r138.
   * @type {Number}
   */ get multisampling() {
        return this.renderTargetMask.samples;
    }
    set multisampling(value) {
        this.renderTargetMask.samples = value;
        this.renderTargetMask.dispose();
    }
    /**
   * The pattern scale.
   *
   * @type {Number}
   */ get patternScale() {
        return this.uniforms.get("patternScale").value;
    }
    set patternScale(value) {
        this.uniforms.get("patternScale").value = value;
    }
    /**
   * The edge strength.
   *
   * @type {Number}
   */ get edgeStrength() {
        return this.uniforms.get("edgeStrength").value;
    }
    set edgeStrength(value) {
        this.uniforms.get("edgeStrength").value = value;
    }
    /**
   * The visible edge color.
   *
   * @type {Color}
   */ get visibleEdgeColor() {
        return this.uniforms.get("visibleEdgeColor").value;
    }
    set visibleEdgeColor(value) {
        this.uniforms.get("visibleEdgeColor").value = value;
    }
    /**
   * The hidden edge color.
   *
   * @type {Color}
   */ get hiddenEdgeColor() {
        return this.uniforms.get("hiddenEdgeColor").value;
    }
    set hiddenEdgeColor(value) {
        this.uniforms.get("hiddenEdgeColor").value = value;
    }
    /**
   * Returns the blur pass.
   *
   * @deprecated Use blurPass instead.
   * @return {KawaseBlurPass} The blur pass.
   */ getBlurPass() {
        return this.blurPass;
    }
    /**
   * Returns the selection.
   *
   * @deprecated Use selection instead.
   * @return {Selection} The selection.
   */ getSelection() {
        return this.selection;
    }
    /**
   * Returns the pulse speed.
   *
   * @deprecated Use pulseSpeed instead.
   * @return {Number} The speed.
   */ getPulseSpeed() {
        return this.pulseSpeed;
    }
    /**
   * Sets the pulse speed. Set to zero to disable.
   *
   * @deprecated Use pulseSpeed instead.
   * @param {Number} value - The speed.
   */ setPulseSpeed(value) {
        this.pulseSpeed = value;
    }
    /**
   * The current width of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.width instead.
   */ get width() {
        return this.resolution.width;
    }
    set width(value) {
        this.resolution.preferredWidth = value;
    }
    /**
   * The current height of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.height instead.
   */ get height() {
        return this.resolution.height;
    }
    set height(value) {
        this.resolution.preferredHeight = value;
    }
    /**
   * The selection layer.
   *
   * @type {Number}
   * @deprecated Use selection.layer instead.
   */ get selectionLayer() {
        return this.selection.layer;
    }
    set selectionLayer(value) {
        this.selection.layer = value;
    }
    /**
   * Indicates whether dithering is enabled.
   *
   * @type {Boolean}
   * @deprecated
   */ get dithering() {
        return this.blurPass.dithering;
    }
    set dithering(value) {
        this.blurPass.dithering = value;
    }
    /**
   * The blur kernel size.
   *
   * @type {KernelSize}
   * @deprecated Use blurPass.kernelSize instead.
   */ get kernelSize() {
        return this.blurPass.kernelSize;
    }
    set kernelSize(value) {
        this.blurPass.kernelSize = value;
    }
    /**
   * Indicates whether the outlines should be blurred.
   *
   * @type {Boolean}
   * @deprecated Use blurPass.enabled instead.
   */ get blur() {
        return this.blurPass.enabled;
    }
    set blur(value) {
        this.blurPass.enabled = value;
    }
    /**
   * Indicates whether X-ray mode is enabled.
   *
   * @type {Boolean}
   */ get xRay() {
        return this.defines.has("X_RAY");
    }
    set xRay(value) {
        if (this.xRay !== value) {
            if (value) this.defines.set("X_RAY", "1");
            else this.defines.delete("X_RAY");
            this.setChanged();
        }
    }
    /**
   * Indicates whether X-ray mode is enabled.
   *
   * @deprecated Use xRay instead.
   * @return {Boolean} Whether X-ray mode is enabled.
   */ isXRayEnabled() {
        return this.xRay;
    }
    /**
   * Enables or disables X-ray outlines.
   *
   * @deprecated Use xRay instead.
   * @param {Boolean} value - Whether X-ray should be enabled.
   */ setXRayEnabled(value) {
        this.xRay = value;
    }
    /**
   * The pattern texture. Set to `null` to disable.
   *
   * @type {Texture}
   */ get patternTexture() {
        return this.uniforms.get("patternTexture").value;
    }
    set patternTexture(value) {
        if (value !== null) {
            value.wrapS = value.wrapT = (0, $ilwiq.RepeatWrapping);
            this.defines.set("USE_PATTERN", "1");
            this.setVertexShader($fe721963ebf18f1b$var$outline_default4);
        } else {
            this.defines.delete("USE_PATTERN");
            this.setVertexShader(null);
        }
        this.uniforms.get("patternTexture").value = value;
        this.setChanged();
    }
    /**
   * Sets the pattern texture.
   *
   * @deprecated Use patternTexture instead.
   * @param {Texture} value - The new texture.
   */ setPatternTexture(value) {
        this.patternTexture = value;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated Use resolution instead.
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated Use resolution instead.
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * Clears the current selection and selects a list of objects.
   *
   * @param {Object3D[]} objects - The objects that should be outlined. This array will be copied.
   * @return {OutlinePass} This pass.
   * @deprecated Use selection.set() instead.
   */ setSelection(objects) {
        this.selection.set(objects);
        return this;
    }
    /**
   * Clears the list of selected objects.
   *
   * @return {OutlinePass} This pass.
   * @deprecated Use selection.clear() instead.
   */ clearSelection() {
        this.selection.clear();
        return this;
    }
    /**
   * Selects an object.
   *
   * @param {Object3D} object - The object that should be outlined.
   * @return {OutlinePass} This pass.
   * @deprecated Use selection.add() instead.
   */ selectObject(object) {
        this.selection.add(object);
        return this;
    }
    /**
   * Deselects an object.
   *
   * @param {Object3D} object - The object that should no longer be outlined.
   * @return {OutlinePass} This pass.
   * @deprecated Use selection.delete() instead.
   */ deselectObject(object) {
        this.selection.delete(object);
        return this;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const scene = this.scene;
        const camera = this.camera;
        const selection = this.selection;
        const uniforms = this.uniforms;
        const pulse = uniforms.get("pulse");
        const background = scene.background;
        const mask = camera.layers.mask;
        if (this.forceUpdate || selection.size > 0) {
            scene.background = null;
            pulse.value = 1;
            if (this.pulseSpeed > 0) pulse.value = Math.cos(this.time * this.pulseSpeed * 10) * 0.375 + 0.625;
            this.time += deltaTime;
            selection.setVisible(false);
            this.depthPass.render(renderer);
            selection.setVisible(true);
            camera.layers.set(selection.layer);
            this.maskPass.render(renderer, this.renderTargetMask);
            camera.layers.mask = mask;
            scene.background = background;
            this.outlinePass.render(renderer, null, this.renderTargetOutline);
            if (this.blurPass.enabled) this.blurPass.render(renderer, this.renderTargetOutline, this.renderTargetOutline);
        }
        this.forceUpdate = selection.size > 0;
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.blurPass.setSize(width, height);
        this.renderTargetMask.setSize(width, height);
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.depthPass.setSize(w, h);
        this.renderTargetOutline.setSize(w, h);
        this.outlinePass.fullscreenMaterial.setSize(w, h);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.blurPass.initialize(renderer, alpha, (0, $ilwiq.UnsignedByteType));
        if (frameBufferType !== void 0) {
            this.depthPass.initialize(renderer, alpha, frameBufferType);
            this.maskPass.initialize(renderer, alpha, frameBufferType);
            this.outlinePass.initialize(renderer, alpha, frameBufferType);
        }
    }
};
// src/effects/glsl/pixelation.frag
var $fe721963ebf18f1b$var$pixelation_default = "uniform bool active;uniform vec4 d;void mainUv(inout vec2 uv){if(active){uv=d.xy*(floor(uv*d.zw)+0.5);}}";
// src/effects/PixelationEffect.js
var $fe721963ebf18f1b$export$be408d53e0133e76 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new pixelation effect.
   *
   * @param {Object} [granularity=30.0] - The pixel granularity.
   */ constructor(granularity = 30){
        super("PixelationEffect", $fe721963ebf18f1b$var$pixelation_default, {
            uniforms: /* @__PURE__ */ new Map([
                [
                    "active",
                    new (0, $ilwiq.Uniform)(false)
                ],
                [
                    "d",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector4)())
                ]
            ])
        });
        this.resolution = new (0, $ilwiq.Vector2)();
        this._granularity = 0;
        this.granularity = granularity;
    }
    /**
   * The pixel granularity.
   *
   * A higher value yields coarser visuals.
   *
   * @type {Number}
   */ get granularity() {
        return this._granularity;
    }
    set granularity(value) {
        let d = Math.floor(value);
        if (d % 2 > 0) d += 1;
        this._granularity = d;
        this.uniforms.get("active").value = d > 0;
        this.setSize(this.resolution.width, this.resolution.height);
    }
    /**
   * Returns the pixel granularity.
   *
   * @deprecated Use granularity instead.
   * @return {Number} The granularity.
   */ getGranularity() {
        return this.granularity;
    }
    /**
   * Sets the pixel granularity.
   *
   * @deprecated Use granularity instead.
   * @param {Number} value - The new granularity.
   */ setGranularity(value) {
        this.granularity = value;
    }
    /**
   * Updates the granularity.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.set(width, height);
        const d = this.granularity;
        const x = d / resolution.x;
        const y = d / resolution.y;
        this.uniforms.get("d").value.set(x, y, 1 / x, 1 / y);
    }
};
// src/effects/glsl/realistic-bokeh.frag
var $fe721963ebf18f1b$var$realistic_bokeh_default = "uniform float focus;uniform float focalLength;uniform float fStop;uniform float maxBlur;uniform float luminanceThreshold;uniform float luminanceGain;uniform float bias;uniform float fringe;\n#ifdef MANUAL_DOF\nuniform vec4 dof;\n#endif\n#ifdef PENTAGON\nfloat pentagon(const in vec2 coords){const vec4 HS0=vec4(1.0,0.0,0.0,1.0);const vec4 HS1=vec4(0.309016994,0.951056516,0.0,1.0);const vec4 HS2=vec4(-0.809016994,0.587785252,0.0,1.0);const vec4 HS3=vec4(-0.809016994,-0.587785252,0.0,1.0);const vec4 HS4=vec4(0.309016994,-0.951056516,0.0,1.0);const vec4 HS5=vec4(0.0,0.0,1.0,1.0);const vec4 ONE=vec4(1.0);const float P_FEATHER=0.4;const float N_FEATHER=-P_FEATHER;float inOrOut=-4.0;vec4 P=vec4(coords,vec2(RINGS_FLOAT-1.3));vec4 dist=vec4(dot(P,HS0),dot(P,HS1),dot(P,HS2),dot(P,HS3));dist=smoothstep(N_FEATHER,P_FEATHER,dist);inOrOut+=dot(dist,ONE);dist.x=dot(P,HS4);dist.y=HS5.w-abs(P.z);dist=smoothstep(N_FEATHER,P_FEATHER,dist);inOrOut+=dist.x;return clamp(inOrOut,0.0,1.0);}\n#endif\nvec3 processTexel(const in vec2 coords,const in float blur){vec2 scale=texelSize*fringe*blur;vec3 c=vec3(texture2D(inputBuffer,coords+vec2(0.0,1.0)*scale).r,texture2D(inputBuffer,coords+vec2(-0.866,-0.5)*scale).g,texture2D(inputBuffer,coords+vec2(0.866,-0.5)*scale).b);float luminance=linearToRelativeLuminance(c);float threshold=max((luminance-luminanceThreshold)*luminanceGain,0.0);return c+mix(vec3(0.0),c,threshold*blur);}float gather(const in float i,const in float j,const in float ringSamples,const in vec2 uv,const in vec2 blurFactor,const in float blur,inout vec3 color){float step=PI2/ringSamples;vec2 wh=vec2(cos(j*step)*i,sin(j*step)*i);\n#ifdef PENTAGON\nfloat p=pentagon(wh);\n#else\nfloat p=1.0;\n#endif\ncolor+=processTexel(wh*blurFactor+uv,blur)*mix(1.0,i/RINGS_FLOAT,bias)*p;return mix(1.0,i/RINGS_FLOAT,bias)*p;}void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){\n#ifdef PERSPECTIVE_CAMERA\nfloat viewZ=perspectiveDepthToViewZ(depth,cameraNear,cameraFar);float linearDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);\n#else\nfloat linearDepth=depth;\n#endif\n#ifdef MANUAL_DOF\nfloat focalPlane=linearDepth-focus;float farDoF=(focalPlane-dof.z)/dof.w;float nearDoF=(-focalPlane-dof.x)/dof.y;float blur=(focalPlane>0.0)?farDoF:nearDoF;\n#else\nconst float CIRCLE_OF_CONFUSION=0.03;float focalPlaneMM=focus*1000.0;float depthMM=linearDepth*1000.0;float focalPlane=(depthMM*focalLength)/(depthMM-focalLength);float farDoF=(focalPlaneMM*focalLength)/(focalPlaneMM-focalLength);float nearDoF=(focalPlaneMM-focalLength)/(focalPlaneMM*fStop*CIRCLE_OF_CONFUSION);float blur=abs(focalPlane-farDoF)*nearDoF;\n#endif\nconst int MAX_RING_SAMPLES=RINGS_INT*SAMPLES_INT;blur=clamp(blur,0.0,1.0);vec3 color=inputColor.rgb;if(blur>=0.05){vec2 blurFactor=blur*maxBlur*texelSize;float s=1.0;int ringSamples;for(int i=1;i<=RINGS_INT;i++){ringSamples=i*SAMPLES_INT;for(int j=0;j<MAX_RING_SAMPLES;j++){if(j>=ringSamples){break;}s+=gather(float(i),float(j),float(ringSamples),uv,blurFactor,blur,color);}}color/=s;}\n#ifdef SHOW_FOCUS\nfloat edge=0.002*linearDepth;float m=clamp(smoothstep(0.0,edge,blur),0.0,1.0);float e=clamp(smoothstep(1.0-edge,1.0,blur),0.0,1.0);color=mix(color,vec3(1.0,0.5,0.0),(1.0-m)*0.6);color=mix(color,vec3(0.0,0.5,1.0),((1.0-e)-(1.0-m))*0.2);\n#endif\noutputColor=vec4(color,inputColor.a);}";
// src/effects/RealisticBokehEffect.js
var $fe721963ebf18f1b$export$bae36a32c5d14266 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new bokeh effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.focus=1.0] - The focus distance in world units.
   * @param {Number} [options.focalLength=24.0] - The focal length of the main camera.
   * @param {Number} [options.fStop=0.9] - The ratio of the lens focal length to the diameter of the entrance pupil (aperture).
   * @param {Number} [options.luminanceThreshold=0.5] - A luminance threshold.
   * @param {Number} [options.luminanceGain=2.0] - A luminance gain factor.
   * @param {Number} [options.bias=0.5] - A blur bias.
   * @param {Number} [options.fringe=0.7] - A blur offset.
   * @param {Number} [options.maxBlur=1.0] - The maximum blur strength.
   * @param {Boolean} [options.rings=3] - The number of blur iterations.
   * @param {Boolean} [options.samples=2] - The amount of samples taken per ring.
   * @param {Boolean} [options.showFocus=false] - Whether the focal point should be highlighted. Useful for debugging.
   * @param {Boolean} [options.manualDoF=false] - Enables manual control over the depth of field.
   * @param {Boolean} [options.pentagon=false] - Enables pentagonal blur shapes. Requires a high number of rings and samples.
   */ constructor({ blendFunction: blendFunction, focus: focus = 1, focalLength: focalLength = 24, fStop: fStop = 0.9, luminanceThreshold: luminanceThreshold = 0.5, luminanceGain: luminanceGain = 2, bias: bias = 0.5, fringe: fringe = 0.7, maxBlur: maxBlur = 1, rings: rings = 3, samples: samples = 2, showFocus: showFocus = false, manualDoF: manualDoF = false, pentagon: pentagon = false } = {}){
        super("RealisticBokehEffect", $fe721963ebf18f1b$var$realistic_bokeh_default, {
            blendFunction: blendFunction,
            attributes: $fe721963ebf18f1b$export$a72ebb312f9e05c6.CONVOLUTION | $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "focus",
                    new (0, $ilwiq.Uniform)(focus)
                ],
                [
                    "focalLength",
                    new (0, $ilwiq.Uniform)(focalLength)
                ],
                [
                    "fStop",
                    new (0, $ilwiq.Uniform)(fStop)
                ],
                [
                    "luminanceThreshold",
                    new (0, $ilwiq.Uniform)(luminanceThreshold)
                ],
                [
                    "luminanceGain",
                    new (0, $ilwiq.Uniform)(luminanceGain)
                ],
                [
                    "bias",
                    new (0, $ilwiq.Uniform)(bias)
                ],
                [
                    "fringe",
                    new (0, $ilwiq.Uniform)(fringe)
                ],
                [
                    "maxBlur",
                    new (0, $ilwiq.Uniform)(maxBlur)
                ],
                [
                    "dof",
                    new (0, $ilwiq.Uniform)(null)
                ]
            ])
        });
        this.rings = rings;
        this.samples = samples;
        this.showFocus = showFocus;
        this.manualDoF = manualDoF;
        this.pentagon = pentagon;
    }
    /**
   * The amount of blur iterations.
   *
   * @type {Number}
   */ get rings() {
        return Number.parseInt(this.defines.get("RINGS_INT"));
    }
    set rings(value) {
        const r = Math.floor(value);
        this.defines.set("RINGS_INT", r.toFixed(0));
        this.defines.set("RINGS_FLOAT", r.toFixed(1));
        this.setChanged();
    }
    /**
   * The amount of blur samples per ring.
   *
   * @type {Number}
   */ get samples() {
        return Number.parseInt(this.defines.get("SAMPLES_INT"));
    }
    set samples(value) {
        const s = Math.floor(value);
        this.defines.set("SAMPLES_INT", s.toFixed(0));
        this.defines.set("SAMPLES_FLOAT", s.toFixed(1));
        this.setChanged();
    }
    /**
   * Indicates whether the focal point will be highlighted.
   *
   * @type {Boolean}
   */ get showFocus() {
        return this.defines.has("SHOW_FOCUS");
    }
    set showFocus(value) {
        if (this.showFocus !== value) {
            if (value) this.defines.set("SHOW_FOCUS", "1");
            else this.defines.delete("SHOW_FOCUS");
            this.setChanged();
        }
    }
    /**
   * Indicates whether the Depth of Field should be calculated manually.
   *
   * If enabled, the Depth of Field can be adjusted via the `dof` uniform.
   *
   * @type {Boolean}
   */ get manualDoF() {
        return this.defines.has("MANUAL_DOF");
    }
    set manualDoF(value) {
        if (this.manualDoF !== value) {
            if (value) {
                this.defines.set("MANUAL_DOF", "1");
                this.uniforms.get("dof").value = new (0, $ilwiq.Vector4)(0.2, 1, 0.2, 2);
            } else {
                this.defines.delete("MANUAL_DOF");
                this.uniforms.get("dof").value = null;
            }
            this.setChanged();
        }
    }
    /**
   * Indicates whether the blur shape should be pentagonal.
   *
   * @type {Boolean}
   */ get pentagon() {
        return this.defines.has("PENTAGON");
    }
    set pentagon(value) {
        if (this.pentagon !== value) {
            if (value) this.defines.set("PENTAGON", "1");
            else this.defines.delete("PENTAGON");
            this.setChanged();
        }
    }
};
// src/effects/glsl/scanlines.frag
var $fe721963ebf18f1b$var$scanlines_default = "uniform float count;\n#ifdef SCROLL\nuniform float scrollSpeed;\n#endif\nvoid mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){float y=uv.y;\n#ifdef SCROLL\ny+=time*scrollSpeed;\n#endif\nvec2 sl=vec2(sin(y*count),cos(y*count));outputColor=vec4(sl.xyx,inputColor.a);}";
// src/effects/ScanlineEffect.js
var $fe721963ebf18f1b$export$375e89395e3a5238 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new scanline effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.OVERLAY] - The blend function of this effect.
   * @param {Number} [options.density=1.25] - The scanline density.
   * @param {Number} [options.scrollSpeed=0.0] - The scanline scroll speed.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.OVERLAY, density: density = 1.25, scrollSpeed: scrollSpeed = 0 } = {}){
        super("ScanlineEffect", $fe721963ebf18f1b$var$scanlines_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "count",
                    new (0, $ilwiq.Uniform)(0)
                ],
                [
                    "scrollSpeed",
                    new (0, $ilwiq.Uniform)(0)
                ]
            ])
        });
        this.resolution = new (0, $ilwiq.Vector2)();
        this.d = density;
        this.scrollSpeed = scrollSpeed;
    }
    /**
   * The scanline density.
   *
   * @type {Number}
   */ get density() {
        return this.d;
    }
    set density(value) {
        this.d = value;
        this.setSize(this.resolution.width, this.resolution.height);
    }
    /**
   * Returns the current scanline density.
   *
   * @deprecated Use density instead.
   * @return {Number} The scanline density.
   */ getDensity() {
        return this.density;
    }
    /**
   * Sets the scanline density.
   *
   * @deprecated Use density instead.
   * @param {Number} value - The new scanline density.
   */ setDensity(value) {
        this.density = value;
    }
    /**
   * The scanline scroll speed. Default is 0 (disabled).
   *
   * @type {Number}
   */ get scrollSpeed() {
        return this.uniforms.get("scrollSpeed").value;
    }
    set scrollSpeed(value) {
        this.uniforms.get("scrollSpeed").value = value;
        if (value === 0) {
            if (this.defines.delete("SCROLL")) this.setChanged();
        } else if (!this.defines.has("SCROLL")) {
            this.defines.set("SCROLL", "1");
            this.setChanged();
        }
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.resolution.set(width, height);
        this.uniforms.get("count").value = Math.round(height * this.density);
    }
};
// src/effects/glsl/shock-wave.frag
var $fe721963ebf18f1b$var$shock_wave_default = "uniform bool active;uniform vec2 center;uniform float waveSize;uniform float radius;uniform float maxRadius;uniform float amplitude;varying float vSize;void mainUv(inout vec2 uv){if(active){vec2 aspectCorrection=vec2(aspect,1.0);vec2 difference=uv*aspectCorrection-center*aspectCorrection;float distance=sqrt(dot(difference,difference))*vSize;if(distance>radius){if(distance<radius+waveSize){float angle=(distance-radius)*PI2/waveSize;float cosSin=(1.0-cos(angle))*0.5;float extent=maxRadius+waveSize;float decay=max(extent-distance*distance,0.0)/extent;uv-=((cosSin*amplitude*difference)/distance)*decay;}}}}";
// src/effects/glsl/shock-wave.vert
var $fe721963ebf18f1b$var$shock_wave_default2 = "uniform float size;uniform float cameraDistance;varying float vSize;void mainSupport(){vSize=(0.1*cameraDistance)/size;}";
// src/effects/ShockWaveEffect.js
var $fe721963ebf18f1b$var$HALF_PI = Math.PI * 0.5;
var $fe721963ebf18f1b$var$v2 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
var $fe721963ebf18f1b$var$ab = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
var $fe721963ebf18f1b$export$678e91125a3dcb0c = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new shock wave effect.
   *
   * @param {Camera} camera - The main camera.
   * @param {Vector3} [position] - The world position of the shock wave.
   * @param {Object} [options] - The options.
   * @param {Number} [options.speed=2.0] - The animation speed.
   * @param {Number} [options.maxRadius=1.0] - The extent of the shock wave.
   * @param {Number} [options.waveSize=0.2] - The wave size.
   * @param {Number} [options.amplitude=0.05] - The distortion amplitude.
   */ constructor(camera, position = new (0, $ilwiq.Vector3)(), { speed: speed = 2, maxRadius: maxRadius = 1, waveSize: waveSize = 0.2, amplitude: amplitude = 0.05 } = {}){
        super("ShockWaveEffect", $fe721963ebf18f1b$var$shock_wave_default, {
            vertexShader: $fe721963ebf18f1b$var$shock_wave_default2,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "active",
                    new (0, $ilwiq.Uniform)(false)
                ],
                [
                    "center",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)(0.5, 0.5))
                ],
                [
                    "cameraDistance",
                    new (0, $ilwiq.Uniform)(1)
                ],
                [
                    "size",
                    new (0, $ilwiq.Uniform)(1)
                ],
                [
                    "radius",
                    new (0, $ilwiq.Uniform)(-waveSize)
                ],
                [
                    "maxRadius",
                    new (0, $ilwiq.Uniform)(maxRadius)
                ],
                [
                    "waveSize",
                    new (0, $ilwiq.Uniform)(waveSize)
                ],
                [
                    "amplitude",
                    new (0, $ilwiq.Uniform)(amplitude)
                ]
            ])
        });
        this.position = position;
        this.speed = speed;
        this.camera = camera;
        this.screenPosition = this.uniforms.get("center").value;
        this.time = 0;
        this.active = false;
    }
    set mainCamera(value) {
        this.camera = value;
    }
    /**
   * The amplitude.
   *
   * @type {Number}
   */ get amplitude() {
        return this.uniforms.get("amplitude").value;
    }
    set amplitude(value) {
        this.uniforms.get("amplitude").value = value;
    }
    /**
   * The wave size.
   *
   * @type {Number}
   */ get waveSize() {
        return this.uniforms.get("waveSize").value;
    }
    set waveSize(value) {
        this.uniforms.get("waveSize").value = value;
    }
    /**
   * The maximum radius.
   *
   * @type {Number}
   */ get maxRadius() {
        return this.uniforms.get("maxRadius").value;
    }
    set maxRadius(value) {
        this.uniforms.get("maxRadius").value = value;
    }
    /**
   * The position of the shock wave.
   *
   * @type {Vector3}
   * @deprecated Use position instead.
   */ get epicenter() {
        return this.position;
    }
    set epicenter(value) {
        this.position = value;
    }
    /**
   * Returns the position of the shock wave.
   *
   * @deprecated Use position instead.
   * @return {Vector3} The position.
   */ getPosition() {
        return this.position;
    }
    /**
   * Sets the position of the shock wave.
   *
   * @deprecated Use position instead.
   * @param {Vector3} value - The position.
   */ setPosition(value) {
        this.position = value;
    }
    /**
   * Returns the speed of the shock wave.
   *
   * @deprecated Use speed instead.
   * @return {Number} The speed.
   */ getSpeed() {
        return this.speed;
    }
    /**
   * Sets the speed of the shock wave.
   *
   * @deprecated Use speed instead.
   * @param {Number} value - The speed.
   */ setSpeed(value) {
        this.speed = value;
    }
    /**
   * Emits the shock wave.
   */ explode() {
        this.time = 0;
        this.active = true;
        this.uniforms.get("active").value = true;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [delta] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, delta) {
        const position = this.position;
        const camera = this.camera;
        const uniforms = this.uniforms;
        const uActive = uniforms.get("active");
        if (this.active) {
            const waveSize = uniforms.get("waveSize").value;
            camera.getWorldDirection($fe721963ebf18f1b$var$v2);
            $fe721963ebf18f1b$var$ab.copy(camera.position).sub(position);
            uActive.value = $fe721963ebf18f1b$var$v2.angleTo($fe721963ebf18f1b$var$ab) > $fe721963ebf18f1b$var$HALF_PI;
            if (uActive.value) {
                uniforms.get("cameraDistance").value = camera.position.distanceTo(position);
                $fe721963ebf18f1b$var$v2.copy(position).project(camera);
                this.screenPosition.set(($fe721963ebf18f1b$var$v2.x + 1) * 0.5, ($fe721963ebf18f1b$var$v2.y + 1) * 0.5);
            }
            this.time += delta * this.speed;
            const radius = this.time - waveSize;
            uniforms.get("radius").value = radius;
            if (radius >= (uniforms.get("maxRadius").value + waveSize) * 2) {
                this.active = false;
                uActive.value = false;
            }
        }
    }
};
var $fe721963ebf18f1b$export$6588cb38f2a0e4fe = class extends $fe721963ebf18f1b$export$1e2a1743038c77d5 {
    /**
   * Constructs a new selective bloom effect.
   *
   * @param {Scene} scene - The main scene.
   * @param {Camera} camera - The main camera.
   * @param {Object} [options] - The options. See {@link BloomEffect} for details.
   */ constructor(scene, camera, options){
        super(options);
        this.setAttributes(this.getAttributes() | $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH);
        this.camera = camera;
        this.depthPass = new $fe721963ebf18f1b$export$4059e0d5f564fa1(scene, camera);
        this.clearPass = new $fe721963ebf18f1b$export$fc4180e277a6a0c2(true, false, false);
        this.clearPass.overrideClearColor = new (0, $ilwiq.Color)(0);
        this.depthMaskPass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$fe1d84eaa823805a());
        const depthMaskMaterial = this.depthMaskMaterial;
        depthMaskMaterial.copyCameraSettings(camera);
        depthMaskMaterial.depthBuffer1 = this.depthPass.texture;
        depthMaskMaterial.depthPacking1 = (0, $ilwiq.RGBADepthPacking);
        depthMaskMaterial.depthMode = (0, $ilwiq.EqualDepth);
        this.renderTargetMasked = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetMasked.texture.name = "Bloom.Masked";
        this.selection = new $fe721963ebf18f1b$export$52baac22726c72bf();
        this._inverted = false;
        this._ignoreBackground = false;
    }
    set mainScene(value) {
        this.depthPass.mainScene = value;
    }
    set mainCamera(value) {
        this.camera = value;
        this.depthPass.mainCamera = value;
        this.depthMaskMaterial.copyCameraSettings(value);
    }
    /**
   * Returns the selection.
   *
   * @deprecated Use selection instead.
   * @return {Selection} The selection.
   */ getSelection() {
        return this.selection;
    }
    /**
   * The depth mask material.
   *
   * @type {DepthMaskMaterial}
   * @private
   */ get depthMaskMaterial() {
        return this.depthMaskPass.fullscreenMaterial;
    }
    /**
   * Indicates whether the selection should be considered inverted.
   *
   * @type {Boolean}
   */ get inverted() {
        return this._inverted;
    }
    set inverted(value) {
        this._inverted = value;
        this.depthMaskMaterial.depthMode = value ? (0, $ilwiq.NotEqualDepth) : (0, $ilwiq.EqualDepth);
    }
    /**
   * Indicates whether the mask is inverted.
   *
   * @deprecated Use inverted instead.
   * @return {Boolean} Whether the mask is inverted.
   */ isInverted() {
        return this.inverted;
    }
    /**
   * Enables or disable mask inversion.
   *
   * @deprecated Use inverted instead.
   * @param {Boolean} value - Whether the mask should be inverted.
   */ setInverted(value) {
        this.inverted = value;
    }
    /**
   * Indicates whether the background colors will be ignored.
   *
   * @type {Boolean}
   */ get ignoreBackground() {
        return this._ignoreBackground;
    }
    set ignoreBackground(value) {
        this._ignoreBackground = value;
        this.depthMaskMaterial.maxDepthStrategy = value ? $fe721963ebf18f1b$export$a11e355d280abe13.DISCARD_MAX_DEPTH : $fe721963ebf18f1b$export$a11e355d280abe13.KEEP_MAX_DEPTH;
    }
    /**
   * Indicates whether the background is disabled.
   *
   * @deprecated Use ignoreBackground instead.
   * @return {Boolean} Whether the background is disabled.
   */ isBackgroundDisabled() {
        return this.ignoreBackground;
    }
    /**
   * Enables or disables the background.
   *
   * @deprecated Use ignoreBackground instead.
   * @param {Boolean} value - Whether the background should be disabled.
   */ setBackgroundDisabled(value) {
        this.ignoreBackground = value;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthMaskMaterial.depthBuffer0 = depthTexture;
        this.depthMaskMaterial.depthPacking0 = depthPacking;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const camera = this.camera;
        const selection = this.selection;
        const inverted = this.inverted;
        let renderTarget = inputBuffer;
        if (this.ignoreBackground || !inverted || selection.size > 0) {
            const mask = camera.layers.mask;
            camera.layers.set(selection.layer);
            this.depthPass.render(renderer);
            camera.layers.mask = mask;
            renderTarget = this.renderTargetMasked;
            this.clearPass.render(renderer, renderTarget);
            this.depthMaskPass.render(renderer, inputBuffer, renderTarget);
        }
        super.update(renderer, renderTarget, deltaTime);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        super.setSize(width, height);
        this.renderTargetMasked.setSize(width, height);
        this.depthPass.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        super.initialize(renderer, alpha, frameBufferType);
        this.clearPass.initialize(renderer, alpha, frameBufferType);
        this.depthPass.initialize(renderer, alpha, frameBufferType);
        this.depthMaskPass.initialize(renderer, alpha, frameBufferType);
        if (renderer !== null && renderer.capabilities.logarithmicDepthBuffer) this.depthMaskPass.fullscreenMaterial.defines.LOG_DEPTH = "1";
        if (frameBufferType !== void 0) {
            this.renderTargetMasked.texture.type = frameBufferType;
            if (renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) this.renderTargetMasked.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
        }
    }
};
// src/effects/glsl/sepia.frag
var $fe721963ebf18f1b$var$sepia_default = "uniform vec3 weightsR;uniform vec3 weightsG;uniform vec3 weightsB;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(dot(inputColor.rgb,weightsR),dot(inputColor.rgb,weightsG),dot(inputColor.rgb,weightsB));outputColor=vec4(color,inputColor.a);}";
// src/effects/SepiaEffect.js
var $fe721963ebf18f1b$export$c6ab5b20c691455c = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new sepia effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.intensity=1.0] - The intensity of the effect.
   */ constructor({ blendFunction: blendFunction, intensity: intensity = 1 } = {}){
        super("SepiaEffect", $fe721963ebf18f1b$var$sepia_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "weightsR",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector3)(0.393, 0.769, 0.189))
                ],
                [
                    "weightsG",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector3)(0.349, 0.686, 0.168))
                ],
                [
                    "weightsB",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector3)(0.272, 0.534, 0.131))
                ]
            ])
        });
    }
    /**
   * The intensity.
   *
   * @deprecated Use blendMode.opacity instead.
   * @type {Number}
   */ get intensity() {
        return this.blendMode.opacity.value;
    }
    set intensity(value) {
        this.blendMode.opacity.value = value;
    }
    /**
   * Returns the current sepia intensity.
   *
   * @deprecated Use blendMode.opacity instead.
   * @return {Number} The intensity.
   */ getIntensity() {
        return this.intensity;
    }
    /**
   * Sets the sepia intensity.
   *
   * @deprecated Use blendMode.opacity instead.
   * @param {Number} value - The intensity.
   */ setIntensity(value) {
        this.intensity = value;
    }
    /**
   * The weights for the red channel. Default is `(0.393, 0.769, 0.189)`.
   *
   * @type {Vector3}
   */ get weightsR() {
        return this.uniforms.get("weightsR").value;
    }
    /**
   * The weights for the green channel. Default is `(0.349, 0.686, 0.168)`.
   *
   * @type {Vector3}
   */ get weightsG() {
        return this.uniforms.get("weightsG").value;
    }
    /**
   * The weights for the blue channel. Default is `(0.272, 0.534, 0.131)`.
   *
   * @type {Vector3}
   */ get weightsB() {
        return this.uniforms.get("weightsB").value;
    }
};
// src/materials/glsl/edge-detection.frag
var $fe721963ebf18f1b$var$edge_detection_default = "varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;\n#if EDGE_DETECTION_MODE != 0\nvarying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;\n#endif\n#if EDGE_DETECTION_MODE == 1\n#include <common>\n#endif\n#if EDGE_DETECTION_MODE == 0 || PREDICATION_MODE == 1\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D depthBuffer;\n#else\nuniform mediump sampler2D depthBuffer;\n#endif\nfloat readDepth(const in vec2 uv){\n#if DEPTH_PACKING == 3201\nreturn unpackRGBAToDepth(texture2D(depthBuffer,uv));\n#else\nreturn texture2D(depthBuffer,uv).r;\n#endif\n}vec3 gatherNeighbors(){float p=readDepth(vUv);float pLeft=readDepth(vUv0);float pTop=readDepth(vUv1);return vec3(p,pLeft,pTop);}\n#elif PREDICATION_MODE == 2\nuniform sampler2D predicationBuffer;vec3 gatherNeighbors(){float p=texture2D(predicationBuffer,vUv).r;float pLeft=texture2D(predicationBuffer,vUv0).r;float pTop=texture2D(predicationBuffer,vUv1).r;return vec3(p,pLeft,pTop);}\n#endif\n#if PREDICATION_MODE != 0\nvec2 calculatePredicatedThreshold(){vec3 neighbours=gatherNeighbors();vec2 delta=abs(neighbours.xx-neighbours.yz);vec2 edges=step(PREDICATION_THRESHOLD,delta);return PREDICATION_SCALE*EDGE_THRESHOLD*(1.0-PREDICATION_STRENGTH*edges);}\n#endif\n#if EDGE_DETECTION_MODE != 0\nuniform sampler2D inputBuffer;\n#endif\nvoid main(){\n#if EDGE_DETECTION_MODE == 0\nconst vec2 threshold=vec2(DEPTH_THRESHOLD);\n#elif PREDICATION_MODE != 0\nvec2 threshold=calculatePredicatedThreshold();\n#else\nconst vec2 threshold=vec2(EDGE_THRESHOLD);\n#endif\n#if EDGE_DETECTION_MODE == 0\nvec3 neighbors=gatherNeighbors();vec2 delta=abs(neighbors.xx-vec2(neighbors.y,neighbors.z));vec2 edges=step(threshold,delta);if(dot(edges,vec2(1.0))==0.0){discard;}gl_FragColor=vec4(edges,0.0,1.0);\n#elif EDGE_DETECTION_MODE == 1\nfloat l=luminance(texture2D(inputBuffer,vUv).rgb);float lLeft=luminance(texture2D(inputBuffer,vUv0).rgb);float lTop=luminance(texture2D(inputBuffer,vUv1).rgb);vec4 delta;delta.xy=abs(l-vec2(lLeft,lTop));vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}float lRight=luminance(texture2D(inputBuffer,vUv2).rgb);float lBottom=luminance(texture2D(inputBuffer,vUv3).rgb);delta.zw=abs(l-vec2(lRight,lBottom));vec2 maxDelta=max(delta.xy,delta.zw);float lLeftLeft=luminance(texture2D(inputBuffer,vUv4).rgb);float lTopTop=luminance(texture2D(inputBuffer,vUv5).rgb);delta.zw=abs(vec2(lLeft,lTop)-vec2(lLeftLeft,lTopTop));maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges.xy*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);\n#elif EDGE_DETECTION_MODE == 2\nvec4 delta;vec3 c=texture2D(inputBuffer,vUv).rgb;vec3 cLeft=texture2D(inputBuffer,vUv0).rgb;vec3 t=abs(c-cLeft);delta.x=max(max(t.r,t.g),t.b);vec3 cTop=texture2D(inputBuffer,vUv1).rgb;t=abs(c-cTop);delta.y=max(max(t.r,t.g),t.b);vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}vec3 cRight=texture2D(inputBuffer,vUv2).rgb;t=abs(c-cRight);delta.z=max(max(t.r,t.g),t.b);vec3 cBottom=texture2D(inputBuffer,vUv3).rgb;t=abs(c-cBottom);delta.w=max(max(t.r,t.g),t.b);vec2 maxDelta=max(delta.xy,delta.zw);vec3 cLeftLeft=texture2D(inputBuffer,vUv4).rgb;t=abs(c-cLeftLeft);delta.z=max(max(t.r,t.g),t.b);vec3 cTopTop=texture2D(inputBuffer,vUv5).rgb;t=abs(c-cTopTop);delta.w=max(max(t.r,t.g),t.b);maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);\n#endif\n}";
// src/materials/glsl/edge-detection.vert
var $fe721963ebf18f1b$var$edge_detection_default2 = "uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;\n#if EDGE_DETECTION_MODE != 0\nvarying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;\n#endif\nvoid main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,0.0);vUv1=vUv+texelSize*vec2(0.0,-1.0);\n#if EDGE_DETECTION_MODE != 0\nvUv2=vUv+texelSize*vec2(1.0,0.0);vUv3=vUv+texelSize*vec2(0.0,1.0);vUv4=vUv+texelSize*vec2(-2.0,0.0);vUv5=vUv+texelSize*vec2(0.0,-2.0);\n#endif\ngl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/EdgeDetectionMaterial.js
var $fe721963ebf18f1b$export$a9e4c517bf702b92 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new edge detection material.
   *
   * TODO Remove parameters.
   * @param {Vector2} [texelSize] - The screen texel size.
   * @param {EdgeDetectionMode} [mode=EdgeDetectionMode.COLOR] - The edge detection mode.
   */ constructor(texelSize = new (0, $ilwiq.Vector2)(), mode = $fe721963ebf18f1b$export$20d1071ff7b64a56.COLOR){
        super({
            name: "EdgeDetectionMaterial",
            defines: {
                THREE_REVISION: (0, $ilwiq.REVISION).replace(/\D+/g, ""),
                LOCAL_CONTRAST_ADAPTATION_FACTOR: "2.0",
                EDGE_THRESHOLD: "0.1",
                DEPTH_THRESHOLD: "0.01",
                PREDICATION_MODE: "0",
                PREDICATION_THRESHOLD: "0.01",
                PREDICATION_SCALE: "2.0",
                PREDICATION_STRENGTH: "1.0",
                DEPTH_PACKING: "0"
            },
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                depthBuffer: new (0, $ilwiq.Uniform)(null),
                predicationBuffer: new (0, $ilwiq.Uniform)(null),
                texelSize: new (0, $ilwiq.Uniform)(texelSize)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$edge_detection_default,
            vertexShader: $fe721963ebf18f1b$var$edge_detection_default2
        });
        this.edgeDetectionMode = mode;
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * The edge detection mode.
   *
   * @type {EdgeDetectionMode}
   */ get edgeDetectionMode() {
        return Number(this.defines.EDGE_DETECTION_MODE);
    }
    set edgeDetectionMode(value) {
        this.defines.EDGE_DETECTION_MODE = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Returns the edge detection mode.
   *
   * @deprecated Use edgeDetectionMode instead.
   * @return {EdgeDetectionMode} The mode.
   */ getEdgeDetectionMode() {
        return this.edgeDetectionMode;
    }
    /**
   * Sets the edge detection mode.
   *
   * @deprecated Use edgeDetectionMode instead.
   * @param {EdgeDetectionMode} value - The edge detection mode.
   */ setEdgeDetectionMode(value) {
        this.edgeDetectionMode = value;
    }
    /**
   * The local contrast adaptation factor. Has no effect if the edge detection mode is set to DEPTH. Default is 2.0.
   *
   * If a neighbor edge has _factor_ times bigger contrast than the current edge, the edge will be discarded.
   *
   * This allows to eliminate spurious crossing edges and is based on the fact that if there is too much contrast in a
   * direction, the perceptual contrast in the other neighbors will be hidden.
   *
   * @type {Number}
   */ get localContrastAdaptationFactor() {
        return Number(this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR);
    }
    set localContrastAdaptationFactor(value) {
        this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR = value.toFixed("6");
        this.needsUpdate = true;
    }
    /**
   * Returns the local contrast adaptation factor.
   *
   * @deprecated Use localContrastAdaptationFactor instead.
   * @return {Number} The factor.
   */ getLocalContrastAdaptationFactor() {
        return this.localContrastAdaptationFactor;
    }
    /**
   * Sets the local contrast adaptation factor. Has no effect if the edge detection mode is set to DEPTH.
   *
   * @deprecated Use localContrastAdaptationFactor instead.
   * @param {Number} value - The local contrast adaptation factor. Default is 2.0.
   */ setLocalContrastAdaptationFactor(value) {
        this.localContrastAdaptationFactor = value;
    }
    /**
   * The edge detection threshold. Range: [0.0, 0.5].
   *
   * A lower value results in more edges being detected at the expense of performance.
   *
   * For luma- and chroma-based edge detection, 0.1 is a reasonable value and allows to catch most visible edges. 0.05
   * is a rather overkill value that allows to catch 'em all. Darker scenes may require an even lower threshold.
   *
   * If depth-based edge detection is used, the threshold will depend on the scene depth.
   *
   * @type {Number}
   */ get edgeDetectionThreshold() {
        return Number(this.defines.EDGE_THRESHOLD);
    }
    set edgeDetectionThreshold(value) {
        this.defines.EDGE_THRESHOLD = value.toFixed("6");
        this.defines.DEPTH_THRESHOLD = (value * 0.1).toFixed("6");
        this.needsUpdate = true;
    }
    /**
   * Returns the edge detection threshold.
   *
   * @deprecated Use edgeDetectionThreshold instead.
   * @return {Number} The threshold.
   */ getEdgeDetectionThreshold() {
        return this.edgeDetectionThreshold;
    }
    /**
   * Sets the edge detection threshold.
   *
   * @deprecated Use edgeDetectionThreshold instead.
   * @param {Number} value - The edge detection threshold. Range: [0.0, 0.5].
   */ setEdgeDetectionThreshold(value) {
        this.edgeDetectionThreshold = value;
    }
    /**
   * The predication mode.
   *
   * Predicated thresholding allows to better preserve texture details and to improve edge detection using an additional
   * buffer such as a light accumulation or depth buffer.
   *
   * @type {PredicationMode}
   */ get predicationMode() {
        return Number(this.defines.PREDICATION_MODE);
    }
    set predicationMode(value) {
        this.defines.PREDICATION_MODE = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Returns the predication mode.
   *
   * @deprecated Use predicationMode instead.
   * @return {PredicationMode} The mode.
   */ getPredicationMode() {
        return this.predicationMode;
    }
    /**
   * Sets the predication mode.
   *
   * @deprecated Use predicationMode instead.
   * @param {PredicationMode} value - The predication mode.
   */ setPredicationMode(value) {
        this.predicationMode = value;
    }
    /**
   * The predication buffer.
   *
   * @type {Texture}
   */ set predicationBuffer(value) {
        this.uniforms.predicationBuffer.value = value;
    }
    /**
   * Sets a custom predication buffer.
   *
   * @deprecated Use predicationBuffer instead.
   * @param {Texture} value - The predication buffer.
   */ setPredicationBuffer(value) {
        this.uniforms.predicationBuffer.value = value;
    }
    /**
   * The predication threshold.
   *
   * @type {Number}
   */ get predicationThreshold() {
        return Number(this.defines.PREDICATION_THRESHOLD);
    }
    set predicationThreshold(value) {
        this.defines.PREDICATION_THRESHOLD = value.toFixed("6");
        this.needsUpdate = true;
    }
    /**
   * Returns the predication threshold.
   *
   * @deprecated Use predicationThreshold instead.
   * @return {Number} The threshold.
   */ getPredicationThreshold() {
        return this.predicationThreshold;
    }
    /**
   * Sets the predication threshold.
   *
   * @deprecated Use predicationThreshold instead.
   * @param {Number} value - The threshold.
   */ setPredicationThreshold(value) {
        this.predicationThreshold = value;
    }
    /**
   * The predication scale. Range: [1.0, 5.0].
   *
   * Determines how much the edge detection threshold should be scaled when using predication.
   *
   * @type {Boolean|Texture|Number}
   */ get predicationScale() {
        return Number(this.defines.PREDICATION_SCALE);
    }
    set predicationScale(value) {
        this.defines.PREDICATION_SCALE = value.toFixed("6");
        this.needsUpdate = true;
    }
    /**
   * Returns the predication scale.
   *
   * @deprecated Use predicationScale instead.
   * @return {Number} The scale.
   */ getPredicationScale() {
        return this.predicationScale;
    }
    /**
   * Sets the predication scale.
   *
   * @deprecated Use predicationScale instead.
   * @param {Number} value - The scale. Range: [1.0, 5.0].
   */ setPredicationScale(value) {
        this.predicationScale = value;
    }
    /**
   * The predication strength. Range: [0.0, 1.0].
   *
   * Determines how much the edge detection threshold should be decreased locally when using predication.
   *
   * @type {Number}
   */ get predicationStrength() {
        return Number(this.defines.PREDICATION_STRENGTH);
    }
    set predicationStrength(value) {
        this.defines.PREDICATION_STRENGTH = value.toFixed("6");
        this.needsUpdate = true;
    }
    /**
   * Returns the predication strength.
   *
   * @deprecated Use predicationStrength instead.
   * @return {Number} The strength.
   */ getPredicationStrength() {
        return this.predicationStrength;
    }
    /**
   * Sets the predication strength.
   *
   * @deprecated Use predicationStrength instead.
   * @param {Number} value - The strength. Range: [0.0, 1.0].
   */ setPredicationStrength(value) {
        this.predicationStrength = value;
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/materials/glsl/smaa-weights.frag
var $fe721963ebf18f1b$var$smaa_weights_default = "#define sampleLevelZeroOffset(t, coord, offset) texture2D(t, coord + offset * texelSize)\n#if __VERSION__ < 300\n#define round(v) floor(v + 0.5)\n#endif\n#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\nuniform lowp sampler2D areaTexture;uniform lowp sampler2D searchTexture;uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}vec2 decodeDiagBilinearAccess(in vec2 e){e.r=e.r*abs(5.0*e.r-5.0*0.75);return round(e);}vec4 decodeDiagBilinearAccess(in vec4 e){e.rb=e.rb*abs(5.0*e.rb-5.0*0.75);return round(e);}vec2 searchDiag1(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 searchDiag2(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);coord.x+=0.25*texelSize.x;vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;e=decodeDiagBilinearAccess(e);coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 areaDiag(const in vec2 dist,const in vec2 e,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE_DIAG,AREATEX_MAX_DISTANCE_DIAG)*e+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.x+=0.5;texCoord.y+=AREATEX_SUBTEX_SIZE*offset;return texture2D(areaTexture,texCoord).rg;}vec2 calculateDiagWeights(const in vec2 texCoord,const in vec2 e,const in vec4 subsampleIndices){vec2 weights=vec2(0.0);vec4 d;vec2 end;if(e.r>0.0){d.xz=searchDiag1(texCoord,vec2(-1.0,1.0),end);d.x+=float(end.y>0.9);}else{d.xz=vec2(0.0);}d.yw=searchDiag1(texCoord,vec2(1.0,-1.0),end);if(d.x+d.y>2.0){vec4 coords=vec4(-d.x+0.25,d.x,d.y,-d.y-0.25)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.xy=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).rg;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).rg;c.yxwz=decodeDiagBilinearAccess(c.xyzw);vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.z);}d.xz=searchDiag2(texCoord,vec2(-1.0,-1.0),end);if(sampleLevelZeroOffset(inputBuffer,texCoord,vec2(1,0)).r>0.0){d.yw=searchDiag2(texCoord,vec2(1.0),end);d.y+=float(end.y>0.9);}else{d.yw=vec2(0.0);}if(d.x+d.y>2.0){vec4 coords=vec4(-d.x,-d.x,d.y,d.y)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.x=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).g;c.y=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(0,-1)).r;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).gr;vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.w).gr;}return weights;}float searchLength(const in vec2 e,const in float offset){vec2 scale=SEARCHTEX_SIZE*vec2(0.5,-1.0);vec2 bias=SEARCHTEX_SIZE*vec2(offset,1.0);scale+=vec2(-1.0,1.0);bias+=vec2(0.5,-0.5);scale*=1.0/SEARCHTEX_PACKED_SIZE;bias*=1.0/SEARCHTEX_PACKED_SIZE;return texture2D(searchTexture,scale*e+bias).r;}float searchXLeft(in vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x>end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(-2.0,0.0)*texelSize+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.0)+3.25;return texelSize.x*offset+texCoord.x;}float searchXRight(vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x<end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(2.0,0.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.5)+3.25;return-texelSize.x*offset+texCoord.x;}float searchYUp(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.y>end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=-vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.0)+3.25;return texelSize.y*offset+texCoord.y;}float searchYDown(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;i++){if(!(texCoord.y<end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.5)+3.25;return-texelSize.y*offset+texCoord.y;}vec2 area(const in vec2 dist,const in float e1,const in float e2,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE)*round(4.0*vec2(e1,e2))+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.y=AREATEX_SUBTEX_SIZE*offset+texCoord.y;return texture2D(areaTexture,texCoord).rg;}void detectHorizontalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){\n#if !defined(DISABLE_CORNER_DETECTION)\nvec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,1)).r;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).r;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,-2)).r;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,-2)).r;weights*=clamp(factor,0.0,1.0);\n#endif\n}void detectVerticalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){\n#if !defined(DISABLE_CORNER_DETECTION)\nvec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(1,0)).g;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).g;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(-2,0)).g;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(-2,1)).g;weights*=clamp(factor,0.0,1.0);\n#endif\n}void main(){vec4 weights=vec4(0.0);vec4 subsampleIndices=vec4(0.0);vec2 e=texture2D(inputBuffer,vUv).rg;if(e.g>0.0){\n#if !defined(DISABLE_DIAG_DETECTION)\nweights.rg=calculateDiagWeights(vUv,e,subsampleIndices);if(weights.r==-weights.g){\n#endif\nvec2 d;vec3 coords;coords.x=searchXLeft(vOffset[0].xy,vOffset[2].x);coords.y=vOffset[1].y;d.x=coords.x;float e1=texture2D(inputBuffer,coords.xy).r;coords.z=searchXRight(vOffset[0].zw,vOffset[2].y);d.y=coords.z;d=round(resolution.xx*d+-vPixCoord.xx);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.zy,vec2(1,0)).r;weights.rg=area(sqrtD,e1,e2,subsampleIndices.y);coords.y=vUv.y;detectHorizontalCornerPattern(weights.rg,coords.xyzy,d);\n#if !defined(DISABLE_DIAG_DETECTION)\n}else{e.r=0.0;}\n#endif\n}if(e.r>0.0){vec2 d;vec3 coords;coords.y=searchYUp(vOffset[1].xy,vOffset[2].z);coords.x=vOffset[0].x;d.x=coords.y;float e1=texture2D(inputBuffer,coords.xy).g;coords.z=searchYDown(vOffset[1].zw,vOffset[2].w);d.y=coords.z;d=round(resolution.yy*d-vPixCoord.yy);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.xz,vec2(0,1)).g;weights.ba=area(sqrtD,e1,e2,subsampleIndices.x);coords.x=vUv.x;detectVerticalCornerPattern(weights.ba,coords.xyxz,d);}gl_FragColor=weights;}";
// src/materials/glsl/smaa-weights.vert
var $fe721963ebf18f1b$var$smaa_weights_default2 = "uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void main(){vUv=position.xy*0.5+0.5;vPixCoord=vUv*resolution;vOffset[0]=vUv.xyxy+texelSize.xyxy*vec4(-0.25,-0.125,1.25,-0.125);vOffset[1]=vUv.xyxy+texelSize.xyxy*vec4(-0.125,-0.25,-0.125,1.25);vOffset[2]=vec4(vOffset[0].xz,vOffset[1].yw)+vec4(-2.0,2.0,-2.0,2.0)*texelSize.xxyy*MAX_SEARCH_STEPS_FLOAT;gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/SMAAWeightsMaterial.js
var $fe721963ebf18f1b$export$b466e73f24a55218 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new SMAA weights material.
   *
   * @param {Vector2} [texelSize] - The absolute screen texel size.
   * @param {Vector2} [resolution] - The resolution.
   */ constructor(texelSize = new (0, $ilwiq.Vector2)(), resolution = new (0, $ilwiq.Vector2)()){
        super({
            name: "SMAAWeightsMaterial",
            defines: {
                // Configurable settings:
                MAX_SEARCH_STEPS_INT: "16",
                MAX_SEARCH_STEPS_FLOAT: "16.0",
                MAX_SEARCH_STEPS_DIAG_INT: "8",
                MAX_SEARCH_STEPS_DIAG_FLOAT: "8.0",
                CORNER_ROUNDING: "25",
                CORNER_ROUNDING_NORM: "0.25",
                // Non-configurable settings:
                AREATEX_MAX_DISTANCE: "16.0",
                AREATEX_MAX_DISTANCE_DIAG: "20.0",
                AREATEX_PIXEL_SIZE: "(1.0 / vec2(160.0, 560.0))",
                AREATEX_SUBTEX_SIZE: "(1.0 / 7.0)",
                SEARCHTEX_SIZE: "vec2(66.0, 33.0)",
                SEARCHTEX_PACKED_SIZE: "vec2(64.0, 16.0)"
            },
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                searchTexture: new (0, $ilwiq.Uniform)(null),
                areaTexture: new (0, $ilwiq.Uniform)(null),
                resolution: new (0, $ilwiq.Uniform)(resolution),
                texelSize: new (0, $ilwiq.Uniform)(texelSize)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$smaa_weights_default,
            vertexShader: $fe721963ebf18f1b$var$smaa_weights_default2
        });
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The search lookup texture.
   *
   * @type {Texture}
   */ get searchTexture() {
        return this.uniforms.searchTexture.value;
    }
    set searchTexture(value) {
        this.uniforms.searchTexture.value = value;
    }
    /**
   * The area lookup texture.
   *
   * @type {Texture}
   */ get areaTexture() {
        return this.uniforms.areaTexture.value;
    }
    set areaTexture(value) {
        this.uniforms.areaTexture.value = value;
    }
    /**
   * Sets the search and area lookup textures.
   *
   * @deprecated Use searchTexture and areaTexture instead.
   * @param {Texture} search - The search lookup texture.
   * @param {Texture} area - The area lookup texture.
   */ setLookupTextures(search, area2) {
        this.searchTexture = search;
        this.areaTexture = area2;
    }
    /**
   * The maximum amount of steps performed in the horizontal/vertical pattern searches, at each side of the pixel.
   * Range: [0, 112].
   *
   * In number of pixels, it's actually the double. So the maximum line length perfectly handled by, for example 16, is
   * 64 (perfectly means that longer lines won't look as good, but are still antialiased).
   *
   * @type {Number}
   */ get orthogonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_INT);
    }
    set orthogonalSearchSteps(value) {
        const s = Math.min(Math.max(value, 0), 112);
        this.defines.MAX_SEARCH_STEPS_INT = s.toFixed("0");
        this.defines.MAX_SEARCH_STEPS_FLOAT = s.toFixed("1");
        this.needsUpdate = true;
    }
    /**
   * Sets the maximum amount of steps performed in the horizontal/vertical pattern searches, at each side of the pixel.
   *
   * @deprecated Use orthogonalSearchSteps instead.
   * @param {Number} value - The search steps. Range: [0, 112].
   */ setOrthogonalSearchSteps(value) {
        this.orthogonalSearchSteps = value;
    }
    /**
   * The maximum steps performed in the diagonal pattern searches, at each side of the pixel. This search
   * jumps one pixel at a time. Range: [0, 20].
   *
   * On high-end machines this search is cheap (between 0.8x and 0.9x slower for 16 steps), but it can have a
   * significant impact on older machines.
   *
   * @type {Number}
   */ get diagonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_DIAG_INT);
    }
    set diagonalSearchSteps(value) {
        const s = Math.min(Math.max(value, 0), 20);
        this.defines.MAX_SEARCH_STEPS_DIAG_INT = s.toFixed("0");
        this.defines.MAX_SEARCH_STEPS_DIAG_FLOAT = s.toFixed("1");
        this.needsUpdate = true;
    }
    /**
   * Specifies the maximum steps performed in the diagonal pattern searches, at each side of the pixel.
   *
   * @deprecated Use diagonalSearchSteps instead.
   * @param {Number} value - The search steps. Range: [0, 20].
   */ setDiagonalSearchSteps(value) {
        this.diagonalSearchSteps = value;
    }
    /**
   * Indicates whether diagonal pattern detection is enabled.
   *
   * @type {Boolean}
   */ get diagonalDetection() {
        return this.defines.DISABLE_DIAG_DETECTION === void 0;
    }
    set diagonalDetection(value) {
        if (value) delete this.defines.DISABLE_DIAG_DETECTION;
        else this.defines.DISABLE_DIAG_DETECTION = "1";
        this.needsUpdate = true;
    }
    /**
   * Indicates whether diagonal pattern detection is enabled.
   *
   * @deprecated Use diagonalDetection instead.
   * @return {Boolean} Whether diagonal pattern detection is enabled.
   */ isDiagonalDetectionEnabled() {
        return this.diagonalDetection;
    }
    /**
   * Enables or disables diagonal pattern detection.
   *
   * @deprecated Use diagonalDetection instead.
   * @param {Boolean} value - Whether diagonal pattern detection should be enabled.
   */ setDiagonalDetectionEnabled(value) {
        this.diagonalDetection = value;
    }
    /**
   * Specifies how much sharp corners will be rounded. Range: [0, 100].
   *
   * @type {Number}
   */ get cornerRounding() {
        return Number(this.defines.CORNER_ROUNDING);
    }
    set cornerRounding(value) {
        const r = Math.min(Math.max(value, 0), 100);
        this.defines.CORNER_ROUNDING = r.toFixed("4");
        this.defines.CORNER_ROUNDING_NORM = (r / 100).toFixed("4");
        this.needsUpdate = true;
    }
    /**
   * Specifies how much sharp corners will be rounded.
   *
   * @deprecated Use cornerRounding instead.
   * @param {Number} value - The corner rounding amount. Range: [0, 100].
   */ setCornerRounding(value) {
        this.cornerRounding = value;
    }
    /**
   * Indicates whether corner detection is enabled.
   *
   * @type {Number}
   */ get cornerDetection() {
        return this.defines.DISABLE_CORNER_DETECTION === void 0;
    }
    set cornerDetection(value) {
        if (value) delete this.defines.DISABLE_CORNER_DETECTION;
        else this.defines.DISABLE_CORNER_DETECTION = "1";
        this.needsUpdate = true;
    }
    /**
   * Indicates whether corner rounding is enabled.
   *
   * @deprecated Use cornerDetection instead.
   * @return {Boolean} Whether corner rounding is enabled.
   */ isCornerRoundingEnabled() {
        return this.cornerDetection;
    }
    /**
   * Enables or disables corner rounding.
   *
   * @deprecated Use cornerDetection instead.
   * @param {Boolean} value - Whether corner rounding should be enabled.
   */ setCornerRoundingEnabled(value) {
        this.cornerDetection = value;
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const uniforms = this.uniforms;
        uniforms.texelSize.value.set(1 / width, 1 / height);
        uniforms.resolution.value.set(width, height);
    }
};
// src/textures/smaa/searchImageDataURL.js
var $fe721963ebf18f1b$var$searchImageDataURL_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAQCAYAAACm53kpAAAAeElEQVRYR+2XSwqAMAxEJ168ePEqwRSKhIIiuHjJqiU0gWE+1CQdApcVAMUAuARaMGCX1MIL/Ow13++9lW2s3mW9MWvsnWc/2fvGygwPAN4E8QzAA4CXAB6AHjG4JTHYI1ey3pcx6FHnEfhLDOIBKAmUBK6/ANUDTlROXAHd9EC1AAAAAElFTkSuQmCC";
// src/textures/smaa/areaImageDataURL.js
var $fe721963ebf18f1b$var$areaImageDataURL_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAAIwCAYAAAABNmBHAAAgAElEQVR4Xuy9CbhlV1ktOvbpq09DkiIkUBI6kxASIH0DlAQiIK1wRfSJTx+i4JX7vKIigs8HXpXvqVcvrcC9agQ7IDTSSWgqCQQliDRBJKkkhDSkqVPNqVOnP+8b//rH3P+eZ+199tlznVTlvVrft7+1T7OaueZY42/m37QALKNk2wHg1pITlB17mC+Pp11W3X/LHyT32vhg48/5SOv+PnwpsHA70JoGlueB1iKApeqzvOzn44GatTB76Xzhd7suBR7+WWADgDEAwwCG/L54b/poDLrHuvvm70Z2Avhsc+PVcxscBU8F8C8ADg5+ipIjD/PlGwfgju8B924E5seARUfLsiNmqQW0IjL8+7L2NYD/7COBzfcCm+aB8SVgdAkYIRCXKyDax4EdAanL5PuNPllNvXDlAHwFgP8AcC2AhRIoDXbsYb48dl5WkVFTE3LGDcC9m4CZCWBuFFgeAZaGAYJQQCRqDHT+McJrVb8zwATUXH02MHYfMHEIGFsAxgjApQqACYQORjtd/B7Axt/z79sC0+cMPgjjlwPwVwHcA+DfAHzTxcVgWBroqMN8+cYBeM71wH0TwKExYHYUWCIAHYRLTlkCYgcIBcAgU/n3qy8GRu4HRgnAOWBkERhddPAJhGJDBxkvw7cqimr+zFM/ZLnZF64cgL8BYD+AWwB8x/dlWuWagHiYL984AJ/0RWBy1AE4AizyM1yxYAcTigW55xMbAkxEiwEdkJ/ZCQxPAiOHgBECcKEC4TBZcKkSv+mTieNcNPNC26mLNsj45QD8LQDTAO4GcJt/7iw2bfoG4WG+vAGwm9ExiEg69zpg/wgwPQLMjgALzn4E4aIzoJjQ9g4024uygkj+pyuAoX0VAIfngOH5NgCHMhAm8Sv2y3XDZeBhNIp8OzJE8OsBzAKYBHAXgDt8/4O+MVT0j4f58o0D8Pxrgf3DwMwIMEPQEYRkNwfgsuuDZLskip0No0gWMD/9HGDoADAkAC4Aw/wsAgZAgs2Z0ABI0GU6IVmKv+f28KDnHxkA/G0A8y6G73N9kOCjXnh/Ebb6OvgwX75xAF5wLTA1VIHPADgMLDj4yIA5AAm6aCUnv4oz46eeDwxNAUMzwJAz4BABSNDFTwSfg7DDKHE23MG5PqIY8A1u/dINs9dBdy8AgnGPM2NfUBrsnw7z5RsH4IXXAAcJviFgluAbygBINnSLWOAjGxJ4pgOKDV0v/OSLKp8iGXBovhLBBOCQM2ACoTOhnYrAdItYbCij5JFzRyIAqRccAnDAQUjg6UNQ7hsMXP0cRQAexss3DsCLCECCLwCQzMcPwUi2MwAScAKbfnY/YRLFQ8DHX+IAJAMSfDkAF13kLvleIjhjQQHxUVS3jjgGpKeeNzYVQEjgUS8k+PghONdhIwAP4+XXBYCHKIJbwJyDTgaIAdCBJx3Q2M8tYAHP9m4df/ylQOsQ0JqtRLCx30K1wtLBggScQOgsKBGcWHAJeOwRC0BSM1mQIKRbhh+Bj98JQP6t4U0APEyXXxcAEnxkQAFwoVUxID9kvQg+c1C7vidRbIDkc24B//hTQGumDcCWA5DgMxASdNIFBUI5pCML8v8API5zfEQx4BudgqiczviSnJhQwCP4BMCGl+wO8+U7AJi/W4O4YS6+pmK/2ciADsAOBhTIIiAJnPB7AvNjP+0AnANaYkAHX2JBAc+tYaJXOqBZv24Vc386XW5dtkHGW+4HFAJonpOe+YYQZAShgKjv3PNvPQaxVoI8zJdfFwASfPzMUwS3Kt1v0UFIlos6oDFdAGFcliMAP/ryAEAGNwQRnDOgLbdlIEwrIs6AZ/QgkMMHQF6ZAKQcJAsSYPwIeAIk9wJgoPK1gi7+PwF4GC/fOAAvIQPSs0URTPBJ/Pp3GSEGRHfBCIQ0xowBtUbcAj7ys5X4Jfu1HIAGQrIgQRXEsAFQIORDFhiDY/rMHmrU4QUgR08AkgUjCAW6CD6CkwBsAIQC4GG6fPMA3OXiNzCg2I9gNCMksmAAoemDzoimFwL48M85AKkiuQVMAAp8CYRRDAt8GQiJ67N6GJODAXAHlsGguscA2AJg1IPGYmxOpBxFWkRN9LsATgIwXnNs/v/5z/9XCf8BO3YAtxbc/46/KDt+5+ea1Yku2VUxHz/z0v24FwMGK1gWsK2OUUxHHdCBeRUB6OxHABr4ZICIBd0QWSF+XRdMTAjgCdTrG9cBNwE4F8CpDkICyYLGsuhFt6zs+gISwUen8zEAjgMw4cfx2H6O/90yAFo84Cbg4ID3/9TfLTt+5+ebnRABkODjx0SwPi5ec/FrYpmqSAxM8Dn60CsqAFI6GfhqAMiDE/gokmvEr0C4PgDkBQm40wE8zMFEUDKEVoxIMLl/KS73mE7H9d+vcKHQQcjwW0Yu9nP8m8sAmOIBuWY6wP2/4s0ezjjg8TuvaR6ABJ70vxUApGrm7EbGE+i472BAB+WHfqHS/eoAaEwY2E9+wLSXTqhI7CXgnB6LCoOJ4BiST+hTnG0HcCwAglCx3ARoZEVFXnBPp/O/A/hXACc7CPs9/i1lAOyIB+RDX+P9/+pbQjjjAMfv/PL6AFDs1wFAgs/9fgKfgdE/ZEpuiQlbwAde6QAMBgiRmsSwA9BY0JfjovGRDBMH4TlcXGhcBOc6HkF0gjPhZgchxTLZMAci/04W/B6Ab3t09EPXcPyflgFwRTwgJ2MN9/8bf5qFM67x+B/aW4XQz42FeL0YrRyikztUFw0704mf9kXgxhOAqc3AAsPyRxxQCs/PdXOFY0W1KHy3QIUGtx+6vdnx1vsB+dsTncm2AogglFgVEAlUWrOMB2RyEmMCGQ/Y7/HvKns6tfGAnJQ+r/9b76oJZ1zD8WdyQjYBh8aBhVEHjELouQ8ukQ7VRSCJAALwkr+sALhnGzDD3JAJYJHg9uhoi4bx8ytkWUtvHT/7+Zc4dw1uZ3612fH2dkQf7yxIEEockwkJQn4IQoq8unhAhmPRKKFx0uv4K8ueTs94wD7u//VX9ghn7OP4c+4G7h8HpseB+dF2AKlFLwuAIZ8jD6NPrOhAffmfA9/ZBuzZCkyRWSeqBCWyoYGQ5yQrBpDbum/ME1HoPo0XEkSD2zlfbna8q6+EUJcTCxKEtHL5EQjP6BEPyIgYAZBvYt3xHyx7OqvGA65y/7/9wVXCGVc5/sl7qxD66dEqiYgRzAqhN1A4CBNAAlDyAFI+iZ9/N3DLJuC+jcDUBmCWyUnOrmTYCMIOkNclLg0B8/RsNLg9+UvNjnd1APLmmQpFHyEBROuWACQT8nN+H/GAvY7/VNnT6SsesMf13/CpahGnZzhjj+PPmwX2MYdDIfQexWyBAwEUOQDrRDN/98p3A7dvAO6fAA5sqHJDBEAyoUVGkwEd6HR12XU4kwzfl6fCXTZzjy57vvnR513X7Hj7AyDvggAUi9EyFgiZqNxPQF6345nOWbD1HQ/Y5fpvuLa/2+82/vNHgAPDFQDnhoF5j2C2qBWCI8bw1eRw5CL5l94L3DEOTI4DB8Y9OWmsEu/zBJ3rgsaybqBob/7A4C7jtWcooRrczr+u2fH2D0AOQgAUCxKEP7aGgLy64+m6KdjWFA9Yc/03/Osa4glrjr+AupqHz1sEs0cxG0BC9HIePLoit9eNkVf9L+DuUWByDJgaq4ybGYLPAWgiXmLedUE7dwC7saL7CqfPKXi4NYdaykCD410bAHlDEsNiwZ9wAPYbkJcfz6T2gm3N8YDZ9d/wHxUA+739fPwXPrSKYGb+BuP3jAFDElFH9HIWwbzCIGkBr/or4J4RYO8oMOW6ZVcAuvi1Cgoha04BCwT5gfMKHm7NoRde2+x41w5A3hQZkADk5+cGiAeMx3+/7AENFA8Yrv/G71cAXFM4Yzj+otOAaQLQA0gZxaIIZtMDFTigKJV8H9Iq6aZ59ZXAvSPAvpEKgBTtBODcSCWCZeRYtpzrmLyeGNCAyFl1v+Hei8qeb370Rdc2O97BAMi7EgB/2QG41nhAHU9LuWAbOB7Qr//GPRUA13r7Gv9FZwIMoVcEswEwfDoimEP0shKKtIphaZQAXv1+YM+wA3DEdcvRKkGJADQQEsQuhi1Tjt95vBsh5nx2IO59SsHDrTmUOStNjndwAAqEry0IyCMICkOyiuIBNwBvPFQQT7gBuPjc9oRYAIHyOEL4vIFEYVNaOou5vCGE/tV/A0wOVcnpzI47NOri3QFIBpSeaSDUdYLOSWvYImSGgftpJDa4MWJbAGxivGUA5MAOc0Be6eVLj7/4Mk+hzCOYPYpZDBiNkLh+G/M3yFyv/ltgL3W3YQfgcFUhgRY2PwY+Z7/EhAR1SFyXCOb57r28QfQBsJQBMn5D4y0HYLPje9Cd7RIC0PM3EiMofF4gVCBp1P840ix/gyz56r+vAMjk9Gl375iB4+CzveuZdLkkEPJ8ZEfX/6R73vOjzT5Si9hucLxHAVg4PwJgRwh9CKOXK8YA4ZEqKZXSQWh5P+5AftXfA/uGKvYjCKn72cctbFrZNECka5L5CPwIPtMH3TVz17MLB5gdLgA2Nd6jACycHwLQxFEUSR5ASvARDB0h9AQb9bXIgCGk6lUfAPYTgEPAITKgg1BObk58srTJgG58WMkWMaAbQQT1nc8rHGANAJsc71EAFs4PAagQestgC1lsBJ4BMCSOK6dDUcwqqaFiQr/0QeAAAdjy+jBiQQeeMSBZT3nCPUDIa9z+/MIB1gCwyfEeBWDh/BCAeQSzgkjFfGLBBD5nxQ4DxN0wv3hVxX5TBGDwL5obxvVA5YqYL5BeMLd66YYxJpRB0gK+96LCAdYAsMnxHgVg4fwIgMrhUPKQ2C+Bz0PmBTqBMQehAbDlIjj4F80KJguSVZ0FuXpjoCOgXawLjALhbT9eOMAuAGxqvEcBWDg/l1IE05Ed0ygZnyHdz0VwCqEPIfNyx0QQvvLDFQCp+8nfZk5und8tXwIgWcHSNX0N2CJmnAl3v6RwgNnhl17T7HiPArBwfghAS7mV/hey2JS9FvM3BLpUUi1YwDRMXvkRYJoAlAh2l0dcZ04s6JUTDIjyBcrl4yDc/dLCAdYAsMnxHgVg4fxwKVwJgGEJNmWtxpQMpX9on2eRhVA+O56AjMfnP+e3Xvf3NwG4xIPTleiY55bpGh6UbafNU0l0z0p+5Jh5HqYJ6b51nP6XP8cx12XNHQVgIQB/bFPVg2OC7Q+WgVFWng/FvtWLI06uWh5oguKEcXVS/9sEAF//VGD7t4ETDgJbF4CNi8CGZWBs2fPL/H6Vwp2KEtVk4fJ+v/EIYPN9wKa5qu+IncfPwXHVZe/aOL3EbwS7xv8A1rQvnO0j8PArTgTGZ4BxFv9mIxhOCGsv+0OPYDRghcLfkWkEuq0+G00x4OtfDGz+d2DbHmDLjL8si8AYP/7CGIAiEEMTG92zXqSbH+d9R2aA0XnvO+JjthiIrOVDHHPOkBrzUQAWAPsZp3oPDpa/Xag6EVkLBK+5rAnJC3/nYk/APD704WiEAV8OTHwX2LQH2DgFbJgFNrBhjd8r79deGoEwsllgNBOzy8CdjweG9wBj08AIAci2D6HafmyAk4/Z7SJ72hGYRwFYAMDLTwOGp4FRFgD3HhzqRGQiyeurqOdG6r0Rm8IEZjzRlkiqCWoEgK8Axm4BJu4HJhyAbFhDxmbDGnZO4j0SgLGDkpibgEq66TJw/1nA0F5gdLpq+zDqFfd5LMeWqu5HNST0uJOIllg+qgMWgI+HPv0xwLA3gWHpW2sC441gCECbmKziaGrnUdMO4aHeh6MxAP4SMHI7ML4HGD8AjHvHJGNAgpDgY/ck3stipRemvVhc+uASMPUEYGh/9dIRgGx8Y+MNbR/00uVtH0wEx94j/v0oAxaA8Ed+GBieAYZZg5kADC0QWGOFzGJlcGPzl1BxNLXD8sk4xftwNAbA/wwM3wGMUmxOOQBnHXzetIYvibonmSiuYTNjriVg7glAiwBk0fNZH6+PmX9P6kfNmCXGpftJ7TgKwBIAnln14BAAYxMYm5C6RjCyCoOyr0qkD/c+HI0B8DXA8N3AyCQwesD1VQKH7EcASm1Q+y4CkN9pUKiVF5nLvy+fBbTUd8QBaH1HvNBROiZvfsNnrF4kcvPwpdsBLBeU18Nf7AB23Dp4ecHC8oBgUlJJecLS+7+WOpE3gbE+HKw+yoevCYkMGKqPJrdEKARutaFYRs1fiEZ0wP8CDN8LDO8FRqYq3W10pgKgfYLaYCzootgA6KXaTA90y374TKB1sBozy77xHFZ536utRgAmEaw6g5kUSFZwSXnA330qsOlfgHMPDlZesLA8IOjoLypPWHj/11EnCiVwkz7kAExtsGraYUWdSDX5TmsagL8KDBGA7Bd30JsW0oWivnEOQNP7yGTSBR101AlZSUtGyfgZDkCWY1HnJdcBVe6325hTvelg2CQjZNDygG/2An0j1wKnL6y9vGBheUC8prQ8YeH9X39OVQSc7Mc6fCaKvAeHdCIVf4yMYCynTpX+nb97NJmlSQb8r8DQHm9YOFUZTKOzoXGhs6AxF0HIexcLBvWBuiHN8s2ne98R3qc6L4Vyb2oBVjfm9MIFHbjDCh6kPOBbQoG+oW8CO5bWVl6wsDwgfr20PGHh/X/1iaEIuDcCTIW/1Q4rFv8OnYiW3c+W2iKwUjKbyjQNwL1uuR6sAEgDgq1brXOmV81PxhNB6DUDBSYzQJwFtz623XcktX1Q1VWKaTF/zZhVazBVYA1tX5MazsGvobwe/jQr0Ne6BTh5uf/ygoXlAfG60vKEhff/rSe1i4DnTWDUACY1guFTDqLYdCBvf6DJYSMYATBfOx1kLfj1v1axH10nQ3Sd0GUkBnTfpemtBJgseIKQAHLQcVxa2TnuMW0Aqui5es8xBIegVdVVE8VhzHnLh65WMB9An+X18K6aAn2tO4ETl6vqbKuVFywsDwhevqg8YeH93/Rk70JE90nowxZbIJjvS3WYNSGUwGHJTpPxwwcbBuBrgRYBeKACn7VtpdUu/c0NJxO9BIxcKu4TTODzbkonPLoaL0vyUQRb2y8HsL1ckfWzMeuFi40Qezqi+yiPhyt7FOjr6/gCFwgP7Xb5vssTFt7/nQRg6MGRWmDRoeyTlpgw68GRTwgZgo1gGmXAX6/8dtaylSKY/koyID9BhzML3q1gAos2AcOrZYSoq/pJp1VtODRm9Z3LS/7WjVkvXOzEtOpKyGrlAT+4SoG+VY8vBGCvy/dVnrDw/vee65NBJiAjBIVcAJQjOm+DkCZEeiGAMw6sAwDZsJrAdhFM9rPGhd4904Co5oVuCZPV6kD40Ec6+9W8dBTBsfdc3nkpvnB82fp2RPcs79dHgb51LA9ofsDV6vut5/3PnxcAmLVBiDqgevDaJLkYrpuQxzcNwN8AWgIgRbB8loEBzXDwl4cGiDGft58SCOWGedgjvOJ+bPvgRkiuA+ZjzhnQQOiFNVbloa7l/fos0LdO5QENgEXlCfs8Qbf7HyMA3QVjYihYhLENgjX9y/qwxQmRU/asfd0ZcLU2CHVGyusJQLKfVi98CS12T5f7iECkHpsMkAhCF8+nshWH2I/jXsOYO144GV/9ApAIrS3vt4YCfetQHtAA2G+/4PW4/2PPbzMgmUMi2NoeSCRxIt2/FvuxWURIWCXg357gfTjEDNIHnTRXRCpH5ugKwGl3HpMBXQc0v6WLYVm/5limj04rG762K2uYY9jBkr9+rI03NL5ZbczS/dJ+LQyoga4o77fGAn0NlwdMAOy3vl/T938KAcj121z8Bn+Y9eWQJRz8Y6kNagDh2ey5EvxjxQD8TWdAuneCCO4An1vw5vdzQMmdktwq7pLZQR+dM34+ZumAxvY1Y04uqOAJ6FsExzeto7zfAAX6GiwPaLWR1lrfr8n7f/Rl3QGzmsis+/uO71V9OFgP2gpPhgr7TGRqRUT6dyvr4aIs/pm/2zVUNbBSv6G8e5pEv0Cvec7Po7+bTtjlBRlkvAMBkDeQyvsNWKCvofKACYBrre/X1P0/oWEAnnFD1YdjhtXxR73mX10FfCHHE9pVWcGAI/S0gKsfA2y+twrFZw6Hxf/F0Pk8Ri/kpGSnMuDx5T0iACgQHioo0NdAecBUHW6QdsV2/cL7v/Cyqr5gnc42CCOcfX1VIZ/V8We9IDmTzVXwPDJiXuKXPxtDBma8+lzP4WAgKkPxCUAPE4v5GzEuMX0PYJPLhB6FJsc7MAMmkVxaYC/K9gG+F1++8AQ7Gwbgk78I7GFpXgIwFiRXOwaJZPUbiR0yCUDRk+cHf+YpwMj9HgfI8ClGPyvsSiH0WSKRuYlitLb/zHM/JOSs5C/YIC9cMQDZr/dwxgOW9gtGYUBi0wA8l304vDQvAchilFbpIBQhZ7Ejq6ZQ0/Yhil8y4j89Axie9DAsD6FX9HOK3QtROTFkviN83kG4felIY8DCeLrSeMDSfsEovAECUFsTjHD+tcB+tkFgcXKvBRir7qtFl9owmO4Xy/1G3bAFfPrZHorFNWBFwHjQAFctIghj2kBarw06If/+MM9ZqTN6DgsDojCerjQesLRfMApvoGkAWh8Ob/tgAPSKWCp8ngNQtadjmTdltvNvn3peFYhgQQgh+iUmEaUAUoXM1yRLmWuFLaE9Z+XIAWBhPF1pPGBpv2AU3kDTALzwmqo6qtVh9kJErAudABia38TC5wJgS2xIhAwBn3yhByL4EhzXfRXxYsDTJ4IvrNN2JFMxZcBzVo4cABbG05XGA5b2C0bhDTQNQLZBYH1AVsQSAAU+imI1obHyblnjG/kJk3U8BHz8xVUQAhnQIl5CyNgKAGp5LKSSCoAySh5Jj79vTagcxUaIBeRNe79g9gq+DXig4wGzy+PONfT7RWFA4noAkGXZVAhcBckJQgNgrLiaNb3paIDo1vHHX+oA9LQBi4DxJcOUPJUnTgU2NJUyROs8irGARxQAC+PpCtsFd40H/AEf0gMQkLgeACT41PiGoLOKqyrJq3K/Ya9mNyr5FusN/uPLPIeDa8Bc+w3rtyl4VFHaMZc3i9RWBM9jjzgAFsbTFbYLRmm/YBTeQNMAtD4cBKDXBTQGdAB2MGBo8SCLmEuS1AFVAJ3A/NhPt0PoCcA8bSDG76XI7aySg6JYuGfKwJHFgH0E5B3ueMCe/Y4L+xVHAOZ+9EHcEgQgwbeiEYx6jwTdz4qfu7EhEJqxGqruf/RnHIAEnxgwBM0aC8aUAYWNBRCmoIll4HTqO122QcZbrgMWxtMVtgvuOx6wa7/jwhtoGoDWh4MBJ16WN4lfr8AqI0TVV1O1fa9BbQzovkAy4Ed+NgCQUSxZCFWvCOaOFREXyUwZOPIA2GdA3uGOB6wPaOz+QPv5S+MA3OXiN9aclghW+d3IgupBF2pPqxcxGenDPxfSRh2ASiKKiVP2PaZScvAKoA0VDc6cOlIB2GdA3uGOB1zR77iwX/F6AFB9ONSOQW0frA50sILVcckWJyIDSgwPAVcJgFbYuZ3FJvAlEHbJ3IsgJLGedeBIA+AAAXmHOx6wo99xYb/i9QKg2iAIfDJEJHqj4SExbEty0gkdhB/6P9oZbBZIGiKYVb9GKaN50lRHBLOvhDxh/5EKwDUG5B3ueMB2QGM/grb7/6wHAPNGMAY+GSGUjC52VX2f2CD4+HO0gqkZfegXKgBaHkcWtS0AWii9xG1ImrLlN5XR8L8fmQD05BVrmEENmpYSP9QX+KHiqj2/82+HqqDWwnbBRfGATdzAegGwru2DpRq7Mzq2fpAf0Nq0Rl2wBXzglZ4yUAPAmDSVWDBPHQjLcgTqOZ6zUvdKHh4ruDCerox/Dnu7YqwXAC1NI/QcEQuK6WK/kdgCTGC0PYAP/KIDMBgglq+hIkrOfsaCviLSofcJgJ5AdM7kkSaCj/HqQKVIGvD4swF8bcBjmzjsaQ2H5D/6acBd9wALB4DFWWB5AVherMp4GKIYEOp7+26UF0aSfT/xYuDG7wDjrIpAERytXf2vajj7ueryQXSFl10K/ON3gIWDwCLvjfGB8Z54O+Ee4ve6513uB2R1yzsqC+twbC8HcNVhfAeaBuDP/TvwtS3A/ePAIfYFVlPq2HHTuyulZCTlhbjhETF5yxTQGgPGhoHhIWC4VSXGD3n0tLkMHXHxu+YyB+MlPwDuZs5K6FlsbCzdVO9DuKfkHM8AEkP7B8fOkwDcD+B7np42+JkGOvKdAL4E4K8P0zvQdET0b14D3DgB3D0B7B8HZka9WzrD88N6sFm+YcUjrn7E1ZDvMtF9DBgeAYaHgSGB0PNHCD4BLwLRsByAyX/ij0/dDUxuqlIG5hix7eFhvLcOVUAtyPSydAFmOQNe6EYGV/9ZESiKgIEgtbaD/gHALQC4ovY5r5KwtjOU/XfTAHzzLuCmIeDuMWDvKHBwpMoN0WQzNtAaYSs0K4ZlOSAjGG9kPjCBRwZ0ABKEBJexYAZEAU3A7Oi1BeDym4EDnjQ1TwCGWMW8MXcKks0YOyZNlQOQjcgYIUHllEzYQ0ktm+r6oz8G4F4AXwXwRd8/kO9A0wB8y65KmPxgGJgcqYJTKYpTv2CCzyddQJRDOjKivn+Deh8BF8BnwBtaCUA+YYEyAU8h+c6Az9gNHHRmrgOgmDA3jHQ+iWupCeUAvNSrA9HNwqx+muk9nJVNg/CTfrmbAPwbgK8D+PcHkIibjob5o13A3XypWsAkG1cPA9PDFQDZM1id0i1KxsWfOrKnAFXlifCFFMMRcASigOcs2MGAIfE9iWXplS6On7UbmPaUUTXQrgsVMzcRj5Folg2V5ayUA5BWYKwOxKUafnosWjcJwk+7W5F2EKvlE3xcXaNYfiCYsGkA/smuqug6hcleAnAImPbO6YwRpMgjCAVAm/yQmKTv5hNsAf/i7SyNBSl2a8Qv/4/M1yF+BZSYlNQCnnVrpbC+mToAACAASURBVJcaI7sOSEY2NpaDXLqpR+vE/OVksDgImgGgghHoYJbTWc7oJtFWc65/cg2AYvh2ALsB3AzgVv95nS/f4QdsIkT9T3cBrGtITWZfC5hqtQHInsEGQn3UDDvEDEY/ICf7SxMOrAg8T+c00JGkvHGd2DABUYZIAONzCUDppCFhSukCBsLQrFtZe/IixYQpSyEoJoqnuPWrVRAubQh83HNlZB23z7j1ywmj6CIIqUPxw2Xeu9bx2jx10wz4Z7sqTYZaDD8EIDuoE3hMVEphWg66JIp90k0sBxBcy+iPIIaT1RtEsHS/yIAqw+VSNPWQfe5tlVEk8auXgVa5BUsEJuT5uoliAbE5AGotmIAjCPnR9xDG3TQernYAUupTdBGEFMf83OkApHG+XlvTAPwfuyrgSZOhas3u6cwTsUBVn2gTwyFMi8wjHZAA1M9fYGHDULJD1m8Cpa8fRxDad+l+Ykf/3XNvd11U+qiL39SxXevSsshdDFvgbI1O2AwAtRZMZzTBRuDFjxe1Xg8QEIB8yyj5yYIUxfQIkfkIRnmHCM712JoG4FsdgHHp3ACoMH2G6jM4lWzoQarSvwQ6MSB/vporVaFkh+mCLlpVR8Z+dqDZLoDOpHSiQeAFDkBjPrlgCHgCUaFifg67H/9uYjn4Ai1vpTERTAASBaoQJBAKeNqHlL6mwPDZYAOROag/EYRkPX34MwHIvzW9rQcA+TLpI22G7EcQKlJGsYIJhC6ClUMiXfBTbFUQAej6nPS/OuAl9pOOqIc2BLzg++3VmWgIEUz82cRuCAtLIHQQm0gO52uOAb22sC3JEWgRfPpZf2sQBQIgLydPEIFGwPEj8MlF2bSbsulghLftqsCXq9HGgHysznrGgi5qzTUTFH8FLhAUn3hIJwCN0HLncw37qaF2zoYvuKNivmQIuUNc7GvWt6sHNs26twA6vhyq8NEMAHlyntFrDCcQehyaPTl+FwAbXDcmAKMRThakEk8Q8kPg8SPL0qzLBl+A9QCgR6uZGs3vfHz8TtBZvkgGQrEPBVAUg2Sij50QAOjiVKI3saADJRm7dSLYWfSFDkCem/dhZeMy9pPY5QvSDYQyUJoDIK8qMezh3wY6fSL49PcGgCAA8pScJLIgAUYQEmz8RPA17StvGoBv39W24eREiBoNQSgWNI1HBkdgxJSw1AI+dFIbgOYmkjimQ1r6XXC3rAbCHycAgytohf8vsB/r2KRaRq7zpZ+D37HMX0s3DDcCUGLYaw53MJ4YUODzusqlGCQAOQCejuxA8UULUkxIwAmMAp8Wa3qkN/R9W+sBwOhIEPjk5SLr8HeKFbTQfb77csPIMHGl/4MPbReslPhNe4+MiTpi9AFGV4nI7MfvagNQLh/pfrYnDAS8aJQ42A2w4em2cAyWQUuJVQTGWLs1uL7DG9J1RjhA+jvYk4t3KXeMqijpzrud4At9z3XtP16yGfjKZmCGooYh1tZzvv8xXPFl4PoJYC97k9FlwZWD+Azi/deMZWeP13eQCGEyoERudChIjbb3mJYwH7V0QIKuCwj/gfMj0asn2I0FXRSHXfL/iRkNgLyeVj8ccMY//J1fyxzTAXT2+xoQViKYD/1hDqLxPiYxTgSvQrphphG97tz4Slqafnj7uk1kIQDZrvWTw8B3jwEW+RLxPgSiCERdPwPR7+wCPg/gulFgfruDkOMQkFc5x84e708JAMmCuRNBXi4TIg5CGRzGiBGE/D4E/C2r2vcAYJoify62i0aJSMhB+2IHoNwu0fkcjQ85pu3ack5nIBREqneYFyWLkAXIJHESe00Cyx5QyeL6F/tyEcDcrOW2n7fX8df0mME+/vQ/PQjhoy3gzo3AISYf80MQaQx1peH9wb7v2mrtmCBkIMMejp3jIJD1MsaxaMZ8v5N/67INAsB3BAYU4JL4DSo1J15AFPAEwuQHZJzkKfUAtOHLJSOQRWndBYQvCQA01cfnNopfsaCJaD2baBn79QjSTiOEP1EcawIpkq2kegBTNgHWEpOKF8Uwq2NRFPM4AqCf46/rA2U9/uVDvurB01zvAJpiiwOl3fEeciCGF+Ij11f+QkbSfMPfIzqw57mEFZ9Dl3Ps5HXWAYByHJAJKV7N+s0cCQQhwSlfm4lGZ0KB8C/rABgZUS6ZHITBSEhCowUYAAksF7cStWREyxRwtuPpOlgw+5s9sq6OaIJIIlUgEhA1edoTgHxa9HVw5jibZNF+j/9yGQA/7pbujZ4bwv2+cWB6tFo0NzYnkxFA+cvEAo43VBoEo2e+48EMXEOmD9F6xhCE8RwZEJ80VblKvDlmzwicfqy93/o+8K8TwB2jVSgW138FrJQTXBNlnJgmrjZwanow9CBP/rL9wF0jwAGWDtFyoN9PHutnIHT05mPXz93dMGQAPniJsjiBXiTbxDZFMF9NLUPQxKR5qezz1Y6/YZDH0D6GkdAkYJIvRalAdHAMmPZoYhb6NhDWvEyf/ma737CXN7R1ZC7hUbPgcFgqt/ZZjADnM1xqEVhYBpb4CUk5UsL7jQvj///5buDrLeCOEeD+YQchYwG9VIfyg1NaZszFiCH6DkRGLze5/dgk8IMWcMCjdCiCzR8od1B8OTwvJM8JEShFut1fzMhi+eRJr6LI7hYP2M/xVLwKNoZjUTwRMAQQmYyhWGQxsSADOflZ4kukj7PhZ75bETjBpkAGahMkcrGgwhsXeCyBHBj1wmOBQwvAwqKzoFeRV8ZaerjKYAuirmPY/o9X7q5Cyr7fAvYMAftCPGAEoYlBiVtFwLjtp2U4irj7yOANbi+crHyrfCbTquJV44O0F1FrwQGIMZFqdQDyP/gGSZ8TC0ZRRsOlVzzgasd/u+zpMByLehAfCgMQCDyGZJHFCCgLZ2f8mgI5qauEcVx9e5vACTgCTwEMWr5TdIpWKJb5MvrnoocDswvAPAG4VLGg6UKeqmi4iuDz4er30oX0FP7u5moMvIf7W8B+jwlUNAzFnlZCIhvGFRCeWzrgXSSIBreXTFZSgVLHAp4UHOFuociEEsn2PJwl/XEk0dzfSojeerFg1IOo5BKAveIBex1P67lgUzgWQaJwLAKRH04i14ItgDKEtGsRnWx49b2Vkk9wUefTGrKCF7R0JxZMqxN8cmPAxWcAcxGABKEAKPA5u9lEaAbCmKMI+sDN1X3z+ro24wEZFc0VEE64ABgT180PF9ZdBcDb6JpqcPtPk+1ACbmKjJnllwyuILunEAWjZHkBsrsRUnfD0qEiC5IJfyisgMhzWhcP2O14Ro4WbASgAMQJ48SJwchmBCDFa8qpyBbSP7OvU4PQ0p2W7+LSnSJUFOrI4V7w5IoBTQQTfJ6oTSYk2mQcpGRyH2syGjIF6EM3V/fM++C1CfwUExhCsmzCaQT43lZC3e1hBpEHh36XEqrB7Scmq5dV0XZxmV8WuDFzAF9iwhow9seAGoBcGtKjqAc+1l9rLb/1igesO55ysmCrC8ei6IxRMAKTWNBi6Xw98xNTFUi0jEcmpYgRAPhddpVi9OIEPP5cYD4CcLkCooHPwaW9kV+iwWrQHT8uA1fd3F7DFvgUHUP2k8jTiogAqLoxFpDgbMj9jXSuN7i9dLIdaxzBp5XVBMIMgFEnFAPKT9qPd6A9BIGI7MfPmf4U+40HzI8nWgq2PBxL4FEkjKJixGRRFyQQPzzd1iAUzCAQas1YOmAEoFjwkecDC/PAwhKw6CxIkCXwOdVJLxTobMjBdyIgfvimNvNJ7Evf4jWtdnRYD1YNGVuG93VWuWs4Jf+mlZCCZxwP/cnJ6mXVKk2+tK8lQQVHRTGc64SDAZB3Ey3JcxyACkToJx4wHl+YwqloGDICmYmTFgMQFBET8yyYzyAG/AfWX8mCGQg0BTRoHwt9KVaPE/HQ890AIfgWK+CRAaMRYnVdxHbhdY8Wslw1V93UDsmPIj9GxgiAioRRMIJNvoti+SW/Ikd0gwAU8+XxJcbGITJPDvI6XdCFREFSknTB83xka40H1PGF9dnycCxFwygkK0bASJQSVAbAYeD98xUAe5U3jKIwBosSgNsuABYogl3/IwgFPrOIg1Xc4ZrpAsSrvruykl2ucykapkMMh4CExD5DwJfWAYAxwk4MKPAJgOIjGSEGwuCakRhemw6Yv0UUwRf7L00L9pnsNx6Qx4feY4O8pDEcixOjsoTKKpMYjSFYYjOC8Eq3Wnnr0YYS+0Tmi2HysrPGLqwASNYzBnT2Mz2QD91laxLB0gs12GAh81cf/o/OcHyJ+qj0S/zxnhUZbSyYWaL8+Rq2S29wowiWkJPan4MvgrDDGAlRe7KIywDIgR3meEDWg9HbJgApNTkXo8o0i7oVgxnEgFr8F7jEdnU5GvqfJQKQKyEOPlsNIQvyvupAGHS/Okv4qv9oh+PHxMLk8ggBCRxvAmEN+AiEzz2iQfQBeNmkh4K52hJBKOaNe/FSLobLRXCz43rQnu2yi9oMSMDxs2jo8303ERz1wsCGZECF4kd3DwEYYwJjhoNlQrgIjlYodbBPrwMAZfEmyzcIv27gs6XDzC/IR1DOgA9a6DRz4wZAsZ+LYXvQYsHoD4ziOFklna6YD3+nnU6dZ7bGDAcBUImIAmEUw/zbJ1i/scGNDJiLXmle3RhQ+l/aq57gUQCWzwwBKPeLsZ/LFrGg/ShRXAe64Ajkv30kALAjF8R11Dy3K7KRwJcsUTaqWScARou3w/INVnCH+A36n8RvM3nB5XP4oD6DATBYwGb5ajlOLOh6X8JaBKRG77+7ygGYp1bn+V25/01AzBnwQ1ypanD7KWfA1QDYC3zJIj7KgOUzc9nFbetX/r+O5biwNhyX5uSEDr5o0xsJwLp8/m4A7GaJUv/j3/5+HQFYJ3oFPPkho/hNeqBcMkcB2BAA6XrxmMBkfFAci/m0JpwzXw0TXvXtzrz+PKc/Ml/ugzM9MDqCAbz/keVjjGcQA/YLvjoguo1mRslRI6RwfsiA5nqhL5D6nscF8gfTdfxpS+/hLzvWfzMQCoB1Fq/8b3VWaPIDZqsRV64DALsZHVHs1gEvsqFAeBSApQC8pHK90Oql4UEAyvCwNeGcBXNLOPMLftgZsI75ouUr9ousp2TEyIJ/sU4AzC1e+WIFshyAHPZREVwItrrD3wGAhibTYBhxVpe/xePyrNBuWaoNp3DgFwC81O+RAepK/a5Lfe51jxr7JwA83nPXYgq1asl0yX5N48+f4VEGLATlK1vAo5YB1gBSRmsM+NFE57lcfPD5pPFWCJImtyvGgGfOAacBYO59zFglgHgPefZsXV6/gPXBYeC0RVgyJNOGYuJjPka9eHWgjL9bWzhWk0/n/wPn+k8bgFNmgYcsVflZnBRmIShtJM/m7JGibGBoOIIez9wKPP4AcNpylfbNlGfdI+9NjBjz8JVzppckZuJ+dBw4aQ44drk6j1LIY9JkPD7P4s2lwVEGLHwJnncscNIh4Nh5YMsSsHm5ndOu1BGFThJ8/K6JrZtoslST2+XHA6ftB05ZAE5crgAups5TfaL6EF+UyIif3gAcOwtsXep82eIYY9JkXpMgMp/AeZQBC2b8OduBYw8C2+aALQvARgJwGZhY7swEzbNa88IRvAVO1qkF91J36DNOBE7eD2yfB45fqphLnevzdGeBKBfL8UX5/CZgyyyweRHYsFwxYHzRNK6oetSBMDLjUQAWTPqPngpsnQK2zgKbCMAlYMMSME4ALrcnR6JYQIwsoUnjpDRstOLy7cBJB4CHUGwuAtuW2nUDVH1EFUhycSwWjGD64mZg0xywcaECoI0z5P3X5P6nWlHdgHgUgAUAfOYOYMtBYNMssHEe2LgITBCADkIzSJZXpCOnIg25uPrhgnupO/TyhwLHHwSOmwW2LVSik2pCrDsQskzNIBGIpBdGI+VfNgMb5oENCxX4yPRjPj4xaJ0+WGeEHRXBDUz2Mx4FbDoIbJypADixUAFwzAFI8KUJChMV2SUaAGc1cE/xFJef3FYRti64nkqWDrqqEhbrsm5zvZCdPCd8nHzJOLZuABRz9hTHZwPL7LnLnoNMIY2VyaKcjtZLHOAbNgNPngKe4BacfGF1pnydD+hphQ/8XV5UiEueLGnDN1tWXj/3/4cTwAUzwGPcRcFJiDpPt3FLmf5vjwE2HAQ2zPrEzDv7OQg5OSM+ScYQy5Xbo8465u/ZfLTJ7fKHAdumKxVh8wKwealSE6inEoSy2MWCdbUHIghv3AqMzwHji9VLZuDzD8cXxxWZs5c7apmW0fMBnIHKn5X7d6I5npvRz94O7LgXuGIReJSb+Xl1tzqflybwRwqf9i97BQRWomWJQ7oZVFtJoqDX/b/oGODsvcBTATB9gsfGqmzdjtVz+G+PAyamgYmZCoDjFE2anCVg1CeJwOMnTRB/DmUINVkkgia3y08BtkwDW+YqAFJFMD1VAAw6XG61R31O9/fdrcDYPDDmY0zjc1UjivBuAMx1QdMB+WAYXU8dhEU16dOSkppbcHFSrng8MHwnsGMPcN5ypURHp2xMIa7zDz2z8Gn/kVe0YomO0wEwBYKujL7v/zHA6C3AxfOVh58g5AsZxx4fZM7sf3h6BcDxWWeGBZ+cMEFiwGEHHRnDzun7ONHs/djkRgBunql0VDOSHIDU3cxSD4aEajhFXS4H4S1bgVGN0V8we7E0Fh9jVDG6Obr1LJMRwn+kOCaTEYT0dsfqZHXl/p7PrLi9wIY7gO0H2yAgCAWCWCowKrYE8nMLn/a7PQn9X7zIJPPkCcK+758y7x7guNsB6l98gZjLLYet3Ay5n0sv4R+fCYxPA2MOwLEAQLIDPyP8uBg2cRYmzFweAYilKkn+OC8/Fdh0CNhEA4nGA40kd6FES13WLO8v1qHKAfh9B+DoYjU2Ak/js/8NAIwg7OUb7LCC+WAfB4CpBJoIiTRNRmS1l13kqWh3Adv2A8cdqqp1MB+aIOSxWv6pq5D2kkIAvt8rF7BLJksN/jMqfa7v+7/Ak4B3A6ceqpasKMq5akAmlLWY37t8ZW97PDB2qALg2BxgAFwANEGcnI5JcrDZRPlkaXL4u1KJUAfAjbTQ59x6dSvdLPXAgGYshZWR6JIRaXB/NwFI8C1WwLMXzMeSwLfcXuKrA2G+wrLCDcN/IIg4ERRn0qvyySAQX6mG1XuA4fuAbTOVwktRRr2MLCoQyvEZ/UY/WwjAj3jtFJZkU79g1ghkgEBf98+0Umb/3A2M3lkBl/fOcdMok2EjkZyv8773LAfgHDDKjwNwxEUw9yailpwdxBAEYhBbAuGzG3aKkQEJwAkCkOCjlb7Y6SYyf2UwlAS+vKYnAXjfNmDEX7DEfA5CjUcsnzvbu1nDtUMmCDkRZEEyGdlAk6G6lQTSa6m0MP6HuY73AxNTlcJLZ6WOJYC5/CNxLpHMgdKIKNl69Qvu6/75AjHOiTU87gKOOViJb748BKCWrnK/maTA+58AjM0Ao7PA6Lx/xBAupoYDC9okBRAmPdBZ47lNA/DhwMRsxX7mPgl+SrmK5EaRNRslXFQ9CKB9DkADn79cZtkHFkysJ103eBbqlh97DpmTQTYgk9VNxu+xYbXKU3lhFoJPOgdFGY+lPkgQxokkgF9Xgj4AvfoFs84eX4Ke9x9fIC+tRfDxvvniif358sSir2LCj5wNjBKAc8CIi2AxxLCzIAGY9L7AhGIKgpATw4l8wToB0JjPrfTkp+SLQbHrOqm5jNyajS6VCMIpApDAWwQ4LrGgXqzIfnq5cv0vN0ZXHTInME5GBNLb1DGdOYQsI7AfGKFjlgqve8wJwG4T+fuFAFytXzCLb+VgWnH/fIGYfc46Hs7iHC8ZkPcdXx4VfVXJw8+cA4wIgM6AHSLKWZCTESfLfg7WsIyRF3ckiRQ+HACXkwHptyP4KHrpJvKVGnOhRF9eBF9wE0mUEogz2wC+WGI/vVxiQQIxAs9+rmHA6E1YFYB8DJwQMZl0OrLZ++i7sfT8zroYHLS9df4RACWKxSZvLXzG/fQLZqk2gqn2/vUCUQ9UZaM9wDaPeSPrC4A5C1KV+NITKwCS/SiCR/jRBDlLmP7nHynsxno1IPwJSyRpbiMADXzuPDYfZfBTEoAmcuVQdiaW0zwXwQsCYDYmMaDA1wG8TBSvaoR0G77EcGSET6hjOvVApfRPAUN0zjr45JzVcSqiTxD+VeGzXku/4Nr7JwDJOkxFIwt6j6+RqUrlkO4bXzp1gCAAv04AzgLDDsBhKugLFUvQUhTwCEKbnKCw14HwJ9cDgGQ9WegRgDI8XEcVEDvAl7lVlglAgi+I4CR+Zf1mLGgMmDFhBGFfDCicRJFERviSABjLS7FC0MFKMU+07wOPE0kGvaoQgGvtF9z1/iODkwn3VWoEXxres5ib9xx1wZufBAwLgAQexbAD0JiQwJOuJBA68/H3Zhk6+3CifqqwWNMKN8wjKgbk6gWJgC+FMaBb5vJVmsUbV2vCqo3cRWZcCIACoax53+ulkqNd7iqOcU1WcC9cxEm5kQBUdZ+sTnSL/jEtTWngi21jhJNJBivZBukXvOL+yYBkcOqxKjJ4AGgxzMrBVwdAMmHrZOAYF2l6y/mwV6xD17zmWo6MbRyeWtOHwxJ91IIhr6rqZS70DPPLXDVUrfBwzHKr1EUp6/h0T/6L/GcCqslt4IhoTcwdAqDSs7I60WQH6R329pHuFyuXDJmEjuOSbdB+wSvuP5bGUjmsA5XoUvcvBXKKAQnApUdXwah0b8jXR2YzJTsC0ZHB33FL+2yiX3h/1YeD1fFZGT81g/H6yqkVa9YEpqMhTADle8erHA6t7Mh6j4ZBXdBGjFyO4CSIm9wGBiBvgqxwIAJQlXIyEJLyI/i0SkAG/FbhaEr6BXfcv+5dLKhCg4z1C1HEBJ8+BODQGZXfk/quAZC6ketAZEQCTWAU8PIJt0fgwHzZvVWNaKqi7JLOmtDWFy42g1FxH/XfqGkII0C+a0tnDkfsGxQjn3VPsk7tXmuy+Xp0JhtoJosAaFcUAJUYKiYJxcqHqKAH9rPlG2cMrmCUbMX9guMLpGTcCMKDlZGhMK8IPnPIn1X5PA2AwegwEEYmDGBMjOI5whGQP3NPBT7VJlRNaKvF4t2IWHbDErtDlSk1p4lJ7/zd246tglGZryIfrFhQ7pU8WCAX0ZENG+57U14Z4YrCeLrSxXdev6TfLwrbxT7znMrfKQXfHLQCnyvmRIv0Q3430ezMmL98P393G3wqz6am1NYzzoGn+svqRmTAU2citctqAX/2EI8F9ACEmLHXLZGoFxtSl2xyK2bAYwrj6Xr12+1noL/jUTCD9vvFrn6u0v1/nvGkaoVBAQi0eummMAuXQHMWJAA7gCixG8U0gFfcXdlBKk4Z6zELgAJfZEKrxpC1xOIl/+Sk7jkcdYlSco90y9+gK6vJrRiADD0piad7RuFo3udNCgft94vCdrGXn+tujgV3QAcHLcFnroelivHkchEL8ue0uQ74S3eubAITS3IQhKkMRjBMokgWG3L//2z3VSnP4VDgQWxUEEUxAZFHL0eR3HDfm3IRbDHkBfF0zy4EIKNhSvr9goGEBdvTz/MIYQLQdVsTwRTFDj5jQmdArRDYJQNDSs961R3tPhx5NXoVgoxleHnarjohgLec3D2HI492yQNvIwvqO9fJm9zKGbAwnu6FhaP5pFuMg/b7tTbpBdvTz68cz/zI8azVj8iAHTqgmFHXDUB89R2dtaC7tUGw4kDOgFb0R2wYRDGZ8g9O8aU4XwPOczhiwGlMjqqLWiFYGu570wADFsbTvaxg8nkow7E8nM/atfKzln6/1mS4YHv6BQ4+Z0BbqHcd0NwwYbVD3+1yWhXJxPBrbq8AqE/XApSqAxiBV2MZ/54DMOZwKE00rnDUWcR5KiV/brjtSAMALIyn+/mCyeehjIYp6fdrvVELth8RAClyHXxmhPi6r1m8FM0ucgk8+y4RHC1kAK/5XgW+2hZYofafWcPq1B5AqDqEYsQ3nepR2gqhV2yiol1COkD0C+aOaoGx4aL7DQCwMJ7uVwomn4fm7VrX2u/XAlELth+5sHPtN+l/Ap6sX2dCsZ/phZkIJgv9l++1wbcq+2WFv2NXIjNKAPzuw7MUAV8DTuynFIEsQy83RgTAhiv+NgBABaQOGE/3mwWTLwAqHnaQfr9GnwUbARgDNBUlkpzQboyYCyYDYdILdf0l4NduW9kGoa4geNdazLElKoA3Prx7DofiETtC6XvE7hGEzJlpcis3Qgrj6d5UOJoYDcMglrX2+y0NPtl5UZUjkfx/Hqbecoe0OZzdF1gHQrln9Bhee4s3f3Zxm4MvAk9VSFdUIw0i+Q2PaBtISiBSSFgCYMjMW00MP7pwvvLDmwFgQTzdHxcOSGvBg/b7ZRZByWYAlOERluKM3Ra9CKWc0q73dTBhMFT4ZwIw9l5Lrpes+HjeBiGCUOKXeuBvPcKTiEIOR0f+RhDBMYi0Lhea4GTaa5NbOQAVDzhgPB1La5RssV3rIP1+7yy5OAADoAchEHBkFbKfGRpiweAPtMs5IFNokyOGk/7rAYC9OhBFwNXVY1at5tftCBHaWVS2AJdEcEinrDNC+Lumiyc1B8AB4+muLARAXTDCWvr93lR4/Z0Xt6ODFQkj8WtumEwHTKDLQejAfN3uds/dfjoQdatGLxb8jQBAYz6/boxiFgAVudzNIc2/s3xLk1szAORoB4yn+2DhaATAGJCtbpkCYq9+v4V+aBgAQ4i66XtaC85YkDog/zdZvzUgfN1N7a633Xqv6fe9msDIHfNaB6Ay2JRE1AHAEDIfI5nzZCLeN4Nbm9yaA+CA8XSsul6yqV0rJ2WQfr+splCyCYBR/HJyKX4phs0PKBZ0lqOYTpvniAiUAmAd+HKjo1cvDjHgr+3wPJQsVCymUZrPMuRsRBDG4AQCsunyJtFGHwAAIABJREFUcc0BUJlxQoH62q8ST8cggpKNAFRGwCD9fkuvbwAkyGgJE3C+Nz1P1q9/T3F1EZBxvZh50s6AEYC5yyUHXt5/Q8zI5/KrAmAIkkipkyGPYwXz1aRT8v5ZO6jJrRyAvKOvNXlLazsXs9bo/ztc29Pohgotp5J49Rcj/pzfIwGS//3OM4CNd1dpntQpFUmjEH4LYIgnyn/OLjL8FeDGhwJbNgFjI8DIEDA8BAy1PFK7FSKf43cNKrvHx+8C/vmxwMgmYHgEaA35J0StpvvzL/nP8RbLAfhyT207TChgDRiu/ZL9DsfWNABvYzbhCDBKoBAk/pEobGWTqp819hzQ1/0k0PoaMDEJbJjxVZFgDad0SaUO5LksWVj+XScDmw5UEUDJ6U4d0nVbC91S3ovfVHp5al64cgC+k7mZAP768KCA0WD3A/ieLz090CDceVmlAuhBljLgrfcAw6PAyDAwPFwBkCAbItM4a/FiNtERjBl76W9ffD2AbwJDdwFj+6syImRXrd5Y2FjIYcnzWPLEqnsfC0zsr6qBMQmfIDR/pyJ6xMhKyMrSDiKD2xja6TADTt0/AGAs1KcAUCFrOLF6tbtiRVFavT/wuMCa7MfVTlH098YBeBcwNAIMEYAUlS4uBULOmK3LCnwOPANlEIOSoF9+C4DvVoWXhvdWZVOYqWgi3vOXDUQhgieB0EElViMYJ08HxqeqnG8D4IIDkAzo51DKQQJvBKUmKACzbM4+5hUivwrgiwC4LzvjmgCh6nBcgiMTcv9Abo0D8E6g5eCjfpUA6AxoQIzgi8ALmWwC4z//DxcPPwBak8DQFDB8yJPpPZHeGCyC0KN5DFCByfh9/+OAsekKgEzCTwD047X0SCPM1IYQjCv2E/MJoGVwUUQoPboq0MdqkWVn7RtDDMahB4g+P6qhXFpjVtkDtRGA2nKjos7IyOyHFUbIrXe0FXsTuzIYfNb4O2M3ATGIYQOmPn6hG6gi3eUkQQAeAIYOAUOzALMVh2pAlESqGFBAXAYOMQVjxll03iO/yYKRAT0FQXkwZkjp1pz51LO2XAT3KtD3AIAwj4Wg05kfiuUHYlsXAJLVnP0INLM0OYFx78AzcRySeTsw2AJueI+Dj2Fne4EWKz5MA0MzDkCCkAByUWqsJzarEanzj2zXwjEGFHuGY+pYsMojzZL1G9EBexXou339IRBrC3lJGmNDuSHX+w7WC4Cm6wWxm8DngLTImgC8pBcGBuTXf/1fXnyTugnFwxTQOgi0CECyIFlsvvJfEnh0mhsYI/s5uxFYi1xZof7oOqSAawwYjRGBzYGXbtWXaCIrlvHUagX6SP/ruMVYCEbEqECXAMjfree2HgA0ESur1/0vtnNwGSsG0RsZME20/+/XWH6Mugk/yngPAGy5GDYALjiIHIgRUIrsZjM7Ax+BSx1S4pfffQVIep8dL7dMDsTGjJB+CvQxTHmdtrw4l0CovFruC2NOe975egDQsCXRK/eK634JhBK90q2C7I1i+Gt0jxF40k1cPJAB7UP2m3MGJAAFQrGei9iUTH9yBUDTHfU3B5+BOIKQ43BWtNtPcWIOzEZE8FoK9K0DCGNxLi3FqaKA9gTgeoFwPQAoI0OulWT11oEwiFz7cwbErzNxWtEYBB+VY76Vh4DWrH8IOoGQ7Ocg1CqMRLPltmxvs1/SHaP4dcAJePYyyUCRIzrTB8tE8FoL9DUMwl61kQQ87Rmy2PS2rgB0a1ci18RudEJH57OsY02y/+83/sZdBKr4FXQTApBvprGgQCg9UEAM+h9F6ugJDkC3gJPBEvRGrYoYCBX9IxEcS5K4i6cZAHIw8oXQ4mLBb35YH5d7OekadtTV1UZSjaEIPH4nQzYNwgjAHNwDuWGYpZc7lzPfX1cQur5oBorfzDf+zi0yVTuSkuxBI2Q+PhQDIUEnMLo1TBCZLufGw/ixbQa0KB8CTODjPohdY78IQmfDjmW7Yo/doAX6GqIiAtDHaYswSmeMubV81kp11L6hy2PdAcgblfslOKC1IiKRmyRxZgV/8++DS8BFrxXi5Hd/U6MeSKdqEsEKhpBRsgRMbAtuG4KU/+9ry5brzP/lPVMv1EPOQegharrVcgZUhVHFxNPcp9VFtlOWkL437C0WABWypFRGsV0sb5Hn2zYBwvUGoKl10v1knDgo0y7XA8Pfv0UACnjaK33Co9gJQAOe64FkNvtZAHQdjz9v2Nz2GSa3jYej2W3KGuZ9ixGdIVSoKT13B2s5AHkGheST6qn0erHv5AIgAAU+LVfw/wq3CEAV7clBKDDGZG9/5oVXx/oyYARczcqH5GyH8eFplTawFvAtrtXLGpNrQDGbejupB3omlIHQGc/ErzOcGSRs8zrhAbbuL1Tco/JfbLlNwHOmi2kIcs3owbdwNpYtynDQhsFcgvuG9/YapGFvYX22zZcAU0/GwA2LJ/4AmGF9mwEbBu98Y3cMF+uAGQCj2HVp3BbPuo3IlqxAy5wHAq4OfARmEBXGfNIBa0BIsG0ecwC67merHgRpZLwocrWaovuTxew/V0txJQ2DWeae3WAGbdhb2DB4+wRw7w5g8Qpv88liyGtoWHzMi4C9fAEHbBi8kwUKu2xNAdBxaGBLbJdZux1LwAGECYAEm6wyfpelJrEgFnRDxESwgyUxIUsVMwjVy5AYO0bG89Auu1/5BF38KqjBHlUAYXsteNCGwTeWNuwtk4JMkrlzGNizA1hm69g1Nix+zDOBW0aBeRZZGqBh8M4emfWNADDT+zqMjQyESdQFHfDbZECCLRgdHeCTe8CBaKJY1rDnBRCIAuGW4TYAZeFG8ZuMkGiQ1IEwGCJtHZBmy1obBsvVMnDD3jIAerti3LEBOMjGcOpa3WfD4ic9t6oveDtLfw7QMHjnH6wPAybW6yaG4+8D4HIQfvtDIVtLejpBFsVvUI7NIBHw3DUjRzL3rDVtsYPOkAScuX3coNDynT2VYJCkn+PjqvUD8hVbS8NgjphGxcANe8sAGNoVY/824BCBtIaGxRe8pLKZdpMkTvXiJ2toGHzSNHDPScAyq3er4qPyGaNc7JCRXWLT2TjwGmCOeQashq6+qSpZmp8vojQpheF58ncdZVjLnjWPHr4VWKTKxrHGUqq97qXu3jp0wPy+eEC/DYNZsZAO6IEb9pY9lNCuGPcNV830ZmkM9dmw+OKfbdcXvJMPdY0Ng0/7GnDXKcDMccBS7MwdKz8KCAKQIgY0MWGCtr4TOHAasMwOkTqf6unyuLykfd254nkb7qsw/iVg7jhgmSX31Vpd9yRHeLx+zRhjEGRbB6wDYT8NdymyubzDzCCGfpMJWfSRYfr9HP/aMgBm7YoxNQHMbQHm+ID6aFh8yS93tAvGQb7da2gYfPoXgbtPAqaPA+a3AEubgGU1RM6B060fgkRoCzj+TcD+04CFE4BldZdRc4/YxlxgjJMewSiwN1zWfsOngdljq3EmY08vm5i/7j5yIMqpvupKyGoNg9lngYosl9wY/0dZdrMzYl8Ne8sAWNOu2MA3zw/F2CoNiy99XbvftrcLriz6PhsGn3U9cM9xMODObQYWCMANwPJ49UliuW6SaqqBn/gGYP8pwPyJwNIxwDK76ahDeN6uXYCuYyABkEza4LbpY5WEWdSLxjF26/dQB0SJ6r4ByAN6NQxmkWcqrnQ00x1DEDJFjR8CcNWGvWVPp6ZdMQ6OVOCb3wAscPJ6NCy+7PerkP5Q3tBY1PrT9tEw+JwbgPu2AlNbgVkCcCOwtAFYcgAuiwWlM/XqDjMEbP9t4MB2YO54YJFMo/5gHIcALV1TRZ17FXOhPtvgtvkqf9H4kvHDlyKK4l6VzvVSBF22uwjOb7pbw+CfcwBSkyeFEHAUx/yw9JTyEbo27C17Ol3aFWNuAlgIn9QxO2tYfNlbK6MvaxeMRYquvL9rTcPgJ30TuH8LcHAzMOugX3QALo21WXBZLEHwRF1OgHS2eOgbgIPHA7PHAezNu7QFWFZ7JnXJ5rnqxHEulvlzwyVNN3+wern5Yovl7SXLGwvn4riLWO4fgMRJXcPd/+pmOymELEhRzBxJAo9gVL4kwVnbsLccgHEpWi3epocCAMeBRU5eTcPiy/6qtl0wpvhA+2gYfO7NwOQm4OBGYGaDs+5ExYDGgqP+ccAkINaVpB8GTv4d4OBxwNw2YGFrxYCmV0YxLNYheCXau7EhV3ga3Lb8g4+R45uoGLADgHWqhsBXA8K1AZADyRvuvtkBSArh+i9DsQhCOtf0UUgW/7aiYW/Z0+nRrhizoxXwFhyAi5y4rGHxU66qAFhT3rDSIVdpGHzencDejcDBDcDsBDBP1uX1CMJRwFiQIBzxieL3KIY1YW5MPOxNwLRb8gs0aghAss1GZ1O+SFHsdRPt0i/PLHu++dFb/x4mXfhcbWxhfCtYMFr/uWvKxfDaAcg7ipPCvFOVpuo3HrCjYW/ZA+rRrti6TS6MVQ+L4NPH2nx698GnXF0BsKa8Iab4dFZpGHz+JLBvApieqAA4J8CPOQuOBBAOV0CUYbIskRkAecrvAdNbXc/aDCxSpyT4CEIyTgRgneiLIp3nP6fs+a4A4N8B8/48CUC+ZGJA29fpuLmxJW+5h5kNFg2jiWHSi0r0Uv4pCoZsxw8DUfnhd4Vk0XGdGvaWPaBV2hVjdjgA0BlpkQ/K9bmn/HOVqtClvKEBqlfD4AtmgP3jDsBxB6DA7tdbcvYzJvQJkii2n4NOeMpbgJktbYPGACiF3wFoEx1ZMNe/4jnPLXu+KwD4t/5SO/iMBcXuesHylyACMBPDgzGg7opM8mEHIGdwrfGA1rC37AH10a64Yr4APvvOSdwEPOVbKxu+K2pdKRTmdI3dqkPPVgbSTBGAY8AsATjWniBdx0QxJylOFCcr6HBiw1P/CDgU3EgEIMW52M8YkLolQRddIN1AyKWiBretf9MJQN6HsaCPxe4rvgDdHOcOxDIAcmDFDXvLnk4f7Yqt63gEIB/Yoj+4p9xaAbBHeUPM8qF2aRh84QQwNQYcGgdmx4C50WqCFngNsgSvQ+Dxu4MuiawhwIAXVk1O+e/A7CZgThY1dcno1nHL2oDIyZULpBsAFTBZ9pjT0QQgn2V6ufRicS8QRgbs5ZYpEsENDejBfpoLrwAOjgIzZMBRZ0AHoUC+SOA56xJwNlEyTFw5FxBPeWvlzpnbANCdQ1eSGTRybMuydgMggVBsKmtYoC6Mt8znZxsZMLzAxoAOvsh+ydDqtXx4FIDl8L/omQ7A0QqA82S/ERdTI22mNfaTuBIIxR4BhKe+y61punQC+MytI/Zz/c9EuvyBeetLAfGZ5WOMZ9j2/gqABB1fMLsHAVBqhfTcyH5d9MByEdzs+B50Z7voGZX+NzNSsd8cwUcG5ASRKYbdHRNYwhhDIHRgGmO0gFP+HJh15jOXjnyKblVT5Cbfoq+yJOszF8P8+VnNPlICkMAzds/YLxlYznrJwIpO6egTPMqA5ZNDAB6iCCYAyYBcBqTRQ0e4630SxZyQJQIvMJ8mSeLrYe+p/GzGfnTpEIBy6US/out+K1wg+brs88rHmDOgAVCMnrEfxxMte1Mt6j7u9zzKgIXzczEBOJIB0BnCJoqgIfDEhM58SWzJEPGJe9hfVH42un/Mfxl9bgSiBySIBWnAJBDGEDAB8QWFA8wO3/a+wH4+rg4RLPYLul8tCI8CsJmJMQAOuwFC9qMI9g9Z0CxhZz65K0wfFBPqu7PEyVdWAOTHVlTcpxhXHZLz1w0ZA6EDLhkCskRf0sw4dRYC0PQ/vVSRAYPo7QCdj7GqVOSMeBSAzUzMxZcDMwLgcKX/zbv45SQlHXDIgagJc+bjZBqAWhUoH/Y+B2D0J7rFa6LYDRmzomsAaOeKqxEvbWacHQB08JkRIteSXiSBLYJOLB+X4xrzAzY7vgfd2S4RAKkDDgPzNEAIxMASSWF38WsgkuXLyXTRSRCe/DduSZMBMwe6ObTd8JBj24Aot07uDObPP9XsIzUGFPs5+JJ/M6oT4buxHv9X7BeY8KgOWDg/Z58GTC9Xq5FxTXOw9c3Cm6k5fPcjgbHbgAlvVG2tH1T3Oavoq6BlniZ+12n5u/2sDbOvasqoFg8x2Lnbcd1GdhSAhXN+7qMrAC4sA8sORJ6yHwD28z+Ft4fdv8UyqUDrDmCEBcpZ39kLS6aq9l4D2rLb/KYsFTPWdfbvh86vQu2s1K/K+zIjTsXIVQ9a59Egs4Y6sZfIA/EcSp/jEXv8BWcAhxaA+SVgSQAkGAMICcwVlNLlqTc9Gbv/HAA7MrL4+f1VlXwrUq7SvCoyGcrrWpGhuur2fNGYwM8YT67hT3s1LaZvqn5MLM0bzmHMmIFSgdFNj/mIBct63NhFZwEzDsBFgpDPeanNgATfCtGsX9TIKwNrg9tuVkhlng7TI/YArX1VkXKrEe1l2SynN1RCsFJsqnQv3UIMxhwIRjU5AGN9QUteVz3BUAvahuNgjC3HxLAND7nBp/cgONXF5wCz8xUDGgCjKPbvevlzcKUHH2ag6cnYzepYBB9Zi2FxDJdjoXJv1WDFiLJ6MKqKZUzoQFTfj2HmwTKcTpVWvcxHKm6kKgoORAEvVclPD6NdzLXpMT8IYNPcLV7yJGB2AVhYrAC4SNA5AxKM9ryDPE5fs6eeVKWGZ2M3S3MQfEyJUKV8L1ZpJXpVJ9pLilmlAxWkVJHKwIhjjD9TtVXVm1HdOy/pJiaMFRWM+bo0rWl4yM1N7oPhTJecC8wRgAttBjQWdBBGESwgSiV0Pb9DRgu0TY19N+M1mRKh8niqFx3rRDsLqjgl9yaGXT80vcL1wnE252PAZCzAHQCoiqoW3yYWFIt664fUpKaREr1NPakH6XkuOQ+YDwy4FMSwgU8GSRSz0UJx3Vx/5vFNbrs/EiLRY+v4ACITww6iJEodQKwBIyBRv9vwhKzUW6z66TUGEwhDS3ezqusAyNxnJn8xa1KRPSFts9YfFB/QDZcAm78CnDBT5U8rCqjfc3yh8Gn/hGd/MsKf1+QzYJ4891Jye13iy1cAE9cDJ+6FpYrEkidxDN3OtXR+FwBGMezoMmxJLOumAuD4J4rxJrfdH/XCoLGFVKiUbw+LAPQqWWaMMLrd6/+JycSIm85w9lOpt1j1MwAwFTiqAWEUxeYH5ENn/jInUVHeMXQ/f/jRePvCa4DhTwLHfBc4frGqqaNJzLPw6iZxV+HTplFGvZrXZT45N39+HW3TujlZv8D6fp8HRq8Dts9XIOR5YtakgBgdrrrt5Qsq8Ssd0BhQ4HMwmVitAWHAY/LbLDQNQDaTVJ8Q6W4qVB51OOqDZDPVB3TLOBepW5jmqaLbec3jGgBGMSxvvemDYkQ9GoKF1ShUCSKCqBeQrvmfVZPC1keBjXcCmw911tTJ8q5XgOLaQgA+x/OdWA2EGZ98gbjleTHdQHQN+2iwls3nK3/Zhj3VeQhovYzdxmArSwQgDRA3QiSCJUrTnjfl4KozRCSCCeYmt90EoJJbVCk/1+FiCwFZxLk4dRfLFia6x8LbYkD9v9cXtLG6+O4AYQRfrgPygVIcqyhTXcWFOJH8fh3rz7EKwnUArq8mcGwK2MCC1i7WY7Zenh56feHT/jE3yliE4TZncd636gPFCKWavGhcRx2J+cvs9MlSw0Ty3cCm+c7n0G0MExdW4BMIbTXE9UCynvyCCX+Ovm4gbByA/xisVgJPpXrzLj4EoRJjJIZrWHArS9iprK+KcefgiyB0XVKGjOmCmW9xhRVMUSyRFnNeFGEdI2q+/HFXclkp9WsAbgTG9wGj08CI64WxRk/OTDcUAvBHXSLQxcVCDMQSWbzv+1e7WVbz+k5w2tJtsbcCYV6WJY7hmAsDA7r1Sz3OgOgoM+KTOJbcjSI5yGIaNE1uuwlAAU/MF+tF5/0sIghVLdVdM2S0bSzHx2Mi+FTxXf8X925NC4BycK8QwfmgVX1LlcFiykEMcL2BndJJ7aQfijKfxLGDwAhByM7aC5U4qwPzNwufNnNuOH4VZaCPlPo2AahqFqoPVFc14ga2m+WEEL0cAz9kdPrOmMu8r1o/rTsXz7f9oswFs+jO6LAqkvC3Ggg5Fg6mwW03CUI6X12h8lyfcz3QHqr3DIl64DbqaQKc9mI87QXACD6vpJqY0EVxz2CEyCI5eMSGX2e7VtI5J4yTRyZhscrvt1nQuivOAaNLlYESwcySgiVbr37Bfd0/u31yEgg2FVaiPCeVOguqAfGov0iR0R9JABJ0bnwk9nMxw+fOh55EbgRhzozrBUA1polN9CLwok5HEEUQBjFMQB7D+j656PW+IrJ8O/bBCo4sGFdGejqiyYCx3mKe9/JtTiBvmI5OFiTisg9LtJFF7gZGDrUbHKs79+hyu5hSaUvh1foFr3r/6vZJCiXgCDwVVFJ7MVmRLsrGltuFCc68yFdACMDAflwR4QM3HPoKgIExt4gz42SuaQb8hBOE2oZmlu+KFlKR3QSssMJxDPWbbjpfLoJrxG8CYT8MKGZSVTCxYFTIb84nkCxCIPLDiby30gXFghaF4c2ReR466Uu2fvoFr3r/fKAEFxvpqMcd9yonIrkuK5LLV7MVCM+/uDJCyIC2J8a0z1iwqyESgMl15Sa33QKgmtPEBnp11mwuXgO70Ud4DHWzfgDYC3zBEOk7HlA6XKyHQzb8HgGoCSQLqsxorIy1Bxie7Wx0rFaf+wr9Xv32C+56/7HbJ5VHtRYT+GJrsehHcya57PyKAQk6+vBkBZPpjPEExlwU59awg3C24W6KBsC6tqHR+MidyVG3i3rdAnAsH2T093XT+zLr197MTA80h3SfsZP2UqpCrPQ46oF317VrpeiKXTJ9MhMLkgGdCacKG/mupV9w1/vnwyGgCDCKWzJe3lqsyzLWZWe6/kc/oKzgKH4jC7oolhdC4jiuzM0WPo+cPQ2AsX1obFCTO5Jzn566PwbReiwnfTWjI4KvDoh1juh+aT+WKSYD3i8Aql2rJk+VsVQly5kkddv2FvHT61icqO7Fr71/IkLNXOi0FQjV0046oBy6wZ922Q95ICqDEaL4XWw3COcf9Mw73DFB9AqE6wZAAS8XuzGQIDKf+oVkqxt00ttAc+YT0PJ9qRFSB8xoye5Xu1ZVeCSgCLbYLVNswoncHxoeLwCzBGjBNki/4BX3z9lXgUCyIIGmhova83cRgO5Te9yLgP3MfmsBS8xs8/U67ePQOqy9umBUruDchqo8sHSd3PMfT5ifo+ack8eFHI6QEcnT5GvdOnVdXof+ptJ+BVPWceiaRHA8Us/nkACo8mzqlqmWrbFDppT5A5UIZm7CPA2Vgm3QfsEd909kKIqB1qJAKCBG8ZstZz3xHOAAiwmpDIdng1maZQAkZzsHZ537YfQrwNyxoQ+HakrnS0h1mUA1C96TdJTmORyhC3oeqdwROi+GDhkFI6bYNrcNDEDeAkXwQizPRpmnIs3OdqZPSaRFUcbchHlgie6agq2kX7Dd/+d8lUJVXuUzk8ERmS+2vfd4uvN2VOV5rSwb0y3JhgIh9wJeN3YMQCIgR78Q+nDEVYBYZUrUpbXFnM7COSdf7N4IPvtDnT2BY/h8Chh10MXQeYGS+7GGjaQiABpuNIFiECnzdWJMIUHcazLptC7YivsF8/7FgLFMqpiQL5TuNbKfA/DC46rqqAbAwIKWK+timRUBEiNGsOQsyQm+Gpjd4n046hbT84KPuYjOmHHyp92gcgDS2OoIuVIeh/xyUkaVwyEWdLrewHE3uBUDcKIwnq40HpDXL+n3CzbaKdguel5VnFJl2awaghLQBTzteZ0cjLq2A2n0M6EPh2pC57Wg41poLzZsAZNso0Hw6eVR/J8bF9YjWGmVCpGKwQLBRCcrbiSxNLgVAxCF8XSl8YDHHFPW7xeFBRwv/rGqOKUBkODzqgdWPYAM53vTASMQu4Bx9J+69OHIF+N71F1O1gUB+AsBfFqKC+4Wi4BWX+CYgOTAU36wdMVNVKka3MoBWBhPxyiuko3xkSX9fvGMkqsDlzzHC1N6SQ4DoINOe7KelWWTheziObeKCdARApD1AdVnRH048gKUAmAEYi6Oh4DJV4VoGDWqjq4XLbO5o1jBoimEPhPJmwu9FvnTLgdgYTwd2wyXbMyRKen3i2eXXB245FlVYUpVxUpGiLtmGBlrTEhVUwV8dEkVKAq3MHJ1uzRbRx+OOgDWFX6MsXJU/36lJoEoA2AKvw8+uwTEDIBbStdOs8ddDsDCeDom7ZdszBIs6fcL9ror2C75US9IxJJsEsHdGFBil4yYuUwknofJgF4XcEUfjrz+X7fKo4EJJ//PkMORO6FrVjQMeL5kJhZMMXzLwNZCt1nzDFgYT8cQwpLt4hDON0i/X7ys5OrAJVe0S/ISgFY7j9ZvnQ7I3+lyqpYaL98CWp/N+nDkZdhi6bW8An1kP3fRTLKVWlwF6RZCH2L4zDDR0k1IqeTNb2OQSYNbOQMWxtMxeqtkY6I+ny9VEz6btfb7xc+XXB249AoXv85+tIBVgJJ6n4lf6oV+mfjdDJNMH0wAVFX90GMk1f5TxlS3Fggh92DyN0IORy5665KIfCktsl+K3VsGtpVOWOMiuDCerlSnjQ2rB+n3C+pIBdulz8wqonrNPLKgwKaC5B3s53qhXVq6oDNg6sOhqvqhEr3V2VNLBjmnSSNdrOLJ1zkAu6VPRjFcFz4fXDJ8i45hG94Gt3IGjOFYA8TTlQZ/qGH1oP1+8ZtlT1MAtHK8mQg25zOZUSCLIliWcbw8wfW5Ln04ssqnHX04euiCk6/3de66MPpuAQVZAEFkw2MKFw6a1wEL4+lSBvmAOMhD8vkOkFX77feLNw14YT/ssmc4A6oOdHBEkwXlgjH2k4Nal6wB4fIuX9LzZjAmorNeHMo5Tc0OewHwDTUh9HXxfGJsYkAbAAAgAElEQVS/uvCpoAcew6zBBrdyBlQwwoDxdLZWXLDFkHyF8xGE/fb7xR8XXByAAVC1oB18HQYIT+8uGfP75SCUs1o64he8v4j6cIQ+IqkPhxrBCHjdjBH6AblQkAeY1ondukSiELmsUPpjbyp7XuvDgAXxdNZVvWCLIfmKg6Bbhrjup98v3lVwcQLw8gqA5v9zC9jErutltg8gMxDWWMBaMVkmANWFyEV6R0uH2I1IzW7ypbkQOTP5f2ch9KsFkwp0kQlDAOmxzHpscGuGAQvi6VD4RgmAg/b7xZVlT5MATNXwqQc6KGwf2U2uGV2uzg3D4ua7fDnPwZcKgIdq9GaIBPZb0YdD7hgyIFWMXiH0eQ5vXS5HcMkc++9lz2t9GLAgns7KxxZsCkgdtN8vWD+vYDMAUpcja7lOR9eLVcIP4tcuob/3AOHCdW02VTX62ApB4Mv1v24gnPy9HiH03fJ366KYHYTHsgBBg1s5AxbG0+HLZaOp65i+ln6/YM5EwdYBwGj1cmUkE7+8THLNdAHhwrUOXtcrO/pwhF4cct2oN68BMDCfmsJM/n6PEPoYPp8bH3kCkbtjji2tJJA962YAWBBPZ0WBCrbYsFoOf9pDAiENk179fkuvf9nTXewKcBSjsn7ldonWbgQpx+26otaLIwAlfi2QQSJY3Yjy5i9dmsFM/oEDMM/Z7Uf0RiYUA7J+ToNbOQC3e0WBBm9qLad6HICG1ZK1XB5PoxnuOOIcxSXe/Of8xHV/P+FpwN47gKUpYHmuSve0pKZgCKSq5wqniWE1WZz/xouBm74KTMwBI17lVBXwtWSs+8/vL45Ff3vhpcAnvwos8d48DZX3M2hx9XIAnu0IIO0chu35AOgLL0yuG/jOmwbg028G/mNz1YWdETbm4I5BrFlov+EtD2wIo7l+Atg8D2xY7iw3V5diEqO54mnj6XdMAYcU+6gon7A3NSO2qFjlyZYDkAX6uD5Iam44YaUfVNDNxaJcLIPXcGGpfi6PnZdVD1wPspQBX/wl4OaNwN6Jqg+xwrxslcVFuYJblehkcYYZGPS3L20BxueBcS8nwg5H5kZkx6TQSbXFZcCQKadx5Cz5mPurAFxrRaa17pAR2PFC+ElSHKQ/0QjQcgCyGyM9v3SnsDBRJgL6msWCf6IfWeUJac8UFlpY8500DcCfvgb43hiwZwyYVhd2D/VSrKGAmIDnBkiafEcN9cprHgKMzgNjS1V7rRjRlceyrqif6KAkMgXIM+6tAnDl+zSL36O9+U8p9jGHQo285/2XA/AnXeNnKAorDXH/AILwbSvLEz6Ql2+cAf/3XcCdw8DkKHBwpOpFbE2wadzIdyh3jjNQirYWEwYq+/zJwMh8pf+xKNSwM6DZMmzNRRbM2K+2Ii6TlFrAWfd5V3i/F7IgT2LBF5LbIdkqxLPWvtzlAGQ3RpU3Y7AiixMxLOUB2t7pKQ8M0qCTnp8HkojJgNqaMEJesQv4AR3Iw8DB4QqAs+6SWRiqgJgY0HVDAdBA4Ba4xN7ndlSFAAjAYX4IPO5dBDMAdS2i+Jx7XTf1eEdTDfgAQnR34p/wQkRmjNAoByDT/ugFphXAmjAEn8qaPQAgZCs0lSckCNmVigEbFMsPBBE3DcBX7gLuawH7hoAD7EM8DMw48AhATrjtQwiXoqkTEwWd7LOneXNCbz6Tiq/TInb2M8ZzIFrTQbGiy92oGz7pXl/7jvdAJnb2470IbB3T77Sai+hyAP5voTqW6sKwFAc/TAdc5+3dvcsTrvPVYSK4SQb8xV3+6IaAqSHg0FDVh3iOIFTIFxtit9orL5Z/LD1Q4s+B8OnHVuXwhhdd5DoLGsgCCJ04q66X/Ju/vSaeAxDPvbdtmdtKDV90gVEPIl/xySkviOhmAEjrlzSkwj40SlQZYZ39I+8JBMx8mZryhOsKwqYB+KpdVSDFvhYwPVR9BD7uyX4SwRS59nNI+bRck/DzJ05v12M0nY8fAk8iWL5BB5qASPGRCi8EVjzv3mqpkC9ACrrwhKukB67GhpqRRowQMqCiYbj8oOoHeUWpdYIBAUj8c8WjrjyhNIJ1unzjDPjqXdUjJAAP8TMEzLYq9uOHICQALe/EwWe+QgddAqCzzD8+vgIgg0qp+5nYjaDzCgjmnCYone0klqP4JSgvvK+6LoFPoFMlkPGh+0rPWta4RHTNJJQz4M8EAGoNTPVU8opS64CC9zoAWTFChcq7lCdch6s3L4J/2QFIEBKA1P9mHIBmhPh3Ai354RyAAmWsR/PRs6vOR8Z8FMPS97yxtIlYgVB/I7jC0rIKSfLXF1EEB+BFFjQ3jCLA49OWsRTTEPzvzQEwry7VrZ5KwzAQAPssT9jw1dcHgCrORQCS/bgn+1HsCYQSveaHkzvGv1scgU/6R55Y1YIxhvOm1EZekQWl8wVDxJgwc88QiJc6AKX/meHDawX9z16M/Em7bO8Q08GBP/jEkAEVjMBoAFWXUjRA3KtNwOBXW3EkAZhrALktpC6lKtTV4OU7RHB+3kHWgv/zrnYZl2kCkF4uF8MGQGc+MqEYUCA0n1tkwxbw4ScHAHr71Q7W4++c8czwcBAmHVB/c7Bcek9b3FuwbdD/kjGWgzJjQ3thGmVA3jhfOyU+RxB6FamOFp8NrhsTgLy8Cpzm5QlVptAU+6CiNgXCaIQ0BcDYV8b0P4pi30vfIxD5+w72C9aliegW8MHzqrmh/meuFhYi0pKbs6D9fsh/n1XFMrYMbPgUByCZz6J+uEknDA9AornWFRb01WZEsACoHhOqyC7wdetT0QAK2KqOb5MCUvPyhLE0oQxzqaYNXL5xBvyVXe12vByLADjXAvgxBvSPGFGMIjCmJbEW8HfntxtQmxT0cmxp9UPAdKAZ1upA6EB7qgDo6oCUxXRtPVSpAwJpnUhuxAqWCCYK1MBExZljY5S8SYr+pxAFAuBayhNG26jw8usCQLX0SAAkwwcAEngyQizaXoziIli+Oe7/9kJvNk1LmBMe9ECO3XRB7aPeF0EYHNVPdT8gj016YBcWtBfBVYJuz7mF7VgGY/pO8f5WdQ1/7U67nIKNS7j0wIbDPFZsyNHHY7od/xdlEHj8CcC3TgCWHgGAPSxiSdt4312u/8SPAl8/Dlh4pDeZW2PD4J1c9+uyDaIDkgEJQKnTfG/N8nUAmu5HUnMW5ARbPfEuIHy/ACjRK7FL5pOR4RaxgTHofKl8r/S1ZWBnAGDKefbn3AFIPRPXB7sFiVQimKVgGdl5ooNwLQ1/1U+DQGSXQ9r5Evy1q9rZbP1lGQDZsPpzI8APHgXgod7qUx11YtBbFzC+/C+BL7SAWwhgdoLkONSLqy5oLogYft3ZI1F7EAC+phsAnekokhP4HIzml/PvthQWmPB9LJ7jxkcSr14jWj4/0wFlgJD5eoDw6fe4DzAYPHokWhHJZ3TFSkn4h7YOSOBwEtiMTv1aY0uktFYTmI2/43EMQmCuAJmUE0gmVD8EFdPpdnxhVhqzDr8F4NMtYM9Jfg98EVTeNu9Q2OFZBX7vr9vtgm/lcezczZ61ZNN8DCvilYCdPXqNDQpAlfGTKm0M6AA0PTAyoMSx64cRfPQHXsniOTI+fEWDFGp+Qb9BeySRBV2kpl0QxxGAlHDmkI56X6z+EP7UDYSdRgh/IouwIZ36lHabBE0GJ0r10Rgb/xA/tt/j/6aMAf+7R4CxzuBXWRGULwBfIrY6UNfpvLae7n0I+LO/reoLMqiVMbW38oUhkNkQIzZO7tIweGePcmWlAFTjAYHPVGwXxWoLYblEDkLuTT8MDPhXLJ4jALpaJB+ggU6xfgJknT7IKXIQXh4Y0FZCog+wxiUTwSkXUbSMV1rB/A31OXWuFpPUda/mRHKi1e6U+hA7Zq7l+A+UAfDtHg/LrptkQpZ727cRWOL9542Pa3rOvuOqagUltgtmJM08j4/PILbIDKz6w5PAHsbraTnMGdZWIwIzxIfeK0rn578J3LAVuH8CODRahV/FFQ/1IumIvXP1QudNfyNT8oVqcHviPcBd48A0g2RDuoDqHdb2SalZAdG9dnfDkAE0gXnH5ijWCDbKCq5/MRiV0QD8HgHQ63jG0hdsLGxA3x9Bw1Asli7hO3BwApgng/Gjvq01IHrXJ7q3Cz7E++YziF2rs1ZLZ+8H9jJsSoECWXj6igmR87aLgfbGq4GvbgLu2gjsHwdmCEIPSI1h+SkCRjpfUC3iNWcpoRrcnrYbuGsUOMBo7QBCxSTG/igxVcBIVGPWM1h1JYQPnyKNExGZMDIJ9b66eEBGxPDY1Y5nv+GCjfGAxD+DDpiawphABWZPjwNzNLAEIH4XCH0M7/5c93bBfI8Yk2cgVAdvdT10ifDkBWC/r9lGH51NhIsnsWHOfPmEUKT94WeAG8eAO8aAfWPAwVEHISNQlKQUglJjJExqC+H6Nq93kOpUg9szbwLuHa66QzFWkaFieXxi6hgVHOMCYGRuJ+5V4jYJIDKI9KlsAvFDq8QDrnb8NWVPh9EwdFkQ79TlSMIsN0Mi5s9MoOGno4U6f3YAvefL7Y7rvdoFLxOANSA8f7xSgWmd0kCQbmZ6mTLEnJ0UqWLhUkxlrBn6n3wWuGkYuGukCsufGq2iojnRFpafsU7MDxErJuZhYCsJosHtWTcBe1oeq+hxigJgXBrMmTBPnJKLrr+VED54ibHYvZos8sO+DNcrHrDX8YVVyglAKud0LtMjFPtNMz6QLDY7VomLJd671AEH4Xu+3g7nWq28ISvX58/hguOBg8vtFQvV/hEzxfqOevuTfpjri8vAWz8L3NYCfjBc6ZYHmBcitnFd06pxyb8W4gPlgonBqffTtdTg9pybqiVNBssyUsdUD7eGO9amnf3sXtxQipl7Wg/sD4A8AwHIyZMYky50Tp/xgN2OL8y051qw2hXzwRCEdT2nmck1RxHG+w5jeO9NFQBpR6ldMIMXlFWgVndqF2dVFsJzuOgRwMElB6DcI6rznemD0RnbwQiSRS3g7Z+tVIl7PC9kahiYZm6IizuLigliT/VoUog+p8P9l3wJ7qGEanB77k3VczroUToWLCsABud4ypaLCUoxf9i/9w9ADiICULrQRWuIB6w7nuZrwaZwLBGwClSqSyz3AhHbaRGEFGOmC44D72UVgjW2C2Z4lIF4ArjodODQcqUGqAxfcpG4mJVuVqcL5tbs2z/veV0tYK/nhTAqesYNHdO5PCJZos+WuzxHJIViuXFyJxupNLg976ZK2lizUKodilGUgzyGhokF8yw5Mf+qRkjdjfuDtwkkm7DTkNaBaQ2ox1q3eMD8+B6O3H6em8Kx1Ccx9ptWl9iYIUAAWrI3I3nHgPdOtsO5eOuxXXBdj0V1vOL/so3Cxef60tlSpYwveKf0pAu6ohfdJ8k4CUqgvr5jV6VGTBKALeCAh+VbZLTnh5gu6D44A6H8cVlkNK95O1WkBrfn31R5HSy+JCwPplAxRegE/2T+AloGncNmbQyogUQx/KwB4gHj8YWNTwRAOW0FIIIndoqNkTAxz/bd09XDGLBdMM6/pLKi5whAX60gCK2ujxzEAqGL2pQ1Jis5AJEAFHvTujYAKjRf+SEugm1d2COQLU/DAwQ44caEw8AtZzSIPgAvuKkdrWMM6M7xCMBoiBn4YpCE2NCfxWAA5MEuwvCCEICwlnhAHV+YORfDsWJGgPpMKwg1b9QpFnzHbD2BK2JGul9s8KkYW17vLALQRTCBpzXZpS4gtCXXMAkduuAy8E7PijPWprXJ5CR38ygw1fJDohh2BlRAgq2OeN7uTWc1D0AFNtmL54ESBsCaJcLkDajxj5ZXRiCIGA0waDwgjy8sk5+HY+X9ppUbJSCp6TnFCMXwny1WAFQ8rUAc2wUrRL6mXTAefWnFfnz3FpbagQKLAqAzoZjAKkkpXkNO5GCEvOMLFXOnnC4xIKOjnQGNdWSM+GqHQGd7JSsxUf+JzQLwhTdV4je1nQvr1MkPGtlf9yP2Dy+gAqZ6rQytfvdHSDxgLwBF8AmAYjHWluEDiKGMiqOVvtejXTBOuRSYJwDJAARgZAGWL9Nk+IM3SzgTydE4eec1nZHbtDaNAf1Dpd/SMx2END6kD0oXtFhBXmcY+OY6AFChnKnzl7NfdMR3qCAae2B+VVMYXASvDs3/X/zHJZcB84vuiqABEo0QPnhnwqQLyRURmZBPytnwHde0M1vN2lR6picoKULaxHDIEdHkW2iWg4/7b5zb7DSQAVd0/griV2JYojfpwRGEYsGBrOBmx/OgP5sAKANkcbFzNWTRnX/GSGImMYH/LYlk+gGvdT+bW+SWH+Ig1GqL5QeTtR2EYj5LVHfjw/ZDwL8yJ6TB7UU3VVoTjTYxYDK+Ivv7dzNAZIxpZSiU8jjKgIWTcykZkBawDBBnQdMr5QeTKI5iWCB09AmEb7+ucnOQ/aTPWn6wuzyS4u+R0Ob6CUGqJpIDA97AdqINbgRgBJ69CG4Jp6q/ckjXqB/RKla4WpkO2ODgHoynigA0JiLwaNiEt95YQKJ4FRC+7brKzRH9jZbN6iJYuSHm9I5iOAOhHNJfZkh+gxsBKPbLu3+JgaWDdojhMO5kkDWSlNTg4B6MpyIAjf3IggJgMD4MCARjFMU9QCgAykhSKnUCYHB9JB0wy5aTRUxmup4h+Q1uAmDs+hpXgFLnB6ULONOn5xACNJqxghsc3IPxVBGAiQG9aLeilWUJW1FvVXEN0TKp1C6At19TMSCBpz1dHtT/JH7N9yaxp6QkF73KBxYIr10nAMproB44qQGTj6sjUrtOFPtLeFQHLES9AdDFrq1E6M13MaxVCTNAXNFThIylLcor40zxtgDAPKuVwDMrOKw+SBTbtR2MND7sZwC7Qvm4wqHa4T/uIrhb+7n0EgbQdTijoyg+agWXT8llDsAFWr/B8qP1K7bT0pvtVwHhW6+t2C/m8svvZlawi2CKe37nhFtapkDnILRqBQA+v04AjMyn79EIkXO/DnzyCBwVweX4wxs9B4rRZgyPVFqykgDd+5JSpBU5r0vHyHz+jsc3ub0KABsZMCyQgeExKyFPVIz3lmcM6OfPAGCADYPE67Jfs6h7G0o+xvi7oyK4cLZfOgpsXwC2Lq9MwuuVERonKn4nSJrcXnQKcM7dwMMXgYcsVxkSebJgzOWPqdB1ad2f3gpsnwK2LXWeR9m3danUIV1lBSCPArBwtp+7DThuBti6UDWDmWA/DvXk8LRptfPtNUlihYZTOPCi04GH3wFsnwGOW6iAs5n3GeJJ+KLoE+9VDClQ8R6vOQHYegDYwuY3S6H/iJ8jb11ck0q9Qhoc9QMWgPBZJwFbpoFN88DGRWBiqQIgWyJY3lPozaGJ1KTEPh36zpTkJrcXPRE44S7g+Cng2DlgyyKwaclfFoIwvCwx9Zn3Q1DmIPx/2/sSaMuusszvjfXq1ZRUElJkKsBEGQyYhJCBSkUqAW1tsBdpuxEVaBzowXZqe1g90G2LotjQdmMjKqtBxQERdAWUAkUlZNBGkQRNyIAEMAkxpFKpqjfUG3t9//m/c/+737njPq9uVeqcte66b7jnnn32/s6///3v//++Tz0dmD0KzC4DM6vAFpd/0L3Gh6yTDgnvLwKzAWDGiH/ThcC2OWDrErB1pRgQisIQhAa+AED+HEEY6uNLyrRnZLSl6tSbrgLOeBQ44yiw8ziwfaV4UGbdegmA5QMTLFlqsfn7XecDW+eAmePAltXiXnkuZSBkRcm4UGXtU2uo3xsAZgz6y54JzMwDWzkgBOAqMMVBCSAUObh8QuN/CiTgcWAuyWhL1amvvBbY+VgxbW477paa7gIBqCnUrbUBiQuhAKDUot13IbBlDtiyBEyvtO5VDxvvVfxW/JkWNFrCeK8NAGsY7BsvKQC4hQCkJNaKy2LRIsg6SJ3IQSe1onKKC2CsOYMeN+0Dtj0ObDsGbFsEZmWp5S74g2Ir2uA22BScAJGA+dJFwPQ8ML0ETAUAkgDTPq9zdK/+sMWpPF19NxYwA4g3PtsHxAE4SQC6FdSgmGWRRIJLZJll8EGKjHiX1jwaN10HzD4BbD0GzC4WrsKMW2pNobZoCu6CLCDfCTqzgg6sr+wFphaAKQfgZHKvpRSYg7HN5XCL2AbAZwPrZGaj6ippXhgn0kqmU1woxnHedg5AATuWHig2FE1uVRwoxoX+Wcbg89S3AqCKPONcCi8oPtVP+9++G3j+oSK2xRBFDElUxbTS+3nvc4FpDsjxllXQoJg8FgdCQoGJJTTicLcQ6vPL6wbg9cDM4cJv27oAzFA5ky9/UOSvmg8oP86n0dICBn25JwjARWDSAUgBHN6vfdbv10AbARh8X91vDM2ss+NvAECKPVLCsHoyUgRqrlbnRwB933OBc+4DXrIC0IEmiLnE75di8HsyAcjzWUVGUi6uICMpVwwJVMXdeOk3XAxc+Hng+vV2esAYw+sWoP31r3eLcLwQBeQUrEHh4Jo2h4vDmJPuAyMLGAeEn7uqbgB+I7DlSWBGCwe31Gb9aL20kGDb/EGRxY6WTz8f2wtM8l4pgL1SgM8esHCvsuylME4nn9cfQLtldg6TZ0kUKorAfij23vAPCmqp3fcCl60XFINid1PlZrf41/dnApB6wSQjutUfIDJR8CGIQOwWEH7DywpKrWc8CFzqRLHkVYrB2jS2FQH5vkuBycXCAlIUUAAkCM2iRBA6+ARCe7DjYmQduLYTleiQ/XTTS4DpI+6nLhZW2nzVCEBaMLd+soIGqjD1ampdugiYWCpeBKA9bBJC9ActAk8LES26SqsftInLZ44dQif4Igdhym5WLrPDyuYH/7HTCNwDnPko8LXrBccjQaioe6BiKad3+QY/MGTH6rS3OBvCnQDuAIyqhiDkQ9RX+29yE3on8IwjxQPI8zkTiApGU3oVkD/4fGDieAuAdMw5MFQjEgg1DYsUku+a3uI0TGBfV7PotwHwaOEmbHEATvuDIutni6UAQoFRIFRYhfe/dhEw7tbe9Of0Si1g8HkrwRcevDajz07gIJ7n05rYyWIpb4ya/7vv8PRdFpj/LXDmkQLAnA4jCCOlTBRN/rFMAJKgkkVHpGUjySSBSFeg7/azqk8EgbSEq8UDRACLKDXSyaQ7Br//DcA4LSCtwnKhTEkQcmAIQhtM+Uaajl0uS9NatITXWzpzfcdNB4DpY+6nBgDaCtanYLN6fCj4u1ay0QIqtML/EYC61wSA9tAJeP6eWsAoDysFpg1eB0HIQRCIIkVeCqQf/05P3WCB+UPA+CPAzvmCaFWDKEuYcl1yMN+Y2dckqGTeHPEvvWDSNhOAfbefX0A6rS8CUw8X9066bFIfdqMHJID++DJgLACQumyc3gyAEYRRKFCLD1eu5ODLF6QvXedx0w3A1BwwxdAJLTXjd8seQnGrZ9bPFxLyA7WIKON63tYtCQBN/sv9QPm6BkLp0vl9t/m6ietR6fbyBA4gnXtORwRRpNnTtPpW6gWLH83lKqcOFTEnDiKtoHwy8RNFhrefyeztbnrBfbWfgttsP+kIyO32ELD1cHHvInrlvWs6TsnB7qAUlg/suFtAWkE55zYQ0QpqcALoNCXTEt7A3KoaDwGQfqoAOEUBa7fUbKctltwCajVbxvSiyvoasM0BaBKwwdKb9fN7NfcqBWGiSWykWXER0umeacUEonQgCKRfIgDFjya5yq8Wfsfs8dYgiuMxgpAg/vnMzu6mF0z6Zj5APdvPQec0TEosnvQosGOhaLuIYvnwEYSithE52F1XFAA0p5yigD4otCqygFKnpHUpLYP0OcKURYv6Mj4MNR433QhM0gL6QongawOg+6rl9CswKoSkEIxPyTsuAPigCYBmAXVfYcVf+n0SRYw6dP1YwNgHsgSajiJP429RrpWOM6cxDiJB6NINM4w7LbUGMQUwB/M9mZ3dSy+YVG0EoBiDBST5ddZ+PkCsAiIlQZDa3LVatJ0WXG2PbL98AB+4omB3oP/HgTUhmGgBfRqWf2TTrUSjExDSP/qWzQDgfAFAWyzR8rkFtDAKX75jo6nUguZxZ8NByHbvvqBQ36T1swcsBaBAGGRg40Ir+rt9WUDhQ5ZAU7Es2e9LLzglqHRxNkbeuW+oQRRls5jaMjnK0a9ecNf2R4LAwO829kQB3LTtEYQPUwzQAWgW0AGo8AQH0ljp/V17pm0KRcEifGuNOnocO1rACQbKPXhs8TtNwVr5uh+n6Zf3wDgu29g2FdMtOc8B6PdpFj08ZFrplw+ZA5FTvAQQ0/BT36FPDkRqBT9Jag7xYlQItY0f88j78sZzCcKPZlrAQfSCK9uvB4h577SCotUiEJ8opq8IQFl/PUBPEoBLxbRE62LSqG4dFB8r5bHcOtiOQSqT5T7RKzYDgJx+BUCCTxZQCwhaQc9oKcEnEBKknj5FsJ1LAPo9xoWWPWDy+6IIoqbeaO0VA+zHB0zxIQDKkn1GgtXiRxMIAx0Vn0Db+lkuFjLRCt5WEwD71Qvu2H5OfekD5FaciQay/GIbFgBXriwAyGmJADR1ck3DwTE3TQ4B0LetzBJErTYAr2BBSI3HTS8tLKBZPo/fWQDZp197Z3scjGb5BDp/L3+njMweB6B83Gj9wj3atOsPWin9WgXCFlVO/3ctf4iD8XkBkH5USlAZlNPZAQqARr5vxu1yjmH0givbX0UQKI63o0Wun/xHuR8E4VnPK5JQLd4VNttTBvK2uoiKOUf/f+GjwMNBh0NMV6J0c0NpcRv7mrYv3kh8/uHxYp+bVpwLp3R7sts2YzouSq3KGa+q7+x7Co4nazAerRKsVlV1QitF59dyyFZaYY0HMu9mWL3gtvZXMbymBIFMZ1ov2h0B+LTLisxgW+Eq5uU92iZ72ud9vvR+4JFp4NjkRh2ONi0OB1/UBCkvEYRhfuNs4OmhhiPKnFQlx6aAjMnSXJUAACAASURBVPjmz1w41nnwO4cCIBvBwZgTAOUHRq3gyDExD4zRGVYEnpm5LqmQc0M5esFt7acFl0SlHiBxuTkYxxdaihUC4QVXFu5FCUD5QtJl85sjGA0ziQxqeu/fem+hw0F2fLLQGxFlYMRvo7v1WmIVtpt1DFkXvOR7LwJ2HSkyoZmEypoVVe8p7b6qEMnidGG/Vl/L2aPOIwuA1pAIQE3DAmFa4j9f7CPaFpCHKujr5xzZesGdHqAqKz5X+FLRAl58le+jui+kTBALMcgZ73CDBkpN2/7+bfcWOhwUyCEAjQTcAVhKdjkPc2RajewKyu/n1//qJcA2uhBMRGXQOcn9U6JIOjXHQqSYOsVoQp1HNgAvz8yny80H5PVz9H6RqVd849WtXQ/zA0Ow2ayGLJ474L0G79vvbulwkJi8BGCg4S01SKqofoNvSIC+5zkhFUupV8rUTpJN06KpaBkFQm5M1HlkA3AyM5/u9Zl38zrk6f0iU6/4hmscgK5ISUtCTowyDqb7UxwsqFJW3fo/vbuIBJEZ1YRgyHwQKNi0KEl1OKTCZJdxtPDn//v8ooaDaVgqFyiTD2IKfcjZS4Fo+7g+HXOPv84jG4DIzKfLzQf8KVfI/FNKrQ6h94tfz+vOA9cGAAbrpylY2SDlVTTt+uCnV3/V3a7DQQAysJAwobZJgUXi78Qayhd812WeiOAZzEyUiAkHMeu5BF5FwZQAWLPwknkLQy9CrPMy8+lIHZFzvN3T+YbV+8X7c64OHHix74V6zIxB+RJ0wQ+UU992tYoFy3fcXcTDxQkoPsCUhFIczKVCegSg5B8A/PILN9ZwxBSxtiKiUAOi7JW0dLTustF8AGbm0/1o3vjjnSGdj+lYlGwdRO8XN+c1wABIoHk6k61yuSCJITq3jDY9Vx0BqK++uwAfX6JkI/hME0SC1EGguiQ+isqcQRLrF6/0jO2w+6FMnZhyZYsQ1W50qOHgPX1NXndtODsfgMwHzMin+0+ZN0S9YOllMzWfLwKQSS396P3iY3kNOLDPM1y065H4gOW3p4uTDkB8zWdb7FgbdDhEgJkCUDRvogTmd/vPv3BVAUBuvylNzAAYi4hisVQnEHoIqWblrxqm4Mx8ujfljT+YjsWBYgIOc0oJPsq1slCpH71fKybJOEoAuuVTRSCnYlmU6P/Z4iSJEcbLv+Yu9/1EAh7JKEXDKxq4ChUiKymRbwjgHdcUWTARgLYXHSr2LOU+BV7MVwzxwOfkOWybYAGZD5iRT0edjpxD6VhcOQ6j94tP51wdOHBdMeXa9OqWRcmWXA1XLUIUH6zyCwlAs3z+YBkfs1u+VIejJEF3ckrjI9T0y/aMA2+/tgAg08VURKT8vbKMUgAMIGzzAcOi5HknHQAz8+l+MW/829KxhtH7tTz+jIMAJPCYMULAWd6fvi+EY9ouoZBM/Kx/4LUBgFLgNC5o16FrE8JJVJgkiFhaQQBv3+dVbMrWVsC8UxFRkjjaVsW2DtRdOJ/vAyohVYK7A+bTvTdj8HlqTMcaRu/XxHkzjgNkIOWuDr8jnYYDKDutgpUhra0uAlAyCCUAK8BXcjBXgLCk/h0D/hcByDxFAdAzoFUqUBYRJTUcMWdPP7ONL6i5bLQeALJRQ+bT/W7G4AuAOXq/lsGdcRgAY+glLkYclJVTsa6ptCX3uQjAKINQstFrAZKIwWxQIhIJuovB/Nx+r2LzFCwlj8Y0evl/MYk0kieVtcvrwGUnHQCVjjVkPl3mItQsIPuElx9G79dOzDgMgGkAWlNyBJn8xKprBRC+zgEo4LWRgcdVcOCjjlNvmx84DrzNAahaFZWLygKWxUNibIhTcPD9BMLLa65bzreAMSGVoXvJ/Cgh1WUfO+XTZS5CDYDs9GH1fnOrIDcAkABTTDCCLYK0Cwi/586WcKJUiEpC8CCBYDsiiSplqUIUmOjf+o2tIiKVUJbgU5uSWl4DWwX4+PcXnrQATBNS+8yny1yEopdcay+930y5YhgAg+9n2OoUeI5TdQer+32fdhmGoOBZanBo+g1yEKU4dYgFSvqB//vZBIBt9RshkTbW8ZZZ2hUgvDL3iU3uux4LSBM0ZD7dPRnTH08VAIfV+2XAOucQAMuVcKfFSD/+IAABsEoGwYAoHZIKEEYxRIHwLS8pUuhjFVs6/ZZhIVWyxVKBBIRXnbQATBNS+8ynI4tBzkEACv+chlUVIKE/5cRGsWmlKfIzudc3APLQSlg3E2OCyVRc1kpU3DgBmKoQsWtlBcswjPu+nfTYtBL+GQdgOf16GCZW6pXlBCqWSgqJypoOAFfXXDifbwFJLvi5HAjlnUsiIe6AjOp4iQNQHRlT2PlgJCUbbc2s+v/hFwFb/q7gm6HlYpBbmTV2sscQyy/qFBj2v0/cAdz/HGD7NDA1AUyOOU+1CwWOewNjKj6/O03F1/WuugW4/XJgfBoYmwDGdH7IxB5kLPIB+I8AfNwZgga5ck2fJbEm8V9zNWPfrasbgMuPAcuseJ8Exsb9FdBhA+7gaQNKB6TfcgCYug+YJT+g89aoBDMmIMScP12uTKj13uDv8zsKig/uJ1uQOsnojm3qB5P5ACRBH3OhPuzzRN9DV88HqQLEWPJnvTy5nm/t/1s4BcuSpRZtGAu4fi+wtBVYEyccrYwn6hF8/FkJp9bKxAKVFsn/d8urgbHPA9NPOEOWl4+2cfoFHhfVrJTZPKHSj5daOtup6JyCpPx8rHWRVQ7WOlrYCMx8AHIzlxkALPD9c0VB+x/A3E/+E2fUYHXdF7KTGwdvTd0AHP9r4PgWYG0KWBdfsBdsMPfPrKKsoL9XAVLAvO2fFylCE4cKliyrDVZNcGS1CqEYhWFiAZV+XntaURdTLmpCEbpchTYLqi6NrkMCzLzt5Xc4HwyJmmkJ+Z73jQOh4NWeDUZiK1K08f0EXt7CMHVawIk7gaVpYJUA9LI1Ao8bzKX1cytoFtFfpdCIWz7rgzHgth8u0oPGDwETc8CEMySUzFaikgtlpW1Ta8JqNba7lVljSRgW+Q6ZP/57WQvj6fydBjXfAjKbgEvMLwWCvhNoipgNpnQshlS4IGFWzIk6ylWwAz93ETLxGWB5ClidLABoIOS7pmGfG+33YAG5mND0G8F4678vkiPJczNOAC4UyQm2N8w94kirFlfIAl7i402d6dbPWWAtrsjOFiuCvAJZOQE0pHTFsckHYDeCvhNgipQNxoAz8/8IPr5nbvH2jd+6AThJAE4AqwTdZKEBLDoDgU4+YVkPHIBoPwareOt/BkDexsMFAFnbzNJYm0IDnVwbt4uyur1kwL7Tp+iZM/08WT9Rc7DHUmuYTr/x+6o4ovvu9fjBbgR9JyA+omwwxvZI5ULg6ZW7y9FPf9QNwKm/CgCcKABovh8ByVy/UCtJq2f+X1yYJPGU27lIZLbuEWDsWBHesZeDz4iURLUWa1TE47LqK12fZmd3OXidFctqm92KatVs1jAEsNv6sdymaa2g8+xUL4I+Pn2beCgbLGWHI/h8G3oTr45iK86POlbBU9yKI/AcfLR+ouQwH9BfmmbLlTHboOnZ/T9+5vaf8FUaAThXsFOQ45mUcgZCWTAxe0UQ+urYMO1/37GtxQmoLCBtRSp30LrDp2SFdzYMgk/R+VNwvwR9mwQDsaspGSfJgYDYNTbp8psCQFJxEIBkQjDrxt8dXCUIY+COH5MVFPi8SOn2n/QYLZ9Gp0cxANIP5IvAkzVzxivRydnKNzBa8fddM84b6AFyAriMF2pajk9kYIeoClXmA3AQgr5NQEHMBqMVFMNaIOayNRL/vhlH3RZwmhbQQUcAasrVVGz4EtjCu/3dfb/ID3PbT7uKAZ/MhcIC0vqRTo4W0IBIEAmEtFwCYqjW03bcmdwBYeoWgetUbrR8snrloiR2drpACf+rD4D9EvTVjIJu7HBV+781X752Czj9lwUZkTEgcPoNPp5Nv4oBRhCG6dd+1DkMz1JIhR1BAHJ7zwqO3fIRRM5tmDK5CoQKsSgOeBYBKFZULTqcB9r6Ni5KYmd3WKDUA0BlhNLM8EbT1QBXBU72aI5ZjUcVOxz7WLkQ8d37vsart/uA6RcPsxNSAtAXHDYNC1AEpf9s01kKwuBwGU7HgVt/1jtD1e60fgQigSe/j5bQp+KYpGB+H62jT7P8/ZypBIC8Dhcx8eY9wF015abhmnoAyJ5WSrKeNgKO9SHxnT/LSasJBim5lRjWBEIVeROInKL1qunybRawLgASdEy74qjaNNzJCgqEEYzBGvK0297mAFSHEIB6ebKDgc8J1ksmV8t29f1en6L5v6cxIK5iK6Xne/5jCTiFcTqVn/r/tWDPWwXnEPTVgIKUHU7ljASawKefIwDpMdRxRB+wFgD+RREDJABpwSzz2c0LfxczVjkVKwaYgtBBezu3SvX08d39P5uO3QKahXMQciourZRAGKZWar/YZ1xXRPe8wQr2AUK7TvbOVTZBXx4MBECRnConUBSFEXT6mf/TK+/qmzAF/0UBOPqBZYF52HrTFCw2LH5G8UCzJEko5nZqmRnPh/uCXmpnVpDTsIPPwKApOaSA2QLDLSHf97iPx0tpISLfz7bl4iFfsUsnj+HZWEeOYDCDnDmCvZkEgedcCjxGseIhBYt3vx049HwMLRh8gA9gh2MoH9ABqKJzxf0McO7XlSAU4HzhYYFq+5D7hwBu/98OQLlIBCKnW39SlXNY+nqeiq2dkQg+gnGPb9/ZpT0lq6MV5D96gLCwgDmCwbdnCvZmCgY/dxy47xxg5SWuUjigYPHFbwA+fyGwfr2rXrMvPB+vp3L3GHCgi9JOHQCkRVPppeUBigXLFymyejYTB4YsgfA20ofRAlYB0FfAlvQqP0/TsX5PLOB5DNu471cmIwiBaRww/F01J+mz2pqChxUMZvpJlmBv3iTocsW4dzewfhkGFix+2febXDAeJO/YEILBB7pU1g8LQFo98QASVGYNQ6DZfEG3fnEqrgLhbf/HV15anbkFNCvohWSl9XPQ2XTM/2s3I4DwPIZwBEDfgitH0Ek6N6x+u/iD7T4g/YdBBYPpWHEaHlqwNw+AQa4Yj54JrJO+aQDB4pt+oCAyYvOPEIQDCgYfeF/9U3AbAMX7ItAlVtAspKZdz5SOlvA2pstxjES3wJ+92NgAGK2gwi78QoVfEhBeQACqNNP1RdoA18kKdgDhxkUI/zKIYDCnqyzB3jwAJnLFOEIW7QEEi1/1Y21ywVglCAcQDD5/Efj7M4CVrZ5AKlkhxeQUaxBI4nvFzxf8IfCVC4HV7cC6ZEX5nen3VX1vAGLZq8ysrvHY+QBwbGfI2E6JpLvdX+ksthpUvQrmX/sVDGZVUJZgb17vJHLFeGQcmCdVb5+Cxd/5xjZ6QzzMLOQBBIOfTV2Ps4HFHQ7CLQUQmUrV0rgKJMsCjsxGAqTn/hzw0EXA4tnAyg5gbTYBorKkUyLnkB9YVhTxu+kT13iccwtwdBewPAus+b2ar9xJAafqfgMQO4dh+J9+BHe5gqZZZzYok1JJUcpaR6bp93P+W/N6p0KuGIemgEWKgPQhWPxdP7NBLhiHKYHUp2DwpZ8rLOD8tmJQVplOLxAqmbRKC6EDYC7/CeCRPcCx3cDSrsISrs04CPm9ArZk55UvKAspYLqPaPdR4/H0g8DRHcDyVr/X6VabLHk2PhjpPVZY7d5xwF6CwS9y/4LbbVyQsEKIufGiKe0p2JvXOx3kinF0GjhOQY+oNRtljji9TQPf/fOV9IZY4Gq4D8Hgy/4W+Oo2YG5bUUy04vUcLCqSJVRWszJbNgxSmMau+q/Ao2cBR88EjtOqbgNWWaTkIFz3YiWrF4nAjtN0nBZrJnU+/8PA3CxwfMYB6LUra3oglL0tps6wlVha5rLiqd9AdDfB4Je6U0s/0BXTDYh80Sr2FOzNA2AXuWIszABL1JaKWq1R+nwGeM17OsoFY5XTVw/B4Cv+Djg0C8xvLYqJCECzgsxmZlq9T8e0XGUyaUizavPtxoFr/zvw2BnA0Z3A8e2FVV3x6c4sqwObckeyhiXAowUSADhD1XhceDMwx37lvU4XxVN2n3rJIocygkr/Vbs7fe+EdBLcfaXXQ3IPWIrpBB6XlnwpR76jYG9e7/SQKzarxM7qJFj8mg8UarMV9IZ4gvNDD8HgKx8HDs8A8zMFAFnPYQPDl0Co2g4fpDZLqKCxT0/7fhJ4fCdwbFvhRiwRgJruCOwUgCpeCvUjZmEFxhfk9W969kW/B8xvKQqnVgg+B6CB0MsI7P70AHgmd2n1NQ0rv7FvALIlVYK73MnQCDLThSGZoDpuP7uCeuX5n8zroB5yxThGnQ0CgyBMxY63Aq/5aBHG6EBviDlOLV0Eg1+0AByZLgbl+HRxnZXJoqqttA4ODovlJZVuSjTQFtq+NwNPbHMAzramdVpVs6wEoPtdNg37wJfvsYiJP9NFqvHY+7vAwjSwxAeNxVO8T6aNVRRRlT6hHrJ0Ovaw0WDJCKng7g86APvNB9wg2JvXO33IFWOBgn8EIf2nRLD4tbe1+AU7yAWbZeskGHwVdd2mgAUCcNKnJgLQrZ/V9/Jnn5JUYmnAE3hCmv3+t8AWQfSzyPK/POOgJgDdsgqA5nfJAvLdLV+bz0kK4RqPZ3wQWJxyAPqDVhZQyQr7gyaXI9axWCFVAGLvRUhV46PgLnUWBs0HbBPszeudPuWKsTRZAJDTo8l8ui/42juL5veQC7ZpsEow+OrZQlqVVuH4FLA8WVyDAOTAmHUQCAWQkOlsQAwDt/9/AE8SgPQpNa07+AhAA6HLXbb5Xr4IaAMfv/eGvP5NzyYA7UGjBWTWjh40v9fSyscHLtaxhJWxFVsNNAXH1khw983+DYPmA5aCvXkdNIBccemfceooAfhAAcA+6A2xLuAGucxrzgKOMexDfV9OwbS2BB/BEoqLSrBoYGgJ3E8qLcIEsP/ngCPuUy7S13L3wb6PU56/m/Xj4Ps0TKCXQA6AXuNeZY3HMz5QANAeND1kwcKXlj6wOZQ+b7R+Pi0PD0DeFAfk590CKg8qncfoFzIRVWVqfFfBhgn25vXOAHLFWCDbvPstBsJZ4LUPt+jdesgFg+qVptWq11bg2gtgfuLiRAAgQeg+oEmsOujsXb5SsAoCIN/3vx04OlNM6Yv0tdx1MKvK7/TFjVmeCD4HQQQhf159eV7/pmc/kwCcKABoeYvR0oept7SEoZQ0Tr1lPuPQFlAtO0nyAcWhpzw/FSjFzGjLx+RGvxzoSeC1hwsA9klvaFN5FAy+9mJgnhaQ0qqagglADo4c9AhCDpJPl5ZommQ8738HcGw6AJBW1VecZv0cePwOY0/wl1lAD/WUCx0mMlDLr8bjmb+Dwp3x4nkDYbD0thIO5aNtfmDi/xGEeRawxhs7Vb/q2huABQJwAlhyy2cC0xoggjAAUCWWAkksOiIY978TmOOqeqqwqAx3WGhHK06n7TDwOcAV/iipPAKjwgrZm2o8nkUA0gKmAHTrp+o9MTrEYvq44o9pZIOtgmu8mafCV72YAKT/RwAy5OPOuVlAAk9Oule6xQRTWUKlWtkU/IvAHAHti5oIwDK841ZPFtCmdr0U8PaC9hVultd4CIC8P2Ztt/m5/qC11TJXlJDGGpfGAmYODgFoCxACkLpuWh3KCgqE8gNVZK4KtxgjJAB/2X1Krao1rfN7CWZf3LSBT4uAEIyWBVpipL7GgwA0AW25GbGENBTRx3rm1M2w39mmrFVwjTd1Kn+VAZALEE5LtIDyMWUBvbLNLGHgd5H/V07BDp7r3uU+Jadgn3ptxekA5MBri0/Wp4wzBjDbCnkMWMqVpE8GJwLQqvfc0pqbkVj5aNk7gbCxgJno30cAjntowtXNaZ1suvSKNhsYTcVKmw9F5xGE+94dfEoP+JYhD/8OC8eIPUsUHokVVKB78XszbzAF4Pvd//PCKVGIpOAr78mn4DZOm8YC1jco+w6EFTDDPJqeCEBZBa5GffVbhmQ8DtZW5TYOvPhXip0GTuu22lTMLSw+aAVl9QhEWjurI/aQiLJkTMLsX9R3r/ymZ73fp1+37OU9hunXSkdl7T3QrhKCtlCM59k2i5CMMSIAGdqxEIwrmptzTsCEut5yilKoJLAcxCq3fe8tLCDBFwO+tKjyuxSCMdYEXoeDrHcHvu0tTwLzmwHA4N/Gh6zNCqqeOSxC2lb8tQSiMwbuqXIqAcjFh2JjBKGJyShQG6ygVbfJegULWBYcMR3rvb6oCRaQwFPgl1M5rR7/JtBZOIZWx/0+s4QeY5z/1/X2tFnAxPpFELaVkdLN8MWGVr4pCBsfMHN8bmTKfCjZ0Ncp456/x58zLzfw6Qf3ABd8pUgEYmqk5bGyek06IQl1bkXScnlN/u8L24Gdx1qVq91KQvrpgwaAAw9p+wnXPw1YjyWMGtDo2ASOFGMU7SIEUzdYD34vMPmXwLbHgdkFYAtlGiim6DpxJtvq9LtlVr/aWKEB8pUXAOOPAFPzwBTZ9r04vdQ9Ts4pAZ3cd+yHxgfMAOH+vcA69/9Uxijmz/AerYpdar1lNSMYzV+vWY/34I8DY58Gph8Bpo8A04vAFEFIknIHohGVR62QhFRSYjQE6qFri2z3iaPAhHNNlxKwArI0Q1IAxwfReacbC5gBPp66/5ICgLKCtqnsrKKlrFZUFPKOr7osMTtdsxzqQRZ93Q1MPARMPllohUxRqkEK6gShOP0S+dY2hlRv99y+ovRi7IiTnTvLqmg6xDPYpqAUgRgsoR7MxgJmgHD/c4E1FXu7FRRbvEgd7evXWlbPpp9EgUjiJpwe6zwOMlvpAWCMVusJYPIYMOlSDZRpoGiNxKzbdIQlXONMWJbGtw4svdgz3El47nzTRvPrrKptAJT6ZrzfintvAJgx4vsvdQvIXK5VYF3sUZxmJUvgA1FOvwF8spKyBtM1y6EepI4LqVMedbEaTp0EIKdPKh5FqYYqSxgo2jgFr13j6XXHnOiSZOeBVSvyC8qC2r05FVvVw9cAMAOA178AWPMp2LJaaekiCPXExwHw660n1oB/niGQazwOkkSepbJ/72I1x4CJ+cJ6lYI1riccrVicUuVSmIW82pkwnHHVOKbFsOozQGkFkwewnBES37ABYMaAX39ZAUCCb82nIlo+40p2gNnvsoKunxH1xGwA/LOzdQOQJPIuHzV2GBg7Cow7AI0l33XfjOsv6oVodes6ISbBsAZMX+kJxU56KY7pkmFVhOciuvTzSt05v0+ryuT/9gDrZNe4wPMsI7VJP3GcP7gUOOdvgL1rRYJ0ZI5IV3hV4/wrGYPPU3/AiRhYusy2K7mU999P+z90ObD7LuBZK0Xdkeq9NSX2+o4HLwfWlopFCC0fgciBMtAFC8CGrYXVoVjnU2G7rTXrzh4kfRzLY1kyGwBoeiGcPiXb5eAzdXWnazPCSScb4j3xfmav8Cx2p50lAMW0VXINitCogl2r9H2dcctWwQxQsn6ZTBbMNtcgdKIbiZj51VcBk38CXPxoQcfCUg8pjcYgZScw/momACnXyr4leBhs5QaBTHpf7X8dMPYJYO8XgAv9e8QJlAZZq8D4xSuANYKPJQn0AR2AHKy1MACKe9nfFI6IEqduEWoHIJ9wlsVKLekoMCa9EAegSTYQeM4TXco2SEMkAHEbBZoj4bbYtdyCVrFqGXgTSxgXYTZeHLi9AMjEQRCVUXP/n4KUaaT8vVTi+Rtg7GPAuYcAWlMCgUVkQfJ2Q12yBvPXMwHImhDWwf81imsTiLSEvHZkr+jY/p9CQRD4p8DOBwteItai05qn31FFdfLlFxYWgCDUIkRkj/TxbCEi/89jfPZ3X2VqYSJQbmUNQY3HQT7hbv2sLoerVwKQHNEEoCsm8R4MhPRjXUGzVEIKIoY7yaEYuY4dgGb5RXruoSgtSCLLarkICQ9f6QNykGjFdjsIBaI4kGlt8W+Rg5g0HJ8qAp47nihAzFpuWtPIMBZJlASILvR6fQ0DCVbJCkJOJCqnk4pGpb99tZ8MopyiKDX7WWDiwYKXiEQOehCrgKh+eJQ+EQHo1Lby/zRlyf8TIbf9XS5ftIb8I92YugH4ay2pLusorl7dAoonWtMwQSTdOFuQSLTGHyIC8kxSIQuA4hwU2WUAoO4/grBcDbsfWElSzg+JCoYDoEGM1ixSkHzgF/wG7y8sIa3J7JPAGWuFJSQIaU01iJHUiYP4e33BrPOHmG/JMaOfTZVYRhwGav87vWKPJ9/rSH4IOGO5sITqg/ggxXs4TOaBAECbeoOsgfl+DrQShFqcEIhyyt0MbMusEkx76iAZXKM8BvXiZAGlF+KaIbaadYpem4aDgpJZQz6YJABV5VcHAJZ0v4FxX6KG5UpYs0KnqjhRuagEVgPglYAl9ciHf8mdUrJh0Qx9vkDBzBywfbkYQIGwahA/kglATsHsDzKA0BATiPyZ4NEDwIeoa/uFYKKXL2f24nQoIgd9R3yQCMTFqwIAfdBWI7+yB5ZLECYLETd85YJl+2YAUNosLIel/xYlu4Jsl6bhNhD6it4WJCvA2Zc4Gxo73RcgJeOqFmGR6rcChLYACyGojmEYdj59KnZ+tIQRhH9IvWA2hiREjDeRI9Cly7fMF3EtWRFawhQIf5IJwE56wdTIYdt7tp9ys1K8JnoJvod9Wn682PNkP4hUy1ndWgstAtBDMLYN5/6PAc5DGNoF4SrZfN+4+IhT8jqwg2Cp8ThIJ5vfSWBXAVCrWN9SMxDK+skaOvhoAc8me654pmUB3f0wyt+E8FyRAGmPlOEoiSD2qgvmAKoOm52fAuiTDHSyIRxx+lI0QxxADubfF5vffMmSajrWlP7nmZ3dSy+4r/ZzAUEHnQ8R70HsXlK+PgJsW68G4XYGZj0EY2EYATCAT6tAhmE0DXcC4faapcwMgAIfLb0kuzT9Qmw5uwAAIABJREFUSi+EfeALkSrpBovbrQDnkm8wAo8/E3i+CCsZ98NCpAp8cUekZyBavI4ET/TnaAk/RQCyAXy6uNSPA0i+wMeB6ePA5HFgZq2wpNGK3FUDAHmv3fSCe7afX8CB4UNEEOolVi/3obastNwJ9cO5BOBKEQMsAcifHWzRAigWWAlCn5K2bQYAOe1KMjTIR2kRUhKVS7IrLia0v+3xwHMZMCbYNP0KfG79zAqK5DxOvyEuWu6VD5KSHy2YAEQAfpaRdl5UkuUctIpBnCIIl4psD03FtIIP1ADAlBuJM47EqqUX3LX9kSBQcuuyftK78xUkHyQ+RLqHZ3Fv1KcgLj5kAQ1s0Qo6IA1nHhNLQzA8ZxvBXuNx8DcS5UYpNnoYxsCnUIqvZo0F3wPTMa7Hv53HOJVbS/l+5bumX7d+5WLE44hxIRJB2NMCqj9ixwuE90svWCaIA6bAp959EKeWChAyA0PTOV2unGMQveCO7bfqHbcS4rJR7Ewqnw5AWhLuImg2uFQAXAVs8RGmntW4+g2hB3P79L/EJ9zGvqrxOPibiVihAOgrWQOf/EBfBcsPNBBqW9Hv6zzGqFzmoXz3B9AePgXiq6bgiv4YOB9QHS8AfpkAFMMjrWAcQA0iO9XJiQyAnos2vV7ESHOOQfWCO7Zf7F40mZFQScRKAYBaSU6vAVcTgN7xXHiUFpDTMK2dFh56912BTiDcvpkATIXzCL4g3WXTZ4jpGfjoF/oihL+fx+0yWUABLwIwtYKKIabgCzHQvi2ggBKn0McEQDaKT5cGkIOo6SuyYzEfjQB0EM5nZgAPoxe8of3sgSqCQM3jkdFLvpRvR13+7UVRuhUFSavNO6otwp88ZZ3+t4M6HLtch6OT9AG/q9cmtf//gV1JDYcnQ2zY6/YakfSrU+Pg1M45NqPt3IEtoM7WFHokyrWKkooglCMWLYjiUXMtK3g8Uzd1WL3gDe3vRRCoUEYCwGtYFxxqgA2E/jI20F5hhmQod98BHNnlxOTig1aGiDanO21yV4DygWuB8YeB6fnC9WEtiKVVKeE0ZGiXWczeJoWMIig5a9V5DA1ANoKDeDylZ9NSXxyAsiKawrQqmCv2HVf5e8aRoxfc1n7xs+khItAUvojvyWryxVcWJZksVSyZoQRA3dcAoHzax4Gj2wtu6FVKM7gMgti02jbV476oUJJs1j/AbA1mQ3Pm8eTRsoZDtR+xZKCiEKmMXTIeXHPGdhYArX8FwG4DGMEnAHIK4yvT58nWC2b73cexaZgWWaEKgU1gjNbPP7PvOYGsUSBkv3hBtmRWNzxjTk9RWktvxp6POj0vARjY9sWkFel8RWxegjIF4RjwAOnZWMPBTGjqvHmszxJOBUD3xyznL2bqROvoP3N3q84jG4C7M/PpcvMBef0cvV9k6hXv+2Yno5QfGArRbaCC0mWv2YtF3ecerNDhkNZIIsXQRv5dlTtGADJSz2gEE1EJQM//026HdIEZLC8B6A0tk0g1Ja8DuzJdphS82QBEZj5dbj7gxZN5er/IZI+67pscgE7QaDOUMyC0Wb8+gXjuR4F5J6YsaXnFhBoAGEVvUhb60jISgCQnoh/OLBgvIrL8v7DdFkEYM5dtNg97tvz5zJqzdfIBmJlPl5sP+DJP5xtW7xffnzeh7H+Z+3+RpkyWT1YxuURJYVtx6T0fCTocouQV85VkHRIGegEuEv/YKpkA/JceVmL8kv6t5/9pu62tfiPWcFQVEa0DZ9WcLJEPwMx8uvfnjT9IgZyj94t/ldeA/S9tMaGa9SNdmsIxbvVscVJ1GScoMt4UPwhAsmMZ0aXzQBsvdGRBjQz0FUpEJRAJQOq4KAnBdz+sfiPJ3bOYn8fsykyVWMfiN3BOzckS+QDMzKe7OW/88aqQzsfE5kH1fvGjeQ0wADodmVGwOeiMsUqHrGOnS4UFy9P/wAEojkEnI+IqOIJQNLgpCXhcmLAtD/D+kgQE235L93tj+YBqgTX9BiCeW/NedT4AmQ+YkU/3sbzxBymQuZhm8g1T+QbV+wWFdjKO/Te2mEFNlCb6gPF708VJ1TXHgKd91GnZpDfi1k/gM2vqU3DUnCuBmNQe3P9vw6pe229KOvB0K1k+ZS+rnrfM2AlA3JMZtah/EZKZT3drxuDz1O/yxAwu9JgJxr3lQfR+8aa8Buy/wdWQZAVl+ZzCrG3q9c/YrkmHy3IRYryAAqAkEBIlopJxNNUbER+fA/H+/+AAdP9PmS9dazicJybm7mlB8nR2dI1HvgVkOlZGPt2nM29GCamcGZjAwlQ+vvrV+8X/zGsAAUiLVPp/wd+zaTMFWw+/kAA0GQQnpCw5mDsAMIrcRB5mC/+MAffTwgfwKY2KfmCZ6ZIkUShrxXxBX4yYaV8Hzmcn13jUA8CMfDqWYeQcSkhVOl8U6uxH7xekrsg49h8oiCENgC5TUG5vKxxT8f2aRtOtcAKQ1s8soPuOVUIwpchNlEEIOyNSIrrvv3hwnckWIZPZsnbcDyzTpvg3lU8mpZQqozyfK74aj3wAKh1LgrsD5tMxiz/nkGD1sHq/YNFOxkEAcuW7oqmXlisuQOT7VV2jwi/kTgj1RkoZhBje8Z83SCAEEJZW0C3gff8tADCt4VASaWIBK0HI9q8BF5yUAMzIp8tNx5Jg9bB6v/jdDPSRns0BWIZeUitIo9IhHmhXTvzCPQddccnZ76U1V/IvC4SBCFyg26DFNg7c++Mhhb6qiCikT7WVUmr6lYn2nRKyrdZ51GMBlZIc07GUBdMjny6XCiUmpA6j94vMZbgBMFo552pu27PXAqXTyAUQcitOQjAm9xX0N9pIwIPmSCmH5QuPqER0L4kDYgp9zOUL6fYxkbZcFceyAreAF3GlV+NRDwAz8uksnT3jiILVSmpWNlhMze+k94vMZfgGAPJeHDjpCrgM01Tdry9OzvmYAzAqLVWIwEShwzbRwwSEn+MqP6bQK5tZlWyhjCCCsC19Xv7gOnBRbgp7cu/5AOyVjqVMmA75dJZ9nHF0yohWNlhMxKnS+0XmMtwAmFq4imnYbrEqNJPc+9kfd62RKh0On8qV9hXZ9askEPgAfI56ziocUgVbzGT28lEtRMoKtg7lBHtznfZNA+CQ+XQWM8k4uglWK/NLYKzS+8U9GReXD0g/Tyvh4Ne17Yb4Zbr6g6y7/aNWcoPpjKRTsJIags5IJwkEAv6en05S6GUBfRWsUExZyVZVQCQwrgN7Wfdd41GPBczIp8ODeXfTSbBa6YYxlY8/p3q/udc3C+jTbtvqt2oadnB2m4oNgMn0W0p+hYWHWbwg9yU/0Kb9EIy+5y2hiCit4UgKyTeAkN8Valk4Le/ldlONRz4AWWBRM6fdIPfHstw/G+SE5rMnVQ/kA5AkLHS0ak7V7reXfhgACaBqDtD3e/nmc5k9kA/A80JReq+U38zGVp3ObJo/BvAOD3dtwiWar9zEHsgHIGlFubqSx7+Jja36anLLcDvvgwA+NDpDfILv+qlzuXwAXuSjrkKemlO2e3U1uWUYnL8dwB/5e2apca9LNv+vsQfyAUheX4VguB+mzIsaG9ntqxhF4Xbe3QD+n7/uHLAW9wQ1tblMRQ/UA0CaHC7plXEh+q4T0OWcfhleYTSHBK0EH/mi+fcRuKQn4I6fWpeoB4AevCz3HOOm9yb3F5mBlZBNclYCj1aRfyfrbgPCTR6AzK+vD4CyglX7jpmN7HY66d1E0ctdIrEEE4wEIMlam+Pk7YF6AMj7EwAVbU82vTerCwhAXopJN9zVI+AYrOeULLZgErY2x8nZA/kAJGWr0naUWdFpy2cT+oCWjpdjLFxE5UzYIBBpEUX5nLnlvAktb76SPVAfAOUHpiAMm96bsVtCAMaKALICMyxDq6cXfycA+b/mOLl6oF4AiqBRIEzBp7/X2Af0+fi1XIioMIlAI+AIPIGPmeROWV3j1Zuvyu2B+gHoFfZiDS2lC0LiY52WUADkQoTTMH1BFSYRdHoRfKSu5v9qrizMHYPT+vx6ARhSuDcAzzmDo5ZGHT1PAKYMwQxME2jiSo/gEwBrrq+u41ZOy++oD4BaCcsXTPiSI3ey8s4KGoG8QwCMFM+0ggQhLR0BF19SXuD/ayakz7uR0/TsMcxg3SjfqWNA0hsrga/ojaq/8WPcC+YIk4Ke4CMSuB2XVht1Oj8zIfXlU8BtU8DhmYRXWdfrdF1fgr3+S8At48CD04DVjXQSDO70PTUnaJ5uOCwsIIFHSSFy1pKPWCDsZxCpw8UVgKSPxLXM937OzxxAljzcPAbcswU4Qh4V3UN8mKoeKm/bu78IfKJQa8VD48CylHQiL3O3/qg5Rf30BKACMtJXjXKQcfBSK8Dfqc3KVCwuN2VFGRnm/yKZtq4Re5ifyQQgM2A+BeB3GHaZBo5MAIue0l7Kt3cC4xhw+5eL7TuCkJk1jBtyerbUfYG5ExjZ/pqrxE5fAOrOq5SmowVIrRp1IyT2R6+fg0bgVYG4CsyZe2UsaiOGKXr4Sfp9k8CxCYAFSKyvXeY1o1BxQux91yMtfsHPutgnnyUuUvhc0ZsgUXib+nVkq6+ZKaABIHsgVZnuwD9sVo66rrR4ImdhLGSQ8zPL/JgBQxeU1ouWkO9PTgDzbgmXxrzMkatl3keivfG5x4r4IRcz5BfkO5vEZ0kgpIfBZ8yKjlL17syy0tMNcOn9dl4Fy6dLFabj1Mpvow9Ify+I4Nlo9Xt+ZqU9VdJpqZh4QDDyxUyYOYJwHDg+DhgI/WUVZl7aSEt93+GO9Ia2iuZKOfA7lhp9JpvAVy61w2mOwO5hmCgMHC1H9O24gu6UD9jP+ZmbtLRaSsei9SL4XDPbAEh/kGQ/pSUcc0lbApFWb67lQUhpVnLBsoKqqZclFMmUtrxPcwxl3X7vOCAtYLSCcugFQmqhdssH7HU+RznjiOlYXA8wqkOfkItTAom+oKygca4ES8jY+N3z7fSG4hfUtp3ihUHruVSsFy1iRvNP+1N7A5BdJACmVpAgZPhGOyCigEjlPLudn7kvFtOxuB4g6OjD8UWLRkCZFRwrLCEXJQQhp2K+37lQeBCRX1A7KPQto1prFEmSYn2mB9EAsO+kYfk8KQhZF8yjVz5gp/MztyOUjiW9bCUhEBhKRCCgSis45uQ/PhX/xfFWMgOnWu2gxB0TF/o0kEZ/kCDM1Ts+3RHYnwVUL6XhDFrAswfIB6w6P1MrTulY0sum1VICglKwCEACqvQFCUK3gHcsFQCM/ILayqP1k9JshVqrncMalOYYvgcGAyCvIwuod8YBJQmZpmGJeyRwkGw4n8jJOJQNw3idLFhMRNB0SgASTJyKoy/4ieXCeFfJBUeV2SoAclFyR0bbm1OHTUiN0/DTAwD7zQeM52dqj8VsGEkVE2jKetG7AEhQ0frJAv6RC0trC1skl+IWlNinGLbSaZg7Mc0xfA8MbgF1LQV1z08A2G8+oM7PVF9Ms2GUE0gQyp+Lwu2yagLgR9ZaYpkSypQ6a6Q2DCqzpkvietXIFdoZfuieGmcOD0DeP0HEbBhNwYPmA/L8zJQsATAKnguEqS+XTqkE4YfWWwCUFZTksYAYwZfIBeN9Tw0cjOwu8gDIZqsoSSvhEeQDiiGYFoyWiSDRypWgi69UP5sc5fIcquSCNeXqe2X9ZAHfM7Khe2pcOB+AT41+aO5iRD3QAHBEHd9ctuiBBoANEkbaAw0AR9r9zcUbADYYGGkPNAAcafc3F28A2GBgpD3QAHCk3d9cvAFgg4GR9kADwJF2f3PxBoANBkbaAw0AR9r9zcUbADYYGGkPNAAcafc3F28A2GBgpD3QAHCk3d9cfOxqYJ2au9RdPtdp/khoEOlglDYT39V1PzQFXLsMXAlgt9PCxJKPbufyf8/KHIPfBPAZABf79Xc5XQ0ZQ1Q7360NbxoHrlsDvs5ZRsgo0une06by6X1mZvtP99PNAp4F4LsBXA5gjw8EGTeqaGF4QhzQF80CX7cAvGIdeDYAfhdZ2sTKUcVrpE7nd31N5gj8e2dIo2osk7NZpMdK0Z19tv+bJ4F9K8D1ACj8yfNSikHeg+5Z969m57Y/8/ZP+dPLKZhP/rcA+AYAF7g1oRUhEMUzFMt6eSJfX78b2DkPfM0i8GIAX+uWlAMppreUUErn8p2gzTl+2flg/sDbTkvIOik+CP20//mzwAXzwDcCuNTPJeFXpEpM6QEjIHm/zTF8D7T5gATYNQCe69aAloRTGulfBESBSYNyxR5g/Bhw7hKwZwl4vk9LnM5JmsBzUyDGAX3B8G23Mz/g9BuUa/0IiutfMkj7zwKmngAuXSvOpUvAWYBtF4BTnspIj/O8zPaf7qdvWITw6eZA0JLQEhKEGgxZhUj/dz3NzSKwbR44exnYvVKcy+mM5Km0JhxInUtrGkmzCPicg3W5LMGkQiZZTm9xS9Z3+4m2o8C5c4X15pTKW2Lb+fCx7WLtjYxzqiql29Icw/dA5SqYf6RTTilg+lYCIXmICKQ4IK9wxfSJY8AZK8CuFWDnanEua9ZTAMsaCog3Dt92O/MvnRGBtGwkqKRmMEkqCaa+2k+0LQDTh4rP88UHj74kF1WaATo9QHQ7mmP4HugYhtEKj4PB6ZQ+FS0hQahpldPya1kXTOqNY8DscgG+HavAttUCvBxInitrkgL4lcO33c7spBdM3kAuSnq2nx9gQfAh4JyVwvrxwel2z3p4aMlzH6DM2z/lT+8aB+Q/OT4EEqckWQSBkGD6EQKQnDCLwBSnYgcf32fXioGUFawC4esyu7CXXnDP9tOCsyD4KLB1rmgvX7zfbu2WG/Jtme0/3U/vKxBNAMoi0KcjkATCN3HOEr3UAjDrwOP71rXixYEkeKMFlSX8ocwR6KUXTJ7AaNE2tF8WfA4Ye7Kw1mwvX/yZn+eKnvcrfzC6IK/ObP/pfnpfAGQnySoISBqUXyAASS1AK0JfagWYcRDOrAF66TxZQU7jBOEbM0egH71gcgXSFZAV54NQtj9YcNIpbONCyh8Ygi8CVospApDuB63g92W2/3Q/vW8AsqM4gLIKBBIH8bcJwMCNMX68BTqBb8s6sGWtsIA6jwDk662ZI9CvXjA5A6NVa2t/IAicnC/aGV+8T74IQPm/AmGuBc+8/VP+9IEAyLslAKMV/LgAyIUInfnjwPQqMOOgI/DstQ5Mr7UAqMF8V2YXDqoXXNl+EQQ6N9v29aKdesUpWJZbAPyPme0/3U8fGIDssDid/pUASCvCaXgJmFguAEfgEXT27gDkuwaUg/nbmSMwjF7whvbLhSDL5TwwvdRqo9oqHzACkCB8U2b7T/fThwIgO01T1IMCoAZxGRhbKoAXQUcQTjkI+a4B5e5FzjGsXvCG9gdqrLGFYrpVG/UuHzBOw2/LaXxzbh43DKeoJwlAHqLndSs4udoCoIBHQE45EPk3DuitmYOQoxdctp8+rFwIWsGFYiFFoLGNchcEQC6e+OJC5J2Z7T/dTx/aApYdJ37AyJK/DIwvFxYvWr0IwEn/H1Opco5sveDUhSAAF4HJpQJkWixp6k2n4IYfMGf0amDHev2I8+l4/UbvNw8Eozw72wJePOJ8und7EkKj9ztKGA1/7WwATo44n45pWI3e7/AAGPWZ2QBkYHCU+XTMfGGQmYIxjd7vqOE0+PXzATjifDrKtTZ6v4MP/MlyRj4AR5xPF+VaqZLJF1UzKdPV6P2eLDDr3I58AI44n07ZMARbo/d78gMubWE+AEecT8e9YOn2Uheu0fs9tUCYD8AR59MpG6bR+z21gKfW1gNAz4geRT5dTEZo9H5PPRDmAzBmRM8BJzqfLiYjSKKr0fs9dYBYDwBHmE9XtRfMsIz04aQZ1+j9npygrA+Akqs8wfl0BCCTWRq935MTYL1aVQ8Ao1zlAnAi8+kEQGZTNXq/vYb75Pt/fQAcUT5dBGCj93vyAaxXi+oDoFLyT3A+3Rcavd9eY3xS/z8fgCQX/LPR3SOzkon55jg1eyAfgD8M4NcAPD6aDmBtB1e4NMDNcer1QD4AbwbwxwDe4UvRE9wHZG1gNSXDLlwLNcep1QP5APxzzwj9IIAPnXhT5ORc5EYCA9HNcWr1QD4AmRH6FQBMTSZZH98ZmD5Bh5g1FopiNns1x6nTA/kAvAfAEwDudnI+EvQxPfkEzYfaCXRSBluQMB7YHKdGD+QDsBNBH/9+AkAobqTADGK7Inw1x8nfA/kA7EXQt8kgrGAGMfBxZ5Cv5ji5eyAfgL0I+r68uR0QmUFoBQU8vfNvzXHy9kA9AORoMw7CdGQCjoUZDwL4kv/+8OZ1gJhBIjGDgMh3vTavBc035/RAPgD7JegjODfhiMwgoqeJwNPPTaB6Ezq/hq+sB4AcXeXEP+ZhGVo9vRimIQD5v5oPAZCupgDI9wg8/qz/1Xz55usyeyAfgMMQ9GU2Op4eAchpOIJQQEz/VuPlm6/K7IH6AMjgGzdl6QtyX5jWjpQFevF3lq3xf6yhrOlIAUgQCojR8gmE+l9Nl2++JrMH6gEgR5UA5KYsc+AZmCbQCDi+IvgEQMob1XBEAHIajgBMLV+0kCdws6aGu3zqfkV9AGTwjftg3JRVVRAtHQEXX/wbAcoXP5d5CID8GoJKvqDAloKOoIz/y7x8c3pmD4zhaqwjRzCYyQg5gr2ZgsFTLweWr8XQgsXjbwLWrnNtMlKgNoLBmZAa7PTCAuYIBlMvlWQswwr2UlUw45jdDSx8HbD+Ctd+HVCwePKbgJV9aASDM8Yg59TWFDysYPBtmYK91IbNOHaPA/M7gUXKXA4hWDz79cA8+W0aweCMURj+1HYfcBjBYO54MMY3tGDv8I3nmWSHOzYOLJ0LLPGXAQWLz3oB8MQUsEa16kYwOG8whjh74yJkUMFgbsNlCfYO0epwissVY34bsHw2sEIRkAEEi/dcU0SP5qhF1ggG5w3GEGdXr4L5134Fg4kAjuDQgr1DtDqcUmZETwArZwAru4BVqsv0KVh8/o3F4v0QXZBGMDhvMIY4u3MYhv95Zh+Cu1xBcxuOU/HfeDIq5cv7FuwdotXhlCBXjOXZAnyrO4BV6in0IVh8wStLuWCsUAyvEQzOG5ABz+4eB+R/ewnu/kOP/3G/l4kJTERlljQtIot2e53/IwO2OPl4FLtcnCqAp9cahT56CBZf+LpSLhhz1N5qBIPzBmTAs/sLRHcTDKbiNHdBGGymOC/3hglEvgjAnoK9A7Y4+XgiV4zVWYDAs/etxaubYPFFP1QkLtCIP8neaASD8wZkwLP7AyC/tJNg8L/xLNBu+YBdBXsHbHEFAINcMVamgdWZAoRrfPdXm8KitLdmgYveWAq+2y7iMqfuRjA4b1AGOLt/APJLqwSD3+y5T1yI0AoSbAxMMzGV1o8/My2ro2DvAK2t+GgiV4zj4+3AIwDXtwBrVJeuECze+9aW4Dut4PxkIhYsdetGMDhvoDqcPRgA+SWp4O4veQ5Uv/mAGwR78+6rQq4Yq9PAOi2fA4/vBkKudKVU7VZw77uKvWFuZbtcMNb5v0YwOG9g+jx7cADyi6Pg7gccgIxlcA5TKhaD01yYKBmVFpBZMfx/m2Bvny3t8LGqoqTliZbVI+gMgHwnMAnCIFi897cLAAZ6QyzFzzSCwXkD1OPs4QDIL5XgLmk5JHk/SD5gKdibd38VcsVYGmuBTaAzEHLHgyCcaokB7/1IkUET5IKxwF5pBIPzBqbPs4cHIC/AaeqvPL9pmHxAE+zts6VdLCD/lcgVY3UyWD0Bj1ZwqgCggXA7sPfWAoAJvaEtZBrB4Lyx6efsPADyCtmCvf00s/NnOsgVY3m8BTRZPZuGBUACdArY+5lWDqGmYbIrLHEx0ggG5w1OH2fnA7CPizQfaXqgUw80AGywMdIeaAA40u5vLt4AsMHASHugAeBIu7+5eAPABgMj7YEGgCPt/ubiDQAbDIy0BxoAjrT7m4s3AGwwMNIeaAA40u5vLt4AsMHASHugAeBIu7+5eAPABgMj7YEGgCPt/ubiDQAbDIy0B8ZYNMbkX+ZekpuIiOQrPar+xs889HJg6jZg5jAwvVZ8B+ll9PlO5/Fc/o+ECjnHfi8zYfkvM5ulmp4qJXVqx5deD4zfAkw/CGxdAZgoHfuh131QkaI5hu8Bs4Ds8B0AWLnIRGCBsFfn87JffDMwdjOw5R5g8giwZa34jnQQUwDo99wBfJ4TM7COiNdlaj2rA/jeV/vfDeATAP4UGH8I2Lrc6gc+SHqY4oMZ74VSKM0xfA+UUzB/oBUUCKMl6zSQ/PsXqZD5KQC/A0w/DEwcAcYXgYnVwppwADuBkefnCim90FmBWXwnK87Uen53BI8sbuwqaz9p5UgnQhBS+ZN1zE8Ak0utviCwq8DI8/nx5hi+Bzb4gJzKZE1SEFZZgS9/2pWR/gTAJ4HJQ8DEMWB8ARhfBsaWCwDquwQKvvNgHXvOcYVbPFJPkw+dDxC/W1Y4tWDpw/Rlgo4lo1T4/KxTihDNpJwj3/UiMLXemprjffC7eWpzDN8DlYsQDiKtVxzEqoHkyX9HRizW+nIgaQnvAiaeBCbmC0s4tgSMu2rMePAR9X252jXklaTFU108K0MHav/nvJ6ZxVVk9OI7GR2IZoGQNc/HgbHgIwqILIVujuF7oOMqWFawCoRxkfEIB5CWgkREBCNf9wMTc8A4QciBWyoGz16rwNgaML5eWKpctYZL3N+TWLX0gvtuP0HHk2n16JDyxXmVhfU0qywbJbr5GSuXKxA/sV5Y9UYWdnjwyS3qKKgarWA69Wg6fjQOIK0HadnIjPVFB+AiME4AuiUkCFnESyCSkmAuU7Cjm15wX+2X2ifBRn9A8mKcW2UFjULVQcgVDl80u40SYh763FfvquhLCxitoBYUsoJfjXKttByMq9CKcHn4sPuCbgXNJwyWkECcz5Q376UX3LNncZyQAAADEklEQVT9fFgIJs6lBBwtn3Tt6FpIz4RWnuQxPh2XIGzm4CwQ9hWIFgBTK0gQHiIAJddKq0ELQh+KL1qUR4MvSEsoENIKrgALHNiMox+94K7tl9qnnMio8MSf6SNwGpYVjCDk/Ju7isq496fCqX0BkDeqlWwKwic1gAQSpzGREnFgREz01eALLvvq2Kfi45m6cf3qBXdsfxRbJMho8dimqOhEK8cXQRr9QVpvPoDNMXQP9A3ACELFxPh+jACkP0fLIKFCCRRqKuPUdqjlC9o07JZwKVNHeBC94DQcZO0XAAkmgotAk9QYrR9f/BvByYfMSATDVMzwTXMM3QMDAVAgVHCZ7/MaQK4QZUHiNCbBQlqUw74YCb7gcmYkelC9YFlwvVv7RRAorTuBkECU9asCID9/x9B935zYzyKkqpfiNHxcA0gLQgvBAaPVkCqm3h2AtC5m/RyEqzw/4xhGL3hD++MmslgqCbgUfLKAcRrmTlBzDN0DA1tAXUlWcDm1IOIIJAjlT/Fd05lbFQFwjdtgGcewesFt7Rc/Gx8iWjUCjGCT1YvWT1MwgUqrf3NG45tTbcu0aximWx9xENcEQHGbcYAEwtSXSqY0gnCdgeuMI0cvuGx/FUGgFhwEYrR80QckWN+X0fjm1DwAWv8RgJFilJZBznz0pQg+AZAAlVWh1GvGka0XzB0cCQi30aSGVa9AF62fLOB7MhrfnJoPwPER59Px+o3e76mL5Kwp2G57xPl0kxc3er+nLvyKtLmhfUC78RHn081ONnq/pzcAR5xPR9mRRu/31IVgvgUccT4dNaobvd/TGYAjzqejumqj93s6A3DE+XRUg2VSCjdaGr3fUw+I+VPwiPPpqJjO8J1Nw43e7ymHwHoAKMFd7QErAeEE5NNJMb3R+z3lsGcNzgfgiPPpomJ6o/d76oGwPgCOKJ8uKqY3er+nKwBHmE+noqRG7/fUA199U/AI8+kEwEbv93QHoEhZTnA+nYqSGr3fBoAtaiqBUImdm5hPJwA2er+nKwBHnE+X1gUzSbnR+z11wPj/AeCpPDD3t7rvAAAAAElFTkSuQmCC";
// src/effects/glsl/smaa.frag
var $fe721963ebf18f1b$var$smaa_default = "uniform sampler2D weightMap;varying vec2 vOffset0;varying vec2 vOffset1;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 a;a.x=texture2D(weightMap,vOffset0).a;a.y=texture2D(weightMap,vOffset1).g;a.wz=texture2D(weightMap,uv).rb;vec4 color=inputColor;if(dot(a,vec4(1.0))>=1e-5){bool h=max(a.x,a.z)>max(a.y,a.w);vec4 blendingOffset=vec4(0.0,a.y,0.0,a.w);vec2 blendingWeight=a.yw;movec(bvec4(h),blendingOffset,vec4(a.x,0.0,a.z,0.0));movec(bvec2(h),blendingWeight,a.xz);blendingWeight/=dot(blendingWeight,vec2(1.0));vec4 blendingCoord=blendingOffset*vec4(texelSize,-texelSize)+uv.xyxy;color=blendingWeight.x*texture2D(inputBuffer,blendingCoord.xy);color+=blendingWeight.y*texture2D(inputBuffer,blendingCoord.zw);}outputColor=color;}";
// src/effects/glsl/smaa.vert
var $fe721963ebf18f1b$var$smaa_default2 = "varying vec2 vOffset0;varying vec2 vOffset1;void mainSupport(const in vec2 uv){vOffset0=uv+texelSize*vec2(1.0,0.0);vOffset1=uv+texelSize*vec2(0.0,1.0);}";
// src/effects/SMAAEffect.js
var $fe721963ebf18f1b$export$85b31dfef8286ee7 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new SMAA effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {SMAAPreset} [options.preset=SMAAPreset.MEDIUM] - The quality preset.
   * @param {EdgeDetectionMode} [options.edgeDetectionMode=EdgeDetectionMode.COLOR] - The edge detection mode.
   * @param {PredicationMode} [options.predicationMode=PredicationMode.DISABLED] - The predication mode.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SRC, preset: preset = $fe721963ebf18f1b$export$829eaccd811a63f.MEDIUM, edgeDetectionMode: edgeDetectionMode = $fe721963ebf18f1b$export$20d1071ff7b64a56.COLOR, predicationMode: predicationMode = $fe721963ebf18f1b$export$6b657d16effdfea4.DISABLED } = {}){
        super("SMAAEffect", $fe721963ebf18f1b$var$smaa_default, {
            vertexShader: $fe721963ebf18f1b$var$smaa_default2,
            blendFunction: blendFunction,
            attributes: $fe721963ebf18f1b$export$a72ebb312f9e05c6.CONVOLUTION | $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "weightMap",
                    new (0, $ilwiq.Uniform)(null)
                ]
            ])
        });
        let searchImage, areaImage;
        if (arguments.length > 1) {
            searchImage = arguments[0];
            areaImage = arguments[1];
            if (arguments.length > 2) preset = arguments[2];
            if (arguments.length > 3) edgeDetectionMode = arguments[3];
        }
        this.renderTargetEdges = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetEdges.texture.name = "SMAA.Edges";
        this.renderTargetWeights = this.renderTargetEdges.clone();
        this.renderTargetWeights.texture.name = "SMAA.Weights";
        this.uniforms.get("weightMap").value = this.renderTargetWeights.texture;
        this.clearPass = new $fe721963ebf18f1b$export$fc4180e277a6a0c2(true, false, false);
        this.clearPass.overrideClearColor = new (0, $ilwiq.Color)(0);
        this.clearPass.overrideClearAlpha = 1;
        this.edgeDetectionPass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$a9e4c517bf702b92());
        this.edgeDetectionMaterial.edgeDetectionMode = edgeDetectionMode;
        this.edgeDetectionMaterial.predicationMode = predicationMode;
        this.weightsPass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$b466e73f24a55218());
        const loadingManager = new (0, $ilwiq.LoadingManager)();
        loadingManager.onLoad = ()=>{
            const searchTexture = new (0, $ilwiq.Texture)(searchImage);
            searchTexture.name = "SMAA.Search";
            searchTexture.magFilter = (0, $ilwiq.NearestFilter);
            searchTexture.minFilter = (0, $ilwiq.NearestFilter);
            searchTexture.generateMipmaps = false;
            searchTexture.needsUpdate = true;
            searchTexture.flipY = true;
            this.weightsMaterial.searchTexture = searchTexture;
            const areaTexture = new (0, $ilwiq.Texture)(areaImage);
            areaTexture.name = "SMAA.Area";
            areaTexture.magFilter = (0, $ilwiq.LinearFilter);
            areaTexture.minFilter = (0, $ilwiq.LinearFilter);
            areaTexture.generateMipmaps = false;
            areaTexture.needsUpdate = true;
            areaTexture.flipY = false;
            this.weightsMaterial.areaTexture = areaTexture;
            this.dispatchEvent({
                type: "load"
            });
        };
        loadingManager.itemStart("search");
        loadingManager.itemStart("area");
        if (searchImage !== void 0 && areaImage !== void 0) {
            loadingManager.itemEnd("search");
            loadingManager.itemEnd("area");
        } else if (typeof Image !== "undefined") {
            searchImage = new Image();
            areaImage = new Image();
            searchImage.addEventListener("load", ()=>loadingManager.itemEnd("search"));
            areaImage.addEventListener("load", ()=>loadingManager.itemEnd("area"));
            searchImage.src = $fe721963ebf18f1b$var$searchImageDataURL_default;
            areaImage.src = $fe721963ebf18f1b$var$areaImageDataURL_default;
        }
        this.applyPreset(preset);
    }
    /**
   * The edges texture.
   *
   * @type {Texture}
   */ get edgesTexture() {
        return this.renderTargetEdges.texture;
    }
    /**
   * Returns the edges texture.
   *
   * @deprecated Use edgesTexture instead.
   * @return {Texture} The texture.
   */ getEdgesTexture() {
        return this.edgesTexture;
    }
    /**
   * The edge weights texture.
   *
   * @type {Texture}
   */ get weightsTexture() {
        return this.renderTargetWeights.texture;
    }
    /**
   * Returns the edge weights texture.
   *
   * @deprecated Use weightsTexture instead.
   * @return {Texture} The texture.
   */ getWeightsTexture() {
        return this.weightsTexture;
    }
    /**
   * The edge detection material.
   *
   * @type {EdgeDetectionMaterial}
   */ get edgeDetectionMaterial() {
        return this.edgeDetectionPass.fullscreenMaterial;
    }
    /**
   * The edge detection material.
   *
   * @type {EdgeDetectionMaterial}
   * @deprecated Use edgeDetectionMaterial instead.
   */ get colorEdgesMaterial() {
        return this.edgeDetectionMaterial;
    }
    /**
   * Returns the edge detection material.
   *
   * @deprecated Use edgeDetectionMaterial instead.
   * @return {EdgeDetectionMaterial} The material.
   */ getEdgeDetectionMaterial() {
        return this.edgeDetectionMaterial;
    }
    /**
   * The edge weights material.
   *
   * @type {SMAAWeightsMaterial}
   */ get weightsMaterial() {
        return this.weightsPass.fullscreenMaterial;
    }
    /**
   * Returns the edge weights material.
   *
   * @deprecated Use weightsMaterial instead.
   * @return {SMAAWeightsMaterial} The material.
   */ getWeightsMaterial() {
        return this.weightsMaterial;
    }
    /**
   * Sets the edge detection sensitivity.
   *
   * See {@link EdgeDetectionMaterial#setEdgeDetectionThreshold} for more details.
   *
   * @deprecated Use edgeDetectionMaterial instead.
   * @param {Number} threshold - The edge detection sensitivity. Range: [0.05, 0.5].
   */ setEdgeDetectionThreshold(threshold) {
        this.edgeDetectionMaterial.edgeDetectionThreshold = threshold;
    }
    /**
   * Sets the maximum amount of horizontal/vertical search steps.
   *
   * See {@link SMAAWeightsMaterial#setOrthogonalSearchSteps} for more details.
   *
   * @deprecated Use weightsMaterial instead.
   * @param {Number} steps - The search steps. Range: [0, 112].
   */ setOrthogonalSearchSteps(steps) {
        this.weightsMaterial.orthogonalSearchSteps = steps;
    }
    /**
   * Applies the given quality preset.
   *
   * @param {SMAAPreset} preset - The preset.
   */ applyPreset(preset) {
        const edgeDetectionMaterial = this.edgeDetectionMaterial;
        const weightsMaterial = this.weightsMaterial;
        switch(preset){
            case $fe721963ebf18f1b$export$829eaccd811a63f.LOW:
                edgeDetectionMaterial.edgeDetectionThreshold = 0.15;
                weightsMaterial.orthogonalSearchSteps = 4;
                weightsMaterial.diagonalDetection = false;
                weightsMaterial.cornerDetection = false;
                break;
            case $fe721963ebf18f1b$export$829eaccd811a63f.MEDIUM:
                edgeDetectionMaterial.edgeDetectionThreshold = 0.1;
                weightsMaterial.orthogonalSearchSteps = 8;
                weightsMaterial.diagonalDetection = false;
                weightsMaterial.cornerDetection = false;
                break;
            case $fe721963ebf18f1b$export$829eaccd811a63f.HIGH:
                edgeDetectionMaterial.edgeDetectionThreshold = 0.1;
                weightsMaterial.orthogonalSearchSteps = 16;
                weightsMaterial.diagonalSearchSteps = 8;
                weightsMaterial.cornerRounding = 25;
                weightsMaterial.diagonalDetection = true;
                weightsMaterial.cornerDetection = true;
                break;
            case $fe721963ebf18f1b$export$829eaccd811a63f.ULTRA:
                edgeDetectionMaterial.edgeDetectionThreshold = 0.05;
                weightsMaterial.orthogonalSearchSteps = 32;
                weightsMaterial.diagonalSearchSteps = 16;
                weightsMaterial.cornerRounding = 25;
                weightsMaterial.diagonalDetection = true;
                weightsMaterial.cornerDetection = true;
                break;
        }
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.edgeDetectionMaterial.depthBuffer = depthTexture;
        this.edgeDetectionMaterial.depthPacking = depthPacking;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        this.clearPass.render(renderer, this.renderTargetEdges);
        this.edgeDetectionPass.render(renderer, inputBuffer, this.renderTargetEdges);
        this.weightsPass.render(renderer, this.renderTargetEdges, this.renderTargetWeights);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.edgeDetectionMaterial.setSize(width, height);
        this.weightsMaterial.setSize(width, height);
        this.renderTargetEdges.setSize(width, height);
        this.renderTargetWeights.setSize(width, height);
    }
    /**
   * Deletes internal render targets and textures.
   */ dispose() {
        const { searchTexture: searchTexture, areaTexture: areaTexture } = this.weightsMaterial;
        if (searchTexture !== null && areaTexture !== null) {
            searchTexture.dispose();
            areaTexture.dispose();
        }
        super.dispose();
    }
    /**
   * The SMAA search image, encoded as a base64 data URL.
   *
   * @type {String}
   * @deprecated
   */ static get searchImageDataURL() {
        return $fe721963ebf18f1b$var$searchImageDataURL_default;
    }
    /**
   * The SMAA area image, encoded as a base64 data URL.
   *
   * @type {String}
   * @deprecated
   */ static get areaImageDataURL() {
        return $fe721963ebf18f1b$var$areaImageDataURL_default;
    }
};
// src/materials/glsl/ssao.frag
var $fe721963ebf18f1b$var$ssao_default = "#include <common>\n#include <packing>\n#ifdef NORMAL_DEPTH\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D normalDepthBuffer;\n#else\nuniform mediump sampler2D normalDepthBuffer;\n#endif\nfloat readDepth(const in vec2 uv){return texture2D(normalDepthBuffer,uv).a;}\n#else\nuniform lowp sampler2D normalBuffer;\n#if DEPTH_PACKING == 3201\nuniform lowp sampler2D depthBuffer;\n#elif defined(GL_FRAGMENT_PRECISION_HIGH)\nuniform highp sampler2D depthBuffer;\n#else\nuniform mediump sampler2D depthBuffer;\n#endif\nfloat readDepth(const in vec2 uv){\n#if DEPTH_PACKING == 3201\nreturn unpackRGBAToDepth(texture2D(depthBuffer,uv));\n#else\nreturn texture2D(depthBuffer,uv).r;\n#endif\n}\n#endif\nuniform lowp sampler2D noiseTexture;uniform mat4 inverseProjectionMatrix;uniform mat4 projectionMatrix;uniform vec2 texelSize;uniform vec2 cameraNearFar;uniform float intensity;uniform float minRadiusScale;uniform float fade;uniform float bias;uniform vec2 distanceCutoff;uniform vec2 proximityCutoff;varying vec2 vUv;varying vec2 vUv2;float getViewZ(const in float depth){\n#ifdef PERSPECTIVE_CAMERA\nreturn perspectiveDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);\n#else\nreturn orthographicDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);\n#endif\n}vec3 getViewPosition(const in vec2 screenPosition,const in float depth,const in float viewZ){vec4 clipPosition=vec4(vec3(screenPosition,depth)*2.0-1.0,1.0);float clipW=projectionMatrix[2][3]*viewZ+projectionMatrix[3][3];clipPosition*=clipW;return(inverseProjectionMatrix*clipPosition).xyz;}float getAmbientOcclusion(const in vec3 p,const in vec3 n,const in float depth,const in vec2 uv){float radiusScale=1.0-smoothstep(0.0,distanceCutoff.y,depth);radiusScale=radiusScale*(1.0-minRadiusScale)+minRadiusScale;float radius=RADIUS*radiusScale;float noise=texture2D(noiseTexture,vUv2).r;float baseAngle=noise*PI2;float rings=SPIRAL_TURNS*PI2;float occlusion=0.0;int taps=0;for(int i=0;i<SAMPLES_INT;++i){float alpha=(float(i)+0.5)*INV_SAMPLES_FLOAT;float angle=alpha*rings+baseAngle;vec2 rotation=vec2(cos(angle),sin(angle));vec2 coords=alpha*radius*rotation*texelSize+uv;if(coords.s<0.0||coords.s>1.0||coords.t<0.0||coords.t>1.0){continue;}float sampleDepth=readDepth(coords);float viewZ=getViewZ(sampleDepth);\n#ifdef PERSPECTIVE_CAMERA\nfloat linearSampleDepth=viewZToOrthographicDepth(viewZ,cameraNearFar.x,cameraNearFar.y);\n#else\nfloat linearSampleDepth=sampleDepth;\n#endif\nfloat proximity=abs(depth-linearSampleDepth);if(proximity<proximityCutoff.y){float falloff=1.0-smoothstep(proximityCutoff.x,proximityCutoff.y,proximity);vec3 Q=getViewPosition(coords,sampleDepth,viewZ);vec3 v=Q-p;float vv=dot(v,v);float vn=dot(v,n)-bias;float f=max(RADIUS_SQ-vv,0.0)/RADIUS_SQ;occlusion+=(f*f*f*max(vn/(fade+vv),0.0))*falloff;}++taps;}return occlusion/(4.0*max(float(taps),1.0));}void main(){\n#ifdef NORMAL_DEPTH\nvec4 normalDepth=texture2D(normalDepthBuffer,vUv);\n#else\nvec4 normalDepth=vec4(texture2D(normalBuffer,vUv).xyz,readDepth(vUv));\n#endif\nfloat ao=0.0;float depth=normalDepth.a;float viewZ=getViewZ(depth);\n#ifdef PERSPECTIVE_CAMERA\nfloat linearDepth=viewZToOrthographicDepth(viewZ,cameraNearFar.x,cameraNearFar.y);\n#else\nfloat linearDepth=depth;\n#endif\nif(linearDepth<distanceCutoff.y){vec3 viewPosition=getViewPosition(vUv,depth,viewZ);vec3 viewNormal=unpackRGBToNormal(normalDepth.rgb);ao+=getAmbientOcclusion(viewPosition,viewNormal,linearDepth,vUv);float d=smoothstep(distanceCutoff.x,distanceCutoff.y,linearDepth);ao=mix(ao,0.0,d);\n#ifdef LEGACY_INTENSITY\nao=clamp(1.0-pow(1.0-ao,abs(intensity)),0.0,1.0);\n#endif\n}gl_FragColor.r=ao;}";
// src/materials/glsl/ssao.vert
var $fe721963ebf18f1b$var$ssao_default2 = "uniform vec2 noiseScale;varying vec2 vUv;varying vec2 vUv2;void main(){vUv=position.xy*0.5+0.5;vUv2=vUv*noiseScale;gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/SSAOMaterial.js
var $fe721963ebf18f1b$export$b3b89c0d91a017a5 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new SSAO material.
   *
   * @param {Camera} camera - A camera.
   */ constructor(camera){
        super({
            name: "SSAOMaterial",
            defines: {
                SAMPLES_INT: "0",
                INV_SAMPLES_FLOAT: "0.0",
                SPIRAL_TURNS: "0.0",
                RADIUS: "1.0",
                RADIUS_SQ: "1.0",
                DISTANCE_SCALING: "1",
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new (0, $ilwiq.Uniform)(null),
                normalBuffer: new (0, $ilwiq.Uniform)(null),
                normalDepthBuffer: new (0, $ilwiq.Uniform)(null),
                noiseTexture: new (0, $ilwiq.Uniform)(null),
                inverseProjectionMatrix: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Matrix4)()),
                projectionMatrix: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Matrix4)()),
                texelSize: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                cameraNearFar: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                distanceCutoff: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                proximityCutoff: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                noiseScale: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                minRadiusScale: new (0, $ilwiq.Uniform)(0.33),
                intensity: new (0, $ilwiq.Uniform)(1),
                fade: new (0, $ilwiq.Uniform)(0.01),
                bias: new (0, $ilwiq.Uniform)(0)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$ssao_default,
            vertexShader: $fe721963ebf18f1b$var$ssao_default2
        });
        this.copyCameraSettings(camera);
        this.resolution = new (0, $ilwiq.Vector2)();
        this.r = 1;
    }
    /**
   * The current near plane setting.
   *
   * @type {Number}
   * @private
   */ get near() {
        return this.uniforms.cameraNearFar.value.x;
    }
    /**
   * The current far plane setting.
   *
   * @type {Number}
   * @private
   */ get far() {
        return this.uniforms.cameraNearFar.value.y;
    }
    /**
   * A combined normal-depth buffer.
   *
   * @type {Texture}
   */ set normalDepthBuffer(value) {
        this.uniforms.normalDepthBuffer.value = value;
        if (value !== null) this.defines.NORMAL_DEPTH = "1";
        else delete this.defines.NORMAL_DEPTH;
        this.needsUpdate = true;
    }
    /**
   * Sets the combined normal-depth buffer.
   *
   * @deprecated Use normalDepthBuffer instead.
   * @param {Number} value - The buffer.
   */ setNormalDepthBuffer(value) {
        this.normalDepthBuffer = value;
    }
    /**
   * The normal buffer.
   *
   * @type {Texture}
   */ set normalBuffer(value) {
        this.uniforms.normalBuffer.value = value;
    }
    /**
   * Sets the normal buffer.
   *
   * @deprecated Use normalBuffer instead.
   * @param {Number} value - The buffer.
   */ setNormalBuffer(value) {
        this.uniforms.normalBuffer.value = value;
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * The noise texture.
   *
   * @type {Texture}
   */ set noiseTexture(value) {
        this.uniforms.noiseTexture.value = value;
    }
    /**
   * Sets the noise texture.
   *
   * @deprecated Use noiseTexture instead.
   * @param {Number} value - The texture.
   */ setNoiseTexture(value) {
        this.uniforms.noiseTexture.value = value;
    }
    /**
   * The sample count.
   *
   * @type {Number}
   */ get samples() {
        return Number(this.defines.SAMPLES_INT);
    }
    set samples(value) {
        this.defines.SAMPLES_INT = value.toFixed(0);
        this.defines.INV_SAMPLES_FLOAT = (1 / value).toFixed(9);
        this.needsUpdate = true;
    }
    /**
   * Returns the amount of occlusion samples per pixel.
   *
   * @deprecated Use samples instead.
   * @return {Number} The sample count.
   */ getSamples() {
        return this.samples;
    }
    /**
   * Sets the amount of occlusion samples per pixel.
   *
   * @deprecated Use samples instead.
   * @param {Number} value - The sample count.
   */ setSamples(value) {
        this.samples = value;
    }
    /**
   * The sampling spiral ring count.
   *
   * @type {Number}
   */ get rings() {
        return Number(this.defines.SPIRAL_TURNS);
    }
    set rings(value) {
        this.defines.SPIRAL_TURNS = value.toFixed(1);
        this.needsUpdate = true;
    }
    /**
   * Returns the amount of spiral turns in the occlusion sampling pattern.
   *
   * @deprecated Use rings instead.
   * @return {Number} The radius.
   */ getRings() {
        return this.rings;
    }
    /**
   * Sets the amount of spiral turns in the occlusion sampling pattern.
   *
   * @deprecated Use rings instead.
   * @param {Number} value - The radius.
   */ setRings(value) {
        this.rings = value;
    }
    /**
   * The intensity.
   *
   * @type {Number}
   * @deprecated Use SSAOEffect.intensity instead.
   */ get intensity() {
        return this.uniforms.intensity.value;
    }
    set intensity(value) {
        this.uniforms.intensity.value = value;
        if (this.defines.LEGACY_INTENSITY === void 0) {
            this.defines.LEGACY_INTENSITY = "1";
            this.needsUpdate = true;
        }
    }
    /**
   * Returns the intensity.
   *
   * @deprecated Use SSAOEffect.intensity instead.
   * @return {Number} The intensity.
   */ getIntensity() {
        return this.uniforms.intensity.value;
    }
    /**
   * Sets the intensity.
   *
   * @deprecated Use SSAOEffect.intensity instead.
   * @param {Number} value - The intensity.
   */ setIntensity(value) {
        this.uniforms.intensity.value = value;
    }
    /**
   * The depth fade factor.
   *
   * @type {Number}
   */ get fade() {
        return this.uniforms.fade.value;
    }
    set fade(value) {
        this.uniforms.fade.value = value;
    }
    /**
   * Returns the depth fade factor.
   *
   * @deprecated Use fade instead.
   * @return {Number} The fade factor.
   */ getFade() {
        return this.uniforms.fade.value;
    }
    /**
   * Sets the depth fade factor.
   *
   * @deprecated Use fade instead.
   * @param {Number} value - The fade factor.
   */ setFade(value) {
        this.uniforms.fade.value = value;
    }
    /**
   * The depth bias. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get bias() {
        return this.uniforms.bias.value;
    }
    set bias(value) {
        this.uniforms.bias.value = value;
    }
    /**
   * Returns the depth bias.
   *
   * @deprecated Use bias instead.
   * @return {Number} The bias.
   */ getBias() {
        return this.uniforms.bias.value;
    }
    /**
   * Sets the depth bias.
   *
   * @deprecated Use bias instead.
   * @param {Number} value - The bias.
   */ setBias(value) {
        this.uniforms.bias.value = value;
    }
    /**
   * The minimum radius scale for distance scaling. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get minRadiusScale() {
        return this.uniforms.minRadiusScale.value;
    }
    set minRadiusScale(value) {
        this.uniforms.minRadiusScale.value = value;
    }
    /**
   * Returns the minimum radius scale for distance scaling.
   *
   * @deprecated Use minRadiusScale instead.
   * @return {Number} The minimum radius scale.
   */ getMinRadiusScale() {
        return this.uniforms.minRadiusScale.value;
    }
    /**
   * Sets the minimum radius scale for distance scaling.
   *
   * @deprecated Use minRadiusScale instead.
   * @param {Number} value - The minimum radius scale.
   */ setMinRadiusScale(value) {
        this.uniforms.minRadiusScale.value = value;
    }
    /**
   * Updates the absolute radius.
   *
   * @private
   */ updateRadius() {
        const radius = this.r * this.resolution.height;
        this.defines.RADIUS = radius.toFixed(11);
        this.defines.RADIUS_SQ = (radius * radius).toFixed(11);
        this.needsUpdate = true;
    }
    /**
   * The occlusion sampling radius. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get radius() {
        return this.r;
    }
    set radius(value) {
        this.r = Math.min(Math.max(value, 1e-6), 1);
        this.updateRadius();
    }
    /**
   * Returns the occlusion sampling radius.
   *
   * @deprecated Use radius instead.
   * @return {Number} The radius.
   */ getRadius() {
        return this.radius;
    }
    /**
   * Sets the occlusion sampling radius.
   *
   * @deprecated Use radius instead.
   * @param {Number} value - The radius. Range [1e-6, 1.0].
   */ setRadius(value) {
        this.radius = value;
    }
    /**
   * Indicates whether distance-based radius scaling is enabled.
   *
   * @type {Boolean}
   * @deprecated
   */ get distanceScaling() {
        return true;
    }
    set distanceScaling(value) {}
    /**
   * Indicates whether distance-based radius scaling is enabled.
   *
   * @deprecated
   * @return {Boolean} Whether distance scaling is enabled.
   */ isDistanceScalingEnabled() {
        return this.distanceScaling;
    }
    /**
   * Enables or disables distance-based radius scaling.
   *
   * @deprecated
   * @param {Boolean} value - Whether distance scaling should be enabled.
   */ setDistanceScalingEnabled(value) {
        this.distanceScaling = value;
    }
    /**
   * The occlusion distance threshold. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get distanceThreshold() {
        return this.uniforms.distanceCutoff.value.x;
    }
    set distanceThreshold(value) {
        this.uniforms.distanceCutoff.value.set(Math.min(Math.max(value, 0), 1), Math.min(Math.max(value + this.distanceFalloff, 0), 1));
    }
    /**
   * The occlusion distance threshold in world units.
   *
   * @type {Number}
   */ get worldDistanceThreshold() {
        return -$fe721963ebf18f1b$var$orthographicDepthToViewZ(this.distanceThreshold, this.near, this.far);
    }
    set worldDistanceThreshold(value) {
        this.distanceThreshold = $fe721963ebf18f1b$var$viewZToOrthographicDepth(-value, this.near, this.far);
    }
    /**
   * The occlusion distance falloff. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get distanceFalloff() {
        return this.uniforms.distanceCutoff.value.y - this.distanceThreshold;
    }
    set distanceFalloff(value) {
        this.uniforms.distanceCutoff.value.y = Math.min(Math.max(this.distanceThreshold + value, 0), 1);
    }
    /**
   * The occlusion distance falloff in world units.
   *
   * @type {Number}
   */ get worldDistanceFalloff() {
        return -$fe721963ebf18f1b$var$orthographicDepthToViewZ(this.distanceFalloff, this.near, this.far);
    }
    set worldDistanceFalloff(value) {
        this.distanceFalloff = $fe721963ebf18f1b$var$viewZToOrthographicDepth(-value, this.near, this.far);
    }
    /**
   * Sets the occlusion distance cutoff.
   *
   * @deprecated Use distanceThreshold and distanceFalloff instead.
   * @param {Number} threshold - The distance threshold. Range [0.0, 1.0].
   * @param {Number} falloff - The falloff. Range [0.0, 1.0].
   */ setDistanceCutoff(threshold, falloff) {
        this.uniforms.distanceCutoff.value.set(Math.min(Math.max(threshold, 0), 1), Math.min(Math.max(threshold + falloff, 0), 1));
    }
    /**
   * The occlusion proximity threshold. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get proximityThreshold() {
        return this.uniforms.proximityCutoff.value.x;
    }
    set proximityThreshold(value) {
        this.uniforms.proximityCutoff.value.set(Math.min(Math.max(value, 0), 1), Math.min(Math.max(value + this.proximityFalloff, 0), 1));
    }
    /**
   * The occlusion proximity threshold in world units.
   *
   * @type {Number}
   */ get worldProximityThreshold() {
        return -$fe721963ebf18f1b$var$orthographicDepthToViewZ(this.proximityThreshold, this.near, this.far);
    }
    set worldProximityThreshold(value) {
        this.proximityThreshold = $fe721963ebf18f1b$var$viewZToOrthographicDepth(-value, this.near, this.far);
    }
    /**
   * The occlusion proximity falloff. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get proximityFalloff() {
        return this.uniforms.proximityCutoff.value.y - this.proximityThreshold;
    }
    set proximityFalloff(value) {
        this.uniforms.proximityCutoff.value.y = Math.min(Math.max(this.proximityThreshold + value, 0), 1);
    }
    /**
   * The occlusion proximity falloff in world units.
   *
   * @type {Number}
   */ get worldProximityFalloff() {
        return -$fe721963ebf18f1b$var$orthographicDepthToViewZ(this.proximityFalloff, this.near, this.far);
    }
    set worldProximityFalloff(value) {
        this.proximityFalloff = $fe721963ebf18f1b$var$viewZToOrthographicDepth(-value, this.near, this.far);
    }
    /**
   * Sets the occlusion proximity cutoff.
   *
   * @deprecated Use proximityThreshold and proximityFalloff instead.
   * @param {Number} threshold - The range threshold. Range [0.0, 1.0].
   * @param {Number} falloff - The falloff. Range [0.0, 1.0].
   */ setProximityCutoff(threshold, falloff) {
        this.uniforms.proximityCutoff.value.set(Math.min(Math.max(threshold, 0), 1), Math.min(Math.max(threshold + falloff, 0), 1));
    }
    /**
   * Sets the texel size.
   *
   * @deprecated Use setSize() instead.
   * @param {Number} x - The texel width.
   * @param {Number} y - The texel height.
   */ setTexelSize(x, y) {
        this.uniforms.texelSize.value.set(x, y);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @deprecated Use copyCameraSettings instead.
   * @param {Camera} camera - A camera.
   */ adoptCameraSettings(camera) {
        this.copyCameraSettings(camera);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNearFar.value.set(camera.near, camera.far);
            this.uniforms.projectionMatrix.value.copy(camera.projectionMatrix);
            this.uniforms.inverseProjectionMatrix.value.copy(camera.projectionMatrix).invert();
            if (camera instanceof (0, $ilwiq.PerspectiveCamera)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const uniforms = this.uniforms;
        const noiseTexture = uniforms.noiseTexture.value;
        if (noiseTexture !== null) uniforms.noiseScale.value.set(width / noiseTexture.image.width, height / noiseTexture.image.height);
        uniforms.texelSize.value.set(1 / width, 1 / height);
        this.resolution.set(width, height);
        this.updateRadius();
    }
};
// src/materials/glsl/depth-downsampling.frag
var $fe721963ebf18f1b$var$depth_downsampling_default = "#include <packing>\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D depthBuffer;\n#else\nuniform mediump sampler2D depthBuffer;\n#endif\n#ifdef DOWNSAMPLE_NORMALS\nuniform lowp sampler2D normalBuffer;\n#endif\nvarying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;float readDepth(const in vec2 uv){\n#if DEPTH_PACKING == 3201\nreturn unpackRGBAToDepth(texture2D(depthBuffer,uv));\n#else\nreturn texture2D(depthBuffer,uv).r;\n#endif\n}int findBestDepth(const in float samples[4]){float c=(samples[0]+samples[1]+samples[2]+samples[3])*0.25;float distances[4];distances[0]=abs(c-samples[0]);distances[1]=abs(c-samples[1]);distances[2]=abs(c-samples[2]);distances[3]=abs(c-samples[3]);float maxDistance=max(max(distances[0],distances[1]),max(distances[2],distances[3]));int remaining[3];int rejected[3];int i,j,k;for(i=0,j=0,k=0;i<4;++i){if(distances[i]<maxDistance){remaining[j++]=i;}else{rejected[k++]=i;}}for(;j<3;++j){remaining[j]=rejected[--k];}vec3 s=vec3(samples[remaining[0]],samples[remaining[1]],samples[remaining[2]]);c=(s.x+s.y+s.z)/3.0;distances[0]=abs(c-s.x);distances[1]=abs(c-s.y);distances[2]=abs(c-s.z);float minDistance=min(distances[0],min(distances[1],distances[2]));for(i=0;i<3;++i){if(distances[i]==minDistance){break;}}return remaining[i];}void main(){float d[4];d[0]=readDepth(vUv0);d[1]=readDepth(vUv1);d[2]=readDepth(vUv2);d[3]=readDepth(vUv3);int index=findBestDepth(d);\n#ifdef DOWNSAMPLE_NORMALS\nvec3 n[4];n[0]=texture2D(normalBuffer,vUv0).rgb;n[1]=texture2D(normalBuffer,vUv1).rgb;n[2]=texture2D(normalBuffer,vUv2).rgb;n[3]=texture2D(normalBuffer,vUv3).rgb;\n#else\nvec3 n[4];n[0]=vec3(0.0);n[1]=vec3(0.0);n[2]=vec3(0.0);n[3]=vec3(0.0);\n#endif\ngl_FragColor=vec4(n[index],d[index]);}";
// src/materials/glsl/depth-downsampling.vert
var $fe721963ebf18f1b$var$depth_downsampling_default2 = "uniform vec2 texelSize;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vUv0=uv;vUv1=vec2(uv.x,uv.y+texelSize.y);vUv2=vec2(uv.x+texelSize.x,uv.y);vUv3=uv+texelSize;gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/DepthDownsamplingMaterial.js
var $fe721963ebf18f1b$export$b2d248d2215da09e = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new depth downsampling material.
   */ constructor(){
        super({
            name: "DepthDownsamplingMaterial",
            defines: {
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new (0, $ilwiq.Uniform)(null),
                normalBuffer: new (0, $ilwiq.Uniform)(null),
                texelSize: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)())
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$depth_downsampling_default,
            vertexShader: $fe721963ebf18f1b$var$depth_downsampling_default2
        });
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * The normal buffer.
   *
   * @type {Texture}
   */ set normalBuffer(value) {
        this.uniforms.normalBuffer.value = value;
        if (value !== null) this.defines.DOWNSAMPLE_NORMALS = "1";
        else delete this.defines.DOWNSAMPLE_NORMALS;
        this.needsUpdate = true;
    }
    /**
   * Sets the normal buffer.
   *
   * @deprecated Use normalBuffer instead.
   * @param {Texture} value - The normal buffer.
   */ setNormalBuffer(value) {
        this.normalBuffer = value;
    }
    /**
   * Sets the texel size.
   *
   * @deprecated Use setSize() instead.
   * @param {Number} x - The texel width.
   * @param {Number} y - The texel height.
   */ setTexelSize(x, y) {
        this.uniforms.texelSize.value.set(x, y);
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/passes/DepthDownsamplingPass.js
var $fe721963ebf18f1b$export$eb8020324d924933 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new depth downsampling pass.
   *
   * @param {Object} [options] - The options.
   * @param {Texture} [options.normalBuffer=null] - A texture that contains view space normals. See {@link NormalPass}.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor({ normalBuffer: normalBuffer = null, resolutionScale: resolutionScale = 0.5, width: width = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, height: height = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("DepthDownsamplingPass");
        const material = new $fe721963ebf18f1b$export$b2d248d2215da09e();
        material.normalBuffer = normalBuffer;
        this.fullscreenMaterial = material;
        this.needsDepthTexture = true;
        this.needsSwap = false;
        this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            minFilter: (0, $ilwiq.NearestFilter),
            magFilter: (0, $ilwiq.NearestFilter),
            depthBuffer: false,
            type: (0, $ilwiq.FloatType)
        });
        this.renderTarget.texture.name = "DepthDownsamplingPass.Target";
        this.renderTarget.texture.generateMipmaps = false;
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    /**
   * The normal(RGB) + depth(A) texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the normal(RGB) + depth(A) texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.fullscreenMaterial.depthBuffer = depthTexture;
        this.fullscreenMaterial.depthPacking = depthPacking;
    }
    /**
   * Downsamples depth and scene normals.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
        renderer.render(this.scene, this.camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
        this.fullscreenMaterial.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        const gl = renderer.getContext();
        const renderable = gl.getExtension("EXT_color_buffer_float") || gl.getExtension("EXT_color_buffer_half_float");
        if (!renderable) throw new Error("Rendering to float texture is not supported.");
    }
};
// src/effects/glsl/ssao.frag
var $fe721963ebf18f1b$var$ssao_default3 = "uniform lowp sampler2D aoBuffer;uniform float luminanceInfluence;uniform float intensity;\n#if defined(DEPTH_AWARE_UPSAMPLING) && defined(NORMAL_DEPTH)\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D normalDepthBuffer;\n#else\nuniform mediump sampler2D normalDepthBuffer;\n#endif\n#endif\n#ifdef COLORIZE\nuniform vec3 color;\n#endif\nvoid mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){float aoLinear=texture2D(aoBuffer,uv).r;\n#if defined(DEPTH_AWARE_UPSAMPLING) && defined(NORMAL_DEPTH) && __VERSION__ == 300\nvec4 normalDepth[4];normalDepth[0]=textureOffset(normalDepthBuffer,uv,ivec2(0,0));normalDepth[1]=textureOffset(normalDepthBuffer,uv,ivec2(0,1));normalDepth[2]=textureOffset(normalDepthBuffer,uv,ivec2(1,0));normalDepth[3]=textureOffset(normalDepthBuffer,uv,ivec2(1,1));float dot01=dot(normalDepth[0].rgb,normalDepth[1].rgb);float dot02=dot(normalDepth[0].rgb,normalDepth[2].rgb);float dot03=dot(normalDepth[0].rgb,normalDepth[3].rgb);float minDot=min(dot01,min(dot02,dot03));float s=step(THRESHOLD,minDot);float smallestDistance=1.0;int index;for(int i=0;i<4;++i){float distance=abs(depth-normalDepth[i].a);if(distance<smallestDistance){smallestDistance=distance;index=i;}}ivec2 offsets[4];offsets[0]=ivec2(0,0);offsets[1]=ivec2(0,1);offsets[2]=ivec2(1,0);offsets[3]=ivec2(1,1);ivec2 coord=ivec2(uv*vec2(textureSize(aoBuffer,0)))+offsets[index];float aoNearest=texelFetch(aoBuffer,coord,0).r;float ao=mix(aoNearest,aoLinear,s);\n#else\nfloat ao=aoLinear;\n#endif\nfloat l=luminance(inputColor.rgb);ao=mix(ao,0.0,l*luminanceInfluence);ao=clamp(ao*intensity,0.0,1.0);\n#ifdef COLORIZE\noutputColor=vec4(1.0-ao*(1.0-color),inputColor.a);\n#else\noutputColor=vec4(vec3(1.0-ao),inputColor.a);\n#endif\n}";
// src/effects/SSAOEffect.js
var $fe721963ebf18f1b$var$NOISE_TEXTURE_SIZE = 64;
var $fe721963ebf18f1b$export$49399bb0221f2549 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new SSAO effect.
   *
   * @todo Move normalBuffer to options.
   * @param {Camera} [camera] - The main camera.
   * @param {Texture} [normalBuffer] - A texture that contains the scene normals.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.MULTIPLY] - The blend function of this effect.
   * @param {Boolean} [options.distanceScaling=true] - Deprecated.
   * @param {Boolean} [options.depthAwareUpsampling=true] - Enables or disables depth-aware upsampling. Has no effect if WebGL 2 is not supported.
   * @param {Texture} [options.normalDepthBuffer=null] - Deprecated.
   * @param {Number} [options.samples=9] - The amount of samples per pixel. Should not be a multiple of the ring count.
   * @param {Number} [options.rings=7] - The amount of spiral turns in the occlusion sampling pattern. Should be a prime number.
   * @param {Number} [options.worldDistanceThreshold] - The world distance threshold at which the occlusion effect starts to fade out.
   * @param {Number} [options.worldDistanceFalloff] - The world distance falloff. Influences the smoothness of the occlusion cutoff.
   * @param {Number} [options.worldProximityThreshold] - The world proximity threshold at which the occlusion starts to fade out.
   * @param {Number} [options.worldProximityFalloff] - The world proximity falloff. Influences the smoothness of the proximity cutoff.
   * @param {Number} [options.distanceThreshold=0.97] - Deprecated.
   * @param {Number} [options.distanceFalloff=0.03] - Deprecated.
   * @param {Number} [options.rangeThreshold=0.0005] - Deprecated.
   * @param {Number} [options.rangeFalloff=0.001] - Deprecated.
   * @param {Number} [options.minRadiusScale=0.1] - The minimum radius scale.
   * @param {Number} [options.luminanceInfluence=0.7] - Determines how much the luminance of the scene influences the ambient occlusion.
   * @param {Number} [options.radius=0.1825] - The occlusion sampling radius, expressed as a scale relative to the resolution. Range [1e-6, 1.0].
   * @param {Number} [options.intensity=1.0] - The intensity of the ambient occlusion.
   * @param {Number} [options.bias=0.025] - An occlusion bias. Eliminates artifacts caused by depth discontinuities.
   * @param {Number} [options.fade=0.01] - Influences the smoothness of the shadows. A lower value results in higher contrast.
   * @param {Color} [options.color=null] - The color of the ambient occlusion.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor(camera, normalBuffer, { blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.MULTIPLY, samples: samples = 9, rings: rings = 7, normalDepthBuffer: normalDepthBuffer = null, depthAwareUpsampling: depthAwareUpsampling = true, worldDistanceThreshold: worldDistanceThreshold, worldDistanceFalloff: worldDistanceFalloff, worldProximityThreshold: worldProximityThreshold, worldProximityFalloff: worldProximityFalloff, distanceThreshold: distanceThreshold = 0.97, distanceFalloff: distanceFalloff = 0.03, rangeThreshold: rangeThreshold = 5e-4, rangeFalloff: rangeFalloff = 1e-3, minRadiusScale: minRadiusScale = 0.1, luminanceInfluence: luminanceInfluence = 0.7, radius: radius = 0.1825, intensity: intensity = 1, bias: bias = 0.025, fade: fade = 0.01, color: color2 = null, resolutionScale: resolutionScale = 1, width: width = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, height: height = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("SSAOEffect", $fe721963ebf18f1b$var$ssao_default3, {
            blendFunction: blendFunction,
            attributes: $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH,
            defines: /* @__PURE__ */ new Map([
                [
                    "THRESHOLD",
                    "0.997"
                ]
            ]),
            uniforms: /* @__PURE__ */ new Map([
                [
                    "aoBuffer",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "normalDepthBuffer",
                    new (0, $ilwiq.Uniform)(normalDepthBuffer)
                ],
                [
                    "luminanceInfluence",
                    new (0, $ilwiq.Uniform)(luminanceInfluence)
                ],
                [
                    "color",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "intensity",
                    new (0, $ilwiq.Uniform)(intensity)
                ],
                [
                    "scale",
                    new (0, $ilwiq.Uniform)(0)
                ]
            ])
        });
        this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTarget.texture.name = "AO.Target";
        this.uniforms.get("aoBuffer").value = this.renderTarget.texture;
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.camera = camera;
        this.depthDownsamplingPass = new $fe721963ebf18f1b$export$eb8020324d924933({
            normalBuffer: normalBuffer,
            resolutionScale: resolutionScale
        });
        this.depthDownsamplingPass.enabled = normalDepthBuffer === null;
        this.ssaoPass = new $fe721963ebf18f1b$export$c55093fd4f9e42f0(new $fe721963ebf18f1b$export$b3b89c0d91a017a5(camera));
        const noiseTexture = new $fe721963ebf18f1b$export$2d9c702b3963e69c($fe721963ebf18f1b$var$NOISE_TEXTURE_SIZE, $fe721963ebf18f1b$var$NOISE_TEXTURE_SIZE, (0, $ilwiq.RGBAFormat));
        noiseTexture.wrapS = noiseTexture.wrapT = (0, $ilwiq.RepeatWrapping);
        const ssaoMaterial = this.ssaoMaterial;
        ssaoMaterial.normalBuffer = normalBuffer;
        ssaoMaterial.noiseTexture = noiseTexture;
        ssaoMaterial.minRadiusScale = minRadiusScale;
        ssaoMaterial.samples = samples;
        ssaoMaterial.radius = radius;
        ssaoMaterial.rings = rings;
        ssaoMaterial.fade = fade;
        ssaoMaterial.bias = bias;
        ssaoMaterial.distanceThreshold = distanceThreshold;
        ssaoMaterial.distanceFalloff = distanceFalloff;
        ssaoMaterial.proximityThreshold = rangeThreshold;
        ssaoMaterial.proximityFalloff = rangeFalloff;
        if (worldDistanceThreshold !== void 0) ssaoMaterial.worldDistanceThreshold = worldDistanceThreshold;
        if (worldDistanceFalloff !== void 0) ssaoMaterial.worldDistanceFalloff = worldDistanceFalloff;
        if (worldProximityThreshold !== void 0) ssaoMaterial.worldProximityThreshold = worldProximityThreshold;
        if (worldProximityFalloff !== void 0) ssaoMaterial.worldProximityFalloff = worldProximityFalloff;
        if (normalDepthBuffer !== null) {
            this.ssaoMaterial.normalDepthBuffer = normalDepthBuffer;
            this.defines.set("NORMAL_DEPTH", "1");
        }
        this.depthAwareUpsampling = depthAwareUpsampling;
        this.color = color2;
    }
    set mainCamera(value) {
        this.camera = value;
        this.ssaoMaterial.copyCameraSettings(value);
    }
    /**
   * Sets the normal buffer.
   *
   * @type {Texture}
   */ get normalBuffer() {
        return this.ssaoMaterial.normalBuffer;
    }
    set normalBuffer(value) {
        this.ssaoMaterial.normalBuffer = value;
        this.depthDownsamplingPass.fullscreenMaterial.normalBuffer = value;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * The SSAO material.
   *
   * @type {SSAOMaterial}
   */ get ssaoMaterial() {
        return this.ssaoPass.fullscreenMaterial;
    }
    /**
   * Returns the SSAO material.
   *
   * @deprecated Use ssaoMaterial instead.
   * @return {SSAOMaterial} The material.
   */ getSSAOMaterial() {
        return this.ssaoMaterial;
    }
    /**
   * The amount of occlusion samples per pixel.
   *
   * @type {Number}
   * @deprecated Use ssaoMaterial.samples instead.
   */ get samples() {
        return this.ssaoMaterial.samples;
    }
    set samples(value) {
        this.ssaoMaterial.samples = value;
    }
    /**
   * The amount of spiral turns in the occlusion sampling pattern.
   *
   * @type {Number}
   * @deprecated Use ssaoMaterial.rings instead.
   */ get rings() {
        return this.ssaoMaterial.rings;
    }
    set rings(value) {
        this.ssaoMaterial.rings = value;
    }
    /**
   * The occlusion sampling radius.
   *
   * @type {Number}
   * @deprecated Use ssaoMaterial.radius instead.
   */ get radius() {
        return this.ssaoMaterial.radius;
    }
    set radius(value) {
        this.ssaoMaterial.radius = value;
    }
    /**
   * Indicates whether depth-aware upsampling is enabled.
   *
   * @type {Boolean}
   */ get depthAwareUpsampling() {
        return this.defines.has("DEPTH_AWARE_UPSAMPLING");
    }
    set depthAwareUpsampling(value) {
        if (this.depthAwareUpsampling !== value) {
            if (value) this.defines.set("DEPTH_AWARE_UPSAMPLING", "1");
            else this.defines.delete("DEPTH_AWARE_UPSAMPLING");
            this.setChanged();
        }
    }
    /**
   * Indicates whether depth-aware upsampling is enabled.
   *
   * @deprecated Use depthAwareUpsampling instead.
   * @return {Boolean} Whether depth-aware upsampling is enabled.
   */ isDepthAwareUpsamplingEnabled() {
        return this.depthAwareUpsampling;
    }
    /**
   * Enables or disables depth-aware upsampling.
   *
   * @deprecated Use depthAwareUpsampling instead.
   * @param {Boolean} value - Whether depth-aware upsampling should be enabled.
   */ setDepthAwareUpsamplingEnabled(value) {
        this.depthAwareUpsampling = value;
    }
    /**
   * Indicates whether distance-based radius scaling is enabled.
   *
   * @type {Boolean}
   * @deprecated
   */ get distanceScaling() {
        return true;
    }
    set distanceScaling(value) {}
    /**
   * The color of the ambient occlusion. Set to `null` to disable.
   *
   * @type {Color}
   */ get color() {
        return this.uniforms.get("color").value;
    }
    set color(value) {
        const uniforms = this.uniforms;
        const defines = this.defines;
        if (value !== null) {
            if (defines.has("COLORIZE")) uniforms.get("color").value.set(value);
            else {
                defines.set("COLORIZE", "1");
                uniforms.get("color").value = new (0, $ilwiq.Color)(value);
                this.setChanged();
            }
        } else if (defines.has("COLORIZE")) {
            defines.delete("COLORIZE");
            uniforms.get("color").value = null;
            this.setChanged();
        }
    }
    /**
   * The luminance influence factor. Range: [0.0, 1.0].
   *
   * @type {Boolean}
   */ get luminanceInfluence() {
        return this.uniforms.get("luminanceInfluence").value;
    }
    set luminanceInfluence(value) {
        this.uniforms.get("luminanceInfluence").value = value;
    }
    /**
   * The intensity.
   *
   * @type {Number}
   */ get intensity() {
        return this.uniforms.get("intensity").value;
    }
    set intensity(value) {
        this.uniforms.get("intensity").value = value;
    }
    /**
   * Returns the color of the ambient occlusion.
   *
   * @deprecated Use color instead.
   * @return {Color} The color.
   */ getColor() {
        return this.color;
    }
    /**
   * Sets the color of the ambient occlusion. Set to `null` to disable colorization.
   *
   * @deprecated Use color instead.
   * @param {Color} value - The color.
   */ setColor(value) {
        this.color = value;
    }
    /**
   * Sets the occlusion distance cutoff.
   *
   * @deprecated Use ssaoMaterial instead.
   * @param {Number} threshold - The distance threshold. Range [0.0, 1.0].
   * @param {Number} falloff - The falloff. Range [0.0, 1.0].
   */ setDistanceCutoff(threshold, falloff) {
        this.ssaoMaterial.distanceThreshold = threshold;
        this.ssaoMaterial.distanceFalloff = falloff;
    }
    /**
   * Sets the occlusion proximity cutoff.
   *
   * @deprecated Use ssaoMaterial instead.
   * @param {Number} threshold - The proximity threshold. Range [0.0, 1.0].
   * @param {Number} falloff - The falloff. Range [0.0, 1.0].
   */ setProximityCutoff(threshold, falloff) {
        this.ssaoMaterial.proximityThreshold = threshold;
        this.ssaoMaterial.proximityFalloff = falloff;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthDownsamplingPass.setDepthTexture(depthTexture, depthPacking);
        this.ssaoMaterial.depthBuffer = depthTexture;
        this.ssaoMaterial.depthPacking = depthPacking;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const renderTarget = this.renderTarget;
        if (this.depthDownsamplingPass.enabled) this.depthDownsamplingPass.render(renderer);
        this.ssaoPass.render(renderer, null, renderTarget);
    }
    /**
   * Sets the size.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.ssaoMaterial.copyCameraSettings(this.camera);
        this.ssaoMaterial.setSize(w, h);
        this.renderTarget.setSize(w, h);
        this.depthDownsamplingPass.resolution.scale = resolution.scale;
        this.depthDownsamplingPass.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        try {
            let normalDepthBuffer = this.uniforms.get("normalDepthBuffer").value;
            if (normalDepthBuffer === null) {
                this.depthDownsamplingPass.initialize(renderer, alpha, frameBufferType);
                normalDepthBuffer = this.depthDownsamplingPass.texture;
                this.uniforms.get("normalDepthBuffer").value = normalDepthBuffer;
                this.ssaoMaterial.normalDepthBuffer = normalDepthBuffer;
                this.defines.set("NORMAL_DEPTH", "1");
            }
        } catch (e) {
            this.depthDownsamplingPass.enabled = false;
        }
    }
};
// src/effects/glsl/texture.frag
var $fe721963ebf18f1b$var$texture_default = "#ifdef TEXTURE_PRECISION_HIGH\nuniform mediump sampler2D map;\n#else\nuniform lowp sampler2D map;\n#endif\nvarying vec2 vUv2;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){\n#ifdef UV_TRANSFORM\nvec4 texel=texture2D(map,vUv2);\n#else\nvec4 texel=texture2D(map,uv);\n#endif\noutputColor=TEXEL;}";
// src/effects/glsl/texture.vert
var $fe721963ebf18f1b$var$texture_default2 = "#ifdef ASPECT_CORRECTION\nuniform float scale;\n#else\nuniform mat3 uvTransform;\n#endif\nvarying vec2 vUv2;void mainSupport(const in vec2 uv){\n#ifdef ASPECT_CORRECTION\nvUv2=uv*vec2(aspect,1.0)*scale;\n#else\nvUv2=(uvTransform*vec3(uv,1.0)).xy;\n#endif\n}";
// src/effects/TextureEffect.js
var $fe721963ebf18f1b$export$d1c9dd073fa6a2a3 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new texture effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Texture} [options.texture] - A texture.
   * @param {Boolean} [options.aspectCorrection=false] - Deprecated. Adjust the texture's offset, repeat and center instead.
   */ constructor({ blendFunction: blendFunction, texture: texture = null, aspectCorrection: aspectCorrection = false } = {}){
        super("TextureEffect", $fe721963ebf18f1b$var$texture_default, {
            blendFunction: blendFunction,
            defines: /* @__PURE__ */ new Map([
                [
                    "TEXEL",
                    "texel"
                ]
            ]),
            uniforms: /* @__PURE__ */ new Map([
                [
                    "map",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "scale",
                    new (0, $ilwiq.Uniform)(1)
                ],
                [
                    "uvTransform",
                    new (0, $ilwiq.Uniform)(null)
                ]
            ])
        });
        this.texture = texture;
        this.aspectCorrection = aspectCorrection;
    }
    /**
   * The texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.uniforms.get("map").value;
    }
    set texture(value) {
        const prevTexture = this.texture;
        const uniforms = this.uniforms;
        const defines = this.defines;
        if (prevTexture !== value) {
            uniforms.get("map").value = value;
            uniforms.get("uvTransform").value = value.matrix;
            defines.delete("TEXTURE_PRECISION_HIGH");
            if (value !== null) {
                if (value.matrixAutoUpdate) {
                    defines.set("UV_TRANSFORM", "1");
                    this.setVertexShader($fe721963ebf18f1b$var$texture_default2);
                } else {
                    defines.delete("UV_TRANSFORM");
                    this.setVertexShader(null);
                }
                if (value.type !== (0, $ilwiq.UnsignedByteType)) defines.set("TEXTURE_PRECISION_HIGH", "1");
                if (prevTexture === null || prevTexture.type !== value.type || prevTexture.encoding !== value.encoding) this.setChanged();
            }
        }
    }
    /**
   * Returns the texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.texture;
    }
    /**
   * Sets the texture.
   *
   * @deprecated Use texture instead.
   * @param {Texture} value - The texture.
   */ setTexture(value) {
        this.texture = value;
    }
    /**
   * Indicates whether aspect correction is enabled.
   *
   * @type {Number}
   * @deprecated Adjust the texture's offset, repeat, rotation and center instead.
   */ get aspectCorrection() {
        return this.defines.has("ASPECT_CORRECTION");
    }
    set aspectCorrection(value) {
        if (this.aspectCorrection !== value) {
            if (value) this.defines.set("ASPECT_CORRECTION", "1");
            else this.defines.delete("ASPECT_CORRECTION");
            this.setChanged();
        }
    }
    /**
   * Indicates whether the texture UV coordinates will be transformed using the transformation matrix of the texture.
   *
   * @type {Boolean}
   * @deprecated Use texture.matrixAutoUpdate instead.
   */ get uvTransform() {
        const texture = this.texture;
        return texture !== null && texture.matrixAutoUpdate;
    }
    set uvTransform(value) {
        const texture = this.texture;
        if (texture !== null) texture.matrixAutoUpdate = value;
    }
    /**
   * Sets the swizzles that will be applied to the components of a texel before it is written to the output color.
   *
   * @param {ColorChannel} r - The swizzle for the `r` component.
   * @param {ColorChannel} [g=r] - The swizzle for the `g` component.
   * @param {ColorChannel} [b=r] - The swizzle for the `b` component.
   * @param {ColorChannel} [a=r] - The swizzle for the `a` component.
   */ setTextureSwizzleRGBA(r, g = r, b = r, a = r) {
        const rgba = "rgba";
        let swizzle = "";
        if (r !== $fe721963ebf18f1b$export$e8b1230a2d7ba080.RED || g !== $fe721963ebf18f1b$export$e8b1230a2d7ba080.GREEN || b !== $fe721963ebf18f1b$export$e8b1230a2d7ba080.BLUE || a !== $fe721963ebf18f1b$export$e8b1230a2d7ba080.ALPHA) swizzle = [
            ".",
            rgba[r],
            rgba[g],
            rgba[b],
            rgba[a]
        ].join("");
        this.defines.set("TEXEL", "texel" + swizzle);
        this.setChanged();
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        if (this.texture.matrixAutoUpdate) this.texture.updateMatrix();
    }
};
// src/materials/glsl/convolution.tilt-shift.frag
var $fe721963ebf18f1b$var$convolution_tilt_shift_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\nuniform vec4 maskParams;varying vec2 vUv;varying vec2 vUv2;varying vec2 vOffset;float linearGradientMask(const in float x){return smoothstep(maskParams.x,maskParams.y,x)-smoothstep(maskParams.w,maskParams.z,x);}void main(){vec2 dUv=vOffset*(1.0-linearGradientMask(vUv2.y));vec4 sum=texture2D(inputBuffer,vec2(vUv.x-dUv.x,vUv.y+dUv.y));sum+=texture2D(inputBuffer,vec2(vUv.x+dUv.x,vUv.y+dUv.y));sum+=texture2D(inputBuffer,vec2(vUv.x+dUv.x,vUv.y-dUv.y));sum+=texture2D(inputBuffer,vec2(vUv.x-dUv.x,vUv.y-dUv.y));gl_FragColor=sum*0.25;\n#include <colorspace_fragment>\n}";
// src/materials/glsl/convolution.tilt-shift.vert
var $fe721963ebf18f1b$var$convolution_tilt_shift_default2 = "uniform vec4 texelSize;uniform float kernel;uniform float scale;uniform float aspect;uniform vec2 rotation;varying vec2 vUv;varying vec2 vUv2;varying vec2 vOffset;void main(){vec2 uv=position.xy*0.5+0.5;vUv=uv;vUv2=(uv-0.5)*2.0*vec2(aspect,1.0);vUv2=vec2(dot(rotation,vUv2),dot(rotation,vec2(vUv2.y,-vUv2.x)));vOffset=(texelSize.xy*vec2(kernel)+texelSize.zw)*scale;gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/TiltShiftBlurMaterial.js
var $fe721963ebf18f1b$export$207fd7140c306e23 = class extends $fe721963ebf18f1b$export$c69ac3f2757c20a {
    /**
   * Constructs a new tilt shift blur material.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.offset=0.0] - The relative offset of the focus area.
   * @param {Number} [options.rotation=0.0] - The rotation of the focus area in radians.
   * @param {Number} [options.focusArea=0.4] - The relative size of the focus area.
   * @param {Number} [options.feather=0.3] - The softness of the focus area edges.
   */ constructor({ kernelSize: kernelSize = $fe721963ebf18f1b$export$543b1e4815577d06.MEDIUM, offset: offset = 0, rotation: rotation = 0, focusArea: focusArea = 0.4, feather: feather = 0.3 } = {}){
        super();
        this.fragmentShader = $fe721963ebf18f1b$var$convolution_tilt_shift_default;
        this.vertexShader = $fe721963ebf18f1b$var$convolution_tilt_shift_default2;
        this.kernelSize = kernelSize;
        this.uniforms.aspect = new (0, $ilwiq.Uniform)(1);
        this.uniforms.rotation = new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)());
        this.uniforms.maskParams = new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector4)());
        this._offset = offset;
        this._focusArea = focusArea;
        this._feather = feather;
        this.rotation = rotation;
        this.updateParams();
    }
    /**
   * The relative offset of the focus area.
   *
   * @private
   */ updateParams() {
        const params = this.uniforms.maskParams.value;
        const a = Math.max(this.focusArea, 0);
        const b = Math.max(a - this.feather, 0);
        params.set(this.offset - a, this.offset - b, this.offset + a, this.offset + b);
    }
    /**
   * The rotation of the focus area in radians.
   *
   * @type {Number}
   */ get rotation() {
        return Math.acos(this.uniforms.rotation.value.x);
    }
    set rotation(value) {
        this.uniforms.rotation.value.set(Math.cos(value), Math.sin(value));
    }
    /**
   * The relative offset of the focus area.
   *
   * @type {Number}
   */ get offset() {
        return this._offset;
    }
    set offset(value) {
        this._offset = value;
        this.updateParams();
    }
    /**
   * The relative size of the focus area.
   *
   * @type {Number}
   */ get focusArea() {
        return this._focusArea;
    }
    set focusArea(value) {
        this._focusArea = value;
        this.updateParams();
    }
    /**
   * The softness of the focus area edges.
   *
   * @type {Number}
   */ get feather() {
        return this._feather;
    }
    set feather(value) {
        this._feather = value;
        this.updateParams();
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        super.setSize(width, height);
        this.uniforms.aspect.value = width / height;
    }
};
// src/passes/TiltShiftBlurPass.js
var $fe721963ebf18f1b$export$4c0a27a0f0e81f27 = class extends $fe721963ebf18f1b$export$657273fee9302035 {
    /**
   * Constructs a new Kawase blur pass.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.offset=0.0] - The relative offset of the focus area.
   * @param {Number} [options.rotation=0.0] - The rotation of the focus area in radians.
   * @param {Number} [options.focusArea=0.4] - The relative size of the focus area.
   * @param {Number} [options.feather=0.3] - The softness of the focus area edges.
   * @param {KernelSize} [options.kernelSize=KernelSize.MEDIUM] - The blur kernel size.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   */ constructor({ offset: offset = 0, rotation: rotation = 0, focusArea: focusArea = 0.4, feather: feather = 0.3, kernelSize: kernelSize = $fe721963ebf18f1b$export$543b1e4815577d06.MEDIUM, resolutionScale: resolutionScale = 0.5, resolutionX: resolutionX = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionY: resolutionY = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE } = {}){
        super({
            kernelSize: kernelSize,
            resolutionScale: resolutionScale,
            resolutionX: resolutionX,
            resolutionY: resolutionY
        });
        this.blurMaterial = new $fe721963ebf18f1b$export$207fd7140c306e23({
            kernelSize: kernelSize,
            offset: offset,
            rotation: rotation,
            focusArea: focusArea,
            feather: feather
        });
    }
};
// src/effects/glsl/tilt-shift.frag
var $fe721963ebf18f1b$var$tilt_shift_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D map;\n#else\nuniform lowp sampler2D map;\n#endif\nuniform vec2 maskParams;varying vec2 vUv2;float linearGradientMask(const in float x){return step(maskParams.x,x)-step(maskParams.y,x);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){float mask=linearGradientMask(vUv2.y);vec4 texel=texture2D(map,uv);outputColor=mix(texel,inputColor,mask);}";
// src/effects/glsl/tilt-shift.vert
var $fe721963ebf18f1b$var$tilt_shift_default2 = "uniform vec2 rotation;varying vec2 vUv2;void mainSupport(const in vec2 uv){vUv2=(uv-0.5)*2.0*vec2(aspect,1.0);vUv2=vec2(dot(rotation,vUv2),dot(rotation,vec2(vUv2.y,-vUv2.x)));}";
// src/effects/TiltShiftEffect.js
var $fe721963ebf18f1b$export$c658e8e07b156fbc = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new tilt shift Effect
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.offset=0.0] - The relative offset of the focus area.
   * @param {Number} [options.rotation=0.0] - The rotation of the focus area in radians.
   * @param {Number} [options.focusArea=0.4] - The relative size of the focus area.
   * @param {Number} [options.feather=0.3] - The softness of the focus area edges.
   * @param {Number} [options.bias=0.06] - Deprecated.
   * @param {KernelSize} [options.kernelSize=KernelSize.MEDIUM] - The blur kernel size.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   */ constructor({ blendFunction: blendFunction, offset: offset = 0, rotation: rotation = 0, focusArea: focusArea = 0.4, feather: feather = 0.3, kernelSize: kernelSize = $fe721963ebf18f1b$export$543b1e4815577d06.MEDIUM, resolutionScale: resolutionScale = 0.5, resolutionX: resolutionX = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionY: resolutionY = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE } = {}){
        super("TiltShiftEffect", $fe721963ebf18f1b$var$tilt_shift_default, {
            vertexShader: $fe721963ebf18f1b$var$tilt_shift_default2,
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "rotation",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)())
                ],
                [
                    "maskParams",
                    new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)())
                ],
                [
                    "map",
                    new (0, $ilwiq.Uniform)(null)
                ]
            ])
        });
        this._offset = offset;
        this._focusArea = focusArea;
        this._feather = feather;
        this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTarget.texture.name = "TiltShift.Target";
        this.uniforms.get("map").value = this.renderTarget.texture;
        this.blurPass = new $fe721963ebf18f1b$export$4c0a27a0f0e81f27({
            kernelSize: kernelSize,
            resolutionScale: resolutionScale,
            resolutionX: resolutionX,
            resolutionY: resolutionY,
            offset: offset,
            rotation: rotation,
            focusArea: focusArea,
            feather: feather
        });
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.rotation = rotation;
        this.updateParams();
    }
    /**
   * Updates the mask params.
   *
   * @private
   */ updateParams() {
        const params = this.uniforms.get("maskParams").value;
        const x = Math.max(this.focusArea - this.feather, 0);
        params.set(this.offset - x, this.offset + x);
    }
    /**
   * The rotation of the focus area in radians.
   *
   * @type {Number}
   */ get rotation() {
        return Math.acos(this.uniforms.get("rotation").value.x);
    }
    set rotation(value) {
        this.uniforms.get("rotation").value.set(Math.cos(value), Math.sin(value));
        this.blurPass.blurMaterial.rotation = value;
    }
    /**
   * The relative offset of the focus area.
   *
   * @type {Number}
   */ get offset() {
        return this._offset;
    }
    set offset(value) {
        this._offset = value;
        this.blurPass.blurMaterial.offset = value;
        this.updateParams();
    }
    /**
   * The relative size of the focus area.
   *
   * @type {Number}
   */ get focusArea() {
        return this._focusArea;
    }
    set focusArea(value) {
        this._focusArea = value;
        this.blurPass.blurMaterial.focusArea = value;
        this.updateParams();
    }
    /**
   * The softness of the focus area edges.
   *
   * @type {Number}
   */ get feather() {
        return this._feather;
    }
    set feather(value) {
        this._feather = value;
        this.blurPass.blurMaterial.feather = value;
        this.updateParams();
    }
    /**
   * A blend bias.
   *
   * @type {Number}
   * @deprecated
   */ get bias() {
        return 0;
    }
    set bias(value) {}
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        this.blurPass.render(renderer, inputBuffer, this.renderTarget);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
        this.blurPass.resolution.copy(resolution);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.blurPass.initialize(renderer, alpha, frameBufferType);
        if (frameBufferType !== void 0) {
            this.renderTarget.texture.type = frameBufferType;
            if (renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) this.renderTarget.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
        }
    }
};
// src/materials/glsl/adaptive-luminance.frag
var $fe721963ebf18f1b$var$adaptive_luminance_default = "#include <packing>\n#define packFloatToRGBA(v) packDepthToRGBA(v)\n#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)\nuniform lowp sampler2D luminanceBuffer0;uniform lowp sampler2D luminanceBuffer1;uniform float minLuminance;uniform float deltaTime;uniform float tau;varying vec2 vUv;void main(){float l0=unpackRGBAToFloat(texture2D(luminanceBuffer0,vUv));\n#if __VERSION__ < 300\nfloat l1=texture2DLodEXT(luminanceBuffer1,vUv,MIP_LEVEL_1X1).r;\n#else\nfloat l1=textureLod(luminanceBuffer1,vUv,MIP_LEVEL_1X1).r;\n#endif\nl0=max(minLuminance,l0);l1=max(minLuminance,l1);float adaptedLum=l0+(l1-l0)*(1.0-exp(-deltaTime*tau));gl_FragColor=(adaptedLum==1.0)?vec4(1.0):packFloatToRGBA(adaptedLum);}";
// src/materials/AdaptiveLuminanceMaterial.js
var $fe721963ebf18f1b$export$1756588d8d0bb63e = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new adaptive luminance material.
   */ constructor(){
        super({
            name: "AdaptiveLuminanceMaterial",
            defines: {
                MIP_LEVEL_1X1: "0.0"
            },
            uniforms: {
                luminanceBuffer0: new (0, $ilwiq.Uniform)(null),
                luminanceBuffer1: new (0, $ilwiq.Uniform)(null),
                minLuminance: new (0, $ilwiq.Uniform)(0.01),
                deltaTime: new (0, $ilwiq.Uniform)(0),
                tau: new (0, $ilwiq.Uniform)(1)
            },
            extensions: {
                shaderTextureLOD: true
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$adaptive_luminance_default,
            vertexShader: $fe721963ebf18f1b$var$common_default
        });
    }
    /**
   * The primary luminance buffer that contains the downsampled average luminance.
   *
   * @type {Texture}
   */ set luminanceBuffer0(value) {
        this.uniforms.luminanceBuffer0.value = value;
    }
    /**
   * Sets the primary luminance buffer that contains the downsampled average luminance.
   *
   * @deprecated Use luminanceBuffer0 instead.
   * @param {Texture} value - The buffer.
   */ setLuminanceBuffer0(value) {
        this.uniforms.luminanceBuffer0.value = value;
    }
    /**
   * The secondary luminance buffer.
   *
   * @type {Texture}
   */ set luminanceBuffer1(value) {
        this.uniforms.luminanceBuffer1.value = value;
    }
    /**
   * Sets the secondary luminance buffer.
   *
   * @deprecated Use luminanceBuffer1 instead.
   * @param {Texture} value - The buffer.
   */ setLuminanceBuffer1(value) {
        this.uniforms.luminanceBuffer1.value = value;
    }
    /**
   * The 1x1 mipmap level.
   *
   * This level is used to identify the smallest mipmap of the primary luminance buffer.
   *
   * @type {Number}
   */ set mipLevel1x1(value) {
        this.defines.MIP_LEVEL_1X1 = value.toFixed(1);
        this.needsUpdate = true;
    }
    /**
   * Sets the 1x1 mipmap level.
   *
   * @deprecated Use mipLevel1x1 instead.
   * @param {Number} value - The level.
   */ setMipLevel1x1(value) {
        this.mipLevel1x1 = value;
    }
    /**
   * The delta time.
   *
   * @type {Number}
   */ set deltaTime(value) {
        this.uniforms.deltaTime.value = value;
    }
    /**
   * Sets the delta time.
   *
   * @deprecated Use deltaTime instead.
   * @param {Number} value - The delta time.
   */ setDeltaTime(value) {
        this.uniforms.deltaTime.value = value;
    }
    /**
   * The lowest possible luminance value.
   *
   * @type {Number}
   */ get minLuminance() {
        return this.uniforms.minLuminance.value;
    }
    set minLuminance(value) {
        this.uniforms.minLuminance.value = value;
    }
    /**
   * Returns the lowest possible luminance value.
   *
   * @deprecated Use minLuminance instead.
   * @return {Number} The minimum luminance.
   */ getMinLuminance() {
        return this.uniforms.minLuminance.value;
    }
    /**
   * Sets the minimum luminance.
   *
   * @deprecated Use minLuminance instead.
   * @param {Number} value - The minimum luminance.
   */ setMinLuminance(value) {
        this.uniforms.minLuminance.value = value;
    }
    /**
   * The luminance adaptation rate.
   *
   * @type {Number}
   */ get adaptationRate() {
        return this.uniforms.tau.value;
    }
    set adaptationRate(value) {
        this.uniforms.tau.value = value;
    }
    /**
   * Returns the luminance adaptation rate.
   *
   * @deprecated Use adaptationRate instead.
   * @return {Number} The adaptation rate.
   */ getAdaptationRate() {
        return this.uniforms.tau.value;
    }
    /**
   * Sets the luminance adaptation rate.
   *
   * @deprecated Use adaptationRate instead.
   * @param {Number} value - The adaptation rate.
   */ setAdaptationRate(value) {
        this.uniforms.tau.value = value;
    }
};
// src/passes/AdaptiveLuminancePass.js
var $fe721963ebf18f1b$export$cefb3791de100f47 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new adaptive luminance pass.
   *
   * @param {Texture} luminanceBuffer - A buffer that contains the current scene luminance.
   * @param {Object} [options] - The options.
   * @param {Number} [options.minLuminance=0.01] - The minimum luminance.
   * @param {Number} [options.adaptationRate=1.0] - The luminance adaptation rate.
   */ constructor(luminanceBuffer, { minLuminance: minLuminance = 0.01, adaptationRate: adaptationRate = 1 } = {}){
        super("AdaptiveLuminancePass");
        this.fullscreenMaterial = new $fe721963ebf18f1b$export$1756588d8d0bb63e();
        this.needsSwap = false;
        this.renderTargetPrevious = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            minFilter: (0, $ilwiq.NearestFilter),
            magFilter: (0, $ilwiq.NearestFilter),
            depthBuffer: false
        });
        this.renderTargetPrevious.texture.name = "Luminance.Previous";
        const material = this.fullscreenMaterial;
        material.luminanceBuffer0 = this.renderTargetPrevious.texture;
        material.luminanceBuffer1 = luminanceBuffer;
        material.minLuminance = minLuminance;
        material.adaptationRate = adaptationRate;
        this.renderTargetAdapted = this.renderTargetPrevious.clone();
        this.renderTargetAdapted.texture.name = "Luminance.Adapted";
        this.copyPass = new $fe721963ebf18f1b$export$ec9e16bd0f76e979(this.renderTargetPrevious, false);
    }
    /**
   * The adaptive luminance texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTargetAdapted.texture;
    }
    /**
   * Returns the adaptive 1x1 luminance texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTargetAdapted.texture;
    }
    /**
   * Sets the 1x1 mipmap level.
   *
   * This level is used to identify the smallest mipmap of the main luminance texture which contains the downsampled
   * average scene luminance.
   *
   * @type {Number}
   * @deprecated Use fullscreenMaterial.mipLevel1x1 instead.
   */ set mipLevel1x1(value) {
        this.fullscreenMaterial.mipLevel1x1 = value;
    }
    /**
   * The luminance adaptation rate.
   *
   * @type {Number}
   * @deprecated Use fullscreenMaterial.adaptationRate instead.
   */ get adaptationRate() {
        return this.fullscreenMaterial.adaptationRate;
    }
    /**
   * @type {Number}
   * @deprecated Use fullscreenMaterial.adaptationRate instead.
   */ set adaptationRate(value) {
        this.fullscreenMaterial.adaptationRate = value;
    }
    /**
   * Renders the scene normals.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        this.fullscreenMaterial.deltaTime = deltaTime;
        renderer.setRenderTarget(this.renderToScreen ? null : this.renderTargetAdapted);
        renderer.render(this.scene, this.camera);
        this.copyPass.render(renderer, this.renderTargetAdapted);
    }
};
// src/effects/glsl/tone-mapping.frag
var $fe721963ebf18f1b$var$tone_mapping_default = "#include <tonemapping_pars_fragment>\nuniform float whitePoint;\n#if TONE_MAPPING_MODE == 2 || TONE_MAPPING_MODE == 3\nuniform float middleGrey;\n#if TONE_MAPPING_MODE == 3\nuniform lowp sampler2D luminanceBuffer;\n#else\nuniform float averageLuminance;\n#endif\nvec3 Reinhard2ToneMapping(vec3 color){color*=toneMappingExposure;float l=luminance(color);\n#if TONE_MAPPING_MODE == 3\nfloat lumAvg=unpackRGBAToFloat(texture2D(luminanceBuffer,vec2(0.5)));\n#else\nfloat lumAvg=averageLuminance;\n#endif\nfloat lumScaled=(l*middleGrey)/max(lumAvg,1e-6);float lumCompressed=lumScaled*(1.0+lumScaled/(whitePoint*whitePoint));lumCompressed/=(1.0+lumScaled);return clamp(lumCompressed*color,0.0,1.0);}\n#elif TONE_MAPPING_MODE == 4\n#define A 0.15\n#define B 0.50\n#define C 0.10\n#define D 0.20\n#define E 0.02\n#define F 0.30\nvec3 Uncharted2Helper(const in vec3 x){return((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}vec3 Uncharted2ToneMapping(vec3 color){color*=toneMappingExposure;return clamp(Uncharted2Helper(color)/Uncharted2Helper(vec3(whitePoint)),0.0,1.0);}\n#endif\nvoid mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){\n#if TONE_MAPPING_MODE == 2 || TONE_MAPPING_MODE == 3\noutputColor=vec4(Reinhard2ToneMapping(inputColor.rgb),inputColor.a);\n#elif TONE_MAPPING_MODE == 4\noutputColor=vec4(Uncharted2ToneMapping(inputColor.rgb),inputColor.a);\n#else\noutputColor=vec4(toneMapping(inputColor.rgb),inputColor.a);\n#endif\n}";
// src/effects/ToneMappingEffect.js
var $fe721963ebf18f1b$export$6df7d6dd546cd57a = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new tone mapping effect.
   *
   * The additional parameters only affect the Reinhard2 operator.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Boolean} [options.adaptive=false] - Deprecated. Use mode instead.
   * @param {ToneMappingMode} [options.mode=ToneMappingMode.AGX] - The tone mapping mode.
   * @param {Number} [options.resolution=256] - The resolution of the luminance texture. Must be a power of two.
   * @param {Number} [options.maxLuminance=4.0] - Deprecated. Same as whitePoint.
   * @param {Number} [options.whitePoint=4.0] - The white point.
   * @param {Number} [options.middleGrey=0.6] - The middle grey factor.
   * @param {Number} [options.minLuminance=0.01] - The minimum luminance. Prevents very high exposure in dark scenes.
   * @param {Number} [options.averageLuminance=1.0] - The average luminance. Used for the non-adaptive Reinhard operator.
   * @param {Number} [options.adaptationRate=1.0] - The luminance adaptation rate.
   */ constructor({ blendFunction: blendFunction = $fe721963ebf18f1b$export$ea7520add44ba1b6.SRC, adaptive: adaptive = false, mode: mode = adaptive ? $fe721963ebf18f1b$export$f72cb1a914b4b608.REINHARD2_ADAPTIVE : $fe721963ebf18f1b$export$f72cb1a914b4b608.AGX, resolution: resolution = 256, maxLuminance: maxLuminance = 4, whitePoint: whitePoint = maxLuminance, middleGrey: middleGrey = 0.6, minLuminance: minLuminance = 0.01, averageLuminance: averageLuminance = 1, adaptationRate: adaptationRate = 1 } = {}){
        super("ToneMappingEffect", $fe721963ebf18f1b$var$tone_mapping_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "luminanceBuffer",
                    new (0, $ilwiq.Uniform)(null)
                ],
                [
                    "maxLuminance",
                    new (0, $ilwiq.Uniform)(maxLuminance)
                ],
                // Unused
                [
                    "whitePoint",
                    new (0, $ilwiq.Uniform)(whitePoint)
                ],
                [
                    "middleGrey",
                    new (0, $ilwiq.Uniform)(middleGrey)
                ],
                [
                    "averageLuminance",
                    new (0, $ilwiq.Uniform)(averageLuminance)
                ]
            ])
        });
        this.renderTargetLuminance = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            minFilter: (0, $ilwiq.LinearMipmapLinearFilter),
            depthBuffer: false
        });
        this.renderTargetLuminance.texture.generateMipmaps = true;
        this.renderTargetLuminance.texture.name = "Luminance";
        this.luminancePass = new $fe721963ebf18f1b$export$855ea63a754bfd18({
            renderTarget: this.renderTargetLuminance
        });
        this.adaptiveLuminancePass = new $fe721963ebf18f1b$export$cefb3791de100f47(this.luminancePass.texture, {
            minLuminance: minLuminance,
            adaptationRate: adaptationRate
        });
        this.uniforms.get("luminanceBuffer").value = this.adaptiveLuminancePass.texture;
        this.resolution = resolution;
        this.mode = mode;
    }
    /**
   * The tone mapping mode.
   *
   * @type {ToneMappingMode}
   */ get mode() {
        return Number(this.defines.get("TONE_MAPPING_MODE"));
    }
    set mode(value) {
        if (this.mode === value) return;
        const revision = (0, $ilwiq.REVISION).replace(/\D+/g, "");
        const cineonToneMapping = revision >= 168 ? "CineonToneMapping(texel)" : "OptimizedCineonToneMapping(texel)";
        this.defines.clear();
        this.defines.set("TONE_MAPPING_MODE", value.toFixed(0));
        switch(value){
            case $fe721963ebf18f1b$export$f72cb1a914b4b608.LINEAR:
                this.defines.set("toneMapping(texel)", "LinearToneMapping(texel)");
                break;
            case $fe721963ebf18f1b$export$f72cb1a914b4b608.REINHARD:
                this.defines.set("toneMapping(texel)", "ReinhardToneMapping(texel)");
                break;
            case $fe721963ebf18f1b$export$f72cb1a914b4b608.CINEON:
            case $fe721963ebf18f1b$export$f72cb1a914b4b608.OPTIMIZED_CINEON:
                this.defines.set("toneMapping(texel)", cineonToneMapping);
                break;
            case $fe721963ebf18f1b$export$f72cb1a914b4b608.ACES_FILMIC:
                this.defines.set("toneMapping(texel)", "ACESFilmicToneMapping(texel)");
                break;
            case $fe721963ebf18f1b$export$f72cb1a914b4b608.AGX:
                this.defines.set("toneMapping(texel)", "AgXToneMapping(texel)");
                break;
            case $fe721963ebf18f1b$export$f72cb1a914b4b608.NEUTRAL:
                this.defines.set("toneMapping(texel)", "NeutralToneMapping(texel)");
                break;
            default:
                this.defines.set("toneMapping(texel)", "texel");
                break;
        }
        this.adaptiveLuminancePass.enabled = value === $fe721963ebf18f1b$export$f72cb1a914b4b608.REINHARD2_ADAPTIVE;
        this.setChanged();
    }
    /**
   * Returns the current tone mapping mode.
   *
   * @deprecated Use mode instead.
   * @return {ToneMappingMode} The tone mapping mode.
   */ getMode() {
        return this.mode;
    }
    /**
   * Sets the tone mapping mode.
   *
   * @deprecated Use mode instead.
   * @param {ToneMappingMode} value - The tone mapping mode.
   */ setMode(value) {
        this.mode = value;
    }
    /**
   * The white point. Default is `4.0`.
   *
   * Only applies to Reinhard2 (Modified & Adaptive).
   *
   * @type {Number}
   */ get whitePoint() {
        return this.uniforms.get("whitePoint").value;
    }
    set whitePoint(value) {
        this.uniforms.get("whitePoint").value = value;
    }
    /**
   * The middle grey factor. Default is `0.6`.
   *
   * Only applies to Reinhard2 (Modified & Adaptive).
   *
   * @type {Number}
   */ get middleGrey() {
        return this.uniforms.get("middleGrey").value;
    }
    set middleGrey(value) {
        this.uniforms.get("middleGrey").value = value;
    }
    /**
   * The average luminance.
   *
   * Only applies to Reinhard2 (Modified).
   *
   * @type {Number}
   */ get averageLuminance() {
        return this.uniforms.get("averageLuminance").value;
    }
    set averageLuminance(value) {
        this.uniforms.get("averageLuminance").value = value;
    }
    /**
   * The adaptive luminance material.
   *
   * @type {AdaptiveLuminanceMaterial}
   */ get adaptiveLuminanceMaterial() {
        return this.adaptiveLuminancePass.fullscreenMaterial;
    }
    /**
   * Returns the adaptive luminance material.
   *
   * @deprecated Use adaptiveLuminanceMaterial instead.
   * @return {AdaptiveLuminanceMaterial} The material.
   */ getAdaptiveLuminanceMaterial() {
        return this.adaptiveLuminanceMaterial;
    }
    /**
   * The resolution of the luminance texture. Must be a power of two.
   *
   * @type {Number}
   */ get resolution() {
        return this.luminancePass.resolution.width;
    }
    set resolution(value) {
        const exponent = Math.max(0, Math.ceil(Math.log2(value)));
        const size = Math.pow(2, exponent);
        this.luminancePass.resolution.setPreferredSize(size, size);
        this.adaptiveLuminanceMaterial.mipLevel1x1 = exponent;
    }
    /**
   * Returns the resolution of the luminance texture.
   *
   * @deprecated Use resolution instead.
   * @return {Number} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Sets the resolution of the luminance texture. Must be a power of two.
   *
   * @deprecated Use resolution instead.
   * @param {Number} value - The resolution.
   */ setResolution(value) {
        this.resolution = value;
    }
    /**
   * Indicates whether this pass uses adaptive luminance.
   *
   * @type {Boolean}
   * @deprecated Use mode instead.
   */ get adaptive() {
        return this.mode === $fe721963ebf18f1b$export$f72cb1a914b4b608.REINHARD2_ADAPTIVE;
    }
    set adaptive(value) {
        this.mode = value ? $fe721963ebf18f1b$export$f72cb1a914b4b608.REINHARD2_ADAPTIVE : $fe721963ebf18f1b$export$f72cb1a914b4b608.REINHARD2;
    }
    /**
   * The luminance adaptation rate.
   *
   * @type {Number}
   * @deprecated Use adaptiveLuminanceMaterial.adaptationRate instead.
   */ get adaptationRate() {
        return this.adaptiveLuminanceMaterial.adaptationRate;
    }
    set adaptationRate(value) {
        this.adaptiveLuminanceMaterial.adaptationRate = value;
    }
    /**
   * @type {Number}
   * @deprecated
   */ get distinction() {
        console.warn(this.name, "distinction was removed.");
        return 1;
    }
    set distinction(value) {
        console.warn(this.name, "distinction was removed.");
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        if (this.adaptiveLuminancePass.enabled) {
            this.luminancePass.render(renderer, inputBuffer);
            this.adaptiveLuminancePass.render(renderer, null, null, deltaTime);
        }
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.adaptiveLuminancePass.initialize(renderer, alpha, frameBufferType);
    }
};
// src/effects/glsl/vignette.frag
var $fe721963ebf18f1b$var$vignette_default = "uniform float offset;uniform float darkness;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){const vec2 center=vec2(0.5);vec3 color=inputColor.rgb;\n#if VIGNETTE_TECHNIQUE == 0\nfloat d=distance(uv,center);color*=smoothstep(0.8,offset*0.799,d*(darkness+offset));\n#else\nvec2 coord=(uv-center)*vec2(offset);color=mix(color,vec3(1.0-darkness),dot(coord,coord));\n#endif\noutputColor=vec4(color,inputColor.a);}";
// src/effects/VignetteEffect.js
var $fe721963ebf18f1b$export$f32350b7e107bb62 = class extends $fe721963ebf18f1b$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new Vignette effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {VignetteTechnique} [options.technique=VignetteTechnique.DEFAULT] - The Vignette technique.
   * @param {Boolean} [options.eskil=false] - Deprecated. Use technique instead.
   * @param {Number} [options.offset=0.5] - The Vignette offset.
   * @param {Number} [options.darkness=0.5] - The Vignette darkness.
   */ constructor({ blendFunction: blendFunction, eskil: eskil = false, technique: technique = eskil ? $fe721963ebf18f1b$export$57fe020f9fbd56c7.ESKIL : $fe721963ebf18f1b$export$57fe020f9fbd56c7.DEFAULT, offset: offset = 0.5, darkness: darkness = 0.5 } = {}){
        super("VignetteEffect", $fe721963ebf18f1b$var$vignette_default, {
            blendFunction: blendFunction,
            defines: /* @__PURE__ */ new Map([
                [
                    "VIGNETTE_TECHNIQUE",
                    technique.toFixed(0)
                ]
            ]),
            uniforms: /* @__PURE__ */ new Map([
                [
                    "offset",
                    new (0, $ilwiq.Uniform)(offset)
                ],
                [
                    "darkness",
                    new (0, $ilwiq.Uniform)(darkness)
                ]
            ])
        });
    }
    /**
   * The Vignette technique.
   *
   * @type {VignetteTechnique}
   */ get technique() {
        return Number(this.defines.get("VIGNETTE_TECHNIQUE"));
    }
    set technique(value) {
        if (this.technique !== value) {
            this.defines.set("VIGNETTE_TECHNIQUE", value.toFixed(0));
            this.setChanged();
        }
    }
    /**
   * Indicates whether Eskil's Vignette technique is enabled.
   *
   * @type {Boolean}
   * @deprecated Use technique instead.
   */ get eskil() {
        return this.technique === $fe721963ebf18f1b$export$57fe020f9fbd56c7.ESKIL;
    }
    /**
   * Indicates whether Eskil's Vignette technique is enabled.
   *
   * @type {Boolean}
   * @deprecated Use technique instead.
   */ set eskil(value) {
        this.technique = value ? $fe721963ebf18f1b$export$57fe020f9fbd56c7.ESKIL : $fe721963ebf18f1b$export$57fe020f9fbd56c7.DEFAULT;
    }
    /**
   * Returns the Vignette technique.
   *
   * @deprecated Use technique instead.
   * @return {VignetteTechnique} The technique.
   */ getTechnique() {
        return this.technique;
    }
    /**
   * Sets the Vignette technique.
   *
   * @deprecated Use technique instead.
   * @param {VignetteTechnique} value - The technique.
   */ setTechnique(value) {
        this.technique = value;
    }
    /**
   * The Vignette offset.
   *
   * @type {Number}
   */ get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(value) {
        this.uniforms.get("offset").value = value;
    }
    /**
   * Returns the Vignette offset.
   *
   * @deprecated Use offset instead.
   * @return {Number} The offset.
   */ getOffset() {
        return this.offset;
    }
    /**
   * Sets the Vignette offset.
   *
   * @deprecated Use offset instead.
   * @param {Number} value - The offset.
   */ setOffset(value) {
        this.offset = value;
    }
    /**
   * The Vignette darkness.
   *
   * @type {Number}
   */ get darkness() {
        return this.uniforms.get("darkness").value;
    }
    set darkness(value) {
        this.uniforms.get("darkness").value = value;
    }
    /**
   * Returns the Vignette darkness.
   *
   * @deprecated Use darkness instead.
   * @return {Number} The darkness.
   */ getDarkness() {
        return this.darkness;
    }
    /**
   * Sets the Vignette darkness.
   *
   * @deprecated Use darkness instead.
   * @param {Number} value - The darkness.
   */ setDarkness(value) {
        this.darkness = value;
    }
};
var $fe721963ebf18f1b$export$cb134e582ee96ec4 = class extends (0, $ilwiq.Loader) {
    /**
   * Loads a LUT.
   *
   * @param {String} url - The URL of the 3dl-file.
   * @param {Function} [onLoad] - A callback that receives the loaded lookup texture.
   * @param {Function} [onProgress] - A progress callback that receives the XMLHttpRequest instance.
   * @param {Function} [onError] - An error callback that receives the URL of the file that failed to load.
   * @return {Promise<LookupTexture>} A promise that returns the lookup texture.
   */ load(url, onLoad = ()=>{}, onProgress = ()=>{}, onError = null) {
        const externalManager = this.manager;
        const internalManager = new (0, $ilwiq.LoadingManager)();
        const loader = new (0, $ilwiq.FileLoader)(internalManager);
        loader.setPath(this.path);
        loader.setResponseType("text");
        return new Promise((resolve, reject)=>{
            internalManager.onError = (url2)=>{
                externalManager.itemError(url2);
                if (onError !== null) {
                    onError(`Failed to load ${url2}`);
                    resolve();
                } else reject(`Failed to load ${url2}`);
            };
            externalManager.itemStart(url);
            loader.load(url, (data)=>{
                try {
                    const result = this.parse(data);
                    externalManager.itemEnd(url);
                    onLoad(result);
                    resolve(result);
                } catch (e) {
                    console.error(e);
                    internalManager.onError(url);
                }
            }, onProgress);
        });
    }
    /**
   * Parses the given data.
   *
   * @param {String} input - The LUT data.
   * @return {LookupTexture} The lookup texture.
   * @throws {Error} Fails if the data is invalid.
   */ parse(input) {
        const regExpGridInfo = /^[\d ]+$/m;
        const regExpDataPoints = /^([\d.e+-]+) +([\d.e+-]+) +([\d.e+-]+) *$/gm;
        let result = regExpGridInfo.exec(input);
        if (result === null) throw new Error("Missing grid information");
        const gridLines = result[0].trim().split(/\s+/g).map((n)=>Number(n));
        const gridStep = gridLines[1] - gridLines[0];
        const size = gridLines.length;
        const sizeSq = size ** 2;
        for(let i = 1, l = gridLines.length; i < l; ++i){
            if (gridStep !== gridLines[i] - gridLines[i - 1]) throw new Error("Inconsistent grid size");
        }
        const data = new Float32Array(size ** 3 * 4);
        let maxValue = 0;
        let index = 0;
        while((result = regExpDataPoints.exec(input)) !== null){
            const r = Number(result[1]);
            const g = Number(result[2]);
            const b = Number(result[3]);
            maxValue = Math.max(maxValue, r, g, b);
            const bLayer = index % size;
            const gLayer = Math.floor(index / size) % size;
            const rLayer = Math.floor(index / sizeSq) % size;
            const d4 = (bLayer * sizeSq + gLayer * size + rLayer) * 4;
            data[d4 + 0] = r;
            data[d4 + 1] = g;
            data[d4 + 2] = b;
            data[d4 + 3] = 1;
            ++index;
        }
        const bits = Math.ceil(Math.log2(maxValue));
        const maxBitValue = Math.pow(2, bits);
        for(let i = 0, l = data.length; i < l; i += 4){
            data[i + 0] /= maxBitValue;
            data[i + 1] /= maxBitValue;
            data[i + 2] /= maxBitValue;
        }
        return new $fe721963ebf18f1b$export$a3627e735a49df45(data, size);
    }
};
var $fe721963ebf18f1b$export$69bfa3b61900cd8b = class extends (0, $ilwiq.Loader) {
    /**
   * Loads a LUT.
   *
   * @param {String} url - The URL of the CUBE-file.
   * @param {Function} [onLoad] - A callback that receives the loaded lookup texture.
   * @param {Function} [onProgress] - A progress callback that receives the XMLHttpRequest instance.
   * @param {Function} [onError] - An error callback that receives the URL of the file that failed to load.
   * @return {Promise<LookupTexture>} A promise that returns the lookup texture.
   */ load(url, onLoad = ()=>{}, onProgress = ()=>{}, onError = null) {
        const externalManager = this.manager;
        const internalManager = new (0, $ilwiq.LoadingManager)();
        const loader = new (0, $ilwiq.FileLoader)(internalManager);
        loader.setPath(this.path);
        loader.setResponseType("text");
        return new Promise((resolve, reject)=>{
            internalManager.onError = (url2)=>{
                externalManager.itemError(url2);
                if (onError !== null) {
                    onError(`Failed to load ${url2}`);
                    resolve();
                } else reject(`Failed to load ${url2}`);
            };
            externalManager.itemStart(url);
            loader.load(url, (data)=>{
                try {
                    const result = this.parse(data);
                    externalManager.itemEnd(url);
                    onLoad(result);
                    resolve(result);
                } catch (e) {
                    console.error(e);
                    internalManager.onError(url);
                }
            }, onProgress);
        });
    }
    /**
   * Parses the given data.
   *
   * @param {String} input - The LUT data.
   * @return {LookupTexture} The lookup texture.
   * @throws {Error} Fails if the data is invalid.
   */ parse(input) {
        const regExpTitle = /TITLE +"([^"]*)"/;
        const regExpSize = /LUT_3D_SIZE +(\d+)/;
        const regExpDomainMin = /DOMAIN_MIN +([\d.]+) +([\d.]+) +([\d.]+)/;
        const regExpDomainMax = /DOMAIN_MAX +([\d.]+) +([\d.]+) +([\d.]+)/;
        const regExpDataPoints = /^([\d.e+-]+) +([\d.e+-]+) +([\d.e+-]+) *$/gm;
        let result = regExpTitle.exec(input);
        const title = result !== null ? result[1] : null;
        result = regExpSize.exec(input);
        if (result === null) throw new Error("Missing LUT_3D_SIZE information");
        const size = Number(result[1]);
        const data = new Float32Array(size ** 3 * 4);
        const domainMin = new (0, $ilwiq.Vector3)(0, 0, 0);
        const domainMax = new (0, $ilwiq.Vector3)(1, 1, 1);
        result = regExpDomainMin.exec(input);
        if (result !== null) domainMin.set(Number(result[1]), Number(result[2]), Number(result[3]));
        result = regExpDomainMax.exec(input);
        if (result !== null) domainMax.set(Number(result[1]), Number(result[2]), Number(result[3]));
        if (domainMin.x > domainMax.x || domainMin.y > domainMax.y || domainMin.z > domainMax.z) {
            domainMin.set(0, 0, 0);
            domainMax.set(1, 1, 1);
            throw new Error("Invalid input domain");
        }
        let i = 0;
        while((result = regExpDataPoints.exec(input)) !== null){
            data[i++] = Number(result[1]);
            data[i++] = Number(result[2]);
            data[i++] = Number(result[3]);
            data[i++] = 1;
        }
        const lut = new $fe721963ebf18f1b$export$a3627e735a49df45(data, size);
        lut.domainMin.copy(domainMin);
        lut.domainMax.copy(domainMax);
        if (title !== null) lut.name = title;
        return lut;
    }
};
var $fe721963ebf18f1b$export$aabc8868efe21aac = class extends (0, $ilwiq.Loader) {
    /**
   * Loads the SMAA data images.
   *
   * @param {Function} [onLoad] - A callback that receives the search image and area image as a pair.
   * @param {Function} [onError] - An error callback that receives the URL of the image that failed to load.
   * @return {Promise<Image[]>} A promise that returns the search image and area image as a pair.
   */ load(onLoad = ()=>{}, onError = null) {
        if (arguments.length === 4) {
            onLoad = arguments[1];
            onError = arguments[3];
        } else if (arguments.length === 3 || typeof arguments[0] !== "function") {
            onLoad = arguments[1];
            onError = null;
        }
        const externalManager = this.manager;
        const internalManager = new (0, $ilwiq.LoadingManager)();
        return new Promise((resolve, reject)=>{
            const searchImage = new Image();
            const areaImage = new Image();
            internalManager.onError = (url)=>{
                externalManager.itemError(url);
                if (onError !== null) {
                    onError(`Failed to load ${url}`);
                    resolve();
                } else reject(`Failed to load ${url}`);
            };
            internalManager.onLoad = ()=>{
                const result = [
                    searchImage,
                    areaImage
                ];
                onLoad(result);
                resolve(result);
            };
            searchImage.addEventListener("error", (e)=>{
                internalManager.itemError("smaa-search");
            });
            areaImage.addEventListener("error", (e)=>{
                internalManager.itemError("smaa-area");
            });
            searchImage.addEventListener("load", ()=>{
                externalManager.itemEnd("smaa-search");
                internalManager.itemEnd("smaa-search");
            });
            areaImage.addEventListener("load", ()=>{
                externalManager.itemEnd("smaa-area");
                internalManager.itemEnd("smaa-area");
            });
            externalManager.itemStart("smaa-search");
            externalManager.itemStart("smaa-area");
            internalManager.itemStart("smaa-search");
            internalManager.itemStart("smaa-area");
            searchImage.src = $fe721963ebf18f1b$var$searchImageDataURL_default;
            areaImage.src = $fe721963ebf18f1b$var$areaImageDataURL_default;
        });
    }
};
// src/materials/glsl/convolution.box.frag
var $fe721963ebf18f1b$var$convolution_box_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\n#ifdef BILATERAL\n#include <packing>\nuniform vec2 cameraNearFar;\n#ifdef NORMAL_DEPTH\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D normalDepthBuffer;\n#else\nuniform mediump sampler2D normalDepthBuffer;\n#endif\nfloat readDepth(const in vec2 uv){return texture2D(normalDepthBuffer,uv).a;}\n#else\n#if DEPTH_PACKING == 3201\nuniform lowp sampler2D depthBuffer;\n#elif defined(GL_FRAGMENT_PRECISION_HIGH)\nuniform highp sampler2D depthBuffer;\n#else\nuniform mediump sampler2D depthBuffer;\n#endif\nfloat readDepth(const in vec2 uv){\n#if DEPTH_PACKING == 3201\nreturn unpackRGBAToDepth(texture2D(depthBuffer,uv));\n#else\nreturn texture2D(depthBuffer,uv).r;\n#endif\n}\n#endif\nfloat getViewZ(const in float depth){\n#ifdef PERSPECTIVE_CAMERA\nreturn perspectiveDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);\n#else\nreturn orthographicDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);\n#endif\n}\n#ifdef PERSPECTIVE_CAMERA\n#define linearDepth(v) viewZToOrthographicDepth(getViewZ(readDepth(v)), cameraNearFar.x, cameraNearFar.y)\n#else\n#define linearDepth(v) readDepth(v)\n#endif\n#endif\n#define getTexel(v) texture2D(inputBuffer, v)\n#if KERNEL_SIZE == 3\nvarying vec2 vUv00,vUv01,vUv02;varying vec2 vUv03,vUv04,vUv05;varying vec2 vUv06,vUv07,vUv08;\n#elif KERNEL_SIZE == 5 && MAX_VARYING_VECTORS >= 13\nvarying vec2 vUv00,vUv01,vUv02,vUv03,vUv04;varying vec2 vUv05,vUv06,vUv07,vUv08,vUv09;varying vec2 vUv10,vUv11,vUv12,vUv13,vUv14;varying vec2 vUv15,vUv16,vUv17,vUv18,vUv19;varying vec2 vUv20,vUv21,vUv22,vUv23,vUv24;\n#else\nuniform vec2 texelSize;uniform float scale;varying vec2 vUv;\n#endif\nvoid main(){\n#if KERNEL_SIZE == 3\nvec4 c[]=vec4[KERNEL_SIZE_SQ](getTexel(vUv00),getTexel(vUv01),getTexel(vUv02),getTexel(vUv03),getTexel(vUv04),getTexel(vUv05),getTexel(vUv06),getTexel(vUv07),getTexel(vUv08));\n#ifdef BILATERAL\nfloat z[]=float[KERNEL_SIZE_SQ](linearDepth(vUv00),linearDepth(vUv01),linearDepth(vUv02),linearDepth(vUv03),linearDepth(vUv04),linearDepth(vUv05),linearDepth(vUv06),linearDepth(vUv07),linearDepth(vUv08));\n#endif\n#elif KERNEL_SIZE == 5 && MAX_VARYING_VECTORS >= 13\nvec4 c[]=vec4[KERNEL_SIZE_SQ](getTexel(vUv00),getTexel(vUv01),getTexel(vUv02),getTexel(vUv03),getTexel(vUv04),getTexel(vUv05),getTexel(vUv06),getTexel(vUv07),getTexel(vUv08),getTexel(vUv09),getTexel(vUv10),getTexel(vUv11),getTexel(vUv12),getTexel(vUv13),getTexel(vUv14),getTexel(vUv15),getTexel(vUv16),getTexel(vUv17),getTexel(vUv18),getTexel(vUv19),getTexel(vUv20),getTexel(vUv21),getTexel(vUv22),getTexel(vUv23),getTexel(vUv24));\n#ifdef BILATERAL\nfloat z[]=float[KERNEL_SIZE_SQ](linearDepth(vUv00),linearDepth(vUv01),linearDepth(vUv02),linearDepth(vUv03),linearDepth(vUv04),linearDepth(vUv05),linearDepth(vUv06),linearDepth(vUv07),linearDepth(vUv08),linearDepth(vUv09),linearDepth(vUv10),linearDepth(vUv11),linearDepth(vUv12),linearDepth(vUv13),linearDepth(vUv14),linearDepth(vUv15),linearDepth(vUv16),linearDepth(vUv17),linearDepth(vUv18),linearDepth(vUv19),linearDepth(vUv20),linearDepth(vUv21),linearDepth(vUv22),linearDepth(vUv23),linearDepth(vUv24));\n#endif\n#endif\nvec4 result=vec4(0.0);\n#ifdef BILATERAL\nfloat w=0.0;\n#if KERNEL_SIZE == 3 || (KERNEL_SIZE == 5 && MAX_VARYING_VECTORS >= 13)\nfloat centerDepth=z[KERNEL_SIZE_SQ_HALF];for(int i=0;i<KERNEL_SIZE_SQ;++i){float d=step(abs(z[i]-centerDepth),DISTANCE_THRESHOLD);result+=c[i]*d;w+=d;}\n#else\nfloat centerDepth=linearDepth(vUv);vec2 s=texelSize*scale;for(int x=-KERNEL_SIZE_HALF;x<=KERNEL_SIZE_HALF;++x){for(int y=-KERNEL_SIZE_HALF;y<=KERNEL_SIZE_HALF;++y){vec2 coords=vUv+vec2(x,y)*s;vec4 c=getTexel(coords);float z=(x==0&&y==0)?centerDepth:linearDepth(coords);float d=step(abs(z-centerDepth),DISTANCE_THRESHOLD);result+=c*d;w+=d;}}\n#endif\ngl_FragColor=result/max(w,1.0);\n#else\n#if KERNEL_SIZE == 3 || (KERNEL_SIZE == 5 && MAX_VARYING_VECTORS >= 13)\nfor(int i=0;i<KERNEL_SIZE_SQ;++i){result+=c[i];}\n#else\nvec2 s=texelSize*scale;for(int x=-KERNEL_SIZE_HALF;x<=KERNEL_SIZE_HALF;++x){for(int y=-KERNEL_SIZE_HALF;y<=KERNEL_SIZE_HALF;++y){result+=getTexel(uv+vec2(x,y)*s);}}\n#endif\ngl_FragColor=result*INV_KERNEL_SIZE_SQ;\n#endif\n}";
// src/materials/glsl/convolution.box.vert
var $fe721963ebf18f1b$var$convolution_box_default2 = "uniform vec2 texelSize;uniform float scale;\n#if KERNEL_SIZE == 3\nvarying vec2 vUv00,vUv01,vUv02;varying vec2 vUv03,vUv04,vUv05;varying vec2 vUv06,vUv07,vUv08;\n#elif KERNEL_SIZE == 5 && MAX_VARYING_VECTORS >= 13\nvarying vec2 vUv00,vUv01,vUv02,vUv03,vUv04;varying vec2 vUv05,vUv06,vUv07,vUv08,vUv09;varying vec2 vUv10,vUv11,vUv12,vUv13,vUv14;varying vec2 vUv15,vUv16,vUv17,vUv18,vUv19;varying vec2 vUv20,vUv21,vUv22,vUv23,vUv24;\n#else\nvarying vec2 vUv;\n#endif\nvoid main(){vec2 uv=position.xy*0.5+0.5;\n#if KERNEL_SIZE == 3\nvec2 s=texelSize*scale;vUv00=uv+s*vec2(-1.0,-1.0);vUv01=uv+s*vec2(0.0,-1.0);vUv02=uv+s*vec2(1.0,-1.0);vUv03=uv+s*vec2(-1.0,0.0);vUv04=uv;vUv05=uv+s*vec2(1.0,0.0);vUv06=uv+s*vec2(-1.0,1.0);vUv07=uv+s*vec2(0.0,1.0);vUv08=uv+s*vec2(1.0,1.0);\n#elif KERNEL_SIZE == 5\nvec2 s=texelSize*scale;vUv00=uv+s*vec2(-2.0,-2.0);vUv01=uv+s*vec2(-1.0,-2.0);vUv02=uv+s*vec2(0.0,-2.0);vUv03=uv+s*vec2(1.0,-2.0);vUv04=uv+s*vec2(2.0,-2.0);vUv05=uv+s*vec2(-2.0,-1.0);vUv06=uv+s*vec2(-1.0,-1.0);vUv07=uv+s*vec2(0.0,-1.0);vUv08=uv+s*vec2(1.0,-1.0);vUv09=uv+s*vec2(2.0,-1.0);vUv10=uv+s*vec2(-2.0,0.0);vUv11=uv+s*vec2(-1.0,0.0);vUv12=uv;vUv13=uv+s*vec2(1.0,0.0);vUv14=uv+s*vec2(2.0,0.0);vUv15=uv+s*vec2(-2.0,1.0);vUv16=uv+s*vec2(-1.0,1.0);vUv17=uv+s*vec2(0.0,1.0);vUv18=uv+s*vec2(1.0,1.0);vUv19=uv+s*vec2(2.0,1.0);vUv20=uv+s*vec2(-2.0,2.0);vUv21=uv+s*vec2(-1.0,2.0);vUv22=uv+s*vec2(0.0,2.0);vUv23=uv+s*vec2(1.0,2.0);vUv24=uv+s*vec2(2.0,2.0);\n#else\nvUv=uv;\n#endif\ngl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/BoxBlurMaterial.js
var $fe721963ebf18f1b$export$d331d314f1169029 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new box blur material.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.bilateral=false] - Enables or disables bilateral blurring.
   * @param {Number} [options.kernelSize=5] - The kernel size.
   */ constructor({ bilateral: bilateral = false, kernelSize: kernelSize = 5 } = {}){
        super({
            name: "BoxBlurMaterial",
            defines: {
                DEPTH_PACKING: "0",
                DISTANCE_THRESHOLD: "0.1"
            },
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                depthBuffer: new (0, $ilwiq.Uniform)(null),
                normalDepthBuffer: new (0, $ilwiq.Uniform)(null),
                texelSize: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                cameraNearFar: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                scale: new (0, $ilwiq.Uniform)(1)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$convolution_box_default,
            vertexShader: $fe721963ebf18f1b$var$convolution_box_default2
        });
        this.bilateral = bilateral;
        this.kernelSize = kernelSize;
        this.maxVaryingVectors = 8;
    }
    /**
   * The maximum amount of varying vectors.
   *
   * Should be synced with `renderer.capabilities.maxVaryings`. Default is 8.
   *
   * @type {Number}
   */ set maxVaryingVectors(value) {
        this.defines.MAX_VARYING_VECTORS = value.toFixed(0);
    }
    /**
   * The kernel size.
   *
   * - Must be an odd number
   * - Kernel size 3 and 5 use optimized code paths
   * - Default is 5
   *
   * @type {Number}
   */ get kernelSize() {
        return Number(this.defines.KERNEL_SIZE);
    }
    set kernelSize(value) {
        if (value % 2 === 0) throw new Error("The kernel size must be an odd number");
        this.defines.KERNEL_SIZE = value.toFixed(0);
        this.defines.KERNEL_SIZE_HALF = Math.floor(value / 2).toFixed(0);
        this.defines.KERNEL_SIZE_SQ = (value ** 2).toFixed(0);
        this.defines.KERNEL_SIZE_SQ_HALF = Math.floor(value ** 2 / 2).toFixed(0);
        this.defines.INV_KERNEL_SIZE_SQ = (1 / value ** 2).toFixed(6);
        this.needsUpdate = true;
    }
    /**
   * The blur scale.
   *
   * @type {Number}
   */ get scale() {
        return this.uniforms.scale.value;
    }
    set scale(value) {
        this.uniforms.scale.value = value;
    }
    /**
   * The current near plane setting.
   *
   * @type {Number}
   * @private
   */ get near() {
        return this.uniforms.cameraNearFar.value.x;
    }
    /**
   * The current far plane setting.
   *
   * @type {Number}
   * @private
   */ get far() {
        return this.uniforms.cameraNearFar.value.y;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * A combined normal-depth buffer. Overrides {@link depthBuffer} if set.
   *
   * @type {Texture}
   */ set normalDepthBuffer(value) {
        this.uniforms.normalDepthBuffer.value = value;
        if (value !== null) this.defines.NORMAL_DEPTH = "1";
        else delete this.defines.NORMAL_DEPTH;
        this.needsUpdate = true;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Indicates whether bilateral filtering is enabled.
   *
   * @type {Boolean}
   */ get bilateral() {
        return this.defines.BILATERAL !== void 0;
    }
    set bilateral(value) {
        if (value !== null) this.defines.BILATERAL = "1";
        else delete this.defines.BILATERAL;
        this.needsUpdate = true;
    }
    /**
   * The bilateral filter distance threshold in world units.
   *
   * @type {Number}
   */ get worldDistanceThreshold() {
        return -$fe721963ebf18f1b$var$orthographicDepthToViewZ(Number(this.defines.DISTANCE_THRESHOLD), this.near, this.far);
    }
    set worldDistanceThreshold(value) {
        const threshold = $fe721963ebf18f1b$var$viewZToOrthographicDepth(-value, this.near, this.far);
        this.defines.DISTANCE_THRESHOLD = threshold.toFixed(12);
        this.needsUpdate = true;
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNearFar.value.set(camera.near, camera.far);
            if (camera instanceof (0, $ilwiq.PerspectiveCamera)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/materials/glsl/depth-copy.frag
var $fe721963ebf18f1b$var$depth_copy_default = "#include <packing>\nvarying vec2 vUv;\n#ifdef NORMAL_DEPTH\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nuniform highp sampler2D normalDepthBuffer;\n#else\nuniform mediump sampler2D normalDepthBuffer;\n#endif\nfloat readDepth(const in vec2 uv){return texture2D(normalDepthBuffer,uv).a;}\n#else\n#if INPUT_DEPTH_PACKING == 3201\nuniform lowp sampler2D depthBuffer;\n#elif defined(GL_FRAGMENT_PRECISION_HIGH)\nuniform highp sampler2D depthBuffer;\n#else\nuniform mediump sampler2D depthBuffer;\n#endif\nfloat readDepth(const in vec2 uv){\n#if INPUT_DEPTH_PACKING == 3201\nreturn unpackRGBAToDepth(texture2D(depthBuffer,uv));\n#else\nreturn texture2D(depthBuffer,uv).r;\n#endif\n}\n#endif\nvoid main(){\n#if INPUT_DEPTH_PACKING == OUTPUT_DEPTH_PACKING\ngl_FragColor=texture2D(depthBuffer,vUv);\n#else\nfloat depth=readDepth(vUv);\n#if OUTPUT_DEPTH_PACKING == 3201\ngl_FragColor=(depth==1.0)?vec4(1.0):packDepthToRGBA(depth);\n#else\ngl_FragColor=vec4(vec3(depth),1.0);\n#endif\n#endif\n}";
// src/materials/glsl/depth-copy.vert
var $fe721963ebf18f1b$var$depth_copy_default2 = "varying vec2 vUv;\n#if DEPTH_COPY_MODE == 1\nuniform vec2 texelPosition;\n#endif\nvoid main(){\n#if DEPTH_COPY_MODE == 1\nvUv=texelPosition;\n#else\nvUv=position.xy*0.5+0.5;\n#endif\ngl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/DepthCopyMaterial.js
var $fe721963ebf18f1b$export$c6821a730bfea2ec = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new depth copy material.
   */ constructor(){
        super({
            name: "DepthCopyMaterial",
            defines: {
                INPUT_DEPTH_PACKING: "0",
                OUTPUT_DEPTH_PACKING: "0",
                DEPTH_COPY_MODE: "0"
            },
            uniforms: {
                depthBuffer: new (0, $ilwiq.Uniform)(null),
                texelPosition: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)())
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$depth_copy_default,
            vertexShader: $fe721963ebf18f1b$var$depth_copy_default2
        });
        this.depthCopyMode = $fe721963ebf18f1b$export$f14251d45898bc40.FULL;
    }
    /**
   * The input depth buffer.
   *
   * @type {Texture}
   */ get depthBuffer() {
        return this.uniforms.depthBuffer.value;
    }
    set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The input depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set inputDepthPacking(value) {
        this.defines.INPUT_DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * The output depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ get outputDepthPacking() {
        return Number(this.defines.OUTPUT_DEPTH_PACKING);
    }
    set outputDepthPacking(value) {
        this.defines.OUTPUT_DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the input depth buffer.
   *
   * @deprecated Use depthBuffer and inputDepthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthBuffer = buffer;
        this.inputDepthPacking = depthPacking;
    }
    /**
   * Returns the current input depth packing strategy.
   *
   * @deprecated
   * @return {DepthPackingStrategies} The input depth packing strategy.
   */ getInputDepthPacking() {
        return Number(this.defines.INPUT_DEPTH_PACKING);
    }
    /**
   * Sets the input depth packing strategy.
   *
   * @deprecated Use inputDepthPacking instead.
   * @param {DepthPackingStrategies} value - The new input depth packing strategy.
   */ setInputDepthPacking(value) {
        this.defines.INPUT_DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Returns the current output depth packing strategy.
   *
   * @deprecated Use outputDepthPacking instead.
   * @return {DepthPackingStrategies} The output depth packing strategy.
   */ getOutputDepthPacking() {
        return Number(this.defines.OUTPUT_DEPTH_PACKING);
    }
    /**
   * Sets the output depth packing strategy.
   *
   * @deprecated Use outputDepthPacking instead.
   * @param {DepthPackingStrategies} value - The new output depth packing strategy.
   */ setOutputDepthPacking(value) {
        this.defines.OUTPUT_DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * The screen space position used for single-texel copy operations.
   *
   * @type {Vector2}
   */ get texelPosition() {
        return this.uniforms.texelPosition.value;
    }
    /**
   * Returns the screen space position used for single-texel copy operations.
   *
   * @deprecated Use texelPosition instead.
   * @return {Vector2} The position.
   */ getTexelPosition() {
        return this.uniforms.texelPosition.value;
    }
    /**
   * Sets the screen space position used for single-texel copy operations.
   *
   * @deprecated
   * @param {Vector2} value - The position.
   */ setTexelPosition(value) {
        this.uniforms.texelPosition.value = value;
    }
    /**
   * The depth copy mode.
   *
   * @type {DepthCopyMode}
   */ get mode() {
        return this.depthCopyMode;
    }
    set mode(value) {
        this.depthCopyMode = value;
        this.defines.DEPTH_COPY_MODE = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Returns the depth copy mode.
   *
   * @deprecated Use mode instead.
   * @return {DepthCopyMode} The depth copy mode.
   */ getMode() {
        return this.mode;
    }
    /**
   * Sets the depth copy mode.
   *
   * @deprecated Use mode instead.
   * @param {DepthCopyMode} value - The new mode.
   */ setMode(value) {
        this.mode = value;
    }
};
// src/materials/glsl/effect.frag
var $fe721963ebf18f1b$var$effect_default = "#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#define packFloatToRGBA(v) packDepthToRGBA(v)\n#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)\n#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\n#if DEPTH_PACKING == 3201\nuniform lowp sampler2D depthBuffer;\n#elif defined(GL_FRAGMENT_PRECISION_HIGH)\nuniform highp sampler2D depthBuffer;\n#else\nuniform mediump sampler2D depthBuffer;\n#endif\nuniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;vec4 sRGBToLinear(const in vec4 value){return vec4(mix(pow(value.rgb*0.9478672986+vec3(0.0521327014),vec3(2.4)),value.rgb*0.0773993808,vec3(lessThanEqual(value.rgb,vec3(0.04045)))),value.a);}float readDepth(const in vec2 uv){\n#if DEPTH_PACKING == 3201\nreturn unpackRGBAToDepth(texture2D(depthBuffer,uv));\n#else\nreturn texture2D(depthBuffer,uv).r;\n#endif\n}float getViewZ(const in float depth){\n#ifdef PERSPECTIVE_CAMERA\nreturn perspectiveDepthToViewZ(depth,cameraNear,cameraFar);\n#else\nreturn orthographicDepthToViewZ(depth,cameraNear,cameraFar);\n#endif\n}vec3 RGBToHCV(const in vec3 RGB){vec4 P=mix(vec4(RGB.bg,-1.0,2.0/3.0),vec4(RGB.gb,0.0,-1.0/3.0),step(RGB.b,RGB.g));vec4 Q=mix(vec4(P.xyw,RGB.r),vec4(RGB.r,P.yzx),step(P.x,RGB.r));float C=Q.x-min(Q.w,Q.y);float H=abs((Q.w-Q.y)/(6.0*C+EPSILON)+Q.z);return vec3(H,C,Q.x);}vec3 RGBToHSL(const in vec3 RGB){vec3 HCV=RGBToHCV(RGB);float L=HCV.z-HCV.y*0.5;float S=HCV.y/(1.0-abs(L*2.0-1.0)+EPSILON);return vec3(HCV.x,S,L);}vec3 HueToRGB(const in float H){float R=abs(H*6.0-3.0)-1.0;float G=2.0-abs(H*6.0-2.0);float B=2.0-abs(H*6.0-4.0);return clamp(vec3(R,G,B),0.0,1.0);}vec3 HSLToRGB(const in vec3 HSL){vec3 RGB=HueToRGB(HSL.x);float C=(1.0-abs(2.0*HSL.z-1.0))*HSL.y;return(RGB-0.5)*C+HSL.z;}FRAGMENT_HEAD void main(){FRAGMENT_MAIN_UV vec4 color0=texture2D(inputBuffer,UV);vec4 color1=vec4(0.0);FRAGMENT_MAIN_IMAGE color0.a=clamp(color0.a,0.0,1.0);gl_FragColor=color0;\n#ifdef ENCODE_OUTPUT\n#include <colorspace_fragment>\n#endif\n#include <dithering_fragment>\n}";
// src/materials/glsl/effect.vert
var $fe721963ebf18f1b$var$effect_default2 = "uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;VERTEX_HEAD void main(){vUv=position.xy*0.5+0.5;VERTEX_MAIN_SUPPORT gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/EffectMaterial.js
var $fe721963ebf18f1b$export$a26662c57c109212 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new effect material.
   *
   * @param {Map<String, String>} [shaderParts] - Deprecated. Use setShaderData instead.
   * @param {Map<String, String>} [defines] - Deprecated. Use setShaderData instead.
   * @param {Map<String, Uniform>} [uniforms] - Deprecated. Use setShaderData instead.
   * @param {Camera} [camera] - A camera.
   * @param {Boolean} [dithering=false] - Deprecated.
   */ constructor(shaderParts, defines, uniforms, camera, dithering = false){
        super({
            name: "EffectMaterial",
            defines: {
                THREE_REVISION: (0, $ilwiq.REVISION).replace(/\D+/g, ""),
                DEPTH_PACKING: "0",
                ENCODE_OUTPUT: "1"
            },
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                depthBuffer: new (0, $ilwiq.Uniform)(null),
                resolution: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                texelSize: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                cameraNear: new (0, $ilwiq.Uniform)(0.3),
                cameraFar: new (0, $ilwiq.Uniform)(1e3),
                aspect: new (0, $ilwiq.Uniform)(1),
                time: new (0, $ilwiq.Uniform)(0)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            dithering: dithering
        });
        if (shaderParts) this.setShaderParts(shaderParts);
        if (defines) this.setDefines(defines);
        if (uniforms) this.setUniforms(uniforms);
        this.copyCameraSettings(camera);
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ get depthBuffer() {
        return this.uniforms.depthBuffer.value;
    }
    set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ get depthPacking() {
        return Number(this.defines.DEPTH_PACKING);
    }
    set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * Sets the shader data.
   *
   * @param {EffectShaderData} data - The shader data.
   * @return {EffectMaterial} This material.
   */ setShaderData(data) {
        this.setShaderParts(data.shaderParts);
        this.setDefines(data.defines);
        this.setUniforms(data.uniforms);
        this.setExtensions(data.extensions);
    }
    /**
   * Sets the shader parts.
   *
   * @deprecated Use setShaderData instead.
   * @param {Map<String, String>} shaderParts - A collection of shader snippets. See {@link EffectShaderSection}.
   * @return {EffectMaterial} This material.
   */ setShaderParts(shaderParts) {
        this.fragmentShader = $fe721963ebf18f1b$var$effect_default.replace($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_HEAD, shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_HEAD) || "").replace($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_UV, shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_UV) || "").replace($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE, shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE) || "");
        this.vertexShader = $fe721963ebf18f1b$var$effect_default2.replace($fe721963ebf18f1b$export$a147810b69c6903e.VERTEX_HEAD, shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.VERTEX_HEAD) || "").replace($fe721963ebf18f1b$export$a147810b69c6903e.VERTEX_MAIN_SUPPORT, shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.VERTEX_MAIN_SUPPORT) || "");
        this.needsUpdate = true;
        return this;
    }
    /**
   * Sets the shader macros.
   *
   * @deprecated Use setShaderData instead.
   * @param {Map<String, String>} defines - A collection of preprocessor macro definitions.
   * @return {EffectMaterial} This material.
   */ setDefines(defines) {
        for (const entry of defines.entries())this.defines[entry[0]] = entry[1];
        this.needsUpdate = true;
        return this;
    }
    /**
   * Sets the shader uniforms.
   *
   * @deprecated Use setShaderData instead.
   * @param {Map<String, Uniform>} uniforms - A collection of uniforms.
   * @return {EffectMaterial} This material.
   */ setUniforms(uniforms) {
        for (const entry of uniforms.entries())this.uniforms[entry[0]] = entry[1];
        return this;
    }
    /**
   * Sets the required shader extensions.
   *
   * @deprecated Use setShaderData instead.
   * @param {Set<WebGLExtension>} extensions - A collection of extensions.
   * @return {EffectMaterial} This material.
   */ setExtensions(extensions) {
        this.extensions = {};
        for (const extension of extensions)this.extensions[extension] = true;
        return this;
    }
    /**
   * Indicates whether output encoding is enabled.
   *
   * @type {Boolean}
   */ get encodeOutput() {
        return this.defines.ENCODE_OUTPUT !== void 0;
    }
    set encodeOutput(value) {
        if (this.encodeOutput !== value) {
            if (value) this.defines.ENCODE_OUTPUT = "1";
            else delete this.defines.ENCODE_OUTPUT;
            this.needsUpdate = true;
        }
    }
    /**
   * Indicates whether output encoding is enabled.
   *
   * @deprecated Use encodeOutput instead.
   * @return {Boolean} Whether output encoding is enabled.
   */ isOutputEncodingEnabled(value) {
        return this.encodeOutput;
    }
    /**
   * Enables or disables output encoding.
   *
   * @deprecated Use encodeOutput instead.
   * @param {Boolean} value - Whether output encoding should be enabled.
   */ setOutputEncodingEnabled(value) {
        this.encodeOutput = value;
    }
    /**
   * The time in seconds.
   *
   * @type {Number}
   */ get time() {
        return this.uniforms.time.value;
    }
    set time(value) {
        this.uniforms.time.value = value;
    }
    /**
   * Sets the delta time.
   *
   * @deprecated Use time instead.
   * @param {Number} value - The delta time in seconds.
   */ setDeltaTime(value) {
        this.uniforms.time.value += value;
    }
    /**
   * Copies the settings of the given camera.
   *
   * @deprecated Use copyCameraSettings instead.
   * @param {Camera} camera - A camera.
   */ adoptCameraSettings(camera) {
        this.copyCameraSettings(camera);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNear.value = camera.near;
            this.uniforms.cameraFar.value = camera.far;
            if (camera instanceof (0, $ilwiq.PerspectiveCamera)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
    /**
   * Sets the resolution.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const uniforms = this.uniforms;
        uniforms.resolution.value.set(width, height);
        uniforms.texelSize.value.set(1 / width, 1 / height);
        uniforms.aspect.value = width / height;
    }
    /**
   * An enumeration of shader code placeholders.
   *
   * @deprecated Use EffectShaderSection instead.
   * @type {Object}
   */ static get Section() {
        return $fe721963ebf18f1b$export$a147810b69c6903e;
    }
};
// src/materials/glsl/convolution.gaussian.frag
var $fe721963ebf18f1b$var$convolution_gaussian_default = "#ifdef FRAMEBUFFER_PRECISION_HIGH\nuniform mediump sampler2D inputBuffer;\n#else\nuniform lowp sampler2D inputBuffer;\n#endif\nuniform vec2 kernel[STEPS];varying vec2 vOffset;varying vec2 vUv;void main(){vec4 result=texture2D(inputBuffer,vUv)*kernel[0].y;for(int i=1;i<STEPS;++i){vec2 offset=kernel[i].x*vOffset;vec4 c0=texture2D(inputBuffer,vUv+offset);vec4 c1=texture2D(inputBuffer,vUv-offset);result+=(c0+c1)*kernel[i].y;}gl_FragColor=result;\n#include <colorspace_fragment>\n}";
// src/materials/glsl/convolution.gaussian.vert
var $fe721963ebf18f1b$var$convolution_gaussian_default2 = "uniform vec2 texelSize;uniform vec2 direction;uniform float scale;varying vec2 vOffset;varying vec2 vUv;void main(){vOffset=direction*texelSize*scale;vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}";
// src/materials/GaussianBlurMaterial.js
var $fe721963ebf18f1b$export$c01ac62da39ecb86 = class extends (0, $ilwiq.ShaderMaterial) {
    /**
   * Constructs a new convolution material.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.kernelSize=35] - The kernel size.
   */ constructor({ kernelSize: kernelSize = 35 } = {}){
        super({
            name: "GaussianBlurMaterial",
            uniforms: {
                inputBuffer: new (0, $ilwiq.Uniform)(null),
                texelSize: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                direction: new (0, $ilwiq.Uniform)(new (0, $ilwiq.Vector2)()),
                kernel: new (0, $ilwiq.Uniform)(null),
                scale: new (0, $ilwiq.Uniform)(1)
            },
            blending: (0, $ilwiq.NoBlending),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $fe721963ebf18f1b$var$convolution_gaussian_default,
            vertexShader: $fe721963ebf18f1b$var$convolution_gaussian_default2
        });
        this._kernelSize = 0;
        this.kernelSize = kernelSize;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The kernel size.
   *
   * @type {Number}
   */ get kernelSize() {
        return this._kernelSize;
    }
    set kernelSize(value) {
        this._kernelSize = value;
        this.generateKernel(value);
    }
    /**
   * The blur direction.
   *
   * @type {Vector2}
   */ get direction() {
        return this.uniforms.direction.value;
    }
    /**
   * The blur kernel scale. Values greater than 1.0 may introduce artifacts.
   *
   * @type {Number}
   */ get scale() {
        return this.uniforms.scale.value;
    }
    set scale(value) {
        this.uniforms.scale.value = value;
    }
    /**
   * Generates the Gauss kernel.
   *
   * @param {KernelSize} kernelSize - The kernel size. Should be an odd number.
   * @private
   */ generateKernel(kernelSize) {
        const kernel = new $fe721963ebf18f1b$export$66c54bc65bf8869c(kernelSize);
        const steps = kernel.linearSteps;
        const kernelData = new Float64Array(steps * 2);
        for(let i = 0, j = 0; i < steps; ++i){
            kernelData[j++] = kernel.linearOffsets[i];
            kernelData[j++] = kernel.linearWeights[i];
        }
        this.uniforms.kernel.value = kernelData;
        this.defines.STEPS = steps.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
var $fe721963ebf18f1b$export$13b54093f26c053a = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new box blur pass.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.kernelSize=5] - Must be an odd number. The sizes 3 and 5 use optimized code paths.
   * @param {Number} [options.iterations=1] - The amount of times the blur should be applied.
   * @param {Number} [options.bilateral=false] - Enables or disables bilateral blurring.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   */ constructor({ kernelSize: kernelSize = 5, iterations: iterations = 1, bilateral: bilateral = false, resolutionScale: resolutionScale = 1, resolutionX: resolutionX = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionY: resolutionY = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE } = {}){
        super("BoxBlurPass");
        this.needsDepthTexture = bilateral;
        this.renderTargetA = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetA.texture.name = "Blur.Target.A";
        this.renderTargetB = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetB.texture.name = "Blur.Target.B";
        this.blurMaterial = new $fe721963ebf18f1b$export$d331d314f1169029({
            bilateral: bilateral,
            kernelSize: kernelSize
        });
        this.copyMaterial = new $fe721963ebf18f1b$export$d4b5f24bda67f7e4();
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.iterations = iterations;
    }
    set mainCamera(value) {
        this.blurMaterial.copyCameraSettings(value);
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.blurMaterial.depthBuffer = depthTexture;
        this.blurMaterial.depthPacking = depthPacking;
    }
    /**
   * Renders the blur.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const scene = this.scene;
        const camera = this.camera;
        const renderTargetA = this.renderTargetA;
        const renderTargetB = this.renderTargetB;
        const blurMaterial = this.blurMaterial;
        this.fullscreenMaterial = blurMaterial;
        let previousBuffer = inputBuffer;
        for(let i = 0, l = Math.max(this.iterations, 1); i < l; ++i){
            const buffer = (i & 1) === 0 ? renderTargetA : renderTargetB;
            blurMaterial.inputBuffer = previousBuffer.texture;
            renderer.setRenderTarget(buffer);
            renderer.render(scene, camera);
            previousBuffer = buffer;
        }
        this.copyMaterial.inputBuffer = previousBuffer.texture;
        this.fullscreenMaterial = this.copyMaterial;
        renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
        renderer.render(scene, camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.renderTargetA.setSize(w, h);
        this.renderTargetB.setSize(w, h);
        this.blurMaterial.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (renderer !== null) this.blurMaterial.maxVaryingVectors = renderer.capabilities.maxVaryings;
        if (frameBufferType !== void 0) {
            this.renderTargetA.texture.type = frameBufferType;
            this.renderTargetB.texture.type = frameBufferType;
            if (frameBufferType !== (0, $ilwiq.UnsignedByteType)) this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
            else if (renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) {
                this.renderTargetA.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
                this.renderTargetB.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
            }
        }
    }
};
var $fe721963ebf18f1b$export$d66f952c334c662b = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new depth save pass.
   *
   * @param {Object} [options] - The options.
   * @param {DepthPackingStrategies} [options.depthPacking=RGBADepthPacking] - The output depth packing.
   */ constructor({ depthPacking: depthPacking = (0, $ilwiq.RGBADepthPacking) } = {}){
        super("DepthCopyPass");
        const material = new $fe721963ebf18f1b$export$c6821a730bfea2ec();
        material.outputDepthPacking = depthPacking;
        this.fullscreenMaterial = material;
        this.needsDepthTexture = true;
        this.needsSwap = false;
        this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            type: depthPacking === (0, $ilwiq.RGBADepthPacking) ? (0, $ilwiq.UnsignedByteType) : (0, $ilwiq.FloatType),
            minFilter: (0, $ilwiq.NearestFilter),
            magFilter: (0, $ilwiq.NearestFilter),
            depthBuffer: false
        });
        this.renderTarget.texture.name = "DepthCopyPass.Target";
    }
    /**
   * The output depth texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the output depth texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * The output depth packing.
   *
   * @type {DepthPackingStrategies}
   */ get depthPacking() {
        return this.fullscreenMaterial.outputDepthPacking;
    }
    /**
   * Returns the output depth packing.
   *
   * @deprecated Use depthPacking instead.
   * @return {DepthPackingStrategies} The depth packing.
   */ getDepthPacking() {
        return this.fullscreenMaterial.outputDepthPacking;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.fullscreenMaterial.depthBuffer = depthTexture;
        this.fullscreenMaterial.inputDepthPacking = depthPacking;
    }
    /**
   * Copies depth from a depth texture.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
        renderer.render(this.scene, this.camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.renderTarget.setSize(width, height);
    }
};
// src/passes/DepthPickingPass.js
var $fe721963ebf18f1b$var$threeRevision = Number((0, $ilwiq.REVISION).replace(/\D+/g, ""));
var $fe721963ebf18f1b$var$unpackDownscale = 255 / 256;
var $fe721963ebf18f1b$var$unpackFactorsLegacy = new Float32Array([
    $fe721963ebf18f1b$var$unpackDownscale / 256 ** 3,
    $fe721963ebf18f1b$var$unpackDownscale / 65536,
    $fe721963ebf18f1b$var$unpackDownscale / 256,
    $fe721963ebf18f1b$var$unpackDownscale
]);
var $fe721963ebf18f1b$var$unpackFactors = new Float32Array([
    $fe721963ebf18f1b$var$unpackDownscale,
    $fe721963ebf18f1b$var$unpackDownscale / 256,
    $fe721963ebf18f1b$var$unpackDownscale / 65536,
    1 / 256 ** 3
]);
function $fe721963ebf18f1b$var$unpackRGBAToDepth(packedDepth) {
    const f = $fe721963ebf18f1b$var$threeRevision >= 167 ? $fe721963ebf18f1b$var$unpackFactors : $fe721963ebf18f1b$var$unpackFactorsLegacy;
    return (packedDepth[0] * f[0] + packedDepth[1] * f[1] + packedDepth[2] * f[2] + packedDepth[3] * f[3]) / 255;
}
var $fe721963ebf18f1b$export$bd325dd997857b23 = class extends $fe721963ebf18f1b$export$d66f952c334c662b {
    /**
   * Constructs a new depth picking pass.
   *
   * @param {Object} [options] - The options.
   * @param {DepthPackingStrategies} [options.depthPacking=RGBADepthPacking] - The depth packing.
   * @param {Number} [options.mode=DepthCopyMode.SINGLE] - The depth copy mode.
   */ constructor({ depthPacking: depthPacking = (0, $ilwiq.RGBADepthPacking), mode: mode = $fe721963ebf18f1b$export$f14251d45898bc40.SINGLE } = {}){
        if (depthPacking !== (0, $ilwiq.RGBADepthPacking) && depthPacking !== (0, $ilwiq.BasicDepthPacking)) throw new Error(`Unsupported depth packing: ${depthPacking}`);
        super({
            depthPacking: depthPacking
        });
        this.name = "DepthPickingPass";
        this.fullscreenMaterial.mode = mode;
        this.pixelBuffer = depthPacking === (0, $ilwiq.RGBADepthPacking) ? new Uint8Array(4) : new Float32Array(4);
        this.callback = null;
    }
    /**
   * Reads depth at a specific screen position.
   *
   * Only one depth value can be picked per frame. Calling this method multiple times per frame will overwrite the
   * picking coordinates. Unresolved promises will be abandoned.
   *
   * @example
   * const ndc = new Vector3();
   * const clientRect = myViewport.getBoundingClientRect();
   * const clientX = pointerEvent.clientX - clientRect.left;
   * const clientY = pointerEvent.clientY - clientRect.top;
   * ndc.x = (clientX / myViewport.clientWidth) * 2.0 - 1.0;
   * ndc.y = -(clientY / myViewport.clientHeight) * 2.0 + 1.0;
   * const depth = await depthPickingPass.readDepth(ndc);
   * ndc.z = depth * 2.0 - 1.0;
   *
   * const worldPosition = ndc.unproject(camera);
   *
   * @param {Vector2|Vector3} ndc - Normalized device coordinates. Only X and Y are relevant.
   * @return {Promise<Number>} A promise that returns the depth on the next frame.
   */ readDepth(ndc) {
        this.fullscreenMaterial.texelPosition.set(ndc.x * 0.5 + 0.5, ndc.y * 0.5 + 0.5);
        return new Promise((resolve)=>{
            this.callback = resolve;
        });
    }
    /**
   * Copies depth and resolves depth picking promises.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const material = this.fullscreenMaterial;
        const mode = material.mode;
        if (mode === $fe721963ebf18f1b$export$f14251d45898bc40.FULL) super.render(renderer);
        if (this.callback !== null) {
            const renderTarget = this.renderTarget;
            const pixelBuffer = this.pixelBuffer;
            const packed = renderTarget.texture.type !== (0, $ilwiq.FloatType);
            let x = 0, y = 0;
            if (mode === $fe721963ebf18f1b$export$f14251d45898bc40.SINGLE) super.render(renderer);
            else {
                const texelPosition = material.texelPosition;
                x = Math.round(texelPosition.x * renderTarget.width);
                y = Math.round(texelPosition.y * renderTarget.height);
            }
            renderer.readRenderTargetPixels(renderTarget, x, y, 1, 1, pixelBuffer);
            this.callback(packed ? $fe721963ebf18f1b$var$unpackRGBAToDepth(pixelBuffer) : pixelBuffer[0]);
            this.callback = null;
        }
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        if (this.fullscreenMaterial.mode === $fe721963ebf18f1b$export$f14251d45898bc40.FULL) super.setSize(width, height);
    }
};
function $fe721963ebf18f1b$var$prefixSubstrings(prefix, substrings, strings) {
    for (const substring of substrings){
        const prefixed = "$1" + prefix + substring.charAt(0).toUpperCase() + substring.slice(1);
        const regExp = new RegExp("([^\\.])(\\b" + substring + "\\b)", "g");
        for (const entry of strings.entries())if (entry[1] !== null) strings.set(entry[0], entry[1].replace(regExp, prefixed));
    }
}
function $fe721963ebf18f1b$var$integrateEffect(prefix, effect, data) {
    let fragmentShader = effect.getFragmentShader();
    let vertexShader = effect.getVertexShader();
    const mainImageExists = fragmentShader !== void 0 && /mainImage/.test(fragmentShader);
    const mainUvExists = fragmentShader !== void 0 && /mainUv/.test(fragmentShader);
    data.attributes |= effect.getAttributes();
    if (fragmentShader === void 0) throw new Error(`Missing fragment shader (${effect.name})`);
    else if (mainUvExists && (data.attributes & $fe721963ebf18f1b$export$a72ebb312f9e05c6.CONVOLUTION) !== 0) throw new Error(`Effects that transform UVs are incompatible with convolution effects (${effect.name})`);
    else if (!mainImageExists && !mainUvExists) throw new Error(`Could not find mainImage or mainUv function (${effect.name})`);
    else {
        const functionRegExp = /\w+\s+(\w+)\([\w\s,]*\)\s*{/g;
        const shaderParts = data.shaderParts;
        let fragmentHead = shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_HEAD) || "";
        let fragmentMainUv = shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_UV) || "";
        let fragmentMainImage = shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE) || "";
        let vertexHead = shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.VERTEX_HEAD) || "";
        let vertexMainSupport = shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.VERTEX_MAIN_SUPPORT) || "";
        const varyings = /* @__PURE__ */ new Set();
        const names = /* @__PURE__ */ new Set();
        if (mainUvExists) {
            fragmentMainUv += `	${prefix}MainUv(UV);
`;
            data.uvTransformation = true;
        }
        if (vertexShader !== null && /mainSupport/.test(vertexShader)) {
            const needsUv = /mainSupport *\([\w\s]*?uv\s*?\)/.test(vertexShader);
            vertexMainSupport += `	${prefix}MainSupport(`;
            vertexMainSupport += needsUv ? "vUv);\n" : ");\n";
            for (const m2 of vertexShader.matchAll(/(?:varying\s+\w+\s+([\S\s]*?);)/g))for (const n of m2[1].split(/\s*,\s*/)){
                data.varyings.add(n);
                varyings.add(n);
                names.add(n);
            }
            for (const m2 of vertexShader.matchAll(functionRegExp))names.add(m2[1]);
        }
        for (const m2 of fragmentShader.matchAll(functionRegExp))names.add(m2[1]);
        for (const d of effect.defines.keys())names.add(d.replace(/\([\w\s,]*\)/g, ""));
        for (const u of effect.uniforms.keys())names.add(u);
        names.delete("while");
        names.delete("for");
        names.delete("if");
        effect.uniforms.forEach((val, key)=>data.uniforms.set(prefix + key.charAt(0).toUpperCase() + key.slice(1), val));
        effect.defines.forEach((val, key)=>data.defines.set(prefix + key.charAt(0).toUpperCase() + key.slice(1), val));
        const shaders = /* @__PURE__ */ new Map([
            [
                "fragment",
                fragmentShader
            ],
            [
                "vertex",
                vertexShader
            ]
        ]);
        $fe721963ebf18f1b$var$prefixSubstrings(prefix, names, data.defines);
        $fe721963ebf18f1b$var$prefixSubstrings(prefix, names, shaders);
        fragmentShader = shaders.get("fragment");
        vertexShader = shaders.get("vertex");
        const blendMode = effect.blendMode;
        data.blendModes.set(blendMode.blendFunction, blendMode);
        if (mainImageExists) {
            if (effect.inputColorSpace !== null && effect.inputColorSpace !== data.colorSpace) fragmentMainImage += effect.inputColorSpace === (0, $ilwiq.SRGBColorSpace) ? "color0 = sRGBTransferOETF(color0);\n	" : "color0 = sRGBToLinear(color0);\n	";
            if (effect.outputColorSpace !== (0, $ilwiq.NoColorSpace)) data.colorSpace = effect.outputColorSpace;
            else if (effect.inputColorSpace !== null) data.colorSpace = effect.inputColorSpace;
            const depthParamRegExp = /MainImage *\([\w\s,]*?depth[\w\s,]*?\)/;
            fragmentMainImage += `${prefix}MainImage(color0, UV, `;
            if ((data.attributes & $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH) !== 0 && depthParamRegExp.test(fragmentShader)) {
                fragmentMainImage += "depth, ";
                data.readDepth = true;
            }
            fragmentMainImage += "color1);\n	";
            const blendOpacity = prefix + "BlendOpacity";
            data.uniforms.set(blendOpacity, blendMode.opacity);
            fragmentMainImage += `color0 = blend${blendMode.blendFunction}(color0, color1, ${blendOpacity});

	`;
            fragmentHead += `uniform float ${blendOpacity};

`;
        }
        fragmentHead += fragmentShader + "\n";
        if (vertexShader !== null) vertexHead += vertexShader + "\n";
        shaderParts.set($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_HEAD, fragmentHead);
        shaderParts.set($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_UV, fragmentMainUv);
        shaderParts.set($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE, fragmentMainImage);
        shaderParts.set($fe721963ebf18f1b$export$a147810b69c6903e.VERTEX_HEAD, vertexHead);
        shaderParts.set($fe721963ebf18f1b$export$a147810b69c6903e.VERTEX_MAIN_SUPPORT, vertexMainSupport);
        if (effect.extensions !== null) for (const extension of effect.extensions)data.extensions.add(extension);
    }
}
var $fe721963ebf18f1b$export$9b60604040f63be5 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new effect pass.
   *
   * @param {Camera} camera - The main camera.
   * @param {...Effect} effects - The effects that will be rendered by this pass.
   */ constructor(camera, ...effects){
        super("EffectPass");
        this.fullscreenMaterial = new $fe721963ebf18f1b$export$a26662c57c109212(null, null, null, camera);
        this.listener = (event)=>this.handleEvent(event);
        this.effects = [];
        this.setEffects(effects);
        this.skipRendering = false;
        this.minTime = 1;
        this.maxTime = Number.POSITIVE_INFINITY;
        this.timeScale = 1;
    }
    set mainScene(value) {
        for (const effect of this.effects)effect.mainScene = value;
    }
    set mainCamera(value) {
        this.fullscreenMaterial.copyCameraSettings(value);
        for (const effect of this.effects)effect.mainCamera = value;
    }
    /**
   * Indicates whether this pass encodes its output when rendering to screen.
   *
   * @type {Boolean}
   * @deprecated Use fullscreenMaterial.encodeOutput instead.
   */ get encodeOutput() {
        return this.fullscreenMaterial.encodeOutput;
    }
    set encodeOutput(value) {
        this.fullscreenMaterial.encodeOutput = value;
    }
    /**
   * Indicates whether dithering is enabled.
   *
   * @type {Boolean}
   */ get dithering() {
        return this.fullscreenMaterial.dithering;
    }
    set dithering(value) {
        const material = this.fullscreenMaterial;
        material.dithering = value;
        material.needsUpdate = true;
    }
    /**
   * Sets the effects.
   *
   * @param {Effect[]} effects - The effects.
   * @protected
   */ setEffects(effects) {
        for (const effect of this.effects)effect.removeEventListener("change", this.listener);
        this.effects = effects.sort((a, b)=>b.attributes - a.attributes);
        for (const effect of this.effects)effect.addEventListener("change", this.listener);
    }
    /**
   * Updates the compound shader material.
   *
   * @protected
   */ updateMaterial() {
        const data = new $fe721963ebf18f1b$export$810aed40073d4f73();
        let id = 0;
        for (const effect of this.effects){
            if (effect.blendMode.blendFunction === $fe721963ebf18f1b$export$ea7520add44ba1b6.DST) data.attributes |= effect.getAttributes() & $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH;
            else if ((data.attributes & effect.getAttributes() & $fe721963ebf18f1b$export$a72ebb312f9e05c6.CONVOLUTION) !== 0) throw new Error(`Convolution effects cannot be merged (${effect.name})`);
            else $fe721963ebf18f1b$var$integrateEffect("e" + id++, effect, data);
        }
        let fragmentHead = data.shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_HEAD);
        let fragmentMainImage = data.shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE);
        let fragmentMainUv = data.shaderParts.get($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_UV);
        const blendRegExp = /\bblend\b/g;
        for (const blendMode of data.blendModes.values())fragmentHead += blendMode.getShaderCode().replace(blendRegExp, `blend${blendMode.blendFunction}`) + "\n";
        if ((data.attributes & $fe721963ebf18f1b$export$a72ebb312f9e05c6.DEPTH) !== 0) {
            if (data.readDepth) fragmentMainImage = "float depth = readDepth(UV);\n\n	" + fragmentMainImage;
            this.needsDepthTexture = this.getDepthTexture() === null;
        } else this.needsDepthTexture = false;
        if (data.colorSpace === (0, $ilwiq.SRGBColorSpace)) fragmentMainImage += "color0 = sRGBToLinear(color0);\n	";
        if (data.uvTransformation) {
            fragmentMainUv = "vec2 transformedUv = vUv;\n" + fragmentMainUv;
            data.defines.set("UV", "transformedUv");
        } else data.defines.set("UV", "vUv");
        data.shaderParts.set($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_HEAD, fragmentHead);
        data.shaderParts.set($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE, fragmentMainImage);
        data.shaderParts.set($fe721963ebf18f1b$export$a147810b69c6903e.FRAGMENT_MAIN_UV, fragmentMainUv);
        for (const [key, value] of data.shaderParts)if (value !== null) data.shaderParts.set(key, value.trim().replace(/^#/, "\n#"));
        this.skipRendering = id === 0;
        this.needsSwap = !this.skipRendering;
        this.fullscreenMaterial.setShaderData(data);
    }
    /**
   * Rebuilds the shader material.
   */ recompile() {
        this.updateMaterial();
    }
    /**
   * Returns the current depth texture.
   *
   * @return {Texture} The current depth texture, or null if there is none.
   */ getDepthTexture() {
        return this.fullscreenMaterial.depthBuffer;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ilwiq.BasicDepthPacking)) {
        this.fullscreenMaterial.depthBuffer = depthTexture;
        this.fullscreenMaterial.depthPacking = depthPacking;
        for (const effect of this.effects)effect.setDepthTexture(depthTexture, depthPacking);
    }
    /**
   * Renders the effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        for (const effect of this.effects)effect.update(renderer, inputBuffer, deltaTime);
        if (!this.skipRendering || this.renderToScreen) {
            const material = this.fullscreenMaterial;
            material.inputBuffer = inputBuffer.texture;
            material.time += deltaTime * this.timeScale;
            renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
            renderer.render(this.scene, this.camera);
        }
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.fullscreenMaterial.setSize(width, height);
        for (const effect of this.effects)effect.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.renderer = renderer;
        for (const effect of this.effects)effect.initialize(renderer, alpha, frameBufferType);
        this.updateMaterial();
        if (frameBufferType !== void 0 && frameBufferType !== (0, $ilwiq.UnsignedByteType)) this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
    }
    /**
   * Deletes disposable objects.
   */ dispose() {
        super.dispose();
        for (const effect of this.effects){
            effect.removeEventListener("change", this.listener);
            effect.dispose();
        }
    }
    /**
   * Handles events.
   *
   * @param {Event} event - An event.
   */ handleEvent(event) {
        switch(event.type){
            case "change":
                this.recompile();
                break;
        }
    }
};
var $fe721963ebf18f1b$export$5990dba06227c4dd = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new Gaussian blur pass.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.kernelSize=35] - The kernel size. Should be an odd number in the range [3, 1020].
   * @param {Number} [options.iterations=1] - The amount of times the blur should be applied.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   */ constructor({ kernelSize: kernelSize = 35, iterations: iterations = 1, resolutionScale: resolutionScale = 1, resolutionX: resolutionX = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionY: resolutionY = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE } = {}){
        super("GaussianBlurPass");
        this.renderTargetA = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetA.texture.name = "Blur.Target.A";
        this.renderTargetB = this.renderTargetA.clone();
        this.renderTargetB.texture.name = "Blur.Target.B";
        this.blurMaterial = new $fe721963ebf18f1b$export$c01ac62da39ecb86({
            kernelSize: kernelSize
        });
        this.copyMaterial = new $fe721963ebf18f1b$export$d4b5f24bda67f7e4();
        this.copyMaterial.inputBuffer = this.renderTargetB.texture;
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.iterations = iterations;
    }
    /**
   * Renders the blur.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const scene = this.scene;
        const camera = this.camera;
        const renderTargetA = this.renderTargetA;
        const renderTargetB = this.renderTargetB;
        const blurMaterial = this.blurMaterial;
        this.fullscreenMaterial = blurMaterial;
        let previousBuffer = inputBuffer;
        for(let i = 0, l = Math.max(this.iterations, 1); i < l; ++i){
            blurMaterial.direction.set(1, 0);
            blurMaterial.inputBuffer = previousBuffer.texture;
            renderer.setRenderTarget(renderTargetA);
            renderer.render(scene, camera);
            blurMaterial.direction.set(0, 1);
            blurMaterial.inputBuffer = renderTargetA.texture;
            renderer.setRenderTarget(renderTargetB);
            renderer.render(scene, camera);
            if (i === 0 && l > 1) previousBuffer = renderTargetB;
        }
        this.fullscreenMaterial = this.copyMaterial;
        renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
        renderer.render(scene, camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.renderTargetA.setSize(w, h);
        this.renderTargetB.setSize(w, h);
        this.blurMaterial.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0) {
            this.renderTargetA.texture.type = frameBufferType;
            this.renderTargetB.texture.type = frameBufferType;
            if (frameBufferType !== (0, $ilwiq.UnsignedByteType)) {
                this.blurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
                this.copyMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
            } else if (renderer !== null && renderer.outputColorSpace === (0, $ilwiq.SRGBColorSpace)) {
                this.renderTargetA.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
                this.renderTargetB.texture.colorSpace = (0, $ilwiq.SRGBColorSpace);
            }
        }
    }
};
// src/passes/LambdaPass.js
var $fe721963ebf18f1b$export$9eabb5915fb6b06 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new lambda pass.
   *
   * @param {Function} f - A function.
   */ constructor(f){
        super("LambdaPass", null, null);
        this.needsSwap = false;
        this.f = f;
    }
    /**
   * Executes the function.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        this.f();
    }
};
var $fe721963ebf18f1b$export$68bd776dda9a43a9 = class extends $fe721963ebf18f1b$export$802bc10488da99c7 {
    /**
   * Constructs a new normal pass.
   *
   * @param {Scene} scene - The scene to render.
   * @param {Camera} camera - The camera to use to render the scene.
   * @param {Object} [options] - The options.
   * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor(scene, camera, { renderTarget: renderTarget, resolutionScale: resolutionScale = 1, width: width = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, height: height = $fe721963ebf18f1b$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("NormalPass");
        this.needsSwap = false;
        this.renderPass = new $fe721963ebf18f1b$export$f63ea822f020b5b0(scene, camera, new (0, $ilwiq.MeshNormalMaterial)());
        const renderPass = this.renderPass;
        renderPass.ignoreBackground = true;
        renderPass.skipShadowMapUpdate = true;
        const clearPass = renderPass.getClearPass();
        clearPass.overrideClearColor = new (0, $ilwiq.Color)(7829503);
        clearPass.overrideClearAlpha = 1;
        this.renderTarget = renderTarget;
        if (this.renderTarget === void 0) {
            this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
                minFilter: (0, $ilwiq.NearestFilter),
                magFilter: (0, $ilwiq.NearestFilter)
            });
            this.renderTarget.texture.name = "NormalPass.Target";
        }
        const resolution = this.resolution = new $fe721963ebf18f1b$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    set mainScene(value) {
        this.renderPass.mainScene = value;
    }
    set mainCamera(value) {
        this.renderPass.mainCamera = value;
    }
    /**
   * The normal texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * The normal texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated Use resolution.preferredWidth or resolution.preferredHeight instead.
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated Use resolution.preferredWidth or resolution.preferredHeight instead.
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * Renders the scene normals.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const renderTarget = this.renderToScreen ? null : this.renderTarget;
        this.renderPass.render(renderer, renderTarget, renderTarget);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
    }
};
// src/textures/lut/TetrahedralUpscaler.js
var $fe721963ebf18f1b$var$P = [
    new Float32Array(3),
    new Float32Array(3)
];
var $fe721963ebf18f1b$var$C = [
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3)
];
var $fe721963ebf18f1b$var$T = [
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ]
];
function $fe721963ebf18f1b$var$calculateTetrahedronVolume(a, b, c2, d) {
    const bcX = c2[0] - b[0];
    const bcY = c2[1] - b[1];
    const bcZ = c2[2] - b[2];
    const baX = a[0] - b[0];
    const baY = a[1] - b[1];
    const baZ = a[2] - b[2];
    const crossX = bcY * baZ - bcZ * baY;
    const crossY = bcZ * baX - bcX * baZ;
    const crossZ = bcX * baY - bcY * baX;
    const length = Math.sqrt(crossX * crossX + crossY * crossY + crossZ * crossZ);
    const triangleArea = length * 0.5;
    const normalX = crossX / length;
    const normalY = crossY / length;
    const normalZ = crossZ / length;
    const constant = -(a[0] * normalX + a[1] * normalY + a[2] * normalZ);
    const dot = d[0] * normalX + d[1] * normalY + d[2] * normalZ;
    const height = Math.abs(dot + constant);
    return height * triangleArea / 3;
}
function $fe721963ebf18f1b$var$sample(data, size, x, y, z, color2) {
    const i4 = (x + y * size + z * size * size) * 4;
    color2[0] = data[i4 + 0];
    color2[1] = data[i4 + 1];
    color2[2] = data[i4 + 2];
}
function $fe721963ebf18f1b$var$tetrahedralSample(data, size, u, v3, w, color2) {
    const px = u * (size - 1);
    const py = v3 * (size - 1);
    const pz = w * (size - 1);
    const minX = Math.floor(px);
    const minY = Math.floor(py);
    const minZ = Math.floor(pz);
    const maxX = Math.ceil(px);
    const maxY = Math.ceil(py);
    const maxZ = Math.ceil(pz);
    const su = px - minX;
    const sv = py - minY;
    const sw = pz - minZ;
    if (minX === px && minY === py && minZ === pz) $fe721963ebf18f1b$var$sample(data, size, px, py, pz, color2);
    else {
        let vertices;
        if (su >= sv && sv >= sw) vertices = $fe721963ebf18f1b$var$T[0];
        else if (su >= sw && sw >= sv) vertices = $fe721963ebf18f1b$var$T[1];
        else if (sw >= su && su >= sv) vertices = $fe721963ebf18f1b$var$T[2];
        else if (sv >= su && su >= sw) vertices = $fe721963ebf18f1b$var$T[3];
        else if (sv >= sw && sw >= su) vertices = $fe721963ebf18f1b$var$T[4];
        else if (sw >= sv && sv >= su) vertices = $fe721963ebf18f1b$var$T[5];
        const [P0, P1, P2, P3] = vertices;
        const coords = $fe721963ebf18f1b$var$P[0];
        coords[0] = su;
        coords[1] = sv;
        coords[2] = sw;
        const tmp = $fe721963ebf18f1b$var$P[1];
        const diffX = maxX - minX;
        const diffY = maxY - minY;
        const diffZ = maxZ - minZ;
        tmp[0] = diffX * P0[0] + minX;
        tmp[1] = diffY * P0[1] + minY;
        tmp[2] = diffZ * P0[2] + minZ;
        $fe721963ebf18f1b$var$sample(data, size, tmp[0], tmp[1], tmp[2], $fe721963ebf18f1b$var$C[0]);
        tmp[0] = diffX * P1[0] + minX;
        tmp[1] = diffY * P1[1] + minY;
        tmp[2] = diffZ * P1[2] + minZ;
        $fe721963ebf18f1b$var$sample(data, size, tmp[0], tmp[1], tmp[2], $fe721963ebf18f1b$var$C[1]);
        tmp[0] = diffX * P2[0] + minX;
        tmp[1] = diffY * P2[1] + minY;
        tmp[2] = diffZ * P2[2] + minZ;
        $fe721963ebf18f1b$var$sample(data, size, tmp[0], tmp[1], tmp[2], $fe721963ebf18f1b$var$C[2]);
        tmp[0] = diffX * P3[0] + minX;
        tmp[1] = diffY * P3[1] + minY;
        tmp[2] = diffZ * P3[2] + minZ;
        $fe721963ebf18f1b$var$sample(data, size, tmp[0], tmp[1], tmp[2], $fe721963ebf18f1b$var$C[3]);
        const V0 = $fe721963ebf18f1b$var$calculateTetrahedronVolume(P1, P2, P3, coords) * 6;
        const V1 = $fe721963ebf18f1b$var$calculateTetrahedronVolume(P0, P2, P3, coords) * 6;
        const V2 = $fe721963ebf18f1b$var$calculateTetrahedronVolume(P0, P1, P3, coords) * 6;
        const V3 = $fe721963ebf18f1b$var$calculateTetrahedronVolume(P0, P1, P2, coords) * 6;
        $fe721963ebf18f1b$var$C[0][0] *= V0;
        $fe721963ebf18f1b$var$C[0][1] *= V0;
        $fe721963ebf18f1b$var$C[0][2] *= V0;
        $fe721963ebf18f1b$var$C[1][0] *= V1;
        $fe721963ebf18f1b$var$C[1][1] *= V1;
        $fe721963ebf18f1b$var$C[1][2] *= V1;
        $fe721963ebf18f1b$var$C[2][0] *= V2;
        $fe721963ebf18f1b$var$C[2][1] *= V2;
        $fe721963ebf18f1b$var$C[2][2] *= V2;
        $fe721963ebf18f1b$var$C[3][0] *= V3;
        $fe721963ebf18f1b$var$C[3][1] *= V3;
        $fe721963ebf18f1b$var$C[3][2] *= V3;
        color2[0] = $fe721963ebf18f1b$var$C[0][0] + $fe721963ebf18f1b$var$C[1][0] + $fe721963ebf18f1b$var$C[2][0] + $fe721963ebf18f1b$var$C[3][0];
        color2[1] = $fe721963ebf18f1b$var$C[0][1] + $fe721963ebf18f1b$var$C[1][1] + $fe721963ebf18f1b$var$C[2][1] + $fe721963ebf18f1b$var$C[3][1];
        color2[2] = $fe721963ebf18f1b$var$C[0][2] + $fe721963ebf18f1b$var$C[1][2] + $fe721963ebf18f1b$var$C[2][2] + $fe721963ebf18f1b$var$C[3][2];
    }
}
var $fe721963ebf18f1b$export$a7045d693b4714f8 = class {
    /**
   * Expands the given data to the target size.
   *
   * @param {TypedArray} data - The input RGBA data. Assumed to be cubic.
   * @param {Number} size - The target size.
   * @return {TypedArray} The new data.
   */ static expand(data, size) {
        const originalSize = Math.cbrt(data.length / 4);
        const rgb = new Float32Array(3);
        const array = new data.constructor(size ** 3 * 4);
        const maxValue = data instanceof Uint8Array ? 255 : 1;
        const sizeSq = size ** 2;
        const s = 1 / (size - 1);
        for(let z = 0; z < size; ++z){
            for(let y = 0; y < size; ++y)for(let x = 0; x < size; ++x){
                const u = x * s;
                const v3 = y * s;
                const w = z * s;
                const i4 = Math.round(x + y * size + z * sizeSq) * 4;
                $fe721963ebf18f1b$var$tetrahedralSample(data, originalSize, u, v3, w, rgb);
                array[i4 + 0] = rgb[0];
                array[i4 + 1] = rgb[1];
                array[i4 + 2] = rgb[2];
                array[i4 + 3] = maxValue;
            }
        }
        return array;
    }
};
// src/textures/smaa/SMAAAreaImageData.js
var $fe721963ebf18f1b$var$area = [
    new Float32Array(2),
    new Float32Array(2)
];
var $fe721963ebf18f1b$var$ORTHOGONAL_SIZE = 16;
var $fe721963ebf18f1b$var$DIAGONAL_SIZE = 20;
var $fe721963ebf18f1b$var$DIAGONAL_SAMPLES = 30;
var $fe721963ebf18f1b$var$SMOOTH_MAX_DISTANCE = 32;
var $fe721963ebf18f1b$var$orthogonalSubsamplingOffsets = new Float32Array([
    0,
    -0.25,
    0.25,
    -0.125,
    0.125,
    -0.375,
    0.375
]);
var $fe721963ebf18f1b$var$diagonalSubsamplingOffsets = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        0.25,
        -0.25
    ]),
    new Float32Array([
        -0.25,
        0.25
    ]),
    new Float32Array([
        0.125,
        -0.125
    ]),
    new Float32Array([
        -0.125,
        0.125
    ])
];
var $fe721963ebf18f1b$var$orthogonalEdges = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        3,
        3
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        4,
        0
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        4,
        3
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        0,
        4
    ]),
    new Uint8Array([
        3,
        4
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        4,
        1
    ]),
    new Uint8Array([
        1,
        4
    ]),
    new Uint8Array([
        4,
        4
    ])
];
var $fe721963ebf18f1b$var$diagonalEdges = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        0,
        2
    ]),
    new Uint8Array([
        1,
        2
    ]),
    new Uint8Array([
        2,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        2,
        2
    ]),
    new Uint8Array([
        3,
        2
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        2,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        2,
        3
    ]),
    new Uint8Array([
        3,
        3
    ])
];
function $fe721963ebf18f1b$var$lerp(a, b, p) {
    return a + (b - a) * p;
}
function $fe721963ebf18f1b$var$saturate(a) {
    return Math.min(Math.max(a, 0), 1);
}
function $fe721963ebf18f1b$var$smoothArea(d) {
    const a1 = $fe721963ebf18f1b$var$area[0];
    const a2 = $fe721963ebf18f1b$var$area[1];
    const b1X = Math.sqrt(a1[0] * 2) * 0.5;
    const b1Y = Math.sqrt(a1[1] * 2) * 0.5;
    const b2X = Math.sqrt(a2[0] * 2) * 0.5;
    const b2Y = Math.sqrt(a2[1] * 2) * 0.5;
    const p = $fe721963ebf18f1b$var$saturate(d / $fe721963ebf18f1b$var$SMOOTH_MAX_DISTANCE);
    a1[0] = $fe721963ebf18f1b$var$lerp(b1X, a1[0], p);
    a1[1] = $fe721963ebf18f1b$var$lerp(b1Y, a1[1], p);
    a2[0] = $fe721963ebf18f1b$var$lerp(b2X, a2[0], p);
    a2[1] = $fe721963ebf18f1b$var$lerp(b2Y, a2[1], p);
}
function $fe721963ebf18f1b$var$getOrthArea(p1X, p1Y, p2X, p2Y, x, result) {
    const dX = p2X - p1X;
    const dY = p2Y - p1Y;
    const x1 = x;
    const x2 = x + 1;
    const y1 = p1Y + dY * (x1 - p1X) / dX;
    const y2 = p1Y + dY * (x2 - p1X) / dX;
    if (x1 >= p1X && x1 < p2X || x2 > p1X && x2 <= p2X) {
        if (Math.sign(y1) === Math.sign(y2) || Math.abs(y1) < 1e-4 || Math.abs(y2) < 1e-4) {
            const a = (y1 + y2) / 2;
            if (a < 0) {
                result[0] = Math.abs(a);
                result[1] = 0;
            } else {
                result[0] = 0;
                result[1] = Math.abs(a);
            }
        } else {
            const t = -p1Y * dX / dY + p1X;
            const tInt = Math.trunc(t);
            const a1 = t > p1X ? y1 * (t - tInt) / 2 : 0;
            const a2 = t < p2X ? y2 * (1 - (t - tInt)) / 2 : 0;
            const a = Math.abs(a1) > Math.abs(a2) ? a1 : -a2;
            if (a < 0) {
                result[0] = Math.abs(a1);
                result[1] = Math.abs(a2);
            } else {
                result[0] = Math.abs(a2);
                result[1] = Math.abs(a1);
            }
        }
    } else {
        result[0] = 0;
        result[1] = 0;
    }
    return result;
}
function $fe721963ebf18f1b$var$getOrthAreaForPattern(pattern, left, right, offset, result) {
    const a1 = $fe721963ebf18f1b$var$area[0];
    const a2 = $fe721963ebf18f1b$var$area[1];
    const o1 = 0.5 + offset;
    const o2 = 0.5 + offset - 1;
    const d = left + right + 1;
    switch(pattern){
        case 0:
            result[0] = 0;
            result[1] = 0;
            break;
        case 1:
            if (left <= right) $fe721963ebf18f1b$var$getOrthArea(0, o2, d / 2, 0, left, result);
            else {
                result[0] = 0;
                result[1] = 0;
            }
            break;
        case 2:
            if (left >= right) $fe721963ebf18f1b$var$getOrthArea(d / 2, 0, d, o2, left, result);
            else {
                result[0] = 0;
                result[1] = 0;
            }
            break;
        case 3:
            $fe721963ebf18f1b$var$getOrthArea(0, o2, d / 2, 0, left, a1);
            $fe721963ebf18f1b$var$getOrthArea(d / 2, 0, d, o2, left, a2);
            $fe721963ebf18f1b$var$smoothArea(d, $fe721963ebf18f1b$var$area);
            result[0] = a1[0] + a2[0];
            result[1] = a1[1] + a2[1];
            break;
        case 4:
            if (left <= right) $fe721963ebf18f1b$var$getOrthArea(0, o1, d / 2, 0, left, result);
            else {
                result[0] = 0;
                result[1] = 0;
            }
            break;
        case 5:
            result[0] = 0;
            result[1] = 0;
            break;
        case 6:
            if (Math.abs(offset) > 0) {
                $fe721963ebf18f1b$var$getOrthArea(0, o1, d, o2, left, a1);
                $fe721963ebf18f1b$var$getOrthArea(0, o1, d / 2, 0, left, a2);
                $fe721963ebf18f1b$var$getOrthArea(d / 2, 0, d, o2, left, result);
                a2[0] = a2[0] + result[0];
                a2[1] = a2[1] + result[1];
                result[0] = (a1[0] + a2[0]) / 2;
                result[1] = (a1[1] + a2[1]) / 2;
            } else $fe721963ebf18f1b$var$getOrthArea(0, o1, d, o2, left, result);
            break;
        case 7:
            $fe721963ebf18f1b$var$getOrthArea(0, o1, d, o2, left, result);
            break;
        case 8:
            if (left >= right) $fe721963ebf18f1b$var$getOrthArea(d / 2, 0, d, o1, left, result);
            else {
                result[0] = 0;
                result[1] = 0;
            }
            break;
        case 9:
            if (Math.abs(offset) > 0) {
                $fe721963ebf18f1b$var$getOrthArea(0, o2, d, o1, left, a1);
                $fe721963ebf18f1b$var$getOrthArea(0, o2, d / 2, 0, left, a2);
                $fe721963ebf18f1b$var$getOrthArea(d / 2, 0, d, o1, left, result);
                a2[0] = a2[0] + result[0];
                a2[1] = a2[1] + result[1];
                result[0] = (a1[0] + a2[0]) / 2;
                result[1] = (a1[1] + a2[1]) / 2;
            } else $fe721963ebf18f1b$var$getOrthArea(0, o2, d, o1, left, result);
            break;
        case 10:
            result[0] = 0;
            result[1] = 0;
            break;
        case 11:
            $fe721963ebf18f1b$var$getOrthArea(0, o2, d, o1, left, result);
            break;
        case 12:
            $fe721963ebf18f1b$var$getOrthArea(0, o1, d / 2, 0, left, a1);
            $fe721963ebf18f1b$var$getOrthArea(d / 2, 0, d, o1, left, a2);
            $fe721963ebf18f1b$var$smoothArea(d, $fe721963ebf18f1b$var$area);
            result[0] = a1[0] + a2[0];
            result[1] = a1[1] + a2[1];
            break;
        case 13:
            $fe721963ebf18f1b$var$getOrthArea(0, o2, d, o1, left, result);
            break;
        case 14:
            $fe721963ebf18f1b$var$getOrthArea(0, o1, d, o2, left, result);
            break;
        case 15:
            result[0] = 0;
            result[1] = 0;
            break;
    }
    return result;
}
function $fe721963ebf18f1b$var$isInsideArea(a1X, a1Y, a2X, a2Y, x, y) {
    let result = a1X === a2X && a1Y === a2Y;
    if (!result) {
        const xm = (a1X + a2X) / 2;
        const ym = (a1Y + a2Y) / 2;
        const a = a2Y - a1Y;
        const b = a1X - a2X;
        const c2 = a * (x - xm) + b * (y - ym);
        result = c2 > 0;
    }
    return result;
}
function $fe721963ebf18f1b$var$getDiagAreaForPixel(a1X, a1Y, a2X, a2Y, pX, pY) {
    let n = 0;
    for(let y = 0; y < $fe721963ebf18f1b$var$DIAGONAL_SAMPLES; ++y)for(let x = 0; x < $fe721963ebf18f1b$var$DIAGONAL_SAMPLES; ++x){
        const offsetX = x / ($fe721963ebf18f1b$var$DIAGONAL_SAMPLES - 1);
        const offsetY = y / ($fe721963ebf18f1b$var$DIAGONAL_SAMPLES - 1);
        if ($fe721963ebf18f1b$var$isInsideArea(a1X, a1Y, a2X, a2Y, pX + offsetX, pY + offsetY)) ++n;
    }
    return n / ($fe721963ebf18f1b$var$DIAGONAL_SAMPLES * $fe721963ebf18f1b$var$DIAGONAL_SAMPLES);
}
function $fe721963ebf18f1b$var$getDiagArea(pattern, a1X, a1Y, a2X, a2Y, left, offset, result) {
    const e = $fe721963ebf18f1b$var$diagonalEdges[pattern];
    const e1 = e[0];
    const e2 = e[1];
    if (e1 > 0) {
        a1X += offset[0];
        a1Y += offset[1];
    }
    if (e2 > 0) {
        a2X += offset[0];
        a2Y += offset[1];
    }
    result[0] = 1 - $fe721963ebf18f1b$var$getDiagAreaForPixel(a1X, a1Y, a2X, a2Y, 1 + left, 0 + left);
    result[1] = $fe721963ebf18f1b$var$getDiagAreaForPixel(a1X, a1Y, a2X, a2Y, 1 + left, 1 + left);
    return result;
}
function $fe721963ebf18f1b$var$getDiagAreaForPattern(pattern, left, right, offset, result) {
    const a1 = $fe721963ebf18f1b$var$area[0];
    const a2 = $fe721963ebf18f1b$var$area[1];
    const d = left + right + 1;
    switch(pattern){
        case 0:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 1 + d, 1 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 1:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 0 + d, 0 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 2:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 0, 0, 1 + d, 0 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 3:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, result);
            break;
        case 4:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 0 + d, 0 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 5:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 0 + d, 0 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 6:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 1 + d, 0 + d, left, offset, result);
            break;
        case 7:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 1 + d, 0 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 8:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 0, 0, 1 + d, 1 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 1 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 9:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 1 + d, left, offset, result);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 1 + d, left, offset, result);
            break;
        case 10:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 0, 0, 1 + d, 1 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 11:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 1 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 12:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 1 + d, 1 + d, left, offset, result);
            break;
        case 13:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 1 + d, 1 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 1 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 14:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 1 + d, 1 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 15:
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 1, 1 + d, 1 + d, left, offset, a1);
            $fe721963ebf18f1b$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
    }
    return result;
}
function $fe721963ebf18f1b$var$generatePatterns(patterns, offset, orthogonal) {
    const result = new Float32Array(2);
    for(let i = 0, l = patterns.length; i < l; ++i){
        const pattern = patterns[i];
        const data = pattern.data;
        const size = pattern.width;
        for(let y = 0; y < size; ++y)for(let x = 0; x < size; ++x){
            if (orthogonal) $fe721963ebf18f1b$var$getOrthAreaForPattern(i, x, y, offset, result);
            else $fe721963ebf18f1b$var$getDiagAreaForPattern(i, x, y, offset, result);
            const c2 = (y * size + x) * 2;
            data[c2] = result[0] * 255;
            data[c2 + 1] = result[1] * 255;
        }
    }
}
function $fe721963ebf18f1b$var$assemble(baseX, baseY, patterns, edges2, size, orthogonal, target) {
    const dstData = target.data;
    const dstWidth = target.width;
    for(let i = 0, l = patterns.length; i < l; ++i){
        const edge = edges2[i];
        const pattern = patterns[i];
        const srcData = pattern.data;
        const srcWidth = pattern.width;
        for(let y = 0; y < size; ++y)for(let x = 0; x < size; ++x){
            const pX = edge[0] * size + baseX + x;
            const pY = edge[1] * size + baseY + y;
            const c2 = (pY * dstWidth + pX) * 4;
            const d = orthogonal ? (y * y * srcWidth + x * x) * 2 : (y * srcWidth + x) * 2;
            dstData[c2] = srcData[d];
            dstData[c2 + 1] = srcData[d + 1];
            dstData[c2 + 2] = 0;
            dstData[c2 + 3] = 255;
        }
    }
}
var $fe721963ebf18f1b$export$73fc6bfc4fcb4fee = class {
    /**
   * Creates a new area image.
   *
   * @return {RawImageData} The generated image data.
   */ static generate() {
        const width = 10 * $fe721963ebf18f1b$var$ORTHOGONAL_SIZE;
        const height = $fe721963ebf18f1b$var$orthogonalSubsamplingOffsets.length * 5 * $fe721963ebf18f1b$var$ORTHOGONAL_SIZE;
        const data = new Uint8ClampedArray(width * height * 4);
        const result = new $fe721963ebf18f1b$export$82a80f8de384fe62(width, height, data);
        const orthPatternSize = Math.pow($fe721963ebf18f1b$var$ORTHOGONAL_SIZE - 1, 2) + 1;
        const diagPatternSize = $fe721963ebf18f1b$var$DIAGONAL_SIZE;
        const orthogonalPatterns = [];
        const diagonalPatterns = [];
        for(let i = 3, l = data.length; i < l; i += 4)data[i] = 255;
        for(let i = 0; i < 16; ++i){
            orthogonalPatterns.push(new $fe721963ebf18f1b$export$82a80f8de384fe62(orthPatternSize, orthPatternSize, new Uint8ClampedArray(orthPatternSize * orthPatternSize * 2), 2));
            diagonalPatterns.push(new $fe721963ebf18f1b$export$82a80f8de384fe62(diagPatternSize, diagPatternSize, new Uint8ClampedArray(diagPatternSize * diagPatternSize * 2), 2));
        }
        for(let i = 0, l = $fe721963ebf18f1b$var$orthogonalSubsamplingOffsets.length; i < l; ++i){
            $fe721963ebf18f1b$var$generatePatterns(orthogonalPatterns, $fe721963ebf18f1b$var$orthogonalSubsamplingOffsets[i], true);
            $fe721963ebf18f1b$var$assemble(0, 5 * $fe721963ebf18f1b$var$ORTHOGONAL_SIZE * i, orthogonalPatterns, $fe721963ebf18f1b$var$orthogonalEdges, $fe721963ebf18f1b$var$ORTHOGONAL_SIZE, true, result);
        }
        for(let i = 0, l = $fe721963ebf18f1b$var$diagonalSubsamplingOffsets.length; i < l; ++i){
            $fe721963ebf18f1b$var$generatePatterns(diagonalPatterns, $fe721963ebf18f1b$var$diagonalSubsamplingOffsets[i], false);
            $fe721963ebf18f1b$var$assemble(5 * $fe721963ebf18f1b$var$ORTHOGONAL_SIZE, 4 * $fe721963ebf18f1b$var$DIAGONAL_SIZE * i, diagonalPatterns, $fe721963ebf18f1b$var$diagonalEdges, $fe721963ebf18f1b$var$DIAGONAL_SIZE, false, result);
        }
        return result;
    }
};
// tmp/smaa/worker.txt
var $fe721963ebf18f1b$var$worker_default2 = '"use strict";(()=>{function q(t,a,s){let e=document.createElement("canvas"),n=e.getContext("2d");if(e.width=t,e.height=a,s instanceof Image)n.drawImage(s,0,0);else{let r=n.createImageData(t,a);r.data.set(s),n.putImageData(r,0,0)}return e}var F=class t{constructor(a=0,s=0,e=null){this.width=a,this.height=s,this.data=e}toCanvas(){return typeof document=="undefined"?null:q(this.width,this.height,this.data)}static from(a){let{width:s,height:e}=a,n;if(a instanceof Image){let r=q(s,e,a);r!==null&&(n=r.getContext("2d").getImageData(0,0,s,e).data)}else n=a.data;return new t(s,e,n)}};var M=[new Float32Array(2),new Float32Array(2)],D=16,W=20,I=30,j=32,v=new Float32Array([0,-.25,.25,-.125,.125,-.375,.375]),N=[new Float32Array([0,0]),new Float32Array([.25,-.25]),new Float32Array([-.25,.25]),new Float32Array([.125,-.125]),new Float32Array([-.125,.125])],z=[new Uint8Array([0,0]),new Uint8Array([3,0]),new Uint8Array([0,3]),new Uint8Array([3,3]),new Uint8Array([1,0]),new Uint8Array([4,0]),new Uint8Array([1,3]),new Uint8Array([4,3]),new Uint8Array([0,1]),new Uint8Array([3,1]),new Uint8Array([0,4]),new Uint8Array([3,4]),new Uint8Array([1,1]),new Uint8Array([4,1]),new Uint8Array([1,4]),new Uint8Array([4,4])],p=[new Uint8Array([0,0]),new Uint8Array([1,0]),new Uint8Array([0,2]),new Uint8Array([1,2]),new Uint8Array([2,0]),new Uint8Array([3,0]),new Uint8Array([2,2]),new Uint8Array([3,2]),new Uint8Array([0,1]),new Uint8Array([1,1]),new Uint8Array([0,3]),new Uint8Array([1,3]),new Uint8Array([2,1]),new Uint8Array([3,1]),new Uint8Array([2,3]),new Uint8Array([3,3])];function C(t,a,s){return t+(a-t)*s}function B(t){return Math.min(Math.max(t,0),1)}function _(t){let a=M[0],s=M[1],e=Math.sqrt(a[0]*2)*.5,n=Math.sqrt(a[1]*2)*.5,r=Math.sqrt(s[0]*2)*.5,o=Math.sqrt(s[1]*2)*.5,c=B(t/j);a[0]=C(e,a[0],c),a[1]=C(n,a[1],c),s[0]=C(r,s[0],c),s[1]=C(o,s[1],c)}function d(t,a,s,e,n,r){let o=s-t,c=e-a,h=n,i=n+1,w=a+c*(h-t)/o,b=a+c*(i-t)/o;if(h>=t&&h<s||i>t&&i<=s)if(Math.sign(w)===Math.sign(b)||Math.abs(w)<1e-4||Math.abs(b)<1e-4){let g=(w+b)/2;g<0?(r[0]=Math.abs(g),r[1]=0):(r[0]=0,r[1]=Math.abs(g))}else{let g=-a*o/c+t,k=Math.trunc(g),m=g>t?w*(g-k)/2:0,U=g<s?b*(1-(g-k))/2:0;(Math.abs(m)>Math.abs(U)?m:-U)<0?(r[0]=Math.abs(m),r[1]=Math.abs(U)):(r[0]=Math.abs(U),r[1]=Math.abs(m))}else r[0]=0,r[1]=0;return r}function J(t,a,s,e,n){let r=M[0],o=M[1],c=.5+e,h=.5+e-1,i=a+s+1;switch(t){case 0:{n[0]=0,n[1]=0;break}case 1:{a<=s?d(0,h,i/2,0,a,n):(n[0]=0,n[1]=0);break}case 2:{a>=s?d(i/2,0,i,h,a,n):(n[0]=0,n[1]=0);break}case 3:{d(0,h,i/2,0,a,r),d(i/2,0,i,h,a,o),_(i,M),n[0]=r[0]+o[0],n[1]=r[1]+o[1];break}case 4:{a<=s?d(0,c,i/2,0,a,n):(n[0]=0,n[1]=0);break}case 5:{n[0]=0,n[1]=0;break}case 6:{Math.abs(e)>0?(d(0,c,i,h,a,r),d(0,c,i/2,0,a,o),d(i/2,0,i,h,a,n),o[0]=o[0]+n[0],o[1]=o[1]+n[1],n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2):d(0,c,i,h,a,n);break}case 7:{d(0,c,i,h,a,n);break}case 8:{a>=s?d(i/2,0,i,c,a,n):(n[0]=0,n[1]=0);break}case 9:{Math.abs(e)>0?(d(0,h,i,c,a,r),d(0,h,i/2,0,a,o),d(i/2,0,i,c,a,n),o[0]=o[0]+n[0],o[1]=o[1]+n[1],n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2):d(0,h,i,c,a,n);break}case 10:{n[0]=0,n[1]=0;break}case 11:{d(0,h,i,c,a,n);break}case 12:{d(0,c,i/2,0,a,r),d(i/2,0,i,c,a,o),_(i,M),n[0]=r[0]+o[0],n[1]=r[1]+o[1];break}case 13:{d(0,h,i,c,a,n);break}case 14:{d(0,c,i,h,a,n);break}case 15:{n[0]=0,n[1]=0;break}}return n}function K(t,a,s,e,n,r){let o=t===s&&a===e;if(!o){let c=(t+s)/2,h=(a+e)/2,i=e-a,w=t-s;o=i*(n-c)+w*(r-h)>0}return o}function G(t,a,s,e,n,r){let o=0;for(let c=0;c<I;++c)for(let h=0;h<I;++h){let i=h/(I-1),w=c/(I-1);K(t,a,s,e,n+i,r+w)&&++o}return o/(I*I)}function A(t,a,s,e,n,r,o,c){let h=p[t],i=h[0],w=h[1];return i>0&&(a+=o[0],s+=o[1]),w>0&&(e+=o[0],n+=o[1]),c[0]=1-G(a,s,e,n,1+r,0+r),c[1]=G(a,s,e,n,1+r,1+r),c}function Q(t,a,s,e,n){let r=M[0],o=M[1],c=a+s+1;switch(t){case 0:{A(t,1,1,1+c,1+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 1:{A(t,1,0,0+c,0+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 2:{A(t,0,0,1+c,0+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 3:{A(t,1,0,1+c,0+c,a,e,n);break}case 4:{A(t,1,1,0+c,0+c,a,e,r),A(t,1,1,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 5:{A(t,1,1,0+c,0+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 6:{A(t,1,1,1+c,0+c,a,e,n);break}case 7:{A(t,1,1,1+c,0+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 8:{A(t,0,0,1+c,1+c,a,e,r),A(t,1,0,1+c,1+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 9:{A(t,1,0,1+c,1+c,a,e,n),A(t,1,0,1+c,1+c,a,e,n);break}case 10:{A(t,0,0,1+c,1+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 11:{A(t,1,0,1+c,1+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 12:{A(t,1,1,1+c,1+c,a,e,n);break}case 13:{A(t,1,1,1+c,1+c,a,e,r),A(t,1,0,1+c,1+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 14:{A(t,1,1,1+c,1+c,a,e,r),A(t,1,1,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 15:{A(t,1,1,1+c,1+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}}return n}function R(t,a,s){let e=new Float32Array(2);for(let n=0,r=t.length;n<r;++n){let o=t[n],c=o.data,h=o.width;for(let i=0;i<h;++i)for(let w=0;w<h;++w){s?J(n,w,i,a,e):Q(n,w,i,a,e);let b=(i*h+w)*2;c[b]=e[0]*255,c[b+1]=e[1]*255}}}function T(t,a,s,e,n,r,o){let c=o.data,h=o.width;for(let i=0,w=s.length;i<w;++i){let b=e[i],g=s[i],k=g.data,m=g.width;for(let U=0;U<n;++U)for(let x=0;x<n;++x){let Z=b[0]*n+t+x,O=((b[1]*n+a+U)*h+Z)*4,L=r?(U*U*m+x*x)*2:(U*m+x)*2;c[O]=k[L],c[O+1]=k[L+1],c[O+2]=0,c[O+3]=255}}}var S=class{static generate(){let a=10*D,s=v.length*5*D,e=new Uint8ClampedArray(a*s*4),n=new F(a,s,e),r=Math.pow(D-1,2)+1,o=W,c=[],h=[];for(let i=3,w=e.length;i<w;i+=4)e[i]=255;for(let i=0;i<16;++i)c.push(new F(r,r,new Uint8ClampedArray(r*r*2),2)),h.push(new F(o,o,new Uint8ClampedArray(o*o*2),2));for(let i=0,w=v.length;i<w;++i)R(c,v[i],!0),T(0,5*D*i,c,z,D,!0,n);for(let i=0,w=N.length;i<w;++i)R(h,N[i],!1),T(5*D,4*W*i,h,p,W,!1,n);return n}};var P=new Map([[y(0,0,0,0),new Float32Array([0,0,0,0])],[y(0,0,0,1),new Float32Array([0,0,0,1])],[y(0,0,1,0),new Float32Array([0,0,1,0])],[y(0,0,1,1),new Float32Array([0,0,1,1])],[y(0,1,0,0),new Float32Array([0,1,0,0])],[y(0,1,0,1),new Float32Array([0,1,0,1])],[y(0,1,1,0),new Float32Array([0,1,1,0])],[y(0,1,1,1),new Float32Array([0,1,1,1])],[y(1,0,0,0),new Float32Array([1,0,0,0])],[y(1,0,0,1),new Float32Array([1,0,0,1])],[y(1,0,1,0),new Float32Array([1,0,1,0])],[y(1,0,1,1),new Float32Array([1,0,1,1])],[y(1,1,0,0),new Float32Array([1,1,0,0])],[y(1,1,0,1),new Float32Array([1,1,0,1])],[y(1,1,1,0),new Float32Array([1,1,1,0])],[y(1,1,1,1),new Float32Array([1,1,1,1])]]);function H(t,a,s){return t+(a-t)*s}function y(t,a,s,e){let n=H(t,a,.75),r=H(s,e,1-.25);return H(n,r,1-.125)}function V(t,a){let s=0;return a[3]===1&&(s+=1),s===1&&a[2]===1&&t[1]!==1&&t[3]!==1&&(s+=1),s}function $(t,a){let s=0;return a[3]===1&&t[1]!==1&&t[3]!==1&&(s+=1),s===1&&a[2]===1&&t[0]!==1&&t[2]!==1&&(s+=1),s}var E=class{static generate(){let o=new Uint8ClampedArray(2178),c=new Uint8ClampedArray(64*16*4);for(let h=0;h<33;++h)for(let i=0;i<66;++i){let w=.03125*i,b=.03125*h;if(P.has(w)&&P.has(b)){let g=P.get(w),k=P.get(b),m=h*66+i;o[m]=127*V(g,k),o[m+33]=127*$(g,k)}}for(let h=0,i=17;i<33;++i)for(let w=0;w<64;++w,h+=4)c[h]=o[i*66+w],c[h+3]=255;return new F(64,16,c)}};self.addEventListener("message",t=>{let a=S.generate(),s=E.generate();postMessage({areaImageData:a,searchImageData:s},[a.data.buffer,s.data.buffer]),close()});})();\n';
// src/textures/smaa/SMAAImageGenerator.js
function $fe721963ebf18f1b$var$generate(useCache = true) {
    const workerURL = URL.createObjectURL(new Blob([
        $fe721963ebf18f1b$var$worker_default2
    ], {
        type: "text/javascript"
    }));
    const worker = new Worker(workerURL);
    URL.revokeObjectURL(workerURL);
    return new Promise((resolve, reject)=>{
        worker.addEventListener("error", (event)=>reject(event.error));
        worker.addEventListener("message", (event)=>{
            const searchImageData = $fe721963ebf18f1b$export$82a80f8de384fe62.from(event.data.searchImageData);
            const areaImageData = $fe721963ebf18f1b$export$82a80f8de384fe62.from(event.data.areaImageData);
            const urls = [
                searchImageData.toCanvas().toDataURL("image/png", 1),
                areaImageData.toCanvas().toDataURL("image/png", 1)
            ];
            if (useCache) {
                localStorage.setItem("smaa-search", urls[0]);
                localStorage.setItem("smaa-area", urls[1]);
            }
            resolve(urls);
        });
        worker.postMessage(null);
    });
}
var $fe721963ebf18f1b$export$ca191ed58d7431fe = class {
    /**
   * Constructs a new SMAA image generator.
   */ constructor(){
        this.disableCache = false;
    }
    /**
   * Enables or disables caching via localStorage.
   *
   * @param {Boolean} value - Whether the cache should be enabled.
   */ setCacheEnabled(value) {
        this.disableCache = !value;
    }
    /**
   * Generates the SMAA data images.
   *
   * @example
   * SMAAImageGenerator.generate().then(([search, area]) => {
   *   const smaaEffect = new SMAAEffect(search, area);
   * });
   * @return {Promise<Image[]>} A promise that returns the search image and area image as a pair.
   */ generate() {
        const useCache = !this.disableCache && window.localStorage !== void 0;
        const cachedURLs = useCache ? [
            localStorage.getItem("smaa-search"),
            localStorage.getItem("smaa-area")
        ] : [
            null,
            null
        ];
        const promise = cachedURLs[0] !== null && cachedURLs[1] !== null ? Promise.resolve(cachedURLs) : $fe721963ebf18f1b$var$generate(useCache);
        return promise.then((urls)=>{
            return new Promise((resolve, reject)=>{
                const searchImage = new Image();
                const areaImage = new Image();
                const manager = new (0, $ilwiq.LoadingManager)();
                manager.onLoad = ()=>resolve([
                        searchImage,
                        areaImage
                    ]);
                manager.onError = reject;
                searchImage.addEventListener("error", (e)=>manager.itemError("smaa-search"));
                areaImage.addEventListener("error", (e)=>manager.itemError("smaa-area"));
                searchImage.addEventListener("load", ()=>manager.itemEnd("smaa-search"));
                areaImage.addEventListener("load", ()=>manager.itemEnd("smaa-area"));
                manager.itemStart("smaa-search");
                manager.itemStart("smaa-area");
                searchImage.src = urls[0];
                areaImage.src = urls[1];
            });
        });
    }
};
// src/textures/smaa/SMAASearchImageData.js
var $fe721963ebf18f1b$var$edges = /* @__PURE__ */ new Map([
    [
        $fe721963ebf18f1b$var$bilinear(0, 0, 0, 0),
        new Float32Array([
            0,
            0,
            0,
            0
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(0, 0, 0, 1),
        new Float32Array([
            0,
            0,
            0,
            1
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(0, 0, 1, 0),
        new Float32Array([
            0,
            0,
            1,
            0
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(0, 0, 1, 1),
        new Float32Array([
            0,
            0,
            1,
            1
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(0, 1, 0, 0),
        new Float32Array([
            0,
            1,
            0,
            0
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(0, 1, 0, 1),
        new Float32Array([
            0,
            1,
            0,
            1
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(0, 1, 1, 0),
        new Float32Array([
            0,
            1,
            1,
            0
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(0, 1, 1, 1),
        new Float32Array([
            0,
            1,
            1,
            1
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(1, 0, 0, 0),
        new Float32Array([
            1,
            0,
            0,
            0
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(1, 0, 0, 1),
        new Float32Array([
            1,
            0,
            0,
            1
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(1, 0, 1, 0),
        new Float32Array([
            1,
            0,
            1,
            0
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(1, 0, 1, 1),
        new Float32Array([
            1,
            0,
            1,
            1
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(1, 1, 0, 0),
        new Float32Array([
            1,
            1,
            0,
            0
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(1, 1, 0, 1),
        new Float32Array([
            1,
            1,
            0,
            1
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(1, 1, 1, 0),
        new Float32Array([
            1,
            1,
            1,
            0
        ])
    ],
    [
        $fe721963ebf18f1b$var$bilinear(1, 1, 1, 1),
        new Float32Array([
            1,
            1,
            1,
            1
        ])
    ]
]);
function $fe721963ebf18f1b$var$lerp2(a, b, p) {
    return a + (b - a) * p;
}
function $fe721963ebf18f1b$var$bilinear(e0, e1, e2, e3) {
    const a = $fe721963ebf18f1b$var$lerp2(e0, e1, 0.75);
    const b = $fe721963ebf18f1b$var$lerp2(e2, e3, 0.75);
    return $fe721963ebf18f1b$var$lerp2(a, b, 0.875);
}
function $fe721963ebf18f1b$var$deltaLeft(left, top) {
    let d = 0;
    if (top[3] === 1) d += 1;
    if (d === 1 && top[2] === 1 && left[1] !== 1 && left[3] !== 1) d += 1;
    return d;
}
function $fe721963ebf18f1b$var$deltaRight(left, top) {
    let d = 0;
    if (top[3] === 1 && left[1] !== 1 && left[3] !== 1) d += 1;
    if (d === 1 && top[2] === 1 && left[0] !== 1 && left[2] !== 1) d += 1;
    return d;
}
var $fe721963ebf18f1b$export$fcf9afd86c84a43a = class {
    /**
   * Creates a new search image.
   *
   * @return {RawImageData} The generated image data.
   */ static generate() {
        const width = 66;
        const height = 33;
        const halfWidth = width / 2;
        const croppedWidth = 64;
        const croppedHeight = 16;
        const data = new Uint8ClampedArray(width * height);
        const croppedData = new Uint8ClampedArray(croppedWidth * croppedHeight * 4);
        for(let y = 0; y < height; ++y)for(let x = 0; x < width; ++x){
            const s = 0.03125 * x;
            const t = 0.03125 * y;
            if ($fe721963ebf18f1b$var$edges.has(s) && $fe721963ebf18f1b$var$edges.has(t)) {
                const e1 = $fe721963ebf18f1b$var$edges.get(s);
                const e2 = $fe721963ebf18f1b$var$edges.get(t);
                const i = y * width + x;
                data[i] = 127 * $fe721963ebf18f1b$var$deltaLeft(e1, e2);
                data[i + halfWidth] = 127 * $fe721963ebf18f1b$var$deltaRight(e1, e2);
            }
        }
        for(let i = 0, y = height - croppedHeight; y < height; ++y)for(let x = 0; x < croppedWidth; ++x, i += 4){
            croppedData[i] = data[y * width + x];
            croppedData[i + 3] = 255;
        }
        return new $fe721963ebf18f1b$export$82a80f8de384fe62(croppedWidth, croppedHeight, croppedData);
    }
};


// src/index.ts


var $ilwiq = parcelRequire("ilwiq");
// src/bilateralFilter.frag
var $359f518c62257e95$var$bilateralFilter_default = "uniform sampler2D tInput;uniform vec2 resolution;uniform float bSigma;varying vec2 vUv;\n#if (KSIZE_ENUM == 0)\n#define KSIZE 2\n#define MSIZE 5\nconst float kernel[MSIZE]=float[MSIZE](0.,0.24196934138575799,0.39894,0.24196934138575799,0.);\n#elif (KSIZE_ENUM == 1)\n#define KSIZE 3\n#define MSIZE 7\nconst float kernel[MSIZE]=float[MSIZE](0.,0.39104045872899694,0.3969502784491287,0.39894,0.3969502784491287,0.39104045872899694,0.);\n#elif (KSIZE_ENUM == 2)\n#define KSIZE 4\n#define MSIZE 9\nconst float kernel[MSIZE]=float[MSIZE](0.,0.3813856354024969,0.39104045872899694,0.3969502784491287,0.39894,0.3969502784491287,0.39104045872899694,0.3813856354024969,0.);\n#elif (KSIZE_ENUM == 3)\n#define KSIZE 5\n#define MSIZE 11\nconst float kernel[MSIZE]=float[MSIZE](0.,0.03682680352274845,0.03813856354024969,0.039104045872899694,0.03969502784491287,0.039894,0.03969502784491287,0.039104045872899694,0.03813856354024969,0.03682680352274845,0.);\n#elif (KSIZE_ENUM == 4)\n#define KSIZE 6\n#define MSIZE 13\nconst float kernel[MSIZE]=float[MSIZE](0.,0.035206331431709856,0.03682680352274845,0.03813856354024969,0.039104045872899694,0.03969502784491287,0.039894,0.03969502784491287,0.039104045872899694,0.03813856354024969,0.03682680352274845,0.035206331431709856,0.);\n#elif (KSIZE_ENUM == 5)\n#define KSIZE 7\n#define MSIZE 15\nconst float kernel[MSIZE]=float[MSIZE](0.031225216,0.033322271,0.035206333,0.036826804,0.038138565,0.039104044,0.039695028,0.039894000,0.039695028,0.039104044,0.038138565,0.036826804,0.035206333,0.033322271,0.031225216);\n#endif\nfloat normpdf(in float x,in float sigma){return 0.39894*exp(-0.5*x*x/(sigma*sigma))/sigma;}float normpdf3(in vec3 v,in float sigma){return 0.39894*exp(-0.5*dot(v,v)/(sigma*sigma))/sigma;}void main(){vec3 c=texture(tInput,vUv).rgb;ivec2 fragCoord=ivec2(vUv*resolution);vec3 finalColor=vec3(0.);float bZ=1.0/normpdf(0.0,bSigma);float totalFactor=0.;for(int i=-KSIZE;i<=KSIZE;++i){for(int j=-KSIZE;j<=KSIZE;++j){vec3 cc=texelFetch(tInput,fragCoord+ivec2(i,j),0).rgb;float factor=normpdf3(cc-c,bSigma)*bZ*kernel[KSIZE+j]*kernel[KSIZE+i];totalFactor+=factor;finalColor+=factor*cc;}}gl_FragColor=vec4(finalColor/totalFactor,1.);}";
// src/compositor.vert
var $359f518c62257e95$var$compositor_default = "varying vec2 vUv;void main(){vUv=uv;gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0);}";
// src/bilateralFilter.ts
var $359f518c62257e95$var$GODRAYS_BLUR_RESOLUTION_SCALE = 1;
var $359f518c62257e95$var$BilateralFilterMaterial = class extends $ilwiq.ShaderMaterial {
    constructor(input){
        super({
            uniforms: {
                tInput: {
                    value: input
                },
                resolution: {
                    value: new $ilwiq.Vector2(input.image.width * $359f518c62257e95$var$GODRAYS_BLUR_RESOLUTION_SCALE, input.image.height * $359f518c62257e95$var$GODRAYS_BLUR_RESOLUTION_SCALE)
                },
                bSigma: {
                    value: 0
                }
            },
            defines: {
                KSIZE_ENUM: (0, $fe721963ebf18f1b$export$543b1e4815577d06).SMALL
            },
            vertexShader: $359f518c62257e95$var$compositor_default,
            fragmentShader: $359f518c62257e95$var$bilateralFilter_default
        });
    }
};
var $359f518c62257e95$var$BilateralFilterPass = class extends (0, $fe721963ebf18f1b$export$802bc10488da99c7) {
    constructor(input){
        super("BilateralFilterPass", void 0, new $ilwiq.Camera());
        this.needsSwap = false;
        this.material = new $359f518c62257e95$var$BilateralFilterMaterial(input);
        this.fullscreenMaterial = this.material;
    }
    setSize(width, height) {
        this.material.uniforms.resolution.value.set(width, height);
    }
    render(renderer, _inputBuffer, outputBuffer, _deltaTime, _stencilTest) {
        renderer.setRenderTarget(outputBuffer);
        renderer.render(this.scene, this.camera);
    }
    updateUniforms(params) {
        this.material.uniforms.bSigma.value = params.variance;
        this.material.defines.KSIZE_ENUM = params.kernelSize;
    }
    dispose() {
        this.material.dispose();
        super.dispose();
    }
};
// src/compositor.frag
var $359f518c62257e95$var$compositor_default2 = "#include <common>\nuniform sampler2D godrays;uniform sampler2D sceneDiffuse;uniform sampler2D sceneDepth;uniform float edgeStrength;uniform float edgeRadius;uniform vec2 resolution;uniform float near;uniform float far;uniform vec3 color;uniform bool gammaCorrection;varying vec2 vUv;\n#define DITHERING\n#include <dithering_pars_fragment>\nfloat linearize_depth(float depth,float zNear,float zFar){\n#if defined( USE_LOGDEPTHBUF )\nfloat d=pow(2.0,depth*log2(far+1.0))-1.0;float a=far/(far-near);float b=far*near/(near-far);depth=a+b/d;\n#endif\nreturn zNear*zFar/(zFar+depth*(zNear-zFar));}vec4 LinearTosRGB_(in vec4 value){return vec4(mix(pow(value.rgb,vec3(0.41666))*1.055-vec3(0.055),value.rgb*12.92,vec3(lessThanEqual(value.rgb,vec3(0.0031308)))),value.a);}void main(){float rawDepth=texture2D(sceneDepth,vUv).x;float correctDepth=linearize_depth(rawDepth,near,far);vec2 pushDir=vec2(0.0);float count=0.0;for(float x=-edgeRadius;x<=edgeRadius;x++){for(float y=-edgeRadius;y<=edgeRadius;y++){vec2 sampleUv=(vUv*resolution+vec2(x,y))/resolution;float sampleDepth=texelFetch(sceneDepth,ivec2(sampleUv*resolution),0).x;sampleDepth=linearize_depth(sampleDepth,near,far);if(abs(sampleDepth-correctDepth)<0.05*correctDepth){pushDir+=vec2(x,y);count+=1.0;}}}if(count==0.0){count=1.0;}pushDir/=count;pushDir=normalize(pushDir);vec2 sampleUv=length(pushDir)>0.0?vUv+edgeStrength*(pushDir/resolution):vUv;float bestChoice=texture2D(godrays,sampleUv).x;vec3 diffuse=texture2D(sceneDiffuse,vUv).rgb;gl_FragColor=vec4(mix(diffuse,color,bestChoice),1.0);\n#include <dithering_fragment>\nif(gammaCorrection){gl_FragColor=LinearTosRGB_(gl_FragColor);}}";
// src/compositorPass.ts
var $359f518c62257e95$var$GodraysCompositorMaterial = class extends $ilwiq.ShaderMaterial {
    constructor({ godrays: godrays, edgeStrength: edgeStrength, edgeRadius: edgeRadius, color: color, camera: camera, gammaCorrection: gammaCorrection }){
        const uniforms = {
            godrays: {
                value: godrays
            },
            sceneDiffuse: {
                value: null
            },
            sceneDepth: {
                value: null
            },
            edgeStrength: {
                value: edgeStrength
            },
            edgeRadius: {
                value: edgeRadius
            },
            near: {
                value: 0.1
            },
            far: {
                value: 1e3
            },
            color: {
                value: color
            },
            resolution: {
                value: new $ilwiq.Vector2(1, 1)
            },
            gammaCorrection: {
                value: 1
            }
        };
        super({
            name: "GodraysCompositorMaterial",
            uniforms: uniforms,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $359f518c62257e95$var$compositor_default2,
            vertexShader: $359f518c62257e95$var$compositor_default
        });
        this.updateUniforms(edgeStrength, edgeRadius, color, gammaCorrection, camera.near, camera.far);
    }
    updateUniforms(edgeStrength, edgeRadius, color, gammaCorrection, near, far) {
        this.uniforms.edgeStrength.value = edgeStrength;
        this.uniforms.edgeRadius.value = edgeRadius;
        this.uniforms.color.value = color;
        this.uniforms.near.value = near;
        this.uniforms.far.value = far;
        this.uniforms.gammaCorrection.value = gammaCorrection ? 1 : 0;
    }
    setSize(width, height) {
        this.uniforms.resolution.value.set(width, height);
    }
};
var $359f518c62257e95$var$GodraysCompositorPass = class extends (0, $fe721963ebf18f1b$export$802bc10488da99c7) {
    constructor(props){
        super("GodraysCompositorPass", void 0, new $ilwiq.Camera());
        this.depthCopyRenderTexture = null;
        this.depthTextureCopyPass = null;
        this.fullscreenMaterial = new $359f518c62257e95$var$GodraysCompositorMaterial(props);
        this.sceneCamera = props.camera;
    }
    updateUniforms(params) {
        this.fullscreenMaterial.updateUniforms(params.edgeStrength, params.edgeRadius, params.color, params.gammaCorrection, this.sceneCamera.near, this.sceneCamera.far);
    }
    render(renderer, inputBuffer, outputBuffer, _deltaTime, _stencilTest) {
        this.fullscreenMaterial.uniforms.sceneDiffuse.value = inputBuffer.texture;
        const sceneDepth = this.fullscreenMaterial.uniforms.sceneDepth.value;
        if (sceneDepth && outputBuffer && outputBuffer.depthTexture && sceneDepth === outputBuffer.depthTexture) {
            if (!this.depthCopyRenderTexture) this.depthCopyRenderTexture = new $ilwiq.WebGLRenderTarget(outputBuffer.depthTexture.image.width, outputBuffer.depthTexture.image.height, {
                minFilter: outputBuffer.depthTexture.minFilter,
                magFilter: outputBuffer.depthTexture.magFilter,
                format: outputBuffer.depthTexture.format,
                generateMipmaps: outputBuffer.depthTexture.generateMipmaps
            });
            if (!this.depthTextureCopyPass) this.depthTextureCopyPass = new (0, $fe721963ebf18f1b$export$ec9e16bd0f76e979)();
            this.depthTextureCopyPass.render(renderer, this.fullscreenMaterial.uniforms.sceneDepth.value, this.depthCopyRenderTexture);
            this.fullscreenMaterial.uniforms.sceneDepth.value = this.depthCopyRenderTexture.texture;
        }
        renderer.setRenderTarget(outputBuffer);
        renderer.render(this.scene, this.camera);
        this.fullscreenMaterial.uniforms.sceneDepth.value = sceneDepth;
    }
    setDepthTexture(depthTexture, depthPacking) {
        if (depthPacking && depthPacking !== $ilwiq.BasicDepthPacking) throw new Error("Only BasicDepthPacking is supported");
        this.fullscreenMaterial.uniforms.sceneDepth.value = depthTexture;
    }
    setSize(width, height) {
        this.fullscreenMaterial.setSize(width, height);
    }
};
var $359f518c62257e95$var$BlueNoiseTextureDataURI = "data:image/png;base64,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";
var $359f518c62257e95$var$getBlueNoiseTexture = async ()=>{
    const textureLoader = new $ilwiq.TextureLoader();
    const blueNoiseTexture = await textureLoader.loadAsync($359f518c62257e95$var$BlueNoiseTextureDataURI);
    blueNoiseTexture.wrapS = $ilwiq.RepeatWrapping;
    blueNoiseTexture.wrapT = $ilwiq.RepeatWrapping;
    blueNoiseTexture.magFilter = $ilwiq.NearestFilter;
    blueNoiseTexture.minFilter = $ilwiq.NearestFilter;
    blueNoiseTexture.generateMipmaps = false;
    return blueNoiseTexture;
};
// src/godrays.frag
var $359f518c62257e95$var$godrays_default = "varying vec2 vUv;uniform sampler2D sceneDepth;uniform sampler2D blueNoise;uniform vec3 lightPos;uniform vec3 cameraPos;uniform vec2 resolution;uniform mat4 cameraProjectionMatrixInv;uniform mat4 cameraMatrixWorld;\n#if defined(USE_CUBE_SHADOWMAP)\nuniform samplerCube shadowMap;\n#else\nuniform sampler2D shadowMap;\n#endif\nuniform vec2 noiseResolution;uniform float texelSizeY;uniform float lightCameraNear;uniform float lightCameraFar;uniform float near;uniform float far;uniform float density;uniform float maxDensity;uniform float distanceAttenuation;uniform vec3[6]fNormals;uniform float[6]fConstants;uniform float raymarchSteps;uniform mat4 premultipliedLightCameraMatrix;\n#include <packing>\nvec3 WorldPosFromDepth(float depth,vec2 coord){\n#if defined( USE_LOGDEPTHBUF )\nfloat d=pow(2.0,depth*log2(far+1.0))-1.0;float a=far/(far-near);float b=far*near/(near-far);depth=a+b/d;\n#endif\nfloat z=depth*2.0-1.0;vec4 clipSpacePosition=vec4(coord*2.0-1.0,z,1.0);vec4 viewSpacePosition=cameraProjectionMatrixInv*clipSpacePosition;viewSpacePosition/=viewSpacePosition.w;vec4 worldSpacePosition=cameraMatrixWorld*viewSpacePosition;return worldSpacePosition.xyz;}vec2 cubeToUV(vec3 v){vec3 absV=abs(v);float scaleToCube=1.0/max(absV.x,max(absV.y,absV.z));absV*=scaleToCube;v*=scaleToCube*(1.0-2.0*texelSizeY);vec2 planar=v.xy;float almostATexel=1.5*texelSizeY;float almostOne=1.0-almostATexel;if(absV.z>=almostOne){if(v.z>0.0)planar.x=4.0-v.x;}else if(absV.x>=almostOne){float signX=sign(v.x);planar.x=v.z*signX+2.0*signX;}else if(absV.y>=almostOne){float signY=sign(v.y);planar.x=v.x+2.0*signY+2.0;planar.y=v.z*signY-2.0;}return vec2(0.125,0.25)*planar+vec2(0.375,0.75);}vec3 projectToShadowMap(vec3 worldPos){vec4 lightSpacePos=premultipliedLightCameraMatrix*vec4(worldPos,1.0);lightSpacePos/=lightSpacePos.w;lightSpacePos=lightSpacePos*0.5+0.5;return lightSpacePos.xyz;}vec2 inShadow(vec3 worldPos){\n#if defined(USE_CUBE_SHADOWMAP)\nvec3 lightToPos=worldPos-lightPos;float lightDist=length(lightToPos);float shadowMapDepth=textureCube(shadowMap,lightToPos).r;float depth=lightCameraNear+(lightCameraFar-lightCameraNear)*shadowMapDepth;return vec2(float(lightDist>depth+0.005),lightDist);\n#else\n#if defined(IS_POINT_LIGHT)\nvec2 shadowMapUV=cubeToUV(normalize(worldPos-lightPos));\n#elif defined(IS_DIRECTIONAL_LIGHT)\nvec3 shadowMapUV=projectToShadowMap(worldPos);bool isOutsideShadowMap=shadowMapUV.x<0.0||shadowMapUV.x>1.0||shadowMapUV.y<0.0||shadowMapUV.y>1.0||shadowMapUV.z<0.0||shadowMapUV.z>1.0;if(isOutsideShadowMap){return vec2(1.0,0.0);}\n#endif\nvec4 packedDepth=texture2D(shadowMap,shadowMapUV.xy);\n#if defined( USE_UNPACKED_DEPTH )\n#if defined(IS_DIRECTIONAL_LIGHT)\nfloat depth=packedDepth.x;\n#else\nfloat depth=1.-packedDepth.x;\n#endif\n#else\nfloat depth=unpackRGBAToDepth(packedDepth);\n#endif\ndepth=lightCameraNear+(lightCameraFar-lightCameraNear)*depth;\n#if defined(IS_POINT_LIGHT)\nfloat lightDist=distance(worldPos,lightPos);\n#elif defined(IS_DIRECTIONAL_LIGHT)\nfloat lightDist=(lightCameraNear+(lightCameraFar-lightCameraNear)*shadowMapUV.z);\n#endif\nfloat difference=lightDist-depth;return vec2(float(difference>0.0),lightDist);\n#endif\n}float sdPlane(vec3 p,vec3 n,float h){return dot(p,n)+h;}float intersectRayPlane(vec3 rayOrigin,vec3 rayDirection,vec3 planeNormal,float planeDistance){float denom=dot(planeNormal,rayDirection);return-(sdPlane(rayOrigin,planeNormal,planeDistance)/denom);}void main(){float depth=texture2D(sceneDepth,vUv).x;vec3 worldPos=WorldPosFromDepth(depth,vUv);float inBoxDist=-10000.0;for(int i=0;i<6;i++){inBoxDist=max(inBoxDist,sdPlane(cameraPos,fNormals[i],fConstants[i]));}bool cameraIsInBox=inBoxDist<0.0;vec3 startPos=cameraPos;if(cameraIsInBox){for(int i=0;i<6;i++){if(sdPlane(worldPos,fNormals[i],fConstants[i])>0.0){vec3 direction=normalize(worldPos-cameraPos);float t=intersectRayPlane(cameraPos,direction,fNormals[i],fConstants[i]);worldPos=cameraPos+t*direction;}}}else{vec3 direction=normalize(worldPos-cameraPos);float minT=10000.0;for(int i=0;i<6;i++){float t=intersectRayPlane(cameraPos,direction,fNormals[i],fConstants[i]);if(t<minT&&t>0.0){minT=t;}}if(minT==10000.0){gl_FragColor=vec4(0.0,0.0,0.0,1.0);return;}startPos=cameraPos+(minT+0.001)*direction;float endInBoxDist=-10000.0;for(int i=0;i<6;i++){endInBoxDist=max(endInBoxDist,sdPlane(worldPos,fNormals[i],fConstants[i]));}bool endInBox=false;if(endInBoxDist<0.0){endInBox=true;}if(!endInBox){float minT=10000.0;for(int i=0;i<6;i++){if(sdPlane(worldPos,fNormals[i],fConstants[i])>0.0){float t=intersectRayPlane(startPos,direction,fNormals[i],fConstants[i]);if(t<minT&&t>0.0){minT=t;}}}if(minT<distance(worldPos,startPos)){worldPos=startPos+minT*direction;}}}float illum=0.0;vec4 blueNoiseSample=texture2D(blueNoise,vUv*(resolution/noiseResolution));float samplesFloat=round(raymarchSteps+((raymarchSteps/8.)+2.)*blueNoiseSample.x);int samples=int(samplesFloat);for(int i=0;i<samples;i++){vec3 samplePos=mix(startPos,worldPos,float(i)/samplesFloat);vec2 shadowInfo=inShadow(samplePos);float shadowAmount=1.0-shadowInfo.x;illum+=shadowAmount*(distance(startPos,worldPos)*density)*pow(1.0-shadowInfo.y/lightCameraFar,distanceAttenuation);}illum/=samplesFloat;gl_FragColor=vec4(vec3(clamp(1.0-exp(-illum),0.0,maxDensity)),depth);}";
// src/godrays.vert
var $359f518c62257e95$var$godrays_default2 = "varying vec2 vUv;void main(){vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}";
// src/illumPass.ts
var $359f518c62257e95$var$GODRAYS_RESOLUTION_SCALE = 0.5;
var $359f518c62257e95$var$GodraysMaterial = class extends $ilwiq.ShaderMaterial {
    constructor(light){
        const uniforms = {
            density: {
                value: 1 / 128
            },
            maxDensity: {
                value: 0.5
            },
            distanceAttenuation: {
                value: 2
            },
            sceneDepth: {
                value: null
            },
            lightPos: {
                value: new $ilwiq.Vector3(0, 0, 0)
            },
            cameraPos: {
                value: new $ilwiq.Vector3(0, 0, 0)
            },
            resolution: {
                value: new $ilwiq.Vector2(1, 1)
            },
            premultipliedLightCameraMatrix: {
                value: new $ilwiq.Matrix4()
            },
            cameraProjectionMatrixInv: {
                value: new $ilwiq.Matrix4()
            },
            cameraMatrixWorld: {
                value: new $ilwiq.Matrix4()
            },
            shadowMap: {
                value: null
            },
            texelSizeY: {
                value: 1
            },
            lightCameraNear: {
                value: 0.1
            },
            lightCameraFar: {
                value: 1e3
            },
            near: {
                value: 0.1
            },
            far: {
                value: 1e3
            },
            blueNoise: {
                value: null
            },
            noiseResolution: {
                value: new $ilwiq.Vector2(1, 1)
            },
            fNormals: {
                value: $359f518c62257e95$var$DIRECTIONS.map(()=>new $ilwiq.Vector3())
            },
            fConstants: {
                value: $359f518c62257e95$var$DIRECTIONS.map(()=>0)
            },
            raymarchSteps: {
                value: 60
            }
        };
        const defines = {};
        if (light instanceof $ilwiq.PointLight || light.isPointLight) defines.IS_POINT_LIGHT = "";
        else if (light instanceof $ilwiq.DirectionalLight || light.isDirectionalLight) defines.IS_DIRECTIONAL_LIGHT = "";
        const threeVersion = +$ilwiq.REVISION;
        if (threeVersion >= 182) defines.USE_UNPACKED_DEPTH = "";
        super({
            name: "GodraysMaterial",
            uniforms: uniforms,
            fragmentShader: $359f518c62257e95$var$godrays_default,
            vertexShader: $359f518c62257e95$var$godrays_default2,
            defines: defines
        });
        $359f518c62257e95$var$getBlueNoiseTexture().then((blueNoiseTexture)=>{
            uniforms.blueNoise.value = blueNoiseTexture;
            uniforms.noiseResolution.value.set(blueNoiseTexture.image.width, blueNoiseTexture.image.height);
        });
    }
};
var $359f518c62257e95$var$DIRECTIONS = [
    new $ilwiq.Vector3(1, 0, 0),
    new $ilwiq.Vector3(-1, 0, 0),
    new $ilwiq.Vector3(0, 1, 0),
    new $ilwiq.Vector3(0, -1, 0),
    new $ilwiq.Vector3(0, 0, 1),
    new $ilwiq.Vector3(0, 0, -1)
];
var $359f518c62257e95$var$PLANES = $359f518c62257e95$var$DIRECTIONS.map(()=>new $ilwiq.Plane());
var $359f518c62257e95$var$SCRATCH_VECTOR = new $ilwiq.Vector3();
var $359f518c62257e95$var$SCRATCH_FRUSTUM = new $ilwiq.Frustum();
var $359f518c62257e95$var$SCRATCH_MAT4 = new $ilwiq.Matrix4();
var $359f518c62257e95$var$GodraysIllumPass = class extends (0, $fe721963ebf18f1b$export$802bc10488da99c7) {
    constructor(props, params){
        super("GodraysPass", void 0, new $ilwiq.Camera());
        this.shadowMapSet = false;
        this.lightWorldPos = new $ilwiq.Vector3();
        this.props = props;
        this.lastParams = params;
        this.material = new $359f518c62257e95$var$GodraysMaterial(props.light);
        this.updateUniforms(props, params);
        this.fullscreenMaterial = this.material;
    }
    setSize(width, height) {
        this.material.uniforms.resolution.value.set(Math.ceil(width * $359f518c62257e95$var$GODRAYS_RESOLUTION_SCALE), Math.ceil(height * $359f518c62257e95$var$GODRAYS_RESOLUTION_SCALE));
        this.material.uniforms.near.value = this.props.camera.near;
        this.material.uniforms.far.value = this.props.camera.far;
    }
    render(renderer, _inputBuffer, outputBuffer, _deltaTime, _stencilTest) {
        var _a;
        if (!this.shadowMapSet && ((_a = this.props.light.shadow.map) == null ? void 0 : _a.texture)) {
            this.updateUniforms(this.props, this.lastParams);
            this.shadowMapSet = true;
        }
        this.updateLightParams(this.props);
        renderer.setRenderTarget(outputBuffer);
        renderer.render(this.scene, this.camera);
    }
    setDepthTexture(depthTexture, depthPacking) {
        this.material.uniforms.sceneDepth.value = depthTexture;
        if (depthPacking && depthPacking !== $ilwiq.BasicDepthPacking) throw new Error("Only BasicDepthPacking is supported");
    }
    updateLightParams({ light: light }) {
        light.getWorldPosition(this.lightWorldPos);
        const uniforms = this.material.uniforms;
        uniforms.premultipliedLightCameraMatrix.value.multiplyMatrices(light.shadow.camera.projectionMatrix, light.shadow.camera.matrixWorldInverse);
        if (light instanceof $ilwiq.PointLight || light.isPointLight) for(let i = 0; i < $359f518c62257e95$var$DIRECTIONS.length; i += 1){
            const direction = $359f518c62257e95$var$DIRECTIONS[i];
            const plane = $359f518c62257e95$var$PLANES[i];
            $359f518c62257e95$var$SCRATCH_VECTOR.copy(light.position);
            $359f518c62257e95$var$SCRATCH_VECTOR.addScaledVector(direction, uniforms.lightCameraFar.value);
            plane.setFromNormalAndCoplanarPoint(direction, $359f518c62257e95$var$SCRATCH_VECTOR);
            uniforms.fNormals.value[i].copy(plane.normal);
            uniforms.fConstants.value[i] = plane.constant;
        }
        else if (light instanceof $ilwiq.DirectionalLight || light.isDirectionalLight) {
            $359f518c62257e95$var$SCRATCH_MAT4.multiplyMatrices(light.shadow.camera.projectionMatrix, light.shadow.camera.matrixWorldInverse);
            $359f518c62257e95$var$SCRATCH_FRUSTUM.setFromProjectionMatrix($359f518c62257e95$var$SCRATCH_MAT4);
            for(let planeIx = 0; planeIx < 6; planeIx += 1){
                const plane = $359f518c62257e95$var$SCRATCH_FRUSTUM.planes[planeIx];
                uniforms.fNormals.value[planeIx].copy(plane.normal).multiplyScalar(-1);
                uniforms.fConstants.value[planeIx] = plane.constant * -1;
            }
        }
    }
    updateUniforms({ light: light, camera: camera }, params) {
        var _a, _b, _c, _d, _e, _f, _g;
        const shadow = light.shadow;
        if (!shadow) throw new Error("Light used for godrays must have shadow");
        let shadowMap = (_b = (_a = shadow.map) == null ? void 0 : _a.texture) != null ? _b : null;
        if ((light instanceof $ilwiq.DirectionalLight || light.isDirectionalLight) && ((_c = shadow.map) == null ? void 0 : _c.depthTexture)) shadowMap = shadow.map.depthTexture;
        const mapSize = (_e = (_d = shadow.map) == null ? void 0 : _d.height) != null ? _e : 1;
        if (shadowMap && shadowMap.isCubeTexture) {
            if (this.material.defines.USE_CUBE_SHADOWMAP === void 0) {
                this.material.defines.USE_CUBE_SHADOWMAP = "";
                this.material.needsUpdate = true;
            }
        } else if (this.material.defines.USE_CUBE_SHADOWMAP !== void 0) {
            delete this.material.defines.USE_CUBE_SHADOWMAP;
            this.material.needsUpdate = true;
        }
        const uniforms = this.material.uniforms;
        uniforms.density.value = params.density;
        uniforms.maxDensity.value = params.maxDensity;
        uniforms.lightPos.value = this.lightWorldPos;
        uniforms.cameraPos.value = camera.position;
        uniforms.cameraProjectionMatrixInv.value = camera.projectionMatrixInverse;
        uniforms.cameraMatrixWorld.value = camera.matrixWorld;
        uniforms.shadowMap.value = shadowMap;
        uniforms.texelSizeY.value = 1 / (mapSize * 2);
        uniforms.lightCameraNear.value = (_f = shadow == null ? void 0 : shadow.camera.near) != null ? _f : 0.1;
        uniforms.lightCameraFar.value = (_g = shadow == null ? void 0 : shadow.camera.far) != null ? _g : 1e3;
        uniforms.near.value = camera.near;
        uniforms.far.value = camera.far;
        uniforms.density.value = params.density;
        uniforms.maxDensity.value = params.maxDensity;
        uniforms.distanceAttenuation.value = params.distanceAttenuation;
        uniforms.raymarchSteps.value = params.raymarchSteps;
    }
};
// src/index.ts
var $359f518c62257e95$var$defaultParams = {
    density: 1 / 128,
    maxDensity: 0.5,
    edgeStrength: 2,
    edgeRadius: 2,
    distanceAttenuation: 2,
    color: new $ilwiq.Color(16777215),
    raymarchSteps: 60,
    blur: true,
    gammaCorrection: true
};
var $359f518c62257e95$var$populateParams = (partialParams)=>{
    var _a;
    return {
        ...$359f518c62257e95$var$defaultParams,
        ...partialParams,
        color: new $ilwiq.Color((_a = partialParams.color) != null ? _a : $359f518c62257e95$var$defaultParams.color)
    };
};
var $359f518c62257e95$var$defaultGodraysBlurParams = {
    variance: 0.1,
    kernelSize: (0, $fe721963ebf18f1b$export$543b1e4815577d06).SMALL
};
var $359f518c62257e95$var$populateGodraysBlurParams = (blur)=>{
    if (typeof blur === "boolean") return {
        ...$359f518c62257e95$var$defaultGodraysBlurParams
    };
    return {
        ...$359f518c62257e95$var$defaultGodraysBlurParams,
        ...blur
    };
};
var $359f518c62257e95$export$f09470d9976132bc = class extends (0, $fe721963ebf18f1b$export$802bc10488da99c7) {
    /**
   * Constructs a new GodraysPass.  Casts godrays from a point light source.  Add to your scene's composer like this:
   *
   * ```ts
   * import { EffectComposer, RenderPass } from 'postprocessing';
   * import { GodraysPass } from 'three-good-godrays';
   *
   * const composer = new EffectComposer(renderer, { frameBufferType: THREE.HalfFloatType });
   * const renderPass = new RenderPass(scene, camera);
   * renderPass.renderToScreen = false;
   * composer.addPass(renderPass);
   *
   * const godraysPass = new GodraysPass(pointLight, camera);
   * godraysPass.renderToScreen = true;
   * composer.addPass(godraysPass);
   *
   * function animate() {
   *   composer.render(scene, camera);
   * }
   * ```
   *
   * @param light The light source to use for the godrays.
   * @param camera The camera used to render the scene.
   * @param partialParams The parameters to use for the godrays effect.  Will use default values for any parameters not specified.
   */ constructor(light, camera, partialParams = {}){
        super("GodraysPass", void 0, new $ilwiq.Camera());
        this.depthTexture = null;
        this.depthPacking = null;
        this.godraysRenderTarget = new $ilwiq.WebGLRenderTarget(1, 1, {
            minFilter: $ilwiq.LinearFilter,
            magFilter: $ilwiq.LinearFilter,
            format: $ilwiq.RGBAFormat,
            type: $ilwiq.HalfFloatType,
            generateMipmaps: false
        });
        this.enableBlurPass = true;
        this.blurPass = null;
        this.blurRenderTarget = null;
        this.props = {
            light: light,
            camera: camera
        };
        const params = $359f518c62257e95$var$populateParams(partialParams);
        this.lastParams = params;
        this.illumPass = new $359f518c62257e95$var$GodraysIllumPass(this.props, params);
        this.illumPass.needsDepthTexture = true;
        this.compositorPass = new $359f518c62257e95$var$GodraysCompositorPass({
            godrays: this.godraysRenderTarget.texture,
            edgeStrength: params.edgeStrength,
            edgeRadius: params.edgeRadius,
            color: params.color,
            camera: camera,
            gammaCorrection: params.gammaCorrection
        });
        this.compositorPass.needsDepthTexture = true;
        this.needsDepthTexture = true;
        this.setParams(params);
    }
    /**
   * Updates the parameters used for the godrays effect.  Will use default values for any parameters not specified.
   */ setParams(partialParams) {
        const params = $359f518c62257e95$var$populateParams(partialParams);
        this.lastParams = params;
        this.illumPass.updateUniforms(this.props, params);
        this.compositorPass.updateUniforms(params);
        this.enableBlurPass = !!params.blur;
        if (params.blur && this.blurPass) {
            const blurParams = $359f518c62257e95$var$populateGodraysBlurParams(params.blur);
            if (this.blurPass.material.defines.KSIZE_ENUM !== blurParams.kernelSize) {
                this.blurPass.dispose();
                this.maybeInitBlur(this.godraysRenderTarget.texture);
            }
            this.blurPass.updateUniforms(blurParams);
        }
    }
    maybeInitBlur(input) {
        var _a;
        if (!this.blurPass) {
            this.blurPass = new $359f518c62257e95$var$BilateralFilterPass(input);
            const blurParams = $359f518c62257e95$var$populateGodraysBlurParams(this.lastParams.blur);
            this.blurPass.updateUniforms(blurParams);
            if (this.depthTexture) this.blurPass.setDepthTexture(this.depthTexture, (_a = this.depthPacking) != null ? _a : void 0);
        }
        if (!this.blurRenderTarget) this.blurRenderTarget = new $ilwiq.WebGLRenderTarget(Math.ceil(this.godraysRenderTarget.width * $359f518c62257e95$var$GODRAYS_BLUR_RESOLUTION_SCALE), Math.ceil(this.godraysRenderTarget.height * $359f518c62257e95$var$GODRAYS_BLUR_RESOLUTION_SCALE), {
            minFilter: $ilwiq.LinearFilter,
            magFilter: $ilwiq.LinearFilter,
            format: $ilwiq.RGBAFormat,
            type: $ilwiq.HalfFloatType,
            generateMipmaps: false
        });
    }
    render(renderer, inputBuffer, outputBuffer, _deltaTime, _stencilTest) {
        this.illumPass.render(renderer, inputBuffer, this.godraysRenderTarget);
        if (this.enableBlurPass) {
            this.maybeInitBlur(this.godraysRenderTarget.texture);
            this.blurPass.render(renderer, this.godraysRenderTarget, this.blurRenderTarget);
            this.compositorPass.fullscreenMaterial.uniforms.godrays.value = this.blurRenderTarget.texture;
        } else this.compositorPass.fullscreenMaterial.uniforms.godrays.value = this.godraysRenderTarget.texture;
        this.compositorPass.render(renderer, inputBuffer, this.renderToScreen ? null : outputBuffer);
    }
    setDepthTexture(depthTexture, depthPacking) {
        this.illumPass.setDepthTexture(depthTexture, depthPacking);
        this.compositorPass.setDepthTexture(depthTexture, depthPacking);
        this.depthTexture = depthTexture;
        this.depthPacking = depthPacking;
    }
    setSize(width, height) {
        var _a, _b;
        this.godraysRenderTarget.setSize(Math.ceil(width * $359f518c62257e95$var$GODRAYS_RESOLUTION_SCALE), Math.ceil(height * $359f518c62257e95$var$GODRAYS_RESOLUTION_SCALE));
        this.illumPass.setSize(width, height);
        this.compositorPass.setSize(width, height);
        (_a = this.blurPass) == null || _a.setSize(Math.ceil(width * $359f518c62257e95$var$GODRAYS_RESOLUTION_SCALE), Math.ceil(height * $359f518c62257e95$var$GODRAYS_RESOLUTION_SCALE));
        (_b = this.blurRenderTarget) == null || _b.setSize(Math.ceil(width * $359f518c62257e95$var$GODRAYS_RESOLUTION_SCALE * $359f518c62257e95$var$GODRAYS_BLUR_RESOLUTION_SCALE), Math.ceil(height * $359f518c62257e95$var$GODRAYS_RESOLUTION_SCALE * $359f518c62257e95$var$GODRAYS_BLUR_RESOLUTION_SCALE));
    }
    dispose() {
        var _a;
        this.godraysRenderTarget.dispose();
        this.illumPass.dispose();
        this.compositorPass.dispose();
        (_a = this.blurPass) == null || _a.dispose;
        super.dispose();
    }
};


// RedScreenEffect.js


var $ilwiq = parcelRequire("ilwiq");
// Fragment shader as a string (since we can't import .frag files in this environment)
const $0a9c335b89a84bd1$var$fragmentShader = `
uniform float opacity;

void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
    // Mix original color with red
    vec3 redColor = vec3(1.0, 0.0, 0.0);
    vec3 mixedColor = mix(inputColor.rgb, redColor, opacity);
    
    outputColor = vec4(mixedColor, inputColor.a);
}
`;
class $0a9c335b89a84bd1$export$eacc1449123771f5 extends (0, $fe721963ebf18f1b$export$a32b0b1c1ac59d04) {
    constructor(opacity = 0.5){
        super("RedScreenEffect", $0a9c335b89a84bd1$var$fragmentShader, {
            blendFunction: (0, $fe721963ebf18f1b$export$ea7520add44ba1b6).NORMAL,
            uniforms: new Map([
                [
                    "opacity",
                    new (0, $ilwiq.Uniform)(opacity)
                ]
            ])
        });
    }
    // Helper method to update red intensity
    setOpacity(value) {
        this.uniforms.get("opacity").value = value;
    }
} //Fragment shader that reads and displays depth
 // const fragmentShader = `
 // uniform float cameraNear;
 // uniform float cameraFar;
 // uniform float fogStart;
 // uniform float fogEnd;
 // float readDepth(sampler2D depthSampler, vec2 coord) {
 //     float fragCoordZ = texture2D(depthSampler, coord).x;
 //     float viewZ = perspectiveDepthToViewZ(fragCoordZ, cameraNear, cameraFar);
 //     return viewZToOrthographicDepth(viewZ, cameraNear, cameraFar);
 // }
 // void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
 //     float fogEnd = 500.0;
 //     float fogStart = 150.0;
 //     float fogPower = 0.9;
 //     float fogIntensity = 0.75;
 //     vec3 fogColor = vec3(2.0, 2.0, 2.0);
 //     // Read linearized depth value (0.0 = near plane, 1.0 = far plane)
 //     float depth = readDepth(depthBuffer, uv);
 //     // Convert normalized depth back to world space distance
 //     float worldDistance = mix(cameraNear, cameraFar, depth);
 //     // Remap world distance to fog range
 //     //float fogFactor = smoothstep(fogStart, fogEnd, worldDistance);
 //     // Alternative: use linear interpolation instead of smoothstep
 //     float fogFactorLinear = clamp((worldDistance - fogStart) / (fogEnd - fogStart), 0.0, 1.0);
 //     // Apply power curve for smooth falloff
 //     float fogFactor = pow(fogFactorLinear, fogPower);
 //     // Mix original color with fog color based on fog factor
 //     // fogFactor = 0.0 -> show original color (no fog)
 //     // fogFactor = 1.0 -> show fog color (full fog)
 //     vec3 mixedColor = mix(inputColor.rgb, fogColor.a, fogFactor * fogIntensity);
 //     outputColor = vec4(mixedColor, 1.0);
 // }
 // `;




var $ilwiq = parcelRequire("ilwiq");
const $ee0ff4ab0aa277e6$var$fragmentShader = `
uniform mat4 projectionMatrixInverse;
uniform mat4 viewMatrixInverse;
uniform float fog_intensity;


// Function to reconstruct world position
vec3 getWorldPositionFromDepth(vec2 uv, float depth) {
    // Convert depth to NDC
    float z = depth * 2.0 - 1.0;

    // Convert UV to NDC
    vec2 ndc = uv * 2.0 - 1.0;

    // Create clip space position
    vec4 clipPos = vec4(ndc, z, 1.0);

    // Transform to view space
    vec4 viewPos = projectionMatrixInverse * clipPos;
    viewPos /= viewPos.w;

    // Transform to world space
    vec4 worldPos = viewMatrixInverse * viewPos;
    return worldPos.xyz;
}

void mainImage(const in vec4 inputColor, const in vec2 uv, const in float depth, out vec4 outputColor) {
    vec4 original = inputColor;
    float viewZ = getViewZ(depth);

    float fogStart = 0.0;
    float fogEnd = 200.0;
    float distance = -viewZ;

    float fogFactorLinear = clamp((distance - fogStart) / (fogEnd - fogStart), 0.0, 1.0);
    float fogFactor = pow(fogFactorLinear, 2.0);

    // Get world position
    vec3 worldPos = getWorldPositionFromDepth(uv, depth);

    // Height-based fog mask
    float worldHeightMin = 0.0;   // World Y where fog is strongest
    float worldHeightMax = 250.0;  // World Y where fog fades out

    // Calculate height mask (1 = full fog at bottom, 0 = no fog at top)
    float heightMaskLinear = 1.0 - clamp((worldPos.y - worldHeightMin) / (worldHeightMax - worldHeightMin), 0.0, 1.0);
    float heightMask = pow(heightMaskLinear, 2.0);

    // Combine distance and height fog
    float finalFogFactor = fogFactor * heightMask;

    vec4 fogColor = vec4(0.95, 0.9, 0.8, 0.5); // Warm golden-white

    
    outputColor = mix(original, fogColor, finalFogFactor); // Added 0.5 to reduce intensity
}
`;
class $ee0ff4ab0aa277e6$export$662d94658d24c8c extends (0, $fe721963ebf18f1b$export$a32b0b1c1ac59d04) {
    constructor(camera, fogIntensity){
        super("FogEffect", $ee0ff4ab0aa277e6$var$fragmentShader, {
            blendFunction: (0, $fe721963ebf18f1b$export$ea7520add44ba1b6).NORMAL,
            attributes: (0, $fe721963ebf18f1b$export$a72ebb312f9e05c6).DEPTH,
            uniforms: new Map([
                [
                    "fog_intensity",
                    new (0, $ilwiq.Uniform)(fogIntensity)
                ],
                [
                    "projectionMatrixInverse",
                    new (0, $ilwiq.Uniform)(camera.projectionMatrixInverse)
                ],
                [
                    "viewMatrixInverse",
                    new (0, $ilwiq.Uniform)(camera.matrixWorld)
                ],
                [
                    "cameraNear",
                    new (0, $ilwiq.Uniform)(camera.near)
                ],
                [
                    "cameraFar",
                    new (0, $ilwiq.Uniform)(camera.far)
                ]
            ])
        });
        this.camera = camera;
    }
} /*
import { BlendFunction, Effect, EffectAttribute } from "postprocessing";
import { Uniform } from "three";



const fragmentShader = `
uniform float cameraNear;
uniform float cameraFar;
uniform float fogStart;
uniform float fogEnd;
uniform float fogIntensity;
uniform mat4 cameraInverseProjectionMatrix;
uniform mat4 cameraMatrixWorld;

float readDepth(sampler2D depthSampler, vec2 coord) {
    float fragCoordZ = texture2D(depthSampler, coord).x; //raw depth value (0.0 - 1.0) stored in depth buffer NDC nomalized device coord. 
    float viewZ = perspectiveDepthToViewZ(fragCoordZ, cameraNear, cameraFar); //transform to view space -> actual -z value to fragment
    //return viewZ;
    return viewZToOrthographicDepth(viewZ, cameraNear, cameraFar);
}

vec3 getWorldPositionFromDepth(vec2 uv, float depth) {
    // Convert UV to NDC coordinates
    vec2 ndc = uv * 2.0 - 1.0;

    // Create NDC position with depth
    vec4 ndcPos = vec4(ndc, depth * 2.0 - 1.0, 1.0);

    // Transform to view space
    vec4 viewPos = cameraInverseProjectionMatrix * ndcPos;
    viewPos /= viewPos.w;

    // Transform to world space
    vec4 worldPos = cameraMatrixWorld * viewPos;

    return worldPos.xyz;
}

void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {

    float fogEnd = 500.0;
    float fogStart = 0.0;
    float fogPower = 0.9;
    float fogIntensity = 0.75;
    vec3 fogColor = vec3(1.0, 1.0, 1.0);

    // Height fog parameters
    float fogHeightStart = 0.0;   // Height where fog starts
    float fogHeightEnd = 20.0;    // Height where fog is fully applied
    float fogHeightFalloff = 1.5; // Controls how sharply fog cuts off with height

    // Read linearized depth value
    float depth = readDepth(depthBuffer, uv);

    // Convert normalized depth back to world space distance
    float worldDistance = mix(cameraNear, cameraFar, depth);

    // Reconstruct world position from depth and UV
    vec3 worldPosition = getWorldPositionFromDepth(uv, depth);

    // Height-based fog factor (0.0 = no fog above fogHeightEnd, 1.0 = full fog below fogHeightStart)
    float heightFactor = 1.0 - clamp((-worldPosition.y - fogHeightStart) / (fogHeightEnd - fogHeightStart), 0.0, 1.0);
    heightFactor = pow(heightFactor, fogHeightFalloff);

    // Distance-based fog factor
    float fogFactorLinear = clamp((worldDistance - fogStart) / (fogEnd - fogStart), 0.0, 1.0);
    float distanceFogFactor = pow(fogFactorLinear, fogPower);

    // Combine height and distance fog factors
    float finalFogFactor = distanceFogFactor * heightFactor;

    // Mix original color with fog color
    vec3 mixedColor = mix(inputColor.rgb, fogColor, finalFogFactor * fogIntensity);
    //outputColor = vec4(mixedColor, 1.0);
    outputColor = vec4(vec3(worldPosition.y * 0.01), 1.0);
}
`;


export class FogEffect extends Effect {
    constructor(camera, fogIntensity) {
        super("DepthVisualizationEffect", fragmentShader, {
            blendFunction: BlendFunction.NORMAL,
            attributes: EffectAttribute.DEPTH, // Request depth buffer access
            uniforms: new Map([
                ["cameraNear", new Uniform(camera.near)],
                ["cameraFar", new Uniform(camera.far)],
                ['fogIntensity', new Uniform(fogIntensity)],
                ["cameraInverseProjectionMatrix", new Uniform(camera.projectionMatrixInverse)],
                ["cameraMatrixWorld", new Uniform(camera.matrixWorld)],
            ])
        });

        this.camera = camera;

    }
}
    */ 


class $cef69bdc893056f5$export$2e2bcd8739ae039 {
    constructor(container, visitedFromMobileDevice){
        this.container = container;
        this.init();
        this.addLights();
        this.addFog();
        this.addDefaultPostProcessing();
        this.addInteriorFactoryPostProcessing();
        this.envMap = null;
    //this.addSkybox(visitedFromMobileDevice);
    }
    init() {
        this.scene = new $ilwiq.Scene();
        this.camera = new $ilwiq.PerspectiveCamera(65, window.innerWidth / window.innerHeight, 0.1, 1800);
        this.renderer = new $ilwiq.WebGLRenderer({
            powerPreference: "high-performance",
            antialias: false,
            stencil: false,
            depth: false,
            depthTexture: false,
            logarithmicDepthBuffer: false,
            precision: "mediump",
            alpha: false
        });
        let pixelRatio = window.devicePixelRatio;
        //this.renderer.setPixelRatio(pixelRatio > 1.5 ? 1.0 : pixelRatio);
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.1));
        //this.renderer.setPixelRatio(1.05);
        this.renderer.outputEncoding = $ilwiq.SRGBColorSpace;
        //this.renderer.setClearColor(0x000000, 0);
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = $ilwiq.PCFSoftShadowMap;
        this.renderer.shadowMap.autoUpdate = true;
        this.renderer.toneMappingExposure = 0.24;
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.container.appendChild(this.renderer.domElement);
        this.composerDefault = new (0, $fe721963ebf18f1b$export$7fe01e6ab8aa748c)(this.renderer, {
            frameBufferType: (0, $ilwiq.HalfFloatType),
            multisampling: 4
        });
        this.composerFactoryInterior = new (0, $fe721963ebf18f1b$export$7fe01e6ab8aa748c)(this.renderer, {
            multisampling: 4,
            frameBufferType: (0, $ilwiq.HalfFloatType)
        });
        // Resize Observer
        this.resizeObserver = new ResizeObserver((entries)=>{
            for (let entry of entries){
                const { width: width, height: height } = entry.contentRect;
                this.renderer.setSize(width, height);
                this.composerDefault.setSize(width, height);
                this.composerFactoryInterior.setSize(width, height);
                this.camera.aspect = width / height;
                this.camera.updateProjectionMatrix();
            }
        });
        this.resizeObserver.observe(this.container);
    }
    addLights() {
        //const dayLight = new THREE.HemisphereLight(0xfff2c7, 0x080820, 20.35);
        //const dayLight = new THREE.DirectionalLight(0xfff2c7, 1.2)
        //fff2c7
        //F2E6BD
        //dayLight.position.set(0, 50, 50)
        //f2e1aa
        //F2E6BD
        //this.scene.add(dayLight);
        //const helperDir = new THREE.DirectionalLightHelper(dayLight, 5);
        //worldScene.scene.add(helperDir);
        const widthLight = 200;
        const height = 90;
        const intensity = 5; //9
        //const rectLight = new THREE.RectAreaLight(0xf1f3e1, intensity, widthLight, height);
        //0xa9dbfd
        const rectLight = new $ilwiq.RectAreaLight(0xF2E6BD, intensity, widthLight, height);
        const rectLight2 = new $ilwiq.RectAreaLight(0xF2E6BD, intensity, 320, 80); //8
        //82ccff
        rectLight2.position.set(0, 0, 0);
        rectLight2.lookAt(0, 0, 100);
        rectLight.position.set(0, 40, 145);
        rectLight.lookAt(0, 0, 125);
        this.scene.add(rectLight2);
        this.scene.add(rectLight);
    }
    addFog() {
        this.scene.fog = new $ilwiq.FogExp2(0x000000, 0.0015); // 0.0017 is the density of the fog
    //56515f
    //45414d
    //44424d
    //4b4856
    //56545c
    //64616b
    //9692a1
    //9998ab
    //f2dfa0
    }
    addDefaultPostProcessing() {
        const effectTonemapping = new (0, $fe721963ebf18f1b$export$6df7d6dd546cd57a)({
            blendFunction: (0, $fe721963ebf18f1b$export$ea7520add44ba1b6).SRC,
            mode: (0, $fe721963ebf18f1b$export$f72cb1a914b4b608).ACES_FILMIC
        });
        const effectBloom = new (0, $fe721963ebf18f1b$export$6588cb38f2a0e4fe)(this.scene, this.camera, {
            blendFunction: (0, $fe721963ebf18f1b$export$ea7520add44ba1b6).ADD,
            mipmapBlur: true,
            levels: 6,
            luminanceThreshold: 1.0,
            luminanceSmoothing: 0.9,
            intensity: 0.65,
            opacity: 1.0,
            radius: 0.9,
            kernelSize: (0, $fe721963ebf18f1b$export$543b1e4815577d06).MEDIUM
        });
        // // Depth of Field effect - exposed for tweaking
        // this.dofEffect = new DepthOfFieldEffect(this.camera, {
        //     focusDistance: 0.4,    // focus distance in world units (0 = auto)
        //     focalLength: 2.2,     // focal length of the camera lens
        //     bokehScale: 3.0,       // blur scale / bokeh size
        //     resolutionScale: 0.5   // lower = more performance, less quality
        // });
        // this.dofEffect.blendMode.opacity.value = 1.0; // disabled by default
        this.composerDefault.addPass(new (0, $fe721963ebf18f1b$export$f63ea822f020b5b0)(this.scene, this.camera));
        this.composerDefault.addPass(new (0, $fe721963ebf18f1b$export$9b60604040f63be5)(this.camera, effectBloom, effectTonemapping));
    }
    addInteriorFactoryPostProcessing() {
        const effectTonemapping = new (0, $fe721963ebf18f1b$export$6df7d6dd546cd57a)({
            blendFunction: (0, $fe721963ebf18f1b$export$ea7520add44ba1b6).SRC,
            mode: (0, $fe721963ebf18f1b$export$f72cb1a914b4b608).ACES_FILMIC
        });
        const godraysParams = {
            density: 0.002,
            maxDensity: 0.01,
            edgeStrength: 5.0,
            edgeRadius: 2.0,
            distanceAttenuation: 2.0,
            color: new $ilwiq.Color(0xFFB55C),
            raymarchSteps: 30,
            blur: true,
            blurVariance: 0.1,
            //blurKernelSize: SMALL,
            gammaCorrection: true
        };
        // godrays can be cast from either `PointLight`s or `DirectionalLight`s
        const lightPos = new $ilwiq.Vector3(1420, 140, 1300);
        const dirLight = new $ilwiq.DirectionalLight(0xffffff, 0.0);
        dirLight.castShadow = true;
        dirLight.shadow.mapSize.width = 1024;
        dirLight.shadow.mapSize.height = 1024;
        dirLight.shadow.camera.near = 10;
        dirLight.shadow.camera.far = 500;
        dirLight.shadow.camera.left = -340;
        dirLight.shadow.camera.right = 150;
        dirLight.shadow.camera.top = 60;
        dirLight.shadow.camera.bottom = -110;
        dirLight.shadow.camera.updateProjectionMatrix();
        dirLight.shadow.autoUpdate = true;
        dirLight.position.copy(lightPos).add(new $ilwiq.Vector3(0, 0, 10));
        //dirLight.target.position.set(1200, 50, 800);
        dirLight.target.position.set(1200, 5, 600);
        dirLight.target.updateMatrixWorld();
        this.scene.add(dirLight.target);
        this.scene.add(dirLight);
        //const dirLightHelper = new THREE.DirectionalLightHelper(dirLight, 5);
        //worldScene.scene.add(dirLightHelper);
        //const dirLightCameraHelper = new THREE.CameraHelper(dirLight.shadow.camera);
        //worldScene.scene.add(dirLightCameraHelper);
        const godraysPass = new (0, $359f518c62257e95$export$f09470d9976132bc)(dirLight, this.camera, godraysParams);
        //const smaaEffect = new SMAAEffect({ preset: SMAAPreset.ULTRA });
        this.composerFactoryInterior.addPass(new (0, $fe721963ebf18f1b$export$f63ea822f020b5b0)(this.scene, this.camera));
        this.composerFactoryInterior.addPass(new (0, $fe721963ebf18f1b$export$9b60604040f63be5)(this.camera, effectTonemapping));
        this.composerFactoryInterior.addPass(godraysPass);
    //this.composerFactoryInterior.addPass(new EffectPass(this.camera, smaaEffect));
    }
    loadSkybox() {
        const pmremGenerator = new $ilwiq.PMREMGenerator(this.renderer);
        pmremGenerator.compileEquirectangularShader();
        this.skyboxPromise = new Promise((resolve)=>{
            const ultraHDRLoader = new (0, $4b74f05b0ba4394f$export$89704621c14a7582)();
            ultraHDRLoader.setDataType($ilwiq.HalfFloatType);
            ultraHDRLoader.load("./assets/envMap.jpg", (texture)=>{
                texture.mapping = $ilwiq.EquirectangularReflectionMapping;
                this.envMap = pmremGenerator.fromEquirectangular(texture).texture;
                this.scene.background = this.envMap;
                pmremGenerator.dispose();
                // Resolve with original equirectangular texture (for ground material etc.)
                resolve(texture);
            });
        });
    }
    /* --- ORIGINAL RGBELoader skybox method (revert by swapping with loadSkybox above) ---
    loadSkybox(visitedFromMobileDevice) {
        const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
        pmremGenerator.compileEquirectangularShader();

        const skyboxToLoad = visitedFromMobileDevice ? 'belfast_sunset_puresky_1k' : 'belfast_sunset_puresky_1k';

        this.skyboxPromise = new Promise((resolve) => {
            const rgbeLoader = new RGBELoader();
            rgbeLoader.load(`./assets/${skyboxToLoad}.hdr`, (texture) => {
                texture.mapping = THREE.EquirectangularReflectionMapping;

                this.envMap = pmremGenerator.fromEquirectangular(texture).texture;
                this.scene.background = this.envMap;

                pmremGenerator.dispose();
                resolve(texture);
            });
        });
    }
    --- END ORIGINAL RGBELoader skybox method --- */ getRenderer() {
        return this.renderer;
    }
    getCamera() {
        return this.camera;
    }
    getComposerDefault() {
        return this.composerDefault;
    }
    getComposerFactoryInterior() {
        return this.composerFactoryInterior;
    }
}


function $8ecb29f509dc0bd0$var$clamp(t, i, e) {
    return Math.max(t, Math.min(i, e));
}
class $8ecb29f509dc0bd0$var$Animate {
    constructor(){
        this.isRunning = !1, this.value = 0, this.from = 0, this.to = 0, this.currentTime = 0;
    }
    advance(t) {
        var i;
        if (!this.isRunning) return;
        let e = !1;
        if (this.duration && this.easing) {
            this.currentTime += t;
            const i = $8ecb29f509dc0bd0$var$clamp(0, this.currentTime / this.duration, 1);
            e = i >= 1;
            const s = e ? 1 : this.easing(i);
            this.value = this.from + (this.to - this.from) * s;
        } else this.lerp ? (this.value = function damp(t, i, e, s) {
            return function lerp(t, i, e) {
                return (1 - e) * t + e * i;
            }(t, i, 1 - Math.exp(-e * s));
        }(this.value, this.to, 60 * this.lerp, t), Math.round(this.value) === this.to && (this.value = this.to, e = !0)) : (this.value = this.to, e = !0);
        e && this.stop(), null === (i = this.onUpdate) || void 0 === i || i.call(this, this.value, e);
    }
    stop() {
        this.isRunning = !1;
    }
    fromTo(t, i, { lerp: e, duration: s, easing: o, onStart: n, onUpdate: l }) {
        this.from = this.value = t, this.to = i, this.lerp = e, this.duration = s, this.easing = o, this.currentTime = 0, this.isRunning = !0, null == n || n(), this.onUpdate = l;
    }
}
class $8ecb29f509dc0bd0$var$Dimensions {
    constructor(t, i, { autoResize: e = !0, debounce: s = 250 } = {}){
        this.wrapper = t, this.content = i, this.width = 0, this.height = 0, this.scrollHeight = 0, this.scrollWidth = 0, this.resize = ()=>{
            this.onWrapperResize(), this.onContentResize();
        }, this.onWrapperResize = ()=>{
            this.wrapper instanceof Window ? (this.width = window.innerWidth, this.height = window.innerHeight) : (this.width = this.wrapper.clientWidth, this.height = this.wrapper.clientHeight);
        }, this.onContentResize = ()=>{
            this.wrapper instanceof Window ? (this.scrollHeight = this.content.scrollHeight, this.scrollWidth = this.content.scrollWidth) : (this.scrollHeight = this.wrapper.scrollHeight, this.scrollWidth = this.wrapper.scrollWidth);
        }, e && (this.debouncedResize = function debounce(t, i) {
            let e;
            return function(...s) {
                let o = this;
                clearTimeout(e), e = setTimeout(()=>{
                    e = void 0, t.apply(o, s);
                }, i);
            };
        }(this.resize, s), this.wrapper instanceof Window ? window.addEventListener("resize", this.debouncedResize, !1) : (this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize), this.wrapperResizeObserver.observe(this.wrapper)), this.contentResizeObserver = new ResizeObserver(this.debouncedResize), this.contentResizeObserver.observe(this.content)), this.resize();
    }
    destroy() {
        var t, i;
        null === (t = this.wrapperResizeObserver) || void 0 === t || t.disconnect(), null === (i = this.contentResizeObserver) || void 0 === i || i.disconnect(), this.wrapper === window && this.debouncedResize && window.removeEventListener("resize", this.debouncedResize, !1);
    }
    get limit() {
        return {
            x: this.scrollWidth - this.width,
            y: this.scrollHeight - this.height
        };
    }
}
class $8ecb29f509dc0bd0$var$Emitter {
    constructor(){
        this.events = {};
    }
    emit(t, ...i) {
        var e;
        let s = this.events[t] || [];
        for(let t = 0, o = s.length; t < o; t++)null === (e = s[t]) || void 0 === e || e.call(s, ...i);
    }
    on(t, i) {
        var e;
        return (null === (e = this.events[t]) || void 0 === e ? void 0 : e.push(i)) || (this.events[t] = [
            i
        ]), ()=>{
            var e;
            this.events[t] = null === (e = this.events[t]) || void 0 === e ? void 0 : e.filter((t)=>i !== t);
        };
    }
    off(t, i) {
        var e;
        this.events[t] = null === (e = this.events[t]) || void 0 === e ? void 0 : e.filter((t)=>i !== t);
    }
    destroy() {
        this.events = {};
    }
}
const $8ecb29f509dc0bd0$var$t = 100 / 6, $8ecb29f509dc0bd0$var$i = {
    passive: !1
};
class $8ecb29f509dc0bd0$var$VirtualScroll {
    constructor(e, s = {
        wheelMultiplier: 1,
        touchMultiplier: 1
    }){
        this.element = e, this.options = s, this.touchStart = {
            x: 0,
            y: 0
        }, this.lastDelta = {
            x: 0,
            y: 0
        }, this.window = {
            width: 0,
            height: 0
        }, this.emitter = new $8ecb29f509dc0bd0$var$Emitter, this.onTouchStart = (t)=>{
            const { clientX: i, clientY: e } = t.targetTouches ? t.targetTouches[0] : t;
            this.touchStart.x = i, this.touchStart.y = e, this.lastDelta = {
                x: 0,
                y: 0
            }, this.emitter.emit("scroll", {
                deltaX: 0,
                deltaY: 0,
                event: t
            });
        }, this.onTouchMove = (t)=>{
            const { clientX: i, clientY: e } = t.targetTouches ? t.targetTouches[0] : t, s = -(i - this.touchStart.x) * this.options.touchMultiplier, o = -(e - this.touchStart.y) * this.options.touchMultiplier;
            this.touchStart.x = i, this.touchStart.y = e, this.lastDelta = {
                x: s,
                y: o
            }, this.emitter.emit("scroll", {
                deltaX: s,
                deltaY: o,
                event: t
            });
        }, this.onTouchEnd = (t)=>{
            this.emitter.emit("scroll", {
                deltaX: this.lastDelta.x,
                deltaY: this.lastDelta.y,
                event: t
            });
        }, this.onWheel = (i)=>{
            let { deltaX: e, deltaY: s, deltaMode: o } = i;
            e *= 1 === o ? $8ecb29f509dc0bd0$var$t : 2 === o ? this.window.width : 1, s *= 1 === o ? $8ecb29f509dc0bd0$var$t : 2 === o ? this.window.height : 1, e *= this.options.wheelMultiplier, s *= this.options.wheelMultiplier, this.emitter.emit("scroll", {
                deltaX: e,
                deltaY: s,
                event: i
            });
        }, this.onWindowResize = ()=>{
            this.window = {
                width: window.innerWidth,
                height: window.innerHeight
            };
        }, window.addEventListener("resize", this.onWindowResize, !1), this.onWindowResize(), this.element.addEventListener("wheel", this.onWheel, $8ecb29f509dc0bd0$var$i), this.element.addEventListener("touchstart", this.onTouchStart, $8ecb29f509dc0bd0$var$i), this.element.addEventListener("touchmove", this.onTouchMove, $8ecb29f509dc0bd0$var$i), this.element.addEventListener("touchend", this.onTouchEnd, $8ecb29f509dc0bd0$var$i);
    }
    on(t, i) {
        return this.emitter.on(t, i);
    }
    destroy() {
        this.emitter.destroy(), window.removeEventListener("resize", this.onWindowResize, !1), this.element.removeEventListener("wheel", this.onWheel, $8ecb29f509dc0bd0$var$i), this.element.removeEventListener("touchstart", this.onTouchStart, $8ecb29f509dc0bd0$var$i), this.element.removeEventListener("touchmove", this.onTouchMove, $8ecb29f509dc0bd0$var$i), this.element.removeEventListener("touchend", this.onTouchEnd, $8ecb29f509dc0bd0$var$i);
    }
}
class $8ecb29f509dc0bd0$export$2e2bcd8739ae039 {
    constructor({ wrapper: t = window, content: i = document.documentElement, eventsTarget: e = t, smoothWheel: s = !0, syncTouch: o = !1, syncTouchLerp: n = .075, touchInertiaMultiplier: l = 35, duration: r, easing: h = (t)=>Math.min(1, 1.001 - Math.pow(2, -10 * t)), lerp: a = .1, infinite: c = !1, orientation: u = "vertical", gestureOrientation: d = "vertical", touchMultiplier: p = 1, wheelMultiplier: m = 1, autoResize: v = !0, prevent: g, virtualScroll: S, __experimental__naiveDimensions: w = !1 } = {}){
        this._isScrolling = !1, this._isStopped = !1, this._isLocked = !1, this._preventNextNativeScrollEvent = !1, this._resetVelocityTimeout = null, this.time = 0, this.userData = {}, this.lastVelocity = 0, this.velocity = 0, this.direction = 0, this.animate = new $8ecb29f509dc0bd0$var$Animate, this.emitter = new $8ecb29f509dc0bd0$var$Emitter, this.onPointerDown = (t)=>{
            1 === t.button && this.reset();
        }, this.onVirtualScroll = (t)=>{
            if ("function" == typeof this.options.virtualScroll && !1 === this.options.virtualScroll(t)) return;
            const { deltaX: i, deltaY: e, event: s } = t;
            if (this.emitter.emit("virtual-scroll", {
                deltaX: i,
                deltaY: e,
                event: s
            }), s.ctrlKey) return;
            const o = s.type.includes("touch"), n = s.type.includes("wheel");
            this.isTouching = "touchstart" === s.type || "touchmove" === s.type;
            if (this.options.syncTouch && o && "touchstart" === s.type && !this.isStopped && !this.isLocked) return void this.reset();
            const l = 0 === i && 0 === e, r = "vertical" === this.options.gestureOrientation && 0 === e || "horizontal" === this.options.gestureOrientation && 0 === i;
            if (l || r) return;
            let h = s.composedPath();
            h = h.slice(0, h.indexOf(this.rootElement));
            const a = this.options.prevent;
            if (h.find((t)=>{
                var i, e, s, l, r;
                return t instanceof HTMLElement && ("function" == typeof a && (null == a ? void 0 : a(t)) || (null === (i = t.hasAttribute) || void 0 === i ? void 0 : i.call(t, "data-lenis-prevent")) || o && (null === (e = t.hasAttribute) || void 0 === e ? void 0 : e.call(t, "data-lenis-prevent-touch")) || n && (null === (s = t.hasAttribute) || void 0 === s ? void 0 : s.call(t, "data-lenis-prevent-wheel")) || (null === (l = t.classList) || void 0 === l ? void 0 : l.contains("lenis")) && !(null === (r = t.classList) || void 0 === r ? void 0 : r.contains("lenis-stopped")));
            })) return;
            if (this.isStopped || this.isLocked) return void s.preventDefault();
            if (!(this.options.syncTouch && o || this.options.smoothWheel && n)) return this.isScrolling = "native", void this.animate.stop();
            s.preventDefault();
            let c = e;
            "both" === this.options.gestureOrientation ? c = Math.abs(e) > Math.abs(i) ? e : i : "horizontal" === this.options.gestureOrientation && (c = i);
            const u = o && this.options.syncTouch, d = o && "touchend" === s.type && Math.abs(c) > 5;
            d && (c = this.velocity * this.options.touchInertiaMultiplier), this.scrollTo(this.targetScroll + c, Object.assign({
                programmatic: !1
            }, u ? {
                lerp: d ? this.options.syncTouchLerp : 1
            } : {
                lerp: this.options.lerp,
                duration: this.options.duration,
                easing: this.options.easing
            }));
        }, this.onNativeScroll = ()=>{
            if (null !== this._resetVelocityTimeout && (clearTimeout(this._resetVelocityTimeout), this._resetVelocityTimeout = null), this._preventNextNativeScrollEvent) this._preventNextNativeScrollEvent = !1;
            else if (!1 === this.isScrolling || "native" === this.isScrolling) {
                const t = this.animatedScroll;
                this.animatedScroll = this.targetScroll = this.actualScroll, this.lastVelocity = this.velocity, this.velocity = this.animatedScroll - t, this.direction = Math.sign(this.animatedScroll - t), this.isScrolling = "native", this.emit(), 0 !== this.velocity && (this._resetVelocityTimeout = setTimeout(()=>{
                    this.lastVelocity = this.velocity, this.velocity = 0, this.isScrolling = !1, this.emit();
                }, 400));
            }
        }, window.lenisVersion = "1.1.13", t && t !== document.documentElement && t !== document.body || (t = window), this.options = {
            wrapper: t,
            content: i,
            eventsTarget: e,
            smoothWheel: s,
            syncTouch: o,
            syncTouchLerp: n,
            touchInertiaMultiplier: l,
            duration: r,
            easing: h,
            lerp: a,
            infinite: c,
            gestureOrientation: d,
            orientation: u,
            touchMultiplier: p,
            wheelMultiplier: m,
            autoResize: v,
            prevent: g,
            virtualScroll: S,
            __experimental__naiveDimensions: w
        }, this.dimensions = new $8ecb29f509dc0bd0$var$Dimensions(t, i, {
            autoResize: v
        }), this.updateClassName(), this.targetScroll = this.animatedScroll = this.actualScroll, this.options.wrapper.addEventListener("scroll", this.onNativeScroll, !1), this.options.wrapper.addEventListener("pointerdown", this.onPointerDown, !1), this.virtualScroll = new $8ecb29f509dc0bd0$var$VirtualScroll(e, {
            touchMultiplier: p,
            wheelMultiplier: m
        }), this.virtualScroll.on("scroll", this.onVirtualScroll);
    }
    destroy() {
        this.emitter.destroy(), this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, !1), this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown, !1), this.virtualScroll.destroy(), this.dimensions.destroy(), this.cleanUpClassName();
    }
    on(t, i) {
        return this.emitter.on(t, i);
    }
    off(t, i) {
        return this.emitter.off(t, i);
    }
    setScroll(t) {
        this.isHorizontal ? this.rootElement.scrollLeft = t : this.rootElement.scrollTop = t;
    }
    resize() {
        this.dimensions.resize(), this.animatedScroll = this.targetScroll = this.actualScroll, this.emit();
    }
    emit() {
        this.emitter.emit("scroll", this);
    }
    reset() {
        this.isLocked = !1, this.isScrolling = !1, this.animatedScroll = this.targetScroll = this.actualScroll, this.lastVelocity = this.velocity = 0, this.animate.stop();
    }
    start() {
        this.isStopped && (this.isStopped = !1, this.reset());
    }
    stop() {
        this.isStopped || (this.isStopped = !0, this.animate.stop(), this.reset());
    }
    raf(t) {
        const i = t - (this.time || t);
        this.time = t, this.animate.advance(.001 * i);
    }
    scrollTo(t, { offset: i = 0, immediate: e = !1, lock: s = !1, duration: o = this.options.duration, easing: n = this.options.easing, lerp: l = this.options.lerp, onStart: r, onComplete: h, force: a = !1, programmatic: c = !0, userData: u } = {}) {
        if (!this.isStopped && !this.isLocked || a) {
            if ("string" == typeof t && [
                "top",
                "left",
                "start"
            ].includes(t)) t = 0;
            else if ("string" == typeof t && [
                "bottom",
                "right",
                "end"
            ].includes(t)) t = this.limit;
            else {
                let e;
                if ("string" == typeof t ? e = document.querySelector(t) : t instanceof HTMLElement && (null == t ? void 0 : t.nodeType) && (e = t), e) {
                    if (this.options.wrapper !== window) {
                        const t = this.rootElement.getBoundingClientRect();
                        i -= this.isHorizontal ? t.left : t.top;
                    }
                    const s = e.getBoundingClientRect();
                    t = (this.isHorizontal ? s.left : s.top) + this.animatedScroll;
                }
            }
            if ("number" == typeof t) {
                if (t += i, t = Math.round(t), this.options.infinite ? c && (this.targetScroll = this.animatedScroll = this.scroll) : t = $8ecb29f509dc0bd0$var$clamp(0, t, this.limit), t === this.targetScroll) return null == r || r(this), void (null == h || h(this));
                if (this.userData = null != u ? u : {}, e) return this.animatedScroll = this.targetScroll = t, this.setScroll(this.scroll), this.reset(), this.preventNextNativeScrollEvent(), this.emit(), null == h || h(this), void (this.userData = {});
                c || (this.targetScroll = t), this.animate.fromTo(this.animatedScroll, t, {
                    duration: o,
                    easing: n,
                    lerp: l,
                    onStart: ()=>{
                        s && (this.isLocked = !0), this.isScrolling = "smooth", null == r || r(this);
                    },
                    onUpdate: (t, i)=>{
                        this.isScrolling = "smooth", this.lastVelocity = this.velocity, this.velocity = t - this.animatedScroll, this.direction = Math.sign(this.velocity), this.animatedScroll = t, this.setScroll(this.scroll), c && (this.targetScroll = t), i || this.emit(), i && (this.reset(), this.emit(), null == h || h(this), this.userData = {}, this.preventNextNativeScrollEvent());
                    }
                });
            }
        }
    }
    preventNextNativeScrollEvent() {
        this._preventNextNativeScrollEvent = !0, requestAnimationFrame(()=>{
            this._preventNextNativeScrollEvent = !1;
        });
    }
    get rootElement() {
        return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    get limit() {
        return this.options.__experimental__naiveDimensions ? this.isHorizontal ? this.rootElement.scrollWidth - this.rootElement.clientWidth : this.rootElement.scrollHeight - this.rootElement.clientHeight : this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    get isHorizontal() {
        return "horizontal" === this.options.orientation;
    }
    get actualScroll() {
        return this.isHorizontal ? this.rootElement.scrollLeft : this.rootElement.scrollTop;
    }
    get scroll() {
        return this.options.infinite ? function modulo(t, i) {
            return (t % i + i) % i;
        }(this.animatedScroll, this.limit) : this.animatedScroll;
    }
    get progress() {
        return 0 === this.limit ? 1 : this.scroll / this.limit;
    }
    get isScrolling() {
        return this._isScrolling;
    }
    set isScrolling(t) {
        this._isScrolling !== t && (this._isScrolling = t, this.updateClassName());
    }
    get isStopped() {
        return this._isStopped;
    }
    set isStopped(t) {
        this._isStopped !== t && (this._isStopped = t, this.updateClassName());
    }
    get isLocked() {
        return this._isLocked;
    }
    set isLocked(t) {
        this._isLocked !== t && (this._isLocked = t, this.updateClassName());
    }
    get isSmooth() {
        return "smooth" === this.isScrolling;
    }
    get className() {
        let t = "lenis";
        return this.isStopped && (t += " lenis-stopped"), this.isLocked && (t += " lenis-locked"), this.isScrolling && (t += " lenis-scrolling"), "smooth" === this.isScrolling && (t += " lenis-smooth"), t;
    }
    updateClassName() {
        this.cleanUpClassName(), this.rootElement.className = `${this.rootElement.className} ${this.className}`.trim();
    }
    cleanUpClassName() {
        this.rootElement.className = this.rootElement.className.replace(/lenis(-\w+)?/g, "").trim();
    }
}



var $c0f9beb4dba4e00a$exports = {};
$c0f9beb4dba4e00a$exports = JSON.parse('{"glass":{"title":"The Virtual Glass Harmonica","video_ref":"./assets/glass/video.webm","main_txt":"Together with a fellow peer, the design and development of the virtual glass harmonica was a project completed for the <span class=\'color-glass\'>Danish Music Museum</span>. As part of the <i>Music History - Taken out of the Box</i> project, funded by the Augustinus Foundation, it explores the use of <span class=\'color-glass\'>Virtual Reality</span> to resurrect a forgotten instrument and present its history, sound, and interaction through an immersive virtual environment. The installation can be experienced at the Music Museum, where qualitative evaluations have shown that it establishes a good connection between the virtual instrument and the physical 1780-era glass harmonica on display.","client":"Danish Music Museum","tech":"Unity-C# | Blender | Meta Quest 2 Standalone | Handtracking | Shadergraph","publications":"<h4><a href=\'https://link.springer.com/chapter/10.1007/978-3-031-55312-7_16\' style=\'text-decoration: none; color: white; font-weight: 100\' target=\'_blank\'>ArtsIT, Interactivity and Game Creation 2023</a></h4> <h4><a href=\'https://doi.org/10.5281/zenodo.6822203\' style=\'text-decoration: none; color: white; font-weight: 100\' target=\'_blank\'>Sound and Music Computing Conference 2022</a></h4>","images":["./assets/glass/showcase-img1.webp","./assets/glass/showcase-img2.webp","./assets/glass/showcase-img3.webp"],"images_alt":["The virtual reality experience leverages the handtracking capabilities of the meta quest 2 device. Virtual environment capture.","Virtual environemnt capture showing interactive buttons for initiating tutorial and storytelling by Benjamin Franklin.","Photograph of excited visitor trying the virtual reality experience, at the Danish Music Museum."]},"nature":{"title":"Through the Eyes of Nature","video_ref":"./assets/nature/video.webm","main_txt":"In collaboration with Gehl Architects, this master\u2019s thesis explores the potential impact of integrating Virtual Reality into participatory workshops focused on urban biodiversity. The case study involved the urban greenspace development of Nordhavn in Copenhagen, with an immersive narrative that takes the user on a journey where the story is told through the perspective of nature at the site. The Virtual Reality experience was evaluated through a participatory workshop and expert interviews conducted within Gehl\'s R&D department. The findings showed that immersive storytelling in Virtual Reality can be a powerful tool to elicit empathy and foster emotionally engaged discussions on complex topics. This project serves as a pilot in Gehl Architects\u2019 exploration of integrating XR media into their urban planning processes.","client":"Gehl Architects","tech":"Unity | Blender | Meta Quest 3 Standalone | Handtracking | Shadergraph | Spatial Sounds","images":["./assets/nature/showcase-img1.webp","./assets/nature/showcase-img2.webp","./assets/nature/showcase-img3.webp"],"images_alt":["The three-stages of the virtual experience, showing the colour mood journey.","Exited users testing the experience, at the collaborative workshop held at Gehl Architects offices.","The core project team, at the Nordhavn site."]},"dad":{"title":"Denmark After Dark","video_ref":"./assets/dad/video.webm","main_txt":"As part of the Denmark After Dark exhibition, the Danish National Museum aimed to integrate interactivity into the installation. Together with a fellow student, I was part of the project team and worked on the rehearsal and recording studio for the exhibition. With the band D-A-D as the focus, we aimed to create a social space where visitors could unleash their inner rockstar by playing instruments and mixing a track. The main challenge in the process was to develop solutions that offered the robustness and usability required for a daily visited exhibition. Video credits: Natmus. Cover photo credits: Anders Groos Mikkelsen ","client":"Danish National Museum","link":"<h4><a href=\'https://www.dad.natmus.dk/\' style=\'text-decoration: none; color: white; font-weight: 100\' target=\'_blank\'>DAD - Natmus</a></h4>","tech":"Touch Designer | Ableton Live | Max4Live | Blender","images":["./assets/dad/showcase-img1.webp","./assets/dad/showcase-img2.webp"],"images_alt":["Excited user trying the interactive studio installation, where a DAD song can be mixed in real time. The backend was created using Max4Live and TouchDesigner. Photo credit: NatMus","An early project render of a studio installation suggestion, created in Blender 3D"]},"fragments":{"title":"Fragments of Fungi","video_ref":"./assets/fragments/video.webm","main_txt":"In this project, our group of four explored the relationship between art, nature, and technology to design and develop an interactive, immersive Virtual Reality experience centered around the phenomenon of Mycelium networks. The experience was conceptualized and designed through participatory workshops involving creative activities. The final evaluation aimed to create a shared experience in a physical forest setting that would enhance the immersive aspect. This evaluation highlighted the potential of Virtual Reality to elicit feelings of awe and emphasized the benefits of collective spaces for reflection and dialogue when presenting self-contained, emotional experiences inherent in Virtual Reality.","client":"Multisensory Experience Lab","publications":"<h4><a href=\'https://link.springer.com/chapter/10.1007/978-3-031-55312-7_6\' style=\'text-decoration: none; color: white; font-weight: 100\' target=\'_blank\'>Springer Link</a></h4>","tech":"Unity | Blender | Meta Quest 2 Standalone | AppSW | Handtracking | Shadergraph | Spatial Sounds","images":["./assets/fragments/showcase-img1.webp","./assets/fragments/showcase-img2.webp","./assets/fragments/showcase-img3.webp"],"images_alt":["Excited user immersed in the Hareskov forest, at the collective experiences VR workshop.","The Fragments of Fungi virtual experience.","Designing the virtual experience narrative journey."]},"mizwak":{"title":"Mizwak","video_ref":"./assets/mizwak/video.webm","main_txt":"As part of the EU-funded cooperation project Taking Care: Ethnographic and World Cultures Museums as Spaces of Care, the aim was to explore new and experimental ways of exhibiting in the context of ethnographic and world cultures. In collaboration with the Danish National Museum and the Multisensory Experience Lab, the story behind the world\u2019s oldest toothbrush, the Miswak, was designed and implemented over the course of a semester. The final installation was developed through co-creation workshops with museum staff and leveraged sensor technology alongside a 3D-printed tangible user interface that unlocked the stories behind the Miswak through physical interactions. The design, implementation, and user testing were conducted at the PlayLab at the Danish National Museum. The installation was on display throughout 2023.","client":"Danish National Museum","link":"<h4><a href=\'https://takingcareproject.eu/article/miswak-exhibition-at-the-nationalmuseet\' style=\'text-decoration: none; color: white; font-weight: 100\' target=\'_blank\'>Taking Care EU Project</a></h4> <h4><a href=\'https://natmus.dk/nyhed/verdens-aeldste-tandboerste-vokser-paa-et-trae/\' style=\'text-decoration: none; color: white; font-weight: 100\' target=\'_blank\'>National Museet - Mizwak</a></h4>","tech":"Blender | QLab | Ultimaker Cura","images":["./assets/mizwak/showcase-img1.webp","./assets/mizwak/showcase-img2.webp","./assets/mizwak/showcase-img3.webp"],"images_alt":["Mizwak installation at Nationalmuseet. The exhibited mizwaks.","Mizwak installation, at Nationalmuseet, with the 3D printed interactive objects.","Mizwak installation work in progress, at Nationalmuseet."]},"spaceshooter":{"title":"Embodied Spaceshooter","video_ref":"./assets/spaceshooter/video.webm","main_txt":"Work in progress.. A browser based mini game that explores the use of embodied interaction in gaming. Allowing the user to control a player through head- and body movement tracked by the webcam utilizing the Google MediaPipe framework. ","client":"AAU Exam Project","link":"<h4><a href=\'https://getelementsbyclassname.github.io/embodied_interaction_course/\' style=\'text-decoration: none; color: white; font-weight: 100\' target=\'_blank\'>Demo</a></h4>","tech":"ThreeJS | Google MediaPipe | Blender","images":[],"images_alt":[]}}');


class $e0c699995c427076$export$2524c4960ed9dff2 {
    constructor({ visitedFromMobileDevice: visitedFromMobileDevice }){
        this._visitedFromMobileDevice = visitedFromMobileDevice;
        this._overlayIsOpen = false;
        this._currentSectionIndex = 0;
        this._controls = null;
        this._isScrolling = false;
        // DOM references
        this._nav = document.querySelector("nav");
        this._secondaryNav = document.querySelector(".secondary-menu");
        this._footer = document.querySelector("footer");
        this._overlay = document.getElementById("overlay");
        this._closeBtn = document.getElementById("closeBtn");
        this._sectionScene = document.getElementById("container-opening-scene");
        this._sections = document.querySelectorAll("section");
        this._navItems = document.querySelectorAll(".nav-item");
        this._lines = document.querySelectorAll(".line");
        this._imageContainers = document.querySelectorAll(".image-container");
        // Content DOM references
        this._contentTitle = document.getElementById("content-title");
        this._contentVideo = document.getElementById("content-video");
        this._contentMainText = document.getElementById("content-main-txt");
        this._contentClient = document.getElementById("content-client");
        this._contentTech = document.getElementById("content-tech");
        this._headingLink = document.getElementById("heading-link");
        this._contentLink = document.getElementById("external-link");
        this._colorTxt = document.getElementsByClassName("txt-color");
        document.getElementById("currentYear").textContent = new Date().getFullYear();
        this._activeIndex = 0;
        this._targetSection = "#container-opening-scene";
        this._timeoutId = null;
        this._overlayTouchStart = 0;
        this._initNavVisibility();
        this._initLenis();
        this._initNavBarFade();
        this._initNavItemClicks();
        this._initWheelScroll();
        this._initOverlay();
        this._initContentLoading();
        this._initHideWasdIcon();
    }
    get overlayIsOpen() {
        return this._overlayIsOpen;
    }
    get currentSectionIndex() {
        return this._currentSectionIndex;
    }
    get lenisSite() {
        return this._lenisSite;
    }
    get lenisOverlay() {
        return this._lenisOverlay;
    }
    get sectionScene() {
        return this._sectionScene;
    }
    setControls(controls) {
        this._controls = controls;
    }
    // --- Nav Visibility ---
    _initNavVisibility() {
        if (!this._visitedFromMobileDevice) {
            this._nav.classList.remove("hide");
            this._secondaryNav.classList.remove("hide");
            this._footer.classList.remove("hide");
        }
        this._navItems[this._activeIndex].classList.add("active");
    }
    // --- Nav Bar Fade/Hover ---
    _initNavBarFade() {
        this._nav.addEventListener("mouseenter", ()=>this._fnResetTimer());
        document.addEventListener("wheel", ()=>this._fnResetTimer());
        this._fnResetTimer();
    }
    _fnHideNavBar() {
        this._nav.classList.add("hidden");
    }
    _fnResetTimer() {
        this._nav.classList.remove("hidden");
        clearTimeout(this._timeoutId);
        this._timeoutId = setTimeout(()=>this._fnHideNavBar(), 3000);
    }
    // --- Nav Item Clicks & Highlight ---
    _initNavItemClicks() {
        this._navItems.forEach((item, index)=>{
            item.addEventListener("click", ()=>{
                this._targetSection = this._navItems[index].dataset.targetsection;
                for(let i = 0; i < 3; i++)this._navItems[i].classList.remove("active");
                this._lines[0].classList.remove("highlight-up", "highlight-down");
                this._lines[1].classList.remove("highlight-up", "highlight-down");
                item.classList.add("active");
                this._fnUpdateNavigation(index, this._activeIndex, this._lines);
                this._lenisSite.scrollTo(this._targetSection, {
                    duration: 2.0,
                    offset: 0
                });
                this._activeIndex = index;
                this._targetSection = "";
                this._currentSectionIndex = this._activeIndex;
            });
        });
    }
    _fnUpdateNavigation(index, activeIndex, lines) {
        if (index > activeIndex) {
            for(let i = activeIndex; i < index; i++)if (i === index - 1 && index != activeIndex + 1) setTimeout(()=>{
                lines[i].classList.add("highlight-down");
            }, 600);
            else lines[i].classList.add("highlight-down");
        }
        if (index < activeIndex) {
            for(let i = activeIndex - 1; i >= index; i--)if (i === index && index != activeIndex - 1) setTimeout(()=>{
                lines[i].classList.add("highlight-up");
            }, 600);
            else lines[i].classList.add("highlight-up");
        }
    }
    // --- Lenis Setup ---
    _initLenis() {
        const lenisOverlayOptions = {
            duration: 1.75,
            direction: "vertical",
            gestureDirection: "vertical",
            smooth: true,
            mouseMultiplier: 1,
            smoothTouch: false,
            touchMultiplier: 2,
            infinite: false,
            wrapper: this._overlay,
            content: this._overlay.children[1]
        };
        const lenisSiteOptions = {
            duration: 1.25,
            smooth: true
        };
        this._lenisOverlay = new (0, $8ecb29f509dc0bd0$export$2e2bcd8739ae039)(lenisOverlayOptions);
        this._lenisSite = new (0, $8ecb29f509dc0bd0$export$2e2bcd8739ae039)(lenisSiteOptions);
        const raf = (time)=>{
            this._lenisSite.raf(time);
            this._lenisOverlay.raf(time);
            requestAnimationFrame(raf);
        };
        requestAnimationFrame(raf);
    }
    // --- Wheel Scroll Sections ---
    _initWheelScroll() {
        window.addEventListener("wheel", (event)=>{
            if (this._isScrolling) return;
            if (event.deltaY > 0 && !this._overlayIsOpen) {
                this._isScrolling = true;
                this._currentSectionIndex = Math.min(this._currentSectionIndex + 1, this._sections.length - 1);
                this._lines[this._currentSectionIndex - 1].classList.add("highlight-down");
                this._scrollToSection(this._currentSectionIndex);
                this._activeIndex = this._currentSectionIndex;
                this._navItems[this._currentSectionIndex].classList.add("active");
                this._navItems[this._currentSectionIndex - 1].classList.remove("active");
                setTimeout(()=>{
                    this._lines[this._currentSectionIndex - 1].classList.remove("highlight-up", "highlight-down");
                }, 600);
                if (this._controls !== null && this._controls !== undefined) this._controls.unlock();
            } else if (event.deltaY < 0 && !this._overlayIsOpen) {
                this._isScrolling = true;
                this._currentSectionIndex = Math.max(this._currentSectionIndex - 1, 0);
                this._lines[this._currentSectionIndex].classList.add("highlight-up");
                this._scrollToSection(this._currentSectionIndex);
                this._activeIndex = this._currentSectionIndex;
                this._navItems[this._currentSectionIndex].classList.add("active");
                this._navItems[this._currentSectionIndex + 1].classList.remove("active");
                setTimeout(()=>{
                    this._lines[this._currentSectionIndex].classList.remove("highlight-up", "highlight-down");
                }, 600);
            }
        });
    }
    _scrollToSection(index) {
        this._isScrolling = true;
        if (index >= 0 && index < this._sections.length) this._lenisSite.scrollTo(this._sections[index], {
            duration: 1.0,
            offset: 0,
            lock: true,
            onComplete: ()=>{
                this._isScrolling = false;
            }
        });
    }
    // --- Overlay Open/Close ---
    _initOverlay() {
        this._imageContainers.forEach((container)=>{
            container.addEventListener("click", ()=>{
                this._isScrolling = false;
                this._overlay.classList.add("show");
                this._lenisSite.stop();
                this._closeBtn.classList.add("show");
                this._overlayIsOpen = !this._overlayIsOpen;
                this._nav.classList.add("hide");
            });
        });
        this._closeBtn.addEventListener("click", ()=>{
            this._fnHandleCloseOverlay();
        });
        this._overlay.addEventListener("click", (e)=>{
            e.stopPropagation();
            this._fnHandleCloseOverlay();
        });
        this._overlay.addEventListener("touchstart", (event)=>{
            this._overlayTouchStart = event.touches[0].clientX;
        });
        this._overlay.addEventListener("touchmove", (e)=>{
            const currentX = e.touches[0].clientX;
            const deltaX = currentX - this._overlayTouchStart;
            if (deltaX > 40) {
                this._overlay.classList.remove("show");
                this._closeBtn.classList.remove("show");
                this._lenisSite.start();
                setTimeout(()=>{
                    this._lenisOverlay.scrollTo(0);
                }, 1000);
            }
        });
    }
    _fnHandleCloseOverlay() {
        this._isScrolling = false;
        this._overlayIsOpen = !this._overlayIsOpen;
        this._overlay.classList.remove("show");
        this._closeBtn.classList.remove("show");
        setTimeout(()=>{
            this._lenisOverlay.scrollTo(0);
        }, 1000);
        if (!this._visitedFromMobileDevice) this._nav.classList.remove("hide");
        this._lenisSite.start();
    }
    // --- Content Loading ---
    _initContentLoading() {
        this._imageContainers.forEach((container)=>{
            container.addEventListener("click", async (e)=>{
                const id = e.currentTarget.dataset.id;
                this._fnLoadContent(id);
            });
        });
    }
    _fnLoadContent(id) {
        const contentData = (0, (/*@__PURE__*/$parcel$interopDefault($c0f9beb4dba4e00a$exports)))[id];
        this._contentTitle.innerText = contentData.title;
        this._contentMainText.innerHTML = contentData.main_txt;
        this._contentClient.innerText = contentData.client;
        this._contentTech.innerHTML = contentData.tech;
        [
            ...this._colorTxt
        ].forEach((elem)=>{
            const classes = elem.classList;
            classes.forEach((className)=>{
                if (className.startsWith("color-")) elem.classList.remove(className);
            });
            elem.classList.add("color-" + id);
        });
        if (contentData.publications !== undefined) {
            this._headingLink.innerHTML = "Publication";
            this._contentLink.innerHTML = contentData.publications;
        } else if (contentData.link !== undefined) {
            this._headingLink.innerHTML = "Link";
            this._contentLink.innerHTML = contentData.link;
        } else {
            this._headingLink.innerHTML = "";
            this._contentLink.innerHTML = "";
        }
        // Create video element
        this._contentVideo.innerHTML = "";
        const videoElement = document.createElement("video");
        videoElement.autoplay = true;
        videoElement.playsInline = true;
        videoElement.loop = true;
        videoElement.muted = true;
        videoElement.setAttribute("width", "100%");
        const sourceElement = document.createElement("source");
        sourceElement.src = contentData.video_ref;
        sourceElement.type = "video/webm";
        videoElement.appendChild(sourceElement);
        this._contentVideo.appendChild(videoElement);
        videoElement.load();
        for(let i = 1; i < 4; i++){
            const showcaseImage = document.getElementById(`showcase-image-${i}`);
            if (contentData.images[i - 1]) {
                showcaseImage.src = contentData.images[i - 1];
                showcaseImage.alt = contentData.images_alt[i - 1];
                showcaseImage.type = "image/webp";
                showcaseImage.nextElementSibling.innerText = contentData.images_alt[i - 1];
            } else {
                showcaseImage.src = "";
                showcaseImage.alt = "";
                showcaseImage.nextElementSibling.innerText = "";
            }
        }
    }
    // --- WASD Icon Hide ---
    _initHideWasdIcon() {
        this._wasdHidden = false;
    }
    hideWasdIcon() {
        if (!this._wasdHidden) {
            this._wasdHidden = true;
            document.querySelector(".wasd-icon").classList.add("hide");
        }
    }
}



var $ilwiq = parcelRequire("ilwiq");

var $ilwiq = parcelRequire("ilwiq");
const $d953e530ff341053$var$_euler = new (0, $ilwiq.Euler)(0, 0, 0, "YXZ");
const $d953e530ff341053$var$_vector = new (0, $ilwiq.Vector3)();
const $d953e530ff341053$var$_changeEvent = {
    type: "change"
};
const $d953e530ff341053$var$_lockEvent = {
    type: "lock"
};
const $d953e530ff341053$var$_unlockEvent = {
    type: "unlock"
};
const $d953e530ff341053$var$_PI_2 = Math.PI / 2;
class $d953e530ff341053$export$e08ee79bd6cc99de extends (0, $ilwiq.EventDispatcher) {
    constructor(camera, domElement){
        super();
        this.camera = camera;
        this.domElement = domElement;
        this.isLocked = false;
        // Set to constrain the pitch of the camera
        // Range is 0 to Math.PI radians
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        this.pointerSpeed = 1.0;
        this._onMouseMove = $d953e530ff341053$var$onMouseMove.bind(this);
        this._onPointerlockChange = $d953e530ff341053$var$onPointerlockChange.bind(this);
        this._onPointerlockError = $d953e530ff341053$var$onPointerlockError.bind(this);
        this.connect();
    }
    connect() {
        this.domElement.ownerDocument.addEventListener("mousemove", this._onMouseMove);
        this.domElement.ownerDocument.addEventListener("pointerlockchange", this._onPointerlockChange);
        this.domElement.ownerDocument.addEventListener("pointerlockerror", this._onPointerlockError);
    }
    disconnect() {
        this.domElement.ownerDocument.removeEventListener("mousemove", this._onMouseMove);
        this.domElement.ownerDocument.removeEventListener("pointerlockchange", this._onPointerlockChange);
        this.domElement.ownerDocument.removeEventListener("pointerlockerror", this._onPointerlockError);
    }
    dispose() {
        this.disconnect();
    }
    getObject() {
        return this.camera;
    }
    getDirection(v) {
        return v.set(0, 0, -1).applyQuaternion(this.camera.quaternion);
    }
    moveForward(distance) {
        // move forward parallel to the xz-plane
        // assumes camera.up is y-up
        const camera = this.camera;
        $d953e530ff341053$var$_vector.setFromMatrixColumn(camera.matrix, 0);
        $d953e530ff341053$var$_vector.crossVectors(camera.up, $d953e530ff341053$var$_vector);
        camera.position.addScaledVector($d953e530ff341053$var$_vector, distance);
    }
    moveRight(distance) {
        const camera = this.camera;
        $d953e530ff341053$var$_vector.setFromMatrixColumn(camera.matrix, 0);
        camera.position.addScaledVector($d953e530ff341053$var$_vector, distance);
    }
    lock() {
        this.domElement.requestPointerLock();
    }
    unlock() {
        this.domElement.ownerDocument.exitPointerLock();
    }
}
// event listeners
function $d953e530ff341053$var$onMouseMove(event) {
    if (this.isLocked === false) return;
    const movementX = event.movementX || event.mozMovementX || event.webkitMovementX || 0;
    const movementY = event.movementY || event.mozMovementY || event.webkitMovementY || 0;
    const camera = this.camera;
    $d953e530ff341053$var$_euler.setFromQuaternion(camera.quaternion);
    $d953e530ff341053$var$_euler.y -= movementX * 0.002 * this.pointerSpeed;
    $d953e530ff341053$var$_euler.x -= movementY * 0.002 * this.pointerSpeed;
    $d953e530ff341053$var$_euler.x = Math.max($d953e530ff341053$var$_PI_2 - this.maxPolarAngle, Math.min($d953e530ff341053$var$_PI_2 - this.minPolarAngle, $d953e530ff341053$var$_euler.x));
    camera.quaternion.setFromEuler($d953e530ff341053$var$_euler);
    this.dispatchEvent($d953e530ff341053$var$_changeEvent);
}
function $d953e530ff341053$var$onPointerlockChange() {
    if (this.domElement.ownerDocument.pointerLockElement === this.domElement) {
        this.dispatchEvent($d953e530ff341053$var$_lockEvent);
        this.isLocked = true;
    } else {
        this.dispatchEvent($d953e530ff341053$var$_unlockEvent);
        this.isLocked = false;
    }
}
function $d953e530ff341053$var$onPointerlockError() {
    console.error("THREE.PointerLockControls: Unable to use Pointer Lock API");
}




class $06fb980720f8d216$export$cbacd6dcfff5ae2e {
    constructor({ camera: camera, renderer: renderer, sectionScene: sectionScene, modelRegistry: modelRegistry, stoneFigureParams: stoneFigureParams, fnToggleFigureAnimation: fnToggleFigureAnimation, personHeight: personHeight, speed: speed, endPosition: endPosition, gameIsActive: gameIsActive, hideWasdIcon: hideWasdIcon }){
        this._camera = camera;
        this._renderer = renderer;
        this._sectionScene = sectionScene;
        this._modelRegistry = modelRegistry;
        this._stoneFigureParams = stoneFigureParams;
        this._fnToggleFigureAnimation = fnToggleFigureAnimation;
        this._personHeight = personHeight;
        this._speed = speed;
        this._gameIsActive = gameIsActive;
        this._hideWasdIcon = hideWasdIcon;
        this._controls = null;
        this._controlsIsLocked = false;
        this._velocity = new $ilwiq.Vector3();
        this._moveForward = false;
        this._moveBackward = false;
        this._moveLeft = false;
        this._moveRight = false;
        this._playerCollider = new $ilwiq.Sphere(new $ilwiq.Vector3(0, 0, 0));
        this._playerCollider.center.set(endPosition.x, (0, $320c956a09dd2394$export$c08559766941f856)(endPosition.x, endPosition.y), endPosition.z);
        this._initControls();
        this._initTouchInput();
        this._initKeyboardInput();
    }
    get controls() {
        return this._controls;
    }
    get isLocked() {
        return this._controlsIsLocked;
    }
    _initControls() {
        this._controls = new (0, $d953e530ff341053$export$e08ee79bd6cc99de)(this._camera, this._renderer.domElement);
        this._controls.pointerSpeed = 0.8;
        this._sectionScene.addEventListener("click", ()=>{
            if (!this._controlsIsLocked && this._gameIsActive()) {
                this._controls.lock();
                this._controlsIsLocked = true;
                this._hideWasdIcon();
                setTimeout(()=>{
                    document.querySelector(".wasd-icon").classList.add("hide");
                }, 10000);
            } else {
                this._controls.unlock();
                this._controlsIsLocked = false;
            }
        });
    }
    _initTouchInput() {
        let startX = 0;
        let startY = 0;
        let isTouching = false;
        this._sectionScene.addEventListener("touchstart", (event)=>{
            isTouching = true;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
        });
        this._sectionScene.addEventListener("touchmove", (e)=>{
            if (!isTouching) return;
            const currentX = e.touches[0].clientX;
            const currentY = e.touches[0].clientY;
            const deltaX = currentX - startX;
            const deltaY = currentY - startX;
            const rotationSpeed = 0.005;
            this._camera.rotation.y -= deltaX * rotationSpeed;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        });
        this._sectionScene.addEventListener("touchend", ()=>{
            isTouching = false;
        });
    }
    _initKeyboardInput() {
        const onKeyDown = (event)=>{
            switch(event.code){
                case "ArrowUp":
                case "KeyW":
                    this._moveForward = true;
                    break;
                case "ArrowLeft":
                case "KeyA":
                    this._moveLeft = true;
                    break;
                case "ArrowDown":
                case "KeyS":
                    this._moveBackward = true;
                    break;
                case "ArrowRight":
                case "KeyD":
                    this._moveRight = true;
                    break;
            }
        };
        const onKeyUp = (event)=>{
            switch(event.code){
                case "ArrowUp":
                case "KeyW":
                    this._moveForward = false;
                    break;
                case "ArrowLeft":
                case "KeyA":
                    this._moveLeft = false;
                    break;
                case "ArrowDown":
                case "KeyS":
                    this._moveBackward = false;
                    break;
                case "ArrowRight":
                case "KeyD":
                    this._moveRight = false;
                    break;
            }
        };
        document.addEventListener("keydown", onKeyDown);
        document.addEventListener("keyup", onKeyUp);
    }
    update(deltaTime) {
        const newPosition = this._playerCollider.center.clone();
        const direction = new $ilwiq.Vector3();
        this._controls.getDirection(direction);
        const right = new $ilwiq.Vector3();
        right.crossVectors(direction, this._controls.getObject().up);
        this._velocity.x -= this._velocity.x * 10.0 * deltaTime;
        this._velocity.z -= this._velocity.z * 10.0 * deltaTime;
        if (this._moveForward) this._velocity.z -= this._speed * deltaTime;
        if (this._moveBackward) this._velocity.z += this._speed * deltaTime;
        if (this._moveLeft) this._velocity.x += this._speed * deltaTime;
        if (this._moveRight) this._velocity.x -= this._speed * deltaTime;
        newPosition.addScaledVector(direction, -this._velocity.z * deltaTime);
        newPosition.addScaledVector(right, -this._velocity.x * deltaTime);
        // Collision check
        const playerRadius = 5.5;
        const playerSphere = new $ilwiq.Sphere(newPosition, playerRadius);
        const closestPoint = new $ilwiq.Vector3();
        this._modelRegistry.forEach((data, id)=>{
            if (!(0, $9be4dfcf19ae1185$export$2e2bcd8739ae039).fnIsWithinDistance(data.position, newPosition, data.collisionRadius)) return;
            if (data.bvh) {
                if (data.name.includes("figure")) this._fnToggleFigureAnimation(this._stoneFigureParams, data.name);
                data.bvh.shapecast({
                    intersectsBounds: (box)=>box.intersectsSphere(playerSphere),
                    intersectsTriangle: (tri)=>{
                        tri.closestPointToPoint(newPosition, closestPoint);
                        const distance = newPosition.distanceTo(closestPoint);
                        if (distance < playerRadius) {
                            const penetrationDepth = playerRadius - distance;
                            const displacement = newPosition.clone().sub(closestPoint).normalize().multiplyScalar(penetrationDepth);
                            newPosition.add(displacement);
                        }
                    }
                });
            }
        });
        this._playerCollider.center.copy(newPosition);
        this._controls.getObject().position.copy(this._playerCollider.center);
        const height = (0, $320c956a09dd2394$export$c08559766941f856)(this._playerCollider.center.x, this._playerCollider.center.z);
        this._playerCollider.center.y = height + this._personHeight;
        this._controls.getObject().position.y = this._playerCollider.center.y;
    }
}



var $ilwiq = parcelRequire("ilwiq");

var $ilwiq = parcelRequire("ilwiq");

var $ilwiq = parcelRequire("ilwiq");
function $5451ea62abbe5f68$export$676e3e70c930f774(geometry, MikkTSpace, negateSign = true) {
    if (!MikkTSpace || !MikkTSpace.isReady) throw new Error("BufferGeometryUtils: Initialized MikkTSpace library required.");
    if (!geometry.hasAttribute("position") || !geometry.hasAttribute("normal") || !geometry.hasAttribute("uv")) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function getAttributeArray(attribute) {
        if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
            const dstArray = new Float32Array(attribute.count * attribute.itemSize);
            for(let i = 0, j = 0; i < attribute.count; i++){
                dstArray[j++] = attribute.getX(i);
                dstArray[j++] = attribute.getY(i);
                if (attribute.itemSize > 2) dstArray[j++] = attribute.getZ(i);
            }
            return dstArray;
        }
        if (attribute.array instanceof Float32Array) return attribute.array;
        return new Float32Array(attribute.array);
    }
    // MikkTSpace algorithm requires non-indexed input.
    const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;
    // Compute vertex tangents.
    const tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));
    // Texture coordinate convention of glTF differs from the apparent
    // default of the MikkTSpace library; .w component must be flipped.
    if (negateSign) for(let i = 3; i < tangents.length; i += 4)tangents[i] *= -1;
    //
    _geometry.setAttribute("tangent", new (0, $ilwiq.BufferAttribute)(tangents, 4));
    if (geometry !== _geometry) geometry.copy(_geometry);
    return geometry;
}
/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */ function $5451ea62abbe5f68$export$f06f69b3bf41d25c(geometries, useGroups = false) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $ilwiq.BufferGeometry)();
    let offset = 0;
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
            return null;
        }
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === undefined) attributes[name] = [];
            attributes[name].push(geometry.attributes[name]);
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". Make sure all geometries have the same number of attributes.");
            return null;
        }
        // gather morph attributes, exit early if they're different
        if (morphTargetsRelative !== geometry.morphTargetsRelative) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". .morphTargetsRelative must be consistent throughout all geometries.");
            return null;
        }
        for(const name in geometry.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ".  .morphAttributes must be consistent throughout all geometries.");
                return null;
            }
            if (morphAttributes[name] === undefined) morphAttributes[name] = [];
            morphAttributes[name].push(geometry.morphAttributes[name]);
        }
        if (useGroups) {
            let count;
            if (isIndexed) count = geometry.index.count;
            else if (geometry.attributes.position !== undefined) count = geometry.attributes.position.count;
            else {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". The geometry must have either an index or a position attribute");
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    }
    // merge indices
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        for(let i = 0; i < geometries.length; ++i){
            const index = geometries[i].index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geometries[i].attributes.position.count;
        }
        mergedGeometry.setIndex(mergedIndex);
    }
    // merge attributes
    for(const name in attributes){
        const mergedAttribute = $5451ea62abbe5f68$export$9f98db6234c4bd78(attributes[name]);
        if (!mergedAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + name + " attribute.");
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    // merge morph attributes
    for(const name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $5451ea62abbe5f68$export$9f98db6234c4bd78(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + name + " morphAttribute.");
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */ function $5451ea62abbe5f68$export$9f98db6234c4bd78(attributes) {
    let TypedArray;
    let itemSize;
    let normalized;
    let gpuType = -1;
    let arrayLength = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
            return null;
        }
        if (itemSize === undefined) itemSize = attribute.itemSize;
        if (itemSize !== attribute.itemSize) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
            return null;
        }
        if (normalized === undefined) normalized = attribute.normalized;
        if (normalized !== attribute.normalized) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
            return null;
        }
        if (gpuType === -1) gpuType = attribute.gpuType;
        if (gpuType !== attribute.gpuType) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.");
            return null;
        }
        arrayLength += attribute.count * itemSize;
    }
    const array = new TypedArray(arrayLength);
    const result = new (0, $ilwiq.BufferAttribute)(array, itemSize, normalized);
    let offset = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (attribute.isInterleavedBufferAttribute) {
            const tupleOffset = offset / itemSize;
            for(let j = 0, l = attribute.count; j < l; j++)for(let c = 0; c < itemSize; c++){
                const value = attribute.getComponent(j, c);
                result.setComponent(j + tupleOffset, c, value);
            }
        } else array.set(attribute.array, offset);
        offset += attribute.count * itemSize;
    }
    if (gpuType !== undefined) result.gpuType = gpuType;
    return result;
}
function $5451ea62abbe5f68$export$4848639a9adff548(attribute) {
    if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) return $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attribute);
    if (attribute.isInstancedBufferAttribute) return new (0, $ilwiq.InstancedBufferAttribute)().copy(attribute);
    return new (0, $ilwiq.BufferAttribute)().copy(attribute);
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */ function $5451ea62abbe5f68$export$308f9509e428a845(attributes) {
    // Interleaves the provided attributes into an InterleavedBuffer and returns
    // a set of InterleavedBufferAttributes for each attribute
    let TypedArray;
    let arrayLength = 0;
    let stride = 0;
    // calculate the length and type of the interleavedBuffer
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("AttributeBuffers of different types cannot be interleaved");
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    // Create the set of buffer attributes
    const interleavedBuffer = new (0, $ilwiq.InterleavedBuffer)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $ilwiq.InterleavedBufferAttribute)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        // Move the data for each attribute into the new interleavedBuffer
        // at the appropriate offset
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++)iba[setters[k]](c, attribute[getters[k]](c));
    }
    return res;
}
function $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attribute) {
    const cons = attribute.data.array.constructor;
    const count = attribute.count;
    const itemSize = attribute.itemSize;
    const normalized = attribute.normalized;
    const array = new cons(count * itemSize);
    let newAttribute;
    if (attribute.isInstancedInterleavedBufferAttribute) newAttribute = new (0, $ilwiq.InstancedBufferAttribute)(array, itemSize, normalized, attribute.meshPerAttribute);
    else newAttribute = new (0, $ilwiq.BufferAttribute)(array, itemSize, normalized);
    for(let i = 0; i < count; i++){
        newAttribute.setX(i, attribute.getX(i));
        if (itemSize >= 2) newAttribute.setY(i, attribute.getY(i));
        if (itemSize >= 3) newAttribute.setZ(i, attribute.getZ(i));
        if (itemSize >= 4) newAttribute.setW(i, attribute.getW(i));
    }
    return newAttribute;
}
function $5451ea62abbe5f68$export$e7413b17bfaaa80b(geometry) {
    const attributes = geometry.attributes;
    const morphTargets = geometry.morphTargets;
    const attrMap = new Map();
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attr));
            attributes[key] = attrMap.get(attr);
        }
    }
    for(const key in morphTargets){
        const attr = morphTargets[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attr));
            morphTargets[key] = attrMap.get(attr);
        }
    }
}
/**
 * @param {BufferGeometry} geometry
 * @return {number}
 */ function $5451ea62abbe5f68$export$35bee7999e19754d(geometry) {
    // Return the estimated memory used by this geometry in bytes
    // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
    // for InterleavedBufferAttributes.
    let mem = 0;
    for(const name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */ function $5451ea62abbe5f68$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    // Generate an index buffer if the geometry doesn't have one, or optimize it
    // if it's already available.
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute("position");
    const vertexCount = indices ? indices.count : positions.count;
    // next value for triangle indices
    let nextIndex = 0;
    // attributes and new attribute arrays
    const attributeNames = Object.keys(geometry.attributes);
    const tmpAttributes = {};
    const tmpMorphAttributes = {};
    const newIndices = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    // Initialize the arrays, allocating space conservatively. Extra
    // space will be trimmed in the last step.
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const attr = geometry.attributes[name];
        tmpAttributes[name] = new attr.constructor(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
        const morphAttributes = geometry.morphAttributes[name];
        if (morphAttributes) {
            if (!tmpMorphAttributes[name]) tmpMorphAttributes[name] = [];
            morphAttributes.forEach((morphAttr, i)=>{
                const array = new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize);
                tmpMorphAttributes[name][i] = new morphAttr.constructor(array, morphAttr.itemSize, morphAttr.normalized);
            });
        }
    }
    // convert the error tolerance to an amount of decimal places to truncate to
    const halfTolerance = tolerance * 0.5;
    const exponent = Math.log10(1 / tolerance);
    const hashMultiplier = Math.pow(10, exponent);
    const hashAdditive = halfTolerance * hashMultiplier;
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        // Generate a hash for the vertex attributes at the current index 'i'
        let hash = "";
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)// double tilde truncates the decimal value
            hash += `${~~(attribute[getters[k]](index) * hashMultiplier + hashAdditive)},`;
        }
        // Add another reference to the vertex if it's already
        // used by another index
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            // copy data to the new index in the temporary attributes
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttributes = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newArray = tmpAttributes[name];
                const newMorphArrays = tmpMorphAttributes[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    const setterFunc = setters[k];
                    newArray[setterFunc](nextIndex, attribute[getterFunc](index));
                    if (morphAttributes) for(let m = 0, ml = morphAttributes.length; m < ml; m++)newMorphArrays[m][setterFunc](nextIndex, morphAttributes[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    // generate result BufferGeometry
    const result = geometry.clone();
    for(const name in geometry.attributes){
        const tmpAttribute = tmpAttributes[name];
        result.setAttribute(name, new tmpAttribute.constructor(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));
        if (!(name in tmpMorphAttributes)) continue;
        for(let j = 0; j < tmpMorphAttributes[name].length; j++){
            const tmpMorphAttribute = tmpMorphAttributes[name][j];
            result.morphAttributes[name][j] = new tmpMorphAttribute.constructor(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
        }
    }
    // indices
    result.setIndex(newIndices);
    return result;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */ function $5451ea62abbe5f68$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $ilwiq.TrianglesDrawMode)) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return geometry;
    }
    if (drawMode === (0, $ilwiq.TriangleFanDrawMode) || drawMode === (0, $ilwiq.TriangleStripDrawMode)) {
        let index = geometry.getIndex();
        // generate index if not present
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute("position");
            if (position !== undefined) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
                return geometry;
            }
        }
        //
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (drawMode === (0, $ilwiq.TriangleFanDrawMode)) // gl.TRIANGLE_FAN
        for(let i = 1; i <= numberOfTriangles; i++){
            newIndices.push(index.getX(0));
            newIndices.push(index.getX(i));
            newIndices.push(index.getX(i + 1));
        }
        else {
            // gl.TRIANGLE_STRIP
            for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i + 2));
            } else {
                newIndices.push(index.getX(i + 2));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i));
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        // build final geometry
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
        return geometry;
    }
}
/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */ function $5451ea62abbe5f68$export$29e54e2e4ab904e7(object) {
    const _vA = new (0, $ilwiq.Vector3)();
    const _vB = new (0, $ilwiq.Vector3)();
    const _vC = new (0, $ilwiq.Vector3)();
    const _tempA = new (0, $ilwiq.Vector3)();
    const _tempB = new (0, $ilwiq.Vector3)();
    const _tempC = new (0, $ilwiq.Vector3)();
    const _morphA = new (0, $ilwiq.Vector3)();
    const _morphB = new (0, $ilwiq.Vector3)();
    const _morphC = new (0, $ilwiq.Vector3)();
    function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a);
        _vB.fromBufferAttribute(attribute, b);
        _vC.fromBufferAttribute(attribute, c);
        const morphInfluences = object.morphTargetInfluences;
        if (morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const influence = morphInfluences[i];
                const morph = morphAttribute[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a);
                _tempB.fromBufferAttribute(morph, b);
                _tempC.fromBufferAttribute(morph, c);
                if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object.isSkinnedMesh) {
            object.applyBoneTransform(a, _vA);
            object.applyBoneTransform(b, _vB);
            object.applyBoneTransform(c, _vC);
        }
        modifiedAttributeArray[a * 3 + 0] = _vA.x;
        modifiedAttributeArray[a * 3 + 1] = _vA.y;
        modifiedAttributeArray[a * 3 + 2] = _vA.z;
        modifiedAttributeArray[b * 3 + 0] = _vB.x;
        modifiedAttributeArray[b * 3 + 1] = _vB.y;
        modifiedAttributeArray[b * 3 + 2] = _vB.z;
        modifiedAttributeArray[c * 3 + 0] = _vC.x;
        modifiedAttributeArray[c * 3 + 1] = _vC.y;
        modifiedAttributeArray[c * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        // indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else {
        // non-indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $ilwiq.Float32BufferAttribute)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $ilwiq.Float32BufferAttribute)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $5451ea62abbe5f68$export$8babbf41197098b1(geometry) {
    if (geometry.groups.length === 0) {
        console.warn("THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.");
        return geometry;
    }
    let groups = geometry.groups;
    // sort groups by material index
    groups = groups.sort((a, b)=>{
        if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
        return a.start - b.start;
    });
    // create index for non-indexed geometries
    if (geometry.getIndex() === null) {
        const positionAttribute = geometry.getAttribute("position");
        const indices = [];
        for(let i = 0; i < positionAttribute.count; i += 3)indices.push(i, i + 1, i + 2);
        geometry.setIndex(indices);
    }
    // sort index
    const index = geometry.getIndex();
    const newIndices = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const groupStart = group.start;
        const groupLength = groupStart + group.count;
        for(let j = groupStart; j < groupLength; j++)newIndices.push(index.getX(j));
    }
    geometry.dispose(); // Required to force buffer recreation
    geometry.setIndex(newIndices);
    // update groups indices
    let start = 0;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        group.start = start;
        start += group.count;
    }
    // merge groups
    let currentGroup = groups[0];
    geometry.groups = [
        currentGroup
    ];
    for(let i = 1; i < groups.length; i++){
        const group = groups[i];
        if (currentGroup.materialIndex === group.materialIndex) currentGroup.count += group.count;
        else {
            currentGroup = group;
            geometry.groups.push(currentGroup);
        }
    }
    return geometry;
}
/**
 * Modifies the supplied geometry if it is non-indexed, otherwise creates a new,
 * non-indexed geometry. Returns the geometry with smooth normals everywhere except
 * faces that meet at an angle greater than the crease angle.
 *
 * @param {BufferGeometry} geometry
 * @param {number} [creaseAngle]
 * @return {BufferGeometry}
 */ function $5451ea62abbe5f68$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 1e2;
    // reusable vectors
    const verts = [
        new (0, $ilwiq.Vector3)(),
        new (0, $ilwiq.Vector3)(),
        new (0, $ilwiq.Vector3)()
    ];
    const tempVec1 = new (0, $ilwiq.Vector3)();
    const tempVec2 = new (0, $ilwiq.Vector3)();
    const tempNorm = new (0, $ilwiq.Vector3)();
    const tempNorm2 = new (0, $ilwiq.Vector3)();
    // hashes a vector
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    // BufferGeometry.toNonIndexed() warns if the geometry is non-indexed
    // and returns the original geometry
    const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    // find all the normals shared by commonly located vertices
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        // add the normal to the map for all vertices
        const normal = new (0, $ilwiq.Vector3)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    // average normals from all vertices that share a common location if they are within the
    // provided crease threshold
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $ilwiq.BufferAttribute)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        // get the face normal for this vertex
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        // average all normals that meet the threshold and set the normal value
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute("normal", normAttr);
    return resultGeometry;
}


class $559434fcc6e6401d$export$aa93f11e7884f0f4 extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsDispersionExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsBumpExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMeshGpuInstancing(parser);
        });
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== "") resourcePath = this.resourcePath;
        else if (this.path !== "") {
            // If a base path is set, resources will be relative paths from that plus the relative path of the gltf file
            // Example  path = 'https://my-cnd-server.com/', url = 'assets/models/model.gltf'
            // resourcePath = 'https://my-cnd-server.com/assets/models/'
            // referenced resource 'model.bin' will be loaded from 'https://my-cnd-server.com/assets/models/model.bin'
            // referenced resource '../textures/texture.png' will be loaded from 'https://my-cnd-server.com/assets/textures/texture.png'
            const relativeUrl = (0, $ilwiq.LoaderUtils).extractUrlBase(url);
            resourcePath = (0, $ilwiq.LoaderUtils).resolveURL(relativeUrl, this.path);
        } else resourcePath = (0, $ilwiq.LoaderUtils).extractUrlBase(url);
        // Tells the LoadingManager to track an extra item, which resolves after
        // the model is fully loaded. This means the count of items loaded will
        // be incorrect, but ensures manager.onLoad() does not fire early.
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $ilwiq.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        const textDecoder = new TextDecoder();
        if (typeof data === "string") json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
            if (magic === $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF] = new $559434fcc6e6401d$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse(textDecoder.decode(data));
        } else json = data;
        if (json.asset === undefined || json.asset.version[0] < 2) {
            if (onError) onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
            return;
        }
        const parser = new $559434fcc6e6401d$var$GLTFParser(json, {
            path: path || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            if (!plugin.name) console.error("THREE.GLTFLoader: Invalid plugin found: missing name");
            plugins[plugin.name] = plugin;
            // Workaround to avoid determining as unknown extension
            // in addUnknownExtensionsToUserData().
            // Remove this workaround if we move all the existing
            // extension handlers to plugin system
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFMaterialsUnlitExtension();
                    break;
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFTextureTransformExtension();
                    break;
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
/* GLTFREGISTRY */ function $559434fcc6e6401d$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
/*********************************/ /********** EXTENSIONS ***********/ /*********************************/ const $559434fcc6e6401d$var$EXTENSIONS = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_MATERIALS_BUMP: "EXT_materials_bump",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */ class $559434fcc6e6401d$var$GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        // Object3D instance caches
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = "light:" + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $ilwiq.Color)(0xffffff);
        if (lightDef.color !== undefined) color.setRGB(lightDef.color[0], lightDef.color[1], lightDef.color[2], (0, $ilwiq.LinearSRGBColorSpace));
        const range = lightDef.range !== undefined ? lightDef.range : 0;
        switch(lightDef.type){
            case "directional":
                lightNode = new (0, $ilwiq.DirectionalLight)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case "point":
                lightNode = new (0, $ilwiq.PointLight)(color);
                lightNode.distance = range;
                break;
            case "spot":
                lightNode = new (0, $ilwiq.SpotLight)(color);
                lightNode.distance = range;
                // Handle spotlight properties.
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
        }
        // Some lights (e.g. spot) default to a position other than the origin. Reset the position
        // here, because node-level parsing will only override position if explicitly specified.
        lightNode.position.set(0, 0, 0);
        lightNode.decay = 2;
        $559434fcc6e6401d$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== "light") return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self1 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === undefined) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self1.cache, lightIndex, light);
        });
    }
}
/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */ class $559434fcc6e6401d$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $ilwiq.MeshBasicMaterial;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $ilwiq.Color)(1.0, 1.0, 1.0);
        materialParams.opacity = 1.0;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], (0, $ilwiq.LinearSRGBColorSpace));
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, (0, $ilwiq.SRGBColorSpace)));
        }
        return Promise.all(pending);
    }
}
/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */ class $559434fcc6e6401d$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== undefined) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */ class $559434fcc6e6401d$var$GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== undefined) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== undefined) pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== undefined) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== undefined) {
            pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== undefined) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $ilwiq.Vector2)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
/**
 * Materials dispersion Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_dispersion
 */ class $559434fcc6e6401d$var$GLTFMaterialsDispersionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_DISPERSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.dispersion = extension.dispersion !== undefined ? extension.dispersion : 0;
        return Promise.resolve();
    }
}
/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */ class $559434fcc6e6401d$var$GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== undefined) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== undefined) pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
        if (extension.iridescenceIor !== undefined) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === undefined) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== undefined) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== undefined) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */ class $559434fcc6e6401d$var$GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $ilwiq.Color)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== undefined) {
            const colorFactor = extension.sheenColorFactor;
            materialParams.sheenColor.setRGB(colorFactor[0], colorFactor[1], colorFactor[2], (0, $ilwiq.LinearSRGBColorSpace));
        }
        if (extension.sheenRoughnessFactor !== undefined) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, (0, $ilwiq.SRGBColorSpace)));
        if (extension.sheenRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */ class $559434fcc6e6401d$var$GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== undefined) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== undefined) pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */ class $559434fcc6e6401d$var$GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $ilwiq.Color)().setRGB(colorArray[0], colorArray[1], colorArray[2], (0, $ilwiq.LinearSRGBColorSpace));
        return Promise.all(pending);
    }
}
/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */ class $559434fcc6e6401d$var$GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */ class $559434fcc6e6401d$var$GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
        if (extension.specularTexture !== undefined) pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $ilwiq.Color)().setRGB(colorArray[0], colorArray[1], colorArray[2], (0, $ilwiq.LinearSRGBColorSpace));
        if (extension.specularColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, (0, $ilwiq.SRGBColorSpace)));
        return Promise.all(pending);
    }
}
/**
 * Materials bump Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/EXT_materials_bump
 */ class $559434fcc6e6401d$var$GLTFMaterialsBumpExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_MATERIALS_BUMP;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.bumpScale = extension.bumpFactor !== undefined ? extension.bumpFactor : 1.0;
        if (extension.bumpTexture !== undefined) pending.push(parser.assignTexture(materialParams, "bumpMap", extension.bumpTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 */ class $559434fcc6e6401d$var$GLTFMaterialsAnisotropyExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== undefined) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== undefined) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== undefined) pending.push(parser.assignTexture(materialParams, "anisotropyMap", extension.anisotropyTexture));
        return Promise.all(pending);
    }
}
/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */ class $559434fcc6e6401d$var$GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            else // Assumes that the extension is optional and that a fallback texture is present
            return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */ class $559434fcc6e6401d$var$GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image. Support for lossy images doesn't guarantee support for all
            // WebP images, unfortunately.
            image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */ class $559434fcc6e6401d$var$GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image.
            image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */ class $559434fcc6e6401d$var$GLTFMeshoptCompression {
    constructor(parser){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                else // Assumes that the extension is optional and that fallback buffer data is present
                return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res) {
                    return res.buffer;
                });
                else // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
                return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */ class $559434fcc6e6401d$var$GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        // No Points or Lines + Instancing support yet
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        // @TODO: Can we support InstancedMesh + SkinnedMesh?
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency("accessor", attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count; // All attribute counts should be same
            const instancedMeshes = [];
            for (const mesh of meshes){
                // Temporal variables
                const m = new (0, $ilwiq.Matrix4)();
                const p = new (0, $ilwiq.Vector3)();
                const q = new (0, $ilwiq.Quaternion)();
                const s = new (0, $ilwiq.Vector3)(1, 1, 1);
                const instancedMesh = new (0, $ilwiq.InstancedMesh)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                // Add instance attributes to the geometry, excluding TRS.
                for(const attributeName in attributes){
                    if (attributeName === "_COLOR_0") {
                        const attr = attributes[attributeName];
                        instancedMesh.instanceColor = new (0, $ilwiq.InstancedBufferAttribute)(attr.array, attr.itemSize, attr.normalized);
                    } else if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                }
                // Just in case
                (0, $ilwiq.Object3D).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
/* BINARY EXTENSION */ const $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $559434fcc6e6401d$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 0x4E4F534A,
    BIN: 0x004E4942
};
class $559434fcc6e6401d$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH);
        const textDecoder = new TextDecoder();
        this.header = {
            magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        else if (this.header.version < 2.0) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const chunkContentsLength = this.header.length - $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $559434fcc6e6401d$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = textDecoder.decode(contentArray);
            } else if (chunkType === $559434fcc6e6401d$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            // Clients must ignore chunks with unknown types.
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */ class $559434fcc6e6401d$var$GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $559434fcc6e6401d$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $559434fcc6e6401d$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== undefined) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve, reject) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== undefined) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap, (0, $ilwiq.LinearSRGBColorSpace), reject);
            });
        });
    }
}
/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */ class $559434fcc6e6401d$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) // See https://github.com/mrdoob/three.js/issues/21819.
        return texture;
        texture = texture.clone();
        if (transform.texCoord !== undefined) texture.channel = transform.texCoord;
        if (transform.offset !== undefined) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== undefined) texture.rotation = transform.rotation;
        if (transform.scale !== undefined) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */ class $559434fcc6e6401d$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
/*********************************/ /********** INTERPOLATION ********/ /*********************************/ // Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class $559434fcc6e6401d$var$GLTFCubicSplineInterpolant extends (0, $ilwiq.Interpolant) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        // Copies a sample value to the result buffer. See description of glTF
        // CUBICSPLINE values layout in interpolate_() function below.
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        // Layout of keyframe output values for CUBICSPLINE animations:
        //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride]; // splineVertex_k
            const m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
            const p1 = values[offset1 + i + stride]; // splineVertex_k+1
            const m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const $559434fcc6e6401d$var$_q = new (0, $ilwiq.Quaternion)();
class $559434fcc6e6401d$var$GLTFCubicSplineQuaternionInterpolant extends $559434fcc6e6401d$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $559434fcc6e6401d$var$_q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
/*********************************/ /********** INTERNALS ************/ /*********************************/ /* CONSTANTS */ const $559434fcc6e6401d$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $559434fcc6e6401d$var$WEBGL_FILTERS = {
    9728: (0, $ilwiq.NearestFilter),
    9729: (0, $ilwiq.LinearFilter),
    9984: (0, $ilwiq.NearestMipmapNearestFilter),
    9985: (0, $ilwiq.LinearMipmapNearestFilter),
    9986: (0, $ilwiq.NearestMipmapLinearFilter),
    9987: (0, $ilwiq.LinearMipmapLinearFilter)
};
const $559434fcc6e6401d$var$WEBGL_WRAPPINGS = {
    33071: (0, $ilwiq.ClampToEdgeWrapping),
    33648: (0, $ilwiq.MirroredRepeatWrapping),
    10497: (0, $ilwiq.RepeatWrapping)
};
const $559434fcc6e6401d$var$WEBGL_TYPE_SIZES = {
    "SCALAR": 1,
    "VEC2": 2,
    "VEC3": 3,
    "VEC4": 4,
    "MAT2": 4,
    "MAT3": 9,
    "MAT4": 16
};
const $559434fcc6e6401d$var$ATTRIBUTES = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv1",
    TEXCOORD_2: "uv2",
    TEXCOORD_3: "uv3",
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
};
const $559434fcc6e6401d$var$PATH_PROPERTIES = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
};
const $559434fcc6e6401d$var$INTERPOLATION = {
    CUBICSPLINE: undefined,
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $ilwiq.InterpolateLinear),
    STEP: (0, $ilwiq.InterpolateDiscrete)
};
const $559434fcc6e6401d$var$ALPHA_MODES = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
};
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */ function $559434fcc6e6401d$var$createDefaultMaterial(cache) {
    if (cache["DefaultMaterial"] === undefined) cache["DefaultMaterial"] = new (0, $ilwiq.MeshStandardMaterial)({
        color: 0xFFFFFF,
        emissive: 0x000000,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $ilwiq.FrontSide)
    });
    return cache["DefaultMaterial"];
}
function $559434fcc6e6401d$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    // Add unknown glTF extensions to an object's userData.
    for(const name in objectDef.extensions)if (knownExtensions[name] === undefined) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */ function $559434fcc6e6401d$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== undefined) {
        if (typeof gltfDef.extras === "object") Object.assign(object.userData, gltfDef.extras);
        else console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
}
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $559434fcc6e6401d$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== undefined) hasMorphPosition = true;
        if (target.NORMAL !== undefined) hasMorphNormal = true;
        if (target.COLOR_0 !== undefined) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== undefined ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== undefined ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== undefined ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */ function $559434fcc6e6401d$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== undefined) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    // .extras has user-defined data, so check that .extras.targetNames is an array.
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function $559434fcc6e6401d$var$createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + $559434fcc6e6401d$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ":" + $559434fcc6e6401d$var$createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
    if (primitiveDef.targets !== undefined) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ":" + $559434fcc6e6401d$var$createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function $559434fcc6e6401d$var$createAttributesKey(attributes) {
    let attributesKey = "";
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ":" + attributes[keys[i]] + ";";
    return attributesKey;
}
function $559434fcc6e6401d$var$getNormalizedComponentScale(constructor) {
    // Reference:
    // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
function $559434fcc6e6401d$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return "image/jpeg";
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return "image/webp";
    return "image/png";
}
const $559434fcc6e6401d$var$_identityMatrix = new (0, $ilwiq.Matrix4)();
/* GLTF PARSER */ class $559434fcc6e6401d$var$GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        // loader object cache
        this.cache = new $559434fcc6e6401d$var$GLTFRegistry();
        // associations between Three.js objects and glTF elements
        this.associations = new Map();
        // BufferGeometry caching
        this.primitiveCache = {};
        // Node cache
        this.nodeCache = {};
        // Object3D instance caches
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        // Track node names, to ensure no duplicates
        this.nodeNamesUsed = {};
        // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
        // expensive work of uploading a texture to the GPU off the main thread.
        let isSafari = false;
        let safariVersion = -1;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== "undefined") {
            const userAgent = navigator.userAgent;
            isSafari = /^((?!chrome|android).)*safari/i.test(userAgent) === true;
            const safariMatch = userAgent.match(/Version\/(\d+)/);
            safariVersion = isSafari && safariMatch ? parseInt(safariMatch[1], 10) : -1;
            isFirefox = userAgent.indexOf("Firefox") > -1;
            firefoxVersion = isFirefox ? userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === "undefined" || isSafari && safariVersion < 17 || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $ilwiq.TextureLoader)(this.options.manager);
        else this.textureLoader = new (0, $ilwiq.ImageBitmapLoader)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $ilwiq.FileLoader)(this.options.manager);
        this.fileLoader.setResponseType("arraybuffer");
        if (this.options.crossOrigin === "use-credentials") this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        // Clear the loader cache
        this.cache.removeAll();
        this.nodeCache = {};
        // Mark the special nodes/meshes in json for efficient parse
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies("scene"),
                parser.getDependencies("animation"),
                parser.getDependencies("camera")
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, result, json);
            $559434fcc6e6401d$var$assignExtrasToUserData(result, json);
            return Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                for (const scene of result.scenes)scene.updateMatrixWorld();
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
	 * Marks the special nodes/meshes in json for efficient parse.
	 */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        // Nothing in the node definition indicates whether it is a Bone or an
        // Object3D. Use the skins' joint references to mark bones.
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        // Iterate over all nodes, marking references to shared resources,
        // as well as skeleton joints.
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== undefined) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                // Nothing in the mesh definition indicates whether it is
                // a SkinnedMesh or Mesh. Use the node's mesh reference
                // to mark SkinnedMesh if node has skin.
                if (nodeDef.skin !== undefined) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== undefined) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
	 * Counts references to shared node / Object3D resources. These resources
	 * can be reused, or "instantiated", at multiple nodes in the scene
	 * hierarchy. Mesh, Camera, and Light instances are instantiated and must
	 * be marked. Non-scenegraph resources (like Materials, Geometries, and
	 * Textures) can be reused directly and are not marked here.
	 *
	 * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
	 */ _addNodeRef(cache, index) {
        if (index === undefined) return;
        if (cache.refs[index] === undefined) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /** Returns a reference to a shared resource, cloning it if necessary. */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        // Propagates mappings to the cloned object, prevents mappings on the
        // original object from being lost.
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += "_instance_" + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
	 * Requests the specified dependency asynchronously, with caching.
	 * @param {string} type
	 * @param {number} index
	 * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
	 */ getDependency(type, index) {
        const cacheKey = type + ":" + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case "scene":
                    dependency = this.loadScene(index);
                    break;
                case "node":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case "mesh":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case "accessor":
                    dependency = this.loadAccessor(index);
                    break;
                case "bufferView":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case "buffer":
                    dependency = this.loadBuffer(index);
                    break;
                case "material":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case "texture":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case "skin":
                    dependency = this.loadSkin(index);
                    break;
                case "animation":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case "camera":
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error("Unknown type: " + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
	 * Requests all dependencies of the specified type asynchronously, with caching.
	 * @param {string} type
	 * @return {Promise<Array<Object>>}
	 */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== "arraybuffer") throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
        // If present, GLB container is required to be the first buffer.
        if (bufferDef.uri === undefined && bufferIndex === 0) return Promise.resolve(this.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, $ilwiq.LoaderUtils).resolveURL(bufferDef.uri, options.path), resolve, undefined, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferViewIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
	 * @param {number} accessorIndex
	 * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
	 */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
            const itemSize = $559434fcc6e6401d$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $ilwiq.BufferAttribute)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== undefined) pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== undefined) {
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $559434fcc6e6401d$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            // The buffer is not interleaved if the stride is the item size in bytes.
            if (byteStride && byteStride !== itemBytes) {
                // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                // This makes sure that IBA.count reflects accessor.count properly
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    // Integer parameters to IB/IBA are in array elements, not bytes.
                    ib = new (0, $ilwiq.InterleavedBuffer)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $ilwiq.InterleavedBufferAttribute)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $ilwiq.BufferAttribute)(array, itemSize, normalized);
            }
            // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
            if (accessorDef.sparse !== undefined) {
                const itemSizeIndices = $559434fcc6e6401d$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                bufferAttribute = new (0, $ilwiq.BufferAttribute)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
            }
            return bufferAttribute;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
	 * @param {number} textureIndex
	 * @return {Promise<THREE.Texture|null>}
	 */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
        if (this.textureCache[cacheKey]) // See https://github.com/mrdoob/three.js/issues/21559.
        return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || "";
            if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $559434fcc6e6401d$var$WEBGL_FILTERS[sampler.magFilter] || (0, $ilwiq.LinearFilter);
            texture.minFilter = $559434fcc6e6401d$var$WEBGL_FILTERS[sampler.minFilter] || (0, $ilwiq.LinearMipmapLinearFilter);
            texture.wrapS = $559434fcc6e6401d$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $ilwiq.RepeatWrapping);
            texture.wrapT = $559434fcc6e6401d$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $ilwiq.RepeatWrapping);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== undefined) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || "";
        let isObjectURL = false;
        if (sourceDef.bufferView !== undefined) // Load binary image data from bufferView, if provided.
        sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === undefined) throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
        const promise = Promise.resolve(sourceURI).then(function(sourceURI) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $ilwiq.Texture)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $ilwiq.LoaderUtils).resolveURL(sourceURI, options.path), onLoad, undefined, reject);
            });
        }).then(function(texture) {
            // Clean up resources and configure Texture.
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            $559434fcc6e6401d$var$assignExtrasToUserData(texture, sourceDef);
            texture.userData.mimeType = sourceDef.mimeType || $559434fcc6e6401d$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
	 * Asynchronously assigns a texture to the given material parameters.
	 * @param {Object} materialParams
	 * @param {string} mapName
	 * @param {Object} mapDef
	 * @return {Promise<Texture>}
	 */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency("texture", mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== undefined ? mapDef.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (colorSpace !== undefined) texture.colorSpace = colorSpace;
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
	 * Assigns final material to a Mesh, Line, or Points instance. The instance
	 * already has a material (generated from the glTF material options alone)
	 * but reuse of the same glTF material may require multiple threejs materials
	 * to accommodate different primitive types, defines, etc. New materials will
	 * be created if necessary, and reused from a cache.
	 * @param  {Object3D} mesh Mesh, Line, or Points instance.
	 */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === undefined;
        const useVertexColors = geometry.attributes.color !== undefined;
        const useFlatShading = geometry.attributes.normal === undefined;
        if (mesh.isPoints) {
            const cacheKey = "PointsMaterial:" + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $ilwiq.PointsMaterial)();
                (0, $ilwiq.Material).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = "LineBasicMaterial:" + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $ilwiq.LineBasicMaterial)();
                (0, $ilwiq.Material).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        // Clone the material if it will be modified
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = "ClonedMaterial:" + material.uuid + ":";
            if (useDerivativeTangents) cacheKey += "derivative-tangents:";
            if (useVertexColors) cacheKey += "vertex-colors:";
            if (useFlatShading) cacheKey += "flat-shading:";
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $ilwiq.MeshStandardMaterial;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
	 * @param {number} materialIndex
	 * @return {Promise<Material>}
	 */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            // Specification:
            // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $ilwiq.Color)(1.0, 1.0, 1.0);
            materialParams.opacity = 1.0;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], (0, $ilwiq.LinearSRGBColorSpace));
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, (0, $ilwiq.SRGBColorSpace)));
            materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
            materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
            if (metallicRoughness.metallicRoughnessTexture !== undefined) {
                pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $ilwiq.DoubleSide);
        const alphaMode = materialDef.alphaMode || $559434fcc6e6401d$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $559434fcc6e6401d$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            // See: https://github.com/mrdoob/three.js/issues/17706
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $559434fcc6e6401d$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== undefined && materialType !== (0, $ilwiq.MeshBasicMaterial)) {
            pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
            materialParams.normalScale = new (0, $ilwiq.Vector2)(1, 1);
            if (materialDef.normalTexture.scale !== undefined) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== undefined && materialType !== (0, $ilwiq.MeshBasicMaterial)) {
            pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== undefined) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== undefined && materialType !== (0, $ilwiq.MeshBasicMaterial)) {
            const emissiveFactor = materialDef.emissiveFactor;
            materialParams.emissive = new (0, $ilwiq.Color)().setRGB(emissiveFactor[0], emissiveFactor[1], emissiveFactor[2], (0, $ilwiq.LinearSRGBColorSpace));
        }
        if (materialDef.emissiveTexture !== undefined && materialType !== (0, $ilwiq.MeshBasicMaterial)) pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, (0, $ilwiq.SRGBColorSpace)));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $559434fcc6e6401d$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /** When Object3D instances are targeted by animation, they need unique names. */ createUniqueName(originalName) {
        const sanitizedName = (0, $ilwiq.PropertyBinding).sanitizeNodeName(originalName || "");
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + "_" + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
	 *
	 * Creates BufferGeometries from primitives.
	 *
	 * @param {Array<GLTF.Primitive>} primitives
	 * @return {Promise<Array<BufferGeometry>>}
	 */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $559434fcc6e6401d$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $559434fcc6e6401d$var$createPrimitiveKey(primitive);
            // See if we've already created this geometry
            const cached = cache[cacheKey];
            if (cached) // Use the cached geometry if it exists
            pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) // Use DRACO geometry if available
                geometryPromise = createDracoPrimitive(primitive);
                else // Otherwise create a new geometry
                geometryPromise = $559434fcc6e6401d$var$addPrimitiveAttributes(new (0, $ilwiq.BufferGeometry)(), primitive, parser);
                // Cache this geometry
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
	 * @param {number} meshIndex
	 * @return {Promise<Group|Mesh|SkinnedMesh>}
	 */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === undefined ? $559434fcc6e6401d$var$createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                // 1. create Mesh
                let mesh;
                const material = materials[i];
                if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
                    // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $ilwiq.SkinnedMesh)(geometry, material) : new (0, $ilwiq.Mesh)(geometry, material);
                    if (mesh.isSkinnedMesh === true) // normalize skin weights to fix malformed assets (see #15319)
                    mesh.normalizeSkinWeights();
                    if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $5451ea62abbe5f68$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $ilwiq.TriangleStripDrawMode));
                    else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $5451ea62abbe5f68$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $ilwiq.TriangleFanDrawMode));
                } else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $ilwiq.LineSegments)(geometry, material);
                else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $ilwiq.Line)(geometry, material);
                else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $ilwiq.LineLoop)(geometry, material);
                else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $ilwiq.Points)(geometry, material);
                else throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $559434fcc6e6401d$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
                $559434fcc6e6401d$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, $ilwiq.Group)();
            if (meshDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
	 * @param {number} cameraIndex
	 * @return {Promise<THREE.Camera>}
	 */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn("THREE.GLTFLoader: Missing camera parameters.");
            return;
        }
        if (cameraDef.type === "perspective") camera = new (0, $ilwiq.PerspectiveCamera)((0, $ilwiq.MathUtils).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === "orthographic") camera = new (0, $ilwiq.OrthographicCamera)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $559434fcc6e6401d$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
	 * @param {number} skinIndex
	 * @return {Promise<Skeleton>}
	 */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== undefined) pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            // Note that bones (joint nodes) may or may not be in the
            // scene graph at this time.
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $ilwiq.Matrix4)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $ilwiq.Skeleton)(bones, boneInverses);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
	 * @param {number} animationIndex
	 * @return {Promise<AnimationClip>}
	 */ loadAnimation(animationIndex) {
        const json = this.json;
        const parser = this;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === undefined) continue;
            pendingNodes.push(this.getDependency("node", name));
            pendingInputAccessors.push(this.getDependency("accessor", input));
            pendingOutputAccessors.push(this.getDependency("accessor", output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === undefined) continue;
                if (node.updateMatrix) node.updateMatrix();
                const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
                if (createdTracks) for(let k = 0; k < createdTracks.length; k++)tracks.push(createdTracks[k]);
            }
            return new (0, $ilwiq.AnimationClip)(animationName, undefined, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === undefined) return null;
        return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            // if weights are provided on the node, override weights on the mesh.
            if (nodeDef.weights !== undefined) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
	 * @param {number} nodeIndex
	 * @return {Promise<Object3D>}
	 */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency("node", childrenDef[i]));
        const skeletonPending = nodeDef.skin === undefined ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) // This full traverse should be fine because
            // child glTF nodes have not been added to this node yet.
            node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $559434fcc6e6401d$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        // This method is called from .loadNode() and .loadSkin().
        // Cache a node to avoid duplication.
        if (this.nodeCache[nodeIndex] !== undefined) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        // reserve node's name before its dependencies, so the root has the intended name.
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== undefined) pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            // .isBone isn't in glTF spec. See ._markDefs
            if (nodeDef.isBone === true) node = new (0, $ilwiq.Bone)();
            else if (objects.length > 1) node = new (0, $ilwiq.Group)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $ilwiq.Object3D)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $559434fcc6e6401d$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== undefined) {
                const matrix = new (0, $ilwiq.Matrix4)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== undefined) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== undefined) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== undefined) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
	 * @param {number} sceneIndex
	 * @return {Promise<Group>}
	 */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        // Loader returns Group, not Scene.
        // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
        const scene = new (0, $ilwiq.Group)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $559434fcc6e6401d$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency("node", nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            // Removes dangling associations, associations that reference a node that
            // didn't make it into the scene.
            const reduceAssociations = (node)=>{
                const reducedAssociations = new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $ilwiq.Material) || key instanceof (0, $ilwiq.Texture)) reducedAssociations.set(key, value);
                node.traverse((node)=>{
                    const mappings = parser.associations.get(node);
                    if (mappings != null) reducedAssociations.set(node, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
    _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
        const tracks = [];
        const targetName = node.name ? node.name : node.uuid;
        const targetNames = [];
        if ($559434fcc6e6401d$var$PATH_PROPERTIES[target.path] === $559434fcc6e6401d$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
            if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
        });
        else targetNames.push(targetName);
        let TypedKeyframeTrack;
        switch($559434fcc6e6401d$var$PATH_PROPERTIES[target.path]){
            case $559434fcc6e6401d$var$PATH_PROPERTIES.weights:
                TypedKeyframeTrack = (0, $ilwiq.NumberKeyframeTrack);
                break;
            case $559434fcc6e6401d$var$PATH_PROPERTIES.rotation:
                TypedKeyframeTrack = (0, $ilwiq.QuaternionKeyframeTrack);
                break;
            case $559434fcc6e6401d$var$PATH_PROPERTIES.position:
            case $559434fcc6e6401d$var$PATH_PROPERTIES.scale:
                TypedKeyframeTrack = (0, $ilwiq.VectorKeyframeTrack);
                break;
            default:
                switch(outputAccessor.itemSize){
                    case 1:
                        TypedKeyframeTrack = (0, $ilwiq.NumberKeyframeTrack);
                        break;
                    case 2:
                    case 3:
                    default:
                        TypedKeyframeTrack = (0, $ilwiq.VectorKeyframeTrack);
                        break;
                }
                break;
        }
        const interpolation = sampler.interpolation !== undefined ? $559434fcc6e6401d$var$INTERPOLATION[sampler.interpolation] : (0, $ilwiq.InterpolateLinear);
        const outputArray = this._getArrayFromAccessor(outputAccessor);
        for(let j = 0, jl = targetNames.length; j < jl; j++){
            const track = new TypedKeyframeTrack(targetNames[j] + "." + $559434fcc6e6401d$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
            // Override interpolation with custom factory method.
            if (sampler.interpolation === "CUBICSPLINE") this._createCubicSplineTrackInterpolant(track);
            tracks.push(track);
        }
        return tracks;
    }
    _getArrayFromAccessor(accessor) {
        let outputArray = accessor.array;
        if (accessor.normalized) {
            const scale = $559434fcc6e6401d$var$getNormalizedComponentScale(outputArray.constructor);
            const scaled = new Float32Array(outputArray.length);
            for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
            outputArray = scaled;
        }
        return outputArray;
    }
    _createCubicSplineTrackInterpolant(track) {
        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
            // A CUBICSPLINE keyframe in glTF has three output values for each input value,
            // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
            // must be divided by three to get the interpolant's sampleSize argument.
            const interpolantType = this instanceof (0, $ilwiq.QuaternionKeyframeTrack) ? $559434fcc6e6401d$var$GLTFCubicSplineQuaternionInterpolant : $559434fcc6e6401d$var$GLTFCubicSplineInterpolant;
            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
        };
        // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */ function $559434fcc6e6401d$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $ilwiq.Box3)();
    if (attributes.POSITION !== undefined) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
        if (min !== undefined && max !== undefined) {
            box.set(new (0, $ilwiq.Vector3)(min[0], min[1], min[2]), new (0, $ilwiq.Vector3)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $559434fcc6e6401d$var$getNormalizedComponentScale($559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== undefined) {
        const maxDisplacement = new (0, $ilwiq.Vector3)();
        const vector = new (0, $ilwiq.Vector3)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== undefined) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
                if (min !== undefined && max !== undefined) {
                    // we need to get max of absolute components because target weight is [-1,1]
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $559434fcc6e6401d$var$getNormalizedComponentScale($559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
                    // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
                    // are used to implement key-frame animations and as such only two are active at a time - this results in very large
                    // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
                    maxDisplacement.max(vector);
                } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            }
        }
        // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $ilwiq.Sphere)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $559434fcc6e6401d$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $559434fcc6e6401d$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        // Skip attributes already provided by e.g. Draco extension.
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== undefined && !geometry.index) {
        const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor) {
            geometry.setIndex(accessor);
        });
        pending.push(accessor);
    }
    if ((0, $ilwiq.ColorManagement).workingColorSpace !== (0, $ilwiq.LinearSRGBColorSpace) && "COLOR_0" in attributes) console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${(0, $ilwiq.ColorManagement).workingColorSpace}" not supported.`);
    $559434fcc6e6401d$var$assignExtrasToUserData(geometry, primitiveDef);
    $559434fcc6e6401d$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== undefined ? $559434fcc6e6401d$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}



var $ilwiq = parcelRequire("ilwiq");
const $8e8b252f320f3b48$var$_taskCache = new WeakMap();
class $8e8b252f320f3b48$export$45c25de53be259ac extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
        this.decoderPath = "";
        this.decoderConfig = {};
        this.decoderBinary = null;
        this.decoderPending = null;
        this.workerLimit = 4;
        this.workerPool = [];
        this.workerNextTaskID = 1;
        this.workerSourceURL = "";
        this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        };
        this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(path) {
        this.decoderPath = path;
        return this;
    }
    setDecoderConfig(config) {
        this.decoderConfig = config;
        return this;
    }
    setWorkerLimit(workerLimit) {
        this.workerLimit = workerLimit;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        const loader = new (0, $ilwiq.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (buffer)=>{
            this.parse(buffer, onLoad, onError);
        }, onProgress, onError);
    }
    parse(buffer, onLoad, onError = ()=>{}) {
        this.decodeDracoFile(buffer, onLoad, null, null, (0, $ilwiq.SRGBColorSpace), onError).catch(onError);
    }
    decodeDracoFile(buffer, callback, attributeIDs, attributeTypes, vertexColorSpace = (0, $ilwiq.LinearSRGBColorSpace), onError = ()=>{}) {
        const taskConfig = {
            attributeIDs: attributeIDs || this.defaultAttributeIDs,
            attributeTypes: attributeTypes || this.defaultAttributeTypes,
            useUniqueIDs: !!attributeIDs,
            vertexColorSpace: vertexColorSpace
        };
        return this.decodeGeometry(buffer, taskConfig).then(callback).catch(onError);
    }
    decodeGeometry(buffer, taskConfig) {
        const taskKey = JSON.stringify(taskConfig);
        // Check for an existing task using this buffer. A transferred buffer cannot be transferred
        // again from this thread.
        if ($8e8b252f320f3b48$var$_taskCache.has(buffer)) {
            const cachedTask = $8e8b252f320f3b48$var$_taskCache.get(buffer);
            if (cachedTask.key === taskKey) return cachedTask.promise;
            else if (buffer.byteLength === 0) // Technically, it would be possible to wait for the previous task to complete,
            // transfer the buffer back, and decode again with the second configuration. That
            // is complex, and I don't know of any reason to decode a Draco buffer twice in
            // different ways, so this is left unimplemented.
            throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        //
        let worker;
        const taskID = this.workerNextTaskID++;
        const taskCost = buffer.byteLength;
        // Obtain a worker and assign a task, and construct a geometry instance
        // when the task completes.
        const geometryPending = this._getWorker(taskID, taskCost).then((_worker)=>{
            worker = _worker;
            return new Promise((resolve, reject)=>{
                worker._callbacks[taskID] = {
                    resolve: resolve,
                    reject: reject
                };
                worker.postMessage({
                    type: "decode",
                    id: taskID,
                    taskConfig: taskConfig,
                    buffer: buffer
                }, [
                    buffer
                ]);
            // this.debug();
            });
        }).then((message)=>this._createGeometry(message.geometry));
        // Remove task from the task list.
        // Note: replaced '.finally()' with '.catch().then()' block - iOS 11 support (#19416)
        geometryPending.catch(()=>true).then(()=>{
            if (worker && taskID) this._releaseTask(worker, taskID);
        });
        // Cache the task result.
        $8e8b252f320f3b48$var$_taskCache.set(buffer, {
            key: taskKey,
            promise: geometryPending
        });
        return geometryPending;
    }
    _createGeometry(geometryData) {
        const geometry = new (0, $ilwiq.BufferGeometry)();
        if (geometryData.index) geometry.setIndex(new (0, $ilwiq.BufferAttribute)(geometryData.index.array, 1));
        for(let i = 0; i < geometryData.attributes.length; i++){
            const result = geometryData.attributes[i];
            const name = result.name;
            const array = result.array;
            const itemSize = result.itemSize;
            const attribute = new (0, $ilwiq.BufferAttribute)(array, itemSize);
            if (name === "color") {
                this._assignVertexColorSpace(attribute, result.vertexColorSpace);
                attribute.normalized = array instanceof Float32Array === false;
            }
            geometry.setAttribute(name, attribute);
        }
        return geometry;
    }
    _assignVertexColorSpace(attribute, inputColorSpace) {
        // While .drc files do not specify colorspace, the only 'official' tooling
        // is PLY and OBJ converters, which use sRGB. We'll assume sRGB when a .drc
        // file is passed into .load() or .parse(). GLTFLoader uses internal APIs
        // to decode geometry, and vertex colors are already Linear-sRGB in there.
        if (inputColorSpace !== (0, $ilwiq.SRGBColorSpace)) return;
        const _color = new (0, $ilwiq.Color)();
        for(let i = 0, il = attribute.count; i < il; i++){
            _color.fromBufferAttribute(attribute, i).convertSRGBToLinear();
            attribute.setXYZ(i, _color.r, _color.g, _color.b);
        }
    }
    _loadLibrary(url, responseType) {
        const loader = new (0, $ilwiq.FileLoader)(this.manager);
        loader.setPath(this.decoderPath);
        loader.setResponseType(responseType);
        loader.setWithCredentials(this.withCredentials);
        return new Promise((resolve, reject)=>{
            loader.load(url, resolve, undefined, reject);
        });
    }
    preload() {
        this._initDecoder();
        return this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        const useJS = typeof WebAssembly !== "object" || this.decoderConfig.type === "js";
        const librariesPending = [];
        if (useJS) librariesPending.push(this._loadLibrary("draco_decoder.js", "text"));
        else {
            librariesPending.push(this._loadLibrary("draco_wasm_wrapper.js", "text"));
            librariesPending.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"));
        }
        this.decoderPending = Promise.all(librariesPending).then((libraries)=>{
            const jsContent = libraries[0];
            if (!useJS) this.decoderConfig.wasmBinary = libraries[1];
            const fn = $8e8b252f320f3b48$var$DRACOWorker.toString();
            const body = [
                "/* draco decoder */",
                jsContent,
                "",
                "/* worker */",
                fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
            ].join("\n");
            this.workerSourceURL = URL.createObjectURL(new Blob([
                body
            ]));
        });
        return this.decoderPending;
    }
    _getWorker(taskID, taskCost) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const worker = new Worker(this.workerSourceURL);
                worker._callbacks = {};
                worker._taskCosts = {};
                worker._taskLoad = 0;
                worker.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                });
                worker.onmessage = function(e) {
                    const message = e.data;
                    switch(message.type){
                        case "decode":
                            worker._callbacks[message.id].resolve(message);
                            break;
                        case "error":
                            worker._callbacks[message.id].reject(message);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + message.type + '"');
                    }
                };
                this.workerPool.push(worker);
            } else this.workerPool.sort(function(a, b) {
                return a._taskLoad > b._taskLoad ? -1 : 1;
            });
            const worker = this.workerPool[this.workerPool.length - 1];
            worker._taskCosts[taskID] = taskCost;
            worker._taskLoad += taskCost;
            return worker;
        });
    }
    _releaseTask(worker, taskID) {
        worker._taskLoad -= worker._taskCosts[taskID];
        delete worker._callbacks[taskID];
        delete worker._taskCosts[taskID];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((worker)=>worker._taskLoad));
    }
    dispose() {
        for(let i = 0; i < this.workerPool.length; ++i)this.workerPool[i].terminate();
        this.workerPool.length = 0;
        if (this.workerSourceURL !== "") URL.revokeObjectURL(this.workerSourceURL);
        return this;
    }
}
/* WEB WORKER */ function $8e8b252f320f3b48$var$DRACOWorker() {
    let decoderConfig;
    let decoderPending;
    onmessage = function(e) {
        const message = e.data;
        switch(message.type){
            case "init":
                decoderConfig = message.decoderConfig;
                decoderPending = new Promise(function(resolve /*, reject*/ ) {
                    decoderConfig.onModuleLoaded = function(draco) {
                        // Module is Promise-like. Wrap before resolving to avoid loop.
                        resolve({
                            draco: draco
                        });
                    };
                    DracoDecoderModule(decoderConfig); // eslint-disable-line no-undef
                });
                break;
            case "decode":
                const buffer = message.buffer;
                const taskConfig = message.taskConfig;
                decoderPending.then((module)=>{
                    const draco = module.draco;
                    const decoder = new draco.Decoder();
                    try {
                        const geometry = decodeGeometry(draco, decoder, new Int8Array(buffer), taskConfig);
                        const buffers = geometry.attributes.map((attr)=>attr.array.buffer);
                        if (geometry.index) buffers.push(geometry.index.array.buffer);
                        self.postMessage({
                            type: "decode",
                            id: message.id,
                            geometry: geometry
                        }, buffers);
                    } catch (error) {
                        console.error(error);
                        self.postMessage({
                            type: "error",
                            id: message.id,
                            error: error.message
                        });
                    } finally{
                        draco.destroy(decoder);
                    }
                });
                break;
        }
    };
    function decodeGeometry(draco, decoder, array, taskConfig) {
        const attributeIDs = taskConfig.attributeIDs;
        const attributeTypes = taskConfig.attributeTypes;
        let dracoGeometry;
        let decodingStatus;
        const geometryType = decoder.GetEncodedGeometryType(array);
        if (geometryType === draco.TRIANGULAR_MESH) {
            dracoGeometry = new draco.Mesh();
            decodingStatus = decoder.DecodeArrayToMesh(array, array.byteLength, dracoGeometry);
        } else if (geometryType === draco.POINT_CLOUD) {
            dracoGeometry = new draco.PointCloud();
            decodingStatus = decoder.DecodeArrayToPointCloud(array, array.byteLength, dracoGeometry);
        } else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!decodingStatus.ok() || dracoGeometry.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + decodingStatus.error_msg());
        const geometry = {
            index: null,
            attributes: []
        };
        // Gather all vertex attributes.
        for(const attributeName in attributeIDs){
            const attributeType = self[attributeTypes[attributeName]];
            let attribute;
            let attributeID;
            // A Draco file may be created with default vertex attributes, whose attribute IDs
            // are mapped 1:1 from their semantic name (POSITION, NORMAL, ...). Alternatively,
            // a Draco file may contain a custom set of attributes, identified by known unique
            // IDs. glTF files always do the latter, and `.drc` files typically do the former.
            if (taskConfig.useUniqueIDs) {
                attributeID = attributeIDs[attributeName];
                attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
            } else {
                attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
                if (attributeID === -1) continue;
                attribute = decoder.GetAttribute(dracoGeometry, attributeID);
            }
            const attributeResult = decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute);
            if (attributeName === "color") attributeResult.vertexColorSpace = taskConfig.vertexColorSpace;
            geometry.attributes.push(attributeResult);
        }
        // Add index.
        if (geometryType === draco.TRIANGULAR_MESH) geometry.index = decodeIndex(draco, decoder, dracoGeometry);
        draco.destroy(dracoGeometry);
        return geometry;
    }
    function decodeIndex(draco, decoder, dracoGeometry) {
        const numFaces = dracoGeometry.num_faces();
        const numIndices = numFaces * 3;
        const byteLength = numIndices * 4;
        const ptr = draco._malloc(byteLength);
        decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
        const index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
        draco._free(ptr);
        return {
            array: index,
            itemSize: 1
        };
    }
    function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
        const numComponents = attribute.num_components();
        const numPoints = dracoGeometry.num_points();
        const numValues = numPoints * numComponents;
        const byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
        const dataType = getDracoDataType(draco, attributeType);
        const ptr = draco._malloc(byteLength);
        decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
        const array = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
        draco._free(ptr);
        return {
            name: attributeName,
            array: array,
            itemSize: numComponents
        };
    }
    function getDracoDataType(draco, attributeType) {
        switch(attributeType){
            case Float32Array:
                return draco.DT_FLOAT32;
            case Int8Array:
                return draco.DT_INT8;
            case Int16Array:
                return draco.DT_INT16;
            case Int32Array:
                return draco.DT_INT32;
            case Uint8Array:
                return draco.DT_UINT8;
            case Uint16Array:
                return draco.DT_UINT16;
            case Uint32Array:
                return draco.DT_UINT32;
        }
    }
}


/**
 * Loader for KTX 2.0 GPU Texture containers.
 *
 * KTX 2.0 is a container format for various GPU texture formats. The loader
 * supports Basis Universal GPU textures, which can be quickly transcoded to
 * a wide variety of GPU texture compression formats, as well as some
 * uncompressed DataTexture and Data3DTexture formats.
 *
 * References:
 * - KTX: http://github.khronos.org/KTX-Specification/
 * - DFD: https://www.khronos.org/registry/DataFormat/specs/1.3/dataformat.1.3.html#basicdescriptor
 */ 
var $ilwiq = parcelRequire("ilwiq");
/**
 * @author Deepkolos / https://github.com/deepkolos
 */ class $3bec5ab2a182c32e$export$ddf9e847a113aa9c {
    constructor(pool = 4){
        this.pool = pool;
        this.queue = [];
        this.workers = [];
        this.workersResolve = [];
        this.workerStatus = 0;
    }
    _initWorker(workerId) {
        if (!this.workers[workerId]) {
            const worker = this.workerCreator();
            worker.addEventListener("message", this._onMessage.bind(this, workerId));
            this.workers[workerId] = worker;
        }
    }
    _getIdleWorker() {
        for(let i = 0; i < this.pool; i++)if (!(this.workerStatus & 1 << i)) return i;
        return -1;
    }
    _onMessage(workerId, msg) {
        const resolve = this.workersResolve[workerId];
        resolve && resolve(msg);
        if (this.queue.length) {
            const { resolve: resolve, msg: msg, transfer: transfer } = this.queue.shift();
            this.workersResolve[workerId] = resolve;
            this.workers[workerId].postMessage(msg, transfer);
        } else this.workerStatus ^= 1 << workerId;
    }
    setWorkerCreator(workerCreator) {
        this.workerCreator = workerCreator;
    }
    setWorkerLimit(pool) {
        this.pool = pool;
    }
    postMessage(msg, transfer) {
        return new Promise((resolve)=>{
            const workerId = this._getIdleWorker();
            if (workerId !== -1) {
                this._initWorker(workerId);
                this.workerStatus |= 1 << workerId;
                this.workersResolve[workerId] = resolve;
                this.workers[workerId].postMessage(msg, transfer);
            } else this.queue.push({
                resolve: resolve,
                msg: msg,
                transfer: transfer
            });
        });
    }
    dispose() {
        this.workers.forEach((worker)=>worker.terminate());
        this.workersResolve.length = 0;
        this.workers.length = 0;
        this.queue.length = 0;
        this.workerStatus = 0;
    }
}


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $b74ab90c26700169$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
const $b74ab90c26700169$export$dfb4bf9f0e8f884d = 0, $b74ab90c26700169$export$50d7156c91330e2b = 1, $b74ab90c26700169$export$f86b792952cda261 = 2, $b74ab90c26700169$export$e7cd70eefa05f10 = 3, $b74ab90c26700169$export$b10b0c628dcb3d4b = 0, $b74ab90c26700169$export$585c0ca340aa80c3 = 0, $b74ab90c26700169$export$b83200552035bd72 = 2, $b74ab90c26700169$export$81cbd6a275da487d = 0, $b74ab90c26700169$export$bb4f583bd8c020ea = 1, $b74ab90c26700169$export$9848a55d20756fd7 = 160, $b74ab90c26700169$export$ff03cb24c68d49b7 = 161, $b74ab90c26700169$export$41f29c6c18993f37 = 162, $b74ab90c26700169$export$d9254a6869da5f27 = 163, $b74ab90c26700169$export$12bb99ce3ee4ad1b = 0, $b74ab90c26700169$export$525db1eae5f818 = 1, $b74ab90c26700169$export$b5511aca8d40baac = 0, $b74ab90c26700169$export$b6932a8ac4a05677 = 1, $b74ab90c26700169$export$51f70737c6bbd8ab = 2, $b74ab90c26700169$export$14baca52d710db46 = 3, $b74ab90c26700169$export$d496054d5c2071a0 = 4, $b74ab90c26700169$export$e683f84b261f7135 = 5, $b74ab90c26700169$export$a5b396ff1557020e = 6, $b74ab90c26700169$export$e155a42d3491bc17 = 7, $b74ab90c26700169$export$ee960419ee6bd3e7 = 8, $b74ab90c26700169$export$31979284be459866 = 9, $b74ab90c26700169$export$5cce28b5b96fe8c4 = 10, $b74ab90c26700169$export$40206af89eb30573 = 11, $b74ab90c26700169$export$c0297fd619090cd3 = 12, $b74ab90c26700169$export$da0dcc8d39b47fb6 = 13, $b74ab90c26700169$export$1f2f0bcc45cc1367 = 14, $b74ab90c26700169$export$ad92cf5661a3ddad = 15, $b74ab90c26700169$export$788c52eb60adec0b = 16, $b74ab90c26700169$export$bbb35422dc3b8cb0 = 17, $b74ab90c26700169$export$c4248d135f0e7f49 = 18, $b74ab90c26700169$export$95cf3faafba16241 = 0, $b74ab90c26700169$export$4934a6a551fb755b = 1, $b74ab90c26700169$export$89da11e5651ae5e4 = 2, $b74ab90c26700169$export$f946f8d5cc055d33 = 3, $b74ab90c26700169$export$56c389504f941e29 = 4, $b74ab90c26700169$export$1a5134276e95fed0 = 5, $b74ab90c26700169$export$3c0991533291a2b = 6, $b74ab90c26700169$export$ec7119bcb708ede4 = 7, $b74ab90c26700169$export$11f484090cca9182 = 8, $b74ab90c26700169$export$4d48b35e9484d33d = 9, $b74ab90c26700169$export$50d46de3f74fc52c = 10, $b74ab90c26700169$export$62b8de8a8ba55b99 = 11, $b74ab90c26700169$export$9b00039f916098f8 = 0, $b74ab90c26700169$export$180aeae6205b1170 = 1, $b74ab90c26700169$export$e82ee6d6c4dbfb81 = 2, $b74ab90c26700169$export$d9c40bf5fc157929 = 13, $b74ab90c26700169$export$6c6486484d390518 = 14, $b74ab90c26700169$export$ace4d06901eac849 = 15, $b74ab90c26700169$export$4e4cdf9b2e6c34ea = 128, $b74ab90c26700169$export$6316eba5642e228 = 64, $b74ab90c26700169$export$bbb29f530614d618 = 32, $b74ab90c26700169$export$9fbb8c04cd78e025 = 16, $b74ab90c26700169$export$27918221fd719bf1 = 0, $b74ab90c26700169$export$195270b9b7c4c2da = 1, $b74ab90c26700169$export$13c2919d3278ce57 = 2, $b74ab90c26700169$export$7e96d1d03cb3a504 = 3, $b74ab90c26700169$export$cb3e98ec8f4479d7 = 4, $b74ab90c26700169$export$1cf3403334d3b477 = 5, $b74ab90c26700169$export$c14385bfb79632d7 = 6, $b74ab90c26700169$export$8fb42efbb09bfc31 = 7, $b74ab90c26700169$export$9aa6df89f3287a47 = 8, $b74ab90c26700169$export$41511673c8c4bac = 9, $b74ab90c26700169$export$879188b9a76c8e1b = 10, $b74ab90c26700169$export$d12671fcf64232fa = 13, $b74ab90c26700169$export$12c4f0a3c108cd05 = 14, $b74ab90c26700169$export$8071bfaa2e2c3f81 = 15, $b74ab90c26700169$export$20e3a1260a6d7ac = 16, $b74ab90c26700169$export$4811f7d763f73ad3 = 17, $b74ab90c26700169$export$df4ab1b6b34d131e = 20, $b74ab90c26700169$export$ae57b93946d97c8c = 21, $b74ab90c26700169$export$cf3a884ffb7b38a3 = 22, $b74ab90c26700169$export$3e9f95a0d18e3749 = 23, $b74ab90c26700169$export$8100c80f1596560e = 24, $b74ab90c26700169$export$44d5a3a8eb212027 = 27, $b74ab90c26700169$export$f1b093f3f2db4fbc = 28, $b74ab90c26700169$export$78021b2be93b5a68 = 29, $b74ab90c26700169$export$bd3e6925bbceb7b8 = 30, $b74ab90c26700169$export$606064a7b3f54132 = 31, $b74ab90c26700169$export$7aa3f62f3d28ed23 = 34, $b74ab90c26700169$export$4f698ff8fa76621b = 35, $b74ab90c26700169$export$aaf9de8cdd50895 = 36, $b74ab90c26700169$export$160be17be77b4b56 = 37, $b74ab90c26700169$export$f87c998e4e6e72e4 = 38, $b74ab90c26700169$export$b5498a8af3f444bd = 41, $b74ab90c26700169$export$991ef69bec412754 = 42, $b74ab90c26700169$export$c839892416f0a511 = 43, $b74ab90c26700169$export$acc6aa3d62a95ee6 = 44, $b74ab90c26700169$export$c6048b6638dca8b5 = 45, $b74ab90c26700169$export$404e4a6ea33c0b20 = 48, $b74ab90c26700169$export$c1f9c40bf3e77839 = 49, $b74ab90c26700169$export$627bb21c9776f75 = 50, $b74ab90c26700169$export$25b28a6ee9c1b569 = 58, $b74ab90c26700169$export$6f34b1e3286f44f4 = 59, $b74ab90c26700169$export$f8550002914b2abb = 62, $b74ab90c26700169$export$9f4e0901a4b8f3dc = 63, $b74ab90c26700169$export$edc7d3a10219a0d0 = 64, $b74ab90c26700169$export$c8ee7cc873a6db85 = 65, $b74ab90c26700169$export$a17cce2bb0b20552 = 68, $b74ab90c26700169$export$42d714aadd3c5677 = 69, $b74ab90c26700169$export$3b174a0bc4bf8993 = 70, $b74ab90c26700169$export$9489d89a92577d55 = 71, $b74ab90c26700169$export$a06b6c25f3277297 = 74, $b74ab90c26700169$export$147ff6e7999cf3ac = 75, $b74ab90c26700169$export$f8bb46dd3d4cded5 = 76, $b74ab90c26700169$export$e2976758848490ab = 77, $b74ab90c26700169$export$e03a3f1a9ac8e24b = 78, $b74ab90c26700169$export$bacf55954b330c98 = 81, $b74ab90c26700169$export$54f4234b1108f9ef = 82, $b74ab90c26700169$export$d3b70c0529038fc6 = 83, $b74ab90c26700169$export$674c79881e0eba19 = 84, $b74ab90c26700169$export$2bc7fcbb9a232d40 = 85, $b74ab90c26700169$export$1241ffb2da736325 = 88, $b74ab90c26700169$export$78872334e5f27522 = 89, $b74ab90c26700169$export$1af3440f4c3597a2 = 90, $b74ab90c26700169$export$c32b23f70c7aeb12 = 91, $b74ab90c26700169$export$f755a0b6ec3468b1 = 92, $b74ab90c26700169$export$b0dc7be9a79b92ad = 95, $b74ab90c26700169$export$b933e688ce53181d = 96, $b74ab90c26700169$export$a4bd06ab9faad41 = 97, $b74ab90c26700169$export$8363543a8ff3ad6b = 98, $b74ab90c26700169$export$7b27f1cf9ee3b1a2 = 99, $b74ab90c26700169$export$97764e44e06c7ca4 = 100, $b74ab90c26700169$export$fdea1e29f2c30a9e = 101, $b74ab90c26700169$export$c64895aa69673ced = 102, $b74ab90c26700169$export$5906c4bab83649fb = 103, $b74ab90c26700169$export$209b85aa67b00974 = 104, $b74ab90c26700169$export$8a62004b1441b507 = 105, $b74ab90c26700169$export$858ee95c56cb71b8 = 106, $b74ab90c26700169$export$de3a6275fae42aed = 107, $b74ab90c26700169$export$f8ffa9a0a1c2769a = 108, $b74ab90c26700169$export$fdb3a1bc86d5f751 = 109, $b74ab90c26700169$export$6269f80a43e8b744 = 110, $b74ab90c26700169$export$ccc171fb462524cf = 111, $b74ab90c26700169$export$d34b58779b0b3765 = 112, $b74ab90c26700169$export$9b014881965186ea = 113, $b74ab90c26700169$export$fc8261e0decf03cf = 114, $b74ab90c26700169$export$d76794b378516985 = 115, $b74ab90c26700169$export$864d776c322f0602 = 116, $b74ab90c26700169$export$2b7b6a1befc5c314 = 117, $b74ab90c26700169$export$88fd9646feeabd7a = 118, $b74ab90c26700169$export$7d9bff6db9e37989 = 119, $b74ab90c26700169$export$c27a452186c96eb1 = 120, $b74ab90c26700169$export$18e3d759395a28f3 = 121, $b74ab90c26700169$export$70c795b8626362f1 = 122, $b74ab90c26700169$export$2daf4f73216d3cd8 = 123, $b74ab90c26700169$export$48a3952775ca0a88 = 124, $b74ab90c26700169$export$b079e2e4b72bcf8c = 125, $b74ab90c26700169$export$77e5af157dc93dab = 126, $b74ab90c26700169$export$4002f83ccf16c7bf = 127, $b74ab90c26700169$export$c7197d69f378bfb1 = 128, $b74ab90c26700169$export$9724d70629ae1c1f = 129, $b74ab90c26700169$export$edcbedc16a5a404d = 130, $b74ab90c26700169$export$fbeee6a2325c12cb = 131, $b74ab90c26700169$export$eb071b36b44791d4 = 132, $b74ab90c26700169$export$7866073de2f33c7a = 133, $b74ab90c26700169$export$6d30397f213e4b8a = 134, $b74ab90c26700169$export$66801be65aaa7c00 = 135, $b74ab90c26700169$export$24449b454146ba9f = 136, $b74ab90c26700169$export$558ffb2e138a4bc0 = 137, $b74ab90c26700169$export$7e446f955a0e9e51 = 138, $b74ab90c26700169$export$2d90ea13e7872ac1 = 139, $b74ab90c26700169$export$91956150188935b6 = 140, $b74ab90c26700169$export$241bdce95d4e425e = 141, $b74ab90c26700169$export$1b1ade9ccbc8c95c = 142, $b74ab90c26700169$export$c46b8f347ecc328d = 143, $b74ab90c26700169$export$8d979da2b8b030d2 = 144, $b74ab90c26700169$export$69be116b6fb75f5 = 145, $b74ab90c26700169$export$2f43315379e25c49 = 146, $b74ab90c26700169$export$f4101c6aca1d2bed = 147, $b74ab90c26700169$export$7cc5127dbb53ed2c = 148, $b74ab90c26700169$export$c3777208abe60efb = 149, $b74ab90c26700169$export$530e12598340350a = 150, $b74ab90c26700169$export$baadeba6cb733c3c = 151, $b74ab90c26700169$export$c8219de7de76a761 = 152, $b74ab90c26700169$export$472d098e2d9a1b83 = 153, $b74ab90c26700169$export$47b8ee07ec614722 = 154, $b74ab90c26700169$export$c3a2772dc832f785 = 155, $b74ab90c26700169$export$aadddf036333e3c7 = 156, $b74ab90c26700169$export$9fdafbde5c4452a8 = 157, $b74ab90c26700169$export$a4034f55c4816436 = 158, $b74ab90c26700169$export$b0031dc8820efabc = 159, $b74ab90c26700169$export$75883f02c799840d = 160, $b74ab90c26700169$export$e6ef89e5509488cf = 161, $b74ab90c26700169$export$39d7a0d83ab2f68b = 162, $b74ab90c26700169$export$16b6804fe3368f3 = 163, $b74ab90c26700169$export$c610edf8a3704c3b = 164, $b74ab90c26700169$export$a8e4b1df148871af = 165, $b74ab90c26700169$export$fe6ce7cdb255eca9 = 166, $b74ab90c26700169$export$5ac1e7d71dc3a952 = 167, $b74ab90c26700169$export$3bcc11aa9d69be69 = 168, $b74ab90c26700169$export$cfa4f333e9dd4fd = 169, $b74ab90c26700169$export$e9af17885edf221d = 170, $b74ab90c26700169$export$724dd86a39817f0e = 171, $b74ab90c26700169$export$f3a618831844bbc6 = 172, $b74ab90c26700169$export$10633be47c0ee711 = 173, $b74ab90c26700169$export$f5daeb95c0199e48 = 174, $b74ab90c26700169$export$8d1dd97668701e73 = 175, $b74ab90c26700169$export$c41284ad1c938ed4 = 176, $b74ab90c26700169$export$eabb9df159b75ae2 = 177, $b74ab90c26700169$export$c32791daea0e0763 = 178, $b74ab90c26700169$export$a5a3c98dfe71be71 = 179, $b74ab90c26700169$export$ce137bed6470ce84 = 180, $b74ab90c26700169$export$5321c27915936798 = 181, $b74ab90c26700169$export$334e5966629e7337 = 182, $b74ab90c26700169$export$11fd66b5554502d6 = 183, $b74ab90c26700169$export$3942c6ddb74eaa17 = 184, $b74ab90c26700169$export$9250c37c2b71a713 = 1000156007, $b74ab90c26700169$export$8e2b7c2e5ffec895 = 1000156008, $b74ab90c26700169$export$f674ae001fac983a = 1000156009, $b74ab90c26700169$export$a0faef41278188ab = 1000156010, $b74ab90c26700169$export$f8bcbee97b29fed5 = 1000156011, $b74ab90c26700169$export$e6baf8888e71363e = 1000156017, $b74ab90c26700169$export$a80f3469c8a878ba = 1000156018, $b74ab90c26700169$export$f8e53f5d43b8f6f9 = 1000156019, $b74ab90c26700169$export$88bd34fd3bd4800c = 1000156020, $b74ab90c26700169$export$45f15753cd38dde6 = 1000156021, $b74ab90c26700169$export$81bd6f103f4b2bfb = 1000054e3, $b74ab90c26700169$export$b9849e8106e9aba3 = 1000054001, $b74ab90c26700169$export$e7a5ab93894f8dec = 1000054002, $b74ab90c26700169$export$b75c1ff53ffedff9 = 1000054003, $b74ab90c26700169$export$16c2d4af53f6fa1c = 1000054004, $b74ab90c26700169$export$25e695a22be7b623 = 1000054005, $b74ab90c26700169$export$4f917dcdfe31af50 = 1000054006, $b74ab90c26700169$export$eb9edb91bd8dfc6a = 1000054007, $b74ab90c26700169$export$2e0b295ab8ae632d = 1000066e3, $b74ab90c26700169$export$b779929b8a472a44 = 1000066001, $b74ab90c26700169$export$e047877e132ab354 = 1000066002, $b74ab90c26700169$export$8958677d3349d0e5 = 1000066003, $b74ab90c26700169$export$1123fab9577f64b1 = 1000066004, $b74ab90c26700169$export$5b9f719ee17d2ac3 = 1000066005, $b74ab90c26700169$export$53d7737f84ed867b = 1000066006, $b74ab90c26700169$export$d20d26fc94ff0034 = 1000066007, $b74ab90c26700169$export$5b522b3d43ecbfd6 = 1000066008, $b74ab90c26700169$export$233328ff7a746c78 = 1000066009, $b74ab90c26700169$export$bfa6a84e9937da7a = 1000066010, $b74ab90c26700169$export$dc7e7deab5bc9d53 = 1000066011, $b74ab90c26700169$export$15cc13c55946051b = 1000066012, $b74ab90c26700169$export$d6d8ba94ea68bfc1 = 1000066013, $b74ab90c26700169$export$e937bd9f3da63274 = 100034e4, $b74ab90c26700169$export$aef7fb61e3f6249f = 1000340001;
class $b74ab90c26700169$export$e56ff42d26fc0506 {
    constructor(){
        this.vkFormat = 0, this.typeSize = 1, this.pixelWidth = 0, this.pixelHeight = 0, this.pixelDepth = 0, this.layerCount = 0, this.faceCount = 1, this.supercompressionScheme = 0, this.levels = [], this.dataFormatDescriptor = [
            {
                vendorId: 0,
                descriptorType: 0,
                descriptorBlockSize: 0,
                versionNumber: 2,
                colorModel: 0,
                colorPrimaries: 1,
                transferFunction: 2,
                flags: 0,
                texelBlockDimension: [
                    0,
                    0,
                    0,
                    0
                ],
                bytesPlane: [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                samples: []
            }
        ], this.keyValue = {}, this.globalData = null;
    }
}
class $b74ab90c26700169$var$Ii {
    constructor(t, e, n, i){
        this._dataView = new DataView(t.buffer, t.byteOffset + e, n), this._littleEndian = i, this._offset = 0;
    }
    _nextUint8() {
        const t = this._dataView.getUint8(this._offset);
        return this._offset += 1, t;
    }
    _nextUint16() {
        const t = this._dataView.getUint16(this._offset, this._littleEndian);
        return this._offset += 2, t;
    }
    _nextUint32() {
        const t = this._dataView.getUint32(this._offset, this._littleEndian);
        return this._offset += 4, t;
    }
    _nextUint64() {
        const t = this._dataView.getUint32(this._offset, this._littleEndian) + 2 ** 32 * this._dataView.getUint32(this._offset + 4, this._littleEndian);
        return this._offset += 8, t;
    }
    _nextInt32() {
        const t = this._dataView.getInt32(this._offset, this._littleEndian);
        return this._offset += 4, t;
    }
    _skip(t) {
        return this._offset += t, this;
    }
    _scan(t, e = 0) {
        const n = this._offset;
        let i = 0;
        for(; this._dataView.getUint8(this._offset) !== e && i < t;)i++, this._offset++;
        return i < t && this._offset++, new Uint8Array(this._dataView.buffer, this._dataView.byteOffset + n, i);
    }
}
const $b74ab90c26700169$var$Oi = new Uint8Array([
    0
]), $b74ab90c26700169$var$Ti = [
    171,
    75,
    84,
    88,
    32,
    50,
    48,
    187,
    13,
    10,
    26,
    10
];
function $b74ab90c26700169$var$Vi(t) {
    return "undefined" != typeof TextEncoder ? (new TextEncoder).encode(t) : $b74ab90c26700169$require$Buffer.from(t);
}
function $b74ab90c26700169$var$Ei(t) {
    return "undefined" != typeof TextDecoder ? (new TextDecoder).decode(t) : $b74ab90c26700169$require$Buffer.from(t).toString("utf8");
}
function $b74ab90c26700169$var$Fi(t) {
    let e = 0;
    for (const n of t)e += n.byteLength;
    const n = new Uint8Array(e);
    let i = 0;
    for (const e of t)n.set(new Uint8Array(e), i), i += e.byteLength;
    return n;
}
function $b74ab90c26700169$export$aafa59e2e03f2942(t) {
    const e = new Uint8Array(t.buffer, t.byteOffset, $b74ab90c26700169$var$Ti.length);
    if (e[0] !== $b74ab90c26700169$var$Ti[0] || e[1] !== $b74ab90c26700169$var$Ti[1] || e[2] !== $b74ab90c26700169$var$Ti[2] || e[3] !== $b74ab90c26700169$var$Ti[3] || e[4] !== $b74ab90c26700169$var$Ti[4] || e[5] !== $b74ab90c26700169$var$Ti[5] || e[6] !== $b74ab90c26700169$var$Ti[6] || e[7] !== $b74ab90c26700169$var$Ti[7] || e[8] !== $b74ab90c26700169$var$Ti[8] || e[9] !== $b74ab90c26700169$var$Ti[9] || e[10] !== $b74ab90c26700169$var$Ti[10] || e[11] !== $b74ab90c26700169$var$Ti[11]) throw new Error("Missing KTX 2.0 identifier.");
    const n = new $b74ab90c26700169$export$e56ff42d26fc0506, i = 17 * Uint32Array.BYTES_PER_ELEMENT, s = new $b74ab90c26700169$var$Ii(t, $b74ab90c26700169$var$Ti.length, i, !0);
    n.vkFormat = s._nextUint32(), n.typeSize = s._nextUint32(), n.pixelWidth = s._nextUint32(), n.pixelHeight = s._nextUint32(), n.pixelDepth = s._nextUint32(), n.layerCount = s._nextUint32(), n.faceCount = s._nextUint32();
    const a = s._nextUint32();
    n.supercompressionScheme = s._nextUint32();
    const r = s._nextUint32(), o = s._nextUint32(), l = s._nextUint32(), f = s._nextUint32(), U = s._nextUint64(), c = s._nextUint64(), h = new $b74ab90c26700169$var$Ii(t, $b74ab90c26700169$var$Ti.length + i, 3 * a * 8, !0);
    for(let e = 0; e < a; e++)n.levels.push({
        levelData: new Uint8Array(t.buffer, t.byteOffset + h._nextUint64(), h._nextUint64()),
        uncompressedByteLength: h._nextUint64()
    });
    const _ = new $b74ab90c26700169$var$Ii(t, r, o, !0), p = {
        vendorId: _._skip(4)._nextUint16(),
        descriptorType: _._nextUint16(),
        versionNumber: _._nextUint16(),
        descriptorBlockSize: _._nextUint16(),
        colorModel: _._nextUint8(),
        colorPrimaries: _._nextUint8(),
        transferFunction: _._nextUint8(),
        flags: _._nextUint8(),
        texelBlockDimension: [
            _._nextUint8(),
            _._nextUint8(),
            _._nextUint8(),
            _._nextUint8()
        ],
        bytesPlane: [
            _._nextUint8(),
            _._nextUint8(),
            _._nextUint8(),
            _._nextUint8(),
            _._nextUint8(),
            _._nextUint8(),
            _._nextUint8(),
            _._nextUint8()
        ],
        samples: []
    }, g = (p.descriptorBlockSize / 4 - 6) / 4;
    for(let t = 0; t < g; t++){
        const e = {
            bitOffset: _._nextUint16(),
            bitLength: _._nextUint8(),
            channelType: _._nextUint8(),
            samplePosition: [
                _._nextUint8(),
                _._nextUint8(),
                _._nextUint8(),
                _._nextUint8()
            ],
            sampleLower: -Infinity,
            sampleUpper: Infinity
        };
        64 & e.channelType ? (e.sampleLower = _._nextInt32(), e.sampleUpper = _._nextInt32()) : (e.sampleLower = _._nextUint32(), e.sampleUpper = _._nextUint32()), p.samples[t] = e;
    }
    n.dataFormatDescriptor.length = 0, n.dataFormatDescriptor.push(p);
    const y = new $b74ab90c26700169$var$Ii(t, l, f, !0);
    for(; y._offset < f;){
        const t = y._nextUint32(), e = y._scan(t), i = $b74ab90c26700169$var$Ei(e), s = y._scan(t - e.byteLength);
        n.keyValue[i] = i.match(/^ktx/i) ? $b74ab90c26700169$var$Ei(s) : s, y._offset % 4 && y._skip(4 - y._offset % 4);
    }
    if (c <= 0) return n;
    const x = new $b74ab90c26700169$var$Ii(t, U, c, !0), u = x._nextUint16(), b = x._nextUint16(), d = x._nextUint32(), m = x._nextUint32(), w = x._nextUint32(), D = x._nextUint32(), B = [];
    for(let t = 0; t < a; t++)B.push({
        imageFlags: x._nextUint32(),
        rgbSliceByteOffset: x._nextUint32(),
        rgbSliceByteLength: x._nextUint32(),
        alphaSliceByteOffset: x._nextUint32(),
        alphaSliceByteLength: x._nextUint32()
    });
    const L = U + x._offset, A = L + d, k = A + m, v = k + w, S = new Uint8Array(t.buffer, t.byteOffset + L, d), I = new Uint8Array(t.buffer, t.byteOffset + A, m), O = new Uint8Array(t.buffer, t.byteOffset + k, w), T = new Uint8Array(t.buffer, t.byteOffset + v, D);
    return n.globalData = {
        endpointCount: u,
        selectorCount: b,
        imageDescs: B,
        endpointsData: S,
        selectorsData: I,
        tablesData: O,
        extendedData: T
    }, n;
}
function $b74ab90c26700169$var$Ci() {
    return ($b74ab90c26700169$var$Ci = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var n = arguments[e];
            for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
        }
        return t;
    }).apply(this, arguments);
}
const $b74ab90c26700169$var$zi = {
    keepWriter: !1
};
function $b74ab90c26700169$export$68d8715fc104d294(t, e = {}) {
    e = $b74ab90c26700169$var$Ci({}, $b74ab90c26700169$var$zi, e);
    let n = new ArrayBuffer(0);
    if (t.globalData) {
        const e = new ArrayBuffer(20 + 5 * t.globalData.imageDescs.length * 4), i = new DataView(e);
        i.setUint16(0, t.globalData.endpointCount, !0), i.setUint16(2, t.globalData.selectorCount, !0), i.setUint32(4, t.globalData.endpointsData.byteLength, !0), i.setUint32(8, t.globalData.selectorsData.byteLength, !0), i.setUint32(12, t.globalData.tablesData.byteLength, !0), i.setUint32(16, t.globalData.extendedData.byteLength, !0);
        for(let e = 0; e < t.globalData.imageDescs.length; e++){
            const n = t.globalData.imageDescs[e];
            i.setUint32(20 + 5 * e * 4 + 0, n.imageFlags, !0), i.setUint32(20 + 5 * e * 4 + 4, n.rgbSliceByteOffset, !0), i.setUint32(20 + 5 * e * 4 + 8, n.rgbSliceByteLength, !0), i.setUint32(20 + 5 * e * 4 + 12, n.alphaSliceByteOffset, !0), i.setUint32(20 + 5 * e * 4 + 16, n.alphaSliceByteLength, !0);
        }
        n = $b74ab90c26700169$var$Fi([
            e,
            t.globalData.endpointsData,
            t.globalData.selectorsData,
            t.globalData.tablesData,
            t.globalData.extendedData
        ]);
    }
    const i = [];
    let s = t.keyValue;
    e.keepWriter || (s = $b74ab90c26700169$var$Ci({}, t.keyValue, {
        KTXwriter: "KTX-Parse v0.3.1"
    }));
    for(const t in s){
        const e = s[t], n = $b74ab90c26700169$var$Vi(t), a = "string" == typeof e ? $b74ab90c26700169$var$Vi(e) : e, r = n.byteLength + 1 + a.byteLength + 1, o = r % 4 ? 4 - r % 4 : 0;
        i.push($b74ab90c26700169$var$Fi([
            new Uint32Array([
                r
            ]),
            n,
            $b74ab90c26700169$var$Oi,
            a,
            $b74ab90c26700169$var$Oi,
            new Uint8Array(o).fill(0)
        ]));
    }
    const a = $b74ab90c26700169$var$Fi(i);
    if (1 !== t.dataFormatDescriptor.length || 0 !== t.dataFormatDescriptor[0].descriptorType) throw new Error("Only BASICFORMAT Data Format Descriptor output supported.");
    const r = t.dataFormatDescriptor[0], o = new ArrayBuffer(28 + 16 * r.samples.length), l = new DataView(o), f = 24 + 16 * r.samples.length;
    if (l.setUint32(0, o.byteLength, !0), l.setUint16(4, r.vendorId, !0), l.setUint16(6, r.descriptorType, !0), l.setUint16(8, r.versionNumber, !0), l.setUint16(10, f, !0), l.setUint8(12, r.colorModel), l.setUint8(13, r.colorPrimaries), l.setUint8(14, r.transferFunction), l.setUint8(15, r.flags), !Array.isArray(r.texelBlockDimension)) throw new Error("texelBlockDimension is now an array. For dimensionality `d`, set `d - 1`.");
    l.setUint8(16, r.texelBlockDimension[0]), l.setUint8(17, r.texelBlockDimension[1]), l.setUint8(18, r.texelBlockDimension[2]), l.setUint8(19, r.texelBlockDimension[3]);
    for(let t = 0; t < 8; t++)l.setUint8(20 + t, r.bytesPlane[t]);
    for(let t = 0; t < r.samples.length; t++){
        const e = r.samples[t], n = 28 + 16 * t;
        if (e.channelID) throw new Error("channelID has been renamed to channelType.");
        l.setUint16(n + 0, e.bitOffset, !0), l.setUint8(n + 2, e.bitLength), l.setUint8(n + 3, e.channelType), l.setUint8(n + 4, e.samplePosition[0]), l.setUint8(n + 5, e.samplePosition[1]), l.setUint8(n + 6, e.samplePosition[2]), l.setUint8(n + 7, e.samplePosition[3]), 64 & e.channelType ? (l.setInt32(n + 8, e.sampleLower, !0), l.setInt32(n + 12, e.sampleUpper, !0)) : (l.setUint32(n + 8, e.sampleLower, !0), l.setUint32(n + 12, e.sampleUpper, !0));
    }
    const U = $b74ab90c26700169$var$Ti.length + 68 + 3 * t.levels.length * 8, c = U + o.byteLength;
    let h = n.byteLength > 0 ? c + a.byteLength : 0;
    h % 8 && (h += 8 - h % 8);
    const _ = [], p = new DataView(new ArrayBuffer(3 * t.levels.length * 8));
    let g = (h || c + a.byteLength) + n.byteLength;
    for(let e = 0; e < t.levels.length; e++){
        const n = t.levels[e];
        _.push(n.levelData), p.setBigUint64(24 * e + 0, BigInt(g), !0), p.setBigUint64(24 * e + 8, BigInt(n.levelData.byteLength), !0), p.setBigUint64(24 * e + 16, BigInt(n.uncompressedByteLength), !0), g += n.levelData.byteLength;
    }
    const y = new ArrayBuffer(68), x = new DataView(y);
    return x.setUint32(0, t.vkFormat, !0), x.setUint32(4, t.typeSize, !0), x.setUint32(8, t.pixelWidth, !0), x.setUint32(12, t.pixelHeight, !0), x.setUint32(16, t.pixelDepth, !0), x.setUint32(20, t.layerCount, !0), x.setUint32(24, t.faceCount, !0), x.setUint32(28, t.levels.length, !0), x.setUint32(32, t.supercompressionScheme, !0), x.setUint32(36, U, !0), x.setUint32(40, o.byteLength, !0), x.setUint32(44, c, !0), x.setUint32(48, a.byteLength, !0), x.setBigUint64(52, BigInt(n.byteLength > 0 ? h : 0), !0), x.setBigUint64(60, BigInt(n.byteLength), !0), new Uint8Array($b74ab90c26700169$var$Fi([
        new Uint8Array($b74ab90c26700169$var$Ti).buffer,
        y,
        p.buffer,
        o,
        a,
        h > 0 ? new ArrayBuffer(h - (c + a.byteLength)) : new ArrayBuffer(0),
        n,
        ..._
    ]));
}



var $315a020d3665c3cb$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
let $315a020d3665c3cb$var$A, $315a020d3665c3cb$var$I, $315a020d3665c3cb$var$B;
const $315a020d3665c3cb$var$g = {
    env: {
        emscripten_notify_memory_growth: function(A) {
            $315a020d3665c3cb$var$B = new Uint8Array($315a020d3665c3cb$var$I.exports.memory.buffer);
        }
    }
};
class $315a020d3665c3cb$export$f7c044b600a8b85d {
    init() {
        return $315a020d3665c3cb$var$A || ($315a020d3665c3cb$var$A = "undefined" != typeof fetch ? fetch("data:application/wasm;base64," + $315a020d3665c3cb$var$C).then((A)=>A.arrayBuffer()).then((A)=>WebAssembly.instantiate(A, $315a020d3665c3cb$var$g)).then(this._init) : WebAssembly.instantiate($315a020d3665c3cb$require$Buffer.from($315a020d3665c3cb$var$C, "base64"), $315a020d3665c3cb$var$g).then(this._init), $315a020d3665c3cb$var$A);
    }
    _init(A) {
        $315a020d3665c3cb$var$I = A.instance, $315a020d3665c3cb$var$g.env.emscripten_notify_memory_growth(0);
    }
    decode(A, g = 0) {
        if (!$315a020d3665c3cb$var$I) throw new Error("ZSTDDecoder: Await .init() before decoding.");
        const Q = A.byteLength, C = $315a020d3665c3cb$var$I.exports.malloc(Q);
        $315a020d3665c3cb$var$B.set(A, C), g = g || Number($315a020d3665c3cb$var$I.exports.ZSTD_findDecompressedSize(C, Q));
        const E = $315a020d3665c3cb$var$I.exports.malloc(g), i = $315a020d3665c3cb$var$I.exports.ZSTD_decompress(E, g, C, Q), D = $315a020d3665c3cb$var$B.slice(E, E + i);
        return $315a020d3665c3cb$var$I.exports.free(C), $315a020d3665c3cb$var$I.exports.free(E), D;
    }
}
const $315a020d3665c3cb$var$C = "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";


const $f1a4de4e39dd9e7f$var$_taskCache = new WeakMap();
let $f1a4de4e39dd9e7f$var$_activeLoaders = 0;
let $f1a4de4e39dd9e7f$var$_zstd;
class $f1a4de4e39dd9e7f$export$f2e11b211e093ce0 extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
        this.transcoderPath = "";
        this.transcoderBinary = null;
        this.transcoderPending = null;
        this.workerPool = new (0, $3bec5ab2a182c32e$export$ddf9e847a113aa9c)();
        this.workerSourceURL = "";
        this.workerConfig = null;
        if (typeof MSC_TRANSCODER !== "undefined") console.warn('THREE.KTX2Loader: Please update to latest "basis_transcoder". "msc_basis_transcoder" is no longer supported in three.js r125+.');
    }
    setTranscoderPath(path) {
        this.transcoderPath = path;
        return this;
    }
    setWorkerLimit(num) {
        this.workerPool.setWorkerLimit(num);
        return this;
    }
    async detectSupportAsync(renderer) {
        this.workerConfig = {
            astcSupported: await renderer.hasFeatureAsync("texture-compression-astc"),
            etc1Supported: await renderer.hasFeatureAsync("texture-compression-etc1"),
            etc2Supported: await renderer.hasFeatureAsync("texture-compression-etc2"),
            dxtSupported: await renderer.hasFeatureAsync("texture-compression-bc"),
            bptcSupported: await renderer.hasFeatureAsync("texture-compression-bptc"),
            pvrtcSupported: await renderer.hasFeatureAsync("texture-compression-pvrtc")
        };
        return this;
    }
    detectSupport(renderer) {
        if (renderer.isWebGPURenderer === true) this.workerConfig = {
            astcSupported: renderer.hasFeature("texture-compression-astc"),
            etc1Supported: renderer.hasFeature("texture-compression-etc1"),
            etc2Supported: renderer.hasFeature("texture-compression-etc2"),
            dxtSupported: renderer.hasFeature("texture-compression-bc"),
            bptcSupported: renderer.hasFeature("texture-compression-bptc"),
            pvrtcSupported: renderer.hasFeature("texture-compression-pvrtc")
        };
        else this.workerConfig = {
            astcSupported: renderer.extensions.has("WEBGL_compressed_texture_astc"),
            etc1Supported: renderer.extensions.has("WEBGL_compressed_texture_etc1"),
            etc2Supported: renderer.extensions.has("WEBGL_compressed_texture_etc"),
            dxtSupported: renderer.extensions.has("WEBGL_compressed_texture_s3tc"),
            bptcSupported: renderer.extensions.has("EXT_texture_compression_bptc"),
            pvrtcSupported: renderer.extensions.has("WEBGL_compressed_texture_pvrtc") || renderer.extensions.has("WEBKIT_WEBGL_compressed_texture_pvrtc")
        };
        return this;
    }
    init() {
        if (!this.transcoderPending) {
            // Load transcoder wrapper.
            const jsLoader = new (0, $ilwiq.FileLoader)(this.manager);
            jsLoader.setPath(this.transcoderPath);
            jsLoader.setWithCredentials(this.withCredentials);
            const jsContent = jsLoader.loadAsync("basis_transcoder.js");
            // Load transcoder WASM binary.
            const binaryLoader = new (0, $ilwiq.FileLoader)(this.manager);
            binaryLoader.setPath(this.transcoderPath);
            binaryLoader.setResponseType("arraybuffer");
            binaryLoader.setWithCredentials(this.withCredentials);
            const binaryContent = binaryLoader.loadAsync("basis_transcoder.wasm");
            this.transcoderPending = Promise.all([
                jsContent,
                binaryContent
            ]).then(([jsContent, binaryContent])=>{
                const fn = $f1a4de4e39dd9e7f$export$f2e11b211e093ce0.BasisWorker.toString();
                const body = [
                    "/* constants */",
                    "let _EngineFormat = " + JSON.stringify($f1a4de4e39dd9e7f$export$f2e11b211e093ce0.EngineFormat),
                    "let _TranscoderFormat = " + JSON.stringify($f1a4de4e39dd9e7f$export$f2e11b211e093ce0.TranscoderFormat),
                    "let _BasisFormat = " + JSON.stringify($f1a4de4e39dd9e7f$export$f2e11b211e093ce0.BasisFormat),
                    "/* basis_transcoder.js */",
                    jsContent,
                    "/* worker */",
                    fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
                ].join("\n");
                this.workerSourceURL = URL.createObjectURL(new Blob([
                    body
                ]));
                this.transcoderBinary = binaryContent;
                this.workerPool.setWorkerCreator(()=>{
                    const worker = new Worker(this.workerSourceURL);
                    const transcoderBinary = this.transcoderBinary.slice(0);
                    worker.postMessage({
                        type: "init",
                        config: this.workerConfig,
                        transcoderBinary: transcoderBinary
                    }, [
                        transcoderBinary
                    ]);
                    return worker;
                });
            });
            if ($f1a4de4e39dd9e7f$var$_activeLoaders > 0) // Each instance loads a transcoder and allocates workers, increasing network and memory cost.
            console.warn("THREE.KTX2Loader: Multiple active KTX2 loaders may cause performance issues. Use a single KTX2Loader instance, or call .dispose() on old instances.");
            $f1a4de4e39dd9e7f$var$_activeLoaders++;
        }
        return this.transcoderPending;
    }
    load(url, onLoad, onProgress, onError) {
        if (this.workerConfig === null) throw new Error("THREE.KTX2Loader: Missing initialization with `.detectSupport( renderer )`.");
        const loader = new (0, $ilwiq.FileLoader)(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (buffer)=>{
            // Check for an existing task using this buffer. A transferred buffer cannot be transferred
            // again from this thread.
            if ($f1a4de4e39dd9e7f$var$_taskCache.has(buffer)) {
                const cachedTask = $f1a4de4e39dd9e7f$var$_taskCache.get(buffer);
                return cachedTask.promise.then(onLoad).catch(onError);
            }
            this._createTexture(buffer).then((texture)=>onLoad ? onLoad(texture) : null).catch(onError);
        }, onProgress, onError);
    }
    _createTextureFrom(transcodeResult, container) {
        const { faces: faces, width: width, height: height, format: format, type: type, error: error, dfdFlags: dfdFlags } = transcodeResult;
        if (type === "error") return Promise.reject(error);
        let texture;
        if (container.faceCount === 6) texture = new (0, $ilwiq.CompressedCubeTexture)(faces, format, (0, $ilwiq.UnsignedByteType));
        else {
            const mipmaps = faces[0].mipmaps;
            texture = container.layerCount > 1 ? new (0, $ilwiq.CompressedArrayTexture)(mipmaps, width, height, container.layerCount, format, (0, $ilwiq.UnsignedByteType)) : new (0, $ilwiq.CompressedTexture)(mipmaps, width, height, format, (0, $ilwiq.UnsignedByteType));
        }
        texture.minFilter = faces[0].mipmaps.length === 1 ? (0, $ilwiq.LinearFilter) : (0, $ilwiq.LinearMipmapLinearFilter);
        texture.magFilter = (0, $ilwiq.LinearFilter);
        texture.generateMipmaps = false;
        texture.needsUpdate = true;
        texture.colorSpace = $f1a4de4e39dd9e7f$var$parseColorSpace(container);
        texture.premultiplyAlpha = !!(dfdFlags & (0, $b74ab90c26700169$export$525db1eae5f818));
        return texture;
    }
    /**
	 * @param {ArrayBuffer} buffer
	 * @param {object?} config
	 * @return {Promise<CompressedTexture|CompressedArrayTexture|DataTexture|Data3DTexture>}
	 */ async _createTexture(buffer, config = {}) {
        const container = (0, $b74ab90c26700169$export$aafa59e2e03f2942)(new Uint8Array(buffer));
        if (container.vkFormat !== (0, $b74ab90c26700169$export$27918221fd719bf1)) return $f1a4de4e39dd9e7f$var$createRawTexture(container);
        //
        const taskConfig = config;
        const texturePending = this.init().then(()=>{
            return this.workerPool.postMessage({
                type: "transcode",
                buffer: buffer,
                taskConfig: taskConfig
            }, [
                buffer
            ]);
        }).then((e)=>this._createTextureFrom(e.data, container));
        // Cache the task result.
        $f1a4de4e39dd9e7f$var$_taskCache.set(buffer, {
            promise: texturePending
        });
        return texturePending;
    }
    dispose() {
        this.workerPool.dispose();
        if (this.workerSourceURL) URL.revokeObjectURL(this.workerSourceURL);
        $f1a4de4e39dd9e7f$var$_activeLoaders--;
        return this;
    }
}
/* CONSTANTS */ $f1a4de4e39dd9e7f$export$f2e11b211e093ce0.BasisFormat = {
    ETC1S: 0,
    UASTC_4x4: 1
};
$f1a4de4e39dd9e7f$export$f2e11b211e093ce0.TranscoderFormat = {
    ETC1: 0,
    ETC2: 1,
    BC1: 2,
    BC3: 3,
    BC4: 4,
    BC5: 5,
    BC7_M6_OPAQUE_ONLY: 6,
    BC7_M5: 7,
    PVRTC1_4_RGB: 8,
    PVRTC1_4_RGBA: 9,
    ASTC_4x4: 10,
    ATC_RGB: 11,
    ATC_RGBA_INTERPOLATED_ALPHA: 12,
    RGBA32: 13,
    RGB565: 14,
    BGR565: 15,
    RGBA4444: 16
};
$f1a4de4e39dd9e7f$export$f2e11b211e093ce0.EngineFormat = {
    RGBAFormat: (0, $ilwiq.RGBAFormat),
    RGBA_ASTC_4x4_Format: (0, $ilwiq.RGBA_ASTC_4x4_Format),
    RGBA_BPTC_Format: (0, $ilwiq.RGBA_BPTC_Format),
    RGBA_ETC2_EAC_Format: (0, $ilwiq.RGBA_ETC2_EAC_Format),
    RGBA_PVRTC_4BPPV1_Format: (0, $ilwiq.RGBA_PVRTC_4BPPV1_Format),
    RGBA_S3TC_DXT5_Format: (0, $ilwiq.RGBA_S3TC_DXT5_Format),
    RGB_ETC1_Format: (0, $ilwiq.RGB_ETC1_Format),
    RGB_ETC2_Format: (0, $ilwiq.RGB_ETC2_Format),
    RGB_PVRTC_4BPPV1_Format: (0, $ilwiq.RGB_PVRTC_4BPPV1_Format),
    RGBA_S3TC_DXT1_Format: (0, $ilwiq.RGBA_S3TC_DXT1_Format)
};
/* WEB WORKER */ $f1a4de4e39dd9e7f$export$f2e11b211e093ce0.BasisWorker = function() {
    let config;
    let transcoderPending;
    let BasisModule;
    const EngineFormat = _EngineFormat; // eslint-disable-line no-undef
    const TranscoderFormat = _TranscoderFormat; // eslint-disable-line no-undef
    const BasisFormat = _BasisFormat; // eslint-disable-line no-undef
    self.addEventListener("message", function(e) {
        const message = e.data;
        switch(message.type){
            case "init":
                config = message.config;
                init(message.transcoderBinary);
                break;
            case "transcode":
                transcoderPending.then(()=>{
                    try {
                        const { faces: faces, buffers: buffers, width: width, height: height, hasAlpha: hasAlpha, format: format, dfdFlags: dfdFlags } = transcode(message.buffer);
                        self.postMessage({
                            type: "transcode",
                            id: message.id,
                            faces: faces,
                            width: width,
                            height: height,
                            hasAlpha: hasAlpha,
                            format: format,
                            dfdFlags: dfdFlags
                        }, buffers);
                    } catch (error) {
                        console.error(error);
                        self.postMessage({
                            type: "error",
                            id: message.id,
                            error: error.message
                        });
                    }
                });
                break;
        }
    });
    function init(wasmBinary) {
        transcoderPending = new Promise((resolve)=>{
            BasisModule = {
                wasmBinary: wasmBinary,
                onRuntimeInitialized: resolve
            };
            BASIS(BasisModule); // eslint-disable-line no-undef
        }).then(()=>{
            BasisModule.initializeBasis();
            if (BasisModule.KTX2File === undefined) console.warn("THREE.KTX2Loader: Please update Basis Universal transcoder.");
        });
    }
    function transcode(buffer) {
        const ktx2File = new BasisModule.KTX2File(new Uint8Array(buffer));
        function cleanup() {
            ktx2File.close();
            ktx2File.delete();
        }
        if (!ktx2File.isValid()) {
            cleanup();
            throw new Error("THREE.KTX2Loader:	Invalid or unsupported .ktx2 file");
        }
        const basisFormat = ktx2File.isUASTC() ? BasisFormat.UASTC_4x4 : BasisFormat.ETC1S;
        const width = ktx2File.getWidth();
        const height = ktx2File.getHeight();
        const layerCount = ktx2File.getLayers() || 1;
        const levelCount = ktx2File.getLevels();
        const faceCount = ktx2File.getFaces();
        const hasAlpha = ktx2File.getHasAlpha();
        const dfdFlags = ktx2File.getDFDFlags();
        const { transcoderFormat: transcoderFormat, engineFormat: engineFormat } = getTranscoderFormat(basisFormat, width, height, hasAlpha);
        if (!width || !height || !levelCount) {
            cleanup();
            throw new Error("THREE.KTX2Loader:	Invalid texture");
        }
        if (!ktx2File.startTranscoding()) {
            cleanup();
            throw new Error("THREE.KTX2Loader: .startTranscoding failed");
        }
        const faces = [];
        const buffers = [];
        for(let face = 0; face < faceCount; face++){
            const mipmaps = [];
            for(let mip = 0; mip < levelCount; mip++){
                const layerMips = [];
                let mipWidth, mipHeight;
                for(let layer = 0; layer < layerCount; layer++){
                    const levelInfo = ktx2File.getImageLevelInfo(mip, layer, face);
                    if (face === 0 && mip === 0 && layer === 0 && (levelInfo.origWidth % 4 !== 0 || levelInfo.origHeight % 4 !== 0)) console.warn("THREE.KTX2Loader: ETC1S and UASTC textures should use multiple-of-four dimensions.");
                    if (levelCount > 1) {
                        mipWidth = levelInfo.origWidth;
                        mipHeight = levelInfo.origHeight;
                    } else {
                        // Handles non-multiple-of-four dimensions in textures without mipmaps. Textures with
                        // mipmaps must use multiple-of-four dimensions, for some texture formats and APIs.
                        // See mrdoob/three.js#25908.
                        mipWidth = levelInfo.width;
                        mipHeight = levelInfo.height;
                    }
                    const dst = new Uint8Array(ktx2File.getImageTranscodedSizeInBytes(mip, layer, 0, transcoderFormat));
                    const status = ktx2File.transcodeImage(dst, mip, layer, face, transcoderFormat, 0, -1, -1);
                    if (!status) {
                        cleanup();
                        throw new Error("THREE.KTX2Loader: .transcodeImage failed.");
                    }
                    layerMips.push(dst);
                }
                const mipData = concat(layerMips);
                mipmaps.push({
                    data: mipData,
                    width: mipWidth,
                    height: mipHeight
                });
                buffers.push(mipData.buffer);
            }
            faces.push({
                mipmaps: mipmaps,
                width: width,
                height: height,
                format: engineFormat
            });
        }
        cleanup();
        return {
            faces: faces,
            buffers: buffers,
            width: width,
            height: height,
            hasAlpha: hasAlpha,
            format: engineFormat,
            dfdFlags: dfdFlags
        };
    }
    //
    // Optimal choice of a transcoder target format depends on the Basis format (ETC1S or UASTC),
    // device capabilities, and texture dimensions. The list below ranks the formats separately
    // for ETC1S and UASTC.
    //
    // In some cases, transcoding UASTC to RGBA32 might be preferred for higher quality (at
    // significant memory cost) compared to ETC1/2, BC1/3, and PVRTC. The transcoder currently
    // chooses RGBA32 only as a last resort and does not expose that option to the caller.
    const FORMAT_OPTIONS = [
        {
            if: "astcSupported",
            basisFormat: [
                BasisFormat.UASTC_4x4
            ],
            transcoderFormat: [
                TranscoderFormat.ASTC_4x4,
                TranscoderFormat.ASTC_4x4
            ],
            engineFormat: [
                EngineFormat.RGBA_ASTC_4x4_Format,
                EngineFormat.RGBA_ASTC_4x4_Format
            ],
            priorityETC1S: Infinity,
            priorityUASTC: 1,
            needsPowerOfTwo: false
        },
        {
            if: "bptcSupported",
            basisFormat: [
                BasisFormat.ETC1S,
                BasisFormat.UASTC_4x4
            ],
            transcoderFormat: [
                TranscoderFormat.BC7_M5,
                TranscoderFormat.BC7_M5
            ],
            engineFormat: [
                EngineFormat.RGBA_BPTC_Format,
                EngineFormat.RGBA_BPTC_Format
            ],
            priorityETC1S: 3,
            priorityUASTC: 2,
            needsPowerOfTwo: false
        },
        {
            if: "dxtSupported",
            basisFormat: [
                BasisFormat.ETC1S,
                BasisFormat.UASTC_4x4
            ],
            transcoderFormat: [
                TranscoderFormat.BC1,
                TranscoderFormat.BC3
            ],
            engineFormat: [
                EngineFormat.RGBA_S3TC_DXT1_Format,
                EngineFormat.RGBA_S3TC_DXT5_Format
            ],
            priorityETC1S: 4,
            priorityUASTC: 5,
            needsPowerOfTwo: false
        },
        {
            if: "etc2Supported",
            basisFormat: [
                BasisFormat.ETC1S,
                BasisFormat.UASTC_4x4
            ],
            transcoderFormat: [
                TranscoderFormat.ETC1,
                TranscoderFormat.ETC2
            ],
            engineFormat: [
                EngineFormat.RGB_ETC2_Format,
                EngineFormat.RGBA_ETC2_EAC_Format
            ],
            priorityETC1S: 1,
            priorityUASTC: 3,
            needsPowerOfTwo: false
        },
        {
            if: "etc1Supported",
            basisFormat: [
                BasisFormat.ETC1S,
                BasisFormat.UASTC_4x4
            ],
            transcoderFormat: [
                TranscoderFormat.ETC1
            ],
            engineFormat: [
                EngineFormat.RGB_ETC1_Format
            ],
            priorityETC1S: 2,
            priorityUASTC: 4,
            needsPowerOfTwo: false
        },
        {
            if: "pvrtcSupported",
            basisFormat: [
                BasisFormat.ETC1S,
                BasisFormat.UASTC_4x4
            ],
            transcoderFormat: [
                TranscoderFormat.PVRTC1_4_RGB,
                TranscoderFormat.PVRTC1_4_RGBA
            ],
            engineFormat: [
                EngineFormat.RGB_PVRTC_4BPPV1_Format,
                EngineFormat.RGBA_PVRTC_4BPPV1_Format
            ],
            priorityETC1S: 5,
            priorityUASTC: 6,
            needsPowerOfTwo: true
        }
    ];
    const ETC1S_OPTIONS = FORMAT_OPTIONS.sort(function(a, b) {
        return a.priorityETC1S - b.priorityETC1S;
    });
    const UASTC_OPTIONS = FORMAT_OPTIONS.sort(function(a, b) {
        return a.priorityUASTC - b.priorityUASTC;
    });
    function getTranscoderFormat(basisFormat, width, height, hasAlpha) {
        let transcoderFormat;
        let engineFormat;
        const options = basisFormat === BasisFormat.ETC1S ? ETC1S_OPTIONS : UASTC_OPTIONS;
        for(let i = 0; i < options.length; i++){
            const opt = options[i];
            if (!config[opt.if]) continue;
            if (!opt.basisFormat.includes(basisFormat)) continue;
            if (hasAlpha && opt.transcoderFormat.length < 2) continue;
            if (opt.needsPowerOfTwo && !(isPowerOfTwo(width) && isPowerOfTwo(height))) continue;
            transcoderFormat = opt.transcoderFormat[hasAlpha ? 1 : 0];
            engineFormat = opt.engineFormat[hasAlpha ? 1 : 0];
            return {
                transcoderFormat: transcoderFormat,
                engineFormat: engineFormat
            };
        }
        console.warn("THREE.KTX2Loader: No suitable compressed texture format found. Decoding to RGBA32.");
        transcoderFormat = TranscoderFormat.RGBA32;
        engineFormat = EngineFormat.RGBAFormat;
        return {
            transcoderFormat: transcoderFormat,
            engineFormat: engineFormat
        };
    }
    function isPowerOfTwo(value) {
        if (value <= 2) return true;
        return (value & value - 1) === 0 && value !== 0;
    }
    /** Concatenates N byte arrays. */ function concat(arrays) {
        if (arrays.length === 1) return arrays[0];
        let totalByteLength = 0;
        for(let i = 0; i < arrays.length; i++){
            const array = arrays[i];
            totalByteLength += array.byteLength;
        }
        const result = new Uint8Array(totalByteLength);
        let byteOffset = 0;
        for(let i = 0; i < arrays.length; i++){
            const array = arrays[i];
            result.set(array, byteOffset);
            byteOffset += array.byteLength;
        }
        return result;
    }
};
//
// Parsing for non-Basis textures. These textures are may have supercompression
// like Zstd, but they do not require transcoding.
const $f1a4de4e39dd9e7f$var$UNCOMPRESSED_FORMATS = new Set([
    (0, $ilwiq.RGBAFormat),
    (0, $ilwiq.RGFormat),
    (0, $ilwiq.RedFormat)
]);
const $f1a4de4e39dd9e7f$var$FORMAT_MAP = {
    [(0, $b74ab90c26700169$export$fdb3a1bc86d5f751)]: (0, $ilwiq.RGBAFormat),
    [(0, $b74ab90c26700169$export$a4bd06ab9faad41)]: (0, $ilwiq.RGBAFormat),
    [(0, $b74ab90c26700169$export$160be17be77b4b56)]: (0, $ilwiq.RGBAFormat),
    [(0, $b74ab90c26700169$export$c839892416f0a511)]: (0, $ilwiq.RGBAFormat),
    [(0, $b74ab90c26700169$export$5906c4bab83649fb)]: (0, $ilwiq.RGFormat),
    [(0, $b74ab90c26700169$export$d3b70c0529038fc6)]: (0, $ilwiq.RGFormat),
    [(0, $b74ab90c26700169$export$20e3a1260a6d7ac)]: (0, $ilwiq.RGFormat),
    [(0, $b74ab90c26700169$export$cf3a884ffb7b38a3)]: (0, $ilwiq.RGFormat),
    [(0, $b74ab90c26700169$export$97764e44e06c7ca4)]: (0, $ilwiq.RedFormat),
    [(0, $b74ab90c26700169$export$f8bb46dd3d4cded5)]: (0, $ilwiq.RedFormat),
    [(0, $b74ab90c26700169$export$8071bfaa2e2c3f81)]: (0, $ilwiq.RedFormat),
    [(0, $b74ab90c26700169$export$41511673c8c4bac)]: (0, $ilwiq.RedFormat),
    [(0, $b74ab90c26700169$export$fe6ce7cdb255eca9)]: (0, $ilwiq.RGBA_ASTC_6x6_Format),
    [(0, $b74ab90c26700169$export$a8e4b1df148871af)]: (0, $ilwiq.RGBA_ASTC_6x6_Format)
};
const $f1a4de4e39dd9e7f$var$TYPE_MAP = {
    [(0, $b74ab90c26700169$export$fdb3a1bc86d5f751)]: (0, $ilwiq.FloatType),
    [(0, $b74ab90c26700169$export$a4bd06ab9faad41)]: (0, $ilwiq.HalfFloatType),
    [(0, $b74ab90c26700169$export$160be17be77b4b56)]: (0, $ilwiq.UnsignedByteType),
    [(0, $b74ab90c26700169$export$c839892416f0a511)]: (0, $ilwiq.UnsignedByteType),
    [(0, $b74ab90c26700169$export$5906c4bab83649fb)]: (0, $ilwiq.FloatType),
    [(0, $b74ab90c26700169$export$d3b70c0529038fc6)]: (0, $ilwiq.HalfFloatType),
    [(0, $b74ab90c26700169$export$20e3a1260a6d7ac)]: (0, $ilwiq.UnsignedByteType),
    [(0, $b74ab90c26700169$export$cf3a884ffb7b38a3)]: (0, $ilwiq.UnsignedByteType),
    [(0, $b74ab90c26700169$export$97764e44e06c7ca4)]: (0, $ilwiq.FloatType),
    [(0, $b74ab90c26700169$export$f8bb46dd3d4cded5)]: (0, $ilwiq.HalfFloatType),
    [(0, $b74ab90c26700169$export$8071bfaa2e2c3f81)]: (0, $ilwiq.UnsignedByteType),
    [(0, $b74ab90c26700169$export$41511673c8c4bac)]: (0, $ilwiq.UnsignedByteType),
    [(0, $b74ab90c26700169$export$fe6ce7cdb255eca9)]: (0, $ilwiq.UnsignedByteType),
    [(0, $b74ab90c26700169$export$a8e4b1df148871af)]: (0, $ilwiq.UnsignedByteType)
};
async function $f1a4de4e39dd9e7f$var$createRawTexture(container) {
    const { vkFormat: vkFormat } = container;
    if ($f1a4de4e39dd9e7f$var$FORMAT_MAP[vkFormat] === undefined) throw new Error("THREE.KTX2Loader: Unsupported vkFormat.");
    //
    let zstd;
    if (container.supercompressionScheme === (0, $b74ab90c26700169$export$f86b792952cda261)) {
        if (!$f1a4de4e39dd9e7f$var$_zstd) $f1a4de4e39dd9e7f$var$_zstd = new Promise(async (resolve)=>{
            const zstd = new (0, $315a020d3665c3cb$export$f7c044b600a8b85d)();
            await zstd.init();
            resolve(zstd);
        });
        zstd = await $f1a4de4e39dd9e7f$var$_zstd;
    }
    //
    const mipmaps = [];
    for(let levelIndex = 0; levelIndex < container.levels.length; levelIndex++){
        const levelWidth = Math.max(1, container.pixelWidth >> levelIndex);
        const levelHeight = Math.max(1, container.pixelHeight >> levelIndex);
        const levelDepth = container.pixelDepth ? Math.max(1, container.pixelDepth >> levelIndex) : 0;
        const level = container.levels[levelIndex];
        let levelData;
        if (container.supercompressionScheme === (0, $b74ab90c26700169$export$dfb4bf9f0e8f884d)) levelData = level.levelData;
        else if (container.supercompressionScheme === (0, $b74ab90c26700169$export$f86b792952cda261)) levelData = zstd.decode(level.levelData, level.uncompressedByteLength);
        else throw new Error("THREE.KTX2Loader: Unsupported supercompressionScheme.");
        let data;
        if ($f1a4de4e39dd9e7f$var$TYPE_MAP[vkFormat] === (0, $ilwiq.FloatType)) data = new Float32Array(levelData.buffer, levelData.byteOffset, levelData.byteLength / Float32Array.BYTES_PER_ELEMENT);
        else if ($f1a4de4e39dd9e7f$var$TYPE_MAP[vkFormat] === (0, $ilwiq.HalfFloatType)) data = new Uint16Array(levelData.buffer, levelData.byteOffset, levelData.byteLength / Uint16Array.BYTES_PER_ELEMENT);
        else data = levelData;
        mipmaps.push({
            data: data,
            width: levelWidth,
            height: levelHeight,
            depth: levelDepth
        });
    }
    let texture;
    if ($f1a4de4e39dd9e7f$var$UNCOMPRESSED_FORMATS.has($f1a4de4e39dd9e7f$var$FORMAT_MAP[vkFormat])) texture = container.pixelDepth === 0 ? new (0, $ilwiq.DataTexture)(mipmaps[0].data, container.pixelWidth, container.pixelHeight) : new (0, $ilwiq.Data3DTexture)(mipmaps[0].data, container.pixelWidth, container.pixelHeight, container.pixelDepth);
    else {
        if (container.pixelDepth > 0) throw new Error("THREE.KTX2Loader: Unsupported pixelDepth.");
        texture = new (0, $ilwiq.CompressedTexture)(mipmaps, container.pixelWidth, container.pixelHeight);
    }
    texture.mipmaps = mipmaps;
    texture.type = $f1a4de4e39dd9e7f$var$TYPE_MAP[vkFormat];
    texture.format = $f1a4de4e39dd9e7f$var$FORMAT_MAP[vkFormat];
    texture.colorSpace = $f1a4de4e39dd9e7f$var$parseColorSpace(container);
    texture.needsUpdate = true;
    //
    return Promise.resolve(texture);
}
function $f1a4de4e39dd9e7f$var$parseColorSpace(container) {
    const dfd = container.dataFormatDescriptor[0];
    if (dfd.colorPrimaries === (0, $b74ab90c26700169$export$4934a6a551fb755b)) return dfd.transferFunction === (0, $b74ab90c26700169$export$51f70737c6bbd8ab) ? (0, $ilwiq.SRGBColorSpace) : (0, $ilwiq.LinearSRGBColorSpace);
    else if (dfd.colorPrimaries === (0, $b74ab90c26700169$export$50d46de3f74fc52c)) return dfd.transferFunction === (0, $b74ab90c26700169$export$51f70737c6bbd8ab) ? (0, $ilwiq.DisplayP3ColorSpace) : (0, $ilwiq.LinearDisplayP3ColorSpace);
    else if (dfd.colorPrimaries === (0, $b74ab90c26700169$export$95cf3faafba16241)) return 0, $ilwiq.NoColorSpace;
    else {
        console.warn(`THREE.KTX2Loader: Unsupported color primaries, "${dfd.colorPrimaries}"`);
        return 0, $ilwiq.NoColorSpace;
    }
}


class $8d616e478505b76d$export$2e2bcd8739ae039 {
    constructor(loadingManager, renderer, cacheTimeout = 60000){
        this.loadingManager = loadingManager;
        this.renderer = renderer; // Needed for KTX2Loader
        this.loader = new (0, $559434fcc6e6401d$export$aa93f11e7884f0f4)(this.loadingManager);
        this.cacheTimeout = cacheTimeout;
        this.modelCache = {}; // Cache for loaded models
        this.lastAccessTime = {}; // To track last access time
        // Initialize DRACO Loader
        this.dracoLoader = new (0, $8e8b252f320f3b48$export$45c25de53be259ac)();
        this.dracoLoader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.4.3/");
        this.dracoLoader.preload();
        this.loader.setDRACOLoader(this.dracoLoader);
        // Initialize KTX2 Loader
        this.ktx2Loader = new (0, $f1a4de4e39dd9e7f$export$f2e11b211e093ce0)(this.loadingManager);
        this.loader.setKTX2Loader(this.ktx2Loader);
        this.ktx2Loader.setTranscoderPath("https://unpkg.com/three@0.157.0/examples/jsm/libs/basis/");
        //this.ktx2Loader.setTranscoderPath('https://unpkg.com/three@0.167.1/examples/jsm/libs/basis/');
        this.ktx2Loader.detectSupport(this.renderer);
        // Cache cleanup interval
        setInterval(()=>this.clearCache(), cacheTimeout);
    }
    async loadModel(url) {
        // Return cached model if available
        if (this.modelCache[url]) {
            this.lastAccessTime[url] = Date.now();
            //console.log(`Returning cached model: ${url}`);
            return this.modelCache[url];
        }
        return new Promise((resolve, reject)=>{
            this.loader.load(url, (gltf)=>{
                const model = gltf.scene;
                /*
                                        // Process textures in the model
                                        model.traverse((child) => {
                                            if (child.isMesh && child.material) {
                                                this.processKTX2Textures(child.material);
                                            }
                                        });
                    */ // Cache the model
                this.modelCache[url] = model;
                this.lastAccessTime[url] = Date.now();
                //console.log(`Model loaded: ${url}`);
                resolve(model);
            }, undefined, (error)=>{
                console.error(`Error loading model: ${url}`, error);
                reject(error);
            });
        });
    }
    async loadKTX2Texture(url) {
        return new Promise((resolve, reject)=>{
            this.ktx2Loader.load(url, (texture)=>resolve(texture), undefined, (error)=>reject(error));
        });
    }
    processKTX2Textures(material) {
        if (Array.isArray(material)) material.forEach((mat)=>this.replaceTextureWithKTX2(mat));
        else this.replaceTextureWithKTX2(material);
    }
    async loadTexture(url) {
        return new Promise((resolve, reject)=>{
            const loader = new $ilwiq.TextureLoader();
            loader.load(url, (texture)=>resolve(texture), undefined, (error)=>reject(error));
        });
    }
    replaceTextureWithKTX2(material) {
        if (material.map && material.map.name.endsWith(".ktx2")) material.map = this.ktx2Loader.load(material.map.sourceFile, (texture)=>{
            texture.needsUpdate = true;
        });
    }
    clearCache() {
        const now = Date.now();
        Object.keys(this.lastAccessTime).forEach((url)=>{
            if (now - this.lastAccessTime[url] > this.cacheTimeout) {
                //console.log(`Clearing cache for model: ${url}`);
                delete this.modelCache[url];
                delete this.lastAccessTime[url];
            }
        });
    }
} /*
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { KTX2Loader } from "three/examples/jsm/Addons.js";

export default class ModelLoader {
    constructor(loadingManager, cacheTimeout = 60000) {
        this.loadingManager = loadingManager;
        this.loader = new GLTFLoader(this.loadingManager);
        this.cacheTimeout = cacheTimeout;
        this.modelCache = {}; // To store the loaded models
        this.lastAccessTime = {}; // To track the last access time of the models
        this.dracoLoader = new DRACOLoader();
        this.dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.4.3/'); // Path to Draco decoder
        this.loader.setDRACOLoader(this.dracoLoader);

        // Clean up the cache after a certain time period
        setInterval(() => this.clearCache(), cacheTimeout);
    }

    async loadModel(url) {
        // Check if the model is already in the cache
        if (this.modelCache[url]) {
            // Update the last access time and return the cached model
            this.lastAccessTime[url] = Date.now();
            console.log(`Returning cached model: ${url}`);
            return this.modelCache[url];
        }

        return new Promise((resolve, reject) => {
            this.loader.setDRACOLoader(this.dracoLoader);


            this.loader.load(
                url,
                (gltf) => {
                    // Store the loaded model in the cache
                    this.modelCache[url] = gltf.scene;
                    this.lastAccessTime[url] = Date.now();
                    console.log(`Model loaded: ${url}`);
                    resolve(gltf.scene);
                },
                undefined, // onProgress callback is not needed for now
                (error) => {
                    console.error(`Error loading model: ${url}`, error);
                    reject(error);
                }
            );
        });

    }

    // Function to clear the cache
    clearCache() {
        const now = Date.now();
        Object.keys(this.lastAccessTime).forEach((url) => {
            // If a model hasn't been accessed in a certain period of time, remove it from cache
            if (now - this.lastAccessTime[url] > this.cacheTimeout) {
                console.log(`Clearing cache for model: ${url}`);
                delete this.modelCache[url];
                delete this.lastAccessTime[url];
            }
        });
    }
}
    */ 


/**
 * SoundManager - A comprehensive audio management class for Three.js
 * Handles both sound effects and background ambience
 */ 
var $ilwiq = parcelRequire("ilwiq");
class $0dc3a085ea730d2a$var$SoundManager {
    constructor(camera, listener = null){
        this.sounds = {};
        this.ambientSounds = {};
        this.masterVolume = 1.0;
        this.effectsVolume = 1.0;
        this.ambienceVolume = 0.5;
        // Set up audio listener if not provided
        if (!listener) {
            this.listener = new $ilwiq.AudioListener();
            if (camera) camera.add(this.listener);
        } else this.listener = listener;
        // Create audio loader
        this.audioLoader = new $ilwiq.AudioLoader();
        // Track loaded resources
        this.loadingManager = new $ilwiq.LoadingManager();
        this.isLoading = false;
    }
    /**
     * Set the master volume for all sounds
     * @param {number} value - Volume level from 0.0 to 1.0
     */ setMasterVolume(value) {
        this.masterVolume = Math.max(0, Math.min(1, value));
        // Update all sounds with new master volume
        Object.values(this.sounds).forEach((sound)=>{
            sound.setVolume(this.effectsVolume * this.masterVolume);
        });
        Object.values(this.ambientSounds).forEach((sound)=>{
            sound.setVolume(this.ambienceVolume * this.masterVolume);
        });
    }
    /**
     * Set the effects volume level
     * @param {number} value - Volume level from 0.0 to 1.0
     */ setEffectsVolume(value) {
        this.effectsVolume = Math.max(0, Math.min(1, value));
        // Update all effect sounds
        Object.values(this.sounds).forEach((sound)=>{
            sound.setVolume(this.effectsVolume * this.masterVolume);
        });
    }
    /**
     * Set the ambience volume level
     * @param {number} value - Volume level from 0.0 to 1.0
     */ setAmbienceVolume(value) {
        this.ambienceVolume = Math.max(0, Math.min(1, value));
        // Update all ambient sounds
        Object.values(this.ambientSounds).forEach((sound)=>{
            sound.setVolume(this.ambienceVolume * this.masterVolume);
        });
    }
    /**
     * Preload sound effect
     * @param {string} name - Unique identifier for this sound
     * @param {string} path - File path to the sound
     * @param {Function} callback - Optional callback when loading completes
     */ loadSound(name, path, callback = null) {
        this.isLoading = true;
        this.audioLoader.load(path, (buffer)=>{
            // Create a non-positional audio source
            const sound = new $ilwiq.Audio(this.listener);
            sound.setBuffer(buffer);
            sound.setVolume(this.effectsVolume * this.masterVolume);
            this.sounds[name] = sound;
            if (callback) callback();
            this.isLoading = false;
        }, // onProgress callback
        (xhr)=>{
        //console.log(`${name} sound: ${(xhr.loaded / xhr.total * 100)}% loaded`);
        }, // onError callback
        (err)=>{
            //console.error(`Error loading sound ${name}:`, err);
            this.isLoading = false;
        });
    }
    /**
     * Preload ambient sound
     * @param {string} name - Unique identifier for this ambient sound
     * @param {string} path - File path to the sound
     * @param {boolean} loop - Whether the sound should loop
     * @param {Function} callback - Optional callback when loading completes
     */ loadAmbientSound(name, path, loop = true, callback = null) {
        this.isLoading = true;
        this.audioLoader.load(path, (buffer)=>{
            // Create a non-positional audio source
            const sound = new $ilwiq.Audio(this.listener);
            sound.setBuffer(buffer);
            sound.setVolume(this.ambienceVolume * this.masterVolume);
            sound.setLoop(loop);
            this.ambientSounds[name] = sound;
            if (callback) callback();
            this.isLoading = false;
        }, // onProgress callback
        (xhr)=>{
        //console.log(`${name} ambient sound: ${(xhr.loaded / xhr.total * 100)}% loaded`);
        }, // onError callback
        (err)=>{
            //console.error(`Error loading ambient sound ${name}:`, err);
            this.isLoading = false;
        });
    }
    /**
     * Load a positional sound (3D sound effect)
     * @param {string} name - Unique identifier for this sound
     * @param {string} path - File path to the sound
     * @param {THREE.Object3D} object - The object to attach the sound to
     * @param {number} refDistance - Distance model reference distance 
     * @param {Function} callback - Optional callback when loading completes
     */ loadPositionalSound(name, path, object, refDistance = 1, callback = null) {
        this.isLoading = true;
        this.audioLoader.load(path, (buffer)=>{
            // Create a positional audio source
            const sound = new $ilwiq.PositionalAudio(this.listener);
            sound.setBuffer(buffer);
            sound.setRefDistance(refDistance);
            sound.loop = true;
            sound.setVolume(this.effectsVolume * this.masterVolume);
            // Attach the sound to the object
            object.add(sound);
            // Store reference
            this.sounds[name] = sound;
            if (callback) callback();
            this.isLoading = false;
        }, // onProgress callback
        (xhr)=>{
        //console.log(`${name} positional sound: ${(xhr.loaded / xhr.total * 100)}% loaded`);
        }, // onError callback
        (err)=>{
            //console.error(`Error loading positional sound ${name}:`, err);
            this.isLoading = false;
        });
    }
    /**
     * Play a sound effect
     * @param {string} name - Name of the sound to play
     * @param {boolean} interrupt - Whether to restart if already playing
     * @return {boolean} - Whether the sound was successfully played
     */ play(name, interrupt = true) {
        const sound = this.sounds[name];
        if (!sound) //console.warn(`Sound "${name}" not found`);
        return false;
        if (sound.isPlaying && !interrupt) return false;
        if (sound.isPlaying) sound.stop();
        sound.play();
        return true;
    }
    /**
     * Play an ambient sound
     * @param {string} name - Name of the ambient sound to play
     * @param {boolean} fadeIn - Whether to fade in the sound
     * @param {number} fadeTime - Time in seconds for fade in
     */ playAmbience(name, fadeIn = true, fadeTime = 2.0) {
        const sound = this.ambientSounds[name];
        if (!sound) //console.warn(`Ambient sound "${name}" not found`);
        return false;
        if (sound.isPlaying) return false;
        if (fadeIn) {
            // Store the target volume and start at 0
            const targetVolume = sound.getVolume();
            sound.setVolume(0);
            sound.play();
            // Fade in
            const startTime = performance.now();
            const updateVolume = ()=>{
                const elapsedTime = (performance.now() - startTime) / 1000;
                const progress = Math.min(elapsedTime / fadeTime, 1);
                sound.setVolume(targetVolume * progress);
                if (progress < 1) requestAnimationFrame(updateVolume);
            };
            requestAnimationFrame(updateVolume);
        } else sound.play();
        return true;
    }
    /**
     * Stop a specific sound
     * @param {string} name - Name of the sound to stop
     * @param {boolean} fadeOut - Whether to fade out before stopping
     * @param {number} fadeTime - Time in seconds for fade out
     */ stop(name, fadeOut = false, fadeTime = 1.0) {
        const sound = this.sounds[name] || this.ambientSounds[name];
        if (!sound) //console.warn(`Sound "${name}" not found`);
        return;
        if (!sound.isPlaying) return;
        if (fadeOut) {
            // Store initial volume
            const initialVolume = sound.getVolume();
            const startTime = performance.now();
            // Fade out
            const updateVolume = ()=>{
                const elapsedTime = (performance.now() - startTime) / 1000;
                const progress = Math.min(elapsedTime / fadeTime, 1);
                sound.setVolume(initialVolume * (1 - progress));
                if (progress < 1) requestAnimationFrame(updateVolume);
                else {
                    sound.stop();
                    // Restore original volume
                    sound.setVolume(initialVolume);
                }
            };
            requestAnimationFrame(updateVolume);
        } else sound.stop();
    }
    /**
     * Stop all sounds including ambience
     * @param {boolean} fadeOut - Whether to fade out
     * @param {number} fadeTime - Time in seconds for fade out
     */ stopAll(fadeOut = false, fadeTime = 1.0) {
        // Stop regular sounds
        Object.keys(this.sounds).forEach((name)=>{
            this.stop(name, fadeOut, fadeTime);
        });
        // Stop ambient sounds
        Object.keys(this.ambientSounds).forEach((name)=>{
            this.stop(name, fadeOut, fadeTime);
        });
    }
    /**
     * Pause all currently playing sounds
     */ pauseAll() {
        this.listener.context.suspend();
    }
    /**
     * Resume all paused sounds
     */ resumeAll() {
        this.listener.context.resume();
    }
    /**
     * Crossfade between two ambient sounds
     * @param {string} from - Name of the ambient sound to fade out
     * @param {string} to - Name of the ambient sound to fade in
     * @param {number} duration - Duration of crossfade in seconds
     */ crossfadeAmbience(from, to, duration = 3.0) {
        const fromSound = this.ambientSounds[from];
        const toSound = this.ambientSounds[to];
        if (!fromSound || !toSound) //console.warn(`One or both ambient sounds not found for crossfade`);
        return;
        // Store original volumes
        const fromVolume = fromSound.getVolume();
        const toVolume = toSound.getVolume();
        // Start playing the target sound at zero volume
        toSound.setVolume(0);
        if (!toSound.isPlaying) toSound.play();
        // Perform crossfade
        const startTime = performance.now();
        const updateVolumes = ()=>{
            const elapsedTime = (performance.now() - startTime) / 1000;
            const progress = Math.min(elapsedTime / duration, 1);
            // Fade out source sound
            fromSound.setVolume(fromVolume * (1 - progress));
            // Fade in target sound
            toSound.setVolume(toVolume * progress);
            if (progress < 1) requestAnimationFrame(updateVolumes);
            else {
                fromSound.stop();
                fromSound.setVolume(fromVolume); // Restore original volume
            }
        };
        requestAnimationFrame(updateVolumes);
    }
    /**
     * Update method to call in animation loop for any ongoing processes
     * @param {number} delta - Time delta between frames
     */ update(delta) {
    // Can be extended for time-based effects or analyzers
    }
}
var // Export the class
$0dc3a085ea730d2a$export$2e2bcd8739ae039 = $0dc3a085ea730d2a$var$SoundManager;


/********************************************************************
// Vanilla Javascript
********************************************************************/ /********************************************************************
// Check if Mobile device
********************************************************************/ let $8f6a480bb40b134f$var$visitedFromMobileDevice;
function $8f6a480bb40b134f$var$isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
}
if ($8f6a480bb40b134f$var$isMobileDevice()) $8f6a480bb40b134f$var$visitedFromMobileDevice = true;
else $8f6a480bb40b134f$var$visitedFromMobileDevice = false;
const $8f6a480bb40b134f$var$grassContainer = document.getElementById("container-contact");
/********************************************************************
// Intersection Observer(s) for Canvas
********************************************************************/ // Intersection Observer setup for opening scene
const $8f6a480bb40b134f$var$observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.3 // Trigger when 30% of the target is visible
};
//intersection observer for detecting opening scene out of view
const $8f6a480bb40b134f$var$observerCallback = (entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) // Start or resume animation
        $8f6a480bb40b134f$var$fnStartRendering();
        else // Pause animation
        $8f6a480bb40b134f$var$fnStopRendering();
    });
};
const $8f6a480bb40b134f$var$observer = new IntersectionObserver($8f6a480bb40b134f$var$observerCallback, $8f6a480bb40b134f$var$observerOptions);
const $8f6a480bb40b134f$var$targetElement = document.getElementById("container-opening-scene");
$8f6a480bb40b134f$var$observer.observe($8f6a480bb40b134f$var$targetElement);

// Intersection Observer setup for contact scene
//intersection observer for detecting opening scene out of view
const $8f6a480bb40b134f$var$observerContactSceneCallback = (entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            if ($8f6a480bb40b134f$var$grassScene) $8f6a480bb40b134f$var$grassScene.startRendering();
            else if (!$8f6a480bb40b134f$var$grassSceneInitializing) {
                $8f6a480bb40b134f$var$grassSceneInitializing = true;
                (parcelRequire("arjYd")).then(({ default: GrassScene })=>{
                    $8f6a480bb40b134f$var$grassScene = new GrassScene($8f6a480bb40b134f$var$grassContainer, $8f6a480bb40b134f$var$visitedFromMobileDevice, $8f6a480bb40b134f$var$modelLoader);
                    if ($8f6a480bb40b134f$var$storedSkyboxPromise) $8f6a480bb40b134f$var$grassScene.setEnvMapFromPromise($8f6a480bb40b134f$var$storedSkyboxPromise);
                });
            }
        } else if ($8f6a480bb40b134f$var$grassScene) $8f6a480bb40b134f$var$grassScene.stopRendering();
    });
};
const $8f6a480bb40b134f$var$observerContactScene = new IntersectionObserver($8f6a480bb40b134f$var$observerContactSceneCallback, $8f6a480bb40b134f$var$observerOptions);
$8f6a480bb40b134f$var$observerContactScene.observe($8f6a480bb40b134f$var$grassContainer);
/********************************************************************
// Handle Button Navigation
********************************************************************/ //sound button
const $8f6a480bb40b134f$var$soundToggleBtn = document.getElementById("btn-sound-toggle");
const $8f6a480bb40b134f$var$uiManager = new (0, $e0c699995c427076$export$2524c4960ed9dff2)({
    visitedFromMobileDevice: $8f6a480bb40b134f$var$visitedFromMobileDevice
});
const $8f6a480bb40b134f$var$sectionScene = $8f6a480bb40b134f$var$uiManager.sectionScene;
/********************************************************************
// THREEJS STUFF
********************************************************************/ /********************************************************************
// Scene Constants
********************************************************************/ const $8f6a480bb40b134f$var$PERSON_HEIGHT = 22.0; //21
const $8f6a480bb40b134f$var$DISTANCE_TEXTURE_SWAP = 300.0;
//const DISTANCE_TEXTURE_DISPOSE = 650.0;
//LOD
const $8f6a480bb40b134f$var$DISTANCE_LOD0 = 100;
const $8f6a480bb40b134f$var$DISTANCE_LOD1 = 200;
const $8f6a480bb40b134f$var$DISTANCE_LOD2 = 300;
//Environment Map intensities
/********************************************************************
// Scene Setup
********************************************************************/ const $8f6a480bb40b134f$var$canvasContainer = document.querySelector("#container-opening-scene");
const $8f6a480bb40b134f$var$worldScene = new (0, $cef69bdc893056f5$export$2e2bcd8739ae039)($8f6a480bb40b134f$var$canvasContainer, $8f6a480bb40b134f$var$visitedFromMobileDevice);
let $8f6a480bb40b134f$var$grassScene = null;
let $8f6a480bb40b134f$var$grassSceneInitializing = false;
let $8f6a480bb40b134f$var$storedSkyboxPromise = null;
const $8f6a480bb40b134f$var$renderer = $8f6a480bb40b134f$var$worldScene.getRenderer();
const $8f6a480bb40b134f$var$camera = $8f6a480bb40b134f$var$worldScene.getCamera();
//const axesHelper = new THREE.AxesHelper(1000);
//worldScene.scene.add(axesHelper);
//show stats, updated in animation loop
// const stats = Stats();
// stats.showPanel(0);
// document.body.appendChild(stats.dom);
/********************************************************************
// Sounds
********************************************************************/ const $8f6a480bb40b134f$var$soundManager = new (0, $0dc3a085ea730d2a$export$2e2bcd8739ae039)($8f6a480bb40b134f$var$camera);
$8f6a480bb40b134f$var$soundManager.setMasterVolume(1.00);
$8f6a480bb40b134f$var$soundManager.setAmbienceVolume(0.75);
$8f6a480bb40b134f$var$soundManager.setEffectsVolume(0.90);
let $8f6a480bb40b134f$var$soundOn, $8f6a480bb40b134f$var$soundsAreloaded = false; //windSoundIsLoaded removed - unused
$8f6a480bb40b134f$var$soundToggleBtn.addEventListener("click", ()=>{
    // Toggle sound state
    $8f6a480bb40b134f$var$soundOn = !$8f6a480bb40b134f$var$soundOn;
    // Update the icon based on state
    if ($8f6a480bb40b134f$var$soundOn) {
        $8f6a480bb40b134f$var$soundToggleBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="1em" height="1em" fill="currentColor"><path d="M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"/></svg>';
        $8f6a480bb40b134f$var$soundToggleBtn.classList.add("active");
        // Code to turn sound on
        //soundManager.resumeAll();
        if (!$8f6a480bb40b134f$var$soundsAreloaded) {
            $8f6a480bb40b134f$var$soundManager.resumeAll();
            $8f6a480bb40b134f$var$fnLoadSoundFiles();
        } else $8f6a480bb40b134f$var$soundManager.resumeAll();
    } else {
        $8f6a480bb40b134f$var$soundToggleBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="1em" height="1em" fill="currentColor"><path d="M301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>';
        $8f6a480bb40b134f$var$soundToggleBtn.classList.remove("active");
        // Code to turn sound off
        $8f6a480bb40b134f$var$soundManager.pauseAll();
    }
});
const $8f6a480bb40b134f$var$soundConfigs = {
    "projector": {
        path: "./assets/sounds/projector2.mp3",
        refDistance: 60,
        audibleRange: 170
    }
};
const $8f6a480bb40b134f$var$soundSources = new Map();
function $8f6a480bb40b134f$var$fnCheckIfSoundSourcesShouldPlay(playerPosition) {
    // Check each sound source
    //if (soundSources) {
    $8f6a480bb40b134f$var$soundSources.forEach((data, id)=>{
        //console.log(data)
        const distance = playerPosition.distanceTo(data.audioSource.position);
        const type = data.type;
        // If within audible range but not playing
        if (distance < $8f6a480bb40b134f$var$soundConfigs[type].audibleRange && !data.isPlaying) {
            $8f6a480bb40b134f$var$soundManager.play(type);
            data.isPlaying = true;
            $8f6a480bb40b134f$var$soundSources.set(id, data);
        } else if (distance > $8f6a480bb40b134f$var$soundConfigs[type].audibleRange && data.isPlaying) {
            $8f6a480bb40b134f$var$soundManager.stop(type);
            data.isPlaying = false;
            $8f6a480bb40b134f$var$soundSources.set(id, data);
        }
    });
}
function $8f6a480bb40b134f$var$fnLoadSoundFiles() {
    let loadingcount = 0;
    let totalSounds = $8f6a480bb40b134f$var$soundSources.size + 2; // wind and ambient
    function checkAllSoundsAreLoaded() {
        loadingcount++;
        if (loadingcount >= totalSounds) $8f6a480bb40b134f$var$soundsAreloaded = true;
    }
    //load positional sound files
    $8f6a480bb40b134f$var$soundSources.forEach((data, id)=>{
        $8f6a480bb40b134f$var$soundManager.loadPositionalSound(data.name, data.path, data.audioSource, $8f6a480bb40b134f$var$soundConfigs[data.type].refDistance, ()=>{
            $8f6a480bb40b134f$var$soundManager.play(data.name);
            $8f6a480bb40b134f$var$soundManager.stop(data.name);
            checkAllSoundsAreLoaded();
        });
    });
    // Load ambient sound and play it when loaded
    $8f6a480bb40b134f$var$soundManager.loadAmbientSound("outdoors", "./assets/sounds/ambience.mp3", true, ()=>{
        $8f6a480bb40b134f$var$soundManager.playAmbience("outdoors", true, 3.0);
        checkAllSoundsAreLoaded();
    });
    const windSound = new $ilwiq.Audio($8f6a480bb40b134f$var$soundManager.listener);
    $8f6a480bb40b134f$var$soundManager.audioLoader.load("./assets/sounds/wind.mp3", (buffer)=>{
        windSound.setBuffer(buffer);
        windSound.setLoop(true);
        windSound.setVolume(0.3 * $8f6a480bb40b134f$var$soundManager.masterVolume);
        windSound.play();
        $8f6a480bb40b134f$var$soundManager.sounds["wind"] = windSound;
        checkAllSoundsAreLoaded();
    });
}
/********************************************************************
 // Check for Tab visibility
********************************************************************/ let $8f6a480bb40b134f$var$gameIsActive = true;
function $8f6a480bb40b134f$var$fnStartRendering() {
    $8f6a480bb40b134f$var$renderer.setAnimationLoop($8f6a480bb40b134f$var$animate);
    $8f6a480bb40b134f$var$gameIsActive = true;
    $8f6a480bb40b134f$var$soundToggleBtn.classList.remove("hide");
    if ($8f6a480bb40b134f$var$soundOn) {
        $8f6a480bb40b134f$var$soundManager.resumeAll();
        $8f6a480bb40b134f$var$soundToggleBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="1em" height="1em" fill="currentColor"><path d="M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"/></svg>';
        $8f6a480bb40b134f$var$soundToggleBtn.classList.add("active");
    }
}
function $8f6a480bb40b134f$var$fnStopRendering() {
    $8f6a480bb40b134f$var$renderer.setAnimationLoop(null);
    $8f6a480bb40b134f$var$gameIsActive = false;
    $8f6a480bb40b134f$var$soundManager.pauseAll();
    //soundOn = false;
    $8f6a480bb40b134f$var$soundToggleBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="1em" height="1em" fill="currentColor"><path d="M301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>';
    $8f6a480bb40b134f$var$soundToggleBtn.classList.remove("active");
    $8f6a480bb40b134f$var$soundToggleBtn.classList.add("hide");
}
// Detect when the user switches to a different tab or window
document.addEventListener("visibilitychange", ()=>{
    if (document.hidden) $8f6a480bb40b134f$var$fnStopRendering(); // Pause when the tab is inactive
    else if (window.scrollY === 0 || window.pageYOffset === 0) $8f6a480bb40b134f$var$fnStartRendering(); // Resume when the tab is active again
});
/********************************************************************
// Texture Loading
********************************************************************/ const $8f6a480bb40b134f$var$textureLoader = new $ilwiq.TextureLoader();
/********************************************************************
// Skybox loading
********************************************************************/ // Skybox loading (handled by WorldScene)
$8f6a480bb40b134f$var$worldScene.loadSkybox();
$8f6a480bb40b134f$var$storedSkyboxPromise = $8f6a480bb40b134f$var$worldScene.skyboxPromise;
if ($8f6a480bb40b134f$var$grassScene) $8f6a480bb40b134f$var$grassScene.setEnvMapFromPromise($8f6a480bb40b134f$var$storedSkyboxPromise);
/********************************************************************
// Landscape : Simplex Noise
// Now imported from terrainConfig.js (shared with grassWorker.js)
// simplex, getHeight, smoothstep, flatAreas
********************************************************************/ /********************************************************************
// Factory Entry Check (post processing swap)
********************************************************************/ let $8f6a480bb40b134f$var$activeComposer = $8f6a480bb40b134f$var$worldScene.getComposerDefault();
const $8f6a480bb40b134f$var$factoryEntranceTrigger = new $ilwiq.Box3(new $ilwiq.Vector3(-190, -50, -350), new $ilwiq.Vector3(200, 50, 90));
$8f6a480bb40b134f$var$factoryEntranceTrigger.translate(new $ilwiq.Vector3(1200, (0, $320c956a09dd2394$export$c08559766941f856)(1200, 1200), 1200));
let $8f6a480bb40b134f$var$previousPlayerInsideFactory = false;
let $8f6a480bb40b134f$var$factoryCheckCooldown = 0;
const $8f6a480bb40b134f$var$FACTORY_CHECK_INTERVAL = 100;
function $8f6a480bb40b134f$var$fnCheckIfPlayerIsInFactoryTrigger(playerPosition, deltaTime) {
    $8f6a480bb40b134f$var$factoryCheckCooldown -= deltaTime * 1000;
    if ($8f6a480bb40b134f$var$factoryCheckCooldown <= 0) {
        $8f6a480bb40b134f$var$factoryCheckCooldown = $8f6a480bb40b134f$var$FACTORY_CHECK_INTERVAL;
        const isPlayerInTrigger = $8f6a480bb40b134f$var$factoryEntranceTrigger.containsPoint(playerPosition);
        if (isPlayerInTrigger !== $8f6a480bb40b134f$var$previousPlayerInsideFactory) {
            $8f6a480bb40b134f$var$previousPlayerInsideFactory = isPlayerInTrigger;
            if (isPlayerInTrigger) {
                $8f6a480bb40b134f$var$activeComposer = $8f6a480bb40b134f$var$worldScene.getComposerFactoryInterior();
                //windowMaterial.transparent = true;
                const windSound = $8f6a480bb40b134f$var$soundManager.sounds["wind"];
                if (windSound) windSound.setVolume(0.1 * $8f6a480bb40b134f$var$soundManager.masterVolume);
            } else {
                $8f6a480bb40b134f$var$activeComposer = $8f6a480bb40b134f$var$worldScene.getComposerDefault();
                const windSound = $8f6a480bb40b134f$var$soundManager.sounds["wind"];
                if (windSound) windSound.setVolume(0.3 * $8f6a480bb40b134f$var$soundManager.masterVolume);
            }
        }
    }
}
/********************************************************************
// Video Texture for Rock Projection
********************************************************************/ const $8f6a480bb40b134f$var$videoProject = document.createElement("video");
$8f6a480bb40b134f$var$videoProject.src = "./assets/nature/video.webm";
$8f6a480bb40b134f$var$videoProject.loop = true;
$8f6a480bb40b134f$var$videoProject.muted = true;
$8f6a480bb40b134f$var$videoProject.play();
const $8f6a480bb40b134f$var$videoTextureProject = new $ilwiq.VideoTexture($8f6a480bb40b134f$var$videoProject);
$8f6a480bb40b134f$var$videoTextureProject.minFilter = $ilwiq.LinearFilter;
$8f6a480bb40b134f$var$videoTextureProject.magFilter = $ilwiq.LinearFilter;
$8f6a480bb40b134f$var$videoTextureProject.format = $ilwiq.RGBAFormat;
$8f6a480bb40b134f$var$videoTextureProject.generateMipmaps = false;
function $8f6a480bb40b134f$var$fnCreateVideoMaterial() {
    return new (0, $kEdgE.C)({
        baseMaterial: $ilwiq.MeshStandardMaterial,
        uniforms: {
            uVideoTexture: {
                value: null
            },
            uDiffuseMap: {
                value: null
            },
            uTerrainHeight: {
                value: 0.0
            },
            uFadeHeight: {
                value: 5.3
            },
            uProjectorPosition: {
                value: new $ilwiq.Vector3()
            },
            uProjectorDirection: {
                value: new $ilwiq.Vector3()
            },
            uProjectorMatrix: {
                value: new $ilwiq.Matrix4()
            },
            uProjectorFOV: {
                value: 45.0 * (Math.PI / 180.0)
            },
            uProjectorAspect: {
                value: 16 / 9
            },
            //uBaseColor: { value: new THREE.Color(0.1, 0.1, 0.1) },
            uProjectionIntensity: {
                value: 0.8
            },
            uVignette: {
                value: 0.2
            },
            uBlendFactor: {
                value: 0.25
            },
            uMinZDistance: {
                value: null
            }
        },
        vertexShader: (0, $c758bc53cea77699$export$2e2bcd8739ae039).vert,
        fragmentShader: (0, $c758bc53cea77699$export$2e2bcd8739ae039).frag,
        side: $ilwiq.FrontSide,
        fog: true
    });
}
/********************************************************************
// Materials
********************************************************************/ /** Powerlines Material */ const $8f6a480bb40b134f$var$powerlinesShaderMaterial = new $ilwiq.ShaderMaterial({
    vertexShader: (0, $70eca344ea66fcb2$export$2e2bcd8739ae039).vert,
    fragmentShader: (0, $70eca344ea66fcb2$export$2e2bcd8739ae039).frag,
    uniforms: {
        uTime: {
            value: 0.0
        },
        colorStart: {
            value: new $ilwiq.Color(0x4D474A)
        },
        colorEnd: {
            value: new $ilwiq.Color(0xF2F8FF)
        }
    },
    transparent: true
});
const $8f6a480bb40b134f$var$fadeShaderMaterial = (0, $b1c999dd6ba4b081$export$f67d8322b0a09fb0)({
    fadeHeight: 5.5,
    brightness: 1.0,
    side: $ilwiq.FrontSide
});
const $8f6a480bb40b134f$var$factoryShader = new (0, $kEdgE.C)({
    baseMaterial: $ilwiq.MeshStandardMaterial,
    uniforms: {
        uDiffuseMap: {
            value: null
        },
        uHasDiffuseMap: {
            value: false
        },
        uColor: {
            value: new $ilwiq.Color(1, 0, 0)
        },
        uTerrainHeight: {
            value: null
        },
        uFadeHeight: {
            value: 5.5
        },
        uMeshPosition: {
            value: null
        },
        uBrightness: {
            value: 1.0
        }
    },
    vertexShader: $8f6a480bb40b134f$var$fadeShaderMaterial.__csm.vertexShader,
    fragmentShader: $8f6a480bb40b134f$var$fadeShaderMaterial.__csm.fragmentShader,
    side: $ilwiq.DoubleSide,
    fog: true
});
/********************************************************************
// Load Models
********************************************************************/ let $8f6a480bb40b134f$var$allModelsLoaded = false;
let $8f6a480bb40b134f$var$allModelsAddedToScene = false;
const $8f6a480bb40b134f$var$loadingManager = new $ilwiq.LoadingManager();
const $8f6a480bb40b134f$var$loadingElement = document.querySelector("#text-loading");
$8f6a480bb40b134f$var$loadingManager.onStart = function(url, itemsLoaded, itemsTotal) {
//console.log(`Started loading: ${url} (${itemsLoaded}/${itemsTotal})`);
};
$8f6a480bb40b134f$var$loadingManager.onProgress = function(url, itemsLoaded, itemsTotal) {
    //console.log('Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
    const progress = Math.floor(itemsLoaded / itemsTotal * 100);
    //console.log(`Loading file: ${url}. Loaded ${itemsLoaded}/${itemsTotal} files.`);
    //console.log(`Loading: ${progress}%`)
    $8f6a480bb40b134f$var$loadingElement.textContent = `${progress}%`;
};
$8f6a480bb40b134f$var$loadingManager.onLoad = function() {
    //console.log("All models loaded!");
    $8f6a480bb40b134f$var$allModelsLoaded = true;
};
const $8f6a480bb40b134f$var$modelLoader = new (0, $8d616e478505b76d$export$2e2bcd8739ae039)($8f6a480bb40b134f$var$loadingManager, $8f6a480bb40b134f$var$renderer);
const $8f6a480bb40b134f$var$modelRegistry = new Map();
async function $8f6a480bb40b134f$var$fnLoadPowerlinesModel(url) {
    const position = {
        x: 385,
        z: -300
    }; //360, 275 (10, 12, 10)
    const name = "powerlines";
    let mesh;
    const model = await $8f6a480bb40b134f$var$modelLoader.loadModel(url);
    model.scale.set(11, 13, 11);
    model.rotateY(-Math.PI / 4);
    model.position.set(position.x, (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.z) - 2, position.z);
    mesh = model.children.find((child)=>child.isMesh);
    // Create powerlines material from fadeShaderMaterial clone
    const powerlinesMaterial = $8f6a480bb40b134f$var$fadeShaderMaterial.clone();
    powerlinesMaterial.uniforms.uColor.value = new $ilwiq.Vector3(0.175, 0.175, 0.175);
    powerlinesMaterial.uniforms.uDiffuseMap.value = null;
    powerlinesMaterial.uniforms.uMeshPosition.value = new $ilwiq.Vector3(position.x, (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.z) - 2, position.z);
    powerlinesMaterial.uniforms.uTerrainHeight.value = (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.z);
    powerlinesMaterial.uniforms.uFadeHeight.value = 5.0;
    powerlinesMaterial.uniforms.uHasDiffuseMap.value = false;
    powerlinesMaterial.envMap = $8f6a480bb40b134f$var$worldScene.envMap;
    powerlinesMaterial.envMapIntensity = 0.4;
    powerlinesMaterial.fog = false;
    powerlinesMaterial.metalness = 1.0;
    powerlinesMaterial.roughness = 0.6;
    model.children[1].material = $8f6a480bb40b134f$var$powerlinesShaderMaterial;
    model.children[3].material = $8f6a480bb40b134f$var$powerlinesShaderMaterial;
    model.children[4].material = $8f6a480bb40b134f$var$powerlinesShaderMaterial;
    model.children[6].material = $8f6a480bb40b134f$var$powerlinesShaderMaterial;
    model.children[0].children[0].material = powerlinesMaterial;
    model.children[0].children[1].material = powerlinesMaterial;
    model.children[0].children[2].material = powerlinesMaterial;
    model.traverse((child)=>{
        if (child.isMesh && child.name.includes("Power_Lines")) {
            child.material.transparent = true;
            child.material.opacity = 0.45;
        }
    });
    $8f6a480bb40b134f$var$worldScene.scene.add(model);
    (0, $9be4dfcf19ae1185$export$2e2bcd8739ae039).fnAddModelToRegistry($8f6a480bb40b134f$var$modelRegistry, name, mesh, new $ilwiq.Vector3(position.x, (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.z) - 2, position.z), null, true, false, null, false, null, null);
}
const $8f6a480bb40b134f$var$windowMaterial = new $ilwiq.MeshStandardMaterial({
    color: 0xffffff,
    roughness: 0.85,
    metalness: 0.5,
    opacity: 0.96,
    transparent: true,
    side: $ilwiq.DoubleSide,
    fog: true
});
// Prewarming function
async function $8f6a480bb40b134f$var$prewarmWindowMaterial(renderer, camera) {
    const prewarmGeometry = new $ilwiq.BoxGeometry(1, 1, 1);
    const prewarmBox = new $ilwiq.Mesh(prewarmGeometry, $8f6a480bb40b134f$var$windowMaterial);
    $8f6a480bb40b134f$var$worldScene.scene.add(prewarmBox);
    // Async compile shaders without blocking
    await renderer.compileAsync($8f6a480bb40b134f$var$worldScene.scene, camera);
    $8f6a480bb40b134f$var$worldScene.scene.remove(prewarmBox);
    prewarmGeometry.dispose();
}
if (!$8f6a480bb40b134f$var$visitedFromMobileDevice) $8f6a480bb40b134f$var$prewarmWindowMaterial($8f6a480bb40b134f$var$renderer, $8f6a480bb40b134f$var$camera);
async function $8f6a480bb40b134f$var$fnLoadFactoryModel(url) {
    const position = new $ilwiq.Vector3(1200, (0, $320c956a09dd2394$export$c08559766941f856)(1200, 1200), 1200);
    const name = "factory_new";
    let mesh, material, diffuseMap, model, colliderMesh, colliderBVH, collisionRadius;
    model = await $8f6a480bb40b134f$var$modelLoader.loadModel(url);
    //console.log(model)
    mesh = model.children[0].children[1];
    model.rotateY(-Math.PI / 2);
    model.position.set(position);
    model.scale.set(10, 10, 10);
    diffuseMap = mesh.material.map;
    colliderMesh = model.children[2];
    //console.log(colliderMesh)
    material = $8f6a480bb40b134f$var$factoryShader;
    mesh.material = material;
    material.uniforms.uHasDiffuseMap.value = true;
    material.uniforms.uDiffuseMap.value = diffuseMap;
    material.uniforms.uFadeHeight.value = 30.0;
    material.uniforms.uTerrainHeight.value = (0, $320c956a09dd2394$export$c08559766941f856)(1200, 1200);
    material.uniforms.uMeshPosition.value = new $ilwiq.Vector3(1200, (0, $320c956a09dd2394$export$c08559766941f856)(1200, 1200), 1200);
    // const LOD1Material = new THREE.MeshStandardMaterial({
    //     color: 0xFF0000,
    //     map: diffuseMap,
    //     fog: true,
    // });
    material.envMap = $8f6a480bb40b134f$var$worldScene.envMap;
    material.envMapIntensity = 1.5;
    $8f6a480bb40b134f$var$windowMaterial.map = diffuseMap;
    // Apply material to window meshes
    const windowMeshLOD0 = model.children[0].children[0];
    const windowMeshLOD1 = model.children[1].children[0];
    windowMeshLOD0.material = $8f6a480bb40b134f$var$windowMaterial;
    windowMeshLOD1.material = $8f6a480bb40b134f$var$windowMaterial;
    // Set environment map properties
    windowMeshLOD0.material.envMap = $8f6a480bb40b134f$var$worldScene.envMap;
    windowMeshLOD1.material.envMap = $8f6a480bb40b134f$var$worldScene.envMap;
    windowMeshLOD0.material.envMapIntensity = 1.5;
    windowMeshLOD1.material.envMapIntensity = 1.5;
    //windowMeshLOD0.visible = false;
    /*
        model.children[0].children[1].material = windowMaterial;
        model.children[2].children[1].material = windowMaterial;
        model.children[0].children[1].material.envMap = worldScene.envMap;
        model.children[2].children[1].material.envMap = worldScene.envMap;
        model.children[0].children[1].material.envMapIntensity = 0.5; //1.2
        model.children[2].children[1].material.envMapIntensity = 0.5; //1.2
    */ //model.children[0].children[1].visible = false;
    //model.children[2].children[1].visible = false;
    //material.needsUpdate = true;
    //windowMaterial.needsUpdate = true;
    const LOD0 = model.children[0];
    const LOD1 = model.children[1];
    //console.log(LOD1.children[1].material)
    //LOD1.children[1].material = LOD1Material;
    //LOD 1 mesh material
    LOD1.children[1].material.envMap = $8f6a480bb40b134f$var$worldScene.envMap;
    LOD1.children[1].material.envMapIntensity = 1.2;
    const lod = new $ilwiq.LOD();
    lod.addLevel(LOD0, 900);
    lod.addLevel(LOD1, 1100);
    lod.rotateY(-Math.PI / 2);
    lod.position.set(position.x, position.y, position.z);
    lod.scale.set(10.0, 10.0, 10.0);
    //colliderMesh = model.children.find(child => child.isMesh && child.name === 'collider');
    colliderMesh.visible = false;
    colliderMesh.rotateY(-Math.PI / 2);
    colliderMesh.position.set(position.x, position.y, position.z);
    colliderMesh.scale.set(10, 10, 10);
    // Ensure world matrix is updated before applying it to geometry
    colliderMesh.updateMatrixWorld(true);
    const geom = colliderMesh.geometry.clone();
    geom.applyMatrix4(colliderMesh.matrixWorld);
    // Create BVH from the transformed geometry
    geom.boundsTree = new (0, $4eb4044e12c26831$export$9d614b3bc2c4eacf)(geom);
    // Assign the transformed geometry to the mesh
    colliderMesh.geometry = geom;
    // Add to the scene
    colliderBVH = colliderMesh.geometry.boundsTree;
    collisionRadius = colliderBVH.geometry.boundingSphere.radius + 170;
    (0, $9be4dfcf19ae1185$export$2e2bcd8739ae039).fnAddModelToRegistry($8f6a480bb40b134f$var$modelRegistry, name, mesh, position, diffuseMap, true, true, 700, false, colliderBVH, collisionRadius);
    $8f6a480bb40b134f$var$worldScene.scene.add(lod);
// console.log('Scaled collider geometry bounds - fac:', colliderMesh.geometry.boundingBox);
// console.log('Scaled collider bounding sphere - fac:', colliderMesh.geometry.boundingSphere);
}
async function $8f6a480bb40b134f$var$fnLoadFactoryInteriorModel(url) {
    //const position = { x: 1200, z: 1200 };
    const position = new $ilwiq.Vector3(1200, (0, $320c956a09dd2394$export$c08559766941f856)(1200, 1200), 1200);
    const name = "factory_interior";
    let mesh, material, diffuseMap, model, colliderMesh, colliderBVH, collisionRadius;
    model = await $8f6a480bb40b134f$var$modelLoader.loadModel(url);
    mesh = model.children[0];
    const LOD1 = model.children[0].clone();
    diffuseMap = mesh.material.map;
    mesh.castShadow = true;
    mesh.receiveShadow = true;
    // Transform children locally (no position - that goes on LOD)
    mesh.rotateY(-Math.PI / 2);
    mesh.scale.set(9.98, 9.98, 9.98);
    LOD1.rotateY(-Math.PI / 2);
    LOD1.scale.set(9.98, 9.98, 9.98);
    // Basic red material for LOD1 testing
    LOD1.material = new $ilwiq.MeshStandardMaterial({
        map: mesh.material.map,
        envMap: $8f6a480bb40b134f$var$worldScene.envMap,
        envMapIntensity: 1.5
    });
    //create LOD - position goes HERE, not on children
    const lod = new $ilwiq.LOD();
    lod.position.set(position.x, position.y, position.z);
    lod.addLevel(mesh, 0); // projection material when close (0-400 units)
    lod.addLevel(LOD1, 900); // red basic material when far (400+ units)
    //colliderMesh = model.children[1];
    material = $8f6a480bb40b134f$var$fnCreateVideoMaterial();
    mesh.material = material;
    // Update shader uniforms
    const videoTest = document.createElement("video");
    videoTest.src = "./assets/glass/super8.webm";
    videoTest.loop = true;
    videoTest.muted = true; // Important for autoplay
    videoTest.crossOrigin = "anonymous";
    videoTest.play();
    // Create a video texture
    const videoTextureTest = new $ilwiq.VideoTexture(videoTest);
    videoTextureTest.minFilter = $ilwiq.LinearFilter;
    videoTextureTest.magFilter = $ilwiq.LinearFilter;
    videoTextureTest.format = $ilwiq.RGBAFormat;
    // Create a larger target surface
    const surfaceWidth = 75; // Larger width
    //const surfaceHeight = surfaceWidth * (9 / 16);// Larger height
    const surfaceHeight = surfaceWidth * (3 / 4); // Larger height
    // Define the projection area relative to the surface size
    // These values control the relative size and position of the projection on the surface
    const projectionParams = {
        // Size of projection as a fraction of the surface dimensions
        relativeWidth: 0.5,
        relativeHeight: 0.5,
        // Center position of projection (0,0 is center, values from -0.5 to 0.5)
        offsetX: 0.0,
        offsetY: -0.25 // Offset slightly upward
    };
    const targetCenter = new $ilwiq.Vector3(projectionParams.offsetX * surfaceWidth, projectionParams.offsetY * surfaceHeight, 0);
    // Create the projector object (this will be the source of projection)
    const projector = new $ilwiq.Object3D();
    projector.position.set(projectionParams.offsetX * surfaceWidth - 650, (0, $320c956a09dd2394$export$c08559766941f856)(1200, 1200) + 20, 710 // Center Z over target
    );
    //projector.rotation.set(0, -Math.PI / 2, 0);  // -90 degrees on X axis
    projector.lookAt(projectionParams.offsetX * surfaceWidth + 50, projectionParams.offsetY * surfaceHeight, 0); // Point at the center of the desired projection area
    $8f6a480bb40b134f$var$worldScene.scene.add(projector);
    //projector.position.set(0, 0, 0);
    //soundManager.play('projector');
    const projectorAudioSource = new $ilwiq.Object3D();
    projectorAudioSource.position.set(1250, (0, $320c956a09dd2394$export$c08559766941f856)(1250, 1200) + $8f6a480bb40b134f$var$PERSON_HEIGHT, 1200);
    $8f6a480bb40b134f$var$worldScene.scene.add(projectorAudioSource);
    //soundManager.loadPositionalSound('projector', './assets/sounds/projector2.mp3', projectorAudioSource, 60.0);
    $8f6a480bb40b134f$var$soundSources.set(projectorAudioSource.id, {
        audioSource: projectorAudioSource,
        type: "projector",
        name: "projector",
        path: "./assets/sounds/projector2.mp3",
        isPlaying: false
    });
    // Get the static projector position and direction
    const projectorPosition = new $ilwiq.Vector3();
    projector.getWorldPosition(projectorPosition);
    const projectorDirection = new $ilwiq.Vector3();
    projector.getWorldDirection(projectorDirection);
    projectorDirection.negate(); // Flip to point forward
    // Create a static view matrix for the projector
    const projectorViewMatrix = new $ilwiq.Matrix4();
    projectorViewMatrix.lookAt(projectorPosition, new $ilwiq.Vector3().addVectors(projectorPosition, projectorDirection), new $ilwiq.Vector3(0, 1, 0));
    // Calculate field of view to cover only a portion of the surface
    // We'll use a narrower FOV to restrict the projection area
    const distance = projectorPosition.distanceTo(targetCenter);
    const targetWidth = surfaceWidth * projectionParams.relativeWidth;
    const targetHeight = surfaceHeight * projectionParams.relativeHeight;
    // Calculate FOV based on the desired projection width and distance
    const fovX = 2 * Math.atan(targetWidth / (2 * distance));
    const fovY = 2 * Math.atan(targetHeight / (2 * distance));
    const fov = Math.max(fovX, fovY); // Use the larger angle to ensure coverage
    const aspect = targetWidth / targetHeight;
    const projectorProjectionMatrix = new $ilwiq.Matrix4();
    projectorProjectionMatrix.makePerspective(-aspect * Math.tan(fov / 2), aspect * Math.tan(fov / 2), Math.tan(fov / 2), -Math.tan(fov / 2), 1, 1000);
    // Combine into one static projector matrix
    const projectorMatrix = new $ilwiq.Matrix4().multiplyMatrices(projectorProjectionMatrix, projectorViewMatrix);
    material.uniforms.uProjectorPosition.value = projectorPosition;
    material.uniforms.uProjectorDirection.value = projectorDirection;
    material.uniforms.uProjectorMatrix.value = projectorMatrix;
    material.uniforms.uDiffuseMap.value = diffuseMap;
    material.uniforms.uVideoTexture.value = videoTextureTest;
    material.uniforms.uMinZDistance.value = position.z + 500; //500
    material.uniforms.uTerrainHeight.value = (0, $320c956a09dd2394$export$c08559766941f856)(1200, 1200);
    material.uniforms.uFadeHeight.value = 2.5;
    material.envMap = $8f6a480bb40b134f$var$worldScene.envMap;
    material.envMapIntensity = 2.10;
    (0, $9be4dfcf19ae1185$export$2e2bcd8739ae039).fnAddModelToRegistry($8f6a480bb40b134f$var$modelRegistry, name, mesh, position, diffuseMap, true, true, 700, false, colliderBVH, collisionRadius);
    $8f6a480bb40b134f$var$worldScene.scene.add(lod);
}
/********************************************************************
// VIDEO PROJECTION TEST
********************************************************************/ async function $8f6a480bb40b134f$var$fnLoadStoneModelWithProjection({ modelURL: modelURL = null, name: name = null, position: position = new $ilwiq.Vector2(0, 0), scale: scale = 1, envMapIntensity: envMapIntensity = 0.4, isFaded: isFaded = false, fadeHeight: fadeHeight = 15.0 } = {}) {
    let colliderBVH;
    const height = (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.y);
    // Example: model loaded with MeshStandardMaterial
    const model = await $8f6a480bb40b134f$var$modelLoader.loadModel(modelURL);
    const collider = model.children.find((child)=>child.isMesh && child.name === "collider");
    const lod1 = model.children.find((child)=>child.isMesh && child.name === "lod1");
    const lod2 = model.children.find((child)=>child.isMesh && child.name === "lod2");
    collider.visible = false;
    //console.log(collider)
    collider.rotateY(Math.PI * 6 / 4);
    collider.position.set(position.x, (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.y), position.y);
    collider.scale.set(scale, scale, scale);
    //const mesh = model.children.find(child => child.isMesh && child.name === name);
    const diffuseMap = lod1.material.map;
    model.scale.set(scale);
    const lod = new $ilwiq.LOD();
    lod.addLevel(lod1, $8f6a480bb40b134f$var$DISTANCE_LOD0);
    lod.addLevel(lod2, $8f6a480bb40b134f$var$DISTANCE_LOD1);
    lod.position.set(position.x, (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.y), position.y);
    lod.scale.set(scale, scale, scale);
    lod.rotateY(Math.PI * 6 / 4);
    // Ensure world matrix is updated before applying it to geometry
    collider.updateMatrixWorld(true);
    const geom = collider.geometry.clone();
    geom.applyMatrix4(collider.matrixWorld);
    // Create BVH from the transformed geometry
    geom.boundsTree = new (0, $4eb4044e12c26831$export$9d614b3bc2c4eacf)(geom);
    // Assign the transformed geometry to the mesh
    collider.geometry = geom;
    // Add to the scene
    colliderBVH = collider.geometry.boundsTree;
    const collisionRadius = colliderBVH.geometry.boundingSphere.radius + 10;
    const projector = new $ilwiq.PerspectiveCamera(30, 16 / 9, 0.01, 2);
    projector.position.set(position.x, height + scale, position.y + 60);
    //const helper = new THREE.CameraHelper(projector);
    //worldScene.scene.add(helper);
    const videoProjectionMaterial = new (0, $0c0e813ce4ad425f$export$2e2bcd8739ae039)({
        camera: projector,
        texture: $8f6a480bb40b134f$var$videoTextureProject,
        textureScale: 0.9,
        textureOffset: new $ilwiq.Vector2(0.0, -0.1),
        cover: true,
        map: diffuseMap,
        roughness: 0.9,
        side: $ilwiq.FrontSide,
        envMap: $8f6a480bb40b134f$var$worldScene.envMap,
        envMapIntensity: envMapIntensity,
        fog: true,
        opacity: 1.0,
        isFaded: isFaded,
        fadeHeight: fadeHeight,
        terrainHeight: height
    });
    lod1.material = videoProjectionMaterial;
    lod2.material = videoProjectionMaterial;
    // and when you're ready project the texture on the box!
    videoProjectionMaterial.project(lod1);
    videoProjectionMaterial.project(lod2);
    $8f6a480bb40b134f$var$worldScene.scene.add(lod);
    (0, $9be4dfcf19ae1185$export$2e2bcd8739ae039).fnAddModelToRegistry($8f6a480bb40b134f$var$modelRegistry, name, lod1, new $ilwiq.Vector3(position.x, 0, position.y), diffuseMap, true, true, $8f6a480bb40b134f$var$DISTANCE_TEXTURE_SWAP, false, colliderBVH, collisionRadius);
}
async function $8f6a480bb40b134f$var$fnLoadHQTexture(data) {
    if (!data) return;
    const material = data.mesh.material;
    const name = data.name;
    if (!data.hqTexture) {
        const textureDiffuse = await $8f6a480bb40b134f$var$modelLoader.loadKTX2Texture(`./assets/models/${name}/base_color_cmp.ktx2`);
        if (material.uniforms && material.uniforms.uDiffuseMap !== undefined) {
            material.uniforms.uDiffuseMap.value.dispose();
            material.uniforms.uDiffuseMap.value = textureDiffuse;
        } else material.map = textureDiffuse;
        data.hqTexture = textureDiffuse;
    } else material.uniforms.uDiffuseMap.value = data.hqTexture;
//data.mesh.material.needsUpdate = true;
}
// // Function to unload HQ texture (remove from GPU memory)
// function fnUnloadHQTexture(data) {
//     if (!data.hqTexture) return;
//     const material = data.mesh.material;
//     if (material.uniforms.uDiffuseMap.value) {
//         material.uniforms.uDiffuseMap.value.dispose();
//         material.uniforms.uDiffuseMap.value = data.lqTexture;
//     }
//     material.needsUpdate = true;
// }
/*
async function fnLoadRockModels() {
    try {
        // Load the factory model
        const model = await modelLoader.loadModel('./assets/models/rock_model.glb');


        model.scale.set(45, 45, 45)
        model.position.set(100, getHeight(100, 800) - 15, 800)

        model.children[0].material.color = new THREE.Color(0.8, 0.8, 0.8)
        model.children[0].material.envMap = worldScene.envMap;
        model.children[0].material.envMapIntensity = 0.35;
        model.children[0].material.roughness = 1.0;
        model.children[0].material.side = THREE.FrontSide;

        worldScene.scene.add(model)


        model.children.forEach((child) => {
            const clonedMesh = child.clone();


            clonedMesh.position.set(0, getHeight(0, 0) - 2, 0)
            clonedMesh.scale.set(2.45, 2.45, 2.45)

            clonedMesh.material.envMap = worldScene.envMap;
            clonedMesh.material.envMapIntensity = 0.35;

            
                        if (child.name === 'LOD0') {
                            lodRocks.addLevel(clonedMesh, 150);
                            //clonedMesh.scale.set(1, 1, 1)
                        } else if (child.name === 'LOD1') {
                            lodRocks.addLevel(clonedMesh, 200);
                            //clonedMesh.scale.set(1, 1, 1)
                        } else if (child.name === 'LOD2') {
                            lodRocks.addLevel(clonedMesh, 250);
                            //clonedMesh.scale.set(1, 1, 1)
                        }
                    
            //clonedMesh.updateMatrixWorld(true);
            //clonedMesh.applyMatrix4(child.matrixWorld);
            //clonedMesh.scale.set(1.7, 1.7, 1.7)
            //clonedMesh.position.set(100, getHeight(100, 1000), 1000)

            //lodRocks.updateMatrixWorld(true);

            //clonedMesh.updateMatrixWorld(true);
            //clonedMesh.matrixAutoUpdate = false;
            //clonedMesh.material.side = THREE.FrontSide;
            //clonedMesh.material.transparent = true;


        });



        lodRocks.position.set(100, getHeight(100, 1000), 1000)
        worldScene.scene.add(lodRocks);

        //model.scale.set(100, 100, 100);

        //console.log(model.children[0])



    } catch (error) {
        //console.error('Error loading models:', error);
    }
}
*/ function $8f6a480bb40b134f$var$createStoneFigureBaseMaterial() {
    return new (0, $kEdgE.C)({
        baseMaterial: $ilwiq.MeshStandardMaterial,
        uniforms: {
            uDiffuseMap: {
                value: null
            },
            hologramColor: {
                value: new $ilwiq.Color(0xab52e3)
            },
            time: {
                value: 0
            },
            uOpacity: {
                value: 0.75
            },
            scanLineFrequency: {
                value: 0.1
            },
            scanLineSpeed: {
                value: 0.5
            },
            distortionAmount: {
                value: 0.0
            },
            glowAmount: {
                value: 2.0
            },
            flickerSpeed: {
                value: 0.05
            },
            flickerIntensity: {
                value: 0.05
            },
            textureInfluence: {
                value: 0.85
            },
            effectsIntensity: {
                value: 0.0
            },
            positionScale: {
                value: 1.0
            },
            uBrightness: {
                value: 1.0
            },
            uTerrainHeight: {
                value: null
            },
            uFadeHeight: {
                value: 1.5
            }
        },
        vertexShader: (0, $ac4331ebc7819748$export$2e2bcd8739ae039).vert,
        fragmentShader: (0, $ac4331ebc7819748$export$2e2bcd8739ae039).frag,
        side: $ilwiq.FrontSide,
        transparent: true,
        fog: false
    });
}
function $8f6a480bb40b134f$var$createStoneFigureMaterial() {
    const baseMaterial = $8f6a480bb40b134f$var$createStoneFigureBaseMaterial();
    const clone = baseMaterial.clone();
    //clone.uniforms = THREE.UniformsUtils.clone(clone.uniforms);
    return clone;
}
const $8f6a480bb40b134f$var$stoneFigureParams = [
    {
        url: "./assets/models/horse_figure/horse_figure.glb",
        name: "horse_figure",
        position: (0, $9be4dfcf19ae1185$export$2e2bcd8739ae039).fnGetRandomPosition(600, 800, 800),
        scale: new $ilwiq.Vector3(2.5, 2.5, 2.5),
        rotation: -Math.PI / 4,
        material: $8f6a480bb40b134f$var$createStoneFigureMaterial(),
        isAnimating: false,
        color: new $ilwiq.Color(0xf6e3ff)
    },
    //{ url: './assets/models/dog_figure/dog_figure.glb', name: 'dog_figure', position: Utils.fnGetRandomPosition(600, 800, 850), scale: new THREE.Vector3(3.5, 3.5, 3.5), rotation: -Math.PI / 4, material: createStoneFigureMaterial(), isAnimating: false, color: new THREE.Color(0xf6e3ff) },
    {
        url: "./assets/models/mouse_figure/mouse_figure.glb",
        name: "mouse_figure",
        position: (0, $9be4dfcf19ae1185$export$2e2bcd8739ae039).fnGetRandomPosition(800, 1000, 1000),
        scale: new $ilwiq.Vector3(2.5, 2.5, 2.5),
        rotation: -Math.PI / 4,
        material: $8f6a480bb40b134f$var$createStoneFigureMaterial(),
        isAnimating: false,
        color: new $ilwiq.Color(0xf6e3ff)
    },
    {
        url: "./assets/models/snake_figure/snake_figure.glb",
        name: "snake_figure",
        position: (0, $9be4dfcf19ae1185$export$2e2bcd8739ae039).fnGetRandomPosition(650, 500, 500),
        scale: new $ilwiq.Vector3(2.5, 2.5, 2.5),
        rotation: -Math.PI / 4,
        material: $8f6a480bb40b134f$var$createStoneFigureMaterial(),
        isAnimating: false,
        color: new $ilwiq.Color(0xf6e3ff)
    },
    {
        url: "./assets/models/goat_figure/goat_figure.glb",
        name: "goat_figure",
        position: (0, $9be4dfcf19ae1185$export$2e2bcd8739ae039).fnGetRandomPosition(600, 500, 500),
        scale: new $ilwiq.Vector3(2.5, 2.5, 2.5),
        rotation: Math.PI - Math.PI / 4,
        material: $8f6a480bb40b134f$var$createStoneFigureMaterial(),
        isAnimating: false,
        color: new $ilwiq.Color(0xf6e3ff)
    }
];
async function $8f6a480bb40b134f$var$fnLoadStoneFigureModel(url, name, position, scale, rotation, material, color) {
    let model, mesh, diffuseMap, colliderBVH;
    model = await $8f6a480bb40b134f$var$modelLoader.loadModel(url);
    diffuseMap = model.children[0].material.map;
    mesh = model.children.find((child)=>child.isMesh && child.name === "LOD0");
    mesh.material = material;
    material.transparent = true;
    material.uniforms.uDiffuseMap.value = diffuseMap;
    material.uniforms.uTerrainHeight.value = (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.z);
    material.uniforms.uFadeHeight.value = 8.0;
    material.uniforms.uBrightness.value = 0.75;
    material.uniforms.hologramColor.value = color;
    material.envMap = $8f6a480bb40b134f$var$worldScene.envMap;
    material.envMapIntensity = 0.45;
    const LOD1 = model.children.find((child)=>child.isMesh && child.name === "LOD1");
    const LOD2 = model.children.find((child)=>child.isMesh && child.name === "LOD2");
    const collider = model.children.find((child)=>child.isMesh && child.name === "Collider");
    //collider.rotateY(rotation);
    LOD1.material = material;
    LOD2.material = material;
    const lod = new $ilwiq.LOD();
    lod.addLevel(mesh, $8f6a480bb40b134f$var$DISTANCE_LOD0);
    lod.addLevel(LOD1, $8f6a480bb40b134f$var$DISTANCE_LOD1);
    lod.addLevel(LOD2, $8f6a480bb40b134f$var$DISTANCE_LOD2);
    lod.rotateY(rotation);
    lod.position.set(position.x, (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.z), position.z);
    lod.scale.set(scale.x, scale.y, scale.z);
    //collider.visible = true;
    collider.rotateY(rotation);
    collider.position.set(position.x, (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.z), position.z);
    collider.scale.set(scale.x, scale.y, scale.z);
    // Ensure world matrix is updated before applying it to geometry
    collider.updateMatrixWorld(true);
    const geom = collider.geometry.clone();
    geom.applyMatrix4(collider.matrixWorld);
    // Create BVH from the transformed geometry
    geom.boundsTree = new (0, $4eb4044e12c26831$export$9d614b3bc2c4eacf)(geom);
    // Assign the transformed geometry to the mesh
    collider.geometry = geom;
    // Add to the scene
    colliderBVH = collider.geometry.boundsTree;
    const collisionRadius = colliderBVH.geometry.boundingSphere.radius;
    $8f6a480bb40b134f$var$worldScene.scene.add(lod);
    //renderer.compile(lod, camera, worldScene.scene);
    (0, $9be4dfcf19ae1185$export$2e2bcd8739ae039).fnAddModelToRegistry($8f6a480bb40b134f$var$modelRegistry, name, mesh, new $ilwiq.Vector3(position.x, (0, $320c956a09dd2394$export$c08559766941f856)(position.x, position.z), position.z), diffuseMap, true, true, $8f6a480bb40b134f$var$DISTANCE_TEXTURE_SWAP, false, colliderBVH, collisionRadius);
}
//Load models for desktop
if (!$8f6a480bb40b134f$var$visitedFromMobileDevice) window.addEventListener("load", ()=>{
    $8f6a480bb40b134f$var$stoneFigureParams.forEach((params)=>{
        $8f6a480bb40b134f$var$fnLoadStoneFigureModel(params.url, params.name, params.position, params.scale, params.rotation, params.material, params.color);
    });
    $8f6a480bb40b134f$var$fnLoadFactoryModel("./assets/models/factory_new/factory.glb");
    $8f6a480bb40b134f$var$fnLoadFactoryInteriorModel("./assets/models/factory_interior/factory_interior.glb");
    $8f6a480bb40b134f$var$fnLoadStoneModelWithProjection({
        modelURL: "./assets/models/video_rock/video_rock.glb",
        name: "video_rock",
        position: new $ilwiq.Vector2(-400, 200),
        scale: 10,
        envMapIntensity: 0.25,
        isFaded: true,
        fadeHeight: 18.5
    });
});
// Models that load on all platforms (including mobile)
$8f6a480bb40b134f$var$fnLoadPowerlinesModel("./assets/models/powerlines/powerlines.glb");
function $8f6a480bb40b134f$var$fnToggleFigureAnimation(stoneFigureParams, figureName) {
    for(let i = 0; i < stoneFigureParams.length; i++)if (stoneFigureParams[i].name === figureName) {
        //stoneFigureParams[i].material.uniforms.effectsIntensity.value = 1.0;
        setTimeout(()=>{
            stoneFigureParams[i].isAnimating = true;
        }, 2000);
        break; // Exit loop once found
    }
}
/********************************************************************
// Video Plane
********************************************************************/ // Create a video element
const $8f6a480bb40b134f$var$video = document.createElement("video");
$8f6a480bb40b134f$var$video.src = "./assets/introvideo640.mp4"; // Set the path to your video file
$8f6a480bb40b134f$var$video.setAttribute("webkit-playsinline", "webkit-playsinline"); // For older Safari versions
$8f6a480bb40b134f$var$video.setAttribute("playsinline", "playsinline"); // For modern browsers
$8f6a480bb40b134f$var$video.muted = true;
$8f6a480bb40b134f$var$video.autoPlay = true;
$8f6a480bb40b134f$var$video.loop = true;
$8f6a480bb40b134f$var$video.play();
// Create a texture from the video element
const $8f6a480bb40b134f$var$videoTexture = new $ilwiq.VideoTexture($8f6a480bb40b134f$var$video);
$8f6a480bb40b134f$var$videoTexture.minFilter = $ilwiq.LinearFilter;
$8f6a480bb40b134f$var$videoTexture.magFilter = $ilwiq.LinearFilter;
$8f6a480bb40b134f$var$videoTexture.format = $ilwiq.RGBAFormat;
$8f6a480bb40b134f$var$videoTexture.generateMipmaps = false;
$8f6a480bb40b134f$var$videoTexture.colorSpace = $ilwiq.SRGBColorSpace;
const $8f6a480bb40b134f$var$videoShaderMaterial = (0, $59e304539a3bf5aa$export$d4f3284e3e7553ea)($8f6a480bb40b134f$var$videoTexture, {
    edgeTransparency: 0.15,
    globalOpacity: 0.85
});
// Then handle both paused and low-power conditions
//if (video.paused || video.autoplay && !video.playing) {
if ($8f6a480bb40b134f$var$video.paused) {
    const fallbackTexture = $8f6a480bb40b134f$var$textureLoader.load("./assets/videoFallback.webp", ()=>{
        $8f6a480bb40b134f$var$videoShaderMaterial.uniforms.videoTexture.value = fallbackTexture;
    });
}
document.body.addEventListener("touchstart", function() {
    //set texture to video
    $8f6a480bb40b134f$var$videoShaderMaterial.uniforms.videoTexture.value = $8f6a480bb40b134f$var$videoTexture;
    $8f6a480bb40b134f$var$video.play();
}, {
    once: true
});
// Create a plane geometry
const $8f6a480bb40b134f$var$videoGeometry = new $ilwiq.PlaneGeometry(384, 216, 32, 16); // 10x10 segments for smooth edges
// Create a mesh with the geometry and custom shader material
const $8f6a480bb40b134f$var$videoPlane = new $ilwiq.Mesh($8f6a480bb40b134f$var$videoGeometry, $8f6a480bb40b134f$var$videoShaderMaterial);
$8f6a480bb40b134f$var$videoPlane.position.set(0, (0, $320c956a09dd2394$export$c08559766941f856)(0, 0) + 110.0, 0);
// Video plane is added when grass workers are done with initial load
/********************************************************************
// Position Camera at pageload
********************************************************************/ let $8f6a480bb40b134f$var$startPosition, $8f6a480bb40b134f$var$endPosition;
if ($8f6a480bb40b134f$var$visitedFromMobileDevice) {
    $8f6a480bb40b134f$var$camera.rotation.x = 0;
    $8f6a480bb40b134f$var$camera.far = 1100;
    $8f6a480bb40b134f$var$camera.fov = 60;
    $8f6a480bb40b134f$var$startPosition = new $ilwiq.Vector3(0, (0, $320c956a09dd2394$export$c08559766941f856)(0, 550) + $8f6a480bb40b134f$var$PERSON_HEIGHT, 550);
    $8f6a480bb40b134f$var$endPosition = new $ilwiq.Vector3(0, (0, $320c956a09dd2394$export$c08559766941f856)(0, 450) + $8f6a480bb40b134f$var$PERSON_HEIGHT, 450);
    if (window.matchMedia("(orientation: landscape)").matches) {
        $8f6a480bb40b134f$var$startPosition = new $ilwiq.Vector3(0, (0, $320c956a09dd2394$export$c08559766941f856)(0, 350) + $8f6a480bb40b134f$var$PERSON_HEIGHT, 350);
        $8f6a480bb40b134f$var$endPosition = new $ilwiq.Vector3(0, (0, $320c956a09dd2394$export$c08559766941f856)(0, 250) + $8f6a480bb40b134f$var$PERSON_HEIGHT, 250);
        $8f6a480bb40b134f$var$camera.far = 950;
    }
} else {
    $8f6a480bb40b134f$var$startPosition = new $ilwiq.Vector3(0, (0, $320c956a09dd2394$export$c08559766941f856)(0, 420) + $8f6a480bb40b134f$var$PERSON_HEIGHT, 420); // Starting position
    $8f6a480bb40b134f$var$endPosition = new $ilwiq.Vector3(0, (0, $320c956a09dd2394$export$c08559766941f856)(0, 320) + $8f6a480bb40b134f$var$PERSON_HEIGHT, 320); // Ending position
    $8f6a480bb40b134f$var$camera.rotation.x = Math.PI / 16;
}
$8f6a480bb40b134f$var$camera.position.set($8f6a480bb40b134f$var$startPosition.x, $8f6a480bb40b134f$var$startPosition.y, $8f6a480bb40b134f$var$startPosition.z);
/********************************************************************
// Animate Camera
********************************************************************/ // Animation state
const $8f6a480bb40b134f$var$cameraAnimationState = {
    startTime: null,
    isAnimating: false,
    duration: 5000,
    fnCheckOrientationCanRun: false
};
// Easing function (Ease In-Out Quad)
function $8f6a480bb40b134f$var$easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}
function $8f6a480bb40b134f$var$fnAnimateCamera() {
    // Time management
    const currentTime = performance.now();
    if ($8f6a480bb40b134f$var$cameraAnimationState.isAnimating) {
        if (!$8f6a480bb40b134f$var$cameraAnimationState.startTime) $8f6a480bb40b134f$var$cameraAnimationState.startTime = currentTime;
        const elapsed = currentTime - $8f6a480bb40b134f$var$cameraAnimationState.startTime;
        let progress = Math.min(elapsed / $8f6a480bb40b134f$var$cameraAnimationState.duration, 1); // Clamp progress between 0 and 1
        // Apply easing function to progress
        progress = $8f6a480bb40b134f$var$easeInOutQuad(progress);
        // Interpolate position
        const interpolatedPosition = new $ilwiq.Vector3().lerpVectors($8f6a480bb40b134f$var$startPosition, $8f6a480bb40b134f$var$endPosition, progress);
        // Calculate dynamic y position
        const dynamicY = (0, $320c956a09dd2394$export$c08559766941f856)(interpolatedPosition.x, interpolatedPosition.z) + $8f6a480bb40b134f$var$PERSON_HEIGHT;
        // Set camera position
        $8f6a480bb40b134f$var$camera.position.set(interpolatedPosition.x, dynamicY, interpolatedPosition.z);
        // Stop animation when completed
        if (progress >= 1) {
            $8f6a480bb40b134f$var$cameraAnimationState.isAnimating = false;
            $8f6a480bb40b134f$var$cameraAnimationState.fnCheckOrientationCanRun = true;
            if (!$8f6a480bb40b134f$var$visitedFromMobileDevice) document.querySelector(".wasd-icon").classList.remove("hide");
        }
    }
}
function $8f6a480bb40b134f$var$fnCheckOrientation() {
    if ($8f6a480bb40b134f$var$cameraAnimationState.fnCheckOrientationCanRun) {
        if (window.matchMedia("(orientation: landscape)").matches && $8f6a480bb40b134f$var$visitedFromMobileDevice) {
            $8f6a480bb40b134f$var$camera.far = 750;
            $8f6a480bb40b134f$var$camera.rotation.x = 0;
            $8f6a480bb40b134f$var$camera.position.set(0, (0, $320c956a09dd2394$export$c08559766941f856)(0, 250) + $8f6a480bb40b134f$var$PERSON_HEIGHT, 250);
        } else if (window.matchMedia("(orientation: portrait)").matches && $8f6a480bb40b134f$var$visitedFromMobileDevice) {
            $8f6a480bb40b134f$var$camera.far = 1100;
            $8f6a480bb40b134f$var$camera.rotation.x = 0;
            $8f6a480bb40b134f$var$camera.position.set(0, (0, $320c956a09dd2394$export$c08559766941f856)(0, 450) + $8f6a480bb40b134f$var$PERSON_HEIGHT, 450);
        }
    }
}
/********************************************************************
// PlayerController
********************************************************************/ const $8f6a480bb40b134f$var$clock = new $ilwiq.Clock();
let $8f6a480bb40b134f$var$playerController = null;
if (!$8f6a480bb40b134f$var$visitedFromMobileDevice) {
    $8f6a480bb40b134f$var$playerController = new (0, $06fb980720f8d216$export$cbacd6dcfff5ae2e)({
        camera: $8f6a480bb40b134f$var$camera,
        renderer: $8f6a480bb40b134f$var$renderer,
        sectionScene: $8f6a480bb40b134f$var$sectionScene,
        modelRegistry: $8f6a480bb40b134f$var$modelRegistry,
        stoneFigureParams: $8f6a480bb40b134f$var$stoneFigureParams,
        fnToggleFigureAnimation: $8f6a480bb40b134f$var$fnToggleFigureAnimation,
        personHeight: $8f6a480bb40b134f$var$PERSON_HEIGHT,
        speed: 350.0,
        endPosition: $8f6a480bb40b134f$var$endPosition,
        gameIsActive: ()=>$8f6a480bb40b134f$var$gameIsActive,
        hideWasdIcon: ()=>$8f6a480bb40b134f$var$uiManager.hideWasdIcon()
    });
    $8f6a480bb40b134f$var$uiManager.setControls($8f6a480bb40b134f$var$playerController.controls);
} else {
    // Mobile touch input for camera rotation
    let startX = 0;
    let startY = 0;
    let isTouching = false;
    $8f6a480bb40b134f$var$sectionScene.addEventListener("touchstart", (event)=>{
        isTouching = true;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
    });
    $8f6a480bb40b134f$var$sectionScene.addEventListener("touchmove", (e)=>{
        if (!isTouching) return;
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const deltaX = currentX - startX;
        const deltaY = currentY - startX;
        const rotationSpeed = 0.005;
        $8f6a480bb40b134f$var$camera.rotation.y -= deltaX * rotationSpeed;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
    });
    $8f6a480bb40b134f$var$sectionScene.addEventListener("touchend", ()=>{
        isTouching = false;
    });
}
/********************************************************************
// Terrain Manager
********************************************************************/ const $8f6a480bb40b134f$var$terrainManager = new (0, $2c13acf5111e79d3$export$7a788af8dc4eb88e)({
    worldScene: $8f6a480bb40b134f$var$worldScene,
    camera: $8f6a480bb40b134f$var$camera
});
$8f6a480bb40b134f$var$terrainManager.loadInitialTerrain(1);
/********************************************************************
// Function to run start animation and welcome screen fade, at page load
********************************************************************/ function $8f6a480bb40b134f$var$fnCreateOnceFunction() {
    let hasBeenCalled = false;
    return function() {
        if (!hasBeenCalled) {
            $8f6a480bb40b134f$var$fnFadeOutWelcomeScreen();
            $8f6a480bb40b134f$var$cameraAnimationState.isAnimating = true;
            hasBeenCalled = true;
        }
    };
}
const $8f6a480bb40b134f$var$fnOnTerrainComplete = $8f6a480bb40b134f$var$fnCreateOnceFunction();
/********************************************************************
// Function to fade out welcome screen and add Video Plane to scene
********************************************************************/ function $8f6a480bb40b134f$var$fnFadeOutWelcomeScreen() {
    const welcomeScreen = document.getElementById("welcome-screen");
    welcomeScreen.classList.add("hidden");
    $8f6a480bb40b134f$var$worldScene.scene.add($8f6a480bb40b134f$var$videoPlane);
    setTimeout(()=>{
        welcomeScreen.style.display = "none";
    }, 2100); // Matches the duration of the CSS transition
}
/********************************************************************
// Animate Function
********************************************************************/ let $8f6a480bb40b134f$var$textureswapCheckCooldown = 0;
const $8f6a480bb40b134f$var$TEXTURE_SWAP_CHECK_INTERVAL = 100;
let $8f6a480bb40b134f$var$renderInfoCooldown = 0;
const $8f6a480bb40b134f$var$RENDER_INFO_INTERVAL = 2000;
/********************************************************************
// Animate function
********************************************************************/ function $8f6a480bb40b134f$var$animate() {
    const deltaTime = $8f6a480bb40b134f$var$clock.getDelta();
    const playerPosition = $8f6a480bb40b134f$var$camera.position;
    $8f6a480bb40b134f$var$terrainManager.update(playerPosition, deltaTime);
    $8f6a480bb40b134f$var$textureswapCheckCooldown -= deltaTime * 1000;
    if ($8f6a480bb40b134f$var$visitedFromMobileDevice) $8f6a480bb40b134f$var$fnCheckOrientation();
    else if (!$8f6a480bb40b134f$var$cameraAnimationState.isAnimating) $8f6a480bb40b134f$var$playerController.update(deltaTime);
    if ($8f6a480bb40b134f$var$textureswapCheckCooldown <= 0) {
        $8f6a480bb40b134f$var$textureswapCheckCooldown = $8f6a480bb40b134f$var$TEXTURE_SWAP_CHECK_INTERVAL;
        $8f6a480bb40b134f$var$modelRegistry.forEach((data, id)=>{
            //if (!Utils.fnIsInFrustum(data.mesh, camera)) return;
            //distance from mesh to player
            const distance = $8f6a480bb40b134f$var$camera.position.distanceToSquared(data.position);
            const distanceTextureSwap = data.distanceTextureSwap * data.distanceTextureSwap;
            if (data.needsTextureSwapToHQ && distance < distanceTextureSwap) {
                if (!data.textureIsLoaded) {
                    data.textureIsLoaded = true;
                    data.needsTextureSwapToHQ = false;
                    //update model registry
                    $8f6a480bb40b134f$var$modelRegistry.set(id, data);
                    //load texture
                    $8f6a480bb40b134f$var$fnLoadHQTexture(data);
                }
            }
        /*
            if (!data.needsTextureSwapToHQ && distance > DISTANCE_TEXTURE_DISPOSE) {
    
                data.needsTextureSwapToHQ = true;
                data.textureIsLoaded = false;
                modelRegistry.set(id, data);
                fnUnloadHQTexture(data);
            }
            */ });
    }
    if (($8f6a480bb40b134f$var$visitedFromMobileDevice || $8f6a480bb40b134f$var$allModelsLoaded) && !$8f6a480bb40b134f$var$allModelsAddedToScene && $8f6a480bb40b134f$var$terrainManager.allGrassComputed) {
        const allAdded = [
            ...$8f6a480bb40b134f$var$modelRegistry.values()
        ].every((model)=>model.isAddedToScene);
        if (allAdded) {
            //renderer.compile(worldScene.scene, camera);
            $8f6a480bb40b134f$var$fnOnTerrainComplete();
            $8f6a480bb40b134f$var$allModelsAddedToScene = true;
        }
    }
    $8f6a480bb40b134f$var$fnAnimateCamera();
    //shader uniform updates
    $8f6a480bb40b134f$var$powerlinesShaderMaterial.uniforms.uTime.value += deltaTime * 3.0;
    $8f6a480bb40b134f$var$videoShaderMaterial.uniforms.uTime.value += deltaTime * 0.25;
    $8f6a480bb40b134f$var$stoneFigureParams.forEach((item)=>{
        if (item.isAnimating && item.material) {
            if (item.material.uniforms.effectsIntensity.value < 1.0) item.material.uniforms.effectsIntensity.value += deltaTime / 5;
            item.material.uniforms.time.value += deltaTime * 2.0;
        }
    });
    //function to change post-processing composer for indoor env
    $8f6a480bb40b134f$var$fnCheckIfPlayerIsInFactoryTrigger(playerPosition, deltaTime);
    $8f6a480bb40b134f$var$fnCheckIfSoundSourcesShouldPlay(playerPosition);
    // Render once at the end of your animate function
    $8f6a480bb40b134f$var$activeComposer.render(deltaTime);
//stats.update();
// renderInfoCooldown -= deltaTime * 1000;
// if (renderInfoCooldown <= 0) {
//     renderInfoCooldown = RENDER_INFO_INTERVAL;
//     const mem = renderer.info.memory;
//     const render = renderer.info.render;
//     console.log(`[Renderer] geometries: ${mem.geometries} | textures: ${mem.textures} | calls: ${render.calls} | triangles: ${render.triangles} | programs: ${renderer.info.programs?.length ?? '?'}`);
// }
//videoTexture.needsUpdate = true;
}


//# sourceMappingURL=index.a0252398.js.map
